/**
 * JSON taken from https://github.com/iconify/icon-sets/blob/master/json/ri.json
 * tags taken from https://github.com/Remix-Design/remixicon/blob/master/tags.json
 */
const ri = {
  prefix: "ri",
  info: {
    name: "Remix Icon",
    total: 2892,
    version: "4.3.0",
    author: {
      name: "Remix Design",
      url: "https://github.com/Remix-Design/RemixIcon",
    },
    license: {
      title: "Apache 2.0",
      spdx: "Apache-2.0",
      url: "https://github.com/Remix-Design/RemixIcon/blob/master/License",
    },
    samples: ["lock-2-line", "mark-pen-fill", "moon-line"],
    height: 24,
    category: "General",
    palette: false,
  },
  lastModified: 1718298373,
  icons: {
    "24-hours-fill": {
      body: '<path fill="currentColor" d="M12.005 13.003a3 3 0 0 1 2.08 5.162l-1.91 1.837h2.83v2h-6l-.001-1.724l3.694-3.555a1 1 0 1 0-1.693-.72h-2a3 3 0 0 1 3-3m6 0v4h2v-4h2v9h-2v-3h-4v-6zm-14-1a7.99 7.99 0 0 0 3 6.246v2.416a10 10 0 0 1-5-8.662zm8-10c5.185 0 9.449 3.946 9.95 9h-2.012A8.001 8.001 0 0 0 5.87 6.868l2.135 2.135h-6v-6L4.45 5.449a9.98 9.98 0 0 1 7.554-3.446"/>',
    },
    "24-hours-line": {
      body: '<path fill="currentColor" d="M12.005 13.003a3 3 0 0 1 2.08 5.162l-1.91 1.837h2.83v2h-6l-.001-1.724l3.694-3.555a1 1 0 1 0-1.693-.72h-2a3 3 0 0 1 3-3m6 0v4h2v-4h2v9h-2v-3h-4v-6zm-14-1a7.99 7.99 0 0 0 3 6.246v2.416a10 10 0 0 1-5-8.662zm8-10c5.185 0 9.449 3.946 9.95 9h-2.012a8.001 8.001 0 0 0-14.554-3.5h2.616v2h-6v-6h2v2.499a9.99 9.99 0 0 1 8-4"/>',
    },
    "4k-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8.5 10.5V12h-1V9H9v3H7.5V9H6v4.5h3V15h1.5v-1.5zM18 15l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5v-2.25L16.25 15z"/>',
    },
    "4k-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V5zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8.5 10.5h-1V15H9v-1.5H6V9h1.5v3H9V9h1.5v3h1zM18 15h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3z"/>',
    },
    "a-b": {
      body: '<path fill="currentColor" d="M5 15v2c0 1.054.95 2 2 2h3v2H7a4 4 0 0 1-4-4v-2zm13-5l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16 10zm-1 2.885L15.753 16h2.492zM3 3h6a3 3 0 0 1 2.235 5A3 3 0 0 1 9 13H3zm6 6H5v2h4a1 1 0 1 0 0-2m8-6a4 4 0 0 1 4 4v2h-2V7a2 2 0 0 0-2-2h-3V3zM9 5H5v2h4a1 1 0 0 0 0-2"/>',
    },
    "account-box-fill": {
      body: '<path fill="currentColor" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM6.357 18h11.49a6.99 6.99 0 0 0-5.745-3a6.99 6.99 0 0 0-5.745 3M12 13a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7"/>',
    },
    "account-box-line": {
      body: '<path fill="currentColor" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM5 5v14h14V5zm2.972 13.18a10 10 0 0 1-1.751-.978A7 7 0 0 1 12.102 14c2.4 0 4.517 1.207 5.778 3.047a10 10 0 0 1-1.724 1.025A5 5 0 0 0 12.102 16c-1.716 0-3.23.864-4.13 2.18M12 13a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "account-circle-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2M6.023 15.416C7.491 17.606 9.695 19 12.16 19s4.669-1.393 6.136-3.584A8.97 8.97 0 0 0 12.16 13a8.97 8.97 0 0 0-6.137 2.416M12 11a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "account-circle-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m.16 14a6.98 6.98 0 0 0-5.147 2.256A7.97 7.97 0 0 0 12 20a7.97 7.97 0 0 0 5.167-1.892A6.98 6.98 0 0 0 12.16 16M12 4a8 8 0 0 0-6.384 12.821A8.98 8.98 0 0 1 12.16 14a8.97 8.97 0 0 1 6.362 2.634A8 8 0 0 0 12 4m0 1a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "account-pin-box-fill": {
      body: '<path fill="currentColor" d="m14 21l-2 2l-2-2H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21zm-7.643-3h11.49a6.99 6.99 0 0 0-5.745-3a6.99 6.99 0 0 0-5.745 3M12 13a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7"/>',
    },
    "account-pin-box-line": {
      body: '<path fill="currentColor" d="m14 21l-2 2l-2-2H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21zm5-2V5H5v14h5.828L12 20.172L13.172 19zm-11.028-.82a10 10 0 0 1-1.751-.978A7 7 0 0 1 12.102 14c2.4 0 4.517 1.207 5.778 3.047a10 10 0 0 1-1.724 1.025A5 5 0 0 0 12.102 16c-1.716 0-3.23.864-4.13 2.18M12 13a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "account-pin-circle-fill": {
      body: '<path fill="currentColor" d="M14.256 21.744L12 24l-2.256-2.256C5.31 20.72 2 16.744 2 12C2 6.48 6.48 2 12 2s10 4.48 10 10c0 4.744-3.31 8.72-7.744 9.744m-8.233-6.328C7.491 17.606 9.695 19 12.16 19s4.669-1.393 6.136-3.584A8.97 8.97 0 0 0 12.16 13a8.97 8.97 0 0 0-6.137 2.416M12 11a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "account-pin-circle-line": {
      body: '<path fill="currentColor" d="M9.745 21.745C5.308 20.722 2 16.747 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 4.747-3.308 8.722-7.745 9.745L12 24zm-2.733-3.488a7.95 7.95 0 0 0 3.182 1.539l.56.129L12 21.172l1.247-1.247l.56-.13a7.96 7.96 0 0 0 3.36-1.686A6.98 6.98 0 0 0 12.16 16c-2.036 0-3.87.87-5.148 2.257M5.616 16.82A8.98 8.98 0 0 1 12.16 14a8.97 8.97 0 0 1 6.362 2.634a8 8 0 1 0-12.906.187M12 13a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "add-box-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m7 8H7v2h4v4h2v-4h4v-2h-4V7h-2z"/>',
    },
    "add-box-line": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5zm6 6V7h2v4h4v2h-4v4h-2v-4H7v-2z"/>',
    },
    "add-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-1-11H7v2h4v4h2v-4h4v-2h-4V7h-2z"/>',
    },
    "add-circle-line": {
      body: '<path fill="currentColor" d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16"/>',
    },
    "add-fill": {
      body: '<path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"/>',
    },
    "add-large-fill": {
      body: '<path fill="currentColor" d="M11 11V2h2v9h9v2h-9v9h-2v-9H2v-2z"/>',
    },
    "add-large-line": {
      body: '<path fill="currentColor" d="M13 11h9v2h-9v9h-2v-9H2v-2h9V2h2z"/>',
    },
    "add-line": {
      body: '<path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"/>',
    },
    "admin-fill": {
      body: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m9 4h1v5h-8v-5h1v-1a3 3 0 1 1 6 0zm-2 0v-1a1 1 0 1 0-2 0v1z"/>',
    },
    "admin-line": {
      body: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m9 6h1v5h-8v-5h1v-1a3 3 0 1 1 6 0zm-2 0v-1a1 1 0 1 0-2 0v1z"/>',
    },
    "advertisement-fill": {
      body: '<path fill="currentColor" d="m7.552 13l.847-2.115L9.244 13zM16 12h1v2h-1a1 1 0 1 1 0-2m5-9H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-8.402 13h-2.155l-.4-1h-3.29l-.4 1H4.199l1.199-2.998l.001-.002l2-5h2zM17 8h2v8h-3a3 3 0 1 1 0-6h1z"/>',
    },
    "advertisement-line": {
      body: '<path fill="currentColor" d="m12.598 16l-3.2-8h-2l-2 5v.002L4.199 16h2.154l.4-1h3.29l.4 1zm-5.046-3l.847-2.115L9.244 13zM17 8h2v8h-3a3 3 0 1 1 0-6h1zm-1 4a1 1 0 0 0 0 2h1v-2zm5-9H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M4 19V5h16v14z"/>',
    },
    "aed-electrodes-fill": {
      body: '<path fill="currentColor" d="M8 3a1 1 0 0 0-1 1v3H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h5v2h2v-2h5a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm9 12V8a1 1 0 0 0-1-1H9V5h10v10z"/>',
    },
    "aed-electrodes-line": {
      body: '<path fill="currentColor" d="M7 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-5v2H9v-2H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3zm12 11V5H9v2h7a1 1 0 0 1 1 1v7zM5 9v10h10V9z"/>',
    },
    "aed-fill": {
      body: '<path fill="currentColor" d="M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm10 8l-5 7v-5H8l5-7v5z"/>',
    },
    "aed-line": {
      body: '<path fill="currentColor" d="M6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm13 5h-3V6l-5 7h3v5z"/>',
    },
    "ai-generate": {
      body: '<path fill="currentColor" d="M15 5.25A3.25 3.25 0 0 0 18.25 2h1.5A3.25 3.25 0 0 0 23 5.25v1.5A3.25 3.25 0 0 0 19.75 10h-1.5A3.25 3.25 0 0 0 15 6.75zM4 7a2 2 0 0 1 2-2h7V3H6a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-5h-2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/>',
    },
    "airplay-fill": {
      body: '<path fill="currentColor" d="m12.4 13.533l5 6.667a.5.5 0 0 1-.4.8H7a.5.5 0 0 1-.4-.8l5-6.667a.5.5 0 0 1 .8 0M18 19v-2h2V5H4v12h2v2H2.992A.994.994 0 0 1 2 18V4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1z"/>',
    },
    "airplay-line": {
      body: '<path fill="currentColor" d="m12.4 13.533l5 6.667a.5.5 0 0 1-.4.8H7a.5.5 0 0 1-.4-.8l5-6.667a.5.5 0 0 1 .8 0M12 16.33L10 19h4zM18 19v-2h2V5H4v12h2v2H2.992A.994.994 0 0 1 2 18V4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1z"/>',
    },
    "alarm-fill": {
      body: '<path fill="currentColor" d="M12 22a9 9 0 1 1 0-18a9 9 0 0 1 0 18m1-9V8h-2v7h5v-2zM1.747 6.283l3.536-3.536l1.414 1.414L3.16 7.697zm16.97-3.536l3.536 3.536l-1.414 1.414l-3.536-3.536z"/>',
    },
    "alarm-line": {
      body: '<path fill="currentColor" d="M12 22a9 9 0 1 1 0-18a9 9 0 0 1 0 18m0-2a7 7 0 1 0 0-14a7 7 0 0 0 0 14m1-7h3v2h-5V8h2zM1.747 6.283l3.536-3.536l1.414 1.414L3.16 7.697zm16.97-3.536l3.536 3.536l-1.414 1.414l-3.536-3.536z"/>',
    },
    "alarm-warning-fill": {
      body: '<path fill="currentColor" d="M4 20v-6a8 8 0 1 1 16 0v6h1v2H3v-2zm2-6h2a4 4 0 0 1 4-4V8a6 6 0 0 0-6 6m5-12h2v3h-2zm8.778 2.808l1.414 1.414l-2.12 2.121l-1.415-1.414zM2.808 6.222l1.414-1.414l2.121 2.12L4.93 8.344z"/>',
    },
    "alarm-warning-line": {
      body: '<path fill="currentColor" d="M4 20v-6a8 8 0 1 1 16 0v6h1v2H3v-2zm2 0h12v-6a6 6 0 0 0-12 0zm5-18h2v3h-2zm8.778 2.808l1.414 1.414l-2.12 2.121l-1.415-1.414zM2.808 6.222l1.414-1.414l2.121 2.12L4.93 8.344zM7 14a5 5 0 0 1 5-5v2a3 3 0 0 0-3 3z"/>',
    },
    "album-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 14c2.213 0 4-1.787 4-4s-1.787-4-4-4s-4 1.787-4 4s1.787 4 4 4m0-5c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1"/>',
    },
    "album-line": {
      body: '<path fill="currentColor" d="M12 20a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-8a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8"/>',
    },
    "alert-fill": {
      body: '<path fill="currentColor" d="m12.866 3l9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0M11 16v2h2v-2zm0-7v5h2V9z"/>',
    },
    "alert-line": {
      body: '<path fill="currentColor" d="m12.866 3l9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0m-8.66 16h15.588L12 5.5zM11 16h2v2h-2zm0-7h2v5h-2z"/>',
    },
    "alibaba-cloud-fill": {
      body: '<path fill="currentColor" d="M9.514 5.14H4.68A3.68 3.68 0 0 0 1 8.82v6.358a3.68 3.68 0 0 0 3.68 3.68h4.85L8.36 17.2l-3.538-1.08a1.54 1.54 0 0 1-1.07-1.472V9.37a1.53 1.53 0 0 1 1.07-1.47l3.536-1.104zm9.825 0h-4.85l1.17 1.656L19.195 7.9a1.53 1.53 0 0 1 1.067 1.471v5.277a1.535 1.535 0 0 1-1.067 1.472L15.66 17.2l-1.17 1.656h4.85a3.66 3.66 0 0 0 3.66-3.68V8.82a3.68 3.68 0 0 0-3.66-3.68m-3.672 5.998h-7.33v1.652h7.33z"/>',
    },
    "alibaba-cloud-line": {
      body: '<path fill="currentColor" d="M5 5a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h4l-1-2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3l1-2zm11 2h3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3l-1 2h4a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4h-4zm-8 6h8v-2H8z"/>',
    },
    "aliens-fill": {
      body: '<path fill="currentColor" d="M12 2a8.5 8.5 0 0 1 8.5 8.5c0 6.5-5.5 12-8.5 12s-8.5-5.5-8.5-12A8.5 8.5 0 0 1 12 2m5.5 10a4.5 4.5 0 0 0-4.475 4.975q.235.025.475.025a4.5 4.5 0 0 0 4.475-4.975A5 5 0 0 0 17.5 12m-11 0q-.24 0-.475.025a4.5 4.5 0 0 0 4.95 4.95Q11 16.74 11 16.5A4.5 4.5 0 0 0 6.5 12"/>',
    },
    "aliens-line": {
      body: '<path fill="currentColor" d="M12 2a8.5 8.5 0 0 1 8.5 8.5c0 6.5-5.5 12-8.5 12s-8.5-5.5-8.5-12A8.5 8.5 0 0 1 12 2m0 2a6.5 6.5 0 0 0-6.5 6.5c0 4.794 4.165 10 6.5 10s6.5-5.206 6.5-10A6.5 6.5 0 0 0 12 4m5.5 7q.24 0 .475.025q.025.235.025.475a4.5 4.5 0 0 1-4.975 4.475A4.5 4.5 0 0 1 17.5 11m-11 0a4.5 4.5 0 0 1 4.475 4.975a4.5 4.5 0 0 1-4.95-4.95Q6.259 11 6.5 11"/>',
    },
    "align-bottom": {
      body: '<path fill="currentColor" d="M3 19h18v2H3zm5-6h3l-4 4l-4-4h3V3h2zm10 0h3l-4 4l-4-4h3V3h2z"/>',
    },
    "align-center": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm2 15h14v2H5zm-2-5h18v2H3zm2-5h14v2H5z"/>',
    },
    "align-item-bottom-fill": {
      body: '<path fill="currentColor" d="M4 4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm7 12H3v2h18z"/>',
    },
    "align-item-bottom-line": {
      body: '<path fill="currentColor" d="M9 5v10H6V5zM5 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 6v6h3V9zm-2-1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zm8 11H3v2h18z"/>',
    },
    "align-item-horizontal-center-fill": {
      body: '<path fill="currentColor" d="M11 4V2h2v2h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-6v2h4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-4v2h-2v-2H7a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h4v-2H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/>',
    },
    "align-item-horizontal-center-line": {
      body: '<path fill="currentColor" d="M11 4V2h2v2h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-6v2h4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-4v2h-2v-2H7a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h4v-2H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM8 15v3h8v-3zM6 9h12V6H6z"/>',
    },
    "align-item-left-fill": {
      body: '<path fill="currentColor" d="M3 21V3h2v18zm4-7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zM8 4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"/>',
    },
    "align-item-left-line": {
      body: '<path fill="currentColor" d="M3 21V3h2v18zm6-6h6v3H9zm-1-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm1-4h10V6H9zM7 5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"/>',
    },
    "align-item-right-fill": {
      body: '<path fill="currentColor" d="M19 21V3h2v18zM7 14a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zM4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"/>',
    },
    "align-item-right-line": {
      body: '<path fill="currentColor" d="M19 21V3h2v18zM9 15h6v3H9zm-1-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zM5 9h10V6H5zM3 5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>',
    },
    "align-item-top-fill": {
      body: '<path fill="currentColor" d="M21 3H3v2h18zm-7 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM4 8a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/>',
    },
    "align-item-top-line": {
      body: '<path fill="currentColor" d="M21 3H3v2h18zm-6 6v6h3V9zm-2-1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zM9 9v10H6V9zM5 7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"/>',
    },
    "align-item-vertical-center-fill": {
      body: '<path fill="currentColor" d="M4 19a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6h2v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4h2v-2h-2V7a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v4h-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6H2v2h2z"/>',
    },
    "align-item-vertical-center-line": {
      body: '<path fill="currentColor" d="M9 18V6H6v12zm-4 2a1 1 0 0 1-1-1v-6H2v-2h2V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6h2V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4h2v2h-2v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4h-2v6a1 1 0 0 1-1 1zm10-4h3V8h-3z"/>',
    },
    "align-justify": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 15h18v2H3zm0-5h18v2H3zm0-5h18v2H3z"/>',
    },
    "align-left": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 15h14v2H3zm0-5h18v2H3zm0-5h14v2H3z"/>',
    },
    "align-right": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm4 15h14v2H7zm-4-5h18v2H3zm4-5h14v2H7z"/>',
    },
    "align-top": {
      body: '<path fill="currentColor" d="M3 3h18v2H3zm5 8v10H6V11H3l4-4l4 4zm10 0v10h-2V11h-3l4-4l4 4z"/>',
    },
    "align-vertically": {
      body: '<path fill="currentColor" d="M3 11h18v2H3zm15 7v3h-2v-3h-3l4-4l4 4zM8 18v3H6v-3H3l4-4l4 4zM18 6h3l-4 4l-4-4h3V3h2zM8 6h3l-4 4l-4-4h3V3h2z"/>',
    },
    "alipay-fill": {
      body: '<path fill="currentColor" d="M21.422 15.358q-5.744-1.73-6.678-2.062a12.4 12.4 0 0 0 1.32-3.32H12.8V8.872h4v-.68h-4V6.344h-1.536c-.28 0-.312.248-.312.248v1.592H7.2v.68h3.752v1.104H7.88v.616h6.224a11 11 0 0 1-.888 2.176c-1.408-.464-2.192-.784-3.912-.944c-3.256-.312-4.008 1.48-4.128 2.576C5 16.064 6.48 17.424 8.688 17.424s3.68-1.024 5.08-2.72q1.75.837 6.514 2.902A9.99 9.99 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a10 10 0 0 1-.578 3.358m-12.99 1.01c-2.336 0-2.704-1.48-2.584-2.096s.8-1.416 2.104-1.416c1.496 0 2.832.384 4.44 1.16c-1.136 1.48-2.52 2.352-3.96 2.352"/>',
    },
    "alipay-line": {
      body: '<path fill="currentColor" d="M18.408 16.79q-3.26-1.425-4.64-2.086c-1.4 1.696-2.872 2.72-5.08 2.72S5 16.064 5.176 14.392c.12-1.096.872-2.888 4.128-2.576c1.72.16 2.504.48 3.912.944c.36-.664.664-1.4.888-2.176H7.88v-.616h3.072V8.864H7.2v-.68h3.752V6.592s.032-.248.312-.248H12.8v1.848h4v.68h-4v1.104h3.264a12.4 12.4 0 0 1-1.32 3.32q.765.273 4.76 1.483a8 8 0 1 0-1.096 2.012M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-3.568-5.632c1.44 0 2.824-.872 3.96-2.352c-1.608-.776-2.944-1.16-4.44-1.16c-1.304 0-1.984.8-2.104 1.416s.248 2.096 2.584 2.096"/>',
    },
    "amazon-fill": {
      body: '<path fill="currentColor" d="M21.997 18.23c0 .727-.405 2.127-1.315 2.896c-.182.14-.364.061-.284-.143c.265-.648.871-2.147.587-2.492c-.201-.262-1.031-.242-1.739-.182c-.323.041-.607.06-.827.105c-.204.016-.245-.163-.041-.303a3.1 3.1 0 0 1 .87-.428c1.15-.344 2.479-.137 2.67.083c.036.042.079.16.079.463m-1.922 1.294a7 7 0 0 1-.829.55c-2.122 1.275-4.871 1.943-7.258 1.943c-3.843 0-7.28-1.417-9.888-3.788c-.224-.182-.039-.446.223-.303c2.81 1.64 6.288 2.632 9.888 2.632c2.266 0 4.708-.424 7.035-1.336c.163-.061.345-.144.504-.202c.367-.165.69.242.325.504m-6.17-11.03c0-1.041.042-1.654-.303-2.18c-.306-.433-.833-.693-1.569-.652c-.798.044-1.655.567-1.873 1.526c-.043.22-.171.436-.437.483l-2.435-.31c-.174-.04-.439-.173-.352-.521C7.459 4.088 9.81 3.129 12.034 3h.522c1.22 0 2.788.349 3.791 1.264c1.217 1.136 1.087 2.662 1.087 4.32v3.927c0 1.178.478 1.7.958 2.314c.13.219.175.477-.044.655a78 78 0 0 1-1.917 1.654c-.175.133-.489.147-.61.045c-.77-.645-.958-1.003-1.435-1.658c-.83.871-1.527 1.352-2.356 1.613a7 7 0 0 1-1.784.216c-2.09 0-3.745-1.303-3.745-3.88c0-2.049 1.09-3.442 2.7-4.101c1.61-.66 3.95-.87 4.704-.874m-.477 5.192c.52-.872.477-1.586.477-3.185c-.652 0-1.306.045-1.871.178c-1.045.303-1.875.96-1.875 2.355c0 1.09.568 1.832 1.526 1.832q.198 0 .348-.045c.67-.186 1.088-.522 1.395-1.135"/>',
    },
    "amazon-line": {
      body: '<path fill="currentColor" d="M15.626 14.62c-1.107 1.619-2.728 2.384-4.625 2.384c-2.304 0-4.277-1.773-3.993-4.124c.314-2.608 2.34-3.73 5.708-4.143c.601-.073.85-.094 2.147-.19l.138-.01v-.215C15 6.526 13.933 5.3 12.5 5.3c-1.437 0-2.44.747-3.055 2.526l-1.89-.652C8.442 4.604 10.193 3.3 12.5 3.3c2.602 0 4.5 2.178 4.5 5.022c0 2.649.163 4.756.483 5.557c.356.893.486 1.117.884 1.613l-1.56 1.251c-.524-.652-.753-1.048-1.182-2.122m5.631 5.925c-.27.2-.741.081-.528-.44c.264-.648.547-1.408.262-1.752c-.21-.255-.468-.382-1.027-.382c-.46 0-.69.06-.995.08c-.204.014-.294-.297-.091-.44c.261-.185.544-.33.87-.428c1.15-.344 2.505-.155 2.67.083c.365.53-.2 2.569-1.16 3.28m-1.182-1.084a8 8 0 0 1-.829.695c-2.122 1.616-4.871 2.46-7.258 2.46c-3.843 0-7.28-1.793-9.888-4.795c-.224-.23-.039-.566.223-.384c2.81 2.077 6.288 3.333 9.888 3.333c2.266 0 4.708-.537 7.035-1.692c.163-.077.345-.182.504-.255c.367-.21.69.306.325.638m-5.064-8.92c-1.259.094-1.496.113-2.052.181c-2.553.313-3.797 1.003-3.966 2.398c-.125 1.043.81 1.884 2.008 1.884c2.039 0 3.517-1.228 4.022-4.463z"/>',
    },
    "anchor-fill": {
      body: '<path fill="currentColor" d="M13 9.874v10.054c3.619-.454 6.487-3.336 6.938-6.972H17L20.704 7A10.04 10.04 0 0 1 22 11.95C22 17.5 17.523 22 12 22S2 17.5 2 11.95c0-1.8.471-3.489 1.296-4.95L7 12.956H4.062c.451 3.636 3.32 6.518 6.938 6.972V9.874A4.002 4.002 0 0 1 12 2a4 4 0 0 1 1 7.874M12 8a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "anchor-line": {
      body: '<path fill="currentColor" d="M2.05 11H7v2H4.062A8.004 8.004 0 0 0 11 19.938V9.874A4.002 4.002 0 0 1 12 2a4 4 0 0 1 1 7.874v10.064A8.004 8.004 0 0 0 19.938 13H17v-2h4.95q.05.493.05 1c0 5.523-4.477 10-10 10S2 17.523 2 12q0-.507.05-1M12 8a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "ancient-gate-fill": {
      body: '<path fill="currentColor" d="M6.964 3h10.072a3.5 3.5 0 0 0 4.445 2.86A3.5 3.5 0 0 1 18 9H6a3.5 3.5 0 0 1-3.481-3.14A3.5 3.5 0 0 0 6.964 3m16.015 8.111a3 3 0 0 1-4.077-1.11H5.098a3 3 0 0 1-4.078 1.11A3.5 3.5 0 0 0 3 14.663V21h6v-2a3 3 0 0 1 6 0v2h6v-6.336a3.5 3.5 0 0 0 1.979-3.553"/>',
    },
    "ancient-gate-line": {
      body: '<path fill="currentColor" d="M6.964 3h10.072a3.5 3.5 0 0 0 4.445 2.86A3.5 3.5 0 0 1 18 9H6a3.5 3.5 0 0 1-3.482-3.14A3.5 3.5 0 0 0 6.964 3M16.9 6.658A5.4 5.4 0 0 1 15.59 5H8.411A5.4 5.4 0 0 1 7.1 6.658A6 6 0 0 1 6.667 7h10.666a6 6 0 0 1-.434-.342M21.5 11.5c.538 0 1.042-.142 1.479-.39q.021.192.021.39a3.5 3.5 0 0 1-2 3.163V21h-7v-2a2 2 0 1 0-4 0v2H3v-6.336a3.5 3.5 0 0 1-1.979-3.553a3 3 0 0 0 4.077-1.11h13.803a3 3 0 0 0 2.599 1.5m-2.537 1.309a5 5 0 0 1-1.038-.81H6.075q-.457.467-1.038.81q-.304.18-.622.312L5 13.4V19h3q0-1.657 1.172-2.828A3.85 3.85 0 0 1 12 15q1.657 0 2.828 1.172A3.85 3.85 0 0 1 16 19h3v-5.6l.585-.278a5 5 0 0 1-.622-.312"/>',
    },
    "ancient-pavilion-fill": {
      body: '<path fill="currentColor" d="M1.516 7.877A4.5 4.5 0 0 0 5 11.887v7.114H3v2h18v-2h-2v-7.114a4.5 4.5 0 0 0 3.484-4.01A9 9 0 0 1 12.514 2h-1.029a9 9 0 0 1-9.97 5.877M17 19H7v-7h10z"/>',
    },
    "ancient-pavilion-line": {
      body: '<path fill="currentColor" d="M1.516 7.877A4.5 4.5 0 0 0 5 11.887v7.114H3v2h18v-2h-2v-7.114a4.5 4.5 0 0 0 3.484-4.01A9 9 0 0 1 12.514 2h-1.029a9 9 0 0 1-9.97 5.877M17 19H7v-7h10zm1.556-9.064L18.28 10H5.72l-.274-.063a2.6 2.6 0 0 1-.392-.121Q7.36 9.39 9.351 7.98A10.9 10.9 0 0 0 12 5.346a10.9 10.9 0 0 0 2.648 2.635q1.993 1.41 4.298 1.835a2.6 2.6 0 0 1-.391.121"/>',
    },
    "android-fill": {
      body: '<path fill="currentColor" d="M6.382 3.968A8.96 8.96 0 0 1 12 2c2.125 0 4.078.736 5.618 1.968l1.453-1.453l1.414 1.414l-1.453 1.453A8.96 8.96 0 0 1 21 11v1H3v-1c0-2.125.736-4.078 1.968-5.618L3.515 3.93l1.414-1.414zM3 14h18v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm6-5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "android-line": {
      body: '<path fill="currentColor" d="M19 13H5v7h14zm0-2a7 7 0 1 0-14 0zM6.382 3.968A8.96 8.96 0 0 1 12 2c2.125 0 4.078.736 5.618 1.968l1.453-1.453l1.414 1.414l-1.453 1.453A8.96 8.96 0 0 1 21 11v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11c0-2.125.736-4.078 1.968-5.618L3.515 3.93l1.414-1.414zM9 9a1 1 0 1 1 0-2a1 1 0 0 1 0 2m6 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "angularjs-fill": {
      body: '<path fill="currentColor" d="m12 2l9.3 3.32l-1.418 12.31L12 22l-7.88-4.37L2.7 5.32zm0 2.21L6.186 17.26h2.168l1.169-2.92h4.935l1.168 2.92h2.168zm1.698 8.33h-3.396L12 8.45z"/>',
    },
    "angularjs-line": {
      body: '<path fill="currentColor" d="m17.524 16.65l.489-.27l1.118-9.71l-7.13-2.546l-7.132 2.545l1.119 9.71l.474.263L12 4.21zm-1.1.61h-.798l-1.168-2.92H9.523l-1.169 2.92h-.778L12 19.713zM12 2l9.3 3.32l-1.418 12.31L12 22l-7.88-4.37L2.7 5.32zm1.698 10.54L12 8.45l-1.698 4.09z"/>',
    },
    "anticlockwise-2-fill": {
      body: '<path fill="currentColor" d="M14 4h2a5 5 0 0 1 5 5v4h-2V9a3 3 0 0 0-3-3h-2v3L9 5l5-4zm1 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1"/>',
    },
    "anticlockwise-2-line": {
      body: '<path fill="currentColor" d="m13.414 6l1.829 1.828l-1.415 1.415L9.586 5L13.828.757l1.415 1.415L13.414 4H16a5 5 0 0 1 5 5v4h-2V9a3 3 0 0 0-3-3zM15 11v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1m-2 1H5v8h8z"/>',
    },
    "anticlockwise-fill": {
      body: '<path fill="currentColor" d="M6 10h3l-4 5l-4-5h3V8a5 5 0 0 1 5-5h4v2H9a3 3 0 0 0-3 3zm5-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1"/>',
    },
    "anticlockwise-line": {
      body: '<path fill="currentColor" d="M11 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1m1 2v8h8v-8zm-6-.414l1.828-1.829l1.415 1.415L5 14.414L.757 10.172l1.415-1.415L4 10.586V8a5 5 0 0 1 5-5h4v2H9a3 3 0 0 0-3 3z"/>',
    },
    "app-store-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2M8.823 15.343q-.591-.716-1.479-.509l-.15.041l-.59 1.016a.823.823 0 0 0 1.366.916l.062-.093zM13.21 8.66c-.488.404-.98 1.597-.29 2.787l3.04 5.266a.824.824 0 0 0 1.476-.722l-.049-.1l-.802-1.392h1.19a.82.82 0 0 0 .822-.823a.82.82 0 0 0-.72-.816l-.103-.006h-2.14L13.44 9.057zm.278-3.044a.825.825 0 0 0-1.063.21l-.062.092l-.367.633l-.359-.633a.824.824 0 0 0-1.476.722l.049.1l.838 1.457l-2.685 4.653H6.266a.82.82 0 0 0-.822.822c0 .421.312.766.719.817l.103.006h7.48c.34-.64-.06-1.549-.81-1.638l-.121-.007h-2.553l3.528-6.11a.823.823 0 0 0-.302-1.124"/>',
    },
    "app-store-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16M8.823 15.343l-.79 1.37a.823.823 0 1 1-1.428-.822l.589-1.016q.989-.307 1.629.468M13.21 8.66l2.423 4.194h2.141a.82.82 0 0 1 .823.822a.82.82 0 0 1-.823.823h-1.19l.803 1.391a.824.824 0 0 1-1.427.823l-3.04-5.266c-.69-1.19-.198-2.383.29-2.787m.278-3.044c.395.226.528.73.302 1.125l-3.528 6.109h2.553c.826 0 1.29.972.931 1.645h-7.48a.82.82 0 0 1-.822-.823a.82.82 0 0 1 .822-.822h2.097l2.685-4.653l-.838-1.456a.824.824 0 0 1 1.427-.823l.359.633l.367-.633a.823.823 0 0 1 1.125-.302"/>',
    },
    "apple-fill": {
      body: '<path fill="currentColor" d="M11.673 7.222c-.876 0-2.232-.996-3.66-.96c-1.884.024-3.612 1.092-4.584 2.784c-1.956 3.396-.504 8.412 1.404 11.172c.936 1.344 2.04 2.856 3.504 2.808c1.404-.06 1.932-.912 3.636-.912c1.692 0 2.172.912 3.66.876c1.512-.024 2.472-1.368 3.396-2.724c1.068-1.56 1.512-3.072 1.536-3.156c-.036-.012-2.94-1.128-2.976-4.488c-.024-2.808 2.292-4.152 2.4-4.212c-1.32-1.932-3.348-2.148-4.056-2.196c-1.848-.144-3.396 1.008-4.26 1.008m3.12-2.832c.78-.936 1.296-2.244 1.152-3.54c-1.116.048-2.46.744-3.264 1.68c-.72.828-1.344 2.16-1.176 3.432c1.236.096 2.508-.636 3.288-1.572"/>',
    },
    "apple-line": {
      body: '<path fill="currentColor" d="M15.778 8.208c-.473-.037-.98.076-1.758.373c.065-.025-.742.29-.969.37c-.502.175-.915.271-1.378.271c-.458 0-.88-.092-1.365-.255a11 11 0 0 1-.505-.186l-.449-.177c-.648-.254-1.012-.35-1.315-.342c-1.153.014-2.243.68-2.877 1.782c-1.292 2.243-.576 6.299 1.313 9.031c1.005 1.444 1.556 1.96 1.777 1.953c.222-.01.386-.057.784-.225l.166-.071c1.006-.429 1.71-.618 2.771-.618c1.021 0 1.703.186 2.669.602l.168.072c.397.17.54.208.792.202c.357-.005.798-.417 1.777-1.854c.268-.391.505-.803.71-1.22a7 7 0 0 1-.391-.347c-1.29-1.228-2.087-2.884-2.109-4.93A6.63 6.63 0 0 1 17 8.458a4.1 4.1 0 0 0-1.221-.25m.155-1.994c.708.048 2.736.264 4.056 2.196c-.108.06-2.424 1.404-2.4 4.212c.036 3.36 2.94 4.476 2.976 4.488c-.024.084-.468 1.596-1.536 3.156c-.924 1.356-1.884 2.7-3.396 2.724c-1.488.036-1.968-.876-3.66-.876c-1.704 0-2.232.852-3.636.912c-1.464.048-2.568-1.464-3.504-2.808c-1.908-2.76-3.36-7.776-1.404-11.172c.972-1.692 2.7-2.76 4.584-2.784c1.428-.036 2.784.96 3.66.96c.864 0 2.412-1.152 4.26-1.008m-1.14-1.824c-.78.936-2.052 1.668-3.288 1.572c-.168-1.272.456-2.604 1.176-3.432c.804-.936 2.148-1.632 3.264-1.68c.144 1.296-.372 2.604-1.152 3.54"/>',
    },
    "apps-2-add-fill": {
      body: '<path fill="currentColor" d="M2.5 7a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0m0 10a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0m10 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0m3.5-6V8h-3V6h3V3h2v3h3v2h-3v3z"/>',
    },
    "apps-2-add-line": {
      body: '<path fill="currentColor" d="M2.5 7a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0m0 10a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0m10 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0m-3-10a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m10 0a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0M16 11V8h-3V6h3V3h2v3h3v2h-3v3z"/>',
    },
    "apps-2-fill": {
      body: '<path fill="currentColor" d="M7 11.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0 10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m10-10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0 10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9"/>',
    },
    "apps-2-line": {
      body: '<path fill="currentColor" d="M7 11.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0 10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m10-10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0 10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9M7 9.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m0 10a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m10-10a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m0 10a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"/>',
    },
    "apps-fill": {
      body: '<path fill="currentColor" d="M6.75 2.5A4.25 4.25 0 0 1 11 6.75V11H6.75a4.25 4.25 0 0 1 0-8.5m0 10.5H11v4.25A4.25 4.25 0 1 1 6.75 13m10.5-10.5a4.25 4.25 0 0 1 0 8.5H13V6.75a4.25 4.25 0 0 1 4.25-4.25M13 13h4.25A4.25 4.25 0 1 1 13 17.25z"/>',
    },
    "apps-line": {
      body: '<path fill="currentColor" d="M6.75 2.5A4.25 4.25 0 0 1 11 6.75V11H6.75a4.25 4.25 0 0 1 0-8.5M9 9V6.75A2.25 2.25 0 1 0 6.75 9zm-2.25 4H11v4.25A4.25 4.25 0 1 1 6.75 13m0 2A2.25 2.25 0 1 0 9 17.25V15zm10.5-12.5a4.25 4.25 0 0 1 0 8.5H13V6.75a4.25 4.25 0 0 1 4.25-4.25m0 6.5A2.25 2.25 0 1 0 15 6.75V9zM13 13h4.25A4.25 4.25 0 1 1 13 17.25zm2 2v2.25A2.25 2.25 0 1 0 17.25 15z"/>',
    },
    "archive-2-fill": {
      body: '<path fill="currentColor" d="M22 20V7l-2-4H4L2 7.004V20a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1M5.236 5h13.528l1 2H4.237zM9 11h6v2H9z"/>',
    },
    "archive-2-line": {
      body: '<path fill="currentColor" d="M22 20V7l-2-4H4L2 7.004V20a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1M4 9h16v10H4zm1.236-4h13.528l1 2H4.237zM15 11H9v2h6z"/>',
    },
    "archive-drawer-fill": {
      body: '<path fill="currentColor" d="M3 13h18v8.003c0 .55-.445.997-.993.997H3.993A.995.995 0 0 1 3 21.003zM3 2.998C3 2.447 3.445 2 3.993 2h16.014c.548 0 .993.446.993.998V11H3zM9 5v2h6V5zm0 11v2h6v-2z"/>',
    },
    "archive-drawer-line": {
      body: '<path fill="currentColor" d="M3 2.992C3 2.444 3.445 2 3.993 2h16.014a1 1 0 0 1 .993.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008zM19 11V4H5v7zm0 2H5v7h14zM9 6h6v2H9zm0 9h6v2H9z"/>',
    },
    "archive-fill": {
      body: '<path fill="currentColor" d="M3 10h18v10.004c0 .55-.445.996-.993.996H3.993A.994.994 0 0 1 3 20.004zm6 2v2h6v-2zM2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.444.992 1v4H2z"/>',
    },
    "archive-line": {
      body: '<path fill="currentColor" d="M3 10H2V4.003C2 3.449 2.455 3 2.992 3h18.016A.99.99 0 0 1 22 4.003V10h-1v10.002a.996.996 0 0 1-.993.998H3.993A.996.996 0 0 1 3 20.002zm16 0H5v9h14zM4 5v3h16V5zm5 7h6v2H9z"/>',
    },
    "archive-stack-fill": {
      body: '<path fill="currentColor" d="M4 5h16V3H4zm16 4H4V7h16zM9 13h6v-2h6v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9h6z"/>',
    },
    "archive-stack-line": {
      body: '<path fill="currentColor" d="M4 5h16V3H4zm16 4H4V7h16zM3 11h7v2h4v-2h7v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm13 2v2H8v-2H5v6h14v-6z"/>',
    },
    "armchair-fill": {
      body: '<path fill="currentColor" d="M16 3H8a4 4 0 0 0-4 4v1a5 5 0 0 1 5 5h6a5 5 0 0 1 5-5V7a4 4 0 0 0-4-4m4 7a3 3 0 0 0-3 3v3h-2v-1H9v1H7v-3a3 3 0 1 0-4 2.83V21h2v-1h14v1h2v-5.17A3.001 3.001 0 0 0 20 10"/>',
    },
    "armchair-line": {
      body: '<path fill="currentColor" d="M8 3a4 4 0 0 0-4 4v2.126a4.002 4.002 0 0 0-1 7.339V21h2v-1h14v1h2v-4.535a4.002 4.002 0 0 0-1-7.339V7a4 4 0 0 0-4-4zm10 6.126c-1.725.444-3 2.01-3 3.874H9a4 4 0 0 0-3-3.874V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2zM9 15h6v1h2v-3a2 2 0 1 1 2.667 1.886a1 1 0 0 0-.667.943V18H5v-2.17a1 1 0 0 0-.667-.944A2.001 2.001 0 0 1 5 11a2 2 0 0 1 2 2v3h2z"/>',
    },
    "arrow-down-circle-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m1 10V8h-2v4H8l4 4l4-4z"/>',
    },
    "arrow-down-circle-line": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m1-8h3l-4 4l-4-4h3V8h2z"/>',
    },
    "arrow-down-double-fill": {
      body: '<path fill="currentColor" d="m12 19.164l6.207-6.207l-1.414-1.414L12 16.336l-4.793-4.793l-1.414 1.414zm0-5.65l6.207-6.207l-1.414-1.414L12 10.686L7.207 5.893L5.793 7.307z"/>',
    },
    "arrow-down-double-line": {
      body: '<path fill="currentColor" d="m12 19.164l6.207-6.207l-1.414-1.414L12 16.336l-4.793-4.793l-1.414 1.414zm0-5.65l6.207-6.207l-1.414-1.414L12 10.686L7.207 5.893L5.793 7.307z"/>',
    },
    "arrow-down-fill": {
      body: '<path fill="currentColor" d="M13 12h7l-8 8l-8-8h7V4h2z"/>',
    },
    "arrow-down-line": {
      body: '<path fill="currentColor" d="m13 16.172l5.364-5.364l1.414 1.414L12 20l-7.778-7.778l1.414-1.414L11 16.172V4h2z"/>',
    },
    "arrow-down-s-fill": {
      body: '<path fill="currentColor" d="m12 16l-6-6h12z"/>',
    },
    "arrow-down-s-line": {
      body: '<path fill="currentColor" d="m12 13.171l4.95-4.95l1.414 1.415L12 16L5.636 9.636L7.05 8.222z"/>',
    },
    "arrow-down-wide-fill": {
      body: '<path fill="currentColor" d="m12 15.632l8.968-4.748l-.936-1.768L12 13.368L3.968 9.116l-.936 1.768z"/>',
    },
    "arrow-down-wide-line": {
      body: '<path fill="currentColor" d="m12 15.632l8.968-4.748l-.936-1.768L12 13.368L3.968 9.116l-.936 1.768z"/>',
    },
    "arrow-drop-down-fill": {
      body: '<path fill="currentColor" d="m12 14l-4-4h8z"/>',
    },
    "arrow-drop-down-line": {
      body: '<path fill="currentColor" d="m12 15l-4.243-4.242l1.415-1.414L12 12.172l2.828-2.828l1.415 1.414z"/>',
    },
    "arrow-drop-left-fill": {
      body: '<path fill="currentColor" d="m9 12l4-4v8z"/>',
    },
    "arrow-drop-left-line": {
      body: '<path fill="currentColor" d="m11.828 12l2.829 2.829l-1.414 1.414L9 12.001l4.243-4.243l1.414 1.414z"/>',
    },
    "arrow-drop-right-fill": {
      body: '<path fill="currentColor" d="m14 12l-4 4V8z"/>',
    },
    "arrow-drop-right-line": {
      body: '<path fill="currentColor" d="M12.172 12L9.343 9.173l1.415-1.414L15 12l-4.242 4.242l-1.415-1.414z"/>',
    },
    "arrow-drop-up-fill": {
      body: '<path fill="currentColor" d="m12 10l4 4H8z"/>',
    },
    "arrow-drop-up-line": {
      body: '<path fill="currentColor" d="m12 11.828l-2.828 2.829l-1.415-1.414L12 9l4.243 4.243l-1.415 1.414z"/>',
    },
    "arrow-go-back-fill": {
      body: '<path fill="currentColor" d="M8 7v4L2 6l6-5v4h5a8 8 0 1 1 0 16H4v-2h9a6 6 0 0 0 0-12z"/>',
    },
    "arrow-go-back-line": {
      body: '<path fill="currentColor" d="m5.828 7l2.536 2.535L6.95 10.95L2 6l4.95-4.95l1.414 1.415L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 0 0 0-12z"/>',
    },
    "arrow-go-forward-fill": {
      body: '<path fill="currentColor" d="M16 7h-5a6 6 0 1 0 0 12h9v2h-9a8 8 0 1 1 0-16h5V1l6 5l-6 5z"/>',
    },
    "arrow-go-forward-line": {
      body: '<path fill="currentColor" d="M18.172 7H11a6 6 0 0 0 0 12h9v2h-9a8 8 0 0 1 0-16h7.172l-2.536-2.536L17.05 1.05L22 6l-4.95 4.95l-1.414-1.415z"/>',
    },
    "arrow-left-circle-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 9V8l-4 4l4 4v-3h4v-2z"/>',
    },
    "arrow-left-circle-line": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m0-9h4v2h-4v3l-4-4l4-4z"/>',
    },
    "arrow-left-double-fill": {
      body: '<path fill="currentColor" d="m4.836 12l6.207 6.207l1.414-1.414L7.664 12l4.793-4.793l-1.414-1.414zm5.65 0l6.207 6.207l1.414-1.414L13.314 12l4.793-4.793l-1.414-1.414z"/>',
    },
    "arrow-left-double-line": {
      body: '<path fill="currentColor" d="m4.836 12l6.207 6.207l1.414-1.414L7.664 12l4.793-4.793l-1.414-1.414zm5.65 0l6.207 6.207l1.414-1.414L13.314 12l4.793-4.793l-1.414-1.414z"/>',
    },
    "arrow-left-down-fill": {
      body: '<path fill="currentColor" d="m12.36 13.052l4.95 4.95H5.998V6.687l4.95 4.95l5.656-5.658l1.415 1.415z"/>',
    },
    "arrow-left-down-line": {
      body: '<path fill="currentColor" d="m9 13.589l8.607-8.607l1.414 1.415l-8.607 8.606H18v2H7v-11h2z"/>',
    },
    "arrow-left-fill": {
      body: '<path fill="currentColor" d="M12 13v7l-8-8l8-8v7h8v2z"/>',
    },
    "arrow-left-line": {
      body: '<path fill="currentColor" d="M7.828 11H20v2H7.828l5.364 5.364l-1.414 1.414L4 12l7.778-7.778l1.414 1.414z"/>',
    },
    "arrow-left-right-fill": {
      body: '<path fill="currentColor" d="M16 16v-4l5 5l-5 5v-4H4v-2zM8 2v3.999L20 6v2H8v4L3 7z"/>',
    },
    "arrow-left-right-line": {
      body: '<path fill="currentColor" d="M16.05 12.05L21 17l-4.95 4.95l-1.414-1.415L17.172 18H4v-2h13.172l-2.536-2.535zm-8.1-10l1.414 1.414l-2.536 2.535H20v2H6.828l2.536 2.536L7.95 11.95L3 7z"/>',
    },
    "arrow-left-s-fill": {
      body: '<path fill="currentColor" d="m8 12l6-6v12z"/>',
    },
    "arrow-left-s-line": {
      body: '<path fill="currentColor" d="m10.828 12l4.95 4.95l-1.414 1.415L8 12l6.364-6.364l1.414 1.414z"/>',
    },
    "arrow-left-up-fill": {
      body: '<path fill="currentColor" d="m12.36 10.947l5.658 5.657l-1.415 1.414l-5.656-5.657l-4.95 4.95V5.997H17.31z"/>',
    },
    "arrow-left-up-line": {
      body: '<path fill="currentColor" d="m9.414 8l8.607 8.607l-1.414 1.414L8 9.414V17H6V6h11v2z"/>',
    },
    "arrow-left-wide-fill": {
      body: '<path fill="currentColor" d="m8.369 12l4.747-8.968l1.768.936L10.632 12l4.252 8.032l-1.768.936z"/>',
    },
    "arrow-left-wide-line": {
      body: '<path fill="currentColor" d="m8.369 12l4.747-8.968l1.768.936L10.632 12l4.252 8.032l-1.768.936z"/>',
    },
    "arrow-right-circle-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 9H8v2h4v3l4-4l-4-4z"/>',
    },
    "arrow-right-circle-line": {
      body: '<path fill="currentColor" d="M12 11V8l4 4l-4 4v-3H8v-2zm0-9c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8"/>',
    },
    "arrow-right-double-fill": {
      body: '<path fill="currentColor" d="m19.164 12l-6.207-6.207l-1.414 1.414L16.336 12l-4.793 4.793l1.414 1.414zm-5.65 0L7.307 5.793L5.893 7.207L10.686 12l-4.793 4.793l1.414 1.414z"/>',
    },
    "arrow-right-double-line": {
      body: '<path fill="currentColor" d="m19.164 12l-6.207-6.207l-1.414 1.414L16.336 12l-4.793 4.793l1.414 1.414zm-5.65 0L7.307 5.793L5.893 7.207L10.686 12l-4.793 4.793l1.414 1.414z"/>',
    },
    "arrow-right-down-fill": {
      body: '<path fill="currentColor" d="M11.637 13.052L5.98 7.395L7.394 5.98l5.657 5.657L18 6.687v11.314H6.687z"/>',
    },
    "arrow-right-down-line": {
      body: '<path fill="currentColor" d="M14.59 16.003L5.983 7.397l1.414-1.415l8.607 8.607V7.003h2v11h-11v-2z"/>',
    },
    "arrow-right-fill": {
      body: '<path fill="currentColor" d="M12 13H4v-2h8V4l8 8l-8 8z"/>',
    },
    "arrow-right-line": {
      body: '<path fill="currentColor" d="m16.172 11l-5.364-5.364l1.414-1.414L20 12l-7.778 7.778l-1.414-1.414L16.172 13H4v-2z"/>',
    },
    "arrow-right-s-fill": {
      body: '<path fill="currentColor" d="m16 12l-6 6V6z"/>',
    },
    "arrow-right-s-line": {
      body: '<path fill="currentColor" d="m13.172 12l-4.95-4.95l1.414-1.413L16 12l-6.364 6.364l-1.414-1.415z"/>',
    },
    "arrow-right-up-fill": {
      body: '<path fill="currentColor" d="m13.05 12.361l-5.656 5.657l-1.414-1.414l5.657-5.657l-4.95-4.95H18v11.314z"/>',
    },
    "arrow-right-up-line": {
      body: '<path fill="currentColor" d="m16.004 9.414l-8.607 8.607l-1.414-1.414L14.59 8H7.003V6h11v11h-2z"/>',
    },
    "arrow-right-wide-fill": {
      body: '<path fill="currentColor" d="m15.632 12l-4.748-8.968l-1.768.936L13.368 12l-4.252 8.032l1.768.936z"/>',
    },
    "arrow-right-wide-line": {
      body: '<path fill="currentColor" d="m15.632 12l-4.748-8.968l-1.768.936L13.368 12l-4.252 8.032l1.768.936z"/>',
    },
    "arrow-turn-back-fill": {
      body: '<path fill="currentColor" d="M17 16h-4l5 6l5-6h-4v-5a8 8 0 1 0-16 0v9h2v-9a6 6 0 1 1 12 0z"/>',
    },
    "arrow-turn-back-line": {
      body: '<path fill="currentColor" d="m17 18.172l-2.535-2.536l-1.414 1.414L18 22l4.95-4.95l-1.415-1.414L19 18.172V11a8 8 0 1 0-16 0v9h2v-9a6 6 0 1 1 12 0z"/>',
    },
    "arrow-turn-forward-fill": {
      body: '<path fill="currentColor" d="M17 8v5a6 6 0 0 1-12 0V4H3v9a8 8 0 1 0 16 0V8h4l-5-6l-5 6z"/>',
    },
    "arrow-turn-forward-line": {
      body: '<path fill="currentColor" d="M17 5.828V13a6 6 0 0 1-12 0V4H3v9a8 8 0 1 0 16 0V5.828l2.536 2.536L22.95 6.95L18 2l-4.95 4.95l1.415 1.414z"/>',
    },
    "arrow-up-circle-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m1 10h3l-4-4l-4 4h3v4h2z"/>',
    },
    "arrow-up-circle-line": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m1-8v4h-2v-4H8l4-4l4 4z"/>',
    },
    "arrow-up-double-fill": {
      body: '<path fill="currentColor" d="m12 4.836l-6.207 6.207l1.414 1.414L12 7.664l4.793 4.793l1.414-1.414zm0 5.65l-6.207 6.207l1.414 1.414L12 13.314l4.793 4.793l1.414-1.414z"/>',
    },
    "arrow-up-double-line": {
      body: '<path fill="currentColor" d="m12 4.836l-6.207 6.207l1.414 1.414L12 7.664l4.793 4.793l1.414-1.414zm0 5.65l-6.207 6.207l1.414 1.414L12 13.314l4.793 4.793l1.414-1.414z"/>',
    },
    "arrow-up-down-fill": {
      body: '<path fill="currentColor" d="M12 8H8.001L8 20H6V8H2l5-5zm10 8l-5 5l-5-5h4V4h2v12z"/>',
    },
    "arrow-up-down-line": {
      body: '<path fill="currentColor" d="m11.95 7.95l-1.414 1.414L8 6.828V20H6V6.828L3.466 9.364L2.05 7.95L7 3zm10 8.1L17 21l-4.95-4.95l1.414-1.414l2.537 2.536L16 4h2v13.172l2.536-2.536z"/>',
    },
    "arrow-up-fill": {
      body: '<path fill="currentColor" d="M13 12v8h-2v-8H4l8-8l8 8z"/>',
    },
    "arrow-up-line": {
      body: '<path fill="currentColor" d="M13 7.828V20h-2V7.828l-5.364 5.364l-1.414-1.414L12 4l7.778 7.778l-1.414 1.414z"/>',
    },
    "arrow-up-s-fill": {
      body: '<path fill="currentColor" d="m12 8l6 6H6z"/>',
    },
    "arrow-up-s-line": {
      body: '<path fill="currentColor" d="m12 10.828l-4.95 4.95l-1.414-1.414L12 8l6.364 6.364l-1.414 1.414z"/>',
    },
    "arrow-up-wide-fill": {
      body: '<path fill="currentColor" d="m12 8.369l8.968 4.747l-.936 1.768L12 10.632l-8.032 4.252l-.936-1.768z"/>',
    },
    "arrow-up-wide-line": {
      body: '<path fill="currentColor" d="m12 8.369l8.968 4.747l-.936 1.768L12 10.632l-8.032 4.252l-.936-1.768z"/>',
    },
    "artboard-2-fill": {
      body: '<path fill="currentColor" d="M6 6h12v12H6zm0-4h2v3H6zm0 17h2v3H6zM2 6h3v2H2zm0 10h3v2H2zM19 6h3v2h-3zm0 10h3v2h-3zM16 2h2v3h-2zm0 17h2v3h-2z"/>',
    },
    "artboard-2-line": {
      body: '<path fill="currentColor" d="M8 8v8h8V8zM6 6h12v12H6zm0-4h2v3H6zm0 17h2v3H6zM2 6h3v2H2zm0 10h3v2H2zM19 6h3v2h-3zm0 10h3v2h-3zM16 2h2v3h-2zm0 17h2v3h-2z"/>',
    },
    "artboard-fill": {
      body: '<path fill="currentColor" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243l-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243l-1.414-1.414zM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1"/>',
    },
    "artboard-line": {
      body: '<path fill="currentColor" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243l-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243l-1.414-1.414zM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1m1 2v7h12V5z"/>',
    },
    "article-fill": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M7 6v4h4V6zm0 6v2h10v-2zm0 4v2h10v-2zm6-9v2h4V7z"/>',
    },
    "article-line": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2V4H5v16zM7 6h4v4H7zm0 6h10v2H7zm0 4h10v2H7zm6-9h4v2h-4z"/>',
    },
    "aspect-ratio-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-3 9h-2v3h-3v2h5zm-7-5H6v5h2V9h3z"/>',
    },
    "aspect-ratio-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H4v14h16zm-7 12v-2h3v-3h2v5zM11 7v2H8v3H6V7z"/>',
    },
    asterisk: {
      body: '<path fill="currentColor" d="M13 3v7.267l6.294-3.633l1 1.732l-6.293 3.633l6.293 3.635l-1 1.732L13 13.732V21h-2v-7.268l-6.294 3.634l-1-1.732L9.999 12L3.706 8.366l1-1.732L11 10.267V3z"/>',
    },
    "at-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m8-10a8 8 0 1 0-3.968 6.911l-1.008-1.728A6 6 0 1 1 18 12v1a1 1 0 1 1-2 0V9h-1.354a4 4 0 1 0 .066 5.94A3 3 0 0 0 20 13zm-8-2a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "at-line": {
      body: '<path fill="currentColor" d="M20 12a8 8 0 1 0-3.562 6.657l1.11 1.664A9.95 9.95 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 15 8h2v5.5a1.5 1.5 0 0 0 3 0zm-8-3a3 3 0 1 0 0 6a3 3 0 0 0 0-6"/>',
    },
    "attachment-2": {
      body: '<path fill="currentColor" d="m14.829 7.757l-5.657 5.657a1 1 0 1 0 1.414 1.414l5.657-5.656A3 3 0 0 0 12 4.929l-5.657 5.657a5 5 0 0 0 7.071 7.07L19.071 12l1.414 1.414l-5.656 5.657a7 7 0 0 1-9.9-9.9l5.657-5.656a5 5 0 0 1 7.071 7.07L12 16.244A3 3 0 0 1 7.758 12l5.656-5.657z"/>',
    },
    "attachment-fill": {
      body: '<path fill="currentColor" d="M20.997 2.992L21 21.008a1 1 0 0 1-.993.992H3.993A.993.993 0 0 1 3 21.008V2.992A1 1 0 0 1 3.993 2h16.01c.549 0 .994.444.994.992M9 13V9a1 1 0 0 1 2 0v4a1 1 0 1 0 2 0V9a3 3 0 1 0-6 0v4a5 5 0 0 0 10 0V8h-2v5a3 3 0 1 1-6 0"/>',
    },
    "attachment-line": {
      body: '<path fill="currentColor" d="M14 13.5V8a4 4 0 0 0-8 0v5.5a6.5 6.5 0 1 0 13 0V4h2v9.5a8.5 8.5 0 0 1-17 0V8a6 6 0 1 1 12 0v5.5a3.5 3.5 0 1 1-7 0V8h2v5.5a1.5 1.5 0 0 0 3 0"/>',
    },
    "auction-fill": {
      body: '<path fill="currentColor" d="M14.005 20.003v2h-12v-2zM14.59.689l7.778 7.778l-1.414 1.414l-1.061-.353l-2.475 2.475l5.657 5.657l-1.414 1.414l-5.657-5.657l-2.404 2.404l.283 1.132l-1.415 1.414l-7.778-7.778l1.414-1.415l1.132.283l6.293-6.293l-.353-1.06z"/>',
    },
    "auction-line": {
      body: '<path fill="currentColor" d="M14.005 20.003v2h-12v-2zM14.59.689l7.778 7.778l-1.414 1.414l-1.061-.353l-2.475 2.475l5.657 5.657l-1.414 1.414l-5.657-5.657l-2.404 2.404l.283 1.132l-1.415 1.414l-7.778-7.778l1.414-1.415l1.132.283l6.293-6.293l-.353-1.06zm.707 3.536l-7.071 7.07l3.535 3.536l7.071-7.07z"/>',
    },
    "award-fill": {
      body: '<path fill="currentColor" d="M17 15.245v6.872a.5.5 0 0 1-.757.429L12 20l-4.243 2.546a.5.5 0 0 1-.757-.43v-6.87a8 8 0 1 1 10 0M12 15a6 6 0 1 0 0-12a6 6 0 0 0 0 12m0-2a4 4 0 1 1 0-8a4 4 0 0 1 0 8"/>',
    },
    "award-line": {
      body: '<path fill="currentColor" d="M17 15.245v6.872a.5.5 0 0 1-.757.429L12 20l-4.243 2.546a.5.5 0 0 1-.757-.43v-6.87a8 8 0 1 1 10 0M9 16.42v3.049l3-1.8l3 1.8v-3.05A8 8 0 0 1 12 17a8 8 0 0 1-3-.581M12 15a6 6 0 1 0 0-12a6 6 0 0 0 0 12"/>',
    },
    "baidu-fill": {
      body: '<path fill="currentColor" d="M5.926 12.497c2.063-.444 1.782-2.909 1.72-3.448c-.1-.83-1.078-2.282-2.404-2.167c-1.67.15-1.914 2.561-1.914 2.561c-.226 1.115.54 3.497 2.598 3.053m2.191 4.288c-.06.173-.195.616-.079 1.002c.23.866.982.905.982.905h1.08v-2.64H8.944c-.52.154-.77.559-.827.733m1.638-8.422c1.14 0 2.06-1.312 2.06-2.933s-.92-2.93-2.06-2.93c-1.138 0-2.06 1.31-2.06 2.93s.923 2.933 2.06 2.933m4.907.193c1.523.198 2.502-1.427 2.697-2.659c.198-1.23-.784-2.658-1.862-2.904c-1.08-.248-2.43 1.483-2.552 2.61c-.147 1.38.197 2.758 1.717 2.953m0 3.448c-1.865-2.905-4.513-1.723-5.399-.245c-.882 1.477-2.256 2.41-2.452 2.658c-.198.244-2.846 1.673-2.258 4.284c.588 2.609 2.653 2.56 2.653 2.56s1.521.15 3.286-.246c1.766-.391 3.286.098 3.286.098s4.124 1.38 5.253-1.278c1.127-2.66-.638-4.038-.638-4.038s-2.356-1.823-3.731-3.793m-6.007 7.75c-1.158-.231-1.62-1.021-1.677-1.156c-.057-.137-.386-.772-.212-1.853c.5-1.619 1.927-1.735 1.927-1.735h1.427v-1.755l1.216.02v6.479zm4.59-.019c-1.196-.308-1.252-1.158-1.252-1.158v-3.412l1.252-.02v3.066c.076.328.482.387.482.387H15v-3.433h1.331v4.57zm7.453-9.11c0-.59-.49-2.364-2.305-2.364c-1.818 0-2.061 1.675-2.061 2.859c0 1.13.095 2.707 2.354 2.657s2.012-2.56 2.012-3.152"/>',
    },
    "baidu-line": {
      body: '<path fill="currentColor" d="M7.563 19.28q.257.012.584.006a9.7 9.7 0 0 0 1.912-.223a8.8 8.8 0 0 1 2.98-.131a8 8 0 0 1 1.289.257c1.077.275 2.61.223 3.005-.41c.29-.468.253-.787-.026-1.199c-.06-.09-.126-.17-.188-.235l-.024-.025l-.165-.132q-.265-.215-.579-.486a26 26 0 0 1-1.752-1.66a16 16 0 0 1-1.577-1.893l-.036-.053c-.742-1.139-1.558-1.067-2.002-.318a9.6 9.6 0 0 1-.955 1.332c-.41.482-.83.89-1.306 1.297c-.122.105-.502.42-.411.344c-.004.003-.017.015.05-.071c-.098.12-.95.877-1.2 1.162c-.515.583-.722 1.08-.645 1.48c.073.376.22.587.45.745a1.4 1.4 0 0 0 .48.206zm7.099-7.276c1.375 1.97 3.731 3.793 3.731 3.793s2.064 1.748.638 4.038s-5.253 1.278-5.253 1.278s-1.52-.49-3.286-.098c-1.765.395-3.286.245-3.286.245S5 21.015 4.553 18.701c-.446-2.314 2.06-4.04 2.258-4.284c.196-.247 1.512-1.073 2.452-2.658c.94-1.586 3.584-2.54 5.399.245m5.538-1.42c0 .457.191 2.393-1.552 2.432c-1.743.038-1.816-1.178-1.816-2.05c0-.913.187-2.205 1.59-2.205c1.4 0 1.778 1.369 1.778 1.824m-5.429-2.777c-1.18-.152-1.447-1.222-1.333-2.293c.095-.875 1.142-2.219 1.981-2.026c.837.19 1.6 1.3 1.446 2.254c-.152.957-.912 2.218-2.094 2.065M9.755 7.44c-.861 0-1.56-.993-1.56-2.22S8.892 3 9.754 3s1.56.993 1.56 2.22s-.697 2.22-1.56 2.22m-3.793 4.566c-1.695.365-2.327-1.597-2.14-2.515c0 0 .2-1.987 1.576-2.11c1.093-.095 1.898 1.101 1.98 1.785c.052.444.283 2.475-1.416 2.84"/>',
    },
    "ball-pen-fill": {
      body: '<path fill="currentColor" d="m17.85 11.805l-.708-.707l-9.9 9.9H3v-4.243L14.314 5.44l5.657 5.657a1 1 0 0 1 0 1.414L12.9 19.583l-1.415-1.414zm.706-9.192l2.829 2.828a1 1 0 0 1 0 1.414L19.97 8.27l-4.243-4.242l1.414-1.414a1 1 0 0 1 1.414 0"/>',
    },
    "ball-pen-line": {
      body: '<path fill="currentColor" d="m17.85 11.698l-.708-.707l-9.9 9.9H3v-4.243L14.314 5.334l5.657 5.657a1 1 0 0 1 0 1.414L12.9 19.477l-1.415-1.415zm-2.122-2.121l-1.414-1.414L5 17.477v1.414h1.414zm2.828-7.071l2.829 2.828a1 1 0 0 1 0 1.415L19.97 8.163L15.728 3.92l1.414-1.414a1 1 0 0 1 1.414 0"/>',
    },
    "bank-card-2-fill": {
      body: '<path fill="currentColor" d="M22.005 11v9a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-9zm0-4h-20V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1z"/>',
    },
    "bank-card-2-line": {
      body: '<path fill="currentColor" d="M3.005 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m17 9h-16v7h16zm0-4V5h-16v3z"/>',
    },
    "bank-card-fill": {
      body: '<path fill="currentColor" d="M22.005 10v10a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V10zm0-2h-20V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-7 8v2h4v-2z"/>',
    },
    "bank-card-line": {
      body: '<path fill="currentColor" d="M3.005 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m17 8h-16v8h16zm0-2V5h-16v4zm-6 6h4v2h-4z"/>',
    },
    "bank-fill": {
      body: '<path fill="currentColor" d="M2 20h20v2H2zm2-8h2v7H4zm5 0h2v7H9zm4 0h2v7h-2zm5 0h2v7h-2zM2 7l10-5l10 5v4H2zm10 1a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "bank-line": {
      body: '<path fill="currentColor" d="M2 20h20v2H2zm2-8h2v7H4zm5 0h2v7H9zm4 0h2v7h-2zm5 0h2v7h-2zM2 7l10-5l10 5v4H2zm2 1.236V9h16v-.764l-8-4zM12 8a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "bar-chart-2-fill": {
      body: '<path fill="currentColor" d="M2 13h6v8H2zM9 3h6v18H9zm7 5h6v13h-6z"/>',
    },
    "bar-chart-2-line": {
      body: '<path fill="currentColor" d="M2 13h6v8H2zm14-5h6v13h-6zM9 3h6v18H9zM4 15v4h2v-4zm7-10v14h2V5zm7 5v9h2v-9z"/>',
    },
    "bar-chart-box-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4 10v4h2v-4zm4-6v10h2V7zm4 3v7h2v-7z"/>',
    },
    "bar-chart-box-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h16V5zm3 8h2v4H7zm4-6h2v10h-2zm4 3h2v7h-2z"/>',
    },
    "bar-chart-fill": {
      body: '<path fill="currentColor" d="M3 12h4v9H3zm14-4h4v13h-4zm-7-6h4v19h-4z"/>',
    },
    "bar-chart-grouped-fill": {
      body: '<path fill="currentColor" d="M2 12h2v9H2zm3 2h2v7H5zm11-6h2v13h-2zm3 2h2v11h-2zM9 2h2v19H9zm3 2h2v17h-2z"/>',
    },
    "bar-chart-grouped-line": {
      body: '<path fill="currentColor" d="M2 12h2v9H2zm3 2h2v7H5zm11-6h2v13h-2zm3 2h2v11h-2zM9 2h2v19H9zm3 2h2v17h-2z"/>',
    },
    "bar-chart-horizontal-fill": {
      body: '<path fill="currentColor" d="M12 3v4H3V3zm4 14v4H3v-4zm6-7v4H3v-4z"/>',
    },
    "bar-chart-horizontal-line": {
      body: '<path fill="currentColor" d="M12 3v2H3V3zm4 16v2H3v-2zm6-8v2H3v-2z"/>',
    },
    "bar-chart-line": {
      body: '<path fill="currentColor" d="M3 12h2v9H3zm16-4h2v13h-2zm-8-6h2v19h-2z"/>',
    },
    "barcode-box-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 4v10h3V7zm4 0v10h2V7zm3 0v10h1V7zm2 0v10h3V7z"/>',
    },
    "barcode-box-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V5zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 4h3v10H6zm4 0h2v10h-2zm3 0h1v10h-1zm2 0h3v10h-3z"/>',
    },
    "barcode-fill": {
      body: '<path fill="currentColor" d="M2 4h2v16H2zm4 0h2v16H6zm3 0h3v16H9zm4 0h2v16h-2zm3 0h2v16h-2zm3 0h3v16h-3z"/>',
    },
    "barcode-line": {
      body: '<path fill="currentColor" d="M2 4h2v16H2zm4 0h1v16H6zm2 0h2v16H8zm3 0h2v16h-2zm3 0h2v16h-2zm3 0h1v16h-1zm2 0h3v16h-3z"/>',
    },
    "bard-fill": {
      body: '<path fill="currentColor" d="m10.614 17.796l.878-2.01a7.74 7.74 0 0 1 3.94-3.992l2.416-1.072c.768-.341.768-1.458 0-1.8l-2.34-1.038a7.75 7.75 0 0 1-3.997-4.125l-.89-2.142a.946.946 0 0 0-1.758 0l-.889 2.142a7.75 7.75 0 0 1-3.997 4.125l-2.34 1.039c-.768.34-.768 1.458 0 1.799l2.415 1.072a7.74 7.74 0 0 1 3.94 3.991l.878 2.01a.946.946 0 0 0 1.744 0m8.787 4.894l.247-.566a4.37 4.37 0 0 1 2.221-2.25l.76-.339a.53.53 0 0 0 0-.963l-.717-.319a4.37 4.37 0 0 1-2.253-2.326l-.254-.611a.507.507 0 0 0-.942 0l-.254.61a4.37 4.37 0 0 1-2.253 2.327l-.718.32a.53.53 0 0 0 0 .962l.76.338a4.37 4.37 0 0 1 2.222 2.251l.247.566c.18.414.754.414.934 0"/>',
    },
    "bard-line": {
      body: '<path fill="currentColor" d="M10.614 17.796a.946.946 0 0 1-1.744 0l-.877-2.01a7.74 7.74 0 0 0-3.94-3.992l-2.416-1.072c-.768-.341-.768-1.458 0-1.8l2.34-1.038a7.75 7.75 0 0 0 3.997-4.125l.89-2.142a.946.946 0 0 1 1.757 0l.89 2.142a7.75 7.75 0 0 0 3.997 4.125l2.34 1.039c.768.34.768 1.458 0 1.799l-2.415 1.072a7.74 7.74 0 0 0-3.941 3.991zM4.54 9.822c2.285 1.015 4.144 2.683 5.202 4.978c1.059-2.295 2.917-3.963 5.203-4.978c-2.313-1.026-4.177-2.776-5.203-5.111c-1.025 2.335-2.89 4.085-5.202 5.111M19.4 22.69l.247-.566a4.37 4.37 0 0 1 2.221-2.25l.76-.339a.53.53 0 0 0 0-.963l-.717-.319a4.37 4.37 0 0 1-2.253-2.326l-.254-.611a.507.507 0 0 0-.942 0l-.254.61a4.37 4.37 0 0 1-2.253 2.327l-.718.32a.53.53 0 0 0 0 .962l.76.338a4.37 4.37 0 0 1 2.222 2.251l.247.566c.18.414.754.414.934 0m-1.026-3.643l.562-.559l.55.559l-.55.543z"/>',
    },
    "barricade-fill": {
      body: '<path fill="currentColor" d="M19.556 19H21v2H3v-2h1.444l.89-4h13.333zM17.333 9l.89 4H5.777l.889-4zm-.444-2H7.11l.715-3.217A1 1 0 0 1 8.802 3h6.396a1 1 0 0 1 .976.783z"/>',
    },
    "barricade-line": {
      body: '<path fill="currentColor" d="M6.493 19h11.014l-.667-3H7.16zm13.063 0H21v2H3v-2h1.444L7.826 3.783A1 1 0 0 1 8.802 3h6.396a1 1 0 0 1 .976.783zM7.604 14h8.792l-.89-4H8.494zm1.334-6h6.124l-.666-3H9.604z"/>',
    },
    "base-station-fill": {
      body: '<path fill="currentColor" d="m12 13l6 9H6zm-1.06-2.44a1.5 1.5 0 1 1 2.12-2.12a1.5 1.5 0 0 1-2.12 2.12M5.281 2.783l1.415 1.415a7.5 7.5 0 0 0 0 10.606l-1.415 1.415a9.5 9.5 0 0 1 0-13.436m13.436 0a9.5 9.5 0 0 1 0 13.436l-1.415-1.415a7.5 7.5 0 0 0 0-10.606zM8.11 5.611l1.414 1.414a3.5 3.5 0 0 0 0 4.95L8.11 13.389a5.5 5.5 0 0 1 0-7.778m7.778 0a5.5 5.5 0 0 1 0 7.778l-1.414-1.414a3.5 3.5 0 0 0 0-4.95z"/>',
    },
    "base-station-line": {
      body: '<path fill="currentColor" d="m12 13l6 9H6zm0 3.6L9.74 20h4.52zm-1.06-6.04a1.5 1.5 0 1 1 2.12-2.12a1.5 1.5 0 0 1-2.12 2.12M5.281 2.783l1.415 1.415a7.5 7.5 0 0 0 0 10.606l-1.415 1.415a9.5 9.5 0 0 1 0-13.436m13.436 0a9.5 9.5 0 0 1 0 13.436l-1.415-1.415a7.5 7.5 0 0 0 0-10.606zM8.11 5.611l1.414 1.414a3.5 3.5 0 0 0 0 4.95L8.11 13.389a5.5 5.5 0 0 1 0-7.778m7.778 0a5.5 5.5 0 0 1 0 7.778l-1.414-1.414a3.5 3.5 0 0 0 0-4.95z"/>',
    },
    "basketball-fill": {
      body: '<path fill="currentColor" d="m12.366 13.366l1.775 1.025a9.98 9.98 0 0 0-.311 7.44A10 10 0 0 1 12 22a10 10 0 0 1-4.11-.88zm3.518 2.032l4.233 2.444a10.03 10.03 0 0 1-4.363 3.43a8 8 0 0 1 .008-5.57zm-7.025-4.056l1.775 1.024l-4.476 7.75a10.03 10.03 0 0 1-3.59-4.785a9.98 9.98 0 0 0 6.085-3.713zm13.046-.726Q22 11.297 22 12a10 10 0 0 1-.88 4.11l-4.236-2.445a8 8 0 0 1 4.866-3.021zM2.881 7.892l4.235 2.445a8 8 0 0 1-5.021 3.05A10 10 0 0 1 2 12a10 10 0 0 1 .88-4.11m14.961-4.008a10.03 10.03 0 0 1 3.59 4.785a9.98 9.98 0 0 0-6.086 3.715l-.205.276l-1.775-1.025zM12 2a10 10 0 0 1 4.11.88l-4.476 7.754L9.859 9.61a9.98 9.98 0 0 0 .311-7.442A10 10 0 0 1 12 2m-3.753.73a8 8 0 0 1-.01 5.57l-.12.303l-4.234-2.445a10.04 10.04 0 0 1 4.164-3.346z"/>',
    },
    "basketball-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m.366 11.366l-3.469 6.01a8.06 8.06 0 0 0 4.459.51a9.94 9.94 0 0 1 .784-5.494zm3.518 2.031a7.96 7.96 0 0 0-.587 3.894a8 8 0 0 0 3.078-2.456zm-7.025-4.055a9.95 9.95 0 0 1-4.365 3.428a8 8 0 0 0 2.671 3.605l3.469-6.009zm11.103-.13l-.258.12a7.95 7.95 0 0 0-2.82 2.333l2.492 1.439a8 8 0 0 0 .586-3.893M4 12q0 .4.038.789a7.95 7.95 0 0 0 3.078-2.453L4.624 8.897A8 8 0 0 0 4 12m12.835-6.374l-3.469 6.008l1.775 1.025a9.95 9.95 0 0 1 4.366-3.43a8 8 0 0 0-2.419-3.402zM12 4q-.695.001-1.357.115a9.93 9.93 0 0 1-.784 5.494l1.775 1.025l3.469-6.01A8 8 0 0 0 12 4m-3.297.71l-.191.088a8 8 0 0 0-2.886 2.367l2.49 1.438a7.96 7.96 0 0 0 .587-3.893"/>',
    },
    "battery-2-charge-fill": {
      body: '<path fill="currentColor" d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm4 8V7l-5 7h3v5l5-7z"/>',
    },
    "battery-2-charge-line": {
      body: '<path fill="currentColor" d="M13 12h3l-5 7v-5H8l5-7zm-2-6H7v14h10V6h-4V4h-2zM9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/>',
    },
    "battery-2-fill": {
      body: '<path fill="currentColor" d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/>',
    },
    "battery-2-line": {
      body: '<path fill="currentColor" d="M11 6H7v14h10V6h-4V4h-2zM9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/>',
    },
    "battery-charge-fill": {
      body: '<path fill="currentColor" d="M12 11V5l-5 8h3v6l5-8zM3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m18 4h2v6h-2z"/>',
    },
    "battery-charge-line": {
      body: '<path fill="currentColor" d="M8 19H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6.625L8.458 7H4v10h4zm4.375 0l1.167-2H18V7h-4V5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zM21 9h2v6h-2zm-9 2h3l-5 8v-6H7l5-8z"/>',
    },
    "battery-fill": {
      body: '<path fill="currentColor" d="M3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m18 4h2v6h-2z"/>',
    },
    "battery-line": {
      body: '<path fill="currentColor" d="M4 7v10h14V7zM3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m18 4h2v6h-2z"/>',
    },
    "battery-low-fill": {
      body: '<path fill="currentColor" d="M3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m2 3v8h4V8zm16 1h2v6h-2z"/>',
    },
    "battery-low-line": {
      body: '<path fill="currentColor" d="M4 7v10h14V7zM3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m2 3h4v8H5zm16 1h2v6h-2z"/>',
    },
    "battery-saver-fill": {
      body: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1zm-1 7h-2v3H8v2h3v3h2v-3h3v-2h-3z"/>',
    },
    "battery-saver-line": {
      body: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1zm-1 2h-2v2H7v14h10V6h-4zm0 5v3h3v2h-3v3h-2v-3H8v-2h3V9z"/>',
    },
    "battery-share-fill": {
      body: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v6.2L15 8v3h-1c-2.142 0-4 1.79-4 4v3h2v-3c0-1.05.95-2 2-2h1v3l4-3.2V21a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1z"/>',
    },
    "battery-share-line": {
      body: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v2h-2V6h-4V4h-2v2H7v14h10v-3h2v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1zm1 6l5 4l-5 4v-3h-1c-1.054 0-2 .95-2 2v3h-2v-3a4 4 0 0 1 4-4h1z"/>',
    },
    "bear-smile-fill": {
      body: '<path fill="currentColor" d="M17.5 2a4.5 4.5 0 0 1 2.951 7.897A9 9 0 0 1 21 13a9 9 0 1 1-18 0c0-1.09.194-2.136.55-3.103a4.5 4.5 0 1 1 6.791-5.744a9 9 0 0 1 3.32 0A4.5 4.5 0 0 1 17.5 2M10 13H8a4 4 0 0 0 8 0h-2a2 2 0 1 1-4 0"/>',
    },
    "bear-smile-line": {
      body: '<path fill="currentColor" d="M12 17a4 4 0 0 0 4-4h-2a2 2 0 1 1-4 0H8a4 4 0 0 0 4 4M6.5 2a4.5 4.5 0 0 0-2.95 7.898a9 9 0 1 0 16.901 0a4.5 4.5 0 1 0-6.79-5.745a9 9 0 0 0-3.321 0A4.5 4.5 0 0 0 6.5 2M4 6.5a2.5 2.5 0 0 1 4.852-.851l.318.878l.898-.257A7 7 0 0 1 12 6c.672 0 1.32.094 1.932.27l.898.257l.318-.878a2.501 2.501 0 1 1 3.58 3.03l-.814.46l.404.842a7 7 0 1 1-12.635 0l.403-.843l-.814-.46A2.5 2.5 0 0 1 4 6.5"/>',
    },
    "beer-fill": {
      body: '<path fill="currentColor" d="M9 3a2 2 0 0 1 1.972 2.335l1.973.33a4 4 0 0 0-.005-1.361A2 2 0 0 1 15.733 7H5a1 1 0 1 1 .539-1.843a1 1 0 0 0 1.513-.614A2 2 0 0 1 9 3m1.516-1.703A4 4 0 0 0 5.51 3.043A3 3 0 0 0 3 8.236V20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2h2a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-2v-.354a4 4 0 0 0-4.896-6.169a4 4 0 0 0-1.588-1.18M17 18v-7h2v7zM7 11h2v7H7zm4 0h2v7h-2z"/>',
    },
    "beer-line": {
      body: '<path fill="currentColor" d="M9 3a2 2 0 0 1 1.972 2.335l1.973.33a4 4 0 0 0-.005-1.361A2 2 0 0 1 15.733 7H5a1 1 0 1 1 .539-1.843a1 1 0 0 0 1.513-.614A2 2 0 0 1 9 3m1.516-1.703A4 4 0 0 0 5.51 3.043A3 3 0 0 0 3 8.236V20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2h2a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-2v-.354a4 4 0 0 0-4.896-6.169a4 4 0 0 0-1.588-1.18M17 11h2v7h-2zm-2-2v11H5V9zm-8 2v7h2v-7zm6 0v7h-2v-7z"/>',
    },
    "behance-fill": {
      body: '<path fill="currentColor" d="M7.443 5.35c.639 0 1.23.05 1.77.198c.541.099.984.297 1.377.544q.591.371.885 1.039c.197.445.296.99.296 1.583c0 .693-.148 1.286-.492 1.731c-.295.446-.787.841-1.377 1.138c.836.248 1.475.693 1.869 1.286s.639 1.336.639 2.177c0 .693-.148 1.286-.394 1.781c-.245.495-.639.94-1.082 1.237a5.1 5.1 0 0 1-1.573.692c-.59.149-1.18.248-1.77.248H1V5.35zm-.394 5.54c.541 0 .984-.148 1.328-.395s.492-.693.492-1.237c0-.297-.05-.594-.148-.791s-.246-.347-.442-.495a2.4 2.4 0 0 0-.64-.247c-.246-.05-.491-.05-.787-.05H4v3.216zm.148 5.838c.295 0 .59-.05.836-.099c.246-.05.492-.148.688-.297a1.8 1.8 0 0 0 .492-.544c.098-.247.197-.544.197-.89c0-.693-.197-1.188-.59-1.534c-.394-.297-.935-.445-1.574-.445H4v3.81zm9.492-.05q.59.594 1.77.594c.541 0 1.033-.148 1.426-.395q.591-.446.738-.891h2.41c-.394 1.187-.984 2.028-1.77 2.572c-.788.495-1.722.792-2.853.792a5.8 5.8 0 0 1-2.115-.396a3.9 3.9 0 0 1-1.574-1.088a3.9 3.9 0 0 1-.983-1.633c-.246-.643-.345-1.335-.345-2.127c0-.742.099-1.434.345-2.078a5.3 5.3 0 0 1 1.033-1.682c.442-.445.983-.84 1.573-1.088a5.5 5.5 0 0 1 2.066-.396c.836 0 1.574.149 2.213.495c.64.346 1.131.742 1.524 1.336c.394.544.69 1.187.886 1.88c.098.692.147 1.385.098 2.176H16c0 .792.295 1.534.689 1.93m3.098-5.194c-.344-.346-.885-.544-1.525-.544a2.34 2.34 0 0 0-1.082.247c-.295.149-.491.347-.688.545a1.3 1.3 0 0 0-.344.692c-.05.248-.099.445-.099.643h4.426c-.098-.742-.344-1.236-.688-1.583M15.459 6.29h5.508v1.336H15.46z"/>',
    },
    "behance-line": {
      body: '<path fill="currentColor" d="M7.5 11a2 2 0 1 0 0-4H3v4zm1 2H3v4h5.5a2 2 0 1 0 0-4m2.063-1.428A4 4 0 0 1 8.5 19H1V5h6.5a4 4 0 0 1 3.063 6.573M15.5 6H21v1.5h-5.5zm7.5 8.5h-7.5v.25A2.75 2.75 0 0 0 20.7 16h2.134a4.752 4.752 0 0 1-9.334-1.25v-1.5a4.75 4.75 0 1 1 9.5 0zm-2.104-2a2.751 2.751 0 0 0-5.292 0z"/>',
    },
    "bell-fill": {
      body: '<path fill="currentColor" d="m13.414 10.586l.48.486l.464.485l.46.492c3.458 3.764 5.472 7.218 4.607 8.083c-.4.4-1.356.184-2.64-.507a9.01 9.01 0 0 1-10.403-.592l2.98-2.98a2 2 0 1 0-1.45-1.569l.035.155l-2.979 2.98a9.01 9.01 0 0 1-.592-10.405c-.692-1.283-.908-2.238-.508-2.639c.977-.976 5.25 1.715 9.546 6.01m6.364-6.364a2 2 0 0 1-.165 2.976a9.02 9.02 0 0 1 .608 8.47c-1.189-1.954-3.07-4.173-5.393-6.496l-.537-.532c-2.128-2.078-4.156-3.764-5.958-4.86a9.02 9.02 0 0 1 8.471.607q.066-.086.146-.165a2 2 0 0 1 2.828 0"/>',
    },
    "bell-line": {
      body: '<path fill="currentColor" d="M14.121 9.879c4.296 4.295 6.829 8.728 5.657 9.9c-.475.474-1.486.34-2.807-.273a9.01 9.01 0 0 1-10.59-.474l-.038.039l-1.414-1.414l.038-.04A9.01 9.01 0 0 1 4.495 7.03c-.614-1.322-.748-2.333-.273-2.808c1.128-1.128 5.277 1.177 9.417 5.182zm-1.414 1.414C10.823 9.409 8.87 7.842 7.236 6.87l-.186.18a7 7 0 0 0-.657 9.142l1.846-1.846a2 2 0 0 1 3.347-1.932a2 2 0 0 1-1.931 3.347l-1.848 1.846a7 7 0 0 0 9.143-.657l.179-.188l-.053-.089c-.976-1.615-2.52-3.53-4.369-5.38m7.071-7.071a2 2 0 0 1-.165 2.976a9.02 9.02 0 0 1 .663 8.345a21 21 0 0 0-1.386-2.306a6.99 6.99 0 0 0-1.94-6.187a6.99 6.99 0 0 0-6.187-1.94a21 21 0 0 0-2.306-1.386a9.02 9.02 0 0 1 8.347.663q.066-.086.146-.165a2 2 0 0 1 2.828 0"/>',
    },
    "bike-fill": {
      body: '<path fill="currentColor" d="M5.5 12H4V7H2V5h6v2H6v2.795l9.813-2.629L15.233 5H12V3h3.978a1 1 0 0 1 .988.741l1.553 5.796l-1.932.517l-.256-.956zM5 21a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-3a1 1 0 1 0 0-2a1 1 0 0 0 0 2m13 3a5 5 0 1 1 0-10a5 5 0 0 1 0 10m0-4a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "bike-line": {
      body: '<path fill="currentColor" d="M5.5 12H4V7H2V5h6v2H6v2.795l9.813-2.629L15.233 5H12V3h3.978a1 1 0 0 1 .988.741l1.553 5.796l-1.932.517l-.256-.956zM5 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8m13-2a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2a5 5 0 1 1 0-10a5 5 0 0 1 0 10"/>',
    },
    "bilibili-fill": {
      body: '<path fill="currentColor" d="M18.223 3.086a1.25 1.25 0 0 1 0 1.768L17.08 5.996h1.17A3.75 3.75 0 0 1 22 9.747v7.5a3.75 3.75 0 0 1-3.75 3.75H5.75A3.75 3.75 0 0 1 2 17.247v-7.5a3.75 3.75 0 0 1 3.75-3.75h1.166L5.775 4.855a1.25 1.25 0 0 1 1.767-1.768l2.652 2.652q.119.119.198.257h3.213q.08-.14.199-.258l2.651-2.652a1.25 1.25 0 0 1 1.768 0m.027 5.42H5.75a1.25 1.25 0 0 0-1.247 1.157l-.003.094v7.5c0 .659.51 1.198 1.157 1.246l.093.004h12.5a1.25 1.25 0 0 0 1.247-1.157l.003-.093v-7.5c0-.69-.56-1.25-1.25-1.25m-10 2.5c.69 0 1.25.56 1.25 1.25v1.25a1.25 1.25 0 1 1-2.5 0v-1.25c0-.69.56-1.25 1.25-1.25m7.5 0c.69 0 1.25.56 1.25 1.25v1.25a1.25 1.25 0 1 1-2.5 0v-1.25c0-.69.56-1.25 1.25-1.25"/>',
    },
    "bilibili-line": {
      body: '<path fill="currentColor" d="M7.172 2.757L10.414 6h3.171l3.243-3.242a1 1 0 1 1 1.415 1.415L16.414 6H18.5A3.5 3.5 0 0 1 22 9.5v8a3.5 3.5 0 0 1-3.5 3.5h-13A3.5 3.5 0 0 1 2 17.5v-8A3.5 3.5 0 0 1 5.5 6h2.085L5.757 4.171a1 1 0 0 1 1.415-1.415M18.5 8h-13a1.5 1.5 0 0 0-1.493 1.356L4 9.5v8a1.5 1.5 0 0 0 1.356 1.493L5.5 19h13a1.5 1.5 0 0 0 1.493-1.355L20 17.5v-8A1.5 1.5 0 0 0 18.5 8M8 11a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1"/>',
    },
    "bill-fill": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M8 9v2h8V9zm0 4v2h8v-2z"/>',
    },
    "bill-line": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2V4H5v16zM8 9h8v2H8zm0 4h8v2H8z"/>',
    },
    "billiards-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 4a6 6 0 1 0 0 12a6 6 0 0 0 0-12m0 1.75a2.5 2.5 0 0 1 1.88 4.148c.565.456.92 1.117.92 1.852c0 1.38-1.254 2.5-2.8 2.5s-2.8-1.12-2.8-2.5c0-.735.355-1.396.92-1.853A2.5 2.5 0 0 1 12 7.75m0 5c-.754 0-1.3.488-1.3 1s.547 1 1.3 1c.754 0 1.3-.488 1.3-1s-.546-1-1.3-1m0-3.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "billiards-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 2a6 6 0 1 1 0 12a6 6 0 0 1 0-12m0 1.75a2.5 2.5 0 0 0-1.88 4.147c-.565.457-.92 1.118-.92 1.853c0 1.38 1.254 2.5 2.8 2.5s2.8-1.12 2.8-2.5c0-.735-.355-1.396-.92-1.852A2.5 2.5 0 0 0 12 7.75m0 5c.754 0 1.3.488 1.3 1s-.546 1-1.3 1s-1.3-.488-1.3-1s.547-1 1.3-1m0-3.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2"/>',
    },
    "bit-coin-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-1-6v2h2v-2h1a2.5 2.5 0 0 0 2-4a2.5 2.5 0 0 0-2-4h-1v-2h-2v2h-3v8zm-1-3h4a.5.5 0 0 1 0 1h-4zm0-3h4a.5.5 0 0 1 0 1h-4z"/>',
    },
    "bit-coin-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1-4h-3v-8h3v-2h2v2h1a2.5 2.5 0 0 1 2 4a2.5 2.5 0 0 1-2 4h-1v2h-2zm-1-3v1h4a.5.5 0 1 0 0-1zm0-3v1h4a.5.5 0 1 0 0-1z"/>',
    },
    "blaze-fill": {
      body: '<path fill="currentColor" d="M18.5 9q1.5 1.59 1.5 4c0 3.466-3.7 4.276-5.5 9q-1-.862-1-2.5c0-3.482 5-5.29 5-10.5m-4-4q1.8 1.858 1.8 4c0 4.951-6.045 5.692-4.8 13Q9 20.26 9 17c0-3.325 5.5-6 5.5-12M10 1q2 2.5 2 4.5c0 6.25-8.5 8.222-4 16.5c-2.616-.58-4.5-3-4.5-6C3.5 9.5 10 8.5 10 1"/>',
    },
    "blaze-line": {
      body: '<path fill="currentColor" d="M19 9q1 1.59 1 4c0 3-3.5 4-5 9q-1-.862-1-2.5c0-3.482 5-5.29 5-10.5m-4.5-4a8.3 8.3 0 0 1 1 4c0 5-6 6-4 13Q9 20.26 9 17c0-3.325 5.5-6 5.5-12M10 1q1 2 1 4.5c0 6-9 7.5-3 16.5c-2.5-.5-4.5-3-4.5-6C3.5 9.5 10 8.5 10 1"/>',
    },
    "blender-fill": {
      body: '<path fill="currentColor" d="M7.79 15.714c-.144-.455-.24-1.039-.245-1.339c-.006-.299.06-.797.06-.797l-4.509 3.69c-.787.636-1.846.635-2.344-.004c-.491-.628-.24-1.62.54-2.217l8.293-6.364l-4.628.006c-.785-.003-1.298-.532-1.15-1.17c.143-.626.869-1.121 1.624-1.122l9.146-.01l-2.995-2.439c-.466-.382-.407-.989.118-1.355c.518-.363 1.31-.364 1.782-.002l7.204 5.531l-.002.001a7.4 7.4 0 0 1 1.775 1.958a6.82 6.82 0 0 1 1.021 4.13a6.7 6.7 0 0 1-.287 1.479a7.1 7.1 0 0 1-1.526 2.647A7.9 7.9 0 0 1 19 20.263a8.6 8.6 0 0 1-3.505.74a8.6 8.6 0 0 1-3.508-.728a7.9 7.9 0 0 1-2.67-1.918a7.1 7.1 0 0 1-1.527-2.643m7.703 1.815c1.408-.003 2.708-.54 3.637-1.486c.454-.462.787-.992.993-1.558c.201-.555.28-1.143.229-1.736a4.1 4.1 0 0 0-.5-1.634a4.5 4.5 0 0 0-1.104-1.31a5.14 5.14 0 0 0-3.257-1.127a5.15 5.15 0 0 0-3.255 1.136c-.46.377-.834.822-1.105 1.314a4.1 4.1 0 0 0-.27 3.373a4.3 4.3 0 0 0 .994 1.554c.929.945 2.23 1.477 3.638 1.474m-2.018-6.625a3.28 3.28 0 0 1 2.12-.759c.815 0 1.564.288 2.12.759c.566.479.942 1.155.985 1.92c.043.79-.274 1.521-.83 2.064a3.25 3.25 0 0 1-2.275.899a3.25 3.25 0 0 1-2.277-.899c-.556-.543-.872-1.275-.828-2.062c.043-.768.418-1.443.985-1.922m0 0c-.567.479-.942 1.155-.985 1.922c-.044.787.272 1.52.829 2.062a3.25 3.25 0 0 0 2.276.899a3.25 3.25 0 0 0 2.276-.899c.555-.543.872-1.275.83-2.063c-.044-.766-.42-1.442-.986-1.921a3.28 3.28 0 0 0-2.12-.759a3.28 3.28 0 0 0-2.12.759m-5.686 4.81c-.143-.455-.239-1.039-.244-1.339c-.006-.299.06-.797.06-.797l-4.509 3.69c-.787.636-1.846.635-2.344-.004c-.491-.628-.24-1.62.54-2.217l8.293-6.364l-4.628.006c-.785-.003-1.298-.532-1.15-1.17c.143-.626.869-1.121 1.624-1.122l9.146-.01l-2.995-2.439c-.466-.382-.407-.989.118-1.355c.518-.363 1.31-.364 1.782-.002l7.204 5.531l-.002.001a7.4 7.4 0 0 1 1.775 1.958a6.82 6.82 0 0 1 1.021 4.13a6.7 6.7 0 0 1-.287 1.479a7.1 7.1 0 0 1-1.526 2.647A7.9 7.9 0 0 1 19 20.263a8.6 8.6 0 0 1-3.505.74a8.6 8.6 0 0 1-3.508-.728a7.9 7.9 0 0 1-2.67-1.918a7.1 7.1 0 0 1-1.527-2.643m7.704 1.815c1.408-.003 2.708-.54 3.637-1.486c.454-.462.787-.992.993-1.558c.201-.555.28-1.143.229-1.736a4.1 4.1 0 0 0-.5-1.634a4.5 4.5 0 0 0-1.104-1.31a5.14 5.14 0 0 0-3.257-1.127a5.15 5.15 0 0 0-3.255 1.136c-.46.377-.834.822-1.105 1.314a4.1 4.1 0 0 0-.27 3.373a4.3 4.3 0 0 0 .994 1.554c.929.945 2.23 1.477 3.638 1.474"/>',
    },
    "blender-line": {
      body: '<path fill="currentColor" d="M13.122 2.217a1 1 0 1 0-1.244 1.566L15.297 6.5H4.5a1 1 0 1 0 0 2h5.472L.878 15.717a1 1 0 0 0 1.244 1.566l5.423-4.303q-.045.379-.045.77c0 4.108 3.691 7.25 8 7.25s8-3.142 8-7.25c0-2.247-1.124-4.227-2.835-5.539zM11.565 9.79C12.61 8.992 13.983 8.5 15.5 8.5c1.52 0 2.895.494 3.942 1.295c1.284.98 2.058 2.403 2.058 3.955c0 2.796-2.577 5.25-6 5.25s-6-2.454-6-5.25c0-1.48.704-2.842 1.882-3.816zm2.913 4.303c-.277-.26-.399-.566-.381-.882c.032-.565.624-1.21 1.498-1.21c.873 0 1.465.644 1.498 1.209c.018.33-.108.633-.378.887c-.285.27-.697.44-1.12.44a1.66 1.66 0 0 1-1.117-.444M15.595 10c-1.746 0-3.394 1.295-3.495 3.1c-.108 1.945 1.625 3.436 3.495 3.436c1.876 0 3.602-1.477 3.495-3.438C18.988 11.294 17.34 10 15.595 10"/>',
    },
    "blogger-fill": {
      body: '<path fill="currentColor" d="M19.822 9.729H18.73a1.113 1.113 0 0 1-1.093-1.094A5.636 5.636 0 0 0 12 3H8.636A5.636 5.636 0 0 0 3 8.635v6.73A5.636 5.636 0 0 0 8.636 21h6.729A5.636 5.636 0 0 0 21 15.364v-4.458a1.15 1.15 0 0 0-1.178-1.177M8.552 7.542h4.037c.589 0 1.093.504 1.093 1.093S13.178 9.73 12.59 9.73H8.55a1.113 1.113 0 0 1-1.093-1.094c0-.589.505-1.093 1.093-1.093m6.897 8.916H8.636a1.113 1.113 0 0 1-1.094-1.094c0-.589.505-1.093 1.094-1.093h6.813c.588 0 1.093.504 1.093 1.093s-.505 1.094-1.093 1.094"/>',
    },
    "blogger-line": {
      body: '<path fill="currentColor" d="M3 9.009a6.01 6.01 0 0 1 6.01-6.01H12a6.01 6.01 0 0 1 6.01 5.982h.943c1.15 0 2.047.896 2.047 2.047v3.962A6.01 6.01 0 0 1 14.99 21H9.01A6.01 6.01 0 0 1 3 14.99zm6.01-4.01A4.01 4.01 0 0 0 5 9.01v5.981A4.01 4.01 0 0 0 9.01 19h5.98A4.01 4.01 0 0 0 19 14.99V11h-1c-1.076 0-2-.924-2-2c0-2.214-1.786-4-4-4zM8 9a1 1 0 0 1 1-1h3.5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"/>',
    },
    "bluesky-fill": {
      body: '<path fill="currentColor" d="M12 11.388c-.906-1.761-3.372-5.044-5.665-6.662c-2.197-1.55-3.034-1.283-3.583-1.033C2.116 3.978 2 4.955 2 5.528c0 .575.315 4.709.52 5.4c.68 2.28 3.094 3.05 5.32 2.803c-3.26.483-6.157 1.67-2.36 5.898c4.178 4.325 5.726-.927 6.52-3.59c.794 2.663 1.708 7.726 6.444 3.59c3.556-3.59.977-5.415-2.283-5.898c2.225.247 4.64-.523 5.319-2.803c.205-.69.52-4.825.52-5.399c0-.575-.116-1.55-.752-1.838c-.549-.248-1.386-.517-3.583 1.033c-2.293 1.621-4.76 4.904-5.665 6.664"/>',
    },
    "bluesky-line": {
      body: '<path fill="currentColor" d="M4.907 3.44c.709.12 1.533.501 2.576 1.247C9.28 5.97 10.769 7.739 12 9.564c1.231-1.825 2.72-3.593 4.517-4.877c1.043-.746 1.867-1.127 2.576-1.248c.767-.13 1.29.065 1.615.2C21.717 4.06 22 5.225 22 6.215c0 .201-.086 1.302-.185 2.36c-.052.546-.11 1.108-.166 1.577c-.053.428-.115.88-.19 1.133a4.33 4.33 0 0 1-1.951 2.517c.937.707 1.277 1.856.928 2.984c-.597 1.924-2.737 4.397-4.835 4.618c-1.773.186-2.935-1.325-3.601-2.76c-.666 1.435-1.828 2.946-3.6 2.76c-2.099-.22-4.24-2.694-4.836-4.618c-.35-1.128-.01-2.277.928-2.984a4.33 4.33 0 0 1-1.95-2.517c-.076-.253-.138-.705-.19-1.133a61 61 0 0 1-.167-1.577C2.085 7.517 2 6.416 2 6.215c0-.99.283-2.155 1.292-2.576c.326-.135.847-.33 1.615-.2M4.05 6.916c.064.818.18 2.108.288 2.992c.032.268.055.545.122.807c.397 1.34 1.929 2.082 3.686 1.887a1 1 0 0 1 .257 1.983c-.756.112-3.315.357-2.928 1.607c.357 1.151 1.848 3.087 3.134 3.222c.928.097 1.5-1.394 1.766-2.045c.275-.674.488-1.38.668-1.982a1 1 0 0 1 1.916 0c.18.602.393 1.308.668 1.982c.266.651.838 2.142 1.766 2.045c1.286-.135 2.777-2.07 3.134-3.222c.387-1.25-2.172-1.495-2.928-1.607a1 1 0 0 1 .257-1.983c1.757.195 3.289-.547 3.686-1.887c.069-.266.089-.536.122-.807a80 80 0 0 0 .288-2.992c.037-.468.247-1.637-.522-1.506c-.286.049-.823.241-1.749.903c-1.943 1.389-3.705 3.513-4.789 5.64a1 1 0 0 1-1.782 0c-1.084-2.127-2.846-4.251-4.789-5.64c-.926-.662-1.463-.854-1.749-.903c-.784-.134-.559 1.034-.522 1.506"/>',
    },
    "bluetooth-connect-fill": {
      body: '<path fill="currentColor" d="m14.311 12l4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364l-1.415-1.415l5.779-5.778v-.97L5.219 5.737l1.415-1.415l4.364 4.364V2h2l5.656 5.657zm-1.313 1.515v5.657l2.828-2.829zm0-3.03l2.828-2.828l-2.828-2.829zM19.5 13.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-13 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "bluetooth-connect-line": {
      body: '<path fill="currentColor" d="m14.311 12l4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364l-1.415-1.415l5.779-5.778v-.97L5.219 5.737l1.415-1.415l4.364 4.364V2h2l5.656 5.657zm-1.313 1.515v5.657l2.828-2.829zm0-3.03l2.828-2.828l-2.828-2.829zM19.5 13.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-13 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "bluetooth-fill": {
      body: '<path fill="currentColor" d="m14.312 12l4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364l-1.414-1.415l5.778-5.778v-.97L5.22 5.737l1.414-1.415l4.364 4.364V2h2l5.657 5.657zm-1.314 1.515v5.657l2.828-2.829zm0-3.03l2.828-2.828l-2.828-2.829z"/>',
    },
    "bluetooth-line": {
      body: '<path fill="currentColor" d="m14.312 12l4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364l-1.414-1.415l5.778-5.778v-.97L5.22 5.737l1.414-1.415l4.364 4.364V2h2l5.657 5.657zm-1.314 1.515v5.657l2.828-2.829zm0-3.03l2.828-2.828l-2.828-2.829z"/>',
    },
    "blur-off-fill": {
      body: '<path fill="currentColor" d="M5.432 6.843L1.394 2.804L2.808 1.39l19.799 19.8l-1.415 1.413l-3.038-3.038A9 9 0 0 1 5.432 6.843m2.811-2.817L12 .269l6.364 6.364a9 9 0 0 1 2.05 9.564z"/>',
    },
    "blur-off-line": {
      body: '<path fill="currentColor" d="M18.154 19.565A9 9 0 0 1 5.432 6.843L1.394 2.804L2.808 1.39l19.799 19.8l-1.415 1.413zM6.848 8.258a7 7 0 0 0 9.89 9.891zm13.566 7.939l-1.598-1.599a7 7 0 0 0-1.866-6.55L12 3.097L9.658 5.44L8.243 4.026L12 .269l6.364 6.364a9 9 0 0 1 2.05 9.564"/>',
    },
    "bnb-fill": {
      body: '<path fill="currentColor" d="M6.167 4.367L12 1l5.833 3.367l-2.144 1.244L12 3.488L8.312 5.61zm11.666 4.246l-2.144-1.244L12 9.492L8.312 7.37L6.167 8.613V11.1l3.689 2.123v4.246L12 18.714l2.145-1.244v-4.246l3.688-2.123zm0 6.734v-2.488l-2.144 1.244v2.487zm1.523.879l-3.689 2.123v2.487L21.5 17.47v-6.734l-2.145 1.244zM17.21 6.49l2.145 1.244v2.487L21.5 8.977V6.49l-2.145-1.244zM9.856 19.25v2.487L12 22.981l2.145-1.244v-2.488L12 20.493zm-3.689-3.903l2.145 1.243v-2.487l-2.145-1.244zM9.856 6.49L12 7.734l2.145-1.244L12 5.246zM4.644 7.734L6.79 6.49L4.644 5.246L2.5 6.49v2.487l2.144 1.244zm0 4.246L2.5 10.736v6.733l5.833 3.367V18.35l-3.689-2.123z"/>',
    },
    "bnb-line": {
      body: '<path fill="currentColor" d="m12 20.689l-2.01-1.163l-.002 2.31L12 23l2.011-1.165l-.002-2.309zm4.007-2.32l.003 2.31L21.5 17.5v-6.354l-2 1.151v4.05zm3.493-8.38l2-1.151V6.5l-1.996-1.156L17.508 6.5L19.5 7.653zm-3.988-4.645l1.996-1.155L12 1L6.492 4.189l1.996 1.156L12 3.31zM6.492 6.5L4.496 5.345L2.5 6.5v2.338l2 1.152V7.653zM2.5 11.146l2 1.152v4.049l3.492 2.022l-.003 2.31L2.5 17.5zm15-2.34l-1.988-1.15L12 9.689L8.488 7.656L6.5 8.806v2.335l3.498 2.015l-.004 4.06L12 18.378l2.006-1.161L14 13.155l3.499-2.014zM7.995 16.06l.002-1.748L6.5 13.45v1.745zm2.488-9.56L12 7.378l1.516-.878L12 5.622zm5.52 7.81l1.497-.861v1.745l-1.495.866z"/>',
    },
    "body-scan-fill": {
      body: '<path fill="currentColor" d="M4 16v4h4v2H2v-6zm18 0v6h-6v-2h4v-4zM7.5 7a4.5 4.5 0 0 0 9 0h2a6.5 6.5 0 0 1-3.499 5.767L15 19H9v-6.232A6.5 6.5 0 0 1 5.5 7zM12 5a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5M8 2v2l-4-.001V8H2V2zm14 0v6h-2V4h-4V2z"/>',
    },
    "body-scan-line": {
      body: '<path fill="currentColor" d="M4 16v4h4v2H2v-6zm18 0v6h-6v-2h4v-4zM7.5 7a4.5 4.5 0 0 0 3.5 4.389V17h2l.001-5.612A4.5 4.5 0 0 0 16.5 7h2a6.5 6.5 0 0 1-3.499 5.767L15 19H9v-6.232A6.5 6.5 0 0 1 5.5 7zM12 5a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5M8 2v2l-4-.001V8H2V2zm14 0v6h-2V4h-4V2z"/>',
    },
    bold: {
      body: '<path fill="currentColor" d="M8 11h4.5a2.5 2.5 0 0 0 0-5H8zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.5 4.5 0 0 1 18 15.5M8 13v5h5.5a2.5 2.5 0 0 0 0-5z"/>',
    },
    "book-2-fill": {
      body: '<path fill="currentColor" d="M21 18H6a1 1 0 1 0 0 2h15v2H6a3 3 0 0 1-3-3V4a2 2 0 0 1 2-2h16zm-5-9V7H8v2z"/>',
    },
    "book-2-line": {
      body: '<path fill="currentColor" d="M21 18H6a1 1 0 1 0 0 2h15v2H6a3 3 0 0 1-3-3V4a2 2 0 0 1 2-2h16zM5 16.05q.243-.05.5-.05H19V4H5zM16 9H8V7h8z"/>',
    },
    "book-3-fill": {
      body: '<path fill="currentColor" d="M21 4H7a2 2 0 1 0 0 4h14v13a1 1 0 0 1-1 1H7a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h13a1 1 0 0 1 1 1zm-1 3H7a1 1 0 0 1 0-2h13z"/>',
    },
    "book-3-line": {
      body: '<path fill="currentColor" d="M21 4H7a2 2 0 1 0 0 4h14v13a1 1 0 0 1-1 1H7a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h13a1 1 0 0 1 1 1zM5 18a2 2 0 0 0 2 2h12V10H7a4 4 0 0 1-2-.535zM20 7H7a1 1 0 0 1 0-2h13z"/>',
    },
    "book-fill": {
      body: '<path fill="currentColor" d="M20 22H6.5A3.5 3.5 0 0 1 3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2v-3H6.5a1.5 1.5 0 0 0 0 3z"/>',
    },
    "book-line": {
      body: '<path fill="currentColor" d="M3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5A3.5 3.5 0 0 1 3 18.5M19 20v-3H6.5a1.5 1.5 0 0 0 0 3zM5 15.337A3.5 3.5 0 0 1 6.5 15H19V4H6a1 1 0 0 0-1 1z"/>',
    },
    "book-marked-fill": {
      body: '<path fill="currentColor" d="M20 22H6.5A3.5 3.5 0 0 1 3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2v-3H6.5a1.5 1.5 0 0 0 0 3zM10 4v8l3.5-2l3.5 2V4z"/>',
    },
    "book-marked-line": {
      body: '<path fill="currentColor" d="M3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5A3.5 3.5 0 0 1 3 18.5M19 20v-3H6.5a1.5 1.5 0 0 0 0 3zM10 4H6a1 1 0 0 0-1 1v10.337A3.5 3.5 0 0 1 6.5 15H19V4h-2v8l-3.5-2l-3.5 2z"/>',
    },
    "book-open-fill": {
      body: '<path fill="currentColor" d="M21 21h-8V6a3 3 0 0 1 3-3h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1m-10 0H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a3 3 0 0 1 3 3zm0 0h2v2h-2z"/>',
    },
    "book-open-line": {
      body: '<path fill="currentColor" d="M13 21v2h-2v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a4 4 0 0 1 3 1.354A4 4 0 0 1 15 3h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zm7-2V5h-5a2 2 0 0 0-2 2v12zm-9 0V7a2 2 0 0 0-2-2H4v14z"/>',
    },
    "book-read-fill": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM12 5v14h8V5zm1 2h6v2h-6zm0 3h6v2h-6z"/>',
    },
    "book-read-line": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM11 5H4v14h7zm2 0v14h7V5zm1 2h5v2h-5zm0 3h5v2h-5z"/>',
    },
    "book-shelf-fill": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9.303l2.021 9.51a1 1 0 0 0 1.186.77l2.935-.623a1 1 0 0 0 .77-1.186l-2.91-13.694a1 1 0 0 0-1.187-.77L15 5.302V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1-1zm5 3h4v8H9zm4 10v3H9v-3zm-6 1v2H5v-2zm11.77 1.814l-.416-1.956l.978-.208l.416 1.956z"/>',
    },
    "book-shelf-line": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4.703L16 20a1 1 0 0 0 1.186.77l3.912-.832a1 1 0 0 0 .77-1.186l-2.91-13.694a1 1 0 0 0-1.186-.77l-2.78.59A1 1 0 0 0 14 4h-4a1 1 0 0 0-1-1zm6 3h3v8h-3zm0 13v-3h3v3zM8 5v10H5V5zm0 12v2H5v-2zm9.332-.35l1.956-.416l.416 1.956l-1.956.416zm-.416-1.957l-1.663-7.825l1.956-.416l1.664 7.826z"/>',
    },
    "booklet-fill": {
      body: '<path fill="currentColor" d="M8 2v20H4v-4H2v-2h2v-3H2v-2h2V8H2V6h2V2zm12.005 0C21.107 2 22 2.898 22 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H10V2z"/>',
    },
    "booklet-line": {
      body: '<path fill="currentColor" d="M20.005 2C21.107 2 22 2.898 22 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H4v-4H2v-2h2v-3H2v-2h2V8H2V6h2V2zM8 4H6v16h2zm12 0H10v16h10z"/>',
    },
    "bookmark-2-fill": {
      body: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1m3 7v2h8V9z"/>',
    },
    "bookmark-2-line": {
      body: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1m13 2H6v15.432l6-3.761l6 3.761zM8 9h8v2H8z"/>',
    },
    "bookmark-3-fill": {
      body: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v19.276a.5.5 0 0 1-.704.457L12 19.03l-8.296 3.702A.5.5 0 0 1 3 22.276V3a1 1 0 0 1 1-1m8 11.5l2.939 1.545l-.561-3.272l2.377-2.318l-3.285-.478L12 6l-1.47 2.977l-3.285.478l2.377 2.318l-.56 3.272z"/>',
    },
    "bookmark-3-line": {
      body: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v19.276a.5.5 0 0 1-.704.457L12 19.03l-8.296 3.702A.5.5 0 0 1 3 22.276V3a1 1 0 0 1 1-1m15 17.965V4H5v15.965l7-3.124zM12 13.5l-2.939 1.545l.561-3.272l-2.377-2.318l3.286-.478L12 6l1.47 2.977l3.285.478l-2.377 2.318l.56 3.272z"/>',
    },
    "bookmark-fill": {
      body: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1"/>',
    },
    "bookmark-line": {
      body: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1m13 2H6v15.432l6-3.761l6 3.761z"/>',
    },
    "bootstrap-fill": {
      body: '<path fill="currentColor" d="M5.423 3.038c-1.284 0-2.233 1.124-2.19 2.342c.04 1.171-.013 2.688-.395 3.924c-.383 1.24-1.03 2.026-2.088 2.127v1.138c1.058.101 1.705.887 2.088 2.127c.382 1.237.435 2.753.394 3.924c-.042 1.218.907 2.342 2.192 2.342h13.154c1.284 0 2.234-1.124 2.192-2.342c-.041-1.171.012-2.687.393-3.924c.384-1.24 1.03-2.026 2.087-2.127v-1.138c-1.058-.101-1.703-.887-2.087-2.127c-.381-1.236-.434-2.753-.393-3.924c.042-1.218-.908-2.342-2.192-2.342zm10.581 11.033c0 1.678-1.251 2.696-3.328 2.696H9.14a.38.38 0 0 1-.382-.381V7.614a.38.38 0 0 1 .382-.38h3.515c1.732 0 2.869.937 2.869 2.378c0 1.01-.765 1.916-1.739 2.074v.053c1.326.145 2.22 1.064 2.22 2.332M12.29 8.442h-2.016v2.848h1.698c1.313 0 2.036-.529 2.036-1.474c0-.885-.622-1.374-1.718-1.374m-2.016 3.977v3.139h2.09c1.367 0 2.09-.549 2.09-1.58c0-1.03-.743-1.559-2.178-1.559z"/>',
    },
    "bootstrap-line": {
      body: '<path fill="currentColor" d="M1 11v2s2 0 2 4v1a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-1c0-4 2-4 2-4v-2s-2 0-2-4V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v1c0 4-2 4-2 4m19.674 1q-.045.042-.088.086C19.578 13.093 19 14.692 19 17v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1c0-2.308-.578-3.907-1.586-4.914L3.326 12q.045-.042.088-.086C4.422 10.907 5 9.308 5 7V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1c0 2.308.578 3.907 1.586 4.914zM8.5 7v10h5a3 3 0 0 0 1.615-5.529A3 3 0 0 0 12.5 7zm2 4V9h2a1 1 0 1 1 0 2zm0 2h3a1 1 0 1 1 0 2h-3z"/>',
    },
    "bowl-fill": {
      body: '<path fill="currentColor" d="M8 1.5a1 1 0 0 0-2 0v1.018c.004.044.005.063-.207.275l-.02.02C5.506 3.079 5 3.583 5 4.5v1a1 1 0 0 0 2 0V4.482c-.004-.044-.005-.063.207-.275l.02-.02C7.494 3.921 8 3.417 8 2.5zM2 9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1c0 4.1-2.468 7.625-6 9.168V20a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-.832A10 10 0 0 1 2 10zM18 .5a1 1 0 0 1 1 1v1c0 .916-.506 1.42-.773 1.687l-.02.02c-.212.212-.21.231-.208.275L18 4.5v1a1 1 0 1 1-2 0v-1c0-.916.506-1.42.773-1.687l.02-.02c.212-.212.21-.231.208-.275L17 2.5v-1a1 1 0 0 1 1-1m-4.5 1a1 1 0 1 0-2 0v1.018c.004.044.005.063-.207.275l-.02.02c-.267.266-.773.77-.773 1.687v1a1 1 0 1 0 2 0V4.482c-.004-.044-.005-.063.207-.275l.02-.02c.267-.266.773-.77.773-1.687z"/>',
    },
    "bowl-line": {
      body: '<path fill="currentColor" d="M8 1.5a1 1 0 0 0-2 0v1.018c.004.044.005.063-.207.275l-.02.02C5.506 3.079 5 3.583 5 4.5v1a1 1 0 0 0 2 0V4.482c-.004-.044-.005-.063.207-.275l.02-.02C7.494 3.921 8 3.417 8 2.5zm11 0a1 1 0 1 0-2 0v1.018c.004.044.005.063-.207.275l-.02.02c-.267.266-.773.77-.773 1.687v1a1 1 0 1 0 2 0V4.482c-.004-.044-.005-.063.207-.275l.02-.02c.267-.266.773-.77.773-1.687zm-6.5-1a1 1 0 0 1 1 1v1c0 .916-.506 1.42-.773 1.687l-.02.02c-.212.212-.21.231-.208.275l.001.018v1a1 1 0 1 1-2 0v-1c0-.916.506-1.42.773-1.687l.02-.02c.212-.212.21-.231.208-.275L11.5 2.5v-1a1 1 0 0 1 1-1M4 10h16a8 8 0 1 1-16 0M3 8a1 1 0 0 0-1 1v1c0 4.1 2.468 7.625 6 9.168V20a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.832c3.532-1.543 6-5.067 6-9.168V9a1 1 0 0 0-1-1z"/>',
    },
    "box-1-fill": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L13 22.421V11.423l-9.502-5.5zM2.5 7.656V17.5l8.5 4.921v-9.844z"/>',
    },
    "box-1-line": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zM5.494 7.078L13 11.423v8.687l6.5-3.763V7.653L12 3.311zM4.5 8.813v7.534L11 20.11v-7.533z"/>',
    },
    "box-2-fill": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zM4.5 7.658v8.689l7.5 4.342V12z"/>',
    },
    "box-2-line": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zM4.5 7.653v.005L12 12v8.689l7.5-4.342V7.653L12 3.311z"/>',
    },
    "box-3-fill": {
      body: '<path fill="currentColor" d="M20.502 5.922L12 1L3.498 5.922L12 10.845zM2.5 7.656V17.5l8.5 4.921v-9.844zM13 22.42l8.5-4.921V7.656l-8.5 4.92z"/>',
    },
    "box-3-line": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zM5.494 7.078L12 10.844l6.506-3.766L12 3.31zM4.5 8.813v7.534L11 20.11v-7.533zM13 20.11l6.5-3.763V8.813L13 12.576z"/>',
    },
    "boxing-fill": {
      body: '<path fill="currentColor" d="m9.501 11l.144.007a1.5 1.5 0 0 1 1.35 1.348L11 12.5l-.007.145a1.5 1.5 0 0 1-1.349 1.348L9.501 14h-3.5v2h3.5c1.7 0 3.117-1.212 3.434-2.819l.03-.18L19.001 13c.711 0 1.388-.149 2-.416V17a3 3 0 0 1-2 2.829V21a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-1.17a3 3 0 0 1-2-2.83v-4a2 2 0 0 1 2-2zm12.5-3.5V8l-.005.176a3 3 0 0 1-2.819 2.819l-.176.005h-6.337A3.5 3.5 0 0 0 9.71 9.006L9.5 9H5a4 4 0 0 0-2.001.536L3.001 6a4 4 0 0 1 4-4h9.5a5.5 5.5 0 0 1 5.5 5.5"/>',
    },
    "boxing-line": {
      body: '<path fill="currentColor" d="M16.5 2A5.5 5.5 0 0 1 22 7.5V10a3 3 0 0 1-1 2.235V17a3 3 0 0 1-2 2.829V21a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1.17A3 3 0 0 1 3 17V6a4 4 0 0 1 4-4zm-7 9H5v6a1 1 0 0 0 .883.993L6 18h12a1 1 0 0 0 .993-.883L19 17v-4h-6.036A3.5 3.5 0 0 1 9.5 16H6v-2h3.5a1.5 1.5 0 0 0 1.493-1.355L11 12.5a1.5 1.5 0 0 0-1.356-1.493zm7-7H7a2 2 0 0 0-1.995 1.85L5 6v3h4.5a3.5 3.5 0 0 1 3.163 2H19a1 1 0 0 0 .993-.883L20 10V7.5a3.5 3.5 0 0 0-3.308-3.495z"/>',
    },
    "braces-fill": {
      body: '<path fill="currentColor" d="M4 18v-3.7a1.5 1.5 0 0 0-1.5-1.5H2v-1.6h.5A1.5 1.5 0 0 0 4 9.7V6a3 3 0 0 1 3-3h1v2H7a1 1 0 0 0-1 1v4.1A2 2 0 0 1 4.626 12A2 2 0 0 1 6 13.9V18a1 1 0 0 0 1 1h1v2H7a3 3 0 0 1-3-3m16-3.7V18a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1v-4.1a2 2 0 0 1 1.374-1.9A2 2 0 0 1 18 10.1V6a1 1 0 0 0-1-1h-1V3h1a3 3 0 0 1 3 3v3.7a1.5 1.5 0 0 0 1.5 1.5h.5v1.6h-.5a1.5 1.5 0 0 0-1.5 1.5"/>',
    },
    "braces-line": {
      body: '<path fill="currentColor" d="M4 18v-3.7a1.5 1.5 0 0 0-1.5-1.5H2v-1.6h.5A1.5 1.5 0 0 0 4 9.7V6a3 3 0 0 1 3-3h1v2H7a1 1 0 0 0-1 1v4.1A2 2 0 0 1 4.626 12A2 2 0 0 1 6 13.9V18a1 1 0 0 0 1 1h1v2H7a3 3 0 0 1-3-3m16-3.7V18a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1v-4.1a2 2 0 0 1 1.374-1.9A2 2 0 0 1 18 10.1V6a1 1 0 0 0-1-1h-1V3h1a3 3 0 0 1 3 3v3.7a1.5 1.5 0 0 0 1.5 1.5h.5v1.6h-.5a1.5 1.5 0 0 0-1.5 1.5"/>',
    },
    "brackets-fill": {
      body: '<path fill="currentColor" d="M9 3v2H6v14h3v2H4V3zm6 0h5v18h-5v-2h3V5h-3z"/>',
    },
    "brackets-line": {
      body: '<path fill="currentColor" d="M9 3v2H6v14h3v2H4V3zm6 0h5v18h-5v-2h3V5h-3z"/>',
    },
    "brain-2-fill": {
      body: '<path fill="currentColor" d="M8.5 2a3.5 3.5 0 0 0-3.46 4.03A3.5 3.5 0 0 0 3.05 12a3.5 3.5 0 0 0 .963 5.67Q4 17.832 4 18a4 4 0 0 0 7 2.646V3.05A3.5 3.5 0 0 0 8.5 2M13 3.05v17.596a4 4 0 0 0 6.986-2.977A3.5 3.5 0 0 0 20.95 12a3.5 3.5 0 0 0-1.99-5.97q.04-.26.041-.53a3.5 3.5 0 0 0-6-2.45"/>',
    },
    "brain-2-line": {
      body: '<path fill="currentColor" d="M7 6q.001.357.115.67a1 1 0 0 1-1 1.333L6 8a2 2 0 0 0-1.491 3.333a1 1 0 0 1 0 1.334a2 2 0 0 0 .864 3.233a1 1 0 0 1 .67 1.135a2.5 2.5 0 1 0 4.932.824q.009-.063.025-.123V6a2 2 0 1 0-4 0m6 11.736q.016.06.025.122a2.5 2.5 0 1 0 4.932-.823a1 1 0 0 1 .67-1.135a2 2 0 0 0 .864-3.233a1 1 0 0 1 0-1.334a2 2 0 0 0-1.607-3.33a1 1 0 0 1-.999-1.333q.113-.313.115-.67a2 2 0 1 0-4 0zM9 2a4 4 0 0 1 3 1.354a4 4 0 0 1 6.998 2.771A4.002 4.002 0 0 1 21.465 12A3.997 3.997 0 0 1 20 17.465v.035a4.5 4.5 0 0 1-8 2.828A4.5 4.5 0 0 1 4 17.5v-.035A3.997 3.997 0 0 1 2.535 12a4.002 4.002 0 0 1 2.467-5.874L5 6a4 4 0 0 1 4-4"/>',
    },
    "brain-fill": {
      body: '<path fill="currentColor" d="M11 2.535A4 4 0 0 0 5 6v1.774c-.851.342-1.549.874-2.059 1.575C2.292 10.242 2 11.335 2 12.5c0 1.561.795 2.936 2 3.742V17.5a4.5 4.5 0 0 0 7 3.742V17.5c0-1.333-.33-2.185-.86-2.76c-.543-.587-1.424-1.024-2.804-1.254l.328-1.972c1.302.216 2.442.623 3.336 1.313zm2 0v10.292c.894-.69 2.034-1.097 3.336-1.313l.328 1.972c-1.38.23-2.261.667-2.804 1.255c-.53.574-.86 1.426-.86 2.759v3.742a4.5 4.5 0 0 0 7-3.742v-1.258c1.205-.806 2-2.18 2-3.742c0-1.165-.292-2.258-.941-3.15c-.51-.702-1.208-1.234-2.059-1.576V6a4 4 0 0 0-6-3.465"/>',
    },
    "brain-line": {
      body: '<path fill="currentColor" d="M9 4a2 2 0 0 1 2 2v6.827c-.894-.69-2.034-1.097-3.336-1.313l-.328 1.972c1.38.23 2.261.667 2.804 1.255c.53.574.86 1.426.86 2.759a2.5 2.5 0 0 1-5 0v-.35c.43.143.876.26 1.336.336l.328-1.972c-.743-.124-1.489-.4-2.235-.754A2.5 2.5 0 0 1 4 12.5c0-.835.208-1.492.559-1.974c.345-.476.883-.856 1.684-1.056L7 9.28V6a2 2 0 0 1 2-2m3-.646A4 4 0 0 0 5 6v1.774c-.851.342-1.549.874-2.059 1.575C2.292 10.242 2 11.335 2 12.5a4.49 4.49 0 0 0 2 3.742V17.5a4.5 4.5 0 0 0 8 2.829a4.5 4.5 0 0 0 8-2.829v-1.258a4.49 4.49 0 0 0 2-3.742c0-1.165-.292-2.258-.941-3.15c-.51-.702-1.208-1.234-2.059-1.576V6a4 4 0 0 0-7-2.646m6 13.795v.351a2.5 2.5 0 0 1-5 0c0-1.333.33-2.185.86-2.76c.543-.587 1.424-1.024 2.804-1.254l-.328-1.972c-1.302.216-2.442.623-3.336 1.313V6a2 2 0 1 1 4 0v3.28l.758.19c.8.2 1.338.58 1.683 1.056c.351.482.559 1.14.559 1.974c0 .999-.582 1.857-1.43 2.26c-.745.354-1.492.63-2.234.754l.328 1.972A9 9 0 0 0 18 17.149"/>',
    },
    "bread-fill": {
      body: '<path fill="currentColor" d="M1 7a4 4 0 0 1 4-4h2a4 4 0 0 0-2 7.465V19a3 3 0 0 0 3 3H6a3 3 0 0 1-3-3v-8.535A4 4 0 0 1 1 7m7 15v-2a1 1 0 0 1-1-1V9.122l-.667-.236A2.001 2.001 0 0 1 7 5V3h12a4 4 0 0 1 2 7.465V19a3 3 0 0 1-3 3z"/>',
    },
    "bread-line": {
      body: '<path fill="currentColor" d="M5 3a4 4 0 0 0-2 7.465V19a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8.535A4 4 0 0 0 19 3zm2 17a1 1 0 0 1-1-1V9.122l-.667-.236A2.001 2.001 0 0 1 6 5h13a2 2 0 0 1 .667 3.886L19 9.122V19a1 1 0 0 1-1 1z"/>',
    },
    "briefcase-2-fill": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm10 8v-3h-2v3H9v-3H7v3H4v6h16v-6zM9 3v2h6V3z"/>',
    },
    "briefcase-2-line": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm13 8H4v6h16zm0-6H4v4h3V9h2v2h6V9h2v2h3zM9 3v2h6V3z"/>',
    },
    "briefcase-3-fill": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm10 2v5h3V7zm-2 0H9v5h6zM7 7H4v5h3zm2-4v2h6V3z"/>',
    },
    "briefcase-3-line": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm8 2H9v12h6zM7 7H4v12h3zm10 0v12h3V7zM9 3v2h6V3z"/>',
    },
    "briefcase-4-fill": {
      body: '<path fill="currentColor" d="M9 13v3h6v-3h7v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7zm2-2h2v3h-2zM7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v5h-7V9H9v2H2V6a1 1 0 0 1 1-1zm2-2v2h6V3z"/>',
    },
    "briefcase-4-line": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm2 8H4v6h16v-6h-5v3H9zm11-6H4v4h5V9h6v2h5zm-9 4v3h2v-3zM9 3v2h6V3z"/>',
    },
    "briefcase-5-fill": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm-1 8V7H4v6zm2-6v6h3v-2h2v2h3V7zm10 6h2V7h-2zM9 3v2h6V3z"/>',
    },
    "briefcase-5-line": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm9 10h-3v1h-2v-1H8v4h8zM8 7v6h3v-1h2v1h3V7zm-2 6V7H4v6zm12 0h2V7h-2zM6 15H4v4h2zm12 0v4h2v-4zM9 3v2h6V3z"/>',
    },
    "briefcase-fill": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM4 15v4h16v-4zm7-4v2h2v-2zM9 3v2h6V3z"/>',
    },
    "briefcase-line": {
      body: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM4 16v3h16v-3zm0-2h16V7H4zM9 3v2h6V3zm2 8h2v2h-2z"/>',
    },
    "bring-forward": {
      body: '<path fill="currentColor" d="M14 3a1 1 0 0 1 1 1v5h5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H5v8h8z"/>',
    },
    "bring-to-front": {
      body: '<path fill="currentColor" d="M11 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v5h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-2H7a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm5 5H8v8h8z"/>',
    },
    "broadcast-fill": {
      body: '<path fill="currentColor" d="m4.929 2.929l1.414 1.414A7.98 7.98 0 0 0 4 10c0 2.21.895 4.21 2.343 5.657L4.93 17.07A9.97 9.97 0 0 1 2 10a9.97 9.97 0 0 1 2.929-7.071m14.142 0A9.97 9.97 0 0 1 22 10a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A7.98 7.98 0 0 0 20 10c0-2.21-.895-4.21-2.343-5.657zM7.757 5.757l1.415 1.415A4 4 0 0 0 8 10c0 1.105.448 2.105 1.172 2.829l-1.415 1.414A5.98 5.98 0 0 1 6 10c0-1.657.672-3.157 1.757-4.243m8.486 0A5.98 5.98 0 0 1 18 10a5.98 5.98 0 0 1-1.757 4.243l-1.415-1.415A4 4 0 0 0 16 10a4 4 0 0 0-1.172-2.828zM12 12a2 2 0 1 1 0-4a2 2 0 0 1 0 4m0 2c.58 0 1.077.413 1.184.983L14.5 22h-5l1.316-7.017c.107-.57.604-.983 1.184-.983"/>',
    },
    "broadcast-line": {
      body: '<path fill="currentColor" d="m4.929 2.929l1.414 1.414A7.98 7.98 0 0 0 4 10c0 2.21.895 4.21 2.343 5.657L4.93 17.07A9.97 9.97 0 0 1 2 10a9.97 9.97 0 0 1 2.929-7.071m14.142 0A9.97 9.97 0 0 1 22 10a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A7.98 7.98 0 0 0 20 10c0-2.21-.895-4.21-2.343-5.657zM7.757 5.757l1.415 1.415A4 4 0 0 0 8 10c0 1.105.448 2.105 1.172 2.829l-1.415 1.414A5.98 5.98 0 0 1 6 10c0-1.657.672-3.157 1.757-4.243m8.486 0A5.98 5.98 0 0 1 18 10a5.98 5.98 0 0 1-1.757 4.243l-1.415-1.415A4 4 0 0 0 16 10a4 4 0 0 0-1.172-2.828zM12 12a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-1 2h2v8h-2z"/>',
    },
    "brush-2-fill": {
      body: '<path fill="currentColor" d="m16.536 15.947l2.121-2.122l-3.182-3.182l3.536-3.535l-2.122-2.122l-3.535 3.536l-3.182-3.182L8.05 7.46zM13.354 5.693l2.828-2.828a1 1 0 0 1 1.414 0l3.536 3.536a1 1 0 0 1 0 1.414l-2.829 2.828l2.475 2.475a1 1 0 0 1 0 1.414L13 22.311a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l7.779-7.778a1 1 0 0 1 1.414 0z"/>',
    },
    "brush-2-line": {
      body: '<path fill="currentColor" d="m16.536 15.947l2.121-2.122l-3.182-3.182l3.536-3.535l-2.122-2.122l-3.535 3.536l-3.182-3.182L8.05 7.46zM15.12 17.36L6.637 8.875l-2.828 2.829l8.485 8.485zM13.355 5.693l2.828-2.828a1 1 0 0 1 1.414 0l3.536 3.536a1 1 0 0 1 0 1.414l-2.829 2.828l2.475 2.475a1 1 0 0 1 0 1.414L13 22.311a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l7.779-7.778a1 1 0 0 1 1.414 0z"/>',
    },
    "brush-3-fill": {
      body: '<path fill="currentColor" d="M20 10.997v-3h-6v-4h-4v4H4v3zm1 2v8a1 1 0 0 1-1 1H10v-6H8v6H4a1 1 0 0 1-1-1v-8H2v-6a1 1 0 0 1 1-1h5v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3h5a1 1 0 0 1 1 1v6z"/>',
    },
    "brush-3-line": {
      body: '<path fill="currentColor" d="M8 19.997v-5h2v5h9v-7H5v7zm-4-9h16v-3h-6v-4h-4v4H4zm-1 10v-8H2v-6a1 1 0 0 1 1-1h5v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3h5a1 1 0 0 1 1 1v6h-1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1"/>',
    },
    "brush-4-fill": {
      body: '<path fill="currentColor" d="M20 15.997H4v2h16zm-17-2v-10a1 1 0 0 1 1-1h3v8.272h2V2.997h11a1 1 0 0 1 1 1v10h1v5a1 1 0 0 1-1 1h-8v3h-2v-3H3a1 1 0 0 1-1-1v-5z"/>',
    },
    "brush-4-line": {
      body: '<path fill="currentColor" d="M9 4.997v6.272H7V4.997H5v9h14v-9zm11 11H4v2h16zm-17-2v-10a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10h1v5a1 1 0 0 1-1 1h-8v3h-2v-3H3a1 1 0 0 1-1-1v-5z"/>',
    },
    "brush-fill": {
      body: '<path fill="currentColor" d="m13.289 6.213l4.939-3.842a1 1 0 0 1 1.32.083l2.995 2.994a1 1 0 0 1 .082 1.32l-3.84 4.939a7.505 7.505 0 0 1-7.283 9.292C8 20.999 3.5 19.497 1 17.997c3.98-3 3.047-4.81 3.5-6.5c1.058-3.95 4.842-6.258 8.789-5.284M16.7 8.092q.098.095.194.193L18.03 9.42l2.475-3.182l-1.746-1.746l-3.182 2.475z"/>',
    },
    "brush-line": {
      body: '<path fill="currentColor" d="m15.457 9.675l-.143-.142a5.5 5.5 0 0 0-2.39-1.349c-2.907-.779-5.699.869-6.492 3.83c-.043.16-.066.34-.104.791c-.154 1.87-.594 3.265-1.8 4.68c2.26.888 4.938 1.514 6.974 1.514a5.505 5.505 0 0 0 5.31-4.079a5.5 5.5 0 0 0-1.356-5.245m-2.168-3.462l4.939-3.842a1 1 0 0 1 1.32.083l2.995 2.994a1 1 0 0 1 .082 1.32l-3.84 4.939a7.505 7.505 0 0 1-7.283 9.292C8 20.999 3.5 19.497 1 17.997c3.98-3 3.047-4.81 3.5-6.5c1.058-3.95 4.842-6.258 8.789-5.284M16.7 8.092q.098.095.194.193L18.03 9.42l2.475-3.182l-1.746-1.746l-3.182 2.475z"/>',
    },
    "btc-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m4.706-11.436c-.174 1.053-.725 1.567-1.471 1.749c.992.555 1.47 1.398.959 2.877c-.635 1.854-2.057 2.022-3.94 1.663l-.486 1.957l-1.094-.271l.485-1.957q-.186-.049-.373-.091c-.172-.04-.35-.081-.526-.132l-.485 1.957l-1.092-.27l.485-1.958l-2.176-.592l.54-1.384s.822.226.81.212c.304.074.453-.14.514-.288l.776-3.137l.566-2.23c.024-.241-.052-.557-.497-.677c.03-.017-.8-.198-.8-.198l.323-1.312l2.243.556l.475-1.917l1.13.28l-.475 1.917c.291.064.574.14.866.215l.474-1.917l1.1.272l-.488 1.967c1.387.51 2.386 1.263 2.157 2.709m-5.1.39c.657.198 2.605.783 2.933-.52c.306-1.24-1.382-1.618-2.166-1.794q-.14-.03-.235-.055l-.587 2.353zm-1.014 3.82l.095.029c.81.24 3.106.923 3.418-.37c.32-1.246-1.744-1.731-2.669-1.949q-.153-.035-.258-.062z"/>',
    },
    "btc-line": {
      body: '<path fill="currentColor" d="M20 12a8 8 0 1 0-16 0a8 8 0 0 0 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-5.294-1.436c-.174 1.053-.725 1.567-1.471 1.749c.992.555 1.47 1.398.959 2.877c-.635 1.854-2.057 2.022-3.94 1.663l-.486 1.957l-1.094-.271l.485-1.957c-.298-.08-.602-.138-.899-.223l-.485 1.957l-1.092-.27l.485-1.958l-2.176-.592l.54-1.384s.822.226.81.212c.304.074.453-.14.514-.288l.776-3.137l.566-2.23c.024-.241-.052-.557-.497-.677c.03-.017-.8-.198-.8-.198l.323-1.312l2.243.556l.475-1.917l1.13.28l-.475 1.917c.291.064.574.14.866.215l.474-1.917l1.1.272l-.488 1.967c1.387.51 2.386 1.263 2.157 2.709m-5.1.39c.657.198 2.605.783 2.933-.52c.306-1.24-1.382-1.618-2.166-1.794q-.14-.03-.235-.055l-.587 2.353zm-1.014 3.82l.095.029c.81.24 3.106.923 3.418-.37c.32-1.246-1.744-1.731-2.669-1.949q-.153-.035-.258-.062z"/>',
    },
    "bubble-chart-fill": {
      body: '<path fill="currentColor" d="M16 16a3 3 0 1 1 0 6a3 3 0 0 1 0-6M6 12a4 4 0 1 1 0 8a4 4 0 0 1 0-8m8.5-10a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11"/>',
    },
    "bubble-chart-line": {
      body: '<path fill="currentColor" d="M16 16a3 3 0 1 1 0 6a3 3 0 0 1 0-6M6 12a4 4 0 1 1 0 8a4 4 0 0 1 0-8m10 6a1 1 0 1 0 0 2a1 1 0 0 0 0-2M6 14a2 2 0 1 0 0 4a2 2 0 0 0 0-4m8.5-12a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11m0 2a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7"/>',
    },
    "bug-2-fill": {
      body: '<path fill="currentColor" d="M5.07 16A7 7 0 0 1 5 15v-1H3v-2h2v-1q0-.51.07-1H3V8h2.674a7.03 7.03 0 0 1 2.84-3.072l-1.05-1.05L8.88 2.465l1.683 1.684a7 7 0 0 1 2.876 0l1.683-1.684l1.414 1.415l-1.05 1.05A7.03 7.03 0 0 1 18.327 8H21v2h-2.07q.07.49.07 1v1h2v2h-2v1q0 .51-.07 1H21v2h-2.674a7 7 0 0 1-12.652 0H3v-2zM9 10v2h6v-2zm0 4v2h6v-2z"/>',
    },
    "bug-2-line": {
      body: '<path fill="currentColor" d="M10.562 4.148a7 7 0 0 1 2.876 0l1.683-1.684l1.414 1.415l-1.05 1.05A7.03 7.03 0 0 1 18.327 8H21v2h-2.07q.07.49.07 1v1h2v2h-2v1q0 .51-.07 1H21v2h-2.674a7 7 0 0 1-12.652 0H3v-2h2.07A7 7 0 0 1 5 15v-1H3v-2h2v-1q0-.51.07-1H3V8h2.674a7.03 7.03 0 0 1 2.84-3.072l-1.05-1.05L8.88 2.465zM12 6a5 5 0 0 0-5 5v4a5 5 0 0 0 10 0v-4a5 5 0 0 0-5-5m-3 8h6v2H9zm0-4h6v2H9z"/>',
    },
    "bug-fill": {
      body: '<path fill="currentColor" d="M6.056 8.3a7 7 0 0 1 .199-.3h11.49q.103.148.199.3l2.02-1.166l1 1.732l-2.213 1.278c.162.59.249 1.213.249 1.856v1h3v2h-3a7 7 0 0 1-.536 2.69l2.5 1.444l-1 1.732l-2.526-1.458A7 7 0 0 1 13 21.929V14h-2v7.93a7 7 0 0 1-4.438-2.522l-2.526 1.458l-1-1.732l2.5-1.443A7 7 0 0 1 5 15H2v-2h3v-1c0-.643.087-1.265.249-1.856L3.036 8.866l1-1.732zM8 6a4 4 0 1 1 8 0z"/>',
    },
    "bug-line": {
      body: '<path fill="currentColor" d="M13 19.9a5 5 0 0 0 4-4.9v-3c0-.701-.144-1.378-.415-2h-9.17A5 5 0 0 0 7 12v3a5 5 0 0 0 4 4.9V14h2zm-7.464-2.21A7 7 0 0 1 5 15H2v-2h3v-1c0-.643.087-1.265.249-1.856L3.036 8.866l1-1.732L6.056 8.3a7 7 0 0 1 .199-.3h11.49q.103.148.199.3l2.02-1.166l1 1.732l-2.213 1.278c.162.59.249 1.213.249 1.856v1h3v2h-3a7 7 0 0 1-.536 2.69l2.5 1.444l-1 1.732l-2.526-1.458A6.99 6.99 0 0 1 12 22a6.99 6.99 0 0 1-5.438-2.592l-2.526 1.458l-1-1.732zM8 6a4 4 0 1 1 8 0z"/>',
    },
    "building-2-fill": {
      body: '<path fill="currentColor" d="M12 19h2V6l6.394 2.74a1 1 0 0 1 .606.92V19h2v2H1v-2h2V5.65a1 1 0 0 1 .594-.914l7.703-3.423a.5.5 0 0 1 .703.456z"/>',
    },
    "building-2-line": {
      body: '<path fill="currentColor" d="M3 19V5.7a1 1 0 0 1 .658-.94l9.671-3.516a.5.5 0 0 1 .671.47v4.953l6.316 2.105a1 1 0 0 1 .684.949V19h2v2H1v-2zm2 0h7V3.855L5 6.401zm14 0v-8.558l-5-1.667V19z"/>',
    },
    "building-3-fill": {
      body: '<path fill="currentColor" d="M10 10.111V1l11 6v14H3V7z"/>',
    },
    "building-3-line": {
      body: '<path fill="currentColor" d="M10 10.111V1l11 6v14H3V7zm2-5.742v8.82l-7-3.111V19h14V8.187z"/>',
    },
    "building-4-fill": {
      body: '<path fill="currentColor" d="M21 20h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zM8 11v2h3v-2zm0-4v2h3V7zm0 8v2h3v-2zm5 0v2h3v-2zm0-4v2h3v-2zm0-4v2h3V7z"/>',
    },
    "building-4-line": {
      body: '<path fill="currentColor" d="M21 20h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zm-2 0V4H5v16zM8 11h3v2H8zm0-4h3v2H8zm0 8h3v2H8zm5 0h3v2h-3zm0-4h3v2h-3zm0-4h3v2h-3z"/>',
    },
    "building-fill": {
      body: '<path fill="currentColor" d="M21 19h2v2H1v-2h2V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v15h2V9h3a1 1 0 0 1 1 1zM7 11v2h4v-2zm0-4v2h4V7z"/>',
    },
    "building-line": {
      body: '<path fill="currentColor" d="M21 19h2v2H1v-2h2V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v15h4v-8h-2V9h3a1 1 0 0 1 1 1zM5 5v14h8V5zm2 6h4v2H7zm0-4h4v2H7z"/>',
    },
    "bus-2-fill": {
      body: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM5 5v7h14V5zm2.5 13a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m9 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "bus-2-line": {
      body: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM5 5v6h14V5zm14 8H5v5h14zM7.5 17a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "bus-fill": {
      body: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zM5 5v9h14V5zm0 11v2h4v-2zm10 0v2h4v-2z"/>',
    },
    "bus-line": {
      body: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm2-8V5H5v7zm0 2H5v4h14zM6 15h4v2H6zm8 0h4v2h-4z"/>',
    },
    "bus-wifi-fill": {
      body: '<path fill="currentColor" d="M12 3v2H5v9h14v-2h2v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2zM9 16H5v2h4zm10 0h-4v2h4zm-.5-15a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    "bus-wifi-line": {
      body: '<path fill="currentColor" d="M12 3v2H5v7h16v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2zm7 11H5v4h14zm-9 1v2H6v-2zm8 0v2h-4v-2zm.5-14a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    "cactus-fill": {
      body: '<path fill="currentColor" d="M11.998 2a4 4 0 0 1 4 4v9h1c.55 0 1-.45 1-1V8a1 1 0 0 1 2 0v6a3 3 0 0 1-3 3h-1v3h2v2h-12v-2h2v-6h-1a3 3 0 0 1-3-3V9a1 1 0 1 1 2 0v2c0 .55.45 1 1 1h1V6a4 4 0 0 1 4-4"/>',
    },
    "cactus-line": {
      body: '<path fill="currentColor" d="M11.998 2a4 4 0 0 1 4 4v9h1c.55 0 1-.45 1-1V8a1 1 0 0 1 2 0v6c0 1.66-1.34 3-3 3h-1v3h2v2h-12v-2h2v-6h-1a3 3 0 0 1-3-3V9a1 1 0 1 1 2 0v2c0 .55.45 1 1 1h1V6a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v14h4V6a2 2 0 0 0-2-2"/>',
    },
    "cake-2-fill": {
      body: '<path fill="currentColor" d="M8 6v3.999h3V6h2v3.999h3V6h2v3.999L19 10a3 3 0 0 1 2.995 2.824L22 13v1c0 1.014-.377 1.94-.999 2.645L21 21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4.36a4 4 0 0 1-.972-2.182l-.022-.253L2 14v-1a3 3 0 0 1 2.824-2.995L5 10l1-.001V6zm11 6H5a1 1 0 0 0-.993.883L4 13v.971l.003.147A2 2 0 0 0 6 16a2 2 0 0 0 1.98-1.7l.015-.153l.005-.176c.036-1.248 1.827-1.293 1.989-.134l.01.134l.004.147a2 2 0 0 0 3.992.031l.012-.282c.124-1.156 1.862-1.156 1.986 0l.013.282a2 2 0 0 0 3.988 0L20 14v-1a1 1 0 0 0-.883-.993zM7 1c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 0 1-2.898-.776C5.85 2.002 7 2.5 7 1m5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C10.85 2.002 12 2.5 12 1m5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C15.85 2.002 17 2.5 17 1"/>',
    },
    "cake-2-line": {
      body: '<path fill="currentColor" d="M8 6v3.999h3V6h2v3.999h3V6h2v3.999L19 10a3 3 0 0 1 2.995 2.824L22 13v1c0 1.014-.377 1.94-.999 2.645L21 21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4.36a4 4 0 0 1-.972-2.182l-.022-.253L2 14v-1a3 3 0 0 1 2.824-2.995L5 10l1-.001V6zm1.002 10.641l-.054.063a4 4 0 0 1-2.514 1.273l-.23.018L6 18q-.519-.002-1-.126V20h14v-2.126a4 4 0 0 1-3.744-.963l-.15-.15l-.106-.117l-.107.118a4 4 0 0 1-2.451 1.214l-.242.02L12 18a3.98 3.98 0 0 1-2.797-1.144l-.15-.157zM19 12H5a1 1 0 0 0-.993.883L4 13v.971l.003.147A2 2 0 0 0 6 16a2 2 0 0 0 1.98-1.7l.015-.153l.005-.176c.036-1.248 1.827-1.293 1.989-.134l.01.134l.004.147a2 2 0 0 0 3.992.031l.012-.282c.124-1.156 1.862-1.156 1.986 0l.013.282a2 2 0 0 0 3.988 0L20 14v-1a1 1 0 0 0-.883-.993zM7 1c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 0 1-2.898-.776C5.85 2.002 7 2.5 7 1m5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C10.85 2.002 12 2.5 12 1m5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C15.85 2.002 17 2.5 17 1"/>',
    },
    "cake-3-fill": {
      body: '<path fill="currentColor" d="M15.5 2a3.5 3.5 0 0 1 3.437 4.163l-.015.066a4.502 4.502 0 0 1 .303 8.428l-1.086 6.507a1 1 0 0 1-.986.836H6.847a1 1 0 0 1-.986-.836l-1.029-6.17a3 3 0 0 1-.829-5.824L4 9a6 6 0 0 1 8.575-5.42A3.5 3.5 0 0 1 15.5 2M11 15H9v5h2zm4 0h-2v5h2zm2.5-2a2.5 2.5 0 1 0-.956-4.81l-.175.081a2 2 0 0 1-2.663-.804l-.07-.137A4 4 0 0 0 10 5C7.858 5 6.109 6.684 6.005 8.767L6 8.964l.003.17a2 2 0 0 1-1.186 1.863l-.15.059A1.001 1.001 0 0 0 5 13z"/>',
    },
    "cake-3-line": {
      body: '<path fill="currentColor" d="M15.5 2a3.5 3.5 0 0 1 3.437 4.163l-.015.066a4.502 4.502 0 0 1 .303 8.428l-1.086 6.507a1 1 0 0 1-.986.836H6.847a1 1 0 0 1-.986-.836l-1.029-6.17a3 3 0 0 1-.829-5.824L4 9a6 6 0 0 1 8.574-5.421A3.5 3.5 0 0 1 15.5 2M9 15H6.86l.834 5H9zm4 0h-2v5h2zm4.139 0H15v5h1.305zM10 5C7.858 5 6.109 6.684 6.005 8.767L6 8.964l.003.17a2 2 0 0 1-1.186 1.863l-.15.059A1.001 1.001 0 0 0 5 13h12.5a2.5 2.5 0 1 0-.956-4.81l-.175.081a2 2 0 0 1-2.663-.804l-.07-.137A4 4 0 0 0 10 5m5.5-1a1.5 1.5 0 0 0-1.287.729a6 6 0 0 1 1.24 1.764a4.5 4.5 0 0 1 1.446-.453A1.5 1.5 0 0 0 15.5 4"/>',
    },
    "cake-fill": {
      body: '<path fill="currentColor" d="M13 7v4h7a1 1 0 0 1 1 1v8h2v2H1v-2h2v-8a1 1 0 0 1 1-1h7V7zm.83-6.598A3 3 0 0 1 12.732 4.5L11 5.5a3 3 0 0 1 1.098-4.098z"/>',
    },
    "cake-line": {
      body: '<path fill="currentColor" d="M13 7v4h7a1 1 0 0 1 1 1v8h2v2H1v-2h2v-8a1 1 0 0 1 1-1h7V7zm6 6H5v7h14zM13.83.402A3 3 0 0 1 12.732 4.5L11 5.5a3 3 0 0 1 1.098-4.098z"/>',
    },
    "calculator-fill": {
      body: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m3 10v2h2v-2zm0 4v2h2v-2zm4-4v2h2v-2zm0 4v2h2v-2zm4-4v6h2v-6zM7 6v4h10V6z"/>',
    },
    "calculator-line": {
      body: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m1 2v16h14V4zm2 2h10v4H7zm0 6h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v6h-2z"/>',
    },
    "calendar-2-fill": {
      body: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2zM4 9v10h16V9zm2 2h2v2H6zm5 0h2v2h-2zm5 0h2v2h-2z"/>',
    },
    "calendar-2-line": {
      body: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1zm11 10H4v8h16zM8 13v2H6v-2zm5 0v2h-2v-2zm5 0v2h-2v-2zM7 5H4v4h16V5h-3v2h-2V5H9v2H7z"/>',
    },
    "calendar-check-fill": {
      body: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1zm11 7H4v11h16zm-4.964 2.136l1.414 1.414l-4.95 4.95l-3.536-3.536L9.38 11.55l2.121 2.122z"/>',
    },
    "calendar-check-line": {
      body: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1zm11 9H4v9h16zm-4.964 1.136l1.414 1.414l-4.95 4.95l-3.536-3.536L9.38 12.55l2.121 2.122zM7 5H4v3h16V5h-3v1h-2V5H9v1H7z"/>',
    },
    "calendar-close-fill": {
      body: '<path fill="currentColor" d="M9 3V1H7v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4V1h-2v2zM4 8h16v11H4zm5.879 1.964l2.12 2.122l2.122-2.122l1.414 1.415l-2.12 2.121l2.12 2.121l-1.414 1.414L12 14.915l-2.122 2.12l-1.414-1.414l2.122-2.121l-2.122-2.121z"/>',
    },
    "calendar-close-line": {
      body: '<path fill="currentColor" d="M9 3V1H7v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4V1h-2v2zm-5 7h16v9H4zm0-5h3v1h2V5h6v1h2V5h3v3H4zm5.879 5.964L12 13.086l2.121-2.122l1.415 1.415l-2.122 2.121l2.121 2.121l-1.414 1.414L12 15.915l-2.121 2.12l-1.415-1.414l2.122-2.12l-2.122-2.122z"/>',
    },
    "calendar-event-fill": {
      body: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2zM4 9v10h16V9zm2 4h5v4H6z"/>',
    },
    "calendar-event-line": {
      body: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1zm11 10H4v8h16zm-9 2v4H6v-4zM7 5H4v4h16V5h-3v2h-2V5H9v2H7z"/>',
    },
    "calendar-fill": {
      body: '<path fill="currentColor" d="M2 11h20v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm15-8h4a1 1 0 0 1 1 1v5H2V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2z"/>',
    },
    "calendar-line": {
      body: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1zm11 10H4v8h16zM7 5H4v4h16V5h-3v2h-2V5H9v2H7z"/>',
    },
    "calendar-schedule-fill": {
      body: '<path fill="currentColor" d="M7 1v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h7.755A8 8 0 0 1 22 9.755V4a1 1 0 0 0-1-1h-4V1h-2v2H9V1zm16 15a6 6 0 1 1-12 0a6 6 0 0 1 12 0m-7-4v4.414l2.293 2.293l1.414-1.414L18 15.586V12z"/>',
    },
    "calendar-schedule-line": {
      body: '<path fill="currentColor" d="M7 3V1h2v2h6V1h2v2h4a1 1 0 0 1 1 1v5h-2V5h-3v2h-2V5H9v2H7V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm10 9a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0a6 6 0 0 1-12 0m5-3v3.414l2.293 2.293l1.414-1.414L18 15.586V13z"/>',
    },
    "calendar-todo-fill": {
      body: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2zM4 9v10h16V9zm2 2h2v2H6zm0 4h2v2H6zm4-4h8v2h-8zm0 4h5v2h-5z"/>',
    },
    "calendar-todo-line": {
      body: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1zm11 10H4v8h16zM8 14v2H6v-2zm10 0v2h-8v-2zM7 5H4v4h16V5h-3v2h-2V5H9v2H7z"/>',
    },
    "calendar-view": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 15h16V9H4zm7-6H6v4h5z"/>',
    },
    "camera-2-fill": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM12 15a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0 2a5 5 0 1 0 0-10a5 5 0 0 0 0 10m6-12v2h2V5z"/>',
    },
    "camera-2-line": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM4 5v14h16V5zm8 10a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2a5 5 0 1 1 0-10a5 5 0 0 1 0 10m5-11h2v2h-2z"/>',
    },
    "camera-3-fill": {
      body: '<path fill="currentColor" d="M2 6c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20zm12 12a5 5 0 1 0 0-10a5 5 0 0 0 0 10M4 7v2h3V7zm0-5h6v2H4z"/>',
    },
    "camera-3-line": {
      body: '<path fill="currentColor" d="M2 6c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20zm2 1v12h16V7zm10 9a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2a5 5 0 1 1 0-10a5 5 0 0 1 0 10M4 2h6v2H4z"/>',
    },
    "camera-fill": {
      body: '<path fill="currentColor" d="M9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4zm3 16a6 6 0 1 0 0-12a6 6 0 0 0 0 12m0-2a4 4 0 1 1 0-8a4 4 0 0 1 0 8"/>',
    },
    "camera-lens-fill": {
      body: '<path fill="currentColor" d="M9.827 21.763L14.31 14l3.532 6.118A9.96 9.96 0 0 1 12 22c-.746 0-1.473-.082-2.173-.237M7.89 21.12A10.03 10.03 0 0 1 2.458 15h8.965zM2.05 13Q2 12.507 2 12c0-2.607.998-4.981 2.632-6.761L9.113 13zm4.109-9.117A9.96 9.96 0 0 1 12 2c.746 0 1.473.082 2.173.237L9.69 10zM16.11 2.88A10.03 10.03 0 0 1 21.542 9h-8.965zM21.95 11q.05.493.05 1a9.96 9.96 0 0 1-2.632 6.761L14.887 11z"/>',
    },
    "camera-lens-line": {
      body: '<path fill="currentColor" d="M9.858 19.71L12 16H5.07a8.02 8.02 0 0 0 4.788 3.71M4.252 14h4.284L5.07 7.999A7.96 7.96 0 0 0 4 12c0 .69.088 1.36.252 2m2.143-7.708L8.535 10L12 4a7.97 7.97 0 0 0-5.605 2.292m7.747-2.002L12 8h6.93a8.02 8.02 0 0 0-4.788-3.71M19.748 10h-4.284l3.465 6.001A7.96 7.96 0 0 0 20 12a8 8 0 0 0-.252-2m-2.143 7.708L15.465 14L12 20a7.97 7.97 0 0 0 5.605-2.292M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m1.155-12h-2.31l-1.154 2l1.154 2h2.31l1.154-2z"/>',
    },
    "camera-line": {
      body: '<path fill="currentColor" d="m9.828 5l-2 2H4v12h16V7h-3.828l-2-2zM9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4zm3 15a5.5 5.5 0 1 1 0-11a5.5 5.5 0 0 1 0 11m0-2a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7"/>',
    },
    "camera-off-fill": {
      body: '<path fill="currentColor" d="M19.586 21H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h.586L1.394 2.808l1.414-1.415l19.799 19.8l-1.415 1.414zM7.556 8.97a6 6 0 0 0 8.475 8.475l-1.417-1.417a4 4 0 0 1-5.642-5.642zM22 17.786l-4.045-4.045Q18 13.377 18 13a6 6 0 0 0-6.74-5.955L8.107 3.893L9 3h6l2 2h4a1 1 0 0 1 1 1zm-8.49-8.492a4 4 0 0 1 2.197 2.198z"/>',
    },
    "camera-off-line": {
      body: '<path fill="currentColor" d="M19.586 21H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h.586L1.394 2.808l1.414-1.415l19.799 19.8l-1.415 1.414zm-14-14H4v12h13.586l-2.18-2.18A5.5 5.5 0 0 1 7.68 9.094zm3.525 3.525a3.5 3.5 0 0 0 4.865 4.865zM22 17.785l-2-2V7h-3.83l-2-2H9.83l-.308.307l-1.414-1.414L9 3h6l2 2h4a1 1 0 0 1 1 1zM11.262 7.05a5.5 5.5 0 0 1 6.188 6.188L15.112 10.9A3.5 3.5 0 0 0 13.6 9.388z"/>',
    },
    "camera-switch-fill": {
      body: '<path fill="currentColor" d="M9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4zm5.684 15.368l-.895-1.79A4 4 0 0 1 8 13h2.001L7.839 8.677a6 6 0 0 0 6.845 9.69M9.316 7.632l.895 1.79A4 4 0 0 1 16 13h-2.001l2.161 4.323a6 6 0 0 0-6.845-9.69"/>',
    },
    "camera-switch-line": {
      body: '<path fill="currentColor" d="m9.828 5l-2 2H4v12h16V7h-3.828l-2-2zM9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4zm.64 4.53a5.5 5.5 0 0 1 6.187 8.92L13.75 12.6h1.749l.001-.1a3.5 3.5 0 0 0-4.928-3.196zm4.678 9.96a5.5 5.5 0 0 1-6.18-8.905L10.25 12.5H8.5a3.5 3.5 0 0 0 4.886 3.215z"/>',
    },
    "candle-fill": {
      body: '<path fill="currentColor" d="M9.172 9.331a4 4 0 0 1 0-5.656L12 .846l2.828 2.829A4 4 0 0 1 13 10.377V12h5a1 1 0 0 1 1 1v7h2v2H3v-2h2v-7a1 1 0 0 1 1-1h5v-1.623A4 4 0 0 1 9.172 9.33m1.414-4.242a2 2 0 1 0 2.828 0L12 3.675z"/>',
    },
    "candle-line": {
      body: '<path fill="currentColor" d="M9.172 9.331a4 4 0 0 1 0-5.656L12 .846l2.828 2.829A4 4 0 0 1 13 10.377V12h5a1 1 0 0 1 1 1v7h2v2H3v-2h2v-7a1 1 0 0 1 1-1h5v-1.623A4 4 0 0 1 9.172 9.33m1.414-4.242a2 2 0 1 0 2.828 0L12 3.675zM7 14v6h10v-6z"/>',
    },
    "capsule-fill": {
      body: '<path fill="currentColor" d="M19.779 4.222a6 6 0 0 1 0 8.485l-2.122 2.12l-4.95 4.951a6 6 0 0 1-8.485-8.485l7.071-7.071a6 6 0 0 1 8.486 0m-4.95 10.606L9.172 9.172l-3.536 3.535a4 4 0 0 0 5.657 5.657z"/>',
    },
    "capsule-line": {
      body: '<path fill="currentColor" d="M19.779 4.222a6 6 0 0 1 0 8.485l-7.071 7.071a6 6 0 0 1-8.486-8.485l7.071-7.071a6 6 0 0 1 8.486 0m-5.657 11.313L8.466 9.878l-2.83 2.83a4 4 0 0 0 5.657 5.656zm4.242-9.899a4 4 0 0 0-5.657 0L9.88 8.464l5.657 5.657l2.827-2.828a4 4 0 0 0 0-5.657"/>',
    },
    "car-fill": {
      body: '<path fill="currentColor" d="M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.513-6.702A2 2 0 0 1 6.386 4h11.228a2 2 0 0 1 1.873 1.298L22 12v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zM4.136 12h15.728l-2.25-6H6.386zM6.5 17a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m11 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "car-line": {
      body: '<path fill="currentColor" d="M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.48-5.788A2 2 0 0 1 6.32 4h11.36a2 2 0 0 1 1.838 1.212L22 11v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm1-7H4v5h16zM4.176 11h15.648l-2.143-5H6.32zM6.5 17a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m11 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "car-washing-fill": {
      body: '<path fill="currentColor" d="M19 21H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.417-4.029A2 2 0 0 1 6.132 8h11.736a2 2 0 0 1 1.715.971L22 13v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zM4.332 13h15.336l-1.8-3H6.132zM6.5 18a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m11 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M5.44 3.44L6.5 2.378l1.06 1.06a1.5 1.5 0 1 1-2.121 0m5.5 0L12 2.378l1.06 1.06a1.5 1.5 0 1 1-2.121 0m5.5 0l1.06-1.061l1.06 1.06a1.5 1.5 0 1 1-2.121 0"/>',
    },
    "car-washing-line": {
      body: '<path fill="currentColor" d="M19 21H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V12l2.417-4.029A2 2 0 0 1 6.132 7h11.736a2 2 0 0 1 1.715.971L22 12v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm1-7H4v5h16zM4.332 12h15.336l-1.8-3H6.132zM5.44 3.44L6.5 2.378l1.06 1.06a1.5 1.5 0 1 1-2.121 0m5.5 0L12 2.378l1.06 1.06a1.5 1.5 0 1 1-2.121 0m5.5 0l1.061-1.06l1.06 1.06a1.5 1.5 0 1 1-2.121 0M6.5 18a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m11 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "caravan-fill": {
      body: '<path fill="currentColor" d="M14.172 3a2 2 0 0 1 1.414.586l4.828 4.828A2 2 0 0 1 21 9.828V17h2v2h-8.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2zM11 16a2 2 0 1 0 0 4a2 2 0 0 0 0-4m3-9H6v6h8zm-2 2v2H8V9z"/>',
    },
    "caravan-line": {
      body: '<path fill="currentColor" d="M14.172 3a2 2 0 0 1 1.414.586l4.828 4.828A2 2 0 0 1 21 9.828V17h2v2h-8.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2zM11 16a2 2 0 1 0 0 4a2 2 0 0 0 0-4m3.172-11H4v12h3.126a4.002 4.002 0 0 1 7.748 0H19V9.828zM14 7v6H6V7zm-2 2H8v2h4z"/>',
    },
    "carousel-view": {
      body: '<path fill="currentColor" d="M4 3H1v2h2v14H1v2h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m3 1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zm2 1v14h6V5zm10-1a1 1 0 0 1 1-1h3v2h-2v14h2v2h-3a1 1 0 0 1-1-1z"/>',
    },
    "cash-fill": {
      body: '<path fill="currentColor" d="M3.005 4.003h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1M6.5 6H4v2.5A2.5 2.5 0 0 0 6.5 6m11 0A2.5 2.5 0 0 0 20 8.5V6zM4 15.5V18h2.5A2.5 2.5 0 0 0 4 15.5M17.5 18H20v-2.5a2.5 2.5 0 0 0-2.5 2.5M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8"/>',
    },
    "cash-line": {
      body: '<path fill="currentColor" d="M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8m9.005-11.997h-18a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1m-17 11.643V8.354a3.51 3.51 0 0 0 2.35-2.351h11.291a3.51 3.51 0 0 0 2.359 2.353v7.288a3.51 3.51 0 0 0-2.36 2.359H6.355a3.51 3.51 0 0 0-2.351-2.357"/>',
    },
    "cast-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6q0-1.021-.153-2H20V5H4v3.153A13 13 0 0 0 2 8V4a1 1 0 0 1 1-1m10 18h-2a9 9 0 0 0-9-9v-2c6.075 0 11 4.925 11 11m-4 0H7a5 5 0 0 0-5-5v-2a7 7 0 0 1 7 7m-4 0H2v-3a3 3 0 0 1 3 3m9.373-4A13.03 13.03 0 0 0 6 8.627V7h12v10z"/>',
    },
    "cast-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6q0-1.021-.153-2H20V5H4v3.153A13 13 0 0 0 2 8V4a1 1 0 0 1 1-1m10 18h-2a9 9 0 0 0-9-9v-2c6.075 0 11 4.925 11 11m-4 0H7a5 5 0 0 0-5-5v-2a7 7 0 0 1 7 7m-4 0H2v-3a3 3 0 0 1 3 3"/>',
    },
    "cellphone-fill": {
      body: '<path fill="currentColor" d="M7 2h11a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V0h2zm0 2v5h10V4z"/>',
    },
    "cellphone-line": {
      body: '<path fill="currentColor" d="M7 2h11a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V0h2zm0 7h10V4H7zm0 2v9h10v-9z"/>',
    },
    "celsius-fill": {
      body: '<path fill="currentColor" d="M4.5 10a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M22 10h-2a4 4 0 0 0-8 0v5a4 4 0 0 0 8 0h2a6 6 0 0 1-12 0v-5a6 6 0 0 1 12 0"/>',
    },
    "celsius-line": {
      body: '<path fill="currentColor" d="M4.5 10a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M22 10h-2a4 4 0 0 0-8 0v5a4 4 0 0 0 8 0h2a6 6 0 0 1-12 0v-5a6 6 0 0 1 12 0"/>',
    },
    "centos-fill": {
      body: '<path fill="currentColor" d="m12 13.06l4.47 4.471L12 22l-4.47-4.47zm-8 3.06L7.879 20H4zm16 0V20h-3.88zm-2.47-8.59L22 12l-4.469 4.47l-4.47-4.47zm-11.06 0L10.94 12l-4.471 4.469L2 12zM12 2l4.469 4.469L12 10.939L7.53 6.47zM7.879 4l-3.88 3.879L4 4zM20 4v3.879l-3.88-3.88z"/>',
    },
    "centos-line": {
      body: '<path fill="currentColor" d="m12 2l4.292 4.292l1.061-1.06L16.121 4H20v3.879l-1.233-1.233l-1.06 1.061L22 12l-4.292 4.293l1.059 1.059L20 16.121V20h-3.88l1.232-1.233l-1.059-1.06L12 22l-4.293-4.293l-1.061 1.06L7.879 20H4v-3.88l1.231 1.232l1.061-1.06L2 12l4.293-4.293l-1.062-1.061L4 7.879V4h3.879L6.646 5.23l1.062 1.062zm0 11.413l-2.88 2.879l2.88 2.88l2.879-2.88zM7.707 9.12L4.828 12l2.878 2.878l2.88-2.88zm8.585 0l-2.877 2.878l2.878 2.879L19.172 12zM12 4.828L9.122 7.707l2.879 2.878l2.877-2.879z"/>',
    },
    "character-recognition-fill": {
      body: '<path fill="currentColor" d="M20.998 3v18h-18V3zm-8.001 3h-2L6.598 17h2.154l1.199-3h4.09l1.201 3h2.155zm-1 2.885L13.242 12H10.75z"/>',
    },
    "character-recognition-line": {
      body: '<path fill="currentColor" d="M4.998 15v4h4v2h-6v-6zm16 0v6h-6v-2h4v-4zm-8.001-9l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3H6.598l4.399-11zm-1 2.885L10.75 12h2.492zM8.998 3v2h-4v4h-2V3zm12 0v6h-2V5h-4V3z"/>',
    },
    "charging-pile-2-fill": {
      body: '<path fill="currentColor" d="M20 11h-1V7h1V4h2v3h1v4h-1v7a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0zM9 11V7l-4 6h3v4l4-6z"/>',
    },
    "charging-pile-2-line": {
      body: '<path fill="currentColor" d="M20 11h-1V7h1V4h2v3h1v4h-1v7a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0zm-8 8V5H5v14zm-3-8h3l-4 6v-4H5l4-6z"/>',
    },
    "charging-pile-fill": {
      body: '<path fill="currentColor" d="M3 19V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657l1.414-1.414l4.95 4.95A1 1 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2zm6-8V7l-4 6h3v4l4-6z"/>',
    },
    "charging-pile-line": {
      body: '<path fill="currentColor" d="M14 19h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657l1.414-1.414l4.95 4.95A1 1 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2zm-9 0h7V5H5zm4-8h3l-4 6v-4H5l4-6z"/>',
    },
    "chat-1-fill": {
      body: '<path fill="currentColor" d="M10 3h4a8 8 0 1 1 0 16v3.5c-5-2-12-5-12-11.5a8 8 0 0 1 8-8"/>',
    },
    "chat-1-line": {
      body: '<path fill="currentColor" d="M10 3h4a8 8 0 1 1 0 16v3.5c-5-2-12-5-12-11.5a8 8 0 0 1 8-8m2 14h2a6 6 0 0 0 0-12h-4a6 6 0 0 0-6 6c0 3.61 2.462 5.966 8 8.48z"/>',
    },
    "chat-2-fill": {
      body: '<path fill="currentColor" d="M14.45 19L12 22.5L9.55 19H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1z"/>',
    },
    "chat-2-line": {
      body: '<path fill="currentColor" d="M14.45 19L12 22.5L9.55 19H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm-1.041-2H20V5H4v12h6.591L12 19.012z"/>',
    },
    "chat-3-fill": {
      body: '<path fill="currentColor" d="M7.291 20.824L2 22l1.176-5.291A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.709-1.176"/>',
    },
    "chat-3-line": {
      body: '<path fill="currentColor" d="M7.291 20.824L2 22l1.176-5.291A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.709-1.176m.29-2.113l.653.35A7.96 7.96 0 0 0 12 20a8 8 0 1 0-8-8c0 1.335.325 2.617.94 3.766l.349.653l-.655 2.947z"/>',
    },
    "chat-4-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1z"/>',
    },
    "chat-4-line": {
      body: '<path fill="currentColor" d="M5.763 17H20V5H4v13.385zm.692 2L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1z"/>',
    },
    "chat-check-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm4.838-6.879L8.818 9.646l-1.414 1.415l3.889 3.889l5.657-5.657l-1.414-1.414z"/>',
    },
    "chat-check-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm-.692-2H20V5H4v13.385zm5.53-4.879l4.243-4.242l1.414 1.414l-5.657 5.657l-3.89-3.89l1.415-1.414z"/>',
    },
    "chat-delete-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm6.96-8l2.474-2.475l-1.414-1.414L12 9.586L9.525 7.11L8.111 8.525L10.586 11L8.11 13.475l1.414 1.414L12 12.414l2.475 2.475l1.414-1.414z"/>',
    },
    "chat-delete-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM4 18.385L5.763 17H20V5H4zM13.414 11l2.475 2.475l-1.414 1.414L12 12.414L9.525 14.89l-1.414-1.414L10.586 11L8.11 8.525l1.414-1.414L12 9.586l2.475-2.475l1.414 1.414z"/>',
    },
    "chat-download-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM13 11V7h-2v4H8l4 4l4-4z"/>',
    },
    "chat-download-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM4 18.385L5.763 17H20V5H4zM13 11h3l-4 4l-4-4h3V7h2z"/>',
    },
    "chat-follow-up-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1zm-4 4h-2v8h2zm-6 1H9v1.999L7 10v2l2-.001V14h2v-2.001L13 12v-2l-2-.001z"/>',
    },
    "chat-follow-up-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1zm-1 2H4v13.385L5.763 17H20zm-3 2v8h-2V7zm-6 1v1.999L13 10v2l-2-.001V14H9v-2.001L7 12v-2l2-.001V8z"/>',
    },
    "chat-forward-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM12 10H8v2h4v3l4-4l-4-4z"/>',
    },
    "chat-forward-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM4 18.385L5.763 17H20V5H4zM12 10V7l4 4l-4 4v-3H8v-2z"/>',
    },
    "chat-heart-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm5.563-4.3l3.358-3.359a2.25 2.25 0 1 0-3.181-3.182l-.177.177l-.177-.177a2.25 2.25 0 0 0-3.182 3.182z"/>',
    },
    "chat-heart-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM4 18.385L5.763 17H20V5H4zm8.018-3.685l-3.359-3.36a2.25 2.25 0 0 1 3.182-3.182l.177.177l.176-.177a2.25 2.25 0 0 1 3.182 3.182z"/>',
    },
    "chat-history-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.708-1.175L2 22l1.176-5.29A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2m1 5h-2v7h6v-2h-4z"/>',
    },
    "chat-history-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.708-1.175L2 22l1.176-5.29A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2m0 2a8 8 0 0 0-8 8c0 1.335.326 2.618.94 3.766l.35.654l-.656 2.946l2.948-.654l.653.349A7.96 7.96 0 0 0 12 20a8 8 0 1 0 0-16m1 3v5h4v2h-6V7z"/>',
    },
    "chat-new-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM11 10H8v2h3v3h2v-3h3v-2h-3V7h-2z"/>',
    },
    "chat-new-line": {
      body: '<path fill="currentColor" d="M14 3v2H4v13.385L5.763 17H20v-7h2v8a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1zm5 0V0h2v3h3v2h-3v3h-2V5h-3V3z"/>',
    },
    "chat-off-fill": {
      body: '<path fill="currentColor" d="m2.808 1.393l19.799 19.8l-1.415 1.414l-3.607-3.608L6.455 19L2 22.5V4c0-.17.042-.329.116-.469l-.722-.723zM21 3a1 1 0 0 1 1 1v13.785L7.214 3z"/>',
    },
    "chat-off-line": {
      body: '<path fill="currentColor" d="m2.808 1.393l19.799 19.8l-1.415 1.414l-3.607-3.608L6.455 19L2 22.5V4c0-.17.042-.329.116-.469l-.722-.723zM4 5.413v12.972L5.763 17h9.822zM21 3a1 1 0 0 1 1 1v13.785l-2-2V5L9.213 4.999L7.214 3z"/>',
    },
    "chat-poll-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1zm-8 4h-2v8h2zm4 2h-2v6h2zm-8 2H7v4h2z"/>',
    },
    "chat-poll-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1zm-1 2H4v13.385L5.763 17H20zm-7 2v8h-2V7zm4 2v6h-2V9zm-8 2v4H7v-4z"/>',
    },
    "chat-private-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.708-1.175L2 22l1.176-5.29A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2m0 5c-1.598 0-3 1.34-3 3v1H8v5h8v-5h-1v-1a3 3 0 0 0-3-3m2 6v1h-4v-1zm-2-4c.476 0 1 .49 1 1v1h-2v-1c0-.51.487-1 1-1"/>',
    },
    "chat-private-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.708-1.175L2 22l1.176-5.29A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2m0 2a8 8 0 0 0-8 8c0 1.335.326 2.618.94 3.766l.35.654l-.656 2.946l2.948-.654l.653.349A7.96 7.96 0 0 0 12 20a8 8 0 1 0 0-16m0 3a3 3 0 0 1 3 3v1h1v5H8v-5h1v-1a3 3 0 0 1 3-3m2 6h-4v1h4zm-2-4c-.552 0-1 .45-1 1v1h2v-1a1 1 0 0 0-1-1"/>',
    },
    "chat-quote-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1zM10.515 7.412C8.728 8.187 7.5 9.755 7.5 11.505c0 .995.277 1.609.792 2.156c.324.344.837.589 1.374.589a1.75 1.75 0 0 0 1.75-1.75a1.76 1.76 0 0 0-1.614-1.745a2 2 0 0 0-.479.01v-.092c.006-.44.1-1.74 1.639-2.573zm5 0c-1.787.775-3.015 2.343-3.015 4.093c0 .995.277 1.609.792 2.156c.324.344.837.589 1.374.589a1.75 1.75 0 0 0 1.75-1.75a1.76 1.76 0 0 0-1.614-1.745a2 2 0 0 0-.479.01v-.092c.006-.44.1-1.74 1.639-2.573z"/>',
    },
    "chat-quote-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1zm-1 2H4v13.385L5.763 17H20zm-9.485 2.412l.447.688c-1.668.903-1.639 2.352-1.639 2.665c.155-.022.318-.025.48-.01a1.76 1.76 0 0 1 1.613 1.745a1.75 1.75 0 0 1-1.75 1.75c-.537 0-1.05-.245-1.374-.59c-.515-.546-.792-1.16-.792-2.155c0-1.75 1.228-3.318 3.015-4.093m5 0l.447.688c-1.668.903-1.639 2.352-1.639 2.665c.155-.022.318-.025.48-.01a1.76 1.76 0 0 1 1.613 1.745a1.75 1.75 0 0 1-1.75 1.75c-.537 0-1.05-.245-1.374-.59c-.515-.546-.792-1.16-.792-2.155c0-1.75 1.228-3.318 3.015-4.093"/>',
    },
    "chat-search-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8.803A6 6 0 0 0 13.083 19zm17.495 2.535l-1.504-1.503a4 4 0 1 0-1.414 1.414l1.503 1.504zM21 18a2 2 0 1 1-4 0a2 2 0 0 1 4 0"/>',
    },
    "chat-search-line": {
      body: '<path fill="currentColor" d="M5.763 17h7.32a6 6 0 0 0 0 2H6.455L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8.803a6 6 0 0 0-2-.72V5H4v13.385zm18.187 4.535l-1.504-1.503a4 4 0 1 0-1.414 1.414l1.503 1.504zM21 18a2 2 0 1 1-4 0a2 2 0 0 1 4 0"/>',
    },
    "chat-settings-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm1.69-6.929l-.975.563l1 1.732l.976-.563c.501.51 1.14.887 1.854 1.071V16h2v-1.126a4 4 0 0 0 1.854-1.072l.976.564l1-1.732l-.975-.563a4 4 0 0 0 0-2.142l.975-.563l-1-1.732l-.976.563A4 4 0 0 0 13 7.126V6h-2v1.126a4 4 0 0 0-1.854 1.071l-.976-.563l-1 1.732l.975.563a4 4 0 0 0 0 2.142M12 13a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "chat-settings-line": {
      body: '<path fill="currentColor" d="M22 12h-2V5H4v13.385L5.763 17H12v2H6.455L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-7.855 7.071a4 4 0 0 1 0-2.142l-.975-.563l1-1.732l.976.563A4 4 0 0 1 17 14.127V13h2v1.126c.715.184 1.352.56 1.854 1.072l.976-.564l1 1.732l-.975.563a4 4 0 0 1 0 2.142l.975.563l-1 1.732l-.976-.564A4 4 0 0 1 19 21.874V23h-2v-1.126a4 4 0 0 1-1.854-1.072l-.976.564l-1-1.732zM18 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "chat-smile-2-fill": {
      body: '<path fill="currentColor" d="M7.291 20.824L2 22l1.176-5.291A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.709-1.176M7 12a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0z"/>',
    },
    "chat-smile-2-line": {
      body: '<path fill="currentColor" d="M7.291 20.824L2 22l1.176-5.291A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.709-1.176m.29-2.113l.653.35A7.96 7.96 0 0 0 12 20a8 8 0 1 0-8-8c0 1.335.325 2.617.94 3.766l.349.653l-.655 2.947zM7 12h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0"/>',
    },
    "chat-smile-3-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10H2l2.929-2.929A9.97 9.97 0 0 1 2 12C2 6.477 6.477 2 12 2m4 11H8a4 4 0 0 0 8 0"/>',
    },
    "chat-smile-3-line": {
      body: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10H2l2.929-2.929A9.97 9.97 0 0 1 2 12m4.828 8H12a8 8 0 1 0-8-8c0 2.152.851 4.165 2.343 5.657l1.414 1.414zM8 13h8a4 4 0 0 1-8 0"/>',
    },
    "chat-smile-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM7 10a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0z"/>',
    },
    "chat-smile-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm-.692-2H20V5H4v13.385zM7 10h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0"/>',
    },
    "chat-thread-fill": {
      body: '<path fill="currentColor" d="m2 22l5.291-1.176A9.96 9.96 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12c0 1.703.425 3.306 1.176 4.709zM15.449 7l-.175 2H17v2h-1.901l-.175 2H17v2h-2.251l-.175 2h-2.008l.175-2h-2.008l-.175 2H8.552l.175-2H7v-2h1.9l.176-2H7V9h2.25l.176-2h2.007l-.175 2h2.008l.175-2zm-4.366 4l-.175 2h2.008l.175-2z"/>',
    },
    "chat-thread-line": {
      body: '<path fill="currentColor" d="m2 22l5.291-1.176A9.96 9.96 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12c0 1.703.425 3.306 1.176 4.709zm6.234-2.94l-.653-.349l-2.947.655l.655-2.947l-.35-.653A7.96 7.96 0 0 1 4 12a8 8 0 1 1 8 8a7.96 7.96 0 0 1-3.766-.94M15.45 7h-2.01l-.175 2h-2.008l.175-2H9.426L9.25 9H7v2h2.076L8.9 13H7v2h1.726l-.175 2h2.008l.175-2h2.007l-.175 2h2.008l.175-2H17v-2h-2.076l.175-2H17V9h-1.726zm-4.366 4h2.008l-.175 2h-2.008z"/>',
    },
    "chat-unread-fill": {
      body: '<path fill="currentColor" d="M21 7a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2q.515 0 1-.1V18a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h13.1q-.1.486-.1 1a5 5 0 0 0 5 5"/>',
    },
    "chat-unread-line": {
      body: '<path fill="currentColor" d="M21 7a3 3 0 1 0 0-6a3 3 0 0 0 0 6m1 11V8.9a5 5 0 0 1-2 0V17H5.763L4 18.385V5h12.1a5 5 0 0 1 0-2H3a1 1 0 0 0-1 1v18.5L6.455 19H21a1 1 0 0 0 1-1"/>',
    },
    "chat-upload-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM13 11h3l-4-4l-4 4h3v4h2z"/>',
    },
    "chat-upload-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM4 18.385L5.763 17H20V5H4zM13 11v4h-2v-4H8l4-4l4 4z"/>',
    },
    "chat-voice-fill": {
      body: '<path fill="currentColor" d="M4.929 19.071A9.97 9.97 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10H2zM11 6v12h2V6zM7 9v6h2V9zm8 0v6h2V9z"/>',
    },
    "chat-voice-line": {
      body: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10H2l2.929-2.929A9.97 9.97 0 0 1 2 12m4.828 8H12a8 8 0 1 0-8-8c0 2.152.851 4.165 2.343 5.657l1.414 1.414zM11 6h2v12h-2zM7 9h2v6H7zm8 0h2v6h-2z"/>',
    },
    "check-double-fill": {
      body: '<path fill="currentColor" d="m11.602 13.76l1.412 1.412l8.466-8.466l1.414 1.415l-9.88 9.88l-6.364-6.365l1.414-1.414l2.125 2.125zm.002-2.828l4.952-4.953l1.41 1.41l-4.952 4.953zm-2.827 5.655L7.364 18L1 11.636l1.414-1.414l1.413 1.413l-.001.001z"/>',
    },
    "check-double-line": {
      body: '<path fill="currentColor" d="m11.602 13.76l1.412 1.412l8.466-8.466l1.414 1.415l-9.88 9.88l-6.364-6.365l1.414-1.414l2.125 2.125zm.002-2.828l4.952-4.953l1.41 1.41l-4.952 4.953zm-2.827 5.655L7.364 18L1 11.636l1.414-1.414l1.413 1.413l-.001.001z"/>',
    },
    "check-fill": {
      body: '<path fill="currentColor" d="m10 15.17l9.192-9.191l1.414 1.414L10 17.999l-6.364-6.364l1.414-1.414z"/>',
    },
    "check-line": {
      body: '<path fill="currentColor" d="m10 15.17l9.192-9.191l1.414 1.414L10 17.999l-6.364-6.364l1.414-1.414z"/>',
    },
    "checkbox-blank-circle-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10"/>',
    },
    "checkbox-blank-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16"/>',
    },
    "checkbox-blank-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "checkbox-blank-line": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5z"/>',
    },
    "checkbox-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-.997-6l7.07-7.071l-1.413-1.414l-5.657 5.657l-2.829-2.829l-1.414 1.414z"/>',
    },
    "checkbox-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-.997-4L6.76 11.757l1.414-1.414l2.829 2.829l5.657-5.657l1.414 1.414z"/>',
    },
    "checkbox-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m7.003 13l7.07-7.071l-1.413-1.414l-5.657 5.657l-2.829-2.829l-1.414 1.414z"/>',
    },
    "checkbox-indeterminate-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 8v2h10v-2z"/>',
    },
    "checkbox-indeterminate-line": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5zm2 6h10v2H7z"/>',
    },
    "checkbox-line": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5zm6.003 11L6.76 11.757l1.414-1.414l2.829 2.829l5.657-5.657l1.414 1.414z"/>',
    },
    "checkbox-multiple-blank-fill": {
      body: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9z"/>',
    },
    "checkbox-multiple-blank-line": {
      body: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9zM4.003 9L4 20h11V9z"/>',
    },
    "checkbox-multiple-fill": {
      body: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9zm-.498 11l5.657-5.657l-1.414-1.414l-4.243 4.243l-2.12-2.122l-1.415 1.414z"/>',
    },
    "checkbox-multiple-line": {
      body: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9zm6 2H4.003L4 20h11zm-6.498 9l-3.535-3.536L6.38 13.05l2.121 2.122l4.243-4.243l1.414 1.414z"/>',
    },
    "china-railway-fill": {
      body: '<path fill="currentColor" d="M11 19v-6l-2-1V9h6v3l-2 1v6l5 1v2H6v-2zM10 2.223V1h4v1.223a9.003 9.003 0 0 1 2.993 16.266l-1.11-1.664a7 7 0 1 0-7.767 0l-1.109 1.664A9.003 9.003 0 0 1 10 2.223"/>',
    },
    "china-railway-line": {
      body: '<path fill="currentColor" d="M11 20v-7H9v-3h6v3h-2v7h5v2H6v-2zM10 2.223V1h4v1.223a9.003 9.003 0 0 1 2.993 16.266l-1.11-1.664a7 7 0 1 0-7.767 0l-1.109 1.664A9.003 9.003 0 0 1 10 2.223"/>',
    },
    "chrome-fill": {
      body: '<path fill="currentColor" d="M9.827 21.763C5.35 20.771 2 16.777 2 12c0-1.822.487-3.53 1.339-5.002l4.283 7.419a5 5 0 0 0 4.976 2.548zM12 22l4.287-7.425A5 5 0 0 0 17 12a4.98 4.98 0 0 0-1-3h5.542A10 10 0 0 1 22 12c0 5.523-4.477 10-10 10m2.572-8.455a3 3 0 0 1-5.17-.045l-.029-.05a3 3 0 1 1 5.225.05zm-9.94-8.306A9.97 9.97 0 0 1 12 2a10 10 0 0 1 8.662 5H12a5 5 0 0 0-4.599 3.034z"/>',
    },
    "chrome-line": {
      body: '<path fill="currentColor" d="m10.365 19.833l1.93-3.342q-.147.009-.295.009a4.5 4.5 0 0 1-3.94-2.325L4.795 8.52a8.003 8.003 0 0 0 5.57 11.313m2.225.146A8 8 0 0 0 19.602 9.5h-3.86c.479.715.758 1.575.758 2.5c0 .848-.234 1.64-.642 2.318zm1.553-6.691l.022-.038a2.5 2.5 0 1 0-4.354-.042l.024.042a2.5 2.5 0 0 0 4.308.037m-8.108-6.62l1.928 3.34A4.5 4.5 0 0 1 12 7.5h6.615A7.99 7.99 0 0 0 12 4a7.98 7.98 0 0 0-5.965 2.669M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "circle-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10"/>',
    },
    "circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16"/>',
    },
    "clapperboard-fill": {
      body: '<path fill="currentColor" d="m17.998 7l2.31-4h.7c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h3.006l-2.31 4h2.31l2.31-4h3.69l-2.31 4h2.31l2.31-4h3.69l-2.31 4z"/>',
    },
    "clapperboard-line": {
      body: '<path fill="currentColor" d="m5.998 7l2.31-4h3.69l-2.31 4zm6 0l2.31-4h3.69l-2.31 4zm6 0l2.31-4h.7c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h3.006L4 6.46V19h16V7z"/>',
    },
    "clipboard-fill": {
      body: '<path fill="currentColor" d="M6 4v4h12V4h2.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4zm2-2h8v4H8z"/>',
    },
    "clipboard-line": {
      body: '<path fill="currentColor" d="M7 4V2h10v2h3.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4zm0 2H5v14h14V6h-2v2H7zm2-2v2h6V4z"/>',
    },
    "clockwise-2-fill": {
      body: '<path fill="currentColor" d="M10 4V1l5 4l-5 4V6H8a3 3 0 0 0-3 3v4H3V9a5 5 0 0 1 5-5zm-1 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1z"/>',
    },
    "clockwise-2-line": {
      body: '<path fill="currentColor" d="M10.586 4L8.757 2.172L10.172.757L14.414 5l-4.242 4.243l-1.415-1.415L10.586 6H8a3 3 0 0 0-3 3v4H3V9a5 5 0 0 1 5-5zM9 11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1zm2 1v8h8v-8z"/>',
    },
    "clockwise-fill": {
      body: '<path fill="currentColor" d="M20 10h3l-4 5l-4-5h3V8a3 3 0 0 0-3-3h-4V3h4a5 5 0 0 1 5 5zm-7-1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1z"/>',
    },
    "clockwise-line": {
      body: '<path fill="currentColor" d="m20 10.586l1.828-1.829l1.415 1.415L19 14.414l-4.243-4.242l1.415-1.415L18 10.586V8a3 3 0 0 0-3-3h-4V3h4a5 5 0 0 1 5 5zM13 9a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1zm-1 2H4v8h8z"/>',
    },
    "close-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-11.414L9.172 7.757L7.757 9.172L10.586 12l-2.829 2.828l1.415 1.415L12 13.414l2.828 2.829l1.415-1.415L13.414 12l2.829-2.828l-1.415-1.415z"/>',
    },
    "close-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-9.414l2.828-2.829l1.415 1.415L13.414 12l2.829 2.828l-1.415 1.415L12 13.414l-2.828 2.829l-1.415-1.415L10.586 12L7.757 9.172l1.415-1.415z"/>',
    },
    "close-fill": {
      body: '<path fill="currentColor" d="m12 10.587l4.95-4.95l1.414 1.414l-4.95 4.95l4.95 4.95l-1.415 1.414l-4.95-4.95l-4.949 4.95l-1.414-1.415l4.95-4.95l-4.95-4.95L7.05 5.638z"/>',
    },
    "close-large-fill": {
      body: '<path fill="currentColor" d="M10.586 12L2.793 4.207l1.414-1.414L12 10.586l7.793-7.793l1.414 1.414L13.414 12l7.793 7.793l-1.414 1.414L12 13.414l-7.793 7.793l-1.414-1.414z"/>',
    },
    "close-large-line": {
      body: '<path fill="currentColor" d="M10.586 12L2.793 4.207l1.414-1.414L12 10.586l7.793-7.793l1.414 1.414L13.414 12l7.793 7.793l-1.414 1.414L12 13.414l-7.793 7.793l-1.414-1.414z"/>',
    },
    "close-line": {
      body: '<path fill="currentColor" d="m12 10.587l4.95-4.95l1.414 1.414l-4.95 4.95l4.95 4.95l-1.415 1.414l-4.95-4.95l-4.949 4.95l-1.414-1.415l4.95-4.95l-4.95-4.95L7.05 5.638z"/>',
    },
    "closed-captioning-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM9 8c-2.208 0-4 1.792-4 4s1.792 4 4 4c1.1 0 2.1-.45 2.828-1.172l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A4 4 0 0 0 9 8m7 0c-2.208 0-4 1.792-4 4a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A4 4 0 0 0 16 8"/>',
    },
    "closed-captioning-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H4v14h16zM9 8c1.104 0 2.105.448 2.829 1.173l-1.414 1.414a2 2 0 1 0 0 2.828l1.413 1.413A4.001 4.001 0 0 1 5 12c0-2.208 1.792-4 4-4m7 0c1.105 0 2.105.448 2.829 1.173l-1.414 1.414a2 2 0 1 0 0 2.828l1.413 1.413A4.001 4.001 0 0 1 12 12c0-2.208 1.792-4 4-4"/>',
    },
    "cloud-fill": {
      body: '<path fill="currentColor" d="M17 7a8 8 0 0 0-7.493 5.19l1.874.703A6.002 6.002 0 0 1 23 15a6 6 0 0 1-6 6H7A6 6 0 0 1 5.008 9.339a7 7 0 0 1 13.757-2.143A8 8 0 0 0 17 7"/>',
    },
    "cloud-line": {
      body: '<path fill="currentColor" d="M12 2a7 7 0 0 1 6.992 7.339A6 6 0 0 1 17 21H7A6 6 0 0 1 5.008 9.339A7 7 0 0 1 12 2m0 2a5 5 0 0 0-4.994 5.243l.07 1.488l-1.404.494A4.002 4.002 0 0 0 7 19h10a4 4 0 1 0-3.796-5.265l-1.898-.633A6 6 0 0 1 17 9a5 5 0 0 0-5-5"/>',
    },
    "cloud-off-fill": {
      body: '<path fill="currentColor" d="m3.515 2.1l19.092 19.092l-1.415 1.415l-2.014-2.015A6 6 0 0 1 17 21H7A6 6 0 0 1 5.008 9.339a7 7 0 0 1 .353-2.563L2.1 3.514zM17 9a6.003 6.003 0 0 1 5.204 8.989L14.01 9.796C14.89 9.29 15.91 9 17 9m-5-7a7 7 0 0 1 6.765 5.195a8.03 8.03 0 0 0-6.206 1.15L7.694 3.48A6.97 6.97 0 0 1 12 2"/>',
    },
    "cloud-off-line": {
      body: '<path fill="currentColor" d="m3.515 2.1l19.092 19.092l-1.415 1.415l-2.014-2.015A6 6 0 0 1 17 21H7A6 6 0 0 1 5.008 9.339a7 7 0 0 1 .353-2.563L2.1 3.514zM7 9q0 .122.006.243l.07 1.488l-1.404.494A4.002 4.002 0 0 0 7 19h10q.28 0 .548-.037L7.03 8.445Q7 8.718 7 9m5-7a7 7 0 0 1 6.992 7.339a6.003 6.003 0 0 1 3.212 8.65l-1.493-1.494a3.999 3.999 0 0 0-5.207-5.206L14.01 9.796A6 6 0 0 1 17 9a5 5 0 0 0-7.876-4.09l-1.43-1.43A6.97 6.97 0 0 1 12 2"/>',
    },
    "cloud-windy-fill": {
      body: '<path fill="currentColor" d="M14 19v-3.993H2.074a8 8 0 1 1 14.383-6.908A5.5 5.5 0 1 1 17.5 19zm-8 2h10v2H6zm-4-4h10v2H2z"/>',
    },
    "cloud-windy-line": {
      body: '<path fill="currentColor" d="M14 18v-2h3.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 0 0-12 0v.007H1V10a8 8 0 0 1 15.458-2.901A5.5 5.5 0 1 1 17.5 18zm-8 2h10v2H6zm0-8h8v2H6zm-4 4h10v2H2z"/>',
    },
    "cloudy-2-fill": {
      body: '<path fill="currentColor" d="M17 21H7A6 6 0 0 1 5.008 9.339a7 7 0 1 1 13.984 0A6 6 0 0 1 17 21"/>',
    },
    "cloudy-2-line": {
      body: '<path fill="currentColor" d="M17 21H7A6 6 0 0 1 5.008 9.339a7 7 0 1 1 13.984 0A6 6 0 0 1 17 21M7 19h10a4 4 0 1 0-.426-7.978a5 5 0 1 0-9.148 0A4 4 0 1 0 7 19"/>',
    },
    "cloudy-fill": {
      body: '<path fill="currentColor" d="M9 20.986a8.5 8.5 0 1 1 7.715-12.983A6.5 6.5 0 0 1 17 20.981V21H9z"/>',
    },
    "cloudy-line": {
      body: '<path fill="currentColor" d="M9.5 6a6.5 6.5 0 0 0 0 13h7a4.5 4.5 0 1 0-.957-8.898A6.5 6.5 0 0 0 9.5 6m7 15h-7a8.5 8.5 0 1 1 7.215-12.997A6.5 6.5 0 0 1 16.5 21"/>',
    },
    "code-block": {
      body: '<path fill="currentColor" d="m3.414 6l2.293-2.293l-1.414-1.414L.586 6l3.707 3.707l1.414-1.414zm6.172 0L7.293 3.707l1.414-1.414L12.414 6L8.707 9.707L7.293 8.293zM14 3h7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7h16V5h-6z"/>',
    },
    "code-box-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m13.465 12.536L20 12l-3.535-3.536L15.05 9.88L17.172 12l-2.122 2.121zM6.828 12L8.95 9.879L7.536 8.464L4 12l3.536 3.536L8.95 14.12zm4.416 5l3.64-10h-2.128l-3.64 10z"/>',
    },
    "code-box-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h16V5zm16 7l-3.535 3.536l-1.415-1.415L17.172 12L15.05 9.879l1.415-1.415zM6.828 12l2.122 2.121l-1.414 1.415L4 12l3.536-3.536L8.95 9.88zm4.416 5H9.116l3.64-10h2.128z"/>',
    },
    "code-fill": {
      body: '<path fill="currentColor" d="m23 12l-7.071 7.071l-1.414-1.414L20.172 12l-5.657-5.657l1.414-1.414zM3.828 12l5.657 5.657l-1.414 1.414L1 12l7.071-7.071l1.414 1.414z"/>',
    },
    "code-line": {
      body: '<path fill="currentColor" d="m23 12l-7.071 7.071l-1.414-1.414L20.172 12l-5.657-5.657l1.414-1.414zM3.828 12l5.657 5.657l-1.414 1.414L1 12l7.071-7.071l1.414 1.414z"/>',
    },
    "code-s-fill": {
      body: '<path fill="currentColor" d="m24 12l-5.657 5.657l-1.414-1.414L21.172 12l-4.243-4.243l1.414-1.414zM2.828 12l4.243 4.243l-1.414 1.414L0 12l5.657-5.657L7.07 7.757z"/>',
    },
    "code-s-line": {
      body: '<path fill="currentColor" d="m24 12l-5.657 5.657l-1.414-1.414L21.172 12l-4.243-4.243l1.414-1.414zM2.828 12l4.243 4.243l-1.414 1.414L0 12l5.657-5.657L7.07 7.757z"/>',
    },
    "code-s-slash-fill": {
      body: '<path fill="currentColor" d="m24 12l-5.657 5.657l-1.414-1.414L21.172 12l-4.243-4.243l1.414-1.414zM2.828 12l4.243 4.243l-1.414 1.414L0 12l5.657-5.657L7.07 7.757zm6.96 9H7.66l6.552-18h2.128z"/>',
    },
    "code-s-slash-line": {
      body: '<path fill="currentColor" d="m24 12l-5.657 5.657l-1.414-1.414L21.172 12l-4.243-4.243l1.414-1.414zM2.828 12l4.243 4.243l-1.414 1.414L0 12l5.657-5.657L7.07 7.757zm6.96 9H7.66l6.552-18h2.128z"/>',
    },
    "code-view": {
      body: '<path fill="currentColor" d="m16.95 8.464l1.414-1.414l4.95 4.95l-4.95 4.95l-1.414-1.414L20.485 12zm-9.9 0L3.515 12l3.535 3.536l-1.414 1.414L.686 12l4.95-4.95z"/>',
    },
    "codepen-fill": {
      body: '<path fill="currentColor" d="M12 10.202L9.303 12L12 13.798L14.697 12zm4.5.596L19.197 9L13 4.869v3.596zm3.5.07L18.303 12L20 13.132zm-3.5 2.334L13 15.535v3.596L19.197 15zM11 8.465V4.869L4.803 9L7.5 10.798zM4.803 15L11 19.131v-3.596l-3.5-2.333zm.894-3L4 10.868v2.264zM2 9a1 1 0 0 1 .445-.832l9-6a1 1 0 0 1 1.11 0l9 6A1 1 0 0 1 22 9v6a1 1 0 0 1-.445.832l-9 6a1 1 0 0 1-1.11 0l-9-6A1 1 0 0 1 2 15z"/>',
    },
    "codepen-line": {
      body: '<path fill="currentColor" d="M16.5 13.202L13 15.535v3.596L19.197 15zM14.697 12L12 10.202L9.303 12L12 13.798zM20 10.868L18.303 12L20 13.132zM19.197 9L13 4.869v3.596l3.5 2.333zM7.5 10.798L11 8.465V4.869L4.803 9zM4.803 15L11 19.131v-3.596l-3.5-2.333zM4 13.132L5.697 12L4 10.868zM2 9a1 1 0 0 1 .445-.832l9-6a1 1 0 0 1 1.11 0l9 6A1 1 0 0 1 22 9v6a1 1 0 0 1-.445.832l-9 6a1 1 0 0 1-1.11 0l-9-6A1 1 0 0 1 2 15z"/>',
    },
    "coin-fill": {
      body: '<path fill="currentColor" d="M23.005 12.003v2c0 3.314-4.925 6-11 6c-5.967 0-10.824-2.591-10.995-5.823l-.005-.177v-2c0 3.313 4.925 6 11 6s11-2.687 11-6m-11-8c6.075 0 11 2.686 11 6s-4.925 6-11 6s-11-2.687-11-6s4.925-6 11-6"/>',
    },
    "coin-line": {
      body: '<path fill="currentColor" d="M12.005 4.003c6.075 0 11 2.686 11 6v4c0 3.314-4.925 6-11 6c-5.967 0-10.824-2.591-10.995-5.823l-.005-.177v-4c0-3.314 4.925-6 11-6m0 12c-3.72 0-7.01-1.008-9-2.55v.55c0 1.882 3.883 4 9 4c5.01 0 8.838-2.03 8.995-3.882l.005-.118l.001-.55c-1.99 1.542-5.28 2.55-9.001 2.55m0-10c-5.117 0-9 2.118-9 4s3.883 4 9 4s9-2.118 9-4s-3.883-4-9-4"/>',
    },
    "coins-fill": {
      body: '<path fill="currentColor" d="M14.005 2.003a8 8 0 0 1 3.292 15.293A8 8 0 1 1 6.711 6.71a8 8 0 0 1 7.294-4.707m-3 7h-2v1a2.5 2.5 0 0 0-.164 4.994l.164.006h2l.09.008a.5.5 0 0 1 0 .984l-.09.008h-4v2h2v1h2v-1a2.5 2.5 0 0 0 .164-4.995l-.164-.005h-2l-.09-.008a.5.5 0 0 1 0-.984l.09-.008h4v-2h-2zm3-5A6 6 0 0 0 9.52 6.016a8 8 0 0 1 8.47 8.471a6 6 0 0 0-3.986-10.484"/>',
    },
    "coins-line": {
      body: '<path fill="currentColor" d="M14.005 2.003a8 8 0 0 1 3.292 15.293A8 8 0 1 1 6.711 6.71a8 8 0 0 1 7.294-4.707m-4 6a6 6 0 1 0 0 12a6 6 0 0 0 0-12m1 1v1h2v2h-4a.5.5 0 0 0-.09.992l.09.008h2a2.5 2.5 0 0 1 0 5v1h-2v-1h-2v-2h4a.5.5 0 0 0 .09-.992l-.09-.008h-2a2.5 2.5 0 1 1 0-5v-1zm3-5A6 6 0 0 0 9.52 6.016a8 8 0 0 1 8.47 8.471a6 6 0 0 0-3.986-10.484"/>',
    },
    "collage-fill": {
      body: '<path fill="currentColor" d="m11.189 13.264l1.383 7.842H4a1 1 0 0 1-1-1V14.71zM20 3.107a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1l-5.398-.001l-3.174-18zM9.398 3.106l1.444 8.188L3 12.679V4.107a1 1 0 0 1 1-1z"/>',
    },
    "collage-line": {
      body: '<path fill="currentColor" d="M20 3.107a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1zm-8.811 10.158L5 14.355v4.752h7.218zM19 5.107h-7.219l2.468 14H19zm-9.25 0H5v7.218l5.842-1.03z"/>',
    },
    "collapse-diagonal-2-fill": {
      body: '<path fill="currentColor" d="M3.5 11H11V3.5L7.957 6.543l-3.25-3.25l-1.414 1.414l3.25 3.25zm17 2H13v7.5l3.043-3.043l3.25 3.25l1.414-1.414l-3.25-3.25z"/>',
    },
    "collapse-diagonal-2-line": {
      body: '<path fill="currentColor" d="M9 4h2v7H4V9h3.586L3.293 4.707l1.414-1.414L9 7.586zm11 11h-3.586l4.293 4.293l-1.414 1.414L15 16.414V20h-2v-7h7z"/>',
    },
    "collapse-diagonal-fill": {
      body: '<path fill="currentColor" d="M20.5 11H13V3.5l3.043 3.043l3.25-3.25l1.414 1.414l-3.25 3.25zm-17 2H11v7.5l-3.043-3.043l-3.25 3.25l-1.414-1.414l3.25-3.25z"/>',
    },
    "collapse-diagonal-line": {
      body: '<path fill="currentColor" d="M15 4h-2v7h7V9h-3.586l4.293-4.293l-1.414-1.414L15 7.586zM4 15h3.586l-4.293 4.293l1.414 1.414L9 16.414V20h2v-7H4z"/>',
    },
    "collapse-horizontal-fill": {
      body: '<path fill="currentColor" d="m13.5 12l4.95-4.95l-.001 3.95H23v2h-4.552v3.947zM1 13h4.55v3.95L10.5 12L5.55 7.05V11H1z"/>',
    },
    "collapse-horizontal-line": {
      body: '<path fill="currentColor" d="m13.5 12l4.95-4.95l1.414 1.414L17.328 11H23v2h-5.672l2.534 2.533l-1.415 1.414zM1 13h5.67l-2.534 2.535l1.414 1.414L10.5 12L5.55 7.05L4.136 8.465L6.672 11H1z"/>',
    },
    "collapse-vertical-fill": {
      body: '<path fill="currentColor" d="m12 13.5l4.95 4.95l-3.95-.002V23h-2v-4.552l-3.948-.001zM11 1v4.55H7.05L12 10.5l4.95-4.95H13V1z"/>',
    },
    "collapse-vertical-line": {
      body: '<path fill="currentColor" d="m12 13.5l4.95 4.95l-1.415 1.413l-2.536-2.535V23h-2v-5.672L8.467 19.86l-1.414-1.414zM11 1v5.67L8.465 4.135L7.05 5.55L12 10.5l4.95-4.95l-1.414-1.414L13 6.672V1z"/>',
    },
    "color-filter-fill": {
      body: '<path fill="currentColor" d="M16.572 8.027a5 5 0 1 0-5.101 2.945a7 7 0 0 1 5.1-2.945m-3.418 9.92a7 7 0 0 0 0-5.892a5 5 0 1 1 0 5.89m-6.88-7.92a7 7 0 0 0 5.1 2.946a5 5 0 1 1-5.1-2.946"/>',
    },
    "color-filter-line": {
      body: '<path fill="currentColor" d="M12 3a4 4 0 0 1 3.696 5.533a6 6 0 0 0-4.216 2.434A4 4 0 0 1 8 7a4 4 0 0 1 4-4m5.764 5.672a6 6 0 1 0-11.527 0A6 6 0 1 0 12 18.655a6 6 0 1 0 5.764-9.983m-4.61 8.262a6 6 0 0 0 0-4.867a4.001 4.001 0 1 1 0 4.867m-1.79-3.967a4.001 4.001 0 1 1-4.214-2.434a6 6 0 0 0 4.215 2.434"/>',
    },
    "command-fill": {
      body: '<path fill="currentColor" d="M10 8h4V6.5a3.5 3.5 0 1 1 3.5 3.5H16v4h1.5a3.5 3.5 0 1 1-3.5 3.5V16h-4v1.5A3.5 3.5 0 1 1 6.5 14H8v-4H6.5A3.5 3.5 0 1 1 10 6.5zM8 8V6.5A1.5 1.5 0 1 0 6.5 8zm0 8H6.5A1.5 1.5 0 1 0 8 17.5zm8-8h1.5A1.5 1.5 0 1 0 16 6.5zm0 8v1.5a1.5 1.5 0 1 0 1.5-1.5zm-6-6v4h4v-4z"/>',
    },
    "command-line": {
      body: '<path fill="currentColor" d="M10 8h4V6.5a3.5 3.5 0 1 1 3.5 3.5H16v4h1.5a3.5 3.5 0 1 1-3.5 3.5V16h-4v1.5A3.5 3.5 0 1 1 6.5 14H8v-4H6.5A3.5 3.5 0 1 1 10 6.5zM8 8V6.5A1.5 1.5 0 1 0 6.5 8zm0 8H6.5A1.5 1.5 0 1 0 8 17.5zm8-8h1.5A1.5 1.5 0 1 0 16 6.5zm0 8v1.5a1.5 1.5 0 1 0 1.5-1.5zm-6-6v4h4v-4z"/>',
    },
    "community-fill": {
      body: '<path fill="currentColor" d="M9 19h3v-6.058L8 9.454l-4 3.488V19h3v-4h2zm12 2H3a1 1 0 0 1-1-1v-7.513a1 1 0 0 1 .343-.754L6 8.544V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1m-5-10v2h2v-2zm0 4v2h2v-2zm0-8v2h2V7zm-4 0v2h2V7z"/>',
    },
    "community-line": {
      body: '<path fill="currentColor" d="M21 21H3a1 1 0 0 1-1-1v-7.513a1 1 0 0 1 .343-.754L6 8.544V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1M9 19h3v-6.058L8 9.454l-4 3.488V19h3v-4h2zm5 0h6V5H8v2.127c.234 0 .469.082.657.247l5 4.359a1 1 0 0 1 .343.754zm2-8h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm-4 0h2v2h-2z"/>',
    },
    "compass-2-fill": {
      body: '<path fill="currentColor" d="M18.328 4.258L10.586 12L12 13.414l7.742-7.742A9.96 9.96 0 0 1 22 12c0 5.52-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2c2.4 0 4.604.847 6.328 2.258"/>',
    },
    "compass-2-line": {
      body: '<path fill="currentColor" d="m16.625 3.133l-1.5 1.5A8 8 0 0 0 12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8a8 8 0 0 0-.633-3.125l1.5-1.5A9.95 9.95 0 0 1 22 12c0 5.52-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2c1.668 0 3.242.41 4.625 1.133m1.739 1.089l1.414 1.414L12 13.414L10.586 12z"/>',
    },
    "compass-3-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m4.5-14.5L10 10l-2.5 6.5L14 14zM12 13a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "compass-3-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m4.5-12.5L14 14l-6.5 2.5L10 10zM12 13a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "compass-4-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m3.446-12.032a4 4 0 0 0-1.414-1.414l-5.478 5.478a4 4 0 0 0 1.414 1.414z"/>',
    },
    "compass-4-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m3.446-10.032l-5.478 5.478a4 4 0 0 1-1.414-1.414l5.478-5.478a4 4 0 0 1 1.414 1.414"/>',
    },
    "compass-discover-fill": {
      body: '<path fill="currentColor" d="M13 22C7.477 22 3 17.523 3 12S7.477 2 13 2s10 4.477 10 10s-4.477 10-10 10M8 11.5l4 1.5l1.5 4.002L17 8z"/>',
    },
    "compass-discover-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-8.5L16 8l-3.5 9.002L11 13z"/>',
    },
    "compass-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m3.5-13.5l-5 2l-2 5l5-2z"/>',
    },
    "compass-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m3.5-11.5l-2 5l-5 2l2-5z"/>',
    },
    "compasses-2-fill": {
      body: '<path fill="currentColor" d="M16.33 13.497a6.99 6.99 0 0 0 2.67-5.5h2a8.99 8.99 0 0 1-3.661 7.246l2.527 4.378a2 2 0 0 1-.732 2.732l-3.527-6.108a9 9 0 0 1-3.607.752a9 9 0 0 1-3.607-.752l-3.527 6.108a2 2 0 0 1-.732-2.732l5.064-8.77A4.002 4.002 0 0 1 11 4.123V1.997h2v2.126a4.002 4.002 0 0 1 1.803 6.728zm-1.73 1.001l-1.528-2.646a4 4 0 0 1-2.142 0l-1.528 2.646a7 7 0 0 0 2.599.499a7 7 0 0 0 2.599-.499M12 8.997a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "compasses-2-line": {
      body: '<path fill="currentColor" d="M16.33 13.497a6.99 6.99 0 0 0 2.67-5.5h2a8.99 8.99 0 0 1-3.661 7.246l2.527 4.378a2 2 0 0 1-.732 2.732l-3.527-6.108a9 9 0 0 1-3.607.752a9 9 0 0 1-3.607-.752l-3.527 6.108a2 2 0 0 1-.732-2.732l5.064-8.77A4.002 4.002 0 0 1 11 4.123V1.997h2v2.126a4.002 4.002 0 0 1 1.803 6.728zm-1.73 1.001l-1.528-2.646a4 4 0 0 1-2.142 0l-1.528 2.646a7 7 0 0 0 2.599.499a7 7 0 0 0 2.599-.499M12 9.997a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "compasses-fill": {
      body: '<path fill="currentColor" d="M11 4.123V1.997h2v2.126a4.002 4.002 0 0 1 1.802 6.728l6.064 10.502l-1.732 1l-6.063-10.501a4 4 0 0 1-2.142 0L4.866 22.353l-1.732-1l6.063-10.502A4.002 4.002 0 0 1 11 4.123m1 4.874a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "compasses-line": {
      body: '<path fill="currentColor" d="M11 4.123V1.997h2v2.126a4.002 4.002 0 0 1 1.802 6.728l6.064 10.502l-1.732 1l-6.063-10.501a4 4 0 0 1-2.142 0L4.866 22.353l-1.732-1l6.063-10.502A4.002 4.002 0 0 1 11 4.123m1 5.874a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "computer-fill": {
      body: '<path fill="currentColor" d="M13 18v2h4v2H7v-2h4v-2H2.992A1 1 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008z"/>',
    },
    "computer-line": {
      body: '<path fill="currentColor" d="M4 16h16V5H4zm9 2v2h4v2H7v-2h4v-2H2.992A1 1 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008z"/>',
    },
    "contacts-book-2-fill": {
      body: '<path fill="currentColor" d="M20 22H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2v-2H6a1 1 0 1 0 0 2zm-7-10a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-3 4h6a3 3 0 1 0-6 0"/>',
    },
    "contacts-book-2-line": {
      body: '<path fill="currentColor" d="M20 22H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2v-2H6a1 1 0 1 0 0 2zM5 16.17c.313-.11.65-.17 1-.17h13V4H6a1 1 0 0 0-1 1zM12 10a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-3 4a3 3 0 1 1 6 0z"/>',
    },
    "contacts-book-3-fill": {
      body: '<path fill="currentColor" d="M4 2a1 1 0 0 0-1 1v2h2v2H2v2h3v2H2v2h3v2H2v2h3v2H3v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm5 14a3 3 0 1 1 6 0zm3-4a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "contacts-book-3-line": {
      body: '<path fill="currentColor" d="M4 2a1 1 0 0 0-1 1v2h2V4h14v16H5v-1H3v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm5 14a3 3 0 1 1 6 0zm3-4a2 2 0 1 1 0-4a2 2 0 0 1 0 4M6 9V7H2v2zm0 2v2H2v-2zm0 6v-2H2v2z"/>',
    },
    "contacts-book-fill": {
      body: '<path fill="currentColor" d="M7 2v20H3V2zm2 0h10.005C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H9zm13 4h2v4h-2zm0 6h2v4h-2zm-7 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-3 4h6a3 3 0 1 0-6 0"/>',
    },
    "contacts-book-line": {
      body: '<path fill="currentColor" d="M3 2h16.005C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H3zm4 2H5v16h2zm2 16h10V4H9zm2-4a3 3 0 1 1 6 0zm3-4a2 2 0 1 1 0-4a2 2 0 0 1 0 4m8-6h2v4h-2zm0 6h2v4h-2z"/>',
    },
    "contacts-book-upload-fill": {
      body: '<path fill="currentColor" d="M7 2v20H3V2zm12.005 0C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H9V2zM15 8l-4 4h3v4h2v-4h3zm9 4v4h-2v-4zm0-6v4h-2V6z"/>',
    },
    "contacts-book-upload-line": {
      body: '<path fill="currentColor" d="M19.005 2C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H3V2zM7 4H5v16h2zm12 0H9v16h10zm-5 4l4 4h-3v4h-2v-4h-3zm10 4v4h-2v-4zm0-6v4h-2V6z"/>',
    },
    "contacts-fill": {
      body: '<path fill="currentColor" d="M2 22a8 8 0 1 1 16 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m10 4h4v2h-4zm-3-5h7v2h-7zm2-5h5v2h-5z"/>',
    },
    "contacts-line": {
      body: '<path fill="currentColor" d="M19 7h5v2h-5zm-2 5h7v2h-7zm3 5h4v2h-4zM2 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4"/>',
    },
    "contract-fill": {
      body: '<path fill="currentColor" d="M16 2H4a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h8.255A7 7 0 0 1 21 11.674V7zm-2.214 13.327c.039-.727.6-1.319 1.324-1.396l.87-.092a.5.5 0 0 0 .279-.124l.651-.585a1.48 1.48 0 0 1 1.923-.05l.682.55c.08.065.18.103.284.109l.874.047c.727.039 1.319.6 1.396 1.324l.092.87a.5.5 0 0 0 .124.279l.585.651c.487.542.508 1.357.05 1.923l-.55.682a.5.5 0 0 0-.109.284l-.047.874a1.48 1.48 0 0 1-1.324 1.396l-.87.092a.5.5 0 0 0-.279.124l-.651.585a1.48 1.48 0 0 1-1.923.05l-.682-.55a.5.5 0 0 0-.284-.109l-.874-.047a1.48 1.48 0 0 1-1.396-1.324l-.092-.87a.5.5 0 0 0-.124-.279l-.585-.651a1.48 1.48 0 0 1-.05-1.923l.55-.682a.5.5 0 0 0 .109-.284zm7.244 1.703l-1.06-1.06l-2.47 2.47l-1.47-1.47l-1.06 1.06l2 2l.53.53l.53-.53z"/>',
    },
    "contract-left-fill": {
      body: '<path fill="currentColor" d="M15 5v6h6v2h-6v6l-7-7zM4 19V5h2v14z"/>',
    },
    "contract-left-line": {
      body: '<path fill="currentColor" d="m15.071 4.929l1.414 1.414L11.83 11H21v2h-9.17l4.656 4.657l-1.414 1.414L8.001 12zm-11.07 14.07V5h2v14z"/>',
    },
    "contract-left-right-fill": {
      body: '<path fill="currentColor" d="m5 18l6-6l-6-6zM19 6l-6 6l6 6z"/>',
    },
    "contract-left-right-line": {
      body: '<path fill="currentColor" d="M18.793 5.793L12.586 12l6.207 6.207l1.414-1.414L15.414 12l4.793-4.793zM5.207 18.207L11.414 12L5.207 5.793L3.793 7.207L8.586 12l-4.793 4.793z"/>',
    },
    "contract-line": {
      body: '<path fill="currentColor" d="M21 8v4h-2V9h-5V4H5v16h6v2H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995zm-7.214 7.327c.039-.727.6-1.319 1.324-1.396l.87-.092a.5.5 0 0 0 .279-.124l.651-.585a1.48 1.48 0 0 1 1.923-.05l.682.55c.08.065.18.103.284.109l.874.047c.727.039 1.319.6 1.396 1.324l.092.87a.5.5 0 0 0 .124.279l.585.651c.487.542.508 1.357.05 1.923l-.55.682a.5.5 0 0 0-.109.284l-.047.874a1.48 1.48 0 0 1-1.324 1.396l-.87.092a.5.5 0 0 0-.279.124l-.651.585a1.48 1.48 0 0 1-1.923.05l-.682-.55a.5.5 0 0 0-.284-.109l-.874-.047a1.48 1.48 0 0 1-1.396-1.324l-.092-.87a.5.5 0 0 0-.124-.279l-.585-.651a1.48 1.48 0 0 1-.05-1.923l.55-.682a.5.5 0 0 0 .109-.284zm7.244 1.703l-1.06-1.06l-2.47 2.47l-1.47-1.47l-1.06 1.06l2.53 2.53z"/>',
    },
    "contract-right-fill": {
      body: '<path fill="currentColor" d="m9 5l7 7l-7 7v-6H3v-2h6zm9 14V5h2v14z"/>',
    },
    "contract-right-line": {
      body: '<path fill="currentColor" d="M12.172 11L7.515 6.343L8.929 4.93l7.07 7.07l-7.07 7.071l-1.414-1.414L12.17 13H3v-2zM18 19V5h2v14z"/>',
    },
    "contract-up-down-fill": {
      body: '<path fill="currentColor" d="m18 5l-6 6l-6-6zm0 14l-6-6l-6 6z"/>',
    },
    "contract-up-down-line": {
      body: '<path fill="currentColor" d="M5.793 5.207L12 11.414l6.207-6.207l-1.414-1.414L12 8.586L7.207 3.793zm12.414 13.586L12 12.586l-6.207 6.207l1.414 1.414L12 15.414l4.793 4.793z"/>',
    },
    "contrast-2-fill": {
      body: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-6.671-5.575A8 8 0 1 0 16.425 5.325a9 9 0 0 1-2.304 8.793a9 9 0 0 1-8.792 2.304"/>',
    },
    "contrast-2-line": {
      body: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-4.681a8.97 8.97 0 0 0 5.707-2.612a8.97 8.97 0 0 0 2.612-5.707q.49.326.924.757A6 6 0 1 1 7 15.316"/>',
    },
    "contrast-drop-2-fill": {
      body: '<path fill="currentColor" d="M5.636 6.633L12 .269l6.364 6.364a9 9 0 1 1-12.728 0M12 3.097l-4.95 4.95A6.98 6.98 0 0 0 5 12.997h14a6.98 6.98 0 0 0-2.05-4.95z"/>',
    },
    "contrast-drop-2-line": {
      body: '<path fill="currentColor" d="m12 3.097l-4.95 4.95a7 7 0 1 0 9.9 0zM12 .27l6.364 6.364a9 9 0 1 1-12.728 0zM7 12.997h10a5 5 0 1 1-10 0"/>',
    },
    "contrast-drop-fill": {
      body: '<path fill="currentColor" d="m12 .269l6.364 6.364a9 9 0 1 1-12.728 0zm0 2.828l-4.95 4.95a7 7 0 0 0 4.954 11.95z"/>',
    },
    "contrast-drop-line": {
      body: '<path fill="currentColor" d="m12 3.097l-4.95 4.95a7 7 0 1 0 9.9 0zM12 .27l6.364 6.364a9 9 0 1 1-12.728 0zm0 17.728v-10a5 5 0 1 1 0 10"/>',
    },
    "contrast-fill": {
      body: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2v-16a8 8 0 0 0 0 16"/>',
    },
    "contrast-line": {
      body: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-2v-12a6 6 0 0 1 0 12"/>',
    },
    "copilot-fill": {
      body: '<path fill="currentColor" d="M8.662 14.484a1.001 1.001 0 1 1 2.003 0v1.997a1.001 1.001 0 1 1-2.003 0zm6.675 0a1.001 1.001 0 1 0-2.003 0v1.997a1.001 1.001 0 1 0 2.003 0zM11.999 4.028c-.845-1.219-2.598-1.31-3.945-1.188c-1.543.154-2.843.685-3.574 1.464c-1.268 1.386-1.326 4.291-.715 5.89c-.061.274-.12.551-.162.845c-1.13.297-2.283 1.898-2.283 3.043v2.162c0 .6.28 1.148.775 1.522C4.919 19.864 8.439 21.49 12 21.49s7.08-1.626 9.904-3.724a1.89 1.89 0 0 0 .775-1.521v-2.163c0-1.145-1.153-2.746-2.283-3.043c-.042-.294-.1-.57-.162-.844c.611-1.6.552-4.505-.715-5.89c-.731-.78-2.03-1.31-3.574-1.465c-1.347-.121-3.1-.03-3.946 1.188m6.675 13.46c-1.535.854-4.085 2-6.674 2s-5.14-1.146-6.675-2v-5.799c2.477.96 5.327.465 6.673-1.758H12c1.346 2.223 4.196 2.717 6.673 1.758zm-8.01-10.66c0 1.586-.48 3.312-2.67 3.312s-2.606-.524-2.606-1.997c0-2.336.356-3.336 3.316-3.336c1.71 0 1.96.55 1.96 2.022m2.67 0c0-1.472.25-2.02 1.961-2.02c2.96 0 3.316 1 3.316 3.335c0 1.473-.417 1.997-2.607 1.997s-2.67-1.726-2.67-3.311"/>',
    },
    "copilot-line": {
      body: '<path fill="currentColor" d="M5.4 7.8c0-2.088 1.178-3 3.172-3c1.196 0 2.129.264 2.129 1.6c0 1.814-.575 3.75-2.7 3.75c-1.229 0-1.798-.176-2.09-.424c-.247-.21-.51-.67-.51-1.926m3.172-5C5.497 2.8 3.4 4.626 3.4 7.8c0 .999.137 1.89.53 2.605l-.183.364a6.3 6.3 0 0 0-1.425 1.107c-1.061 1.126-.973 2.389-.973 3.824c0 2.267 2.512 3.62 4.315 4.373c2.133.89 4.677 1.427 6.336 1.427c1.658 0 4.202-.537 6.335-1.427c1.803-.753 4.315-2.106 4.315-4.373c0-1.435.088-2.698-.973-3.824a6.3 6.3 0 0 0-1.425-1.107l-.182-.364c.392-.716.53-1.606.53-2.605c0-3.174-2.097-5-5.172-5c-1.24 0-2.618.259-3.428 1.283C11.19 3.059 9.813 2.8 8.57 2.8M8 12.15c1.692 0 3.224-.815 4-2.334c.775 1.519 2.307 2.334 4 2.334c.894 0 1.769-.074 2.517-.38c.511.596 1.17.911 1.705 1.478c.639.678.428 1.585.428 2.452c0 1.272-2.166 2.143-3.086 2.527c-1.942.81-4.223 1.273-5.565 1.273c-1.341 0-3.623-.463-5.565-1.273c-.919-.384-3.085-1.255-3.085-2.527c0-.867-.21-1.774.428-2.452c.56-.594 1.341-.75 1.705-1.478c.748.306 1.623.38 2.518.38m5.3-5.75c0-1.336.932-1.6 2.128-1.6c1.994 0 3.172.912 3.172 3c0 1.257-.264 1.715-.511 1.926c-.292.248-.861.424-2.09.424c-2.125 0-2.7-1.936-2.7-3.75m-4.638 8.084a1.001 1.001 0 1 1 2.002 0v1.997a1.001 1.001 0 1 1-2.002 0zm6.675 0a1.001 1.001 0 1 0-2.003 0v1.997a1.001 1.001 0 1 0 2.003 0z"/>',
    },
    "copper-coin-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-14.243l-4.243 4.243l4.243 4.242l4.242-4.242z"/>',
    },
    "copper-coin-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-12.95l4.95 4.95l-4.95 4.95l-4.95-4.95zm0 2.828l-2.121 2.122l2.12 2.121l2.122-2.121z"/>',
    },
    "copper-diamond-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-2.5-13l-2.5 2.5l5 5l5-5l-2.5-2.5z"/>',
    },
    "copper-diamond-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3-12h6l2.5 3.5l-5.5 5.5l-5.5-5.5zm1.03 2l-.92 1.29l2.89 2.89l2.89-2.89l-.92-1.29z"/>',
    },
    "copyleft-fill": {
      body: '<path fill="currentColor" d="M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10s-4.48 10-10 10m0-5c2.76 0 5-2.24 5-5a5.002 5.002 0 0 0-9.288-2.572l1.715 1.028A3 3 0 1 1 12 15a3 3 0 0 1-2.574-1.457l-1.714 1.03A5 5 0 0 0 12 17"/>',
    },
    "copyleft-line": {
      body: '<path fill="currentColor" d="M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10s-4.48 10-10 10m0-2c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m0-3a5 5 0 0 1-4.288-2.428l1.714-1.029A3 3 0 1 0 12 9a3 3 0 0 0-2.573 1.456L7.712 9.428A4.999 4.999 0 0 1 17 12c0 2.76-2.24 5-5 5"/>',
    },
    "copyright-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 5c-2.76 0-5 2.24-5 5s2.24 5 5 5a5 5 0 0 0 4.288-2.428l-1.715-1.028A3 3 0 1 1 12 9c1.093 0 2.05.584 2.573 1.457l1.715-1.03A5 5 0 0 0 12 7"/>',
    },
    "copyright-line": {
      body: '<path fill="currentColor" d="M16.288 9.428A4.999 4.999 0 0 0 7 12a4.999 4.999 0 0 0 9.288 2.572l-1.715-1.028A3 3 0 1 1 12 9c1.093 0 2.05.584 2.573 1.457zM22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10s10-4.48 10-10M4 12c0-4.42 3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8s-8-3.58-8-8"/>',
    },
    "coreos-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-3.671-9.696c-.04.85.037 1.697.118 2.544c.005.06.027.074.08.08c.406.054.813.102 1.222.127c.964.061 1.928.139 2.896.085c.55-.03 1.1-.048 1.648-.095a21 21 0 0 0 2.33-.312c.958-.194 1.907-.425 2.8-.845c.406-.19.79-.415 1.114-.736c.238-.235.408-.507.41-.86a9 9 0 0 0-.045-.94a9 9 0 0 0-.482-2.18c-.583-1.618-1.509-2.989-2.825-4.07a8.9 8.9 0 0 0-3.851-1.863c-.5-.105-1.006-.144-1.514-.18c-.573-.041-1.064.12-1.488.514c-.495.457-.837 1.025-1.122 1.633c-.667 1.427-.973 2.954-1.166 4.508c-.106.857-.166 1.721-.125 2.59m3.57-5.03c.959.03 1.77.324 2.494.856a4.33 4.33 0 0 1 1.714 2.612c.068.304.097.612.103.922c.005.209-.11.362-.262.49c-.307.258-.67.401-1.05.508a10.3 10.3 0 0 1-2.265.366c-.5.026-1 .035-1.5.01c-.192-.01-.384-.024-.577-.032c-.06-.002-.08-.02-.083-.081c-.024-.434-.058-.868-.051-1.302c.016-1.026.094-2.045.397-3.034c.1-.329.223-.65.42-.936c.173-.25.378-.437.66-.38"/>',
    },
    "coreos-line": {
      body: '<path fill="currentColor" d="M9.454 4.414a8 8 0 1 0 10.202 9.91q-5.1 2.189-11.545 1.565Q7.044 9.702 9.454 4.414M11.902 4a16.8 16.8 0 0 0-1.541 3.768a5.98 5.98 0 0 1 4.114 1.756a5.98 5.98 0 0 1 1.745 3.861q1.994-.513 3.78-1.433A7.994 7.994 0 0 0 11.902 4M4.93 19.07c-3.905-3.905-3.905-10.237 0-14.142s10.237-3.905 14.142 0s3.905 10.237 0 14.142s-10.237 3.905-14.142 0m5.02-9.293a18 18 0 0 0-.076 4.229a23 23 0 0 0 4.36-.219a4 4 0 0 0-1.172-2.849A4 4 0 0 0 9.95 9.777"/>',
    },
    "corner-down-left-fill": {
      body: '<path fill="currentColor" d="M19 14V5h-2v7H9.414V6.586L3 13l6.414 6.414V14z"/>',
    },
    "corner-down-left-line": {
      body: '<path fill="currentColor" d="M19 14V5h-2v7H6.828l3.95-3.95l-1.414-1.414L3 13l6.364 6.364l1.414-1.414L6.828 14z"/>',
    },
    "corner-down-right-fill": {
      body: '<path fill="currentColor" d="M5 14V5h2v7h7.586V6.586L21 13l-6.414 6.414V14z"/>',
    },
    "corner-down-right-line": {
      body: '<path fill="currentColor" d="M5 14V5h2v7h10.172l-3.95-3.95l1.414-1.414L21 13l-6.364 6.364l-1.414-1.414l3.95-3.95z"/>',
    },
    "corner-left-down-fill": {
      body: '<path fill="currentColor" d="M10 5h9v2h-7v7.586h5.414L11 21l-6.414-6.414H10z"/>',
    },
    "corner-left-down-line": {
      body: '<path fill="currentColor" d="M10 5h9v2h-7v10.172l3.95-3.95l1.414 1.414L11 21l-6.364-6.364l1.414-1.414l3.95 3.95z"/>',
    },
    "corner-left-up-fill": {
      body: '<path fill="currentColor" d="M10 19h9v-2h-7V9.414h5.414L11 3L4.586 9.414H10z"/>',
    },
    "corner-left-up-line": {
      body: '<path fill="currentColor" d="M10 19h9v-2h-7V6.828l3.95 3.95l1.414-1.414L11 3L4.636 9.364l1.414 1.414L10 6.828z"/>',
    },
    "corner-right-down-fill": {
      body: '<path fill="currentColor" d="M14 5H5v2h7v7.586H6.586L13 21l6.414-6.414H14z"/>',
    },
    "corner-right-down-line": {
      body: '<path fill="currentColor" d="M14 5H5v2h7v10.172l-3.95-3.95l-1.414 1.414L13 21l6.364-6.364l-1.414-1.414l-3.95 3.95z"/>',
    },
    "corner-right-up-fill": {
      body: '<path fill="currentColor" d="M14 19H5v-2h7V9.414H6.586L13 3l6.414 6.414H14z"/>',
    },
    "corner-right-up-line": {
      body: '<path fill="currentColor" d="M14 19H5v-2h7V6.828l-3.95 3.95l-1.414-1.414L13 3l6.364 6.364l-1.414 1.414L14 6.828z"/>',
    },
    "corner-up-left-double-fill": {
      body: '<path fill="currentColor" d="M20 19v-9h-5.586V4.586L8 11l6.414 6.414V12H18v7zM10.164 6.05L8.75 4.636L2.386 11l6.363 6.364l1.415-1.414L5.214 11z"/>',
    },
    "corner-up-left-double-line": {
      body: '<path fill="currentColor" d="M20 10v9h-2v-7h-6.172l3.95 3.95l-1.414 1.414L8 11l6.364-6.364l1.414 1.414l-3.95 3.95zM8.75 4.636l1.414 1.414L5.214 11l4.95 4.95l-1.414 1.414L2.386 11z"/>',
    },
    "corner-up-left-fill": {
      body: '<path fill="currentColor" d="M19 10v9h-2v-7H9.414v5.414L3 11l6.414-6.414V10z"/>',
    },
    "corner-up-left-line": {
      body: '<path fill="currentColor" d="M19 10v9h-2v-7H6.828l3.95 3.95l-1.414 1.414L3 11l6.364-6.364l1.414 1.414L6.828 10z"/>',
    },
    "corner-up-right-double-fill": {
      body: '<path fill="currentColor" d="M4 19v-9h5.586V4.586L16 11l-6.414 6.414V12H6v7zm9.836-12.95l1.415-1.414L21.614 11l-6.363 6.364l-1.415-1.414l4.95-4.95z"/>',
    },
    "corner-up-right-double-line": {
      body: '<path fill="currentColor" d="M4 10v9h2v-7h6.172l-3.95 3.95l1.414 1.414L16 11L9.636 4.636L8.222 6.05l3.95 3.95zm11.25-5.364L13.836 6.05l4.95 4.95l-4.95 4.95l1.414 1.414L21.614 11z"/>',
    },
    "corner-up-right-fill": {
      body: '<path fill="currentColor" d="M5 10v9h2v-7h7.586v5.414L21 11l-6.414-6.414V10z"/>',
    },
    "corner-up-right-line": {
      body: '<path fill="currentColor" d="M5 10v9h2v-7h10.172l-3.95 3.95l1.414 1.414L21 11l-6.364-6.364l-1.414 1.414l3.95 3.95z"/>',
    },
    "coupon-2-fill": {
      body: '<path fill="currentColor" d="M14.005 3v18h-11a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1zm2 0h5a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-5z"/>',
    },
    "coupon-2-line": {
      body: '<path fill="currentColor" d="M2.005 9.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5m12-4.5h-10v2.968a4.5 4.5 0 0 1 0 8.064V19h10zm2 0v14h4v-2.968a4.5 4.5 0 0 1 0-8.064V5z"/>',
    },
    "coupon-3-fill": {
      body: '<path fill="currentColor" d="M11.005 21a1.5 1.5 0 1 0-3 0h-5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a1.5 1.5 0 0 0 3 0h10a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1zm-1.5-10.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "coupon-3-line": {
      body: '<path fill="currentColor" d="M2.005 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1zM8.09 19a1.5 1.5 0 0 1 2.83 0h9.085v-2.968a4.5 4.5 0 0 1 0-8.064V5H10.92a1.5 1.5 0 0 1-2.83 0H4.005v14zm1.415-8a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m0 5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "coupon-4-fill": {
      body: '<path fill="currentColor" d="M10.005 21h-7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a2 2 0 1 0 4 0h7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-7a2 2 0 1 0-4 0m-4-13v8h2V8zm10 0v8h2V8z"/>',
    },
    "coupon-4-line": {
      body: '<path fill="currentColor" d="M10.005 21h-7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a2 2 0 1 0 4 0h7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-7a2 2 0 1 0-4 0M8.54 19a4 4 0 0 1 3.465-2c1.48 0 2.773.804 3.465 2h4.535V5H15.47a4 4 0 0 1-3.465 2A4 4 0 0 1 8.54 5H4.005v14zM6.005 8h2v8h-2zm10 0h2v8h-2z"/>',
    },
    "coupon-5-fill": {
      body: '<path fill="currentColor" d="M21.005 14v7a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-7a2 2 0 0 0 0-4V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 1 0 0 4m-12-8v2h6V6zm0 10v2h6v-2z"/>',
    },
    "coupon-5-line": {
      body: '<path fill="currentColor" d="M21.005 14v7a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-7a2 2 0 1 0 0-4V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 1 0 0 4m-2 1.465a4 4 0 0 1-2-3.465c0-1.48.804-2.773 2-3.465V4h-14v4.535a4 4 0 0 1 0 6.93V20h14zM9.005 6h6v2h-6zm0 10h6v2h-6z"/>',
    },
    "coupon-fill": {
      body: '<path fill="currentColor" d="M2.005 9.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5m7-.5v2h6V9zm0 4v2h6v-2z"/>',
    },
    "coupon-line": {
      body: '<path fill="currentColor" d="M2.005 9.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5m2-1.532a4.5 4.5 0 0 1 0 8.064V19h16v-2.968a4.5 4.5 0 0 1 0-8.064V5h-16zm5 1.032h6v2h-6zm0 4h6v2h-6z"/>',
    },
    "cpu-fill": {
      body: '<path fill="currentColor" d="M14 20h-4v2H8v-2H5a1 1 0 0 1-1-1v-3H2v-2h2v-4H2V8h2V5a1 1 0 0 1 1-1h3V2h2v2h4V2h2v2h3a1 1 0 0 1 1 1v3h2v2h-2v4h2v2h-2v3a1 1 0 0 1-1 1h-3v2h-2zM7 7v4h4V7z"/>',
    },
    "cpu-line": {
      body: '<path fill="currentColor" d="M6 18h12V6H6zm8 2h-4v2H8v-2H5a1 1 0 0 1-1-1v-3H2v-2h2v-4H2V8h2V5a1 1 0 0 1 1-1h3V2h2v2h4V2h2v2h3a1 1 0 0 1 1 1v3h2v2h-2v4h2v2h-2v3a1 1 0 0 1-1 1h-3v2h-2zM8 8h8v8H8z"/>',
    },
    "creative-commons-by-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m2 8h-4a1 1 0 0 0-1 1v4h1.5v4h3v-4H15v-4a1 1 0 0 0-1-1m-2-5a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "creative-commons-by-line": {
      body: '<path fill="currentColor" d="M14 7a2 2 0 1 1-4 0a2 2 0 0 1 4 0m1 4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4h1.5v4h3v-4H15zm-3-9C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0a8 8 0 0 1-16 0"/>',
    },
    "creative-commons-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2M9 8c-2.208 0-4 1.792-4 4a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A4 4 0 0 0 9 8m7 0c-2.208 0-4 1.792-4 4a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A4 4 0 0 0 16 8"/>',
    },
    "creative-commons-line": {
      body: '<path fill="currentColor" d="M9 8c1.104 0 2.105.448 2.829 1.173l-1.414 1.413a2 2 0 1 0 0 2.828l1.413 1.414A4.001 4.001 0 0 1 5 12c0-2.208 1.792-4 4-4m9.829 1.173A4.001 4.001 0 0 0 12 12a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 0 16a8 8 0 0 0 0-16"/>',
    },
    "creative-commons-nc-fill": {
      body: '<path fill="currentColor" d="m4.256 5.672l3.58 3.577A2.5 2.5 0 0 0 10 13h3.999l.09.008A.5.5 0 0 1 14 14H8.5v2H11v2h2v-2h1q.273-.001.53-.056l3.798 3.8A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.4.846-4.604 2.256-6.328M12 2c5.523 0 10 4.477 10 10c0 2.4-.846 4.604-2.256 6.328l-3.579-3.577A2.5 2.5 0 0 0 14 11h-4l-.09-.01A.5.5 0 0 1 10 10h5.5V8H13V6h-2v2h-1q-.272.001-.529.056l-3.799-3.8A9.96 9.96 0 0 1 12 2"/>',
    },
    "creative-commons-nc-line": {
      body: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2M7.094 5.68A8 8 0 0 1 18.32 16.905l-2.154-2.154A2.5 2.5 0 0 0 14 11h-4a.5.5 0 0 1 0-1.001h5.5V8H13V6h-2v2h-1q-.273.001-.53.056zM5.68 7.094L7.835 9.25A2.5 2.5 0 0 0 10 13h4a.5.5 0 0 1 0 1.001H8.5v2H11v2h2v-2h1q.273-.001.53-.056l2.376 2.376A8 8 0 0 1 5.68 7.095"/>',
    },
    "creative-commons-nd-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m4 11H8v2h8zm0-4H8v2h8z"/>',
    },
    "creative-commons-nd-line": {
      body: '<path fill="currentColor" d="M8 9h8v2H8zm0 6v-2h8v2zm-6-3C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 0 16a8 8 0 0 0 0-16"/>',
    },
    "creative-commons-sa-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 4c-2.177 0-4.03 1.67-4.716 4H6l2.5 3l2.5-3H9.401C9.92 8.805 10.89 8 12 8c1.657 0 3 1.79 3 4s-1.343 4-3 4c-1.11 0-2.08-.804-2.598-1.999H7.285C7.97 16.33 9.823 18 12 18c2.761 0 5-2.686 5-6s-2.239-6-5-6"/>',
    },
    "creative-commons-sa-line": {
      body: '<path fill="currentColor" d="M17 12c0-3.314-2.238-6-5-6c-2.177 0-4.03 1.67-4.716 4H6l2.5 3l2.5-3H9.401C9.92 8.805 10.89 8 12 8c1.657 0 3 1.79 3 4s-1.343 4-3 4c-1.11 0-2.08-.804-2.598-1.999H7.285C7.97 16.33 9.823 18 12 18c2.762 0 5-2.686 5-6M12 2a9.97 9.97 0 0 0-7.07 2.93A9.97 9.97 0 0 0 2 12a9.97 9.97 0 0 0 2.93 7.07A9.97 9.97 0 0 0 12 22a9.97 9.97 0 0 0 7.07-2.93A9.97 9.97 0 0 0 22 12a9.97 9.97 0 0 0-2.93-7.07A9.97 9.97 0 0 0 12 2M6.344 6.344A7.97 7.97 0 0 1 12 4c2.208 0 4.206.895 5.656 2.344A7.97 7.97 0 0 1 20 12a7.97 7.97 0 0 1-2.344 5.656A7.97 7.97 0 0 1 12 20a7.97 7.97 0 0 1-5.656-2.344A7.97 7.97 0 0 1 4 12c0-2.208.895-4.206 2.344-5.656"/>',
    },
    "creative-commons-zero-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 4c-2.761 0-5 2.686-5 6s2.239 6 5 6s5-2.686 5-6s-2.239-6-5-6m2.325 3.472c.422.69.675 1.57.675 2.528c0 2.21-1.343 4-3 4c-.441 0-.86-.127-1.237-.355zM12 8c.441 0 .86.127 1.237.355l-3.562 6.173C9.253 13.838 9 12.958 9 12c0-2.21 1.343-4 3-4"/>',
    },
    "creative-commons-zero-line": {
      body: '<path fill="currentColor" d="M17 12c0-3.314-2.238-6-5-6s-5 2.686-5 6s2.239 6 5 6s5-2.686 5-6m-6.237 3.645l3.562-6.173c.422.69.675 1.57.675 2.528c0 2.21-1.343 4-3 4c-.441 0-.86-.127-1.237-.355M9 12c0-2.21 1.343-4 3-4c.441 0 .86.127 1.237.355l-3.562 6.173C9.253 13.838 9 12.958 9 12m3-10a9.97 9.97 0 0 0-7.07 2.93A9.97 9.97 0 0 0 2 12a9.97 9.97 0 0 0 2.93 7.07A9.97 9.97 0 0 0 12 22a9.97 9.97 0 0 0 7.07-2.93A9.97 9.97 0 0 0 22 12a9.97 9.97 0 0 0-2.93-7.07A9.97 9.97 0 0 0 12 2M6.344 6.344A7.97 7.97 0 0 1 12 4c2.208 0 4.206.895 5.656 2.344A7.97 7.97 0 0 1 20 12a7.97 7.97 0 0 1-2.344 5.656A7.97 7.97 0 0 1 12 20a7.97 7.97 0 0 1-5.656-2.344A7.97 7.97 0 0 1 4 12c0-2.208.895-4.206 2.344-5.656"/>',
    },
    "criminal-fill": {
      body: '<path fill="currentColor" d="M12 2a9 9 0 0 1 6.894 14.786c1.255.83 2.034 1.89 2.101 3.049L21 20l-9 2l-9-2l.005-.165c.067-1.16.846-2.22 2.1-3.05A8.97 8.97 0 0 1 3 11a9 9 0 0 1 9-9m0 11c-1.38 0-2.5.672-2.5 1.5S10.62 16 12 16s2.5-.672 2.5-1.5S13.38 13 12 13M9 8c-1.105 0-2 .672-2 1.5S7.895 11 9 11s2-.672 2-1.5S10.105 8 9 8m6 0c-1.105 0-2 .672-2 1.5s.895 1.5 2 1.5s2-.672 2-1.5S16.105 8 15 8"/>',
    },
    "criminal-line": {
      body: '<path fill="currentColor" d="M12 2a9 9 0 0 1 6.894 14.786c1.255.83 2.034 1.89 2.101 3.049L21 20l-9 2l-9-2l.005-.165c.067-1.16.846-2.22 2.1-3.05A8.97 8.97 0 0 1 3 11a9 9 0 0 1 9-9m0 2a7 7 0 0 0-7 7c0 1.567.514 3.05 1.445 4.261l.192.239l1.443 1.717l-1.962 1.299l-.137.097L12 19.951l6.018-1.338l-.049-.036l-.178-.123l-1.871-1.237l1.443-1.718A6.96 6.96 0 0 0 19 11a7 7 0 0 0-7-7m0 9c1.38 0 2.5.672 2.5 1.5S13.38 16 12 16s-2.5-.672-2.5-1.5S10.62 13 12 13M9 8c1.105 0 2 .672 2 1.5S10.105 11 9 11s-2-.672-2-1.5S7.895 8 9 8m6 0c1.105 0 2 .672 2 1.5s-.895 1.5-2 1.5s-2-.672-2-1.5s.895-1.5 2-1.5"/>',
    },
    "crop-2-fill": {
      body: '<path fill="currentColor" d="m17.586 5l2.556-2.556l1.414 1.414L19 6.414V17h3v2h-3v3h-2V7H9V5zM15 17v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v15zM9 9h6v6H9z"/>',
    },
    "crop-2-line": {
      body: '<path fill="currentColor" d="M8.414 17H15v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v13.586L15.586 7H9V5h8.586l2.556-2.556l1.414 1.414L19 6.414V17h3v2h-3v3h-2V8.414z"/>',
    },
    "crop-fill": {
      body: '<path fill="currentColor" d="M19 17h3v2h-3v3h-2v-3H6a1 1 0 0 1-1-1V7H2V5h3V2h2v3h11a1 1 0 0 1 1 1z"/>',
    },
    "crop-line": {
      body: '<path fill="currentColor" d="M15 17v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v15zm2 5V7H9V5h9a1 1 0 0 1 1 1v11h3v2h-3v3z"/>',
    },
    "cross-fill": {
      body: '<path fill="currentColor" d="M14 2h-4v6H4v4h6v10h4V12h6V8h-6z"/>',
    },
    "cross-line": {
      body: '<path fill="currentColor" d="M9 2h6v5h5v6h-5v9H9v-9H4V7h5zm2 2v5H6v2h5v9h2v-9h5V9h-5V4z"/>',
    },
    "crosshair-2-fill": {
      body: '<path fill="currentColor" d="M11 5.07A7.005 7.005 0 0 0 5.07 11H7v2H5.07A7 7 0 0 0 11 18.93V17h2v1.93A7 7 0 0 0 18.93 13H17v-2h1.93A7 7 0 0 0 13 5.07V7h-2zM3.055 11A9.004 9.004 0 0 1 11 3.055V1h2v2.055A9.004 9.004 0 0 1 20.945 11H23v2h-2.055A9.004 9.004 0 0 1 13 20.945V23h-2v-2.055A9.004 9.004 0 0 1 3.055 13H1v-2zM15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/>',
    },
    "crosshair-2-line": {
      body: '<path fill="currentColor" d="M11 5.07A7.005 7.005 0 0 0 5.07 11H7v2H5.07A7 7 0 0 0 11 18.93V17h2v1.93A7 7 0 0 0 18.93 13H17v-2h1.93A7 7 0 0 0 13 5.07V7h-2zM3.055 11A9.004 9.004 0 0 1 11 3.055V1h2v2.055A9.004 9.004 0 0 1 20.945 11H23v2h-2.055A9.004 9.004 0 0 1 13 20.945V23h-2v-2.055A9.004 9.004 0 0 1 3.055 13H1v-2zM14 12a2 2 0 1 1-4 0a2 2 0 0 1 4 0"/>',
    },
    "crosshair-fill": {
      body: '<path fill="currentColor" d="M19.938 13A8.004 8.004 0 0 1 13 19.938V17h-2v2.938A8.004 8.004 0 0 1 4.062 13H7v-2H4.062A8.004 8.004 0 0 1 11 4.062V7h2V4.062A8.004 8.004 0 0 1 19.938 11H17v2zM2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m10 3a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "crosshair-line": {
      body: '<path fill="currentColor" d="M13 19.938A8.004 8.004 0 0 0 19.938 13H17v-2h2.938A8.004 8.004 0 0 0 13 4.062V7h-2V4.062A8.004 8.004 0 0 0 4.062 11H7v2H4.062A8.004 8.004 0 0 0 11 19.938V17h2zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-8a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "css3-fill": {
      body: '<path fill="currentColor" d="m5 3l-.65 3.34h13.59L17.5 8.5H3.92l-.66 3.33h13.59l-.76 3.81l-5.48 1.81l-4.75-1.81l.33-1.64H2.85l-.79 4l7.85 3l9.05-3l1.2-6.03l.24-1.21L21.94 3z"/>',
    },
    "css3-line": {
      body: '<path fill="currentColor" d="M2.8 14h2.04l-.545 2.724l5.744 2.155l7.228-2.41L18.36 11H3.4l.4-2h14.96l.8-4H4.6L5 3h17l-3 15l-9 3l-8-3z"/>',
    },
    "cup-fill": {
      body: '<path fill="currentColor" d="M5 3h15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a1 1 0 0 1 1-1m13 2v3h2V5zM2 19h18v2H2z"/>',
    },
    "cup-line": {
      body: '<path fill="currentColor" d="M16 13V5H6v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2M5 3h15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a1 1 0 0 1 1-1m13 2v3h2V5zM2 19h18v2H2z"/>',
    },
    "currency-fill": {
      body: '<path fill="currentColor" d="M17.005 16.003h2v-12h-10v2h8zm0 2v2.999c0 .553-.45 1-1.007 1H4.012a1 1 0 0 1-1.007-1l.002-13.998c0-.553.45-1.001 1.007-1.001h2.99v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm-10-2v2h2v1h2v-1h.5a2.5 2.5 0 1 0 0-5h-3a.5.5 0 1 1 0-1h4.5v-2h-2v-1h-2v1h-.5a2.5 2.5 0 0 0 0 5h3a.5.5 0 0 1 0 1z"/>',
    },
    "currency-line": {
      body: '<path fill="currentColor" d="M17.005 16.003h2v-12h-10v2h8zm0 2v2.999c0 .553-.45 1-1.007 1H4.012a1 1 0 0 1-1.007-1l.002-13.998c0-.553.45-1.001 1.007-1.001h2.99v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm-11.998-10l-.002 12h10v-12zm1.998 8h4.5a.5.5 0 1 0 0-1h-3a2.5 2.5 0 1 1 0-5h.5v-1h2v1h2v2h-4.5a.5.5 0 0 0 0 1h3a2.5 2.5 0 0 1 0 5h-.5v1h-2v-1h-2z"/>',
    },
    "cursor-fill": {
      body: '<path fill="currentColor" d="M13.91 12.36L17 20.854l-2.818 1.026l-3.092-8.494l-4.172 3.156l1.49-14.909l10.726 10.463z"/>',
    },
    "cursor-line": {
      body: '<path fill="currentColor" d="m15.387 13.498l2.553 7.014l-4.698 1.71l-2.553-7.014l-3.899 2.445l1.619-16.02l11.537 11.232zm-.01 5.818l-2.715-7.46l2.96-.41l-5.64-5.49l-.791 7.83l2.531-1.587l2.715 7.46z"/>',
    },
    "customer-service-2-fill": {
      body: '<path fill="currentColor" d="M21 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8 8 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 0 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0zM7.76 15.785l1.06-1.696A5.97 5.97 0 0 0 12 15a5.97 5.97 0 0 0 3.18-.911l1.06 1.696A7.96 7.96 0 0 1 12 17a7.96 7.96 0 0 1-4.24-1.215"/>',
    },
    "customer-service-2-line": {
      body: '<path fill="currentColor" d="M19.938 8H21a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8 8 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 0 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0M3 10v4h1v-4zm17 0v4h1v-4zM7.76 15.785l1.06-1.696A5.97 5.97 0 0 0 12 15a5.97 5.97 0 0 0 3.18-.911l1.06 1.696A7.96 7.96 0 0 1 12 17a7.96 7.96 0 0 1-4.24-1.215"/>',
    },
    "customer-service-fill": {
      body: '<path fill="currentColor" d="M22 17.002a6 6 0 0 1-4.713 5.86l-.638-1.914A4 4 0 0 0 19.465 19H17a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.938a8.001 8.001 0 0 0-15.876 0H7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5C2 6.477 6.477 2 12 2s10 4.477 10 10z"/>',
    },
    "customer-service-line": {
      body: '<path fill="currentColor" d="M22 17.002a6 6 0 0 1-4.713 5.86l-.638-1.914A4 4 0 0 0 19.465 19H17a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.938a8.001 8.001 0 0 0-15.876 0H7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5C2 6.477 6.477 2 12 2s10 4.477 10 10zM20 17v-4h-3v4zM4 13v4h3v-4z"/>',
    },
    "dashboard-2-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 3a7 7 0 0 0-5.106 11.789l.156.16l1.414-1.414a5 5 0 0 1 4.83-8.366l1.564-1.56A7 7 0 0 0 12 5m6.392 4.143l-1.561 1.562a5.01 5.01 0 0 1-1.295 4.83l1.414 1.415A6.98 6.98 0 0 0 19 12a7 7 0 0 0-.608-2.857m-2.15-2.8l-3.725 3.725A2.003 2.003 0 0 0 10 12a2 2 0 1 0 3.932-.517l3.725-3.726z"/>',
    },
    "dashboard-2-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 1c1.018 0 1.985.217 2.858.608L13.295 7.17a5 5 0 0 0-4.83 8.366L7.05 16.95l-.156-.161A7 7 0 0 1 12 5m6.392 4.143c.39.872.608 1.84.608 2.857a6.98 6.98 0 0 1-2.05 4.95l-1.414-1.414a5.01 5.01 0 0 0 1.295-4.83zm-2.15-2.8l1.415 1.414l-3.725 3.726A2.003 2.003 0 0 1 12 14a2 2 0 1 1 .517-3.932z"/>',
    },
    "dashboard-3-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m4.596 5.404a.596.596 0 0 0-.763-.067q-4.334 3.043-4.894 3.602a1.5 1.5 0 0 0 2.122 2.122q.328-.329 3.598-4.897a.59.59 0 0 0-.063-.76M17.5 11a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-11 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2m2.318-3.596a1 1 0 1 0-1.414 1.414a1 1 0 0 0 1.414-1.414M12 5.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "dashboard-3-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m3.833 3.337a.596.596 0 0 1 .763.067a.59.59 0 0 1 .063.76q-3.27 4.569-3.598 4.897a1.5 1.5 0 0 1-2.122-2.122q.56-.56 4.894-3.602M17.5 11a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-11 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2m2.318-3.596a1 1 0 1 1-1.414 1.414a1 1 0 0 1 1.414-1.414M12 5.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2"/>',
    },
    "dashboard-fill": {
      body: '<path fill="currentColor" d="M3 12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm0 8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm10 0a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1zm1-17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"/>',
    },
    "dashboard-horizontal-fill": {
      body: '<path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zM3 14a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>',
    },
    "dashboard-horizontal-line": {
      body: '<path fill="currentColor" d="M3 10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm8 10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1zm2-5h6v4h-6zM3 20a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm2-1v-4h2v4zM5 9V5h6v4zm15 2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm-1-2h-2V5h2z"/>',
    },
    "dashboard-line": {
      body: '<path fill="currentColor" d="M14 21a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zM4 13a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm5-2V5H5v6zM4 21a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm1-2h4v-2H5zm10 0h4v-6h-4zM13 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm2 1v2h4V5z"/>',
    },
    "database-2-fill": {
      body: '<path fill="currentColor" d="M21 9.5v3c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5v-3c0 2.485 4.03 4.5 9 4.5s9-2.015 9-4.5m-18 5c0 2.485 4.03 4.5 9 4.5s9-2.015 9-4.5v3c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5zm9-2.5c-4.97 0-9-2.015-9-4.5S7.03 3 12 3s9 2.015 9 4.5s-4.03 4.5-9 4.5"/>',
    },
    "database-2-line": {
      body: '<path fill="currentColor" d="M5 12.5c0 .313.461.858 1.53 1.393C7.914 14.585 9.877 15 12 15s4.086-.415 5.47-1.107c1.069-.535 1.53-1.08 1.53-1.393v-2.171C17.35 11.349 14.827 12 12 12s-5.35-.652-7-1.671zm14 2.829C17.35 16.349 14.827 17 12 17s-5.35-.652-7-1.671V17.5c0 .313.461.858 1.53 1.393C7.914 19.585 9.877 20 12 20s4.086-.415 5.47-1.107c1.069-.535 1.53-1.08 1.53-1.393zM3 17.5v-10C3 5.015 7.03 3 12 3s9 2.015 9 4.5v10c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5m9-7.5c2.123 0 4.086-.415 5.47-1.107C18.539 8.358 19 7.813 19 7.5s-.461-.858-1.53-1.393C16.086 5.415 14.123 5 12 5s-4.086.415-5.47 1.107C5.461 6.642 5 7.187 5 7.5s.461.858 1.53 1.393C7.914 9.585 9.877 10 12 10"/>',
    },
    "database-fill": {
      body: '<path fill="currentColor" d="M11 7V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm-6 9v2h5v-2zm9 0v2h5v-2zm0-3v2h5v-2zm0-3v2h5v-2zm-9 3v2h5v-2z"/>',
    },
    "database-line": {
      body: '<path fill="currentColor" d="M11 19V9H4v10zm0-12V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm2-2v14h7V5zM5 16h5v2H5zm9 0h5v2h-5zm0-3h5v2h-5zm0-3h5v2h-5zm-9 3h5v2H5z"/>',
    },
    "delete-back-2-fill": {
      body: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3m6.464 7.586l-2.828-2.829l-1.414 1.415L11.585 12l-2.828 2.828l1.414 1.415l2.828-2.829l2.829 2.829l1.414-1.415L14.414 12l2.828-2.828l-1.414-1.415z"/>',
    },
    "delete-back-2-line": {
      body: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3m.535 2l-4.667 7l4.667 7H20V5zM13 10.586l2.828-2.829l1.414 1.415L14.414 12l2.828 2.828l-1.414 1.415l-2.829-2.829l-2.828 2.829l-1.414-1.415L11.585 12L8.757 9.172l1.414-1.415z"/>',
    },
    "delete-back-fill": {
      body: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3m9.464 8H9v2h7z"/>',
    },
    "delete-back-line": {
      body: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3m.535 2l-4.667 7l4.667 7H20V5zM16 11v2H9v-2z"/>',
    },
    "delete-bin-2-fill": {
      body: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6zm6.414 8l1.768-1.768l-1.414-1.414L12 12.586l-1.768-1.768l-1.414 1.414L10.586 14l-1.768 1.768l1.414 1.414L12 15.414l1.768 1.768l1.414-1.414zM9 4v2h6V4z"/>',
    },
    "delete-bin-2-line": {
      body: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm1 2H6v12h12zm-4.586 6l1.768 1.768l-1.414 1.414L12 15.414l-1.768 1.768l-1.414-1.414L10.586 14l-1.768-1.768l1.414-1.414L12 12.586l1.768-1.768l1.414 1.414zM9 4v2h6V4z"/>',
    },
    "delete-bin-3-fill": {
      body: '<path fill="currentColor" d="M20 7v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7H2V5h20v2zm-9 2v2h2V9zm0 3v2h2v-2zm0 3v2h2v-2zM7 2h10v2H7z"/>',
    },
    "delete-bin-3-line": {
      body: '<path fill="currentColor" d="M20 7v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7H2V5h20v2zM6 7v13h12V7zm5 2h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zM7 2h10v2H7z"/>',
    },
    "delete-bin-4-fill": {
      body: '<path fill="currentColor" d="M20 7v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7H2V5h20v2zm-9 3v7h2v-7zM7 2h10v2H7z"/>',
    },
    "delete-bin-4-line": {
      body: '<path fill="currentColor" d="M20 7v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7H2V5h20v2zM6 7v13h12V7zm1-5h10v2H7zm4 8h2v7h-2z"/>',
    },
    "delete-bin-5-fill": {
      body: '<path fill="currentColor" d="M4 8h16v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm3-3V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h5v2H2V5zm2-1v1h6V4zm0 8v6h2v-6zm4 0v6h2v-6z"/>',
    },
    "delete-bin-5-line": {
      body: '<path fill="currentColor" d="M4 8h16v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm2 2v10h12V10zm3 2h2v6H9zm4 0h2v6h-2zM7 5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h5v2H2V5zm2-1v1h6V4z"/>',
    },
    "delete-bin-6-fill": {
      body: '<path fill="currentColor" d="M17 4h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4h5V2h10zM9 9v8h2V9zm4 0v8h2V9z"/>',
    },
    "delete-bin-6-line": {
      body: '<path fill="currentColor" d="M7 4V2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4zM6 6v14h12V6zm3 3h2v8H9zm4 0h2v8h-2z"/>',
    },
    "delete-bin-7-fill": {
      body: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6zm2-2v2h6V4z"/>',
    },
    "delete-bin-7-line": {
      body: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm1 2H6v12h12zM9 4v2h6V4z"/>',
    },
    "delete-bin-fill": {
      body: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm-8 5v6h2v-6zm4 0v6h2v-6zM9 4v2h6V4z"/>',
    },
    "delete-bin-line": {
      body: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm1 2H6v12h12zm-9 3h2v6H9zm4 0h2v6h-2zM9 4v2h6V4z"/>',
    },
    "delete-column": {
      body: '<path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v8a5 5 0 1 1 .213 8.152L13 20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H7v14h4zm8 10h-6v2h6z"/>',
    },
    "delete-row": {
      body: '<path fill="currentColor" d="M20 5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1a5 5 0 1 1-8 0H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm-7 10v2h6v-2zm6-8H5v4h14z"/>',
    },
    "device-fill": {
      body: '<path fill="currentColor" d="M19 6h-8a1 1 0 0 0-1 1v13H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-6 2h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1"/>',
    },
    "device-line": {
      body: '<path fill="currentColor" d="M19 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-2 0V4H5v14h7V9a1 1 0 0 1 1-1zm-3 2v10h6V10z"/>',
    },
    "device-recover-fill": {
      body: '<path fill="currentColor" d="M19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-7 5a5 5 0 1 0 .955 9.909L12 15a3 3 0 1 1 0-6c1.598 0 3 1.34 3 3h-2.5l2.128 4.254A5 5 0 0 0 12 7"/>',
    },
    "device-recover-line": {
      body: '<path fill="currentColor" d="M19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-1 2H6v16h12zm-6 3a5 5 0 0 1 2.628 9.254L12.5 12H15a3 3 0 1 0-3 3l.955 1.909q-.464.09-.955.091a5 5 0 0 1 0-10"/>',
    },
    "dice-1-fill": {
      body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm7 11a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "dice-1-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V5zM3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm9 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "dice-2-fill": {
      body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm5.5 6a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m6 6a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "dice-2-line": {
      body: '<path fill="currentColor" d="M19 5v14H5V5zM5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm11.5 12a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M9 10.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "dice-3-fill": {
      body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm3.5 7a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m7 7a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-2-5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "dice-3-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V5zM3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm12.5 12a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M10 8.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m2 5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "dice-4-fill": {
      body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm4 7.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m1.5 4.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m6 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m0-6a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "dice-4-line": {
      body: '<path fill="currentColor" d="M19 5v14H5V5zM5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm11.5 12a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M9 16.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M10.5 9a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m4.5 1.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "dice-5-fill": {
      body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm5 5.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M8.5 17a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m7 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m0-7a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-2 2a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "dice-5-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V5zM3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm12.5 12a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M10 15.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M8.5 10a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M17 8.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-5 5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "dice-6-fill": {
      body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm4 6.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m1.5 2.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m0 4a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M15 9.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m1.5 2.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m0 4a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "dice-6-line": {
      body: '<path fill="currentColor" d="M19 5v14H5V5zM5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm4 6.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m1.5 2.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m0 4a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m6-8a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M15 13.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 4a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "dice-fill": {
      body: '<path fill="currentColor" d="M10.998 1.58a2 2 0 0 1 2.004 0l7.5 4.342a2 2 0 0 1 .998 1.731v8.694a2 2 0 0 1-.998 1.73l-7.5 4.343a2 2 0 0 1-2.004 0l-7.5-4.342a2 2 0 0 1-.998-1.731V7.653a2 2 0 0 1 .998-1.73zM5.25 8.092a.5.5 0 0 0-.751.433v6.669a2 2 0 0 0 .998 1.73l5.751 3.33a.5.5 0 0 0 .751-.432v-6.669a2 2 0 0 0-.998-1.73zm10.517-2.575c-.478-.276-1.254-.276-1.732 0s-.478.724 0 1s1.254.276 1.732 0s.478-.724 0-1m-5.8 0c-.478-.276-1.254-.276-1.732 0s-.478.724 0 1s1.254.276 1.732 0c.479-.276.479-.724 0-1m7.025 10.328c.597-.345 1.082-1.184 1.082-1.875c0-.69-.485-.97-1.082-.625S15.91 14.53 15.91 15.22s.485.97 1.082.625M6.365 12.2c.478.277.866.053.866-.5c0-.552-.388-1.223-.866-1.5s-.866-.052-.866.5c0 .553.388 1.224.866 1.5m4.33 5.498c0 .552-.389.776-.867.5s-.866-.948-.866-1.5s.388-.776.866-.5s.866.948.866 1.5M7.231 15.7c0 .553-.388.777-.866.5c-.478-.276-.866-.947-.866-1.5c0-.552.388-.776.866-.5c.478.277.866.948.866 1.5m3.463-2c0 .553-.388.777-.866.5c-.479-.275-.866-.947-.866-1.5c0-.551.387-.775.866-.5c.478.277.866.949.866 1.5"/>',
    },
    "dice-line": {
      body: '<path fill="currentColor" d="M10.998 1.58a2 2 0 0 1 2.004 0l7.5 4.342a2 2 0 0 1 .998 1.731v8.694a2 2 0 0 1-.998 1.73l-7.5 4.343a2 2 0 0 1-2.004 0l-7.5-4.342a2 2 0 0 1-.998-1.731V7.653a2 2 0 0 1 .998-1.73zM4.5 7.653v.005l6.502 3.764A2 2 0 0 1 12 13.153v7.536l7.5-4.342V7.653L12 3.311zM6.132 12.3c0-.552-.388-1.224-.866-1.5s-.866-.052-.866.5s.388 1.224.866 1.5s.866.052.866-.5m2.597 6.498c.478.276.866.053.866-.5c0-.552-.388-1.224-.866-1.5s-.866-.052-.866.5s.388 1.224.866 1.5M5.266 16.8c.478.276.866.052.866-.5s-.388-1.224-.866-1.5s-.866-.052-.866.5s.388 1.224.866 1.5m3.463-2c.478.277.866.053.865-.5c0-.552-.387-1.223-.866-1.5c-.478-.276-.866-.052-.866.5c0 .553.388 1.224.867 1.5M14.898 8c.478-.276.478-.724 0-1s-1.254-.276-1.732 0c-.479.276-.479.724 0 1c.478.276 1.254.276 1.732 0m-4.8-1c.478.276.478.724 0 1s-1.254.276-1.732 0s-.478-.724 0-1s1.254-.276 1.732 0m5.897 8.35c.598-.346 1.083-1.185 1.083-1.875s-.485-.97-1.082-.625s-1.083 1.184-1.083 1.875c0 .69.485.97 1.082.625"/>',
    },
    "dingding-fill": {
      body: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m4.49 9.04l-.006.014c-.42.898-1.516 2.66-1.516 2.66l-.005-.012l-.32.558h1.543l-2.948 3.919l.67-2.666h-1.215l.422-1.763a17 17 0 0 0-1.223.349s-.646.378-1.862-.729c0 0-.82-.722-.344-.902c.202-.077.981-.175 1.595-.257a80 80 0 0 1 1.338-.172s-2.555.039-3.161-.057c-.606-.095-1.375-1.107-1.539-1.996c0 0-.253-.488.545-.257s4.101.9 4.101.9S8.27 9.312 7.983 8.99c-.286-.32-.841-1.754-.769-2.634c0 0 .031-.22.257-.16c0 0 3.176 1.45 5.347 2.245s4.06 1.199 3.816 2.228c-.02.087-.072.216-.144.37"/>',
    },
    "dingding-line": {
      body: '<path fill="currentColor" d="M12 4a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0-2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m4.49 9.04l-.006.014c-.42.898-1.516 2.66-1.516 2.66l-.005-.012l-.32.558h1.543l-2.948 3.919l.67-2.666h-1.215l.422-1.763a17 17 0 0 0-1.223.349s-.646.378-1.862-.729c0 0-.82-.722-.344-.902c.202-.077.981-.175 1.595-.257a80 80 0 0 1 1.338-.172s-2.555.039-3.161-.057c-.606-.095-1.375-1.107-1.539-1.996c0 0-.253-.488.545-.257s4.101.9 4.101.9S8.27 9.312 7.983 8.99c-.286-.32-.841-1.754-.769-2.634c0 0 .031-.22.257-.16c0 0 3.176 1.45 5.347 2.245s4.06 1.199 3.816 2.228c-.02.087-.072.216-.144.37"/>',
    },
    "direction-fill": {
      body: '<path fill="currentColor" d="M9 10a1 1 0 0 0-1 1v4h2v-3h3v2.5l3.5-3.5L13 7.5V10zm3.707-8.607l9.9 9.9a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l9.9-9.9a1 1 0 0 1 1.414 0"/>',
    },
    "direction-line": {
      body: '<path fill="currentColor" d="M12 3.515L3.515 12L12 20.485L20.485 12zm.707-2.122l9.9 9.9a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l9.9-9.9a1 1 0 0 1 1.414 0M13 10V7.5l3.5 3.5l-3.5 3.5V12h-3v3H8v-4a1 1 0 0 1 1-1z"/>',
    },
    "disc-fill": {
      body: '<path fill="currentColor" d="M13 9.17A3 3 0 1 0 15 12V2.458c4.057 1.274 7 5.064 7 9.542c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2q.507 0 1 .05z"/>',
    },
    "disc-line": {
      body: '<path fill="currentColor" d="M15 4.582V12a3 3 0 1 1-2-2.83V2.05c5.053.501 9 4.765 9 9.95c0 5.523-4.477 10-10 10S2 17.523 2 12c0-5.185 3.947-9.449 9-9.95v2.012A8.001 8.001 0 0 0 12 20a8 8 0 0 0 3-15.418"/>',
    },
    "discord-fill": {
      body: '<path fill="currentColor" d="M19.303 5.337A17.3 17.3 0 0 0 14.963 4c-.191.329-.403.775-.552 1.125a16.6 16.6 0 0 0-4.808 0C9.454 4.775 9.23 4.329 9.05 4a17 17 0 0 0-4.342 1.337C1.961 9.391 1.218 13.35 1.59 17.255a17.7 17.7 0 0 0 5.318 2.664a13 13 0 0 0 1.136-1.836c-.627-.234-1.22-.52-1.794-.86c.149-.106.297-.223.435-.34c3.46 1.582 7.207 1.582 10.624 0c.149.117.287.234.435.34c-.573.34-1.167.626-1.793.86a13 13 0 0 0 1.135 1.836a17.6 17.6 0 0 0 5.318-2.664c.457-4.52-.722-8.448-3.1-11.918M8.52 14.846c-1.04 0-1.889-.945-1.889-2.101s.828-2.102 1.89-2.102c1.05 0 1.91.945 1.888 2.102c0 1.156-.838 2.1-1.889 2.1m6.974 0c-1.04 0-1.89-.945-1.89-2.101s.828-2.102 1.89-2.102c1.05 0 1.91.945 1.889 2.102c0 1.156-.828 2.1-1.89 2.1"/>',
    },
    "discord-line": {
      body: '<path fill="currentColor" d="M8.52 13.846c-1.04 0-1.888-.945-1.888-2.101s.827-2.102 1.889-2.102c1.05 0 1.91.945 1.889 2.102c0 1.156-.839 2.1-1.89 2.1m6.974 0c-1.04 0-1.89-.945-1.89-2.101s.829-2.102 1.89-2.102c1.05 0 1.91.945 1.89 2.102c0 1.156-.829 2.1-1.89 2.1m-5.369-9.523l-.308-.563l-.634.106a16.4 16.4 0 0 0-4.158 1.28l-.228.105l-.142.21c-2.613 3.853-3.33 7.648-2.975 11.375l.039.407l.33.24a16.9 16.9 0 0 0 5.078 2.543l.79.242L9.03 17.55c1.91.472 4.03.472 5.939 0l1.107 2.717l.79-.242a16.8 16.8 0 0 0 5.08-2.545l.327-.238l.04-.402c.436-4.32-.697-8.083-2.958-11.384l-.142-.208l-.228-.104a16.6 16.6 0 0 0-4.154-1.28l-.618-.103l-.314.542c-.088.15-.177.32-.263.493a16 16 0 0 0-3.263 0c-.085-.17-.17-.333-.248-.474M6.715 16.61c.197.114.405.226.61.328l-.449 1.096a15 15 0 0 1-3.428-1.778c-.225-3.138.413-6.305 2.564-9.57a14.6 14.6 0 0 1 2.824-.913c.06.125.116.248.162.356l.273.643l.692-.101a14.1 14.1 0 0 1 4.09 0l.69.1l.272-.642c.047-.112.102-.234.16-.356c.977.21 1.923.52 2.828.915c1.875 2.82 2.821 5.966 2.546 9.567a15 15 0 0 1-3.43 1.779l-.445-1.095c.206-.102.414-.214.613-.329c.49-.282 1.017-.634 1.353-.97l-1.28-1.28c-.163.164-.523.42-.977.682c-.444.256-.885.463-1.167.556c-2.003.663-4.428.663-6.432 0c-.281-.093-.722-.3-1.166-.556c-.454-.261-.814-.518-.978-.682l-1.28 1.28c.337.336.864.688 1.354.97"/>',
    },
    "discount-percent-fill": {
      body: '<path fill="currentColor" d="M13.946 2.094a3 3 0 0 0-3.892 0L8.706 3.243a1 1 0 0 1-.569.236l-1.765.14A3 3 0 0 0 3.62 6.371l-.14 1.766a1 1 0 0 1-.237.569l-1.148 1.348a3 3 0 0 0 0 3.891l1.148 1.349a1 1 0 0 1 .236.569l.141 1.765a3 3 0 0 0 2.752 2.752l1.765.14a1 1 0 0 1 .57.237l1.347 1.148a3 3 0 0 0 3.892 0l1.348-1.148a1 1 0 0 1 .57-.236l1.765-.141a3 3 0 0 0 2.752-2.752l.14-1.765a1 1 0 0 1 .236-.57l1.149-1.347a3 3 0 0 0 0-3.892l-1.149-1.348a1 1 0 0 1-.236-.57l-.14-1.765a3 3 0 0 0-2.752-2.752l-1.766-.14a1 1 0 0 1-.569-.236zm.882 5.663l1.415 1.414l-7.071 7.072l-1.415-1.415zm-4.596 2.475a1.5 1.5 0 1 1-2.121-2.121a1.5 1.5 0 0 1 2.121 2.121m3.536 5.657a1.5 1.5 0 1 1 2.12-2.121a1.5 1.5 0 0 1-2.12 2.12"/>',
    },
    "discount-percent-line": {
      body: '<path fill="currentColor" d="M10.054 2.094a3 3 0 0 1 3.892 0l1.348 1.149a1 1 0 0 0 .57.236l1.765.14a3 3 0 0 1 2.752 2.752l.14 1.766a1 1 0 0 0 .236.569l1.149 1.348a3 3 0 0 1 0 3.892l-1.149 1.348a1 1 0 0 0-.236.569l-.14 1.765a3 3 0 0 1-2.752 2.752l-1.766.14a1 1 0 0 0-.569.237l-1.348 1.148a3 3 0 0 1-3.892 0l-1.348-1.148a1 1 0 0 0-.569-.236l-1.765-.141a3 3 0 0 1-2.752-2.752l-.14-1.765a1 1 0 0 0-.237-.57l-1.148-1.348a3 3 0 0 1 0-3.891l1.148-1.348a1 1 0 0 0 .236-.57l.141-1.765A3 3 0 0 1 6.372 3.62l1.765-.14a1 1 0 0 0 .57-.236zm2.595 1.522a1 1 0 0 0-1.297 0l-1.348 1.15a3 3 0 0 1-1.708.706l-1.765.141a1 1 0 0 0-.917.917l-.141 1.766a3 3 0 0 1-.707 1.707l-1.15 1.348a1 1 0 0 0 0 1.297l1.15 1.348a3 3 0 0 1 .707 1.707l.14 1.766a1 1 0 0 0 .918.917l1.765.141a3 3 0 0 1 1.708.707l1.348 1.15a1 1 0 0 0 1.297 0l1.348-1.15a3 3 0 0 1 1.707-.707l1.765-.14a1 1 0 0 0 .918-.918l.14-1.766c.05-.629.298-1.226.708-1.707l1.149-1.348a1 1 0 0 0 0-1.297l-1.15-1.348a3 3 0 0 1-.706-1.707l-.141-1.766a1 1 0 0 0-.918-.917l-1.765-.14a3 3 0 0 1-1.707-.708zm2.18 4.141l1.414 1.414l-7.071 7.072l-1.415-1.415zm-4.597 2.475a1.5 1.5 0 1 1-2.121-2.121a1.5 1.5 0 0 1 2.121 2.121m3.536 5.657a1.5 1.5 0 1 0 2.121-2.121a1.5 1.5 0 0 0-2.121 2.12"/>',
    },
    "discuss-fill": {
      body: '<path fill="currentColor" d="M16.8 19L14 22.5L11.2 19H6a1 1 0 0 1-1-1V7.103a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1zM2 2h17v2H3v11H1V3a1 1 0 0 1 1-1"/>',
    },
    "discuss-line": {
      body: '<path fill="currentColor" d="M14 22.5L11.2 19H6a1 1 0 0 1-1-1V7.103a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1h-5.2zm1.839-5.5H21V8.103H7V17h5.161L14 19.298zM2 2h17v2H3v11H1V3a1 1 0 0 1 1-1"/>',
    },
    "dislike-fill": {
      body: '<path fill="currentColor" d="m2.808 1.393l18.385 18.385l-1.415 1.414l-3.746-3.747L12 21.485l-8.478-8.492a6 6 0 0 1 .033-8.023L1.394 2.808zm17.435 3.364a6 6 0 0 1 .236 8.236l-1.635 1.636L7.26 3.046a6 6 0 0 1 4.741 1.483a6 6 0 0 1 8.242.228"/>',
    },
    "dislike-line": {
      body: '<path fill="currentColor" d="m2.808 1.393l18.385 18.385l-1.415 1.414l-3.746-3.747L12 21.485l-8.478-8.492a6 6 0 0 1 .033-8.023L1.394 2.808zm2.172 10.23L12 18.654l2.618-2.623l-9.646-9.645a4 4 0 0 0 .008 5.237m15.263-6.866a6 6 0 0 1 .236 8.236l-1.635 1.636l-1.414-1.414l1.59-1.592a4 4 0 0 0-5.683-5.606l-1.335 1.198l-1.336-1.197a4 4 0 0 0-1.155-.723l-2.25-2.25A6 6 0 0 1 12 4.53a6 6 0 0 1 8.242.228"/>',
    },
    "disqus-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-2.53 0-4.84-.94-6.601-2.488L1.5 20l1.424-3.797A10 10 0 0 1 2 12C2 6.477 6.477 2 12 2M8 7v10h3.733l.263-.004c3.375-.103 5.337-2.211 5.337-5.025v-.027l-.003-.215C17.23 8.956 15.21 7 11.79 7zm3.831 2.458c1.628 0 2.709.928 2.709 2.529v.028l-.005.183c-.079 1.5-1.138 2.345-2.704 2.345h-1.108V9.458z"/>',
    },
    "disqus-line": {
      body: '<path fill="currentColor" d="M11.997 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-6.249-2.192l-4.718.59l1.72-4.586A10 10 0 0 1 1.996 12c0-5.523 4.477-10 10-10m0 2a8 8 0 0 0-7.262 11.362l.177.38l-.848 2.26l2.315-.289l.338.297a7.97 7.97 0 0 0 5.28 1.99a8 8 0 1 0 0-16m-3.95 3h3.79c3.42 0 5.44 1.956 5.54 4.729l.004.215v.027c0 2.814-1.963 4.922-5.338 5.025L11.78 17H8.047zh3.79zm3.832 2.458H10.77v5.085h1.109c1.565 0 2.624-.845 2.703-2.345l.005-.183v-.028c0-1.6-1.08-2.53-2.708-2.53"/>',
    },
    "divide-fill": {
      body: '<path fill="currentColor" d="M5 11h14v2H5zm7-3a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m0 11a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "divide-line": {
      body: '<path fill="currentColor" d="M5 11h14v2H5zm7-3a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m0 11a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "dna-fill": {
      body: '<path fill="currentColor" d="M18 1c0 .716-.064 1.38-.184 2H8.232c.639 2.552 2.562 4.229 5.35 6.428A48 48 0 0 1 12 10.727C8.73 8.135 6 5.668 6 1H4c0 5.466 3.21 8.464 6.386 11C7.21 14.537 4 17.534 4 23h2c0-4.96 3.08-7.434 6.618-10.214l.092-.072C16.149 10.012 20 6.987 20 1zm-.184 20H8.232c.659-2.634 2.687-4.335 5.622-6.64c.443-.35.888-.697 1.327-1.051C17.766 15.599 20 18.44 20 23h-2q-.002-1.071-.184-2"/>',
    },
    "dna-line": {
      body: '<path fill="currentColor" d="M18 1c0 .716-.064 1.38-.184 2H8.232a7 7 0 0 0 .849 2h8.1C16.132 7.317 14.187 8.994 12 10.727C8.73 8.135 6 5.668 6 1H4c0 5.466 3.21 8.464 6.386 11C7.21 14.537 4 17.534 4 23h2c0-4.96 3.08-7.434 6.618-10.214l.092-.072C16.149 10.012 20 6.987 20 1zm-.184 20H8.232a7 7 0 0 1 .849-2h8.1c-.787-1.738-2.078-3.116-3.598-4.428c.533-.42 1.07-.837 1.598-1.263C17.766 15.599 20 18.44 20 23h-2q-.002-1.071-.184-2"/>',
    },
    "donut-chart-fill": {
      body: '<path fill="currentColor" d="M11 2.05v3.02a7.002 7.002 0 1 0 5.192 12.536l2.137 2.137A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12c0-5.185 3.947-9.449 9-9.95M21.95 13a9.95 9.95 0 0 1-2.207 5.328l-2.137-2.136A7 7 0 0 0 18.93 13zM13.002 2.05a10.004 10.004 0 0 1 8.95 8.95H18.93a7.005 7.005 0 0 0-5.928-5.929z"/>',
    },
    "donut-chart-line": {
      body: '<path fill="currentColor" d="M11 2.05v2.012a8.001 8.001 0 1 0 5.906 14.258l1.423 1.423A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12c0-5.185 3.947-9.449 9-9.95M21.95 13a9.95 9.95 0 0 1-2.207 5.328l-1.423-1.422A7.96 7.96 0 0 0 19.938 13zM13.002 2.05a10.004 10.004 0 0 1 8.95 8.95h-2.013a8.004 8.004 0 0 0-6.937-6.938z"/>',
    },
    "door-closed-fill": {
      body: '<path fill="currentColor" d="M2.998 21v-2h2V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v15h2v2zm12-10h-2v2h2z"/>',
    },
    "door-closed-line": {
      body: '<path fill="currentColor" d="M2.998 21v-2h2V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v15h2v2zm14-16h-10v14h10zm-2 6v2h-2v-2z"/>',
    },
    "door-fill": {
      body: '<path fill="currentColor" d="M17.998 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-4 8a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "door-line": {
      body: '<path fill="currentColor" d="M17.998 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2h-10v14h10zm-2 6v2h-2v-2z"/>',
    },
    "door-lock-box-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m7 9.792V16h2v-3.208a2.5 2.5 0 1 0-2 0"/>',
    },
    "door-lock-box-line": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5zm6 7.792a2.5 2.5 0 1 1 2 0V16h-2z"/>',
    },
    "door-lock-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-1-9.208V16h2v-3.208a2.5 2.5 0 1 0-2 0"/>',
    },
    "door-lock-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1-7.208a2.5 2.5 0 1 1 2 0V16h-2z"/>',
    },
    "door-open-fill": {
      body: '<path fill="currentColor" d="M1.998 21v-2h2V4.835a1 1 0 0 1 .821-.984l9.472-1.722a.6.6 0 0 1 .707.59v1.28l4 .001a1 1 0 0 1 1 1v14h2v2h-4V6h-3v15zm10-10h-2v2h2z"/>',
    },
    "door-open-line": {
      body: '<path fill="currentColor" d="M1.998 21v-2h2V4.835a1 1 0 0 1 .821-.984l9.472-1.722a.6.6 0 0 1 .707.59v1.28l4 .001a1 1 0 0 1 1 1v14h2v2h-4V6h-3v15zm11-16.603l-7 1.272V19h7zm-1 6.603v2h-2v-2z"/>',
    },
    "dossier-fill": {
      body: '<path fill="currentColor" d="M17 2v2h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V2zm-4 9h-2v2H9v2h1.999L11 17h2l-.001-2H15v-2h-2zm2-7H9v2h6z"/>',
    },
    "dossier-line": {
      body: '<path fill="currentColor" d="M17 2v2h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V2zM7 6H5v14h14V6h-2v2H7zm6 5v2h2v2h-2.001L13 17h-2l-.001-2H9v-2h2v-2zm2-7H9v2h6z"/>',
    },
    "douban-fill": {
      body: '<path fill="currentColor" d="M16.314 19.138h4.065a.62.62 0 0 1 .621.62v.621a.62.62 0 0 1-.62.621H3.62a.62.62 0 0 1-.62-.62v-.621a.62.62 0 0 1 .62-.621h3.754l-.96-3.104h2.19a.62.62 0 0 1 .59.425l.892 2.679H13.6l1.225-4.035H5.172a.62.62 0 0 1-.62-.62V7.345a.62.62 0 0 1 .62-.62h13.656a.62.62 0 0 1 .62.62v7.138a.62.62 0 0 1-.62.62h-1.289zM3.931 3h16.138a.62.62 0 0 1 .62.62v.621a.62.62 0 0 1-.62.621H3.931a.62.62 0 0 1-.62-.62V3.62A.62.62 0 0 1 3.93 3m3.26 5.586a.155.155 0 0 0-.156.155v4.035c0 .086.07.155.156.155h9.62c.086 0 .155-.07.155-.155V8.74a.155.155 0 0 0-.155-.155z"/>',
    },
    "douban-line": {
      body: '<path fill="currentColor" d="M15.274 15H5V7h14v8h-1.624l-1.3 4H21v2H3v-2h4.612L6.8 16.5l1.902-.618L9.715 19h4.259zM3.5 3h17v2h-17zM7 9v4h10V9z"/>',
    },
    "double-quotes-l": {
      body: '<path fill="currentColor" d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621c.537-.278 1.24-.375 1.929-.311c1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5a3.87 3.87 0 0 1-2.748-1.179m10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621c.537-.278 1.24-.375 1.929-.311c1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5a3.87 3.87 0 0 1-2.748-1.179"/>',
    },
    "double-quotes-r": {
      body: '<path fill="currentColor" d="M19.417 6.679C20.447 7.773 21 9 21 10.989c0 3.5-2.456 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.248-5.621c-.537.278-1.24.375-1.93.311c-1.804-.167-3.226-1.648-3.226-3.489a3.5 3.5 0 0 1 3.5-3.5c1.073 0 2.1.49 2.748 1.179m-10 0C10.447 7.773 11 9 11 10.989c0 3.5-2.456 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.247-5.621c-.537.278-1.24.375-1.929.311C4.591 12.323 3.17 10.842 3.17 9a3.5 3.5 0 0 1 3.5-3.5c1.073 0 2.1.49 2.748 1.179"/>',
    },
    "download-2-fill": {
      body: '<path fill="currentColor" d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2zM14 9h5l-7 7l-7-7h5V3h4z"/>',
    },
    "download-2-line": {
      body: '<path fill="currentColor" d="M13 10h5l-6 6l-6-6h5V3h2zm-9 9h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2z"/>',
    },
    "download-cloud-2-fill": {
      body: '<path fill="currentColor" d="M13 13v5.585l1.828-1.828l1.415 1.415L12 22.414l-4.243-4.242l1.415-1.415L11 18.585V13zM12 2a7 7 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978V17a6 6 0 0 0-11.996-.225L6 17v1.978a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2"/>',
    },
    "download-cloud-2-line": {
      body: '<path fill="currentColor" d="M13 13v5.585l1.828-1.828l1.415 1.415L12 22.414l-4.243-4.242l1.415-1.415L11 18.585V13zM12 2a7 7 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978v-2.014a3.5 3.5 0 1 0-1.111-6.91a5 5 0 1 0-9.777 0a3.5 3.5 0 0 0-1.292 6.88l.18.03v2.014a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2"/>',
    },
    "download-cloud-fill": {
      body: '<path fill="currentColor" d="M7 20.981a6.5 6.5 0 0 1-2.936-12a8.001 8.001 0 0 1 15.872 0a6.5 6.5 0 0 1-2.936 12V21H7zM13 12V8h-2v4H8l4 5l4-5z"/>',
    },
    "download-cloud-line": {
      body: '<path fill="currentColor" d="M1 14.5a6.5 6.5 0 0 1 3.064-5.519a8.001 8.001 0 0 1 15.872 0a6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5m15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503l-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942l-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35zM13 12h3l-4 5l-4-5h3V8h2z"/>',
    },
    "download-fill": {
      body: '<path fill="currentColor" d="M3 19h18v2H3zM13 9h7l-8 8l-8-8h7V1h2z"/>',
    },
    "download-line": {
      body: '<path fill="currentColor" d="M3 19h18v2H3zm10-5.828L19.071 7.1l1.414 1.414L12 17L3.515 8.515L4.929 7.1L11 13.173V2h2z"/>',
    },
    "draft-fill": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v3.757l-8.999 9l-.006 4.238l4.246.006L21 15.242V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm1.778 6.808l1.414 1.414L15.414 18l-1.416-.002l.002-1.412zM12 12H7v2h5zm3-4H7v2h8z"/>',
    },
    "draft-line": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v3.757l-2 2V4H5v16h14v-2.758l2-2V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm1.778 6.808l1.414 1.414L15.414 18l-1.416-.002l.002-1.412zM13 12v2H8v-2zm3-4v2H8V8z"/>',
    },
    "drag-drop-fill": {
      body: '<path fill="currentColor" d="M14 6h2v2h5a1 1 0 0 1 1 1v7.5L16 13l.036 8.062l2.223-2.15L20.041 22H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5zm8 11.338V21a1 1 0 0 1-.048.307l-1.96-3.394zM4 14v2H2v-2zm0-4v2H2v-2zm0-4v2H2V6zm0-4v2H2V2zm4 0v2H6V2zm4 0v2h-2V2zm4 0v2h-2V2z"/>',
    },
    "drag-drop-line": {
      body: '<path fill="currentColor" d="m16 13l6.964 4.062l-2.973.85l2.125 3.681l-1.732 1l-2.125-3.68l-2.223 2.15zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5zM4 14v2H2v-2zm0-4v2H2v-2zm0-4v2H2V6zm0-4v2H2V2zm4 0v2H6V2zm4 0v2h-2V2zm4 0v2h-2V2z"/>',
    },
    "drag-move-2-fill": {
      body: '<path fill="currentColor" d="M18 11V8l4 4l-4 4v-3h-5v5h3l-4 4l-4-4h3v-5H6v3l-4-4l4-4v3h5V6H8l4-4l4 4h-3v5z"/>',
    },
    "drag-move-2-line": {
      body: '<path fill="currentColor" d="M11 11V5.828L9.172 7.657L7.757 6.243L12 2l4.243 4.243l-1.415 1.414L13 5.828V11h5.172l-1.829-1.828l1.414-1.415L22 12l-4.243 4.243l-1.414-1.415L18.172 13H13v5.172l1.828-1.829l1.415 1.414L12 22l-4.243-4.243l1.415-1.414L11 18.172V13H5.828l1.829 1.828l-1.414 1.415L2 12l4.243-4.243l1.414 1.415L5.828 11z"/>',
    },
    "drag-move-fill": {
      body: '<path fill="currentColor" d="m12 22l-4-4h8zm0-20l4 4H8zm0 12a2 2 0 1 1 0-4a2 2 0 0 1 0 4M2 12l4-4v8zm20 0l-4 4V8z"/>',
    },
    "drag-move-line": {
      body: '<path fill="currentColor" d="m12 2l4.243 4.243l-1.415 1.414L12 4.828L9.172 7.657L7.757 6.243zM2 12l4.243-4.243l1.414 1.415L4.828 12l2.829 2.828l-1.414 1.415zm20 0l-4.243 4.243l-1.414-1.415L19.172 12l-2.829-2.828l1.414-1.415zm-10 2a2 2 0 1 1 0-4a2 2 0 0 1 0 4m0 8l-4.243-4.243l1.415-1.414L12 19.172l2.828-2.829l1.415 1.414z"/>',
    },
    draggable: {
      body: '<path fill="currentColor" d="M8.5 7a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 6.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m1.5 5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M15.5 7a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m1.5 5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-1.5 8a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "dribbble-fill": {
      body: '<path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2m6.605 4.61a8.5 8.5 0 0 1 1.93 5.314c-.281-.054-3.101-.629-5.943-.271c-.065-.141-.12-.293-.184-.445a25 25 0 0 0-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362M12 3.475c2.17 0 4.154.814 5.662 2.148c-.152.216-1.443 1.941-4.48 3.08c-1.399-2.57-2.95-4.675-3.189-5A8.7 8.7 0 0 1 12 3.475m-3.633.803a54 54 0 0 1 3.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.58 8.58 0 0 1 4.729-5.975M3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215c.25.477.477.965.694 1.453c-.109.033-.228.065-.336.098c-4.404 1.42-6.747 5.303-6.942 5.629a8.52 8.52 0 0 1-2.19-5.705M12 20.547a8.48 8.48 0 0 1-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337c.022-.01.033-.01.054-.022a35.3 35.3 0 0 1 1.823 6.475a8.4 8.4 0 0 1-3.341.684m4.761-1.465c-.086-.52-.542-3.015-1.66-6.084c2.68-.423 5.023.271 5.315.369a8.47 8.47 0 0 1-3.655 5.715"/>',
    },
    "dribbble-line": {
      body: '<path fill="currentColor" d="M19.989 11.572a7.96 7.96 0 0 0-1.573-4.351a10 10 0 0 1-.92.87a13.2 13.2 0 0 1-3.313 2.01c.167.35.32.689.455 1.009v.003c.027.061.05.118.094.229l.017.04c1.513-.17 3.109-.107 4.656.103q.308.04.584.087m-9.385-7.45a46 46 0 0 1 2.692 4.27c1.223-.482 2.234-1.09 3.048-1.767c.33-.274.594-.532.796-.755A7.97 7.97 0 0 0 12 4q-.714.001-1.396.121M4.253 9.997a29 29 0 0 0 2.04-.123a31.5 31.5 0 0 0 4.862-.822a54 54 0 0 0-2.7-4.227a8.02 8.02 0 0 0-4.202 5.172m1.53 7.038a14 14 0 0 1 1.575-1.899c1.454-1.49 3.17-2.65 5.156-3.29l.062-.018c-.165-.364-.32-.689-.476-.995c-1.836.535-3.77.869-5.697 1.042c-.94.085-1.783.122-2.403.128a7.97 7.97 0 0 0 1.784 5.032m9.221 2.38a36 36 0 0 0-1.632-5.709c-2 .727-3.596 1.79-4.829 3.058a9.8 9.8 0 0 0-1.317 1.655A7.96 7.96 0 0 0 12 20a8 8 0 0 0 3.005-.583m1.874-1.075a8 8 0 0 0 2.987-4.87c-.34-.085-.771-.17-1.245-.236a12 12 0 0 0-3.18-.033a39 39 0 0 1 1.438 5.14M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "drinks-2-fill": {
      body: '<path fill="currentColor" d="M7.323 2H4V0h4.677l2 5H21v2h-2.118l-.827 14.059a1 1 0 0 1-.998.941H6.943a1 1 0 0 1-.998-.941L5.118 7H3V5h5.523zm-.202 5l.178 3.025c2.672.11 3.969.605 5.061 1.042c1.051.42 1.92.786 4.227.9L16.879 7z"/>',
    },
    "drinks-2-line": {
      body: '<path fill="currentColor" d="M4 2h3.323l1.2 3H3v2h2.118l.827 14.059a1 1 0 0 0 .998.941h10.114a1 1 0 0 0 .998-.941L18.882 7H21V5H10.677l-2-5H4zm3.3 8.025L7.12 7h9.758l-.292 4.967c-2.307-.114-3.164-.475-4.216-.896c-1.092-.436-2.4-.936-5.072-1.046m.117 2.008c2.304.114 3.172.48 4.223.9c1.06.424 2.316.905 4.83 1.031L16.113 20H7.886z"/>',
    },
    "drinks-fill": {
      body: '<path fill="currentColor" d="M14 2H6.205a1.25 1.25 0 0 0-1.226 1.005L4.18 7H2v2h20V7h-2.18l-.8-3.995A1.25 1.25 0 0 0 17.796 2H16V0h-2zm5.66 9H4.34l1.141 9.893A1.25 1.25 0 0 0 6.723 22h10.554a1.25 1.25 0 0 0 1.242-1.107z"/>',
    },
    "drinks-line": {
      body: '<path fill="currentColor" d="M14 2H6.205a1.25 1.25 0 0 0-1.226 1.005L4.18 7H2v2h2.109L5.48 20.893A1.25 1.25 0 0 0 6.723 22h10.554a1.25 1.25 0 0 0 1.242-1.107L19.89 9H22V7h-2.18l-.8-3.995A1.25 1.25 0 0 0 17.796 2H16V0h-2zm3.78 5H6.22l.6-3h10.36zM6.122 9h11.756l-1.27 11H7.392z"/>',
    },
    "drive-fill": {
      body: '<path fill="currentColor" d="m7.94 4.146l3.482 6.03l-5.94 10.293L2 14.44zm2.176 10.294H22l-3.482 6.029H6.635zm4.343-1L8.518 3.145h6.964l5.94 10.295z"/>',
    },
    "drive-line": {
      body: '<path fill="currentColor" d="M9.097 6.15L4.31 14.443l1.755 3.032l4.785-8.289zm-1.3 12.324h9.568l1.751-3.034H9.55zm11.314-5.034l-4.786-8.29H10.83l4.787 8.29zM8.52 3.15h6.96L22 14.444l-3.48 6.03H5.49L2 14.444zm3.485 8.036l-1.302 2.254h2.603z"/>',
    },
    "drizzle-fill": {
      body: '<path fill="currentColor" d="M11 18v3H9v-3a8 8 0 1 1 7.458-10.901A5.5 5.5 0 1 1 17.5 18zm2 2h2v3h-2z"/>',
    },
    "drizzle-line": {
      body: '<path fill="currentColor" d="M17 18v-2h.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 1 0-8 5.659v2.089a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18zm-8-2h2v4H9zm4 3h2v4h-2z"/>',
    },
    "drop-fill": {
      body: '<path fill="currentColor" d="M5.636 6.633L12 .269l6.364 6.364a9 9 0 1 1-12.728 0"/>',
    },
    "drop-line": {
      body: '<path fill="currentColor" d="m12 3.097l-4.95 4.95a7 7 0 1 0 9.9 0zM12 .27l6.364 6.364a9 9 0 1 1-12.728 0z"/>',
    },
    "dropbox-fill": {
      body: '<path fill="currentColor" d="m17.285 10.668l5.215 3.323l-5.252 3.346L12 13.993l-5.248 3.344L1.5 13.99l5.215-3.323L1.5 7.346L6.752 4L12 7.343L17.248 4L22.5 7.346zm-.074 0L12 7.348l-5.211 3.32L12 13.988zM6.786 18.446l5.252-3.346l5.252 3.346l-5.252 3.346z"/>',
    },
    "dropbox-line": {
      body: '<path fill="currentColor" d="m8.65 17.26l3.392 2.162l3.392-2.161l1.86 1.185l-5.252 3.346l-5.252-3.346zm-.876-8.28l2.393-1.553L7.74 5.854L5.286 7.37zm1.84 1.19l2.39 1.548l2.391-1.547l-2.39-1.552zm4.231 2.74l2.424 1.568l2.45-1.502l-2.486-1.612zm-1.84-6.675l4.236-2.748l6.225 3.843l-4.393 2.843l4.394 2.851l-6.227 3.818l-4.235-2.741l-4.236 2.74l-6.229-3.817l4.395-2.851L1.543 7.33l6.225-3.843zm1.836 1.192l2.394 1.553l2.488-1.61l-2.455-1.517zm-3.677 5.483l-2.39-1.547l-2.485 1.613l2.451 1.502z"/>',
    },
    "dropdown-list": {
      body: '<path fill="currentColor" d="M4 5v14h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5h-2V5zm15.707 6.293L19 10.586l-.707.707l-3 3l1.414 1.414L19 13.414l2.293 2.293l1.414-1.414zm-3 6L19 19.586l2.293-2.293l1.414 1.414l-3 3l-.707.707l-.707-.707l-3-3z"/>',
    },
    "dropper-fill": {
      body: '<path fill="currentColor" d="M15.536 2.807a4 4 0 0 1 5.656 5.657l-2.828 2.829l.354.354a1 1 0 0 1-1.415 1.414l-.353-.354l-6.215 6.215a4 4 0 0 1-2.044 1.094l-1.754.35a2 2 0 0 0-1.022.548l-.986.986a1 1 0 0 1-1.414 0L2.1 20.485a1 1 0 0 1 0-1.414l.986-.986a2 2 0 0 0 .546-1.022l.351-1.754a4 4 0 0 1 1.094-2.044l6.215-6.215l-.354-.353a1 1 0 0 1 1.415-1.414l.353.353zm-2.829 5.658l-6.215 6.214a2 2 0 0 0-.547 1.022l-.35 1.755A4 4 0 0 1 4.5 19.5a4 4 0 0 1 2.044-1.094l1.754-.351a2 2 0 0 0 1.022-.547l6.215-6.215z"/>',
    },
    "dropper-line": {
      body: '<path fill="currentColor" d="M19.778 4.222a2 2 0 0 1 0 2.828L16.95 9.88l-2.83-2.83l2.829-2.828a2 2 0 0 1 2.828 0m1.414-1.415a4 4 0 0 0-5.656 0l-2.829 2.829l-.354-.353a1 1 0 1 0-1.414 1.414l.354.353l-6.215 6.215a4 4 0 0 0-1.094 2.044l-.35 1.754a2 2 0 0 1-.547 1.022l-.986.986a1 1 0 0 0 0 1.414L3.515 21.9a1 1 0 0 0 1.414 0l.986-.986a2 2 0 0 1 1.022-.547l1.754-.351a4 4 0 0 0 2.044-1.094l6.215-6.215l.353.354a1 1 0 0 0 1.415-1.414l-.354-.354l2.828-2.829a4 4 0 0 0 0-5.657m-8.485 5.658l2.829 2.828l-6.215 6.215a2 2 0 0 1-1.022.547l-1.754.35A4 4 0 0 0 4.5 19.5a4 4 0 0 0 1.094-2.044l.35-1.755a2 2 0 0 1 .547-1.022z"/>',
    },
    "dual-sim-1-fill": {
      body: '<path fill="currentColor" d="m15 2l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-2 6h-3v2h1v6h2z"/>',
    },
    "dual-sim-1-line": {
      body: '<path fill="currentColor" d="m15 2l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-.829 2H6v16h12V7.829zM13 16h-2v-6h-1V8h3z"/>',
    },
    "dual-sim-2-fill": {
      body: '<path fill="currentColor" d="m15 2l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-3 5.5a3 3 0 0 0-2.995 2.824L9 10.5h2a1 1 0 1 1 1.751.66l-.082.083L9 14.547V16h6v-2h-2.405l1.412-1.27l-.006-.01l.008.008A3 3 0 0 0 12 7.5"/>',
    },
    "dual-sim-2-line": {
      body: '<path fill="currentColor" d="m15 2l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-.829 2H6v16h12V7.829zM12 7.5a3 3 0 0 1 2.009 5.228l-.008-.008l.006.01L12.595 14H15v2H9v-1.453l3.67-3.304A1 1 0 1 0 11 10.5H9a3 3 0 0 1 3-3"/>',
    },
    "dv-fill": {
      body: '<path fill="currentColor" d="M4 14.745a7 7 0 1 1 8 0V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM8 14A5 5 0 1 0 8 4a5 5 0 0 0 0 10m-1 4v2h2v-2zm1-6a3 3 0 1 1 0-6a3 3 0 0 1 0 6m6 5v-1.292A8.98 8.98 0 0 0 17 9a8.97 8.97 0 0 0-2.292-6H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zm4-10v2h2V7z"/>',
    },
    "dv-line": {
      body: '<path fill="currentColor" d="M11.608 3H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-7v-2h6V5h-6.255A6.97 6.97 0 0 1 15 9a6.99 6.99 0 0 1-3 5.745V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6.255A7 7 0 0 1 11.608 3M6 13.584V20h4v-6.416A5.001 5.001 0 0 0 8 4a5 5 0 0 0-2 9.584M8 12a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m9-3h2v2h-2zM7 17h2v2H7z"/>',
    },
    "dvd-fill": {
      body: '<path fill="currentColor" d="M13 11V6l-5 7h3v5l5-7zm-1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "dvd-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-9h3l-5 7v-5H8l5-7z"/>',
    },
    "e-bike-2-fill": {
      body: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v1h5v6h-2.019l2.746 7.545A4 4 0 1 1 15.126 19h-4.252a4.002 4.002 0 0 1-7.8-.226A2 2 0 0 1 2 17V7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3h-3V1zm3 15a2 2 0 1 0 1.88 1.316l-.017-.044A2 2 0 0 0 19 16M7 16a2 2 0 1 0 0 4a2 2 0 0 0 0-4m2-8H4v2h5zm11-3h-3v2h3z"/>',
    },
    "e-bike-2-line": {
      body: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v1h5v6h-2.019l2.746 7.544a4 4 0 1 1-7.6 2.456h-4.253a4.002 4.002 0 0 1-7.8-.226A2 2 0 0 1 2 17V7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3h-3V1zM7 16a2 2 0 1 0 0 4a2 2 0 0 0 0-4m12-.001a2 2 0 1 0 1.88 1.316l-.017-.044A2 2 0 0 0 19 16m-1.147-7H17v3a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3H4v3.354A4.002 4.002 0 0 1 10.874 17h4.252a4 4 0 0 1 4.568-2.94zM9 8H4v2h5zm11-3h-3v2h3z"/>',
    },
    "e-bike-fill": {
      body: '<path fill="currentColor" d="M15.5 6.937A7 7 0 0 1 19 13v8h-4.17a3.001 3.001 0 0 1-5.66 0H5v-8a7 7 0 0 1 3.5-6.063A4 4 0 0 1 8.125 6H5V4h3.126a4.002 4.002 0 0 1 7.748 0H19v2h-3.126q-.13.497-.373.937M12 14a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m0-7a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "e-bike-line": {
      body: '<path fill="currentColor" d="M15.5 6.937A7 7 0 0 1 19 13v8h-4.17a3.001 3.001 0 0 1-5.66 0H5v-8a7 7 0 0 1 3.5-6.063A4 4 0 0 1 8.125 6H5V4h3.126a4.002 4.002 0 0 1 7.748 0H19v2h-3.126q-.13.497-.373.937m-1.453 1.5c-.6.358-1.3.563-2.048.563a4 4 0 0 1-2.047-.563A5 5 0 0 0 7 13v6h2v-4a3 3 0 1 1 6 0v4h2v-6a5 5 0 0 0-2.953-4.563M12 14a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m0-7a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "earth-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m4.004 10.878c-.345-.525-.594-.903-1.542-.753c-1.79.284-1.989.597-2.074 1.113l-.024.156l-.025.166c-.097.683-.094.941.22 1.27c1.265 1.328 2.023 2.285 2.253 2.845c.112.273.4 1.1.202 1.918a8.2 8.2 0 0 0 3.151-2.237c.11-.374.19-.84.19-1.404v-.105c0-.922 0-1.343-.652-1.716a7 7 0 0 0-.645-.325c-.367-.167-.61-.276-.938-.756q-.06-.085-.116-.172M12 3.833c-2.317 0-4.41.966-5.896 2.516c.177.123.331.296.437.534c.204.457.204.928.204 1.345c0 .328 0 .64.105.865c.144.308.766.44 1.315.554c.197.042.399.084.583.135c.506.14.898.595 1.211.96c.13.151.323.374.42.43c.05-.036.211-.211.29-.498c.062-.22.044-.414-.045-.52c-.56-.66-.529-1.93-.356-2.399c.272-.739 1.122-.684 1.744-.644c.232.015.45.03.614.009c.622-.078.814-1.025.949-1.21c.292-.4 1.186-1.003 1.74-1.375A8.1 8.1 0 0 0 12 3.833"/>',
    },
    "earth-line": {
      body: '<path fill="currentColor" d="M6.235 6.453a8 8 0 0 0 8.817 12.944c.115-.75-.137-1.47-.24-1.722c-.23-.56-.988-1.517-2.253-2.844c-.338-.355-.316-.627-.195-1.437l.013-.091c.082-.554.22-.882 2.085-1.178c.948-.15 1.197.228 1.542.753l.116.172c.328.48.571.59.938.756c.165.075.37.17.645.325c.652.373.652.794.652 1.716v.105c0 .391-.038.735-.098 1.034a8.002 8.002 0 0 0-3.105-12.341c-.553.373-1.312.902-1.577 1.265c-.135.185-.327 1.132-.95 1.21c-.162.02-.381.006-.613-.009c-.622-.04-1.472-.095-1.744.644c-.173.468-.203 1.74.356 2.4c.09.105.107.3.046.519c-.08.287-.241.462-.292.498c-.096-.056-.288-.279-.419-.43c-.313-.366-.705-.82-1.211-.96c-.184-.051-.386-.093-.583-.135c-.549-.115-1.17-.246-1.315-.554c-.106-.226-.105-.537-.105-.865c0-.417 0-.888-.204-1.345a1.3 1.3 0 0 0-.306-.43M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "earthquake-fill": {
      body: '<path fill="currentColor" d="M11.327 1.612a1 1 0 0 1 1.246-.08l.1.08L23 11h-3v9a1 1 0 0 1-.883.993L19 21h-6.5l2.5-4l-3.5-3l4-3L13 9l.5-3l-3 3l2.5 2l-5 3l3.75 3.5L8.5 21H5a1 1 0 0 1-.993-.883L4 20v-9H1z"/>',
    },
    "earthquake-line": {
      body: '<path fill="currentColor" d="M5 21a1 1 0 0 1-.993-.883L4 20v-9H1l10.327-9.388a1 1 0 0 1 1.246-.08l.1.08L23 11h-3v9a1 1 0 0 1-.883.993L19 21zm7-17.298L6 9.156V19h4.357l1.393-1.5L8 14l5-3l-2.5-2l3-3l-.5 3l2.5 2l-4 3l3.5 3l-1.25 2H18V9.157z"/>',
    },
    "edge-fill": {
      body: '<path fill="currentColor" d="M20.645 8.586c-.17-.711-.441-1.448-.774-2.021c-.771-1.329-1.464-2.237-3.177-3.32S13.077 2 12.171 2c-2.415 0-4.211.86-5.525 1.887C3.345 6.47 3.001 11 3.001 11s1.221-2.045 3.54-3.526C7.944 6.579 9.942 6 11.569 6c4.317 0 4.432 4 4.432 4h-7c0-2 1-3 1-3s-5 2-5 7.044c0 .487-.003 1.372.248 2.283c.232.843.7 1.705 1.132 2.353c1.221 1.832 3.045 2.614 3.916 2.904c.996.332 2.029.416 3.01.416c2.72 0 4.877-.886 5.694-1.275v-4.172c-.758.454-2.679 1.447-5 1.447c-5 0-5-4-5-4h12v-2.49s-.039-1.593-.356-2.924"/>',
    },
    "edge-line": {
      body: '<path fill="currentColor" d="M8.008 14.001A5 5 0 0 0 8 14.25C8 16.632 9.753 19 13 19c2.373 0 4.528-.655 6-1.553v3.35C17.211 21.564 15.112 22 13 22c-5.502 0-8-3.47-8-7.75c0-3.231 2.041-6 4.943-7.164C8.54 8.663 8 10.341 8 10.996L18 11c0-3.406-2.548-6-6-6c-5 0-8.001 3.988-9 5.999C3.29 6.237 7.01 2 12 2c5.2 0 9 4.03 9 9v3H8z"/>',
    },
    "edge-new-fill": {
      body: '<path fill="currentColor" d="M13.817 21.835q-.16.005-.317.005c-1.073 0-2.374-.62-3.42-1.758A6.75 6.75 0 0 1 8.3 15.5c0-1.418.518-2.565 1.201-3.406C9.558 14.58 11.86 17.7 16.5 17.7c1.678 0 2.717-.452 3.28-.697c.208-.09.35-.153.436-.153c.184 0 .284.1.284.3c0 .187-.101.321-.426.752l-.073.098a10 10 0 0 1-6.184 3.835m-3.115.081C5.792 21.28 2 17.084 2 12c0-1.28.74-2.329 1.897-3.08C5.058 8.164 6.587 7.75 8 7.75c2.276 0 3.635.765 4.428 1.647q.075.084.144.169A2.5 2.5 0 0 0 12 9.5h-.004a2.5 2.5 0 0 0-1.2.309a5 5 0 0 0-.236.117a6 6 0 0 0-1.51 1.168A6.35 6.35 0 0 0 7.3 15.5c0 2.137.855 3.965 2.044 5.258c.414.45.874.841 1.358 1.159m3.15-8.32c.266-.28.648-.684.648-1.596c0-.86-.338-2.171-1.328-3.272C12.165 7.61 10.524 6.75 8 6.75c-1.587 0-3.308.46-4.647 1.33q-.422.274-.79.605A10 10 0 0 1 12 2c5.523 0 10 4 10 8.5c0 2.8-2.2 4.85-5 4.85c-2 0-3.4-.65-3.4-1.35c0-.14.11-.254.252-.404"/>',
    },
    "edge-new-line": {
      body: '<path fill="currentColor" d="M6.949 18.204C6.3 16.775 6 15.201 6 14c0-1.496.59-3.093 1.603-4.323c.64-.778 1.474-1.436 2.465-1.818q-.72-.107-1.568-.109C5.99 7.75 4 9.612 4 12a7.99 7.99 0 0 0 2.949 6.204M12 20a8 8 0 0 0 2.649-.449c-3.364-.557-5.648-2.613-6.62-4.963c.095 1.026.43 2.296 1.03 3.357C9.776 19.217 10.752 20 12 20m4.5-8q-.001.71-.188 1.315q.309.034.688.035c1.776 0 3-1.234 3-2.85C20 7.37 16.704 4 12 4a7.97 7.97 0 0 0-5.272 1.983A6.8 6.8 0 0 1 8.5 5.75c2.407 0 4.396.601 5.807 1.715C15.737 8.595 16.5 10.198 16.5 12M12 9.5A2.5 2.5 0 0 0 9.5 12c0 2.5 2.3 5.7 7 5.7c.442 0 .84-.031 1.196-.082a7.4 7.4 0 0 0 1.736-.468q.197-.08.347-.147c.209-.09.352-.153.437-.153c.184 0 .284.1.284.3c0 .156-.07.276-.284.563l-.142.19l-.073.097a10 10 0 0 1-1.365 1.48A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4 10 8.5c0 2.8-2.2 4.85-5 4.85c-2 0-3.4-.65-3.4-1.35c0-.14.11-.254.252-.404c.266-.28.648-.684.648-1.596A2.5 2.5 0 0 0 12 9.5"/>',
    },
    "edit-2-fill": {
      body: '<path fill="currentColor" d="M9.243 18.997H21v2H3v-4.243l9.9-9.9l4.242 4.243zm5.07-13.557l2.122-2.121a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.415l-2.122 2.121z"/>',
    },
    "edit-2-line": {
      body: '<path fill="currentColor" d="M5 18.89h1.414l9.314-9.314l-1.414-1.414L5 17.476zm16 2H3v-4.243L16.435 3.212a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L9.243 18.89H21zM15.728 6.748l1.414 1.414l1.414-1.414l-1.414-1.414z"/>',
    },
    "edit-box-fill": {
      body: '<path fill="currentColor" d="m16.757 2.997l-7.466 7.466l.008 4.247l4.238-.008L21 7.24v12.758a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1zm3.728-.9L21.9 3.511l-9.193 9.193l-1.412.002l-.002-1.416z"/>',
    },
    "edit-box-line": {
      body: '<path fill="currentColor" d="m16.757 2.997l-2 2H5v14h14V9.239l2-2v12.758a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1zm3.728-.9L21.9 3.511l-9.193 9.193l-1.412.002l-.002-1.416z"/>',
    },
    "edit-circle-fill": {
      body: '<path fill="currentColor" d="M16.626 3.129L9.29 10.462l.01 4.248l4.238-.008l7.331-7.33A9.96 9.96 0 0 1 22 11.996c0 5.523-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10c1.669 0 3.242.409 4.626 1.131m3.86-1.032l1.413 1.414l-9.192 9.193l-1.412.002l-.002-1.416z"/>',
    },
    "edit-circle-line": {
      body: '<path fill="currentColor" d="M12.684 4.025a8 8 0 1 0 7.287 7.287a8 8 0 0 0-.603-2.439l1.5-1.502A9.94 9.94 0 0 1 22 11.997c0 5.523-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10q.378 0 .749.027a10 10 0 0 1 3.877 1.104L15.125 4.63a8 8 0 0 0-2.44-.604m7.801-1.928L21.9 3.511l-9.193 9.193l-1.412.002l-.002-1.416z"/>',
    },
    "edit-fill": {
      body: '<path fill="currentColor" d="M7.243 17.997H3v-4.243L14.435 2.319a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.415zm-4.243 2h18v2H3z"/>',
    },
    "edit-line": {
      body: '<path fill="currentColor" d="M6.414 15.89L16.556 5.748l-1.414-1.414L5 14.476v1.414zm.829 2H3v-4.243L14.435 2.212a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414zM3 19.89h18v2H3z"/>',
    },
    "eject-fill": {
      body: '<path fill="currentColor" d="m12.416 3.624l7.066 10.599a.5.5 0 0 1-.416.777H4.934a.5.5 0 0 1-.416-.777l7.066-10.599a.5.5 0 0 1 .832 0M5 17h14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2"/>',
    },
    "eject-line": {
      body: '<path fill="currentColor" d="M7.737 13h8.526L12 6.606zm4.679-9.376l7.066 10.599a.5.5 0 0 1-.416.777H4.934a.5.5 0 0 1-.416-.777l7.066-10.599a.5.5 0 0 1 .832 0M5 17h14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2"/>',
    },
    "emoji-sticker-fill": {
      body: '<path fill="currentColor" d="M21.902 10.598a9.99 9.99 0 0 0-9.381 3.873a4.98 4.98 0 0 1-3.854-1.246l-1.334 1.49a6.98 6.98 0 0 0 4.014 1.753A10 10 0 0 0 10.5 20.5q0 .714.098 1.402C5.738 21.221 2 17.047 2 12C2 6.477 6.477 2 12 2c5.047 0 9.22 3.739 9.902 8.598m-.031 2.019a7.99 7.99 0 0 0-7.964 3.35A7.96 7.96 0 0 0 12.5 20.5q0 .701.117 1.37zM8.5 11.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m7 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "emoji-sticker-line": {
      body: '<path fill="currentColor" d="M10.52 19.863a10 10 0 0 1 .826-3.395a6.98 6.98 0 0 1-4.013-1.753l1.334-1.49a4.98 4.98 0 0 0 3.854 1.246a9.99 9.99 0 0 1 7.342-3.951a8 8 0 1 0-9.343 9.343m8.503-7.227a8.01 8.01 0 0 0-6.387 6.387zM22 12q0 .251-.012.5L12.5 21.988A10 10 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-12-2a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m7 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "emotion-2-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-4-9a4 4 0 0 0 8 0z"/>',
    },
    "emotion-2-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-4-7h8a4 4 0 0 1-8 0"/>',
    },
    "emotion-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-4-9a4 4 0 0 0 8 0zm0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m8 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "emotion-happy-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-5-9a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0zm1-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m8 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "emotion-happy-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-7h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0m1-2a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m8 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "emotion-laugh-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 9q-3 0-5 1a5 5 0 0 0 10 0q-2-1-5-1M8.5 7c-1.152 0-2.122.78-2.412 1.84L6.05 9h4.9A2.5 2.5 0 0 0 8.5 7m7 0c-1.152 0-2.122.78-2.412 1.84L13.05 9h4.9a2.5 2.5 0 0 0-2.45-2"/>',
    },
    "emotion-laugh-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 7q3 0 5 1a5 5 0 0 1-10 0q2-1 5-1M8.5 7a2.5 2.5 0 0 1 2.45 2h-4.9A2.5 2.5 0 0 1 8.5 7m7 0a2.5 2.5 0 0 1 2.45 2h-4.9a2.5 2.5 0 0 1 2.45-2"/>',
    },
    "emotion-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-4-7h8a4 4 0 0 1-8 0m0-2a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m8 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "emotion-normal-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-4-8v2h8v-2zm0-3a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m8 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "emotion-normal-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-4-6h8v2H8zm0-3a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m8 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "emotion-sad-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10a9.96 9.96 0 0 1-1.065 4.496a2 2 0 0 0-.398-.775l-.123-.135L19 14.172l-1.414 1.414l-.117.127a2 2 0 0 0 1.679 3.282A9.97 9.97 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2m0 13c-1.38 0-2.63.56-3.534 1.463l-.166.174l.945.86C10.035 17.182 10.982 17 12 17c.905 0 1.754.144 2.486.396l.269.1l.945-.86A5 5 0 0 0 12 15m-3.5-5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3"/>',
    },
    "emotion-sad-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10c0 .727-.078 1.435-.225 2.118l-1.782-1.783Q20 12.17 20 12a8 8 0 1 0-4.381 7.137q.232.37.553.691c.302.303.64.547 1.001.732A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2m7 12.172l1.414 1.414a2 2 0 1 1-2.93.11l.102-.11zM12 15c1.466 0 2.785.631 3.7 1.637l-.945.86C13.965 17.182 13.018 17 12 17s-1.965.183-2.755.496l-.945-.86A5 5 0 0 1 12 15m-3.5-5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m7 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "emotion-unhappy-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-5-5h2a3 3 0 1 1 6 0h2a5 5 0 0 0-10 0m1-6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m8 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "emotion-unhappy-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-3a5 5 0 0 1 10 0h-2a3 3 0 1 0-6 0zm1-6a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m8 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "empathize-fill": {
      body: '<path fill="currentColor" d="M18.364 10.98a4 4 0 0 1 0 5.656l-5.657 5.657a1 1 0 0 1-1.414 0l-5.657-5.657a4 4 0 1 1 5.657-5.657l.707.707l.707-.707a4 4 0 0 1 5.657 0M12 1a4 4 0 1 1 0 8a4 4 0 0 1 0-8"/>',
    },
    "empathize-line": {
      body: '<path fill="currentColor" d="M18.364 10.98a4 4 0 0 1 0 5.656l-5.657 5.657a1 1 0 0 1-1.414 0l-5.657-5.657a4 4 0 1 1 5.657-5.657l.707.707l.707-.707a4 4 0 0 1 5.657 0M7.051 12.392a2 2 0 0 0 0 2.829l4.95 4.95l4.95-4.95a2 2 0 1 0-2.83-2.827l-2.123 2.118l-2.119-2.12a2 2 0 0 0-2.828 0M12 1a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    emphasis: {
      body: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m-5.5 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m11 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M18 3v2H8v4h9v2H8v4h10v2H6V3z"/>',
    },
    "emphasis-cn": {
      body: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m-5.5 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m11 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M13 2v2h6v2h-1.968a18.2 18.2 0 0 1-3.621 6.302a14.7 14.7 0 0 0 5.327 3.042l-.536 1.93A16.7 16.7 0 0 1 12 13.726a16.7 16.7 0 0 1-6.2 3.547l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042a18 18 0 0 1-2.822-4.3h2.24A16 16 0 0 0 12 10.876A16.2 16.2 0 0 0 14.91 6H5V4h6V2z"/>',
    },
    "english-input": {
      body: '<path fill="currentColor" d="M14 10h2v.757a4.5 4.5 0 0 1 7 3.743V20h-2v-5.5c0-1.43-1.174-2.5-2.5-2.5S16 13.07 16 14.5V20h-2zm-2-6v2H4v5h8v2H4v5h8v2H2V4z"/>',
    },
    "equal-fill": {
      body: '<path fill="currentColor" d="M19 8H5v2h14zm0 6H5v2h14z"/>',
    },
    "equal-line": {
      body: '<path fill="currentColor" d="M19 8H5v2h14zm0 6H5v2h14z"/>',
    },
    "equalizer-2-fill": {
      body: '<path fill="currentColor" d="M3 7a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0m17 1h-8V6h8zm-6 9a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0m-2-1v2H4v-2z"/>',
    },
    "equalizer-2-line": {
      body: '<path fill="currentColor" d="M5 7a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m1.5-3.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7M12 8h8V6h-8zm4 9a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m1.5-3.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7M4 16v2h8v-2z"/>',
    },
    "equalizer-3-fill": {
      body: '<path fill="currentColor" d="M7 3v3H3v2h4v3h3V3zm5 5h9V6h-9zm5 5v3h4v2h-4v3h-3v-8zm-5 5H3v-2h9z"/>',
    },
    "equalizer-3-line": {
      body: '<path fill="currentColor" d="M7 3v3H3v2h4v3h2V3zm4 5h10V6H11zm6 5v3h4v2h-4v3h-2v-8zm-4 5H3v-2h10z"/>',
    },
    "equalizer-fill": {
      body: '<path fill="currentColor" d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4z"/>',
    },
    "equalizer-line": {
      body: '<path fill="currentColor" d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4zM9 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m6 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-6 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "eraser-fill": {
      body: '<path fill="currentColor" d="M14 18.997h7v2h-9l-3.998.002l-6.487-6.488a1 1 0 0 1 0-1.414L12.12 2.491a1 1 0 0 1 1.414 0l7.779 7.778a1 1 0 0 1 0 1.414zm1.657-4.486l3.535-3.535l-6.364-6.364l-3.535 3.535z"/>',
    },
    "eraser-line": {
      body: '<path fill="currentColor" d="m8.586 8.854l-4.95 4.95L8.83 19l1.17-.001v-.001h1.171l3.779-3.779zM10 7.44l6.364 6.364l2.828-2.828l-6.364-6.364zm4 11.557h7v2h-9l-3.998.002l-6.487-6.488a1 1 0 0 1 0-1.414L12.12 2.491a1 1 0 0 1 1.414 0l7.779 7.778a1 1 0 0 1 0 1.414z"/>',
    },
    "error-warning-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-1-7v2h2v-2zm0-8v6h2V7z"/>',
    },
    "error-warning-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1-5h2v2h-2zm0-8h2v6h-2z"/>',
    },
    "eth-fill": {
      body: '<path fill="currentColor" d="M12 0L4.63 12.22L12 16.574l7.37-4.354zm0 24L4.63 13.617L12 18l7.37-4.383z"/>',
    },
    "eth-line": {
      body: '<path fill="currentColor" d="M8.149 15.304L12 20.6l3.851-5.296L12 17.674zm8.988-3.14L12 3.816l-5.137 8.348L12 15.326zM4 13l8-13l8 13l-8 11z"/>',
    },
    "evernote-fill": {
      body: '<path fill="currentColor" d="M8.63 7.754c-.215.201-.545.217-.742.217h-2.11c-.61 0-.974 0-1.22.033c-.134.017-.298.084-.381.117c-.033.016-.033 0-.017-.016l4.816-4.94c.017-.017.033-.017.017.017a1.7 1.7 0 0 0-.116.382c-.033.249-.033.615-.033 1.23v2.212c0 .2-.017.533-.214.748m4.683 14.184c-.56-.366-.857-.848-.973-1.147a2.4 2.4 0 0 1-.181-.915a2.513 2.513 0 0 1 2.507-2.51c.412 0 .742.332.742.748a.74.74 0 0 1-.38.648a1 1 0 0 1-.28.1c-.082.017-.396.05-.543.183a.78.78 0 0 0-.298.582a.92.92 0 0 0 .264.649c.297.299.693.465 1.122.465a2.035 2.035 0 0 0 2.028-2.045c0-1.014-.676-1.913-1.567-2.311c-.132-.067-.346-.117-.544-.167a7 7 0 0 0-.495-.083c-.693-.084-2.424-.632-2.54-2.178c0 0-.51 2.328-1.534 2.96c-.098.05-.23.1-.379.133c-.148.033-.312.05-.363.05c-1.665.1-3.43-.433-4.65-1.696c0 0-.825-.682-1.253-2.594c-.099-.466-.297-1.298-.412-2.08c-.05-.282-.067-.498-.083-.698c0-.814.495-1.363 1.121-1.445h3.365c.576 0 .907-.15 1.121-.35c.28-.266.347-.649.347-1.098V3.631c.08-.615.627-1.131 1.434-1.131h.396c.165 0 .363.017.544.033c.132.017.247.05.445.1c1.006.25 1.22 1.28 1.22 1.28l2.854.5c.907.166 3.15.316 3.578 2.594c1.006 5.42.396 10.675.347 10.675c-.71 5.121-4.931 4.871-4.931 4.871a3.43 3.43 0 0 1-2.03-.615m2.622-10.309c-.033.084-.066.183-.05.233c.018.05.051.066.084.083c.198.1.527.15 1.006.2c.478.05.808.083 1.022.05c.033 0 .067-.017.1-.067c.032-.05.016-.15.016-.233c-.05-.449-.462-.781-1.006-.848c-.545-.05-1.006.167-1.172.582"/>',
    },
    "evernote-line": {
      body: '<path fill="currentColor" d="M10.501 8.5a1 1 0 0 1-1 1H6.002c-.336 0-.501.261-.501.532c0 1.32.254 2.371.664 3.193c.216.433.399.67.523.79c.735.76 1.886 1.16 3.092 1.089c.095-.006.199-.064.332-.208c.121-.132.203-.268.214-.293a2 2 0 0 1 2.531-1.073c.693.258 1.277.434 1.813.56c.196.046.375.083.586.123c-.077-.015.402.073.518.097c.34.07.598.146.883.29a5.1 5.1 0 0 1 1.775 1.475a32 32 0 0 0 .087-2.026a34 34 0 0 0-.558-6.673c-.075-.398-.237-.562-.664-.718a4 4 0 0 0-.587-.155c-.146-.028-.65-.11-.693-.118l-.011-.002l-2.33-.407l-.527-.092a2 2 0 0 1-1.524-1.26l-.034-.088a6 6 0 0 0-.702-.036c-.271 0-.388.124-.388.463zm6.23 11.639c.352-.356.56-.829.587-1.327c.054-1.036-.824-2.48-2.317-2.634c-.617-.063-1.586-.306-2.842-.774c0 0-.7 1.603-2.26 1.696c-1.665.1-3.43-.433-4.65-1.696c0 0-1.748-1.64-1.748-5.372c0-.814.29-1.422.648-1.904c.96-1.292 2.505-2.78 4.133-4.304C9.001 3.15 9.702 2.5 10.89 2.5c2.04 0 2.32.664 2.605 1.414l2.854.499c.907.166 3.15.316 3.578 2.594c1.006 5.42.458 9.87.347 10.675c-.71 5.121-4.772 4.871-4.931 4.871c-2.059 0-3.178-1.373-3.183-2.677a2.5 2.5 0 0 1 1.038-2.034a2.6 2.6 0 0 1 1.527-.478c.304 0 .687.318.687.753c0 .37-.255.575-.383.645c-.223.123-1.12.174-1.12.865c0 .317.348 1.114 1.385 1.114a2.03 2.03 0 0 0 1.437-.602m-1.796-9.51c.166-.415.627-.632 1.172-.582c.544.067.956.4 1.006.848c0 .083.017.183-.017.233c-.032.05-.066.067-.1.067c-.213.033-.543 0-1.021-.05c-.48-.05-.808-.1-1.006-.2c-.033-.017-.066-.033-.083-.083s.016-.15.05-.233"/>',
    },
    "exchange-2-fill": {
      body: '<path fill="currentColor" d="M7 21.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m10-10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9M3 8a5 5 0 0 1 5-5h3v2H8a3 3 0 0 0-3 3v3H3zm16 5v3a3 3 0 0 1-3 3h-3v2h3a5 5 0 0 0 5-5v-3z"/>',
    },
    "exchange-2-line": {
      body: '<path fill="currentColor" d="M7 21.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m10-10a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m-10 8a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m10-10a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5M3 8a5 5 0 0 1 5-5h3v2H8a3 3 0 0 0-3 3v3H3zm18 5h-2v3a3 3 0 0 1-3 3h-3v2h3a5 5 0 0 0 5-5z"/>',
    },
    "exchange-box-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m9 6h-4v2h9l-5-5zm-5 4l5 5v-3h4v-2z"/>',
    },
    "exchange-box-line": {
      body: '<path fill="currentColor" d="M4.005 5.003v14h16v-14zm-1-2h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m9 6v-3l5 5h-9v-2zm-5 4h9v2h-4v3z"/>',
    },
    "exchange-cny-fill": {
      body: '<path fill="currentColor" d="M5.378 4.513a9.96 9.96 0 0 1 6.627-2.51c5.523 0 10 4.477 10 10a9.95 9.95 0 0 1-1.793 5.715l-2.707-5.715h2.5A8 8 0 0 0 6.279 6.415zm13.253 14.98a9.96 9.96 0 0 1-6.626 2.51c-5.523 0-10-4.477-10-10c0-2.125.663-4.095 1.793-5.715l2.707 5.715h-2.5A8 8 0 0 0 17.73 17.59zm-5.626-5.955h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586L8.469 8.417l1.415-1.414l2.12 2.121l2.122-2.121l1.414 1.414l-2.12 2.121h2.585v2h-3z"/>',
    },
    "exchange-cny-line": {
      body: '<path fill="currentColor" d="M19.379 15.106A8.001 8.001 0 0 0 8.035 5.056l-.993-1.737a10 10 0 0 1 9.962.023c4.49 2.593 6.21 8.143 4.118 12.77l1.342.775l-4.166 2.214l-.165-4.714zM4.629 8.9a8.001 8.001 0 0 0 11.345 10.05l.992 1.737a10 10 0 0 1-9.962-.024c-4.49-2.593-6.21-8.142-4.117-12.77L1.545 7.12L5.71 4.905l.165 4.714zm8.375 4.638h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586L8.469 8.417l1.414-1.414l2.121 2.121l2.122-2.121l1.414 1.414l-2.122 2.121h2.586v2h-3z"/>',
    },
    "exchange-dollar-fill": {
      body: '<path fill="currentColor" d="M5.378 4.513a9.96 9.96 0 0 1 6.627-2.51c5.523 0 10 4.477 10 10a9.95 9.95 0 0 1-1.793 5.715l-2.707-5.715h2.5A8 8 0 0 0 6.279 6.415zm13.253 14.98a9.96 9.96 0 0 1-6.626 2.51c-5.523 0-10-4.477-10-10c0-2.125.663-4.095 1.793-5.715l2.707 5.715h-2.5A8 8 0 0 0 17.73 17.59zm-10.126-5.49h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1v-1h2v1h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v1h-2v-1h-2.5z"/>',
    },
    "exchange-dollar-line": {
      body: '<path fill="currentColor" d="M19.379 15.106A8.001 8.001 0 0 0 8.035 5.056l-.993-1.737a10 10 0 0 1 9.962.023c4.49 2.593 6.21 8.143 4.118 12.77l1.342.775l-4.166 2.214l-.165-4.714zM4.629 8.9a8.001 8.001 0 0 0 11.345 10.05l.992 1.737a10 10 0 0 1-9.962-.024c-4.49-2.593-6.21-8.142-4.117-12.77L1.545 7.12L5.71 4.905l.165 4.714zm3.875 5.103h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 0 1 0-5h1v-1h2v1h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v1h-2v-1h-2.5z"/>',
    },
    "exchange-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-13h-4v2h9l-5-5zm-5 4l5 5v-3h4v-2z"/>',
    },
    "exchange-funds-fill": {
      body: '<path fill="currentColor" d="M5.378 4.513a9.96 9.96 0 0 1 6.627-2.51c5.523 0 10 4.477 10 10a9.95 9.95 0 0 1-1.793 5.715l-2.707-5.715h2.5A8 8 0 0 0 6.279 6.415zm13.253 14.98a9.96 9.96 0 0 1-6.626 2.51c-5.523 0-10-4.477-10-10c0-2.125.663-4.095 1.793-5.715l2.707 5.715h-2.5A8 8 0 0 0 17.73 17.59zM13.42 14.83l-2.828-2.828l-2.829 2.828l-1.414-1.414l4.243-4.243l2.828 2.829l2.828-2.829l1.415 1.415z"/>',
    },
    "exchange-funds-line": {
      body: '<path fill="currentColor" d="M19.379 15.106A8.001 8.001 0 0 0 8.035 5.056l-.993-1.737a10 10 0 0 1 9.962.023c4.49 2.593 6.21 8.143 4.118 12.77l1.342.775l-4.166 2.214l-.165-4.714zM4.629 8.9a8.001 8.001 0 0 0 11.345 10.05l.992 1.737a10 10 0 0 1-9.962-.024c-4.49-2.593-6.21-8.142-4.117-12.77L1.545 7.12L5.71 4.905l.165 4.714zm8.79 5.931l-2.829-2.828l-2.828 2.828l-1.415-1.414l4.243-4.243l2.828 2.829l2.829-2.829l1.414 1.415z"/>',
    },
    "exchange-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-7h9v2h-4v3zm5-4v-3l5 5h-9v-2z"/>',
    },
    "expand-diagonal-2-fill": {
      body: '<path fill="currentColor" d="M3 3h7.5L7.457 6.043l3.25 3.25l-1.414 1.414l-3.25-3.25L3 10.5zm18 18h-7.5l3.043-3.043l-3.25-3.25l1.414-1.414l3.25 3.25L21 13.5z"/>',
    },
    "expand-diagonal-2-line": {
      body: '<path fill="currentColor" d="M6.414 5H10V3H3v7h2V6.414l4.293 4.293l1.414-1.414zM21 14h-2v3.586l-4.293-4.293l-1.414 1.414L17.586 19H14v2h7z"/>',
    },
    "expand-diagonal-fill": {
      body: '<path fill="currentColor" d="M21 3h-7.5l3.043 3.043l-3.25 3.25l1.414 1.414l3.25-3.25L21 10.5zM3 21h7.5l-3.043-3.043l3.25-3.25l-1.414-1.414l-3.25 3.25L3 13.5z"/>',
    },
    "expand-diagonal-line": {
      body: '<path fill="currentColor" d="M17.586 5H14V3h7v7h-2V6.414l-4.293 4.293l-1.414-1.414zM3 14h2v3.586l4.293-4.293l1.414 1.414L6.414 19H10v2H3z"/>',
    },
    "expand-diagonal-s-2-fill": {
      body: '<path fill="currentColor" d="M5 5v7.5l3.043-3.043l6.5 6.5L11.5 19H19v-7.5l-3.043 3.043l-6.5-6.5L12.5 5z"/>',
    },
    "expand-diagonal-s-2-line": {
      body: '<path fill="currentColor" d="M7 8.414V12H5V5h7v2H8.414L17 15.586V12h2v7h-7v-2h3.586z"/>',
    },
    "expand-diagonal-s-fill": {
      body: '<path fill="currentColor" d="M19 5h-7.5l3.043 3.043l-6.5 6.5L5 11.5V19h7.5l-3.043-3.043l6.5-6.5L19 12.5z"/>',
    },
    "expand-diagonal-s-line": {
      body: '<path fill="currentColor" d="M15.586 7H12V5h7v7h-2V8.414L8.414 17H12v2H5v-7h2v3.586z"/>',
    },
    "expand-height-fill": {
      body: '<path fill="currentColor" d="M18 2H6v2h12zm-1.05 7.45L12 4.5L7.053 9.447L11 9.448v5.102H7.05L12 19.5l4.95-4.95H13v-5.1zM18 20v2H6v-2z"/>',
    },
    "expand-height-line": {
      body: '<path fill="currentColor" d="M6 2h12v2H6zm10.95 7.45L12 4.5L7.053 9.447l1.414 1.415L11 8.328v7.343l-2.535-2.535l-1.414 1.414L12 19.5l4.95-4.95l-1.414-1.414L13 15.672V8.328l2.536 2.536zM18 20v2H6v-2z"/>',
    },
    "expand-horizontal-fill": {
      body: '<path fill="currentColor" d="m.5 12l4.95-4.95L5.449 11H10v2H5.448v3.947zM14 13h4.55v3.95L23.5 12l-4.95-4.95V11H14z"/>',
    },
    "expand-horizontal-line": {
      body: '<path fill="currentColor" d="m.5 12l4.95-4.95l1.414 1.414L4.328 11H10v2H4.328l2.533 2.533l-1.414 1.414zM14 13h5.67l-2.534 2.535l1.414 1.414L23.5 12l-4.95-4.95l-1.414 1.415L19.672 11H14z"/>',
    },
    "expand-horizontal-s-fill": {
      body: '<path fill="currentColor" d="M7.45 7.05L2.5 12l4.947 4.947L7.448 13h9.102v3.95L21.5 12l-4.95-4.95V11h-9.1z"/>',
    },
    "expand-horizontal-s-line": {
      body: '<path fill="currentColor" d="M7.45 7.05L2.5 12l4.947 4.947l1.414-1.414L6.328 13h11.343l-2.535 2.535l1.414 1.414L21.5 12l-4.95-4.95l-1.414 1.415L17.672 11H6.328l2.536-2.535z"/>',
    },
    "expand-left-fill": {
      body: '<path fill="currentColor" d="M10 5v6h6v2h-6v6l-7-7zm8 14V5h2v14z"/>',
    },
    "expand-left-line": {
      body: '<path fill="currentColor" d="m10.071 4.929l1.414 1.414L6.828 11H16v2H6.828l4.657 4.657l-1.414 1.414L3 12.001zM18.001 19V5h2v14z"/>',
    },
    "expand-left-right-fill": {
      body: '<path fill="currentColor" d="m9 6l-6 6l6 6zm6 12l6-6l-6-6z"/>',
    },
    "expand-left-right-line": {
      body: '<path fill="currentColor" d="M9.043 5.793L2.836 12l6.207 6.207l1.414-1.414L5.664 12l4.793-4.793zm5.914 12.414L21.164 12l-6.207-6.207l-1.414 1.414L18.336 12l-4.793 4.793z"/>',
    },
    "expand-right-fill": {
      body: '<path fill="currentColor" d="m14 5l7 7l-7 7v-6H8v-2h6zM4 19V5h2v14z"/>',
    },
    "expand-right-line": {
      body: '<path fill="currentColor" d="m17.172 11l-4.657-4.657l1.414-1.414L21 12l-7.071 7.071l-1.414-1.414L17.172 13H8v-2zM4 19V5h2v14z"/>',
    },
    "expand-up-down-fill": {
      body: '<path fill="currentColor" d="m18 9l-6-6l-6 6zm0 6l-6 6l-6-6z"/>',
    },
    "expand-up-down-line": {
      body: '<path fill="currentColor" d="M18.207 9.043L12 2.836L5.793 9.043l1.414 1.414L12 5.664l4.793 4.793zM5.793 14.957L12 21.164l6.207-6.207l-1.414-1.414L12 18.336l-4.793-4.793z"/>',
    },
    "expand-vertical-fill": {
      body: '<path fill="currentColor" d="m12 .5l4.95 4.95L13 5.447V10h-2V5.448l-3.948-.001zM11 14v4.55H7.05L12 23.5l4.95-4.95H13V14z"/>',
    },
    "expand-vertical-line": {
      body: '<path fill="currentColor" d="m12 .5l4.95 4.95l-1.415 1.413l-2.536-2.535V10h-2V4.328L8.467 6.86L7.052 5.447zM11 14v5.67l-2.535-2.535L7.05 18.55L12 23.5l4.95-4.95l-1.414-1.414L13 19.672v-5.673z"/>',
    },
    "expand-vertical-s-fill": {
      body: '<path fill="currentColor" d="M16.95 7.45L12 2.5L7.051 7.447H11v9.103H7.05L12 21.5l4.95-4.95H13V7.448z"/>',
    },
    "expand-vertical-s-line": {
      body: '<path fill="currentColor" d="M16.95 7.45L12 2.5L7.051 7.447L8.466 8.86L11 6.328V17.67l-2.536-2.535L7.05 16.55L12 21.5l4.95-4.95l-1.414-1.414L13 17.672V6.328l2.535 2.535z"/>',
    },
    "expand-width-fill": {
      body: '<path fill="currentColor" d="M2 6v12h2V6zm7.45 1.05L4.5 12l4.947 4.947L9.448 13h5.102v3.95L19.5 12l-4.95-4.95V11h-5.1zM20 6h2v12h-2z"/>',
    },
    "expand-width-line": {
      body: '<path fill="currentColor" d="M2 18V6h2v12zM9.45 7.05L4.5 12l4.947 4.947l1.415-1.414L8.328 13h7.343l-2.535 2.535l1.414 1.414L19.5 12l-4.95-4.95l-1.414 1.415L15.672 11H8.328l2.536-2.536zM20 6h2v12h-2z"/>',
    },
    "export-fill": {
      body: '<path fill="currentColor" d="M21 3H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-9 13a3 3 0 0 1-3-3H4V5h16v8h-5a3 3 0 0 1-3 3m4-5h-3v3h-2v-3H8l4-4.5z"/>',
    },
    "export-line": {
      body: '<path fill="currentColor" d="M22 4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1zM4 15h3.416a5.001 5.001 0 0 0 9.168 0H20v4H4zM4 5h16v8h-5a3 3 0 1 1-6 0H4zm12 6h-3v3h-2v-3H8l4-4.5z"/>',
    },
    "external-link-fill": {
      body: '<path fill="currentColor" d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm11-3v9l-3.794-3.793l-5.999 6l-1.414-1.414l5.999-6L12 3z"/>',
    },
    "external-link-line": {
      body: '<path fill="currentColor" d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm11-3v8h-2V6.413l-7.793 7.794l-1.414-1.414L17.585 5H13V3z"/>',
    },
    "eye-2-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 5c-.513 0-1.008.077-1.473.22a2.5 2.5 0 1 1-3.306 3.307A5 5 0 1 0 12 7"/>',
    },
    "eye-2-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 3a5 5 0 1 1-4.78 3.527A2.499 2.499 0 0 0 12 9.5a2.5 2.5 0 0 0-1.473-2.28A5 5 0 0 1 12 7"/>',
    },
    "eye-close-fill": {
      body: '<path fill="currentColor" d="m10.13 15.842l-.787 2.94l-1.932-.517l.787-2.94a11 11 0 0 1-3.237-1.871l-2.153 2.153l-1.414-1.414l2.153-2.154a10.96 10.96 0 0 1-2.371-5.07l.9-.164A16.92 16.92 0 0 0 12 10c3.704 0 7.132-1.184 9.924-3.195l.9.163a10.96 10.96 0 0 1-2.37 5.071l2.153 2.154l-1.414 1.414l-2.154-2.153a11 11 0 0 1-3.237 1.872l.788 2.939l-1.932.517l-.788-2.94a11.1 11.1 0 0 1-3.74 0"/>',
    },
    "eye-close-line": {
      body: '<path fill="currentColor" d="m9.343 18.782l-1.932-.518l.787-2.939a11 11 0 0 1-3.237-1.872l-2.153 2.154l-1.414-1.414l2.153-2.154a10.96 10.96 0 0 1-2.371-5.07l1.968-.359a9.002 9.002 0 0 0 17.713 0l1.968.358a10.96 10.96 0 0 1-2.372 5.071l2.154 2.154l-1.414 1.414l-2.154-2.154a11 11 0 0 1-3.237 1.872l.788 2.94l-1.932.517l-.788-2.94a11 11 0 0 1-3.74 0z"/>',
    },
    "eye-fill": {
      body: '<path fill="currentColor" d="M1.182 12C2.122 6.88 6.608 3 12 3s9.878 3.88 10.819 9c-.94 5.12-5.427 9-10.819 9s-9.878-3.88-10.818-9M12 17a5 5 0 1 0 0-10a5 5 0 0 0 0 10m0-2a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "eye-line": {
      body: '<path fill="currentColor" d="M12 3c5.392 0 9.878 3.88 10.819 9c-.94 5.12-5.427 9-10.819 9s-9.878-3.88-10.818-9C2.122 6.88 6.608 3 12 3m0 16a9.005 9.005 0 0 0 8.778-7a9.005 9.005 0 0 0-17.555 0A9.005 9.005 0 0 0 12 19m0-2.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0-2a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"/>',
    },
    "eye-off-fill": {
      body: '<path fill="currentColor" d="M4.52 5.935L1.394 2.808l1.414-1.414l19.799 19.798l-1.414 1.415l-3.31-3.31A10.95 10.95 0 0 1 12 21c-5.392 0-9.878-3.88-10.818-9A11 11 0 0 1 4.52 5.935m10.238 10.237l-1.464-1.464a3 3 0 0 1-4.001-4.001L7.829 9.243a5 5 0 0 0 6.929 6.929M7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.95 10.95 0 0 1-2.012 4.593l-3.86-3.86Q17 12.373 17 12a5 5 0 0 0-5.732-4.947z"/>',
    },
    "eye-off-line": {
      body: '<path fill="currentColor" d="M17.883 19.297A10.95 10.95 0 0 1 12 21c-5.392 0-9.878-3.88-10.818-9A11 11 0 0 1 4.52 5.935L1.394 2.808l1.414-1.414l19.799 19.798l-1.414 1.415zM5.936 7.35A8.97 8.97 0 0 0 3.223 12a9.005 9.005 0 0 0 13.201 5.838l-2.028-2.028A4.5 4.5 0 0 1 8.19 9.604zm6.978 6.978l-3.242-3.241a2.5 2.5 0 0 0 3.241 3.241m7.893 2.265l-1.431-1.431A8.9 8.9 0 0 0 20.778 12A9.005 9.005 0 0 0 9.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.95 10.95 0 0 1-2.012 4.593m-9.084-9.084Q11.86 7.5 12 7.5a4.5 4.5 0 0 1 4.492 4.778z"/>',
    },
    "facebook-box-fill": {
      body: '<path fill="currentColor" d="M15.402 21v-6.966h2.333l.349-2.708h-2.682V9.599c0-.784.218-1.319 1.342-1.319h1.434V5.857a19 19 0 0 0-2.09-.107c-2.067 0-3.482 1.262-3.482 3.58v1.996h-2.338v2.708h2.338V21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1z"/>',
    },
    "facebook-box-line": {
      body: '<path fill="currentColor" d="M14 19h5V5H5v14h7v-5h-2v-2h2v-1.654c0-1.337.14-1.822.4-2.311A2.73 2.73 0 0 1 13.536 6.9c.382-.205.857-.328 1.687-.381q.494-.032 1.278.08v1.9H16c-.917 0-1.296.043-1.522.164a.73.73 0 0 0-.314.314c-.12.226-.164.45-.164 1.368V12h2.5l-.5 2h-2zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "facebook-circle-fill": {
      body: '<path fill="currentColor" d="M12.001 2c-5.523 0-10 4.477-10 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89c1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.344 21.129 22 16.992 22 12c0-5.523-4.477-10-10-10"/>',
    },
    "facebook-circle-line": {
      body: '<path fill="currentColor" d="M13.001 19.938a8.001 8.001 0 0 0-1-15.938a8 8 0 0 0-1 15.938V14h-2v-2h2v-1.654c0-1.337.14-1.822.4-2.311A2.73 2.73 0 0 1 12.537 6.9c.382-.205.857-.328 1.687-.381q.494-.032 1.278.08v1.9h-.5c-.917 0-1.296.043-1.522.164a.73.73 0 0 0-.314.314c-.12.226-.164.45-.164 1.368V12h2.5l-.5 2h-2zm-1 2.062c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "facebook-fill": {
      body: '<path fill="currentColor" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4z"/>',
    },
    "facebook-line": {
      body: '<path fill="currentColor" d="M13 9h4.5l-.5 2h-4v9h-2v-9H7V9h4V7.128c0-1.783.186-2.43.534-3.082a3.64 3.64 0 0 1 1.512-1.512C13.698 2.186 14.345 2 16.128 2q.784 0 1.372.15V4h-1.372c-1.324 0-1.727.078-2.139.298a1.63 1.63 0 0 0-.691.692c-.22.411-.298.814-.298 2.138z"/>',
    },
    "fahrenheit-fill": {
      body: '<path fill="currentColor" d="M12 12h7v2h-7v7h-2V8a4 4 0 0 1 4-4h7v2h-7a2 2 0 0 0-2 2zm-7.5-2a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "fahrenheit-line": {
      body: '<path fill="currentColor" d="M12 12h7v2h-7v7h-2V8a4 4 0 0 1 4-4h7v2h-7a2 2 0 0 0-2 2zm-7.5-2a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "feedback-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM11 13v2h2v-2zm0-6v5h2V7z"/>',
    },
    "feedback-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM4 18.385L5.763 17H20V5H4zM11 13h2v2h-2zm0-6h2v5h-2z"/>',
    },
    "file-2-fill": {
      body: '<path fill="currentColor" d="M3 9h6a1 1 0 0 0 1-1V2h10.002c.551 0 .998.455.998.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.992zm0-2l5-4.997V7z"/>',
    },
    "file-2-line": {
      body: '<path fill="currentColor" d="m3 8l6.003-6h10.995C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993zm7-4v5H5v11h14V4z"/>',
    },
    "file-3-fill": {
      body: '<path fill="currentColor" d="M21 9v11.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2H14v6a1 1 0 0 0 1 1zm0-2h-5V2.003z"/>',
    },
    "file-3-line": {
      body: '<path fill="currentColor" d="M21 8v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995zm-2 1h-5V4H5v16h14z"/>',
    },
    "file-4-fill": {
      body: '<path fill="currentColor" d="M21 15h-7v7H3.998C3.447 22 3 21.545 3 21.008V2.992C3 2.444 3.445 2 3.993 2h16.014A1 1 0 0 1 21 3.007zm0 2l-5 4.997V17z"/>',
    },
    "file-4-line": {
      body: '<path fill="currentColor" d="m21 16l-6.003 6H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zm-2-1V4H5v16h9v-5z"/>',
    },
    "file-add-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-5 9H8v2h3v3h2v-3h3v-2h-3V8h-2z"/>',
    },
    "file-add-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM11 11V8h2v3h3v2h-3v3h-2v-3H8v-2z"/>',
    },
    "file-chart-2-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-4 6a4 4 0 1 0 4 4h-4z"/>',
    },
    "file-chart-2-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM12 8v4h4a4 4 0 1 1-4-4"/>',
    },
    "file-chart-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-5 5v10h2V7zm4 4v6h2v-6zm-8 2v4h2v-4z"/>',
    },
    "file-chart-line": {
      body: '<path fill="currentColor" d="M11 7h2v10h-2zm4 4h2v6h-2zm-8 2h2v4H7zm8-9H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-check-fill": {
      body: '<path fill="currentColor" d="m21 7l-5-5H3.999A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992h8.348A6 6 0 0 1 21 14.803zm-6.535 12.465L18 23l4.95-4.95l-1.414-1.414L18 20.172l-2.12-2.122z"/>',
    },
    "file-check-line": {
      body: '<path fill="currentColor" d="M12 20v2H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.999 2H16l5 5v7h-2V8h-4V4H5v16zm2.465-.535L18 23l4.95-4.95l-1.414-1.414L18 20.172l-2.12-2.122z"/>',
    },
    "file-close-fill": {
      body: '<path fill="currentColor" d="M18 13c1.093 0 2.117.292 3 .803V7l-5-5H3.999A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992h8.81A6 6 0 0 1 18 13m3.536 8.121L19.414 19l2.122-2.121l-1.415-1.415l-2.12 2.122l-2.122-2.122l-1.414 1.415l2.12 2.12l-2.12 2.122l1.414 1.414L18 20.415l2.121 2.12z"/>',
    },
    "file-close-line": {
      body: '<path fill="currentColor" d="M12 22v-2H5V4h10v4h4v5h2V7l-5-5H3.999A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992zm9.536-.879L19.414 19l2.122-2.121l-1.415-1.415l-2.12 2.122l-2.122-2.122l-1.414 1.415l2.12 2.12l-2.12 2.122l1.414 1.414L18 20.415l2.121 2.12z"/>',
    },
    "file-cloud-fill": {
      body: '<path fill="currentColor" d="M14.997 2L21 8l.001 4.26A5.47 5.47 0 0 0 17.5 11l-.221.004a5.5 5.5 0 0 0-5.127 4.205l-.016.074l-.03.02A4.75 4.75 0 0 0 10.878 22H3.993a.993.993 0 0 1-.986-.876L3 21.008V2.992c0-.498.387-.927.885-.985L4.002 2zM17.5 13a3.5 3.5 0 0 1 3.5 3.5l-.002.103a2.75 2.75 0 0 1-.58 5.392L20.25 22h-5.5l-.168-.005a2.75 2.75 0 0 1-.579-5.393L14 16.5a3.5 3.5 0 0 1 3.5-3.5"/>',
    },
    "file-cloud-line": {
      body: '<path fill="currentColor" d="M14.997 2L21 8l.001 4.26a5.5 5.5 0 0 0-2-1.053L19 9h-5V4H5v16h5.06a4.7 4.7 0 0 0 .817 2H3.993a.993.993 0 0 1-.986-.876L3 21.008V2.992c0-.498.387-.927.885-.985L4.002 2zM17.5 13a3.5 3.5 0 0 1 3.5 3.5l-.002.103a2.75 2.75 0 0 1-.58 5.392L20.25 22h-5.5l-.168-.005a2.75 2.75 0 0 1-.579-5.393L14 16.5a3.5 3.5 0 0 1 3.5-3.5m0 2a1.5 1.5 0 0 0-1.473 1.215l-.02.14L16 16.5v1.62l-1.444.406a.75.75 0 0 0 .08 1.465l.109.01h5.51a.75.75 0 0 0 .19-1.475l-1.013-.283L19 18.12V16.5l-.007-.145A1.5 1.5 0 0 0 17.5 15"/>',
    },
    "file-code-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm1.657 10L14.12 8.464L12.707 9.88L14.828 12l-2.12 2.121l1.413 1.415zM6.343 12l3.536 3.536l1.414-1.415L9.172 12l2.12-2.121L9.88 8.464z"/>',
    },
    "file-code-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM17.657 12l-3.536 3.536l-1.414-1.415L14.828 12l-2.12-2.121l1.413-1.415zM6.343 12L9.88 8.464l1.414 1.415L9.172 12l2.12 2.121l-1.413 1.415z"/>',
    },
    "file-copy-2-fill": {
      body: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1 1 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1zm2 0h8v10h2V4H9zm-2 5v2h6v-2zm0 4v2h6v-2z"/>',
    },
    "file-copy-2-line": {
      body: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1 1 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1zM5.002 8L5 20h10V8zM9 6h8v10h2V4H9zm-2 5h6v2H7zm0 4h6v2H7z"/>',
    },
    "file-copy-fill": {
      body: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1 1 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1zm2 0h8v10h2V4H9z"/>',
    },
    "file-copy-line": {
      body: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1 1 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1zM5.002 8L5 20h10V8zM9 6h8v10h2V4H9z"/>',
    },
    "file-damage-fill": {
      body: '<path fill="currentColor" d="m3 14l4 2.5l3-3.5l3 4l2-2.5l3 .5l-3-3l-2 2.5l-3-5l-3.5 3.75L3 10V2.992C3 2.455 3.447 2 3.998 2H14v6a1 1 0 0 0 1 1h6v11.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008zm18-7h-5V2.003z"/>',
    },
    "file-damage-line": {
      body: '<path fill="currentColor" d="M19 9h-5V4H5v7.857l1.5 1.393L10 9.5l3 5l2-2.5l3 3l-3-.5l-2 2.5l-3-4l-3 3.5l-2-1.25V20h14zm2-1v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995z"/>',
    },
    "file-download-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-3 10V8h-2v4H8l4 4l4-4z"/>',
    },
    "file-download-line": {
      body: '<path fill="currentColor" d="M13 12h3l-4 4l-4-4h3V8h2zm2-8H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-edit-fill": {
      body: '<path fill="currentColor" d="M21 15.243v5.765a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.992V9h6a1 1 0 0 0 1-1V2h10.002c.551 0 .998.455.998.992v3.765l-8.999 9l-.006 4.238l4.246.006zm.778-6.435l1.414 1.414L15.414 18l-1.416-.002l.002-1.412zM3 7l5-4.997V7z"/>',
    },
    "file-edit-line": {
      body: '<path fill="currentColor" d="m21 6.757l-2 2V4h-9v5H5v11h14v-2.757l2-2v5.765a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V8l6.003-6h10.995C20.55 2 21 2.455 21 2.992zm.778 2.05l1.414 1.415L15.414 18l-1.416-.002l.002-1.412z"/>',
    },
    "file-excel-2-fill": {
      body: '<path fill="currentColor" d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zm-6.8 9L13 8h-2.4L9 10.286L7.4 8H5l2.8 4L5 16h2.4L9 13.714L10.6 16H13z"/>',
    },
    "file-excel-2-line": {
      body: '<path fill="currentColor" d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M4 4.735v14.53l10 1.429V3.306zM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zm-6.8-7l2.8 4h-2.4L9 13.714L7.4 16H5l2.8-4L5 8h2.4L9 10.286L10.6 8H13z"/>',
    },
    "file-excel-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-2.8 10L16 8h-2.4L12 10.286L10.4 8H8l2.8 4L8 16h2.4l1.6-2.286L13.6 16H16z"/>',
    },
    "file-excel-line": {
      body: '<path fill="currentColor" d="m13.2 12l2.8 4h-2.4L12 13.714L10.4 16H8l2.8-4L8 8h2.4l1.6 2.286L13.6 8H15V4H5v16h14V8h-3zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-fill": {
      body: '<path fill="currentColor" d="m3 8l6.003-6h10.995C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993zm7-4.5L4.5 9H10z"/>',
    },
    "file-forbid-fill": {
      body: '<path fill="currentColor" d="M21 11.674A7 7 0 0 0 12.255 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16l5 5zM18 23a5 5 0 1 1 0-10a5 5 0 0 1 0 10m-1.293-2.292a3 3 0 0 0 4.001-4.001zm-1.415-1.415l4.001-4a3 3 0 0 0-4.001 4.001"/>',
    },
    "file-forbid-line": {
      body: '<path fill="currentColor" d="M11.29 20a7 7 0 0 0 .965 2H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.999 2H16l5 5v4.674a7 7 0 0 0-2-.603V8h-4V4H5v16zM18 23a5 5 0 1 1 0-10a5 5 0 0 1 0 10m-1.293-2.292a3 3 0 0 0 4.001-4.001zm-1.415-1.415l4.001-4a3 3 0 0 0-4.001 4.001"/>',
    },
    "file-gif-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.999 2zm-3 8h-1v5h1zm-2 0H9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a1 1 0 0 0 1-1v-2H9v1h1v1H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2zm6 0h-3v5h1v-2h2v-1h-2v-1h2z"/>',
    },
    "file-gif-line": {
      body: '<path fill="currentColor" d="m16 2l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.999 2zm-1 2H5v16h14V8h-4zm-2 6v5h-1v-5zm-2 0v1H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v-1H9v-1h2v2a1 1 0 0 1-1 1H9a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2zm6 0v1h-2v1h2v1h-2v2h-1v-5z"/>',
    },
    "file-history-fill": {
      body: '<path fill="currentColor" d="m16 2l5 4.999v14.01a.993.993 0 0 1-.993.991H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-3 7h-2v6h5v-2h-3z"/>',
    },
    "file-history-line": {
      body: '<path fill="currentColor" d="m16 2l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.999 2zm-1 2H5v16h14V8h-4zm-2 5v4h3v2h-5V9z"/>',
    },
    "file-hwp-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.999 2zM9.333 14.667H8V18h8v-1.333l-6.667-.001zM12 14.333a1 1 0 1 0 0 2a1 1 0 0 0 0-2M12 9a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5m0 1.333a1.167 1.167 0 1 1 0 2.334a1.167 1.167 0 0 1 0-2.334M12.667 6h-1.334v1.333H8v1.334h8V7.333h-3.334z"/>',
    },
    "file-hwp-line": {
      body: '<path fill="currentColor" d="m16 2l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.999 2zm0 6.667H8V7.333h3.333V6h1.334l-.001 1.333h2.333L15 4H5v16h14V8l-3-.001zm-6.667 6v1.999H16V18H8v-3.333zM12 14.333a1 1 0 1 1 0 2a1 1 0 0 1 0-2M12 9a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5m0 1.333a1.167 1.167 0 1 0 0 2.334a1.167 1.167 0 0 0 0-2.334"/>',
    },
    "file-image-fill": {
      body: '<path fill="currentColor" d="m21 7l-5-5H3.993A.993.993 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992h16.014a.993.993 0 0 0 .993-.992zM11 9.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m6.5 7.5H8l5.5-7z"/>',
    },
    "file-image-line": {
      body: '<path fill="currentColor" d="M15 8V4H5v16h14V8zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM11 9.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m6.5 7.5l-4-7L8 17z"/>',
    },
    "file-info-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-5 5v2h2V7zm0 4v6h2v-6z"/>',
    },
    "file-info-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM11 11h2v6h-2zm0-4h2v2h-2z"/>',
    },
    "file-line": {
      body: '<path fill="currentColor" d="M9 2.003V2h10.998C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V8zM5.83 8H9V4.83zM11 4v5a1 1 0 0 1-1 1H5v10h14V4z"/>',
    },
    "file-list-2-fill": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M8 7v2h8V7zm0 4v2h8v-2zm0 4v2h5v-2z"/>',
    },
    "file-list-2-line": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2V4H5v16zM8 7h8v2H8zm0 4h8v2H8zm0 4h5v2H8z"/>',
    },
    "file-list-3-fill": {
      body: '<path fill="currentColor" d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12h4v4a3 3 0 0 1-3 3m-1-5v2a1 1 0 1 0 2 0v-2zM6 7v2h8V7zm0 4v2h8v-2zm0 4v2h5v-2z"/>',
    },
    "file-list-3-line": {
      body: '<path fill="currentColor" d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12h4v4a3 3 0 0 1-3 3m-1-5v2a1 1 0 1 0 2 0v-2zm-2 3V4H4v15a1 1 0 0 0 1 1zM6 7h8v2H6zm0 4h8v2H6zm0 4h5v2H6z"/>',
    },
    "file-list-fill": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M8 7v2h8V7zm0 4v2h8v-2zm0 4v2h8v-2z"/>',
    },
    "file-list-line": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2V4H5v16zM8 7h8v2H8zm0 4h8v2H8zm0 4h8v2H8z"/>',
    },
    "file-lock-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-1 9v-1a3 3 0 1 0-6 0v1H8v5h8v-5zm-2 0h-2v-1a1 1 0 1 1 2 0z"/>',
    },
    "file-lock-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM15 11h1v5H8v-5h1v-1a3 3 0 1 1 6 0zm-2 0v-1a1 1 0 1 0-2 0v1z"/>',
    },
    "file-marked-fill": {
      body: '<path fill="currentColor" d="M21 2.992v18.016a1 1 0 0 1-.993.992H3.993A.993.993 0 0 1 3 21.008V2.992A1 1 0 0 1 3.993 2h16.014c.548 0 .993.444.993.992M7 4v9l3.5-2l3.5 2V4z"/>',
    },
    "file-marked-line": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M7 4H5v16h14V4h-5v9l-3.5-2L7 13z"/>',
    },
    "file-music-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-5 10.05a2.5 2.5 0 1 0 2 2.45V10h3V8h-5z"/>',
    },
    "file-music-line": {
      body: '<path fill="currentColor" d="M16 8v2h-3v4.5a2.5 2.5 0 1 1-2-2.45V8h4V4H5v16h14V8zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-paper-2-fill": {
      body: '<path fill="currentColor" d="M20 2a3 3 0 0 1 3 3v2h-2v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16v2a1 1 0 0 0 .883.993L18 20a1 1 0 0 0 .993-.883L19 19v-4H3V5a3 3 0 0 1 3-3z"/>',
    },
    "file-paper-2-line": {
      body: '<path fill="currentColor" d="M20 2a3 3 0 0 1 3 3v2h-2v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16v2a1 1 0 0 0 .883.993L18 20a1 1 0 0 0 .993-.883L19 19V4H6a1 1 0 0 0-.993.883L5 5v10H3V5a3 3 0 0 1 3-3z"/>',
    },
    "file-paper-fill": {
      body: '<path fill="currentColor" d="M3 15V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16v2a1 1 0 1 0 2 0v-4z"/>',
    },
    "file-paper-line": {
      body: '<path fill="currentColor" d="M17 17v2a1 1 0 1 0 2 0V4H5v11H3V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2z"/>',
    },
    "file-pdf-2-fill": {
      body: '<path fill="currentColor" d="M3.999 2A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992h16.014A1 1 0 0 0 21 20.992V7l-5-5zM10.5 7.5h2c0 2.49 2.144 5.16 4.816 6.051l-.457 1.939c-3.136-.448-6.377.89-9.304 2.842l-1.18-1.613c1.086-.869 2.128-2.343 2.9-4.066c.77-1.716 1.225-3.576 1.225-5.153m.6 5.972c.267-.597.504-1.216.704-1.843a9.7 9.7 0 0 0 1.706 1.966c-.982.176-1.943.465-2.875.833q.247-.471.465-.956"/>',
    },
    "file-pdf-2-line": {
      body: '<path fill="currentColor" d="M5 4h10v4h4v12H5zM3.999 2A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992h16.014A1 1 0 0 0 21 20.992V7l-5-5zm6.5 5.5c0 1.577-.455 3.437-1.224 5.153c-.772 1.723-1.814 3.197-2.9 4.066l1.18 1.613c2.927-1.952 6.168-3.29 9.304-2.842l.457-1.939C14.644 12.661 12.5 9.99 12.5 7.5zm.6 5.972c.268-.597.505-1.216.705-1.843a9.7 9.7 0 0 0 1.706 1.966c-.982.176-1.944.465-2.875.833q.248-.471.465-.956"/>',
    },
    "file-pdf-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-4 14a4 4 0 0 0 0-8H8v8zm-2-6h2a2 2 0 1 1 0 4h-2z"/>',
    },
    "file-pdf-line": {
      body: '<path fill="currentColor" d="M12 16H8V8h4a4 4 0 0 1 0 8m-2-6v4h2a2 2 0 1 0 0-4zm5-6H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-ppt-2-fill": {
      body: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zM2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M5 8v8h2v-2h6V8zm2 2h4v2H7z"/>',
    },
    "file-ppt-2-line": {
      body: '<path fill="currentColor" d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M4 4.735v14.53l10 1.429V3.306zM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zM5 8h8v6H7v2H5zm2 2v2h4v-2z"/>',
    },
    "file-ppt-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zM8 8v8h2v-2h6V8zm2 2h4v2h-4z"/>',
    },
    "file-ppt-line": {
      body: '<path fill="currentColor" d="M3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM5 4v16h14V8h-3v6h-6v2H8V8h7V4zm5 6v2h4v-2z"/>',
    },
    "file-reduce-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-8 9v2h8v-2z"/>',
    },
    "file-reduce-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM16 11v2H8v-2z"/>',
    },
    "file-search-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-2.471 12.446l2.21 2.21l1.415-1.413l-2.21-2.21a4.001 4.001 0 0 0-6.276-4.861a4 4 0 0 0 4.861 6.274m-.618-2.032a2 2 0 1 1-2.828-2.828a2 2 0 0 1 2.828 2.828"/>',
    },
    "file-search-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zm10.529 11.454a4.001 4.001 0 0 1-4.86-6.274a4 4 0 0 1 6.274 4.86l2.21 2.21l-1.413 1.415zm-.618-2.032a2 2 0 1 0-2.828-2.828a2 2 0 0 0 2.828 2.828"/>',
    },
    "file-settings-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zM8.595 12.812l-.992.572l1 1.732l.992-.573c.393.372.873.654 1.405.812V16.5h2v-1.145a3.5 3.5 0 0 0 1.405-.812l.992.573l1-1.732l-.991-.573a3.5 3.5 0 0 0 0-1.623l.991-.572l-1-1.732l-.992.573A3.5 3.5 0 0 0 13 8.645V7.5h-2v1.145a3.5 3.5 0 0 0-1.405.812l-.992-.573l-1 1.732l.992.573a3.5 3.5 0 0 0 0 1.623M12 13.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "file-settings-line": {
      body: '<path fill="currentColor" d="M8.595 12.812a3.5 3.5 0 0 1 0-1.623l-.992-.573l1-1.732l.992.573A3.5 3.5 0 0 1 11 8.645V7.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573l1 1.732l-.992.572a3.5 3.5 0 0 1 0 1.623l.992.573l-1 1.732l-.992-.573a3.5 3.5 0 0 1-1.405.812V16.5h-2v-1.145a3.5 3.5 0 0 1-1.405-.812l-.992.573l-1-1.732zM12 13.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-shield-2-fill": {
      body: '<path fill="currentColor" d="M21 10H11v7.382c0 1.563.777 3.023 2.074 3.892l1.083.726H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2h11.999L21 7zm-8 2h8v5.382c0 .897-.446 1.734-1.187 2.23L17 21.499l-2.812-1.885A2.68 2.68 0 0 1 13 17.383z"/>',
    },
    "file-shield-2-line": {
      body: '<path fill="currentColor" d="M14 9V4H5v16h6.056a5 5 0 0 0 1.18 1.085l1.39.915H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8v1zm-2 2h9v5.949c0 .99-.501 1.916-1.336 2.465L16.5 21.498l-3.164-2.084A2.95 2.95 0 0 1 12 16.95zm2 5.949c0 .316.162.614.436.795l2.064 1.36l2.064-1.36a.95.95 0 0 0 .436-.795V13h-5z"/>',
    },
    "file-shield-fill": {
      body: '<path fill="currentColor" d="M21 7v13.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2h11.999zM8 8v5.6c0 .85.446 1.643 1.187 2.114L12 17.5l2.813-1.786A2.51 2.51 0 0 0 16 13.6V8zm2 2h4v3.6c0 .158-.09.318-.26.425L12 15.131l-1.74-1.106A.51.51 0 0 1 10 13.6z"/>',
    },
    "file-shield-line": {
      body: '<path fill="currentColor" d="M14 8V4H5v16h14V9h-3v4.62c0 .844-.446 1.633-1.187 2.102L12 17.498L9.187 15.72C8.446 15.254 8 14.465 8 13.62V8zm7 0v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995zm-11 5.62c0 .15.087.304.255.41L12 15.133l1.745-1.101c.168-.107.255-.261.255-.412V10h-4z"/>',
    },
    "file-shred-fill": {
      body: '<path fill="currentColor" d="M22 12v2H2v-2h2V2.995c0-.55.445-.995.996-.995H15l5 5v5zM3 16h2v6H3zm16 0h2v6h-2zm-4 0h2v6h-2zm-4 0h2v6h-2zm-4 0h2v6H7z"/>',
    },
    "file-shred-line": {
      body: '<path fill="currentColor" d="M6 12h12V8h-4V4H6zm-2 0V2.995c0-.55.445-.995.996-.995H15l5 5v5h2v2H2v-2zm-1 4h2v6H3zm16 0h2v6h-2zm-4 0h2v6h-2zm-4 0h2v6h-2zm-4 0h2v6H7z"/>',
    },
    "file-text-fill": {
      body: '<path fill="currentColor" d="M21 9v11.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2H14v6a1 1 0 0 0 1 1zm0-2h-5V2.003zM8 7v2h3V7zm0 4v2h8v-2zm0 4v2h8v-2z"/>',
    },
    "file-text-line": {
      body: '<path fill="currentColor" d="M21 8v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995zm-2 1h-5V4H5v16h14zM8 7h3v2H8zm0 4h8v2H8zm0 4h8v2H8z"/>',
    },
    "file-transfer-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-4 9H8v2h4v3l4-4l-4-4z"/>',
    },
    "file-transfer-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM12 11V8l4 4l-4 4v-3H8v-2z"/>',
    },
    "file-unknow-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-5 13v2h2v-2zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.5 3.5 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2z"/>',
    },
    "file-unknow-line": {
      body: '<path fill="currentColor" d="M11 15h2v2h-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1a1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-upload-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-3 10h3l-4-4l-4 4h3v4h2z"/>',
    },
    "file-upload-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM13 12v4h-2v-4H8l4-4l4 4z"/>',
    },
    "file-user-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-4 9.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5M7.527 17h8.946a4.5 4.5 0 0 0-8.946 0"/>',
    },
    "file-user-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zm9 8.508a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5M7.527 17a4.5 4.5 0 0 1 8.946 0z"/>',
    },
    "file-video-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-1 9.667l-4.878-3.253a.4.4 0 0 0-.622.333v6.505a.4.4 0 0 0 .622.333L15 12.333a.4.4 0 0 0 0-.666"/>',
    },
    "file-video-line": {
      body: '<path fill="currentColor" d="M15 4v4h4v12H5V4zM3.999 2A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992h16.014A1 1 0 0 0 21 20.992V7l-5-5zM15 11.667l-4.88-3.253a.4.4 0 0 0-.621.333v6.505a.4.4 0 0 0 .622.333L15 12.333a.4.4 0 0 0 0-.666"/>',
    },
    "file-warning-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-5 13v2h2v-2zm0-8v6h2V7z"/>',
    },
    "file-warning-line": {
      body: '<path fill="currentColor" d="M15 4H5v16h14V8h-4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zM11 15h2v2h-2zm0-8h2v6h-2z"/>',
    },
    "file-word-2-fill": {
      body: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zM2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M11 8v4.989L9 11l-1.99 2L7 8H5v8h2l2-2l2 2h2V8z"/>',
    },
    "file-word-2-line": {
      body: '<path fill="currentColor" d="M17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zM2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M4 4.735v14.53l10 1.429V3.306zM11 8h2v8h-2l-2-2l-2 2H5V8h2l.01 5L9 11l2 1.989z"/>',
    },
    "file-word-fill": {
      body: '<path fill="currentColor" d="m16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2zm-2 6v4.989L12 11l-1.99 2L10 8H8v8h2l2-2l2 2h2V8z"/>',
    },
    "file-word-line": {
      body: '<path fill="currentColor" d="M16 8v8h-2l-2-2l-2 2H8V8h2v5l2-2l2 2V8h1V4H5v16h14V8zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008z"/>',
    },
    "file-zip-fill": {
      body: '<path fill="currentColor" d="M10 2v2h2V2h8.007c.548 0 .993.444.993.992v18.016a1 1 0 0 1-.993.992H3.993A.993.993 0 0 1 3 21.008V2.992A1 1 0 0 1 3.993 2zm2 2v2h2V4zm-2 2v2h2V6zm2 2v2h2V8zm-2 2v2h2v-2zm2 2v2h-2v3h4v-5z"/>',
    },
    "file-zip-line": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2V4H5v16zm-5-8v5h-4v-3h2v-2zm-2-8h2v2h-2zm-2 2h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2z"/>',
    },
    "film-fill": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM4 5v2h2V5zm14 0v2h2V5zM4 9v2h2V9zm14 0v2h2V9zM4 13v2h2v-2zm14 0v2h2v-2zM4 17v2h2v-2zm14 0v2h2v-2z"/>',
    },
    "film-line": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM8 5v14h8V5zM4 5v2h2V5zm14 0v2h2V5zM4 9v2h2V9zm14 0v2h2V9zM4 13v2h2v-2zm14 0v2h2v-2zM4 17v2h2v-2zm14 0v2h2v-2z"/>',
    },
    "filter-2-fill": {
      body: '<path fill="currentColor" d="M10 14L4 5V3h16v2l-6 9v6l-4 2z"/>',
    },
    "filter-2-line": {
      body: '<path fill="currentColor" d="M14 14v6l-4 2v-8L4 5V3h16v2zM6.404 5L12 13.394L17.596 5z"/>',
    },
    "filter-3-fill": {
      body: '<path fill="currentColor" d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"/>',
    },
    "filter-3-line": {
      body: '<path fill="currentColor" d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"/>',
    },
    "filter-fill": {
      body: '<path fill="currentColor" d="M21 4v2h-1l-6 9v7h-4v-7L4 6H3V4z"/>',
    },
    "filter-line": {
      body: '<path fill="currentColor" d="M21 4v2h-1l-5 7.5V22H9v-8.5L4 6H3V4zM6.404 6L11 12.894V20h2v-7.106L17.596 6z"/>',
    },
    "filter-off-fill": {
      body: '<path fill="currentColor" d="M6.929.515L21.07 14.657l-1.414 1.414l-3.823-3.822L14 14.999v7h-4v-7L4 6H3V4h4.585l-2.07-2.07zM21 4v2h-1l-1.915 2.872L13.213 4z"/>',
    },
    "filter-off-line": {
      body: '<path fill="currentColor" d="M6.929.515L21.07 14.657l-1.414 1.414l-3.823-3.822l-.834 1.25V22H9v-8.5L4 6H3V4h4.585l-2.07-2.07zM9.585 6H6.404L11 12.894V20h2v-7.106l1.392-2.087zM21 4v2h-1l-1.915 2.872l-1.442-1.443l.953-1.43h-2.383l-2-2z"/>',
    },
    "find-replace-fill": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617M16.659 9A6 6 0 0 0 11 5c-3.315 0-6 2.685-6 6h2a4 4 0 0 1 5.91-3.515L12 9zM17 11h-2a4 4 0 0 1-5.91 3.515L10 13H5.341A6 6 0 0 0 11 17c3.315 0 6-2.685 6-6"/>',
    },
    "find-replace-line": {
      body: '<path fill="currentColor" d="m18.033 16.618l4.28 4.282l-1.413 1.414l-4.282-4.281A8.96 8.96 0 0 1 11 20a9 9 0 0 1-8.065-5H9l-1.304 2.173A7 7 0 0 0 11 18a6.98 6.98 0 0 0 4.875-1.975l.15-.15A6.98 6.98 0 0 0 18 11c0-.695-.101-1.366-.29-2h2.067c.146.643.223 1.313.223 2a8.96 8.96 0 0 1-1.967 5.618M19.065 7H13l1.304-2.173A7 7 0 0 0 11 4a7 7 0 0 0-6.71 9H2.223A9 9 0 0 1 2 11c0-4.972 4.028-9 9-9a9 9 0 0 1 8.065 5"/>',
    },
    "finder-fill": {
      body: '<path fill="currentColor" d="M21.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2h-8.465Q10.5 7.966 10.5 13h3a17 17 0 0 0-.107 2.877c1.226-.211 2.704-.777 4.027-1.71l1.135 1.665c-1.642 1.095-3.303 1.779-4.976 2.043q.078.555.184 1.125H20zM6.556 14.168l-1.11 1.664C7.603 17.27 9.793 18 12.001 18v-2c-1.792 0-3.602-.603-5.445-1.832M17 7a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M7 7c-.552 0-1 .452-1 1v1a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1"/>',
    },
    "finder-line": {
      body: '<path fill="currentColor" d="M21.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-10.52 1.999L4.002 5v14h8.746a25 25 0 0 1-.163-1.02q-.445.02-.583.02c-2.208 0-4.398-.73-6.555-2.168l1.11-1.664C8.399 15.397 10.209 16 12 16q.199 0 .398-.01a24 24 0 0 1 .007-1.99H9.501v-1c0-3.275.32-5.94.98-8.001m2.12 0c-.665 1.583-1.044 4.412-1.09 7.001h3.123l-.14 1.124q-.152 1.207-.108 2.52q1.518-.449 3.06-1.476l1.11 1.664q-1.98 1.321-3.993 1.84q.086.65.219 1.327L20 19V5zM7.001 7a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1m10 0a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1"/>',
    },
    "fingerprint-2-fill": {
      body: '<path fill="currentColor" d="M12 1a9 9 0 0 1 9 9v4a8.99 8.99 0 0 1-3.811 7.355c.527-1.692.811-3.49.811-5.355v-2.001h-2V16l-.003.315a15.9 15.9 0 0 1-1.431 6.315a9.1 9.1 0 0 1-3.576.314A12.93 12.93 0 0 0 13 16V9h-2v7l-.004.288a10.95 10.95 0 0 1-2.088 6.167a9 9 0 0 1-2.625-1.503A7.96 7.96 0 0 0 8 16v-6l.005-.2a4 4 0 0 1 .549-1.832L7.109 6.523A5.97 5.97 0 0 0 6 10v6l-.004.225a5.97 5.97 0 0 1-1.12 3.272A8.95 8.95 0 0 1 3 14v-4a9 9 0 0 1 9-9m0 3c-1.296 0-2.496.41-3.476 1.11l1.444 1.444A4 4 0 0 1 16 10v2h2v-2a6 6 0 0 0-6-6"/>',
    },
    "fingerprint-2-line": {
      body: '<path fill="currentColor" d="M12 1a9 9 0 0 1 9 9v4a9 9 0 0 1-12.092 8.455q.192-.265.369-.542l.17-.28a10.9 10.9 0 0 0 1.55-5.345L11 16V9h2v7a13 13 0 0 1-.997 5.002a7 7 0 0 0 2.27-.38c.442-1.36.693-2.807.724-4.308L15 16v-3.001h2V16a17 17 0 0 1-.298 3.185a6.98 6.98 0 0 0 2.294-4.944L19 14v-4A7 7 0 0 0 7.808 4.394L6.383 2.968A8.96 8.96 0 0 1 12 1m-5 9a5 5 0 0 1 10 0v1h-2v-1a3 3 0 0 0-5.995-.176L9 10v6c0 1.567-.4 3.04-1.104 4.323l-.024.04q-.345.622-.782 1.179a9 9 0 0 1-1.237-.97l-.308-.3A8.97 8.97 0 0 1 3 14v-4c0-2.125.736-4.078 1.968-5.617l1.426 1.425a6.97 6.97 0 0 0-1.39 3.951L5 10v4a6.97 6.97 0 0 0 1.57 4.417a6.9 6.9 0 0 0 .426-2.176L7 16z"/>',
    },
    "fingerprint-fill": {
      body: '<path fill="currentColor" d="M17 13v1c0 2.77-.664 5.445-1.915 7.846l-.227.42l-1.746-.974a14.9 14.9 0 0 0 1.881-6.836L15 14v-1zm-6-3h2v4l-.005.379a12.94 12.94 0 0 1-2.691 7.549l-.231.29l-1.549-1.264a10.94 10.94 0 0 0 2.47-6.588L11 14zm1-4a5 5 0 0 1 5 5h-2a3 3 0 0 0-6 0v3c0 2.235-.82 4.344-2.27 5.977l-.212.23l-1.448-1.38a6.97 6.97 0 0 0 1.924-4.524L7 14v-3a5 5 0 0 1 5-5m0-4a9 9 0 0 1 9 9v3c0 1.698-.201 3.37-.596 4.99l-.14.539l-1.93-.526c.392-1.437.614-2.922.658-4.435L19 14v-3A7 7 0 0 0 7.808 5.394L6.383 3.968A8.96 8.96 0 0 1 12 2M4.968 5.383l1.426 1.425a6.97 6.97 0 0 0-1.39 3.951L5 11l.004 2c0 1.12-.264 2.203-.761 3.177l-.157.29l-1.736-.992c.379-.665.6-1.407.645-2.183L3.004 13v-2a8.94 8.94 0 0 1 1.964-5.617"/>',
    },
    "fingerprint-line": {
      body: '<path fill="currentColor" d="M17 13v1c0 2.77-.664 5.445-1.915 7.846l-.227.42l-1.746-.974a14.9 14.9 0 0 0 1.881-6.836L15 14v-1zm-6-3h2v4l-.005.379a12.94 12.94 0 0 1-2.691 7.549l-.231.29l-1.549-1.264a10.94 10.94 0 0 0 2.47-6.588L11 14zm1-4a5 5 0 0 1 5 5h-2a3 3 0 0 0-6 0v3c0 2.235-.82 4.344-2.27 5.977l-.212.23l-1.448-1.38a6.97 6.97 0 0 0 1.924-4.524L7 14v-3a5 5 0 0 1 5-5m0-4a9 9 0 0 1 9 9v3c0 1.698-.201 3.37-.596 4.99l-.14.539l-1.93-.526c.392-1.437.614-2.922.658-4.435L19 14v-3A7 7 0 0 0 7.808 5.394L6.383 3.968A8.96 8.96 0 0 1 12 2M4.968 5.383l1.426 1.425a6.97 6.97 0 0 0-1.39 3.951L5 11l.004 2c0 1.12-.264 2.203-.761 3.177l-.157.29l-1.736-.992c.379-.665.6-1.407.645-2.183L3.004 13v-2a8.94 8.94 0 0 1 1.964-5.617"/>',
    },
    "fire-fill": {
      body: '<path fill="currentColor" d="M12 23a7.5 7.5 0 0 1-5.138-12.963C8.204 8.774 11.5 6.5 11 1.5c6 4 9 8 3 14c1 0 2.5 0 5-2.47c.27.773.5 1.604.5 2.47A7.5 7.5 0 0 1 12 23"/>',
    },
    "fire-line": {
      body: '<path fill="currentColor" d="M12 23a7.5 7.5 0 0 0 7.5-7.5c0-.866-.23-1.697-.5-2.47q-2.5 2.47-3.8 2.47c3.995-7 1.8-10-4.2-14c.5 5-2.796 7.274-4.138 8.537A7.5 7.5 0 0 0 12 23m.71-17.765c3.241 2.75 3.257 4.887.753 9.274c-.761 1.333.202 2.991 1.737 2.991c.688 0 1.384-.2 2.119-.595a5.5 5.5 0 1 1-9.087-5.412c.126-.118.765-.685.793-.71c.424-.38.773-.717 1.118-1.086c1.23-1.318 2.114-2.78 2.566-4.462"/>',
    },
    "firebase-fill": {
      body: '<path fill="currentColor" d="M6.757 1.501L4 18.5L9.473 4.816L7.695 1.353a.5.5 0 0 0-.938.148m4.807 2.817L4 18.5l9.84-11.55l-1.399-2.623a.5.5 0 0 0-.877-.01m-.624 18.52L4 18.5L17.31 5.665a.5.5 0 0 1 .832.296L20 18.5l-6.94 4.337a2 2 0 0 1-2.12 0"/>',
    },
    "firebase-line": {
      body: '<path fill="currentColor" d="m9.223 8.707l-2.312 4.334l1.09-6.715zm1.145-2.148L7.695 1.353a.5.5 0 0 0-.938.148L4 18.5l1.748 1.093l5.192 3.244a2 2 0 0 0 2.12 0L20 18.5L18.142 5.961a.5.5 0 0 0-.841-.287l-2.735 2.637l-2.125-3.984a.5.5 0 0 0-.882 0zm2.701 3.196L8.667 14L12 7.75zm-5.837 8.407l9.36-9.025l1.238 8.36L12 21.143z"/>',
    },
    "firefox-fill": {
      body: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10s-10-4.477-10-10c0-1.463.314-2.854.88-4.106c.466-.939 1.233-1.874 1.85-2.194c-.653 1.283-.973 2.54-1.04 3.383c.454-1.5 1.315-2.757 2.52-3.644c2.066-1.519 4.848-1.587 5.956-.62c-2.056.707-4.296 3.548-3.803 6.876c.08.55.245 1.083.489 1.582c-.384-1.01-.418-2.433.202-3.358c.692-1.03 1.678-1.248 2.206-1.136c-.208-.044-.668.836-.736.991a3 3 0 0 0-.251 1.25a3.4 3.4 0 0 0 1.03 2.38c1.922 1.871 5.023 1.135 6.411-1.002c.954-1.471 1.07-3.968-.154-5.952a7 7 0 0 0-1.084-1.32c-1.85-1.766-4.48-2.57-6.982-2.205q-1.659.266-2.824.956C7.756 2.798 9.912 2 12 2"/>',
    },
    "firefox-line": {
      body: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10s-10-4.477-10-10c0-1.463.314-2.854.88-4.106c.466-.939 1.233-1.874 1.85-2.194c-.653 1.283-.973 2.54-1.04 3.383c.454-1.5 1.315-2.757 2.52-3.644c2.066-1.519 4.848-1.587 5.956-.62c-2.056.707-4.296 3.548-3.803 6.876c.08.55.245 1.083.489 1.582c-.384-1.01-.418-2.433.202-3.358c.692-1.03 1.678-1.248 2.206-1.136c-.208-.044-.668.836-.736.991a3 3 0 0 0-.251 1.25a3.4 3.4 0 0 0 1.03 2.38c1.922 1.871 5.023 1.135 6.411-1.002c.954-1.471 1.07-3.968-.154-5.952a7 7 0 0 0-1.084-1.32c-1.85-1.766-4.48-2.57-6.982-2.205q-1.659.266-2.824.956C7.756 2.798 9.912 2 12 2M6.876 7.705c-2.253.781-3.501 3.17-2.579 6.46a8 8 0 0 0 7.455 5.831L12 20a8 8 0 0 0 7.985-7.504l.009-.212q-.194.522-.463.98l-.14.227c-2.104 3.239-6.681 4.075-9.48 1.348a5.4 5.4 0 0 1-.962-1.257l-.106-.201q-2.604-.58-2.543-2.817c.027-.991.23-1.96.575-2.86"/>',
    },
    "first-aid-kit-fill": {
      body: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4V2a1 1 0 0 1 1-1zm-3 8h-2v3H8v2h2.999L11 17h2l-.001-3H16v-2h-3zm2-6H9v2h6z"/>',
    },
    "first-aid-kit-line": {
      body: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4V2a1 1 0 0 1 1-1zm4 6H4v12h16zm-7 2v3h3v2h-3.001L13 17h-2l-.001-3H8v-2h3V9zm2-6H9v2h6z"/>',
    },
    "flag-2-fill": {
      body: '<path fill="currentColor" d="M2 3h19.138a.5.5 0 0 1 .434.748L18 10l3.573 6.252a.5.5 0 0 1-.435.748H4v5H2z"/>',
    },
    "flag-2-line": {
      body: '<path fill="currentColor" d="M21.138 3a.5.5 0 0 1 .434.748L18 10l3.573 6.252a.5.5 0 0 1-.435.748H4v5H2V3zm-2.584 2H4v10h14.554l-2.857-5z"/>',
    },
    "flag-fill": {
      body: '<path fill="currentColor" d="M3 3h9.382a1 1 0 0 1 .894.553L14 5h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-6.382a1 1 0 0 1-.894-.553L12 16H5v6H3z"/>',
    },
    "flag-line": {
      body: '<path fill="currentColor" d="M12.382 3a1 1 0 0 1 .894.553L14 5h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-6.382a1 1 0 0 1-.894-.553L12 16H5v6H3V3zm-.618 2H5v9h8.236l1 2H19V7h-6.236z"/>',
    },
    "flashlight-fill": {
      body: '<path fill="currentColor" d="M13 10h7l-9 13v-9H4l9-13z"/>',
    },
    "flashlight-line": {
      body: '<path fill="currentColor" d="M13 9h8L11 24v-9H4l9-15zm-2 2V7.22L7.532 13H13v4.394L17.263 11z"/>',
    },
    "flask-fill": {
      body: '<path fill="currentColor" d="M16 2v2h-1v3.243a8 8 0 0 0 .736 3.352l4.281 9.276A1.5 1.5 0 0 1 18.655 22H5.344a1.5 1.5 0 0 1-1.362-2.129l4.281-9.276A8 8 0 0 0 9 7.243V4H8V2zm-3 2h-2v4h2z"/>',
    },
    "flask-line": {
      body: '<path fill="currentColor" d="M16 2v2h-1v3.243a8 8 0 0 0 .736 3.352l4.281 9.276A1.5 1.5 0 0 1 18.655 22H5.344a1.5 1.5 0 0 1-1.362-2.129l4.281-9.276A8 8 0 0 0 9 7.243V4H8V2zm-2.613 8.001h-2.776q-.156.545-.374 1.071l-.158.362L6.124 20h11.75l-3.954-8.566A10 10 0 0 1 13.387 10M11 7.243q0 .38-.028.758h2.057a10 10 0 0 1-.02-.364L13 7.243V4h-2z"/>',
    },
    "flickr-fill": {
      body: '<path fill="currentColor" d="M11 12a5 5 0 1 1-10 0a5 5 0 0 1 10 0m12 0a5 5 0 1 1-10 0a5 5 0 0 1 10 0"/>',
    },
    "flickr-line": {
      body: '<path fill="currentColor" d="M6 17A5 5 0 1 0 6 7a5 5 0 0 0 0 10m3-5a3 3 0 1 1-6 0a3 3 0 0 1 6 0m9 5a5 5 0 1 0 0-10a5 5 0 0 0 0 10m3-5a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/>',
    },
    "flight-land-fill": {
      body: '<path fill="currentColor" d="M20.949 14.888a1.5 1.5 0 0 1-1.837 1.06L3.445 11.752a1 1 0 0 1-.74-.983l.09-5.403l1.449.388l.915 3.351l5.095 1.366l-.37-8.382l1.933.518l2.81 9.035l5.261 1.41a1.5 1.5 0 0 1 1.061 1.837M4 19h16v2H4z"/>',
    },
    "flight-land-line": {
      body: '<path fill="currentColor" d="M20.949 14.888a1.5 1.5 0 0 1-1.837 1.06L3.445 11.752a1 1 0 0 1-.74-.983l.09-5.403l1.449.388l.915 3.351l5.095 1.366l-.37-8.382l1.933.518l2.81 9.035l5.261 1.41a1.5 1.5 0 0 1 1.061 1.837M4 19h16v2H4z"/>',
    },
    "flight-takeoff-fill": {
      body: '<path fill="currentColor" d="M21.949 10.112a1.5 1.5 0 0 1-1.06 1.837L5.221 16.147a1 1 0 0 1-1.133-.48l-2.623-4.725l1.449-.389l2.468 2.445l5.095-1.365l-4.51-7.074l1.931-.518l6.952 6.42l5.26-1.41a1.5 1.5 0 0 1 1.838 1.06M4 19h16v2H4z"/>',
    },
    "flight-takeoff-line": {
      body: '<path fill="currentColor" d="M21.949 10.112a1.5 1.5 0 0 1-1.06 1.837L5.221 16.147a1 1 0 0 1-1.133-.48l-2.623-4.725l1.449-.389l2.468 2.445l5.095-1.365l-4.51-7.074l1.931-.518l6.952 6.42l5.26-1.41a1.5 1.5 0 0 1 1.838 1.06M4 19h16v2H4z"/>',
    },
    "flip-horizontal-2-fill": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm6 5v3h4V8l4 4l-4 4v-3h-4v3l-4-4z"/>',
    },
    "flip-horizontal-2-line": {
      body: '<path fill="currentColor" d="M5 19h14V5H5zM3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm7 4v3h4V8l4 4l-4 4v-3h-4v3l-4-4z"/>',
    },
    "flip-horizontal-fill": {
      body: '<path fill="currentColor" d="M11 2v20h2V2zM7 6v12H4V6zM4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm11 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2z"/>',
    },
    "flip-horizontal-line": {
      body: '<path fill="currentColor" d="M11 2v20h2V2zM2 6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm18 0v12h-3V6zm-3-2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/>',
    },
    "flip-vertical-2-fill": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm4 7l4-4l4 4h-3v4h3l-4 4l-4-4h3v-4z"/>',
    },
    "flip-vertical-2-line": {
      body: '<path fill="currentColor" d="M5 19h14V5H5zM3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm5 6l4-4l4 4h-3v4h3l-4 4l-4-4h3v-4z"/>',
    },
    "flip-vertical-fill": {
      body: '<path fill="currentColor" d="M22 11H2v2h20zm-4-4H6V4h12zm2-3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-2 11a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2z"/>',
    },
    "flip-vertical-line": {
      body: '<path fill="currentColor" d="M22 11H2v2h20zm-4-9a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 18H6v-3h12zm2-3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2z"/>',
    },
    "flood-fill": {
      body: '<path fill="currentColor" d="M16 17.472A5.98 5.98 0 0 0 20 19h2v2h-2a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 12 21a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 4 21H2v-2h2c1.537 0 2.94-.578 4-1.528A5.98 5.98 0 0 0 12 19c1.537 0 2.94-.578 4-1.528m-3.427-15.94l.1.08L23 11h-3v6a5 5 0 0 1-4-2a4.99 4.99 0 0 1-4 2a5 5 0 0 1-4-2a4.99 4.99 0 0 1-4 2l-.001-6H1l10.327-9.388a1 1 0 0 1 1.14-.145z"/>',
    },
    "flood-line": {
      body: '<path fill="currentColor" d="M16 17.472A5.98 5.98 0 0 0 20 19h2v2h-2a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 12 21a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 4 21H2v-2h2c1.537 0 2.94-.578 4-1.528A5.98 5.98 0 0 0 12 19c1.537 0 2.94-.578 4-1.528m-3.427-15.94l.1.08L23 11h-3v6c-.701 0-1.374-.12-2-.341V9.157l-6-5.455l-6 5.454l.001 7.502a6 6 0 0 1-1.702.335L4 17v-6H1l10.327-9.388a1 1 0 0 1 1.246-.08"/>',
    },
    "flow-chart": {
      body: '<path fill="currentColor" d="M6 21.5A3.5 3.5 0 1 1 9.355 17H15v-2h2V9.242L14.757 7H9v2H3V3h6v2h5.757L18 1.756L22.243 6L19 9.241V15h2v6h-6v-2H9.355A3.5 3.5 0 0 1 6 21.5m0-5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m13 .5h-2v2h2zM18 4.586L16.586 6L18 7.414L19.414 6zM7 5H5v2h2z"/>',
    },
    "flower-fill": {
      body: '<path fill="currentColor" d="M12.455 2.309L12 2.076l-.455.233a12 12 0 0 0-3.09 2.265A14 14 0 0 1 12 7.202a14 14 0 0 1 3.544-2.628a12 12 0 0 0-3.089-2.265m-1.756 6.425a11.98 11.98 0 0 0-6.518-3.536L3 4.98V13a9 9 0 0 0 5.697 8.374A14 14 0 0 1 8 17c0-3.092 1.002-5.95 2.7-8.266M21 4.981l-1.18.217C14.232 6.224 10 11.117 10 17c0 1.536.29 3.007.817 4.36l.24.615c.314.01.629.025.943.025a9 9 0 0 0 9-9z"/>',
    },
    "flower-line": {
      body: '<path fill="currentColor" d="m12 2.076l.455.233a12.05 12.05 0 0 1 4.402 3.846a12 12 0 0 1 2.962-.957L21 4.98V13a9 9 0 0 1-18 0V4.98l1.18.218a12 12 0 0 1 2.963.957a12.05 12.05 0 0 1 4.402-3.846zM8.878 7.165a12.1 12.1 0 0 1 3.122 3.2a12.1 12.1 0 0 1 3.122-3.2A10.1 10.1 0 0 0 12 4.337a10.1 10.1 0 0 0-3.122 2.828m2.021 5.269a10.05 10.05 0 0 0-3.908-4.102A10 10 0 0 0 5 7.457V13c0 3.29 2.27 6.05 5.329 6.8A12 12 0 0 1 10 17c0-1.617.32-3.159.9-4.566m1.554 7.551A7 7 0 0 0 19 13V7.457A10 10 0 0 0 12 17c0 1.041.159 2.044.453 2.985"/>',
    },
    "flutter-fill": {
      body: '<path fill="currentColor" d="m13.504 2.001l-10 10l3.083 3.083l13.08-13.083zm-.005 9.198l-5.376 5.42L13.496 22h6.188l-5.387-5.4l5.389-5.4z"/>',
    },
    "flutter-line": {
      body: '<path fill="currentColor" d="M14.598 10.684h2.828l-5.657 5.658l5.657 5.656h-2.828L8.94 16.341zm-.194-8.68h2.829L5.919 13.318l-1.414-1.414z"/>',
    },
    "focus-2-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 18c4.427 0 8-3.573 8-8s-3.573-8-8-8a7.99 7.99 0 0 0-8 8c0 4.427 3.573 8 8 8m0-2c-3.32 0-6-2.68-6-6s2.68-6 6-6s6 2.68 6 6s-2.68 6-6 6m0-8c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2"/>',
    },
    "focus-2-line": {
      body: '<path fill="currentColor" d="M12 20a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-6a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0 2a6 6 0 1 1 0-12a6 6 0 0 1 0 12m0-4a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "focus-3-fill": {
      body: '<path fill="currentColor" d="m13 1l.001 3.062A8.004 8.004 0 0 1 19.938 11H23v2l-3.062.001a8.004 8.004 0 0 1-6.937 6.937L13 23h-2v-3.062a8.004 8.004 0 0 1-6.938-6.937L1 13v-2h3.062A8.004 8.004 0 0 1 11 4.062V1zm-1 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "focus-3-line": {
      body: '<path fill="currentColor" d="m13 1l.001 3.062A8.004 8.004 0 0 1 19.938 11H23v2l-3.062.001a8.004 8.004 0 0 1-6.937 6.937L13 23h-2v-3.062a8.004 8.004 0 0 1-6.938-6.937L1 13v-2h3.062A8.004 8.004 0 0 1 11 4.062V1zm-1 5a6 6 0 1 0 0 12a6 6 0 0 0 0-12m0 4a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "focus-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 8c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2"/>',
    },
    "focus-line": {
      body: '<path fill="currentColor" d="M12 20a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-8a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "focus-mode": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v4h2V5h3V3zm16 0h-4v2h3v3h2V4a1 1 0 0 0-1-1M5 16v3h3v2H4a1 1 0 0 1-1-1v-4zm14 0v3h-3v2h4a1 1 0 0 0 1-1v-4zm-9-7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"/>',
    },
    "foggy-fill": {
      body: '<path fill="currentColor" d="M1.584 13.007a8 8 0 1 1 14.873-5.908a5.5 5.5 0 0 1 6.52 5.908zM4 19h17v2H4zm-2-4h21v2H2z"/>',
    },
    "foggy-line": {
      body: '<path fill="currentColor" d="M1.584 13.007a8 8 0 1 1 14.873-5.908a5.5 5.5 0 0 1 6.52 5.908h-2.013Q21 12.758 21 12.5a3.5 3.5 0 0 0-6-2.45V10a6 6 0 1 0-11.193 3.007zM4 19h17v2H4zm-2-4h21v2H2z"/>',
    },
    "folder-2-fill": {
      body: '<path fill="currentColor" d="M22 11v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9zm0-2H2V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1z"/>',
    },
    "folder-2-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM20 11H4v8h16zm0-2V7h-8.414l-2-2H4v4z"/>',
    },
    "folder-3-fill": {
      body: '<path fill="currentColor" d="M22 8v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7h19a1 1 0 0 1 1 1m-9.586-3H2V4a1 1 0 0 1 1-1h7.414z"/>',
    },
    "folder-3-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 7v12h16V7z"/>',
    },
    "folder-4-fill": {
      body: '<path fill="currentColor" d="M8 21V11h14v9a1 1 0 0 1-1 1zm-2 0H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v3H7a1 1 0 0 0-1 1z"/>',
    },
    "folder-4-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM8 19h12v-8H8zm-2 0v-9a1 1 0 0 1 1-1h13V7h-8.414l-2-2H4v14z"/>',
    },
    "folder-5-fill": {
      body: '<path fill="currentColor" d="M13.414 5H20a1 1 0 0 1 1 1v1H3V4a1 1 0 0 1 1-1h7.414zM3.087 9h17.826a1 1 0 0 1 .997 1.083l-.833 10a1 1 0 0 1-.997.917H3.92a1 1 0 0 1-.996-.917l-.834-10A1 1 0 0 1 3.087 9"/>',
    },
    "folder-5-line": {
      body: '<path fill="currentColor" d="M3.087 9h17.826a1 1 0 0 1 .997 1.083l-.833 10a1 1 0 0 1-.997.917H3.92a1 1 0 0 1-.996-.917l-.834-10A1 1 0 0 1 3.087 9M4.84 19h14.32l.667-8H4.174zm8.574-14H20a1 1 0 0 1 1 1v1H3V4a1 1 0 0 1 1-1h7.414z"/>',
    },
    "folder-6-fill": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v3h7.586L12 4.586L10.414 3zm11.414 2l-4 4H2v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"/>',
    },
    "folder-6-line": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3c-.55 0-1-.45-1-1zm8.586 2l-1-1H4v2h5.586zM4 9v10h16V7h-7.586l-2 2z"/>',
    },
    "folder-add-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM11 12H8v2h3v3h2v-3h3v-2h-3V9h-2z"/>',
    },
    "folder-add-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm7 7V9h2v3h3v2h-3v3h-2v-3H8v-2z"/>',
    },
    "folder-chart-2-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM12 9a4 4 0 1 0 4 4h-4z"/>',
    },
    "folder-chart-2-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm8 4v4h4a4 4 0 1 1-4-4"/>',
    },
    "folder-chart-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM11 9v8h2V9zm4 3v5h2v-5zm-8 2v3h2v-3z"/>',
    },
    "folder-chart-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm7 4h2v8h-2zm4 3h2v5h-2zm-8 2h2v3H7z"/>',
    },
    "folder-check-fill": {
      body: '<path fill="currentColor" d="M19 13c1.093 0 2.117.292 3 .803V6a1 1 0 0 0-1-1h-8.586l-2-2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10.341A6 6 0 0 1 19 13m-3.536 5.465L19 22l4.95-4.95l-1.415-1.414L19 19.172l-2.121-2.122z"/>',
    },
    "folder-check-line": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10v-2H4V5h5.586l2 2H20v6h2V6a1 1 0 0 0-1-1h-8.586l-2-2zm12.465 15.465L19 22l4.95-4.95l-1.415-1.414L19 19.172l-2.121-2.122z"/>',
    },
    "folder-close-fill": {
      body: '<path fill="currentColor" d="M19 12c1.093 0 2.117.292 3 .803V6a1 1 0 0 0-1-1h-8.586l-2-2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10.803A6 6 0 0 1 19 12m1.414 6l2.122 2.121l-1.415 1.414l-2.12-2.12l-2.122 2.12l-1.414-1.414L17.585 18l-2.12-2.121l1.414-1.415L19 16.586l2.121-2.122l1.415 1.415z"/>',
    },
    "folder-close-line": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10v-2H4V5h5.586l2 2H20v5h2V6a1 1 0 0 0-1-1h-8.586l-2-2zm17.414 15l2.122 2.121l-1.415 1.414l-2.12-2.12l-2.122 2.12l-1.414-1.414L17.585 18l-2.12-2.121l1.414-1.415L19 16.586l2.121-2.122l1.415 1.415z"/>',
    },
    "folder-cloud-fill": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v6.36c-.998-1.42-2.646-2.36-4.5-2.36c-2.602 0-4.799 1.853-5.36 4.282A4.74 4.74 0 0 0 10 18.25c0 1.025.325 1.974.877 2.75H3a1 1 0 0 1-1-1zm12.002 11.603A2.751 2.751 0 0 0 14.75 21h5.5a2.75 2.75 0 0 0 .749-5.397C21.055 13.658 19.448 12 17.5 12s-3.555 1.658-3.498 3.603"/>',
    },
    "folder-cloud-line": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h7v-2H4V5h5.586l2 2H20v4h2V6a1 1 0 0 0-1-1h-8.586l-2-2zm9 15.25c0-1.26.847-2.32 2.002-2.647C13.945 13.658 15.552 12 17.5 12s3.555 1.658 3.499 3.603A2.751 2.751 0 0 1 20.25 21h-5.5A2.75 2.75 0 0 1 12 18.25M17.5 14a1.5 1.5 0 0 0-1.5 1.5c0 .464.024.975.057 1.46c-.964.205-2.057.592-2.057 1.29c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75c0-.698-1.093-1.085-2.057-1.29c.033-.485.057-.996.057-1.46a1.5 1.5 0 0 0-1.5-1.5"/>',
    },
    "folder-download-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM13 13V9h-2v4H8l4 4l4-4z"/>',
    },
    "folder-download-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm9 8h3l-4 4l-4-4h3V9h2z"/>',
    },
    "folder-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414z"/>',
    },
    "folder-forbid-fill": {
      body: '<path fill="currentColor" d="M22 11.255A7 7 0 0 0 12.255 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zM18 22a5 5 0 1 1 0-10a5 5 0 0 1 0 10m-1.293-2.292a3 3 0 0 0 4.001-4.001zm-1.415-1.415l4.001-4a3 3 0 0 0-4.001 4.001"/>',
    },
    "folder-forbid-line": {
      body: '<path fill="currentColor" d="M22 11.255a7 7 0 0 0-2-.965V7h-8.414l-2-2H4v14h7.29a7 7 0 0 0 .965 2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zM18 22a5 5 0 1 1 0-10a5 5 0 0 1 0 10m-1.293-2.292a3 3 0 0 0 4.001-4.001zm-1.415-1.415l4.001-4a3 3 0 0 0-4.001 4.001"/>',
    },
    "folder-history-fill": {
      body: '<path fill="currentColor" d="m10.414 3l2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM13 9h-2v6h5v-2h-3z"/>',
    },
    "folder-history-line": {
      body: '<path fill="currentColor" d="m10.414 3l2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-.828 2H4v14h16V7h-8.414zM13 9v4h3v2h-5V9z"/>',
    },
    "folder-image-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM10 10.5a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0m8 6.5l-4-6l-7 6z"/>',
    },
    "folder-image-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V7h-8.414l-2-2zm8.414 0H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM10 10.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m8 6.5l-4-6l-7 6z"/>',
    },
    "folder-info-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM11 9v2h2V9zm0 3v5h2v-5z"/>',
    },
    "folder-info-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm7 7h2v5h-2zm0-3h2v2h-2z"/>',
    },
    "folder-keyhole-fill": {
      body: '<path fill="currentColor" d="m10.414 3l2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM12 9a2 2 0 0 0-1 3.732V17h2l.001-4.268A2 2 0 0 0 12 9"/>',
    },
    "folder-keyhole-line": {
      body: '<path fill="currentColor" d="m10.414 3l2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-.828 2H4v14h16V7h-8.414zM12 9a2 2 0 0 1 1.001 3.732L13 17h-2v-4.268A2 2 0 0 1 12 9"/>',
    },
    "folder-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V7h-8.414l-2-2zm8.414 0H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414z"/>',
    },
    "folder-lock-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM15 13v-1a3 3 0 1 0-6 0v1H8v4h8v-4zm-2 0h-2v-1a1 1 0 1 1 2 0z"/>',
    },
    "folder-lock-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm11 8h1v4H8v-4h1v-1a3 3 0 1 1 6 0zm-2 0v-1a1 1 0 1 0-2 0v1z"/>',
    },
    "folder-music-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM11 13.05a2.5 2.5 0 1 0 2 2.45V11h3V9h-5z"/>',
    },
    "folder-music-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm7 8.05V9h5v2h-3v4.5a2.5 2.5 0 1 1-2-2.45"/>',
    },
    "folder-open-fill": {
      body: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H20a1 1 0 0 1 1 1v3H4v9.996L6 11h16.5l-2.31 9.243a1 1 0 0 1-.97.757z"/>',
    },
    "folder-open-line": {
      body: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H20a1 1 0 0 1 1 1v3h-2V7h-7.414l-2-2H4v11.998L5.5 11h17l-2.31 9.243a1 1 0 0 1-.97.757zm16.938-8H7.062l-1.5 6h12.876z"/>',
    },
    "folder-received-fill": {
      body: '<path fill="currentColor" d="M22 13.126A6 6 0 0 0 13.303 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zM20 17h3v2h-3v3.5L15 18l5-4.5z"/>',
    },
    "folder-received-line": {
      body: '<path fill="currentColor" d="M22 13h-2V7h-8.414l-2-2H4v14h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zm-2 4h3v2h-3v3.5L15 18l5-4.5z"/>',
    },
    "folder-reduce-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM8 12v2h8v-2z"/>',
    },
    "folder-reduce-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm4 7h8v2H8z"/>',
    },
    "folder-settings-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zm-3.823 8.809l-.991.572l1 1.731l.991-.572c.393.371.872.653 1.405.811v1.145h1.999V16.35a3.5 3.5 0 0 0 1.404-.811l.992.572l.999-1.73l-.991-.573a3.5 3.5 0 0 0 0-1.622l.991-.572l-1-1.732l-.992.573a3.5 3.5 0 0 0-1.404-.812V8.5h-1.999v1.144a3.5 3.5 0 0 0-1.404.812L8.6 9.883l-1 1.732l.991.572a3.5 3.5 0 0 0 0 1.622m3.404.688a1.5 1.5 0 1 1 0-2.998a1.5 1.5 0 0 1 0 2.998"/>',
    },
    "folder-settings-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm4.591 8.809a3.5 3.5 0 0 1 0-1.622l-.991-.572l1-1.732l.991.573a3.5 3.5 0 0 1 1.404-.812V8.5h2v1.144c.532.159 1.01.44 1.404.812l.991-.573l1 1.732l-.991.572a3.5 3.5 0 0 1 0 1.622l.991.572l-1 1.731l-.991-.572a3.5 3.5 0 0 1-1.404.811v1.145h-2V16.35a3.5 3.5 0 0 1-1.404-.811l-.991.572l-1-1.73zm3.404.688a1.5 1.5 0 1 0 0-2.999a1.5 1.5 0 0 0 0 3"/>',
    },
    "folder-shared-fill": {
      body: '<path fill="currentColor" d="M22 13.126A6 6 0 0 0 13.303 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zM18 17v-3.5l5 4.5l-5 4.5V19h-3v-2z"/>',
    },
    "folder-shared-line": {
      body: '<path fill="currentColor" d="M22 13h-2V7h-8.414l-2-2H4v14h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zm-4 4v-3.5l5 4.5l-5 4.5V19h-3v-2z"/>',
    },
    "folder-shield-2-fill": {
      body: '<path fill="currentColor" d="M22 10H12v7.382c0 1.409.632 2.734 1.705 3.618H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zm-8 2h8v5.382c0 .897-.446 1.734-1.187 2.23L18 21.499l-2.812-1.885A2.68 2.68 0 0 1 14 17.383z"/>',
    },
    "folder-shield-2-line": {
      body: '<path fill="currentColor" d="M22 9h-2V7h-8.414l-2-2H4v14h7.447a4.97 4.97 0 0 0 1.664 2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1zm-9 2h9v5.949c0 .99-.501 1.916-1.336 2.465L17.5 21.498l-3.164-2.084A2.95 2.95 0 0 1 13 16.95zm2 5.949c0 .316.162.614.436.795l2.064 1.36l2.064-1.36a.95.95 0 0 0 .436-.795V13h-5z"/>',
    },
    "folder-shield-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM8 9v4.904c0 .892.446 1.724 1.187 2.219L12 17.998l2.813-1.875A2.67 2.67 0 0 0 16 13.904V9zm2 4.904V11h4v2.904a.67.67 0 0 1-.297.555L12 15.594l-1.703-1.135a.67.67 0 0 1-.297-.555"/>',
    },
    "folder-shield-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm4 4h8v4.904c0 .892-.446 1.724-1.187 2.219L12 17.998l-2.813-1.875A2.67 2.67 0 0 1 8 13.904zm2 4.904c0 .223.111.431.297.555L12 15.594l1.703-1.135a.67.67 0 0 0 .297-.555V11h-4z"/>',
    },
    "folder-transfer-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM12 12H8v2h4v3l4-4l-4-4z"/>',
    },
    "folder-transfer-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm8 7V9l4 4l-4 4v-3H8v-2z"/>',
    },
    "folder-unknow-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM11 16v2h2v-2zm-2.433-5.187l1.962.393A1.5 1.5 0 1 1 12 13h-1v2h1a3.5 3.5 0 1 0-3.433-4.187"/>',
    },
    "folder-unknow-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm7 11h2v2h-2zm-2.433-5.187A3.501 3.501 0 1 1 12 15h-1v-2h1a1.5 1.5 0 1 0-1.471-1.794z"/>',
    },
    "folder-upload-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM13 13h3l-4-4l-4 4h3v4h2z"/>',
    },
    "folder-upload-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm9 8v4h-2v-4H8l4-4l4 4z"/>',
    },
    "folder-user-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM12 13a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m-4 5h8a4 4 0 0 0-8 0"/>',
    },
    "folder-user-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm4 13a4 4 0 0 1 8 0zm4-5a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5"/>',
    },
    "folder-video-fill": {
      body: '<path fill="currentColor" d="M21 5h-8.586l-2-2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-6 7.667a.4.4 0 0 1 0 .666l-4.878 3.252a.4.4 0 0 1-.622-.333V9.747a.4.4 0 0 1 .622-.333z"/>',
    },
    "folder-video-line": {
      body: '<path fill="currentColor" d="M4 19V5h5.586l2 2H20v12zM21 5h-8.586l-2-2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-6 7.667l-4.878-3.253a.4.4 0 0 0-.622.333v6.505a.4.4 0 0 0 .622.333L15 13.333a.4.4 0 0 0 0-.666"/>',
    },
    "folder-warning-fill": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM11 9v5h2V9zm0 6v2h2v-2z"/>',
    },
    "folder-warning-line": {
      body: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414zM4 5v14h16V7h-8.414l-2-2zm7 10h2v2h-2zm0-6h2v5h-2z"/>',
    },
    "folder-zip-fill": {
      body: '<path fill="currentColor" d="M21 5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H16v2h2V5zm-3 8h-2v2h-2v3h4zm-2-2h-2v2h2zm2-2h-2v2h2zm-2-2h-2v2h2z"/>',
    },
    "folder-zip-line": {
      body: '<path fill="currentColor" d="m10.414 3l2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM18 18h-4v-3h2v-2h-2v-2h2V9h-2V7h-2.414l-2-2H4v14h16V7h-4v2h2v2h-2v2h2z"/>',
    },
    "folders-fill": {
      body: '<path fill="currentColor" d="M6 7V4a1 1 0 0 1 1-1h6.414l2 2H21a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm0 2H4v10h12v-2H6z"/>',
    },
    "folders-line": {
      body: '<path fill="currentColor" d="M6 7V4a1 1 0 0 1 1-1h6.414l2 2H21a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm0 2H4v10h12v-2H6zm2-4v10h12V7h-5.414l-2-2z"/>',
    },
    "font-color": {
      body: '<path fill="currentColor" d="M15.246 14H8.754l-1.6 4H5l6-15h2l6 15h-2.154zm-.8-2L12 5.885L9.554 12zM3 20h18v2H3z"/>',
    },
    "font-family": {
      body: '<path fill="currentColor" d="M5.554 22H3.4L11 3h2l7.6 19h-2.154l-2.4-6H7.954zm3.2-8h6.492L12 5.885z"/>',
    },
    "font-mono": {
      body: '<path fill="currentColor" d="M6 4h13v2H8v6h10v2H8v7H6z"/>',
    },
    "font-sans": {
      body: '<path fill="currentColor" d="M7 4h12v2h-9v6h8v2h-8v7H7z"/>',
    },
    "font-sans-serif": {
      body: '<path fill="currentColor" d="M5 4h14v4h-1.5C17 6 17 5 15 5h-5v7h3c1 0 2-.5 2-2h1v5h-1c0-1.5-1-2-2-2h-3v4.5c0 2.5 3.5 2.5 3.5 2.5v1H5v-1c2-.5 2-1.5 2-2.5v-10c0-1 0-2-2-2.5z"/>',
    },
    "font-size": {
      body: '<path fill="currentColor" d="M11.246 15H4.754l-2 5H.6L7 4h2l6.4 16h-2.154zm-.8-2L8 6.885L5.554 13zM21 12.535V12h2v8h-2v-.535a4 4 0 1 1 0-6.93M19 18a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "font-size-2": {
      body: '<path fill="currentColor" d="M10 6v15H8V6H2V4h14v2zm8 8v7h-2v-7h-3v-2h8v2z"/>',
    },
    "football-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m1.67 14h-3.34l-1.38 1.897l.554 1.706A8 8 0 0 0 12 20c.871 0 1.71-.14 2.496-.397l.553-1.706zm-8.376-5.128l-1.292.938L4 12c0 1.73.549 3.331 1.482 4.64h1.91l1.323-1.82l-1.028-3.17zm13.412 0l-2.393.778l-1.028 3.17l1.322 1.82h1.91A7.96 7.96 0 0 0 20 12l-.003-.191zM14.29 4.333l-1.29.94V7.79l2.694 1.957l2.24-.727l.554-1.703a8 8 0 0 0-4.196-2.984m-4.582 0a8 8 0 0 0-4.196 2.985l.554 1.702l2.239.727L11 7.79V5.273z"/>',
    },
    "football-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m1.67 14h-3.34l-1.38 1.897l.554 1.706A8 8 0 0 0 12 20c.871 0 1.71-.14 2.496-.397l.553-1.706zm-8.376-5.128l-1.292.938L4 12c0 1.73.549 3.331 1.482 4.64h1.91l1.323-1.82l-1.028-3.17zm13.412 0l-2.393.778l-1.028 3.17l1.322 1.82h1.91A7.96 7.96 0 0 0 20 12l-.003-.19zM12 9.536l-2.344 1.702l.896 2.762h2.895l.896-2.762zm2.291-5.203L13 5.273V7.79l2.694 1.957l2.24-.727l.554-1.703a8 8 0 0 0-4.196-2.984m-4.583 0a8 8 0 0 0-4.195 2.985l.554 1.702l2.239.727L11 7.79V5.273z"/>',
    },
    "footprint-fill": {
      body: '<path fill="currentColor" d="M4 18h5.5v1.25a2.75 2.75 0 0 1-5.5 0zM8 6.12c2 0 3 2.88 3 4.88c0 1-.5 2-1 3.5L9.5 16H4c0-1-.5-2.5-.5-5S5.498 6.12 8 6.12m12.054 7.978l-.217 1.231a2.75 2.75 0 0 1-5.416-.955l.216-1.23zM18.178 1.705c2.464.434 4.018 3.125 3.584 5.587s-1.187 3.852-1.36 4.837l-5.417-.955l-.232-1.564c-.232-1.564-.55-2.636-.377-3.62c.347-1.97 1.832-4.632 3.802-4.285"/>',
    },
    "footprint-line": {
      body: '<path fill="currentColor" d="M4 18h5.5v1.25a2.75 2.75 0 0 1-5.5 0zm4.058-4l.045-.132C8.87 11.762 9 11.37 9 11c0-.75-.203-1.643-.528-2.273C8.23 8.257 8.06 8.12 8 8.12c-1.28 0-2.5 1.364-2.5 2.88c0 .958.075 1.772.227 2.757l.038.242zM8 6.12c2 0 3 2.88 3 4.88c0 1-.5 2-1 3.5L9.5 16H4c0-1-.5-2.5-.5-5S5.498 6.12 8 6.12m12.054 7.978l-.217 1.231a2.75 2.75 0 0 1-5.416-.955l.216-1.23zm-1.05-4.246c.165-.5.301-.894.303-.9c.202-.658.361-1.303.485-2.008c.263-1.492-.702-3.047-1.962-3.27c-.059-.01-.25.095-.57.515c-.43.565-.784 1.41-.915 2.147c-.058.33-.049.405.27 2.263c.045.256.082.486.116.717l.02.138zm-.826-8.147c2.464.434 4.018 3.125 3.584 5.587s-1.187 3.852-1.36 4.837l-5.417-.955l-.232-1.564c-.232-1.564-.55-2.636-.377-3.62c.347-1.97 1.832-4.632 3.802-4.285"/>',
    },
    "forbid-2-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m4.891-13.477a6 6 0 0 0-1.414-1.414l-8.368 8.368a6 6 0 0 0 1.414 1.414z"/>',
    },
    "forbid-2-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m4.891-11.477l-8.368 8.368a6 6 0 0 1-1.414-1.414l8.368-8.368a6 6 0 0 1 1.414 1.414"/>',
    },
    "forbid-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M8.523 7.109A6 6 0 0 0 7.11 8.523l8.368 8.368a6 6 0 0 0 1.414-1.414z"/>',
    },
    "forbid-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M8.523 7.109l8.368 8.368a6 6 0 0 1-1.414 1.414L7.109 8.523A6 6 0 0 1 8.523 7.11"/>',
    },
    "format-clear": {
      body: '<path fill="currentColor" d="M12.651 14.065L11.605 20H9.574l1.35-7.661l-7.41-7.41L4.93 3.515L20.485 19.07l-1.414 1.414zm-.878-6.535l.27-1.53h-1.8l-2-2H20v2h-5.927L13.5 9.257z"/>',
    },
    formula: {
      body: '<path fill="currentColor" d="M10 2a4 4 0 0 0-4 4v3H3v2h3v7a2 2 0 0 1-2 2H3v2h1a4 4 0 0 0 4-4v-7h3V9H8V6a2 2 0 0 1 2-2h1V2zm5.202 14.997L11.891 21h2.595l2.014-2.434L18.514 21h2.595l-3.311-4.003L21.105 13h-2.596L16.5 15.428L14.491 13h-2.595z"/>',
    },
    "forward-10-fill": {
      body: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10h-2a8 8 0 1 1-1.865-5.135l-1.997 1.997A2.5 2.5 0 0 0 12 10.75v2.5a2.5 2.5 0 0 0 5 0v-2.5c0-.681-.273-1.3-.715-1.75H22V3l-2.447 2.446A9.98 9.98 0 0 0 12 2m3.5 8.75v2.5a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0M10 8.5H8.5v7H10z"/>',
    },
    "forward-10-line": {
      body: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10h-2a8 8 0 1 1-1.384-4.5H16v1.25a2.5 2.5 0 0 0-4 2v2.5a2.5 2.5 0 0 0 5 0v-2.5c0-.455-.122-.882-.334-1.25H22v-6h-2V6a9.99 9.99 0 0 0-8-4m3.5 8.75v2.5a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0M10 8.5H8.5v7H10z"/>',
    },
    "forward-15-fill": {
      body: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10h-2a8 8 0 1 1-1.865-5.135L16.5 8.5H12v4.25h2.875a.625.625 0 1 1 0 1.25H12v1.5h2.875a2.125 2.125 0 0 0 0-4.25H13.5V10h3.25V9H22V3l-2.447 2.446A9.98 9.98 0 0 0 12 2M8.5 8.5H10v7H8.5z"/>',
    },
    "forward-15-line": {
      body: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10h-2a8 8 0 1 1-1.384-4.5H16v1h-4v4.25h2.875a.625.625 0 1 1 0 1.25H12v1.5h2.875a2.125 2.125 0 0 0 0-4.25H13.5V10h3.25v-.5H22v-6h-2V6a9.99 9.99 0 0 0-8-4M8.5 8.5H10v7H8.5z"/>',
    },
    "forward-30-fill": {
      body: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2a9.98 9.98 0 0 1 7.553 3.446L22 3v6h-5.215c.442.45.715 1.069.715 1.75v2.5a2.5 2.5 0 0 1-5 0v-2.5a2.5 2.5 0 0 1 3.853-2.103l1.782-1.782A8 8 0 1 0 20 12h2c0 5.523-4.477 10-10 10S2 17.523 2 12m13-2.25a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1m-5 3.625a.625.625 0 0 0-.625-.625H7.5v-1.5h1.875a.625.625 0 1 0 0-1.25H6.75V8.5h2.625a2.125 2.125 0 0 1 1.62 3.5a2.125 2.125 0 0 1-1.62 3.5H6.75V14h2.625c.345 0 .625-.28.625-.625"/>',
    },
    "forward-30-line": {
      body: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2a9.99 9.99 0 0 1 8 4V3.5h2v6h-4.834c.212.368.334.795.334 1.25v2.5a2.5 2.5 0 0 1-5 0v-2.5A2.5 2.5 0 0 1 16 8.458V7.5h2.616A8 8 0 1 0 20 12h2c0 5.523-4.477 10-10 10S2 17.523 2 12m13-2.25a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1m-5.625 3a.625.625 0 1 1 0 1.25H6.75v1.5h2.625a2.125 2.125 0 0 0 1.62-3.5a2.125 2.125 0 0 0-1.62-3.5H6.75V10h2.625a.625.625 0 1 1 0 1.25H7.5v1.5z"/>',
    },
    "forward-5-fill": {
      body: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2a9.98 9.98 0 0 1 7.553 3.446L22 3v6h-6l2.135-2.135A8 8 0 1 0 20 12h2c0 5.523-4.477 10-10 10S2 17.523 2 12m12.5-2V8.5h-5v4.25h3.125a.625.625 0 1 1 0 1.25H9.5v1.5h3.125a2.125 2.125 0 0 0 0-4.25H11V10z"/>',
    },
    "forward-5-line": {
      body: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10h-2a8 8 0 1 1-1.384-4.5H16v2h6v-6h-2V6a9.99 9.99 0 0 0-8-4M9.5 8.5h5V10H11v1.25h1.625a2.125 2.125 0 0 1 0 4.25H9.5V14h3.125a.625.625 0 1 0 0-1.25H9.5z"/>',
    },
    "forward-end-fill": {
      body: '<path fill="currentColor" d="M22 4a1 1 0 0 0-1 1v5.666l-9.223-6.148a.5.5 0 0 0-.777.416v5.732L1.777 4.518A.5.5 0 0 0 1 4.934v14.132a.5.5 0 0 0 .777.416L11 13.333v5.733a.5.5 0 0 0 .777.416L21 13.333V19a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1"/>',
    },
    "forward-end-line": {
      body: '<path fill="currentColor" d="M22 4a1 1 0 0 0-1 1v5.666l-9.223-6.148a.5.5 0 0 0-.777.416v5.732L1.777 4.518A.5.5 0 0 0 1 4.934v14.132a.5.5 0 0 0 .777.416L11 13.333v5.733a.5.5 0 0 0 .777.416L21 13.333V19a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1M3 7.737L9.394 12L3 16.263zm10 8.526V7.737L19.394 12z"/>',
    },
    "forward-end-mini-fill": {
      body: '<path fill="currentColor" d="M21 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1M2.5 17.535a.5.5 0 0 0 .288-.092l7.133-5.035a.5.5 0 0 0 0-.817L2.788 6.556A.5.5 0 0 0 2 6.965v10.07a.5.5 0 0 0 .5.5m8.592-10.858a.5.5 0 0 0-.092.288v10.07a.5.5 0 0 0 .788.408l7.133-5.035a.5.5 0 0 0 0-.817l-7.133-5.035a.5.5 0 0 0-.697.12"/>',
    },
    "forward-end-mini-line": {
      body: '<path fill="currentColor" d="M21 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1M4 9.86L7.032 12L4 14.14zm-1.5 7.675a.5.5 0 0 0 .288-.092l7.133-5.035a.5.5 0 0 0 0-.817L2.788 6.556A.5.5 0 0 0 2 6.965v10.07a.5.5 0 0 0 .5.5M16.032 12L13 14.14V9.86zm-4.94-5.323a.5.5 0 0 0-.092.288v10.07a.5.5 0 0 0 .788.408l7.133-5.035a.5.5 0 0 0 0-.817l-7.133-5.035a.5.5 0 0 0-.697.12"/>',
    },
    "fridge-fill": {
      body: '<path fill="currentColor" d="M19.998 12v10a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V12zm-11 2h-2v5h2zm10-13a1 1 0 0 1 1 1v8h-16V2a1 1 0 0 1 1-1zm-10 3h-2v4h2z"/>',
    },
    "fridge-line": {
      body: '<path fill="currentColor" d="M18.998 1a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm-1 11h-12v9h12zm-8 2v4h-2v-4zm8-11h-12v7h12zm-8 2v3h-2V5z"/>',
    },
    "friendica-fill": {
      body: '<path fill="currentColor" d="M15 3v4.5H9v4h6v5H9V21h9a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4z"/>',
    },
    "friendica-line": {
      body: '<path fill="currentColor" d="M16 4v5h-6v2h6v6h-6v3h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 0H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2v-5h6v-2H8V7h6zM2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4z"/>',
    },
    "fullscreen-exit-fill": {
      body: '<path fill="currentColor" d="M18 7h4v2h-6V3h2zM8 9H2V7h4V3h2zm10 8v4h-2v-6h6v2zM8 15v6H6v-4H2v-2z"/>',
    },
    "fullscreen-exit-line": {
      body: '<path fill="currentColor" d="M18 7h4v2h-6V3h2zM8 9H2V7h4V3h2zm10 8v4h-2v-6h6v2zM8 15v6H6v-4H2v-2z"/>',
    },
    "fullscreen-fill": {
      body: '<path fill="currentColor" d="M16 3h6v6h-2V5h-4zM2 3h6v2H4v4H2zm18 16v-4h2v6h-6v-2zM4 19h4v2H2v-6h2z"/>',
    },
    "fullscreen-line": {
      body: '<path fill="currentColor" d="M8 3v2H4v4H2V3zM2 21v-6h2v4h4v2zm20 0h-6v-2h4v-4h2zm0-12h-2V5h-4V3h6z"/>',
    },
    "function-add-fill": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm0 10a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm10 0a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm2-2V8h-3V6h3V3h2v3h3v2h-3v3z"/>',
    },
    "function-add-line": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm0 10a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm10 0a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm1 6v-4h4v4zM5 9V5h4v4zm0 10v-4h4v4zm11-8V8h-3V6h3V3h2v3h3v2h-3v3z"/>',
    },
    "function-fill": {
      body: '<path fill="currentColor" d="M3 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm0 10a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM13 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm0 10a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1z"/>',
    },
    "function-line": {
      body: '<path fill="currentColor" d="M3 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm0 10a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM13 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm0 10a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm2-9v4h4V5zm0 10v4h4v-4zM5 5v4h4V5zm0 10v4h4v-4z"/>',
    },
    functions: {
      body: '<path fill="currentColor" d="m5 18l7.68-6L5 6V4h14v2H8.263L16 12l-7.737 6H19v2H5z"/>',
    },
    "funds-box-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m11.793 6.793l-2.45 2.45l-2.121-2.122l-4.243 4.243l1.414 1.414l2.829-2.828l2.121 2.12l3.864-3.863l1.793 1.793v-5h-5z"/>',
    },
    "funds-box-line": {
      body: '<path fill="currentColor" d="M4.005 5.003v14h16v-14zm-1-2h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m11.793 6.793l-1.793-1.793h5v5l-1.793-1.793l-3.864 3.864l-2.121-2.121l-2.829 2.828l-1.414-1.414l4.243-4.243l2.121 2.121z"/>',
    },
    "funds-fill": {
      body: '<path fill="currentColor" d="m3.901 17.864l3.911-3.911l2.829 2.828l4.571-4.571l1.793 1.793v-5h-5l1.793 1.793l-3.157 3.157l-2.829-2.829l-4.945 4.946a10 10 0 0 1-.862-4.067c0-5.523 4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10a9.99 9.99 0 0 1-8.104-4.14"/>',
    },
    "funds-line": {
      body: '<path fill="currentColor" d="m4.41 14.526l3.402-3.402l2.829 2.829l3.157-3.157l-1.793-1.793h5v5l-1.793-1.793l-4.571 4.571l-2.829-2.828l-2.474 2.474a8 8 0 1 0-.927-1.9m-1.537 1.558l-.01-.01l.004-.004a10 10 0 0 1-.862-4.067c0-5.523 4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10c-4.07 0-7.57-2.43-9.132-5.919"/>',
    },
    "gallery-fill": {
      body: '<path fill="currentColor" d="M17.409 19c-.776-2.399-2.277-3.885-4.266-5.602A10.95 10.95 0 0 1 20 11V3h1.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1h2v4H4v7c5.22 0 9.662 2.462 11.313 7zM18 1v4h-8V3h6V1zm-1.5 9a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "gallery-line": {
      body: '<path fill="currentColor" d="M20 13c-1.678 0-3.249.46-4.593 1.259A15 15 0 0 1 18.147 19H20zm-3.996 6C14.044 14.302 9.408 11 4 11v8zM4 9c3.83 0 7.323 1.435 9.974 3.796A10.95 10.95 0 0 1 20 11V3h1.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1h2v4H4zm14-8v4h-8V3h6V1zm-1.5 9a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "gallery-upload-fill": {
      body: '<path fill="currentColor" d="M8 1v2h8V1h2v2h3.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1zm4 7l-4 4h3v4h2v-4h3z"/>',
    },
    "gallery-upload-line": {
      body: '<path fill="currentColor" d="M8 1v4H4v14h16V3h1.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1zm4 7l4 4h-3v4h-2v-4H8zm6-7v4h-8V3h6V1z"/>',
    },
    "gallery-view": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 1v14h16V5zm2 2h5v4H6zm5 6H6v4h5zm2-6h5v4h-5zm5 6h-5v4h5z"/>',
    },
    "gallery-view-2": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm1 6V5h5v4zm-1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm1 6v-4h5v4zm9-15a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1zm2 1v4h5V5zm-1 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm1 6v-4h5v4z"/>',
    },
    "game-fill": {
      body: '<path fill="currentColor" d="M12 2a9.98 9.98 0 0 1 7.743 3.671L13.414 12l6.329 6.329A9.98 9.98 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2m0 3a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3"/>',
    },
    "game-line": {
      body: '<path fill="currentColor" d="M12 2a9.98 9.98 0 0 1 7.743 3.671L13.414 12l6.329 6.329A9.98 9.98 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 4.697 14.477l.208-.157l-6.32-6.32l6.32-6.321l-.208-.156a7.97 7.97 0 0 0-4.394-1.517zm0 1a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "gamepad-fill": {
      body: '<path fill="currentColor" d="M17 4a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6v-4a6 6 0 0 1 6-6zm-7 5H8v2H6v2h1.999L8 15h2l-.001-2H12v-2h-2zm8 4h-2v2h2zm-2-4h-2v2h2z"/>',
    },
    "gamepad-line": {
      body: '<path fill="currentColor" d="M17 4a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6v-4a6 6 0 0 1 6-6zm0 2H7a4 4 0 0 0-3.995 3.8L3 10v4a4 4 0 0 0 3.8 3.995L7 18h10a4 4 0 0 0 3.995-3.8L21 14v-4a4 4 0 0 0-3.8-3.995zm-7 3v2h2v2H9.999L10 15H8l-.001-2H6v-2h2V9zm8 4v2h-2v-2zm-2-4v2h-2V9z"/>',
    },
    "gas-station-fill": {
      body: '<path fill="currentColor" d="M3 19V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657l1.414-1.414l4.95 4.95A1 1 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2zM5 5v6h7V5z"/>',
    },
    "gas-station-line": {
      body: '<path fill="currentColor" d="M14 19h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657l1.414-1.414l4.95 4.95A1 1 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2zm-9 0h7v-6H5zM5 5v6h7V5z"/>',
    },
    "gatsby-fill": {
      body: '<path fill="currentColor" d="M12.001 2c-5.5 0-10 4.5-10 10s4.5 10 10 10s10-4.5 10-10s-4.5-10-10-10M6.43 17.571c-1.5-1.5-2.286-3.5-2.286-5.428l7.786 7.714c-2-.071-4-.786-5.5-2.286m7.285 2.072l-9.357-9.357c.786-3.5 3.929-6.143 7.643-6.143c2.643 0 4.929 1.286 6.357 3.214l-1.071.929C16.072 6.643 14.144 5.57 12 5.57c-2.786 0-5.143 1.786-6.071 4.286l8.214 8.214c2.071-.714 3.643-2.5 4.143-4.642h-3.429V12h5c0 3.714-2.643 6.857-6.143 7.643"/>',
    },
    "gatsby-line": {
      body: '<path fill="currentColor" d="M11.752 21.997c-5.221-.128-9.45-4.257-9.736-9.438l-.012-.313zM12 2a9.99 9.99 0 0 1 8.193 4.265l-1.638 1.148A8.003 8.003 0 0 0 4.535 9.12L14.88 19.466A8.02 8.02 0 0 0 19.749 14H15.5v-2H22c0 4.726-3.279 8.686-7.686 9.73L2.27 9.686C3.314 5.28 7.275 2 12 2"/>',
    },
    "gemini-fill": {
      body: '<path fill="currentColor" d="M24 12.024c-6.437.388-11.59 5.539-11.977 11.976h-.047C11.588 17.563 6.436 12.412 0 12.024v-.047C6.437 11.588 11.588 6.437 11.976 0h.047c.388 6.437 5.54 11.588 11.977 11.977z"/>',
    },
    "gemini-line": {
      body: '<path fill="currentColor" d="M11.124 1.09h1.751l.052.855a9.743 9.743 0 0 0 9.128 9.128l.854.052v1.75l-.854.052a9.743 9.743 0 0 0-9.128 9.128l-.052.855h-1.75l-.052-.855a9.743 9.743 0 0 0-9.128-9.128l-.854-.051v-1.751l.854-.052a9.743 9.743 0 0 0 9.128-9.128zM12 5.85A11.6 11.6 0 0 1 5.85 12A11.6 11.6 0 0 1 12 18.15A11.6 11.6 0 0 1 18.15 12A11.6 11.6 0 0 1 12 5.85"/>',
    },
    "genderless-fill": {
      body: '<path fill="currentColor" d="M11 7.066V1h2v6.066A7.501 7.501 0 0 1 12 22a7.5 7.5 0 0 1-1-14.934"/>',
    },
    "genderless-line": {
      body: '<path fill="currentColor" d="M13 7.066A7.501 7.501 0 0 1 12 22a7.5 7.5 0 0 1-1-14.934V1h2zM12 20a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11"/>',
    },
    "ghost-2-fill": {
      body: '<path fill="currentColor" d="M12 2c3.5 0 6 3 7 6c3 1 4 3.73 4 6l-2.775.793a1 1 0 0 0-.725.961v1.496A1.75 1.75 0 0 1 17.75 19h-.596a2 2 0 0 0-1.668.896Q14.094 22 12 22t-3.486-2.104A2 2 0 0 0 6.846 19H6.25a1.75 1.75 0 0 1-1.75-1.75v-1.496a1 1 0 0 0-.725-.961L1 14c0-2.266 1-5 4-6c1-3 3.5-6 7-6m0 10c-.828 0-1.5 1.12-1.5 2.5S11.172 17 12 17s1.5-1.12 1.5-2.5S12.828 12 12 12M9.5 8a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m5 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3"/>',
    },
    "ghost-2-line": {
      body: '<path fill="currentColor" d="M12 2c3.5 0 6 3 7 6c3 1 4 3.73 4 6l-2.775.793a1 1 0 0 0-.725.961v1.496A1.75 1.75 0 0 1 17.75 19h-.596a2 2 0 0 0-1.668.896Q14.094 22 12 22t-3.486-2.104A2 2 0 0 0 6.846 19H6.25a1.75 1.75 0 0 1-1.75-1.75v-1.496a1 1 0 0 0-.725-.961L1 14c0-2.266 1-5 4-6c1-3 3.5-6 7-6m0 2C9.89 4 7.935 5.788 6.989 8.371l-.092.261l-.316.95l-.949.315c-1.255.419-2.067 1.341-2.424 2.56l-.023.086l1.14.327a3 3 0 0 1 2.17 2.703l.005.181V17h.346a4 4 0 0 1 3.2 1.6l.136.192C10.758 19.664 11.316 20 12 20c.638 0 1.167-.293 1.703-1.04l.115-.168a4 4 0 0 1 3.1-1.785l.236-.007h.346v-1.246a3 3 0 0 1 2.003-2.83l.173-.054l1.139-.327l-.023-.087c-.337-1.151-1.08-2.037-2.22-2.484l-.204-.075l-.95-.316l-.315-.949C16.195 5.91 14.18 4 12 4m0 8c.828 0 1.5 1.12 1.5 2.5S12.828 17 12 17s-1.5-1.12-1.5-2.5s.672-2.5 1.5-2.5M9.5 8a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "ghost-fill": {
      body: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976a2.999 2.999 0 0 1-5.223 0a3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9m0 10c-1.105 0-2 1.12-2 2.5s.895 2.5 2 2.5s2-1.12 2-2.5s-.895-2.5-2-2.5M9.5 8a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m5 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3"/>',
    },
    "ghost-line": {
      body: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976a2.999 2.999 0 0 1-5.223 0a3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9m0 2a7 7 0 0 0-6.996 6.76L5 11v7.446l.002.138a1.5 1.5 0 0 0 2.645.88l.088-.116a2 2 0 0 1 3.393.142a.999.999 0 0 0 1.74.003a2 2 0 0 1 3.296-.278l.097.13a1.5 1.5 0 0 0 2.732-.701L19 18.5V11a7 7 0 0 0-7-7m0 8c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5s-2-1.12-2-2.5s.895-2.5 2-2.5M9.5 8a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "ghost-smile-fill": {
      body: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976a2.999 2.999 0 0 1-5.223 0a3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9m4 11h-2a2 2 0 0 1-3.995.15L10 13H8l.005.2a4 4 0 0 0 7.99 0zm-4-6a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "ghost-smile-line": {
      body: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976a2.999 2.999 0 0 1-5.223 0a3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9m0 2a7 7 0 0 0-6.996 6.76L5 11v7.446l.002.138a1.5 1.5 0 0 0 2.645.88l.088-.116a2 2 0 0 1 3.393.142a.999.999 0 0 0 1.74.003a2 2 0 0 1 3.296-.278l.097.13a1.5 1.5 0 0 0 2.732-.701L19 18.5V11a7 7 0 0 0-7-7m4 9a4 4 0 0 1-7.995.2L8 13h2a2 2 0 1 0 4 0zm-4-6a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "gift-2-fill": {
      body: '<path fill="currentColor" d="M20.005 13.003v7a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-7zm-5.5-11a3.5 3.5 0 0 1 3.163 5h3.337a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3.337a3.5 3.5 0 0 1 5.664-3.95a3.48 3.48 0 0 1 2.499-1.05m-5 2a1.5 1.5 0 0 0-.145 2.993l.145.007h1.5v-1.5A1.5 1.5 0 0 0 9.649 4.01zm5 0l-.145.007a1.5 1.5 0 0 0-1.348 1.348l-.007.145v1.5h1.5l.144-.007a1.5 1.5 0 0 0 0-2.986z"/>',
    },
    "gift-2-line": {
      body: '<path fill="currentColor" d="M14.505 2.003a3.5 3.5 0 0 1 3.163 5h3.337a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v8a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-8h-1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.337a3.5 3.5 0 0 1 5.664-3.95a3.48 3.48 0 0 1 2.499-1.05m3.5 11h-12v7h12zm2-4h-16v2h16zm-10.5-5a1.5 1.5 0 0 0-.145 2.993l.145.007h1.5v-1.5A1.5 1.5 0 0 0 9.649 4.01zm5 0l-.145.007a1.5 1.5 0 0 0-1.348 1.348l-.007.145v1.5h1.5l.144-.007a1.5 1.5 0 0 0 0-2.986z"/>',
    },
    "gift-fill": {
      body: '<path fill="currentColor" d="M15.005 2.003a4 4 0 0 1 3.464 6h4.536v2h-2v10a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-10h-2v-2H5.54a4 4 0 0 1 6.465-4.646a3.98 3.98 0 0 1 2.999-1.354m-2 8h-2v10h2zm-4-6a2 2 0 0 0-.15 3.994l.15.006h2v-2a2 2 0 0 0-1.697-1.977l-.154-.018zm6 0a2 2 0 0 0-1.995 1.85l-.005.15v2h2a2 2 0 0 0 1.994-1.85l.006-.15a2 2 0 0 0-2-2"/>',
    },
    "gift-line": {
      body: '<path fill="currentColor" d="M15.005 2.003a4 4 0 0 1 3.464 6h4.536v2h-2v10a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-10h-2v-2H5.54a4 4 0 0 1 6.465-4.646a3.98 3.98 0 0 1 2.999-1.354m-4 8h-6v9h6zm8 0h-6v9h6zm-10-6a2 2 0 0 0-.15 3.994l.15.006h2v-2a2 2 0 0 0-1.697-1.977l-.154-.018zm6 0a2 2 0 0 0-1.995 1.85l-.005.15v2h2a2 2 0 0 0 1.994-1.85l.006-.15a2 2 0 0 0-2-2"/>',
    },
    "git-branch-fill": {
      body: '<path fill="currentColor" d="M7.105 15.21A3.001 3.001 0 1 1 5 15.17V8.83a3.001 3.001 0 1 1 2 0V12c.836-.628 1.874-1 3-1h4a3 3 0 0 0 2.895-2.21a3.001 3.001 0 1 1 2.032.064A5 5 0 0 1 14 13h-4a3 3 0 0 0-2.895 2.21"/>',
    },
    "git-branch-line": {
      body: '<path fill="currentColor" d="M7.105 15.21A3.001 3.001 0 1 1 5 15.17V8.83a3.001 3.001 0 1 1 2 0V12c.836-.628 1.874-1 3-1h4a3 3 0 0 0 2.895-2.21a3.001 3.001 0 1 1 2.032.064A5 5 0 0 1 14 13h-4a3 3 0 0 0-2.895 2.21M6 17a1 1 0 1 0 0 2a1 1 0 0 0 0-2M6 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2m12 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "git-close-pull-request-fill": {
      body: '<path fill="currentColor" d="M3 6a3 3 0 1 1 4 2.83v6.34a3.001 3.001 0 1 1-2 0V8.83A3 3 0 0 1 3 6m12.293-2.707a1 1 0 0 1 1.414 0L18 4.586l1.293-1.293a1 1 0 1 1 1.414 1.414L19.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L18 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L16.586 6l-1.293-1.293a1 1 0 0 1 0-1.414M18 10a1 1 0 0 1 1 1v4.17a3.001 3.001 0 1 1-2 0V11a1 1 0 0 1 1-1"/>',
    },
    "git-close-pull-request-line": {
      body: '<path fill="currentColor" d="M6 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2M3 6a3 3 0 1 1 4 2.83v6.34a3.001 3.001 0 1 1-2 0V8.83A3 3 0 0 1 3 6m12.293-2.707a1 1 0 0 1 1.414 0L18 4.586l1.293-1.293a1 1 0 1 1 1.414 1.414L19.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L18 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L16.586 6l-1.293-1.293a1 1 0 0 1 0-1.414M18 10a1 1 0 0 1 1 1v4.17a3.001 3.001 0 1 1-2 0V11a1 1 0 0 1 1-1M6 17a1 1 0 1 0 0 2a1 1 0 0 0 0-2m12 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "git-commit-fill": {
      body: '<path fill="currentColor" d="M15.874 13a4.002 4.002 0 0 1-7.748 0H3v-2h5.126a4.002 4.002 0 0 1 7.748 0H21v2z"/>',
    },
    "git-commit-line": {
      body: '<path fill="currentColor" d="M15.874 13a4.002 4.002 0 0 1-7.748 0H3v-2h5.126a4.002 4.002 0 0 1 7.748 0H21v2zM12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "git-fork-fill": {
      body: '<path fill="currentColor" d="M9 6a3 3 0 0 1-2 2.83V9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-.17a3.001 3.001 0 1 1 2 0V9a4 4 0 0 1-4 4h-2v2.17a3.001 3.001 0 1 1-2 0V13H9a4 4 0 0 1-4-4v-.17A3.001 3.001 0 1 1 9 6"/>',
    },
    "git-fork-line": {
      body: '<path fill="currentColor" d="M6 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2M3 6a3 3 0 1 1 4 2.83V9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-.17a3.001 3.001 0 1 1 2 0V9a4 4 0 0 1-4 4h-2v2.17a3.001 3.001 0 1 1-2 0V13H9a4 4 0 0 1-4-4v-.17A3 3 0 0 1 3 6m15-1a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-6 12a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "git-merge-fill": {
      body: '<path fill="currentColor" d="M7.105 8.79A3 3 0 0 0 10 11h4a5 5 0 0 1 4.927 4.146A3.001 3.001 0 0 1 18 21a3 3 0 0 1-1.105-5.79A3 3 0 0 0 14 13h-4a4.98 4.98 0 0 1-3-1v3.17a3.001 3.001 0 1 1-2 0V8.83a3.001 3.001 0 1 1 2.105-.04"/>',
    },
    "git-merge-line": {
      body: '<path fill="currentColor" d="M7.105 8.79A3 3 0 0 0 10 11h4a5 5 0 0 1 4.927 4.146A3.001 3.001 0 0 1 18 21a3 3 0 0 1-1.105-5.79A3 3 0 0 0 14 13h-4a4.98 4.98 0 0 1-3-1v3.17a3.001 3.001 0 1 1-2 0V8.83a3.001 3.001 0 1 1 2.105-.04M6 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 12a1 1 0 1 0 0-2a1 1 0 0 0 0 2m12 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "git-pr-draft-fill": {
      body: '<path fill="currentColor" d="M7 8.83a3.001 3.001 0 1 0-2 0v6.34a3.001 3.001 0 1 0 2 0zM21 18a3 3 0 1 1-6 0a3 3 0 0 1 6 0M18 7.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m1.5 4a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "git-pr-draft-line": {
      body: '<path fill="currentColor" d="M5 6a1 1 0 1 1 2 0a1 1 0 0 1-2 0m1-3a3 3 0 0 0-1 5.83v6.34a3.001 3.001 0 1 0 2 0V8.83A3.001 3.001 0 0 0 6 3M5 18a1 1 0 1 1 2 0a1 1 0 0 1-2 0m13-1a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0a3 3 0 0 1-6 0m3-10.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m1.5 4a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "git-pull-request-fill": {
      body: '<path fill="currentColor" d="M15 5h2a2 2 0 0 1 2 2v8.17a3.001 3.001 0 1 1-2 0V7h-2v3l-4.5-4L15 2zM5 8.83a3.001 3.001 0 1 1 2 0v6.34a3.001 3.001 0 1 1-2 0z"/>',
    },
    "git-pull-request-line": {
      body: '<path fill="currentColor" d="M15 5h2a2 2 0 0 1 2 2v8.17a3.001 3.001 0 1 1-2 0V7h-2v3l-4.5-4L15 2zM5 8.83a3.001 3.001 0 1 1 2 0v6.34a3.001 3.001 0 1 1-2 0zM6 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 12a1 1 0 1 0 0-2a1 1 0 0 0 0 2m12 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "git-repository-commits-fill": {
      body: '<path fill="currentColor" d="M14 17v6h-2v-6H9l4-5l4 5zm2 2h3v-3h-.8L13 9.5L7.647 16H6.5a1.5 1.5 0 0 0 0 3H10v2H6.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-4zM7 5v2h2V5zm0 3v2h2V8z"/>',
    },
    "git-repository-commits-line": {
      body: '<path fill="currentColor" d="M18 16v-2h1V4H6v10.035Q6.245 14 6.5 14H8v2H6.5a1.5 1.5 0 0 0 0 3H10v2H6.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-4v-2h3v-3zM7 5h2v2H7zm0 3h2v2H7zm7 9v6h-2v-6H9l4-5l4 5z"/>',
    },
    "git-repository-fill": {
      body: '<path fill="currentColor" d="M13 21v2.5l-3-2l-3 2V21h-.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zm-6-2v-2h6v2h6v-3H6.5a1.5 1.5 0 0 0 0 3zM7 5v2h2V5zm0 3v2h2V8zm0 3v2h2v-2z"/>',
    },
    "git-repository-line": {
      body: '<path fill="currentColor" d="M13 21v2.5l-3-2l-3 2V21h-.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zm0-2h6v-3H6.5a1.5 1.5 0 0 0 0 3H7v-2h6zm6-5V4H6v10.035Q6.245 14 6.5 14zM7 5h2v2H7zm0 3h2v2H7zm0 3h2v2H7z"/>',
    },
    "git-repository-private-fill": {
      body: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0zm-2 0V7a4 4 0 0 0-8 0v1zm-9 3v2h2v-2zm0 3v2h2v-2zm0 3v2h2v-2z"/>',
    },
    "git-repository-private-line": {
      body: '<path fill="currentColor" d="M6 10v10h13V10zm12-2h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0zm-2 0V7a4 4 0 0 0-8 0v1zm-9 3h2v2H7zm0 3h2v2H7zm0 3h2v2H7z"/>',
    },
    "github-fill": {
      body: '<path fill="currentColor" d="M12.001 2c-5.525 0-10 4.475-10 10a9.99 9.99 0 0 0 6.837 9.488c.5.087.688-.213.688-.476c0-.237-.013-1.024-.013-1.862c-2.512.463-3.162-.612-3.362-1.175c-.113-.288-.6-1.175-1.025-1.413c-.35-.187-.85-.65-.013-.662c.788-.013 1.35.725 1.538 1.025c.9 1.512 2.337 1.087 2.912.825c.088-.65.35-1.087.638-1.337c-2.225-.25-4.55-1.113-4.55-4.938c0-1.088.387-1.987 1.025-2.687c-.1-.25-.45-1.275.1-2.65c0 0 .837-.263 2.75 1.024a9.3 9.3 0 0 1 2.5-.337c.85 0 1.7.112 2.5.337c1.913-1.3 2.75-1.024 2.75-1.024c.55 1.375.2 2.4.1 2.65c.637.7 1.025 1.587 1.025 2.687c0 3.838-2.337 4.688-4.562 4.938c.362.312.675.912.675 1.85c0 1.337-.013 2.412-.013 2.75c0 .262.188.574.688.474A10.02 10.02 0 0 0 22 12c0-5.525-4.475-10-10-10"/>',
    },
    "github-line": {
      body: '<path fill="currentColor" d="M5.884 18.653c-.3-.2-.558-.455-.86-.816a51 51 0 0 1-.466-.579c-.463-.575-.755-.841-1.056-.95a1 1 0 1 1 .675-1.882c.752.27 1.261.735 1.947 1.588c-.094-.117.34.427.433.539c.19.227.33.365.44.438c.204.137.588.196 1.15.14c.024-.382.094-.753.202-1.095c-2.968-.726-4.648-2.64-4.648-6.396c0-1.24.37-2.356 1.058-3.292c-.218-.894-.185-1.975.302-3.192a1 1 0 0 1 .63-.582c.081-.024.127-.035.208-.047c.803-.124 1.937.17 3.415 1.096a11.7 11.7 0 0 1 2.687-.308c.912 0 1.819.104 2.684.308c1.477-.933 2.614-1.227 3.422-1.096q.128.02.218.05a1 1 0 0 1 .616.58c.487 1.216.52 2.296.302 3.19c.691.936 1.058 2.045 1.058 3.293c0 3.757-1.674 5.665-4.642 6.392c.125.415.19.878.19 1.38c0 .665-.002 1.299-.007 2.01c0 .19-.002.394-.005.706a1 1 0 0 1-.018 1.958c-1.14.227-1.984-.532-1.984-1.525l.002-.447l.005-.705c.005-.707.008-1.337.008-1.997c0-.697-.184-1.152-.426-1.361c-.661-.57-.326-1.654.541-1.751c2.966-.333 4.336-1.482 4.336-4.66c0-.955-.312-1.744-.913-2.404A1 1 0 0 1 17.2 6.19c.166-.414.236-.957.095-1.614l-.01.003c-.491.139-1.11.44-1.858.949a1 1 0 0 1-.833.135a9.6 9.6 0 0 0-2.592-.349c-.89 0-1.772.118-2.592.35a1 1 0 0 1-.829-.134c-.753-.507-1.374-.807-1.87-.947c-.143.653-.072 1.194.093 1.607a1 1 0 0 1-.189 1.045c-.597.655-.913 1.458-.913 2.404c0 3.172 1.371 4.328 4.322 4.66c.865.097 1.202 1.177.545 1.748c-.193.168-.43.732-.43 1.364v3.15c0 .985-.834 1.725-1.96 1.528a1 1 0 0 1-.04-1.962v-.99c-.91.061-1.661-.088-2.254-.485"/>',
    },
    "gitlab-fill": {
      body: '<path fill="currentColor" d="m21.663 9.987l-.028-.072l-2.719-7.094a.71.71 0 0 0-.706-.449a.71.71 0 0 0-.654.522L15.72 8.52H8.282L6.443 2.895a.71.71 0 0 0-.652-.524a.72.72 0 0 0-.707.45L2.362 9.925l-.028.07a5.06 5.06 0 0 0 1.674 5.838l.01.007l.024.019l4.147 3.104l2.05 1.553l1.247.944a.84.84 0 0 0 1.016 0l1.247-.944l2.05-1.553l4.172-3.123l.01-.008a5.055 5.055 0 0 0 1.682-5.845"/>',
    },
    "gitlab-line": {
      body: '<path fill="currentColor" d="M5.544 2.673a1.55 1.55 0 0 1 1.8.097v.001c.246.198.426.466.515.769l1.446 4.428h5.39L16.14 3.54a1.54 1.54 0 0 1 .515-.769l.004-.004a1.55 1.55 0 0 1 1.795-.095l.002.001c.274.174.486.43.605.732l.004.01l2.473 6.451a5.45 5.45 0 0 1-1.813 6.303l-6.73 5.064h-.002a1.66 1.66 0 0 1-2 0l-6.731-5.065a5.45 5.45 0 0 1-1.806-6.294l2.48-6.469c.12-.302.333-.558.607-.732m.811 2.063L4.16 10.464c-.28.737-.337 1.604-.12 2.362c.217.755.671 1.42 1.295 1.896l6.66 5.01l6.653-5.005a3.65 3.65 0 0 0 1.308-1.904c.22-.76.159-1.638-.123-2.378l-2.189-5.71L16 9.769H8z"/>',
    },
    "glasses-2-fill": {
      body: '<path fill="currentColor" d="M3.031 10.976c.04-1.48.127-2.667.325-3.655c.331-1.658.954-2.659 2.199-3.489l-1.11-1.664c-1.754 1.17-2.632 2.669-3.05 4.76C1 8.902 1 11.485 1 14.88V15a5 5 0 1 0 9.935-.806a3 3 0 0 1 2.13 0A5 5 0 1 0 23 15v-.12c0-3.396 0-5.979-.394-7.951c-.419-2.092-1.296-3.591-3.051-4.761l-1.11 1.664c1.246.83 1.868 1.831 2.2 3.49c.197.987.285 2.173.324 3.654A4.98 4.98 0 0 0 18 10a5 5 0 0 0-4.225 2.325A5 5 0 0 0 12 12a5 5 0 0 0-1.775.325A5 5 0 0 0 6 10a4.98 4.98 0 0 0-2.969.976"/>',
    },
    "glasses-2-line": {
      body: '<path fill="currentColor" d="M3.015 10.988c.03-1.535.11-2.52.34-3.667c.331-1.658.954-2.659 2.2-3.489l-1.11-1.664c-1.755 1.17-2.633 2.669-3.051 4.76c-.52 2.6-.398 7.936-.395 8.07V15a5 5 0 1 0 9.935-.806a3 3 0 0 1 2.13 0a5 5 0 1 0 9.935.806s.132-5.439-.394-8.071c-.419-2.092-1.296-3.591-3.05-4.761l-1.11 1.664c1.245.83 1.867 1.831 2.199 3.49c.229 1.145.31 2.131.34 3.666A4.98 4.98 0 0 0 17.998 10a5 5 0 0 0-4.224 2.325A5 5 0 0 0 11.999 12a5 5 0 0 0-1.775.325A5 5 0 0 0 5.999 10a4.98 4.98 0 0 0-2.984.988M3 15a3 3 0 1 1 6 0a3 3 0 0 1-6 0m12.168-.994A3.002 3.002 0 0 1 21 15a3 3 0 1 1-5.832-.994"/>',
    },
    "glasses-fill": {
      body: '<path fill="currentColor" d="M1 12a5 5 0 0 1 8.192-3.848A4 4 0 0 1 12 7c1.095 0 2.086.44 2.808 1.152a5 5 0 1 1-1.264 1.578A2 2 0 0 0 12 9c-.62 0-1.177.283-1.544.73A5 5 0 1 1 1 12"/>',
    },
    "glasses-line": {
      body: '<path fill="currentColor" d="M6 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6m-5 3a5 5 0 0 1 8.192-3.848A4 4 0 0 1 12 7c1.095 0 2.086.44 2.808 1.152a5 5 0 1 1-1.264 1.578A2 2 0 0 0 12 9c-.62 0-1.177.283-1.544.73A5 5 0 1 1 1 12m17-3a2.996 2.996 0 0 0-3 3a3 3 0 1 0 3-3"/>',
    },
    "global-fill": {
      body: '<path fill="currentColor" d="M2.05 13h5.477a17.9 17.9 0 0 0 2.925 8.88A10.005 10.005 0 0 1 2.049 13m0-2a10.005 10.005 0 0 1 8.402-8.881a17.9 17.9 0 0 0-2.925 8.88zm19.9 0h-5.477a17.9 17.9 0 0 0-2.925-8.881a10.005 10.005 0 0 1 8.403 8.88m0 2a10.005 10.005 0 0 1-8.402 8.88A17.9 17.9 0 0 0 16.473 13zM9.53 13h4.94A15.9 15.9 0 0 1 12 20.592A15.9 15.9 0 0 1 9.53 13m0-2A15.9 15.9 0 0 1 12 3.408A15.9 15.9 0 0 1 14.47 11z"/>',
    },
    "global-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.01 8.01 0 0 0 5.648 6.667M10.03 13c.151 2.439.848 4.73 1.97 6.752A15.9 15.9 0 0 0 13.97 13zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.01 8.01 0 0 0 19.938 13M4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333A8.01 8.01 0 0 0 4.062 11m5.969 0h3.938A15.9 15.9 0 0 0 12 4.248A15.9 15.9 0 0 0 10.03 11m4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.01 8.01 0 0 0-5.648-6.667"/>',
    },
    "globe-fill": {
      body: '<path fill="currentColor" d="M13 21h5v2H6v-2h5v-1.05a10 10 0 0 1-7.684-4.988l1.737-.992A8 8 0 1 0 15.97 3.053l.993-1.737A10 10 0 0 1 22 10c0 5.185-3.946 9.449-9 9.95zm-1-4a7 7 0 1 1 0-14a7 7 0 0 1 0 14"/>',
    },
    "globe-line": {
      body: '<path fill="currentColor" d="M13 21h5v2H6v-2h5v-1.05a10 10 0 0 1-7.684-4.988l1.737-.992A8 8 0 1 0 15.97 3.053l.993-1.737A10 10 0 0 1 22 10c0 5.185-3.946 9.449-9 9.95zm-1-4a7 7 0 1 1 0-14a7 7 0 0 1 0 14m0-2a5 5 0 1 0 0-10a5 5 0 0 0 0 10"/>',
    },
    "goblet-2-fill": {
      body: '<path fill="currentColor" d="M6.133 2L5.011 9.859c-.303 2.114.521 3.93 1.88 5.188c1.105 1.022 2.568 1.685 4.11 1.887V20H6v2h12v-2h-5v-3.066c1.54-.202 3.004-.865 4.109-1.888c1.359-1.257 2.182-3.073 1.88-5.187L17.868 2zM10 7c-.83 0-1.838.242-2.629.476L7.868 4h8.265l.49 3.431C15.785 7.707 14.89 8 14 8c-1.392 0-2.572-1-4-1"/>',
    },
    "goblet-2-line": {
      body: '<path fill="currentColor" d="M6.133 2L5.011 9.859c-.303 2.114.521 3.93 1.88 5.188c1.105 1.022 2.568 1.685 4.11 1.887V20H6v2h12v-2h-5v-3.066c1.54-.202 3.004-.865 4.109-1.888c1.359-1.257 2.182-3.073 1.88-5.187L17.868 2zm.857 8.141L7.868 4h8.265l.878 6.141c.198 1.386-.322 2.57-1.26 3.438c-.954.883-2.333 1.421-3.75 1.421c-1.418 0-2.797-.538-3.752-1.421c-.937-.868-1.457-2.052-1.259-3.438"/>',
    },
    "goblet-fill": {
      body: '<path fill="currentColor" d="M11 19v-5.111L3 5V3h18v2l-8 8.889V19h5v2H6v-2zM7.49 7h9.02l1.8-2H5.69z"/>',
    },
    "goblet-line": {
      body: '<path fill="currentColor" d="M11 19v-5.111L3 5V3h18v2l-8 8.889V19h5v2H6v-2zM7.49 7h9.02l1.8-2H5.69zm1.8 2L12 12.01L14.71 9z"/>',
    },
    "goggles-fill": {
      body: '<path fill="currentColor" d="M4.952 6.942C7.08 6.118 9.75 6 12 6s4.92.118 7.049.942c1.08.419 2.08 1.04 2.81 1.974C22.596 9.862 23 11.054 23 12.5c0 1.47-.525 2.933-1.38 4.042c-.85 1.105-2.116 1.958-3.62 1.958c-1.425 0-2.656-.79-3.575-1.38C13.72 16.667 12.883 16 12 16s-1.72.667-2.425 1.12c-.919.59-2.15 1.38-3.575 1.38c-1.503 0-2.769-.852-3.62-1.958A6.74 6.74 0 0 1 1 12.5c0-1.446.402-2.638 1.142-3.584c.729-.933 1.728-1.555 2.81-1.974"/>',
    },
    "goggles-line": {
      body: '<path fill="currentColor" d="M3.718 10.147C3.285 10.7 3 11.446 3 12.5c0 1.015.37 2.052.964 2.822C4.56 16.095 5.294 16.5 6 16.5c.762 0 1.514-.434 2.538-1.092C9.588 14.735 10.706 14 12 14s2.413.735 3.462 1.408c1.024.658 1.776 1.092 2.538 1.092c.706 0 1.44-.405 2.036-1.178c.593-.77.964-1.807.964-2.822c0-1.054-.285-1.8-.718-2.353c-.443-.567-1.1-1.008-1.956-1.34C16.582 8.133 14.252 8 12 8s-4.58.132-6.327.808c-.856.331-1.512.772-1.955 1.339m1.234-3.205C7.08 6.118 9.75 6 12 6s4.92.118 7.049.942c1.08.419 2.08 1.04 2.81 1.974C22.596 9.862 23 11.054 23 12.5c0 1.47-.525 2.933-1.38 4.042c-.85 1.105-2.116 1.958-3.62 1.958c-1.425 0-2.656-.79-3.575-1.38C13.72 16.667 12.883 16 12 16s-1.72.667-2.425 1.12c-.919.59-2.15 1.38-3.575 1.38c-1.503 0-2.769-.852-3.62-1.958A6.74 6.74 0 0 1 1 12.5c0-1.446.402-2.638 1.142-3.584c.729-.933 1.728-1.555 2.81-1.974"/>',
    },
    "golf-ball-fill": {
      body: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-8-5a1 1 0 1 0-2 0a1 1 0 0 0 2 0m-1 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m4 1a1 1 0 1 0-2 0a1 1 0 0 0 2 0m-1-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "golf-ball-line": {
      body: '<path fill="currentColor" d="M12 20a8 8 0 1 1 0-16a8 8 0 0 1 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m2-15a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-1 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m4 1a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-1-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "google-fill": {
      body: '<path fill="currentColor" d="M3.064 7.51A10 10 0 0 1 12 2c2.695 0 4.959.991 6.69 2.605l-2.867 2.868C14.786 6.482 13.468 5.977 12 5.977c-2.605 0-4.81 1.76-5.595 4.123c-.2.6-.314 1.24-.314 1.9s.114 1.3.314 1.9c.786 2.364 2.99 4.123 5.595 4.123c1.345 0 2.49-.355 3.386-.955a4.6 4.6 0 0 0 1.996-3.018H12v-3.868h9.418c.118.654.182 1.336.182 2.045c0 3.046-1.09 5.61-2.982 7.35C16.964 21.105 14.7 22 12 22A9.996 9.996 0 0 1 2 12c0-1.614.386-3.14 1.064-4.49"/>',
    },
    "google-line": {
      body: '<path fill="currentColor" d="M12 11h8.533q.066.578.067 1.184c0 2.734-.98 5.036-2.678 6.6c-1.485 1.371-3.518 2.175-5.942 2.175A8.976 8.976 0 0 1 3 11.98A8.976 8.976 0 0 1 11.98 3c2.42 0 4.453.89 6.008 2.339L16.526 6.8C15.368 5.681 13.803 5 12 5a7 7 0 0 0 0 14c3.527 0 6.144-2.608 6.577-6H12z"/>',
    },
    "google-play-fill": {
      body: '<path fill="currentColor" d="M3.61 1.814L13.793 12L3.611 22.186a1 1 0 0 1-.61-.92V2.735a1 1 0 0 1 .609-.921M14.5 12.707l2.302 2.302l-10.937 6.333zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.207 12zM5.865 2.658L16.803 8.99L14.5 11.293z"/>',
    },
    "google-play-line": {
      body: '<path fill="currentColor" d="M4.001 1.734a1 1 0 0 1 .501.135l16.004 9.266a1 1 0 0 1 0 1.73L4.502 22.131a1 1 0 0 1-1.501-.866V2.735a1 1 0 0 1 1-1m8.292 11.68l-4.498 4.498l5.699-3.299zM5 6.118v11.76l5.88-5.88zm10.284 4.302L13.707 12l1.578 1.577L18.009 12zm-7.49-4.336l4.5 4.5l1.199-1.2z"/>',
    },
    "government-fill": {
      body: '<path fill="currentColor" d="M2 19V8H1V6h3V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2h3v2h-1v11h1v2H1v-2zm11 0v-7h-2v7zm-5 0v-7H6v7zm10 0v-7h-2v7zM6 5v1h12V5z"/>',
    },
    "government-line": {
      body: '<path fill="currentColor" d="M20 6h3v2h-1v11h1v2H1v-2h1V8H1V6h3V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm0 2H4v11h3v-7h2v7h2v-7h2v7h2v-7h2v7h3zM6 5v1h12V5z"/>',
    },
    "gps-fill": {
      body: '<path fill="currentColor" d="m12 16l3 6H9zm-2.627.255a5 5 0 1 1 5.255 0l-1.356-2.711a2 2 0 1 0-2.544 0zm-2.241 4.482A10 10 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a10 10 0 0 1-5.131 8.737l-1.344-2.688a7 7 0 1 0-7.05 0z"/>',
    },
    "gps-line": {
      body: '<path fill="currentColor" d="M7.132 20.737A10 10 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a10 10 0 0 1-5.132 8.737l-.896-1.791a8 8 0 1 0-7.945 0zm1.792-3.584a6 6 0 1 1 6.151 0l-.898-1.797a4 4 0 1 0-4.354 0zM12 16l3 6H9z"/>',
    },
    "gradienter-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M8.126 11H4.062a8 8 0 0 0 0 2h4.064a4 4 0 0 1 0-2m7.748 0a4 4 0 0 1 0 2h4.064a8 8 0 0 0 0-2zM12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "gradienter-line": {
      body: '<path fill="currentColor" d="M2.05 13h2.012a8.001 8.001 0 0 0 15.876 0h2.013c-.502 5.053-4.766 9-9.951 9s-9.449-3.947-9.95-9m0-2c.5-5.053 4.764-9 9.95-9s9.449 3.947 9.95 9h-2.012a8.001 8.001 0 0 0-15.876 0zM12 14a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "graduation-cap-fill": {
      body: '<path fill="currentColor" d="M12 2L0 9l12 7l10-5.833V17.5h2V9zM3.999 13.49V18a9.99 9.99 0 0 0 8 4A9.99 9.99 0 0 0 20 18v-4.509l-8 4.667z"/>',
    },
    "graduation-cap-line": {
      body: '<path fill="currentColor" d="M4 11.333L0 9l12-7l12 7v8.5h-2v-7.333l-2 1.166v6.678l-.223.275A9.98 9.98 0 0 1 12 22a9.98 9.98 0 0 1-7.777-3.714L4 18.011zM6 12.5v4.792A7.98 7.98 0 0 0 12 20a7.98 7.98 0 0 0 6-2.708V12.5L12 16zM3.97 9L12 13.685L20.03 9L12 4.315z"/>',
    },
    "grid-fill": {
      body: '<path fill="currentColor" d="M14 10v4h-4v-4zm2 0h5v4h-5zm-2 11h-4v-5h4zm2 0v-5h5v4a1 1 0 0 1-1 1zM14 3v5h-4V3zm2 0h4a1 1 0 0 1 1 1v4h-5zm-8 7v4H3v-4zm0 11H4a1 1 0 0 1-1-1v-4h5zM8 3v5H3V4a1 1 0 0 1 1-1z"/>',
    },
    "grid-line": {
      body: '<path fill="currentColor" d="M14 10h-4v4h4zm2 0v4h3v-4zm-2 9v-3h-4v3zm2 0h3v-3h-3zM14 5h-4v3h4zm2 0v3h3V5zm-8 5H5v4h3zm0 9v-3H5v3zM8 5H5v3h3zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "group-2-fill": {
      body: '<path fill="currentColor" d="M10 19.748V16.4c0-1.283.995-2.292 2.467-2.868A8.5 8.5 0 0 0 9.5 13c-1.89 0-3.636.617-5.047 1.66A8.02 8.02 0 0 0 10 19.748m8.88-3.662C18.485 15.553 17.17 15 15.5 15c-2.006 0-3.5.797-3.5 1.4V20a8 8 0 0 0 6.88-3.914M9.55 11.5a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5m5.95 1a2 2 0 1 0 0-4a2 2 0 0 0 0 4M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "group-2-line": {
      body: '<path fill="currentColor" d="M9.55 11.5a2.25 2.25 0 1 1 0-4.5a2.25 2.25 0 0 1 0 4.5m.45 8.248V16.4c0-.488.144-.937.404-1.338a6.47 6.47 0 0 0-5.033 1.417A8 8 0 0 0 10 19.749M4.453 14.66A8.46 8.46 0 0 1 9.5 13a8.5 8.5 0 0 1 2.967.532C13.345 13.19 14.392 13 15.5 13c1.66 0 3.185.424 4.206 1.156a8 8 0 1 0-15.253.504m14.426 1.426C18.486 15.553 17.171 15 15.5 15c-2.006 0-3.5.797-3.5 1.4V20a8 8 0 0 0 6.88-3.914M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m3.5-9.5a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "group-3-fill": {
      body: '<path fill="currentColor" d="M2.5 7a4 4 0 1 0 8 0a4 4 0 0 0-8 0M2 21v-4.5a4.5 4.5 0 1 1 9 0V21zm15.5-10a4 4 0 1 1 0-8a4 4 0 0 1 0 8M13 21v-4.5a4.5 4.5 0 1 1 9 0V21z"/>',
    },
    "group-3-line": {
      body: '<path fill="currentColor" d="M8.5 7a2 2 0 1 1-4 0a2 2 0 0 1 4 0m-6 0a4 4 0 1 0 8 0a4 4 0 0 0-8 0M9 16.5a2.5 2.5 0 0 0-5 0V19h5zm2 4.5H2v-4.5a4.5 4.5 0 1 1 9 0zm8.5-14a2 2 0 1 1-4 0a2 2 0 0 1 4 0m-6 0a4 4 0 1 0 8 0a4 4 0 0 0-8 0m6.5 9.5a2.5 2.5 0 0 0-5 0V19h5zM13 19v-2.5a4.5 4.5 0 1 1 9 0V21h-9z"/>',
    },
    "group-fill": {
      body: '<path fill="currentColor" d="M2 22a8 8 0 1 1 16 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m7.363 2.233A7.505 7.505 0 0 1 22.983 22H20c0-2.61-1-4.986-2.637-6.767m-2.023-2.276A7.98 7.98 0 0 0 18 7a7.96 7.96 0 0 0-1.015-3.903A5 5 0 0 1 21 8a5 5 0 0 1-5.66 4.957"/>',
    },
    "group-line": {
      body: '<path fill="currentColor" d="M2 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m8.284 3.703A8 8 0 0 1 23 22h-2a6 6 0 0 0-3.537-5.473zm-.688-11.29A5.5 5.5 0 0 1 21 8.5a5.5 5.5 0 0 1-5 5.478v-2.013a3.5 3.5 0 0 0 1.041-6.609z"/>',
    },
    "guide-fill": {
      body: '<path fill="currentColor" d="M13 8v8a3 3 0 0 1-3 3H7.83a3.001 3.001 0 1 1 0-2H10a1 1 0 0 0 1-1V8a3 3 0 0 1 3-3h3V2l5 4l-5 4V7h-3a1 1 0 0 0-1 1"/>',
    },
    "guide-line": {
      body: '<path fill="currentColor" d="M13 8v8a3 3 0 0 1-3 3H7.83a3.001 3.001 0 1 1 0-2H10a1 1 0 0 0 1-1V8a3 3 0 0 1 3-3h3V2l5 4l-5 4V7h-3a1 1 0 0 0-1 1M5 19a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "h-1": {
      body: '<path fill="currentColor" d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8z"/>',
    },
    "h-2": {
      body: '<path fill="currentColor" d="M4 4v7h7V4h2v16h-2v-7H4v7H2V4zm14.5 4a3.75 3.75 0 0 1 2.978 6.03l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546a1.75 1.75 0 1 0-3.065-1.292l-.005.144h-2A3.75 3.75 0 0 1 18.5 8"/>',
    },
    "h-3": {
      body: '<path fill="currentColor" d="m22 8l-.002 2l-2.505 2.883a3.752 3.752 0 0 1-.993 7.367a3.75 3.75 0 0 1-3.682-3.033l1.964-.382a1.75 1.75 0 1 0 .924-1.895l-1.307-1.547L19.35 10H15V8zM4 4v7h7V4h2v16h-2v-7H4v7H2V4z"/>',
    },
    "h-4": {
      body: '<path fill="currentColor" d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2zm9-12v8h1.5v2H22v2h-2v-2h-5.5v-1.34l5-8.66zm-2 3.133L17.19 16H20z"/>',
    },
    "h-5": {
      body: '<path fill="currentColor" d="M22 8v2h-4.323l-.464 2.636A4.006 4.006 0 0 1 22.25 16.5a4 4 0 0 1-7.846 1.103l1.923-.551a2 2 0 1 0 .363-1.804l-1.81-.904L16 8zM4 4v7h7V4h2v16h-2v-7H4v7H2V4z"/>',
    },
    "h-6": {
      body: '<path fill="currentColor" d="m21.097 8l-2.598 4.5a4 4 0 1 1-3.453 1.981L18.788 8zM4 4v7h7V4h2v16h-2v-7H4v7H2V4zm14.5 10.5a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "hail-fill": {
      body: '<path fill="currentColor" d="M18.995 17.794a4 4 0 0 0-5.085-3.644A4.001 4.001 0 0 0 6 15c0 1.08.428 2.059 1.122 2.778a8 8 0 1 1 9.335-10.68a5.5 5.5 0 0 1 2.537 10.696M10 17a2 2 0 1 1 0-4a2 2 0 0 1 0 4m5 3a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-5 3a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "hail-line": {
      body: '<path fill="currentColor" d="M6 17.419A8.003 8.003 0 0 1 9 2a8 8 0 0 1 7.458 5.099A5.5 5.5 0 0 1 19 17.793v-2.13a3.5 3.5 0 1 0-4-5.612V10a6 6 0 1 0-9 5.197zM10 17a2 2 0 1 1 0-4a2 2 0 0 1 0 4m5 3a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-5 3a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "hammer-fill": {
      body: '<path fill="currentColor" d="M17 8V2h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-2 14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V8H2.5V6.074a1 1 0 0 1 .496-.863L8.5 2H15z"/>',
    },
    "hammer-line": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5v13a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9H3.5a1 1 0 0 1-1-1V5.618a1 1 0 0 1 .553-.894L8.5 2zm-5 2H8.972L4.5 6.236V7H11v14h2V7h2zm4 0h-2v3h2z"/>',
    },
    hand: {
      body: '<path fill="currentColor" d="M12.5 2a.5.5 0 0 0-.5.5V12h-2V4.5a.5.5 0 0 0-1 0V14H7c-.38-1.62-1.358-2.56-2.405-2.678A89 89 0 0 0 6.166 15.1c.86 1.962 1.725 3.422 2.838 4.399C10.078 20.442 11.459 21 13.5 21a5.5 5.5 0 0 0 5.5-5.5V7a.5.5 0 0 0-1 0v5h-2V4a.5.5 0 0 0-1 0v8h-2V2.5a.5.5 0 0 0-.5-.5M21 15.5a7.5 7.5 0 0 1-7.5 7.5c-2.458 0-4.328-.692-5.816-1.998c-1.45-1.274-2.459-3.064-3.35-5.1c-.93-2.127-1.444-3.422-1.724-4.178c-.357-.964.136-2.312 1.476-2.406a4.02 4.02 0 0 1 2.914.94V4.5a2.5 2.5 0 0 1 3.04-2.442a2.5 2.5 0 0 1 4.79-.467A2.502 2.502 0 0 1 18 4v.55q.243-.05.5-.05A2.5 2.5 0 0 1 21 7z"/>',
    },
    "hand-coin-fill": {
      body: '<path fill="currentColor" d="M9.335 11.502h2.17a4.5 4.5 0 0 1 4.5 4.5H9.004v1h8v-1a5.6 5.6 0 0 0-.885-3h2.886a5 5 0 0 1 4.516 2.852c-2.365 3.12-6.194 5.149-10.516 5.149c-2.761 0-5.1-.59-7-1.625v-9.304a6.97 6.97 0 0 1 3.33 1.428m-4.33 7.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm13-14a3 3 0 1 1 0 6a3 3 0 0 1 0-6m-7-3a3 3 0 1 1 0 6a3 3 0 0 1 0-6"/>',
    },
    "hand-coin-line": {
      body: '<path fill="currentColor" d="M5.005 9.003a1 1 0 0 1 1 1a6.97 6.97 0 0 1 4.33 1.5h2.17c1.332 0 2.53.58 3.354 1.5h3.146a5 5 0 0 1 4.516 2.851c-2.365 3.12-6.194 5.149-10.516 5.149c-2.79 0-5.15-.603-7.061-1.658a1 1 0 0 1-.94.658h-3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1zm1 3v5.022l.045.032c1.794 1.26 4.133 1.946 6.955 1.946c3.004 0 5.798-1.156 7.835-3.13l.133-.133l-.12-.1a3 3 0 0 0-1.643-.63l-.205-.007h-2.112q.11.483.112 1v1h-9v-2l6.79-.001l-.034-.079a2.5 2.5 0 0 0-2.092-1.415l-.164-.005h-2.93a5 5 0 0 0-3.57-1.5m-2-1h-1v7h1zm14-6a3 3 0 1 1 0 6a3 3 0 0 1 0-6m0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-7-5a3 3 0 1 1 0 6a3 3 0 0 1 0-6m0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "hand-heart-fill": {
      body: '<path fill="currentColor" d="M9.335 11.502h2.17a4.5 4.5 0 0 1 4.5 4.5H9.004v1h8v-1a5.6 5.6 0 0 0-.885-3h2.886a5 5 0 0 1 4.516 2.852c-2.365 3.12-6.194 5.149-10.516 5.149c-2.761 0-5.1-.59-7-1.625v-9.304a6.97 6.97 0 0 1 3.33 1.428m-5.33-2.5a1 1 0 0 1 .993.884l.007.116v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1zm9.646-5.424l.354.354l.353-.354a2.5 2.5 0 0 1 3.536 3.536l-3.89 3.889l-3.888-3.89a2.5 2.5 0 1 1 3.535-3.535"/>',
    },
    "hand-heart-line": {
      body: '<path fill="currentColor" d="M5.005 9.003a1 1 0 0 1 1 1a6.97 6.97 0 0 1 4.33 1.5h2.17c1.332 0 2.529.579 3.353 1.498l3.147.002a5 5 0 0 1 4.516 2.851c-2.365 3.12-6.194 5.149-10.516 5.149c-2.79 0-5.15-.604-7.061-1.658a1 1 0 0 1-.94.658h-3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1zm1 3v5.02l.045.034c1.794 1.26 4.133 1.946 6.955 1.946c3.004 0 5.798-1.156 7.835-3.13l.133-.133l-.12-.1a3 3 0 0 0-1.643-.63l-.205-.007l-2.112-.001q.11.484.112 1v1h-9v-2h6.79l-.034-.079a2.5 2.5 0 0 0-2.092-1.415l-.164-.005h-2.93a5 5 0 0 0-3.57-1.5m-2-1h-1v7h1zm9.646-7.425l.354.354l.353-.354a2.5 2.5 0 0 1 3.536 3.536l-3.89 3.889l-3.888-3.89a2.5 2.5 0 1 1 3.535-3.535M11.53 4.992a.5.5 0 0 0-.059.637l.058.07l2.475 2.475l2.476-2.475a.5.5 0 0 0 .058-.637l-.058-.07a.5.5 0 0 0-.638-.057l-.07.057l-1.769 1.77l-1.767-1.77l-.068-.058a.5.5 0 0 0-.638.058"/>',
    },
    "hand-sanitizer-fill": {
      body: '<path fill="currentColor" d="M17 2v2l-4-.001V6h3v2a4 4 0 0 1 4 4v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a4 4 0 0 1 4-4V6h3V3.999L7.5 4c-.63 0-1.37.49-2.2 1.6L3.7 4.4C4.87 2.84 6.13 2 7.5 2zm-4 10h-2v2H9v2h2v2h2v-2h2v-2h-2z"/>',
    },
    "hand-sanitizer-line": {
      body: '<path fill="currentColor" d="M17 2v2l-4-.001V6h3v2a4 4 0 0 1 4 4v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a4 4 0 0 1 4-4V6h3V3.999L7.5 4c-.63 0-1.37.49-2.2 1.6L3.7 4.4C4.87 2.84 6.13 2 7.5 2zm-1 8H8a2 2 0 0 0-2 2v8h12v-8a2 2 0 0 0-2-2m-3 2v2h2v2h-2v2h-2v-2H9v-2h2v-2z"/>',
    },
    "handbag-fill": {
      body: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7h1.074a1 1 0 0 1 .997.923l.846 11a1 1 0 0 1-.92 1.074L20.92 22H3.08a1 1 0 0 1-1-1l.003-.077l.846-11A1 1 0 0 1 3.926 9H5a7 7 0 0 1 7-7m2 11h-4v2h4zm-2-9a5 5 0 0 0-4.995 4.783L7 9h10a5 5 0 0 0-4.783-4.995z"/>',
    },
    "handbag-line": {
      body: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7h1.074a1 1 0 0 1 .997.923l.846 11a1 1 0 0 1-.92 1.074L20.92 22H3.08a1 1 0 0 1-1-1l.003-.077l.846-11A1 1 0 0 1 3.926 9H5a7 7 0 0 1 7-7m7.147 9H4.852l-.693 9H19.84zM14 13v2h-4v-2zm-2-9a5 5 0 0 0-4.995 4.783L7 9h10a5 5 0 0 0-4.783-4.995z"/>',
    },
    "hard-drive-2-fill": {
      body: '<path fill="currentColor" d="M21 3v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1M5 16v4h14v-4zm10 1h2v2h-2z"/>',
    },
    "hard-drive-2-line": {
      body: '<path fill="currentColor" d="M5 14h14V4H5zm0 2v4h14v-4zM4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m11 15h2v2h-2z"/>',
    },
    "hard-drive-3-fill": {
      body: '<path fill="currentColor" d="M5.5 2a1 1 0 0 0-.992.876l-1.5 12A1 1 0 0 0 3 15v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6q0-.062-.008-.124l-1.5-12A1 1 0 0 0 18.5 2zM5 16h14v4H5zm10 1h2v2h-2zm-2 0h-2v2h2z"/>',
    },
    "hard-drive-3-line": {
      body: '<path fill="currentColor" d="M4.508 2.876A1 1 0 0 1 5.5 2h13a1 1 0 0 1 .992.876l1.5 12Q21 14.938 21 15v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 .008-.124zM6.383 4l-1.25 10h13.734l-1.25-10zM19 16H5v4h14zm-4 1h2v2h-2zm-2 0h-2v2h2z"/>',
    },
    "hard-drive-fill": {
      body: '<path fill="currentColor" d="M13.95 2H20a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8.05q.494.05 1 .05c5.523 0 10-4.477 10-10q0-.506-.05-1M15 16v2h2v-2zM11.938 2Q12 2.492 12 3a8 8 0 0 1-9 7.938V3a1 1 0 0 1 1-1z"/>',
    },
    "hard-drive-line": {
      body: '<path fill="currentColor" d="M5 10.938A8.004 8.004 0 0 0 11.938 4H5zm0 2.013V20h14V4h-5.05A10 10 0 0 1 5 12.95M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m11 14h2v2h-2z"/>',
    },
    hashtag: {
      body: '<path fill="currentColor" d="m7.784 14l.42-4H4V8h4.415l.525-5h2.011l-.525 5h3.989l.525-5h2.011l-.525 5H20v2h-3.784l-.42 4H20v2h-4.415l-.525 5h-2.011l.525-5H9.585l-.525 5H7.049l.525-5H4v-2zm2.011 0h3.99l.42-4h-3.99z"/>',
    },
    "haze-2-fill": {
      body: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m7.5 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m-15 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M17 7a5 5 0 0 1 0 10q-2.765 0-5-3.121Q9.765 16.999 7 17A5 5 0 0 1 7 7q2.765 0 5 3.121Q14.235 7.001 17 7m-5-5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M4.5 2a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m15 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "haze-2-line": {
      body: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m7.5 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m-15 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M17 7a5 5 0 0 1 0 10q-2.765 0-5-3.121Q9.765 16.999 7 17A5 5 0 0 1 7 7q2.765 0 5 3.121Q14.235 7.001 17 7M7 9a3 3 0 1 0 0 6c1.254 0 2.51-.875 3.759-2.854l.089-.147l-.09-.145c-1.197-1.896-2.4-2.78-3.601-2.85zm10 0c-1.254 0-2.51.875-3.759 2.854l-.09.146l.09.146c1.198 1.896 2.4 2.78 3.602 2.85L17 15a3 3 0 1 0 0-6m-5-7a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M4.5 2a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m15 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "haze-fill": {
      body: '<path fill="currentColor" d="M6.083 13a6 6 0 1 1 11.834 0zM2 15h10v2H2zm12 0h8v2h-8zm2 4h4v2h-4zM4 19h10v2H4zm7-18h2v3h-2zM3.515 4.929l1.414-1.414L7.05 5.636L5.636 7.05zM19.07 3.515l1.414 1.414l-2.121 2.121l-1.414-1.414zM23 11v2h-3v-2zM4 11v2H1v-2z"/>',
    },
    "haze-line": {
      body: '<path fill="currentColor" d="M6.083 13a6 6 0 1 1 11.834 0h-2.043a4 4 0 1 0-7.748 0zM2 15h10v2H2zm12 0h8v2h-8zm2 4h4v2h-4zM4 19h10v2H4zm7-18h2v3h-2zM3.515 4.929l1.414-1.414L7.05 5.636L5.636 7.05zM19.07 3.515l1.414 1.414l-2.121 2.121l-1.414-1.414zM23 11v2h-3v-2zM4 11v2H1v-2z"/>',
    },
    "hd-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4.5 8.25V9H6v6h1.5v-2.25h2V15H11V9H9.5v2.25zm7-.75H16a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1.5zM13 9v6h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2z"/>',
    },
    "hd-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V5zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4.5 8.25h2V9H11v6H9.5v-2.25h-2V15H6V9h1.5zm7-.75v3H16a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zM13 9h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3z"/>',
    },
    heading: {
      body: '<path fill="currentColor" d="M17 11V4h2v17h-2v-8H7v8H5V4h2v7z"/>',
    },
    "headphone-fill": {
      body: '<path fill="currentColor" d="M4 12h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7C2 6.477 6.477 2 12 2s10 4.477 10 10v7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h3a8 8 0 1 0-16 0"/>',
    },
    "headphone-line": {
      body: '<path fill="currentColor" d="M12 4a8 8 0 0 0-8 8h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7C2 6.477 6.477 2 12 2s10 4.477 10 10v7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h3a8 8 0 0 0-8-8M4 14v5h3v-5zm13 0v5h3v-5z"/>',
    },
    "health-book-fill": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2H3v-2h2v-2H3v-2h2v-2H3V9h2V7H3V5h2V3a1 1 0 0 1 1-1zm-6 6h-2v3H9v2h2.999L12 16h2l-.001-3H17v-2h-3z"/>',
    },
    "health-book-line": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2H3v-2h2v-2H3v-2h2v-2H3V9h2V7H3V5h2V3a1 1 0 0 1 1-1zm-1 2H7v16h12zm-5 4v3h3v2h-3.001L14 16h-2l-.001-3H9v-2h3V8z"/>',
    },
    "heart-2-fill": {
      body: '<path fill="currentColor" d="M20.243 4.757a6 6 0 0 1 .236 8.236l-8.48 8.492l-8.478-8.492a6 6 0 0 1 6.74-9.553L6.343 7.358l1.414 1.415L12 4.53l-.013-.014l.014.013a6 6 0 0 1 8.242.228"/>',
    },
    "heart-2-line": {
      body: '<path fill="currentColor" d="M20.243 4.757a6 6 0 0 1 .236 8.236l-8.48 8.492l-8.478-8.492a6 6 0 0 1 8.48-8.464a6 6 0 0 1 8.242.228M5.172 6.172a4 4 0 0 0-.192 5.451L12 18.654l7.02-7.03a4 4 0 0 0-5.646-5.64l-4.202 4.203l-1.415-1.414l2.825-2.827l-.082-.069a4 4 0 0 0-5.328.295"/>',
    },
    "heart-3-fill": {
      body: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2"/>',
    },
    "heart-3-line": {
      body: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2m-3.566 15.604a27 27 0 0 0 2.42-1.701C18.335 14.533 20 11.943 20 9c0-2.36-1.537-4-3.5-4c-1.076 0-2.24.57-3.086 1.414L12 7.828l-1.414-1.414C9.74 5.57 8.576 5 7.5 5C5.56 5 4 6.657 4 9c0 2.944 1.666 5.533 4.645 7.903c.745.593 1.54 1.146 2.421 1.7c.299.189.595.37.934.572c.339-.202.635-.383.934-.571"/>',
    },
    "heart-add-2-fill": {
      body: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 1.425-.31 2.726-.827 3.907a6 6 0 0 0-8.36 8.112c-.307.182-.581.342-.813.481C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2M19 17v-3h-2v3h-3v2h2.999L17 22h2l-.001-3H22v-2z"/>',
    },
    "heart-add-2-line": {
      body: '<path fill="currentColor" d="M4 9c0-2.508 1.714-4 3.5-4c1.906 0 3.254 1.582 4.5 2.828C13.246 6.582 14.594 5 16.5 5C18.316 5 20 6.484 20 9c0 1.122-.236 2.15-.65 3.102l1.836.796A9.7 9.7 0 0 0 22 9c0-3.504-2.466-6-5.5-6c-1.91 0-3.354.985-4.5 2.028C10.854 3.985 9.41 3 7.5 3C4.504 3 2 5.496 2 9c0 3.02 1.362 5.47 3.203 7.445c1.83 1.962 4.182 3.51 6.289 4.753l1.016-1.722c-2.067-1.22-4.215-2.65-5.842-4.395C5.051 13.35 4 11.363 4 9m15 8v-3h-2v3h-3v2h2.999L17 22h2l-.001-3H22v-2z"/>',
    },
    "heart-add-fill": {
      body: '<path fill="currentColor" d="M19 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm1.243-9.243a6 6 0 0 1 .507 7.91a6 6 0 0 0-8.06 8.127l-.69.691l-8.479-8.492a6 6 0 0 1 8.48-8.464a6 6 0 0 1 8.242.228"/>',
    },
    "heart-add-line": {
      body: '<path fill="currentColor" d="M19 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm1.243-9.243a6 6 0 0 1 .237 8.235l-1.42-1.418c1.33-1.524 1.26-3.914-.233-5.404a4 4 0 0 0-5.49-.153l-1.335 1.198l-1.336-1.197a4 4 0 0 0-5.686 5.605l8.432 8.446L12 21.485l-8.48-8.492A6 6 0 0 1 12 4.529a6 6 0 0 1 8.242.228"/>',
    },
    "heart-fill": {
      body: '<path fill="currentColor" d="M12.001 4.529a6 6 0 0 1 8.242.228a6 6 0 0 1 .236 8.236l-8.48 8.492l-8.478-8.492a6 6 0 0 1 8.48-8.464"/>',
    },
    "heart-line": {
      body: '<path fill="currentColor" d="M12.001 4.529a6 6 0 0 1 8.242.228a6 6 0 0 1 .236 8.236l-8.48 8.492l-8.478-8.492a6 6 0 0 1 8.48-8.464m6.826 1.641a4 4 0 0 0-5.49-.153l-1.335 1.198l-1.336-1.197a4 4 0 0 0-5.686 5.605L12 18.654l7.02-7.03a4 4 0 0 0-.193-5.454"/>',
    },
    "heart-pulse-fill": {
      body: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5c-1.978-1.186-7.084-3.937-9.131-8.5h4.697l.934-1.556l3 5L13.566 13H17v-2h-4.566l-.934 1.556l-3-5L6.434 11H2.21A9.6 9.6 0 0 1 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2"/>',
    },
    "heart-pulse-line": {
      body: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5c-1.977-1.186-7.083-3.937-9.131-8.499L1 13v-2h1.21A9.6 9.6 0 0 1 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2m0 2c-1.076 0-2.24.57-3.086 1.414L12 7.828l-1.414-1.414C9.74 5.57 8.576 5 7.5 5C5.56 5 4 6.657 4 9q0 1.028.267 2h2.167L8.5 7.556l3 5L12.434 11H17v2h-3.434L11.5 16.444l-3-5L7.566 13H5.108c.79 1.374 1.985 2.668 3.537 3.903c.745.593 1.54 1.146 2.421 1.7c.299.189.595.37.934.572c.339-.202.635-.383.934-.571a27 27 0 0 0 2.42-1.701C18.335 14.533 20 11.943 20 9c0-2.36-1.537-4-3.5-4"/>',
    },
    "hearts-fill": {
      body: '<path fill="currentColor" d="M17.363 11.045a3.614 3.614 0 0 1 5.084 0a3.55 3.55 0 0 1 0 5.047L17 21.5l-5.447-5.408a3.55 3.55 0 0 1 0-5.047a3.614 3.614 0 0 1 5.084 0l.363.36zm1.88-6.288a6 6 0 0 1 1.689 3.338A5.62 5.62 0 0 0 17 8.808a5.62 5.62 0 0 0-6.856.818a5.55 5.55 0 0 0-.178 7.701l.178.185l2.421 2.404L11 21.485l-8.48-8.492A6 6 0 0 1 11 4.529a6 6 0 0 1 8.242.228"/>',
    },
    "hearts-line": {
      body: '<path fill="currentColor" d="M19.243 4.757a6 6 0 0 1 1.65 5.38c.568.16 1.106.463 1.554.908a3.55 3.55 0 0 1 0 5.047L17 21.5l-3.022-3L11 21.485l-8.48-8.492A6 6 0 0 1 11 4.529a6 6 0 0 1 8.242.228m-6.281 7.708a1.55 1.55 0 0 0 0 2.208L17 18.682l4.038-4.009a1.55 1.55 0 0 0 0-2.208a1.614 1.614 0 0 0-2.268.002l-1.772 1.754l-1.407-1.396l-.363-.36a1.613 1.613 0 0 0-2.266 0m-8.79-6.293a4 4 0 0 0-.192 5.451L11 18.654l1.559-1.562l-1.006-1a3.55 3.55 0 0 1 0-5.047a3.614 3.614 0 0 1 5.084 0l.363.36l.363-.36a3.6 3.6 0 0 1 1.465-.882a4 4 0 0 0-1.001-3.993a4 4 0 0 0-5.49-.153l-1.335 1.198l-1.336-1.197a4 4 0 0 0-5.494.154"/>',
    },
    "heavy-showers-fill": {
      body: '<path fill="currentColor" d="M13 18v5h-2v-5H9v3H7v-3.252a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18H17v3.001h-2v-3z"/>',
    },
    "heavy-showers-line": {
      body: '<path fill="currentColor" d="M5 16.93a8 8 0 1 1 11.458-9.831A5.5 5.5 0 0 1 19 17.793v-2.13a3.5 3.5 0 1 0-4-5.612V10a6 6 0 1 0-10 4.472zM7 14h2v6H7zm8 0h2v6h-2zm-4 3h2v6h-2z"/>',
    },
    "hexagon-fill": {
      body: '<path fill="currentColor" d="M17.5 2.5L23 12l-5.5 9.5h-11L1 12l5.5-9.5z"/>',
    },
    "hexagon-line": {
      body: '<path fill="currentColor" d="M17.5 2.5L23 12l-5.5 9.5h-11L1 12l5.5-9.5zm-1.153 2H7.653L3.311 12l4.342 7.5h8.694l4.342-7.5z"/>',
    },
    "history-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.865-5.135L8 9H2V3l2.447 2.446A9.98 9.98 0 0 1 12 2m1 5v4.585l3.243 3.243l-1.415 1.415L11 12.413V7z"/>',
    },
    "history-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.99 9.99 0 0 1 8-4m1 5v4.585l3.243 3.243l-1.415 1.415L11 12.413V7z"/>',
    },
    "home-2-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3z"/>',
    },
    "home-2-line": {
      body: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1M6 19h12V9.157l-6-5.454l-6 5.454z"/>',
    },
    "home-3-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zM8 15v2h8v-2z"/>',
    },
    "home-3-line": {
      body: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1M6 19h12V9.157l-6-5.454l-6 5.454zm2-4h8v2H8z"/>',
    },
    "home-4-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zm-9-7v6h2v-6z"/>',
    },
    "home-4-line": {
      body: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1m-6-2h5V9.157l-6-5.454l-6 5.454V19h5v-6h2z"/>',
    },
    "home-5-fill": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.223a1 1 0 0 1 1.228 0l8 6.223a1 1 0 0 1 .386.79zm-10-7v6h2v-6z"/>',
    },
    "home-5-line": {
      body: '<path fill="currentColor" d="M13 19h6V9.978l-7-5.444l-7 5.444V19h6v-6h2zm8 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.223a1 1 0 0 1 1.228 0l8 6.223a1 1 0 0 1 .386.79z"/>',
    },
    "home-6-fill": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.223a1 1 0 0 1 1.228 0l8 6.223a1 1 0 0 1 .386.79zM7 15v2h10v-2z"/>',
    },
    "home-6-line": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.223a1 1 0 0 1 1.228 0l8 6.223a1 1 0 0 1 .386.79zm-2-1V9.978l-7-5.444l-7 5.444V19zM7 15h10v2H7z"/>',
    },
    "home-7-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zm-8-5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"/>',
    },
    "home-7-line": {
      body: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1M6 19h12V9.157l-6-5.454l-6 5.454zm6-4a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5"/>',
    },
    "home-8-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zM9 10v6h6v-6zm2 2h2v2h-2z"/>',
    },
    "home-8-line": {
      body: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1M6 19h12V9.157l-6-5.454l-6 5.454zm3-9h6v6H9zm2 2v2h2v-2z"/>',
    },
    "home-fill": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.223a1 1 0 0 1 1.228 0l8 6.223a1 1 0 0 1 .386.79z"/>',
    },
    "home-gear-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zM8.592 13.808l-.991.572l1 1.733l.993-.573c.394.372.873.653 1.405.811v1.145h2.002V16.35a3.5 3.5 0 0 0 1.405-.81l.992.572L16.4 14.38l-.991-.572a3.5 3.5 0 0 0 0-1.62l.991-.573l-1-1.733l-.993.573A3.5 3.5 0 0 0 13 9.645V8.5h-2.002v1.144a3.5 3.5 0 0 0-1.405.811l-.992-.573L7.6 11.616l.991.572a3.5 3.5 0 0 0 0 1.62m3.408.69a1.5 1.5 0 1 1-.002-3.001a1.5 1.5 0 0 1 .002 3"/>',
    },
    "home-gear-line": {
      body: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1M6 19h12V9.157l-6-5.454l-6 5.454zm2.591-5.191a3.5 3.5 0 0 1 0-1.622l-.991-.572l1-1.732l.991.573a3.5 3.5 0 0 1 1.404-.812V8.5h2v1.144c.532.159 1.01.44 1.404.812l.991-.573l1 1.731l-.991.573a3.5 3.5 0 0 1 0 1.622l.991.572l-1 1.731l-.991-.572a3.5 3.5 0 0 1-1.404.811v1.145h-2V16.35a3.5 3.5 0 0 1-1.404-.811l-.991.572l-1-1.73zm3.404.688a1.5 1.5 0 1 0 0-2.998a1.5 1.5 0 0 0 0 2.998"/>',
    },
    "home-heart-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zm-8-3l3.359-3.359a2.25 2.25 0 0 0-3.182-3.182l-.177.177l-.177-.177a2.25 2.25 0 0 0-3.182 3.182z"/>',
    },
    "home-heart-line": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zm-2-1V9.157l-6-5.454l-6 5.454V19zm-6-2l-3.359-3.359a2.25 2.25 0 0 1 3.182-3.182l.177.177l.177-.177a2.25 2.25 0 0 1 3.182 3.182z"/>',
    },
    "home-line": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.223a1 1 0 0 1 1.228 0l8 6.223a1 1 0 0 1 .386.79zm-2-1V9.978l-7-5.444l-7 5.444V19z"/>',
    },
    "home-office-fill": {
      body: '<path fill="currentColor" d="M20.8 9H12v8h-1v4H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0zM14 11h9v7h-9zm-1 10h11v-2H13z"/>',
    },
    "home-office-line": {
      body: '<path fill="currentColor" d="M12.673 1.612L20.8 9h-2.973L12 3.703L6 9.158V19h5v2H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0M14 11h9v7h-9zm2 2v3h5v-3zm8 8H13v-2h11z"/>',
    },
    "home-smile-2-fill": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.314a1 1 0 0 1 .38-.785l8-6.311a1 1 0 0 1 1.24 0l8 6.31a1 1 0 0 1 .38.786zM7 12a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0z"/>',
    },
    "home-smile-2-line": {
      body: '<path fill="currentColor" d="M19 19V9.799l-7-5.522l-7 5.522V19zm2 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.314a1 1 0 0 1 .38-.785l8-6.311a1 1 0 0 1 1.24 0l8 6.31a1 1 0 0 1 .38.786zM7 12h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0"/>',
    },
    "home-smile-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zM7.5 13a4.5 4.5 0 1 0 9 0h-2a2.5 2.5 0 0 1-5 0z"/>',
    },
    "home-smile-line": {
      body: '<path fill="currentColor" d="M6 19h12V9.157l-6-5.454l-6 5.454zm13 2H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1M7.5 13h2a2.5 2.5 0 0 0 5 0h2a4.5 4.5 0 1 1-9 0"/>',
    },
    "home-wifi-fill": {
      body: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3zM7 11v2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7m0 4v3h3a3 3 0 0 0-3-3"/>',
    },
    "home-wifi-line": {
      body: '<path fill="currentColor" d="M6 19h12V9.157l-6-5.454l-6 5.454zm13 2H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1M8 10a7 7 0 0 1 7 7h-2a5 5 0 0 0-5-5zm0 4a3 3 0 0 1 3 3H8z"/>',
    },
    "honor-of-kings-fill": {
      body: '<path fill="currentColor" d="M21.16 4.258c.033 3.5.59 4.81.787 6.701a9.98 9.98 0 0 1-2.875 8.112c-3.666 3.666-9.471 3.89-13.4.673l2.852-2.853a6.002 6.002 0 0 0 8.368-8.368zm-2.83-.002l-2.852 2.853a6.002 6.002 0 0 0-8.368 8.368l-4.267 4.265c-.034-3.5-.591-4.811-.788-6.701A9.98 9.98 0 0 1 4.93 4.929c3.666-3.666 9.471-3.89 13.4-.673M12 8a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3"/>',
    },
    "honor-of-kings-line": {
      body: '<path fill="currentColor" d="m18.33 4.256l-1.424 1.423a8.001 8.001 0 0 0-12.272 9.444l2.417-2.417a5.002 5.002 0 0 1 7.707-4.879l-1.464 1.465a3.001 3.001 0 0 0-4.001 4l-6.45 6.45c-.034-3.5-.591-4.811-.788-6.701A9.98 9.98 0 0 1 4.93 4.929c3.666-3.666 9.471-3.89 13.4-.673m2.83.002c.033 3.5.59 4.81.787 6.701a9.98 9.98 0 0 1-2.875 8.112c-3.666 3.666-9.471 3.89-13.4.673l1.424-1.423a8.001 8.001 0 0 0 12.272-9.444l-2.417 2.417a5.002 5.002 0 0 1-7.707 4.878l1.464-1.464a3.001 3.001 0 0 0 4.001-4z"/>',
    },
    "honour-fill": {
      body: '<path fill="currentColor" d="M21 4v14.721a.5.5 0 0 1-.298.458L12 23.03l-8.702-3.85A.5.5 0 0 1 3 18.722V4H1V2h22v2zM8 12v2h8v-2zm0-4v2h8V8z"/>',
    },
    "honour-line": {
      body: '<path fill="currentColor" d="M21 4v14.721a.5.5 0 0 1-.298.458L12 23.03l-8.702-3.85A.5.5 0 0 1 3 18.722V4H1V2h22v2zM5 4v13.745l7 3.1l7-3.1V4zm3 4h8v2H8zm0 4h8v2H8z"/>',
    },
    "hospital-fill": {
      body: '<path fill="currentColor" d="M21 20h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zM11 8H9v2h2v2h2v-2h2V8h-2V6h-2zm3 12h2v-6H8v6h2v-4h4z"/>',
    },
    "hospital-line": {
      body: '<path fill="currentColor" d="M8 20v-6h8v6h3V4H5v16zm2 0h4v-4h-4zm11 0h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zM11 8V6h2v2h2v2h-2v2h-2v-2H9V8z"/>',
    },
    "hotel-bed-fill": {
      body: '<path fill="currentColor" d="M22 11v9h-2v-3H4v3H2V4h2v10h8V7h6a4 4 0 0 1 4 4M8 13a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "hotel-bed-line": {
      body: '<path fill="currentColor" d="M22 11v9h-2v-3H4v3H2V4h2v10h8V7h6a4 4 0 0 1 4 4m-2 3v-3a2 2 0 0 0-2-2h-4v5zM8 11a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "hotel-fill": {
      body: '<path fill="currentColor" d="M17 19h2v-8h-6v8h2v-6h2zM3 19V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5h2v10h1v2H2v-2zm4-8v2h2v-2zm0 4v2h2v-2zm0-8v2h2V7z"/>',
    },
    "hotel-line": {
      body: '<path fill="currentColor" d="M22 21H2v-2h1V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5h2v10h1zm-5-2h2v-8h-6v8h2v-6h2zm0-10V5H5v14h6V9zM7 11h2v2H7zm0 4h2v2H7zm0-8h2v2H7z"/>',
    },
    "hotspot-fill": {
      body: '<path fill="currentColor" d="M11 2v9h7v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm2 5a2 2 0 0 1 2 2h-2zm0-3a5 5 0 0 1 5 5h-2a3 3 0 0 0-3-3zm0-3a8 8 0 0 1 8 8h-2a6 6 0 0 0-6-6z"/>',
    },
    "hotspot-line": {
      body: '<path fill="currentColor" d="M11 2v2H7v16h10v-9h2v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm2 5a2 2 0 0 1 2 2h-2zm0-3a5 5 0 0 1 5 5h-2a3 3 0 0 0-3-3zm0-3a8 8 0 0 1 8 8h-2a6 6 0 0 0-6-6z"/>',
    },
    "hourglass-2-fill": {
      body: '<path fill="currentColor" d="M4 2h16v4.46L13.537 12L20 17.54V22H4v-4.46L10.463 12L4 6.46zm12.297 5L18 5.54V4H6v1.54L7.703 7zM12 13.317L6 18.46V20h1l5-3l5 3h1v-1.54z"/>',
    },
    "hourglass-2-line": {
      body: '<path fill="currentColor" d="M4 2h16v4.46L13.537 12L20 17.54V22H4v-4.46L10.463 12L4 6.46zm8 8.683l6-5.143V4H6v1.54zm0 2.634L6 18.46V20h12v-1.54z"/>',
    },
    "hourglass-fill": {
      body: '<path fill="currentColor" d="M6 4H4V2h16v2h-2v2c0 1.615-.816 2.915-1.844 3.977c-.703.726-1.558 1.395-2.425 2.023c.867.628 1.722 1.297 2.425 2.023C17.184 15.085 18 16.385 18 18v2h2v2H4v-2h2v-2c0-1.615.816-2.915 1.844-3.977c.703-.726 1.558-1.395 2.425-2.023c-.867-.628-1.722-1.297-2.425-2.023C6.816 8.915 6 7.615 6 6zm2 0v2c0 .685.26 1.335.771 2h6.458c.51-.665.771-1.315.771-2V4zm4 9.222c-1.045.738-1.992 1.441-2.719 2.192a7 7 0 0 0-.51.586h6.458a7 7 0 0 0-.51-.586c-.727-.751-1.674-1.454-2.719-2.192"/>',
    },
    "hourglass-line": {
      body: '<path fill="currentColor" d="M6 4H4V2h16v2h-2v2c0 1.615-.816 2.915-1.844 3.977c-.703.726-1.558 1.395-2.425 2.023c.867.628 1.722 1.297 2.425 2.023C17.184 15.085 18 16.385 18 18v2h2v2H4v-2h2v-2c0-1.615.816-2.915 1.844-3.977c.703-.726 1.558-1.395 2.425-2.023c-.867-.628-1.722-1.297-2.425-2.023C6.816 8.915 6 7.615 6 6zm2 0v2c0 .885.434 1.71 1.281 2.586c.727.751 1.674 1.454 2.719 2.192c1.045-.738 1.992-1.441 2.719-2.192C15.566 7.71 16 6.885 16 6V4zm4 9.222c-1.045.738-1.992 1.441-2.719 2.192C8.434 16.29 8 17.115 8 18v2h8v-2c0-.885-.434-1.71-1.281-2.586c-.727-.751-1.674-1.454-2.719-2.192"/>',
    },
    "hq-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4.5 8.25V9H6v6h1.5v-2.25h2V15H11V9H9.5v2.25zM16.25 15H17a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.75v1.5h1.5zm-1.75-4.5h2v3h-2z"/>',
    },
    "hq-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V5zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4.5 8.25h2V9H11v6H9.5v-2.25h-2V15H6V9h1.5zM16.25 15v1.5h-1.5V15H14a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-1.75-4.5v3h2v-3z"/>',
    },
    "html5-fill": {
      body: '<path fill="currentColor" d="m12 18.178l4.62-1.256l.623-6.778H9.026L8.822 7.89h8.626l.227-2.211H6.325l.636 6.678h7.82l-.261 2.866l-2.52.667l-2.52-.667l-.158-1.844h-2.27l.329 3.544zM3 2h18l-1.623 18L12 22l-7.377-2z"/>',
    },
    "html5-line": {
      body: '<path fill="currentColor" d="m12 18.178l-4.62-1.256l-.328-3.544h2.27l.158 1.844l2.52.667l2.52-.667l.26-2.866H6.96l-.635-6.678h11.35l-.227 2.21H8.822l.204 2.256h8.217l-.624 6.778zM3 2h18l-1.623 18L12 22l-7.377-2zm2.188 2L6.49 18.434L12 19.928l5.51-1.494L18.812 4z"/>',
    },
    "id-card-fill": {
      body: '<path fill="currentColor" d="M1 5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm12 3v2h6V8zm5 4h-5v2h5zm-7.5-2a2.5 2.5 0 1 0-5 0a2.5 2.5 0 0 0 5 0M8 13.5A3.5 3.5 0 0 0 4.5 17h7A3.5 3.5 0 0 0 8 13.5"/>',
    },
    "id-card-line": {
      body: '<path fill="currentColor" d="M3 6h18v12H3zM2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm11 4h6v2h-6zm5 4h-5v2h5zm-7.5-2a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0M8 13.5A3.5 3.5 0 0 0 4.5 17h7A3.5 3.5 0 0 0 8 13.5"/>',
    },
    "ie-fill": {
      body: '<path fill="currentColor" d="M8.613 20.12c-2.744 1.49-5.113 1.799-6.422.49c-1.344-1.34-.628-4.851 1.313-8.373A23.2 23.2 0 0 1 7.128 7.32c.187-.187 1.125-1.123 1.187-1.123c0 0-.5.312-.562.312c-1.95 1.095-3.663 3.08-4.037 3.525q.087-.389.206-.764a9.004 9.004 0 0 1 9.262-6.244c3.095-1.403 5.974-1.727 7.192-.511c1.125 1.123 1.062 2.995.125 5.242l-.027.064a8.96 8.96 0 0 1 1.027 4.18q0 .567-.07 1.12h-.804l-.142.002H8.69v.187c.062 1.997 1.812 3.744 3.937 3.744c1.5 0 2.937-.811 3.562-1.997h4.78l-.024.063a9.003 9.003 0 0 1-12.332 5m-.607-.32a9.03 9.03 0 0 1-3.972-4.743c-1.161 2.282-1.46 4.19-.469 5.18c.813.812 2.438.624 4.438-.436zM20.173 7.291l.015-.034c.75-1.622.813-2.994.125-3.806c-.869-.867-2.54-.75-4.522.168a9.03 9.03 0 0 1 4.382 3.672m-3.609 3.461v-.062c-.125-2.06-1.75-3.62-3.75-3.62c-2.125 0-3.936 1.685-4.061 3.62v.062z"/>',
    },
    "ie-line": {
      body: '<path fill="currentColor" d="M18.16 10a6.003 6.003 0 0 0-11.318 0zM6.584 13a6.002 6.002 0 0 0 11.08 2.057h3.304l-.023.063a9.003 9.003 0 0 1-12.332 5c-2.744 1.49-5.113 1.799-6.422.49c-1.344-1.34-.628-4.851 1.313-8.373a23.6 23.6 0 0 1 2.498-3.665q.54-.65 1.126-1.252c-.275.055-1.88.851-3.412 2.714q.087-.389.206-.764a9.004 9.004 0 0 1 9.262-6.244c3.095-1.403 5.974-1.727 7.192-.511c1.125 1.123 1.062 2.995.125 5.242l-.027.064a8.96 8.96 0 0 1 1.027 4.18q0 .505-.055 1zm1.422 6.8a9.03 9.03 0 0 1-3.972-4.743c-1.161 2.282-1.46 4.19-.469 5.18c.813.812 2.438.624 4.438-.436zM20.173 7.29l.015-.034c.75-1.622.813-2.994.125-3.806c-.869-.867-2.54-.75-4.522.168a9.03 9.03 0 0 1 4.382 3.672"/>',
    },
    "image-2-fill": {
      body: '<path fill="currentColor" d="m5 11.1l2-2l5.5 5.5l3.5-3.5l3 3V5H5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m11.5 7a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "image-2-line": {
      body: '<path fill="currentColor" d="m5 11.1l2-2l5.5 5.5l3.5-3.5l3 3V5H5zm0 2.829V19h3.1l2.986-2.985L7 11.929zM10.929 19H19v-2.071l-3-3zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m11.5 7a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "image-add-fill": {
      body: '<path fill="currentColor" d="M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm.008-12c.548 0 .992.445.992.993v9.349A6 6 0 0 0 20 13V5H4l.001 14l9.292-9.293a1 1 0 0 1 1.32-.084l.094.085l3.545 3.55a6.003 6.003 0 0 0-3.91 7.743L2.992 21A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zM8 7a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "image-add-line": {
      body: '<path fill="currentColor" d="M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm.008-12c.548 0 .992.445.992.993V13h-2V5H4v13.999L14 9l3 3v2.829l-3-3L6.827 19H14v2H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zM8 7a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "image-circle-fill": {
      body: '<path fill="currentColor" d="m19.576 14.576l-3.869-3.869a1 1 0 0 0-1.414 0l-7.428 7.428a8 8 0 1 1 12.711-3.559M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m-1-12a2 2 0 1 1-4 0a2 2 0 0 1 4 0"/>',
    },
    "image-circle-line": {
      body: '<path fill="currentColor" d="m19.576 14.576l-3.87-3.869a1 1 0 0 0-1.413 0l-7.428 7.428a8 8 0 1 1 12.711-3.558M8.59 19.24L15 12.83l3.639 3.638A8 8 0 0 1 12 20a8 8 0 0 1-3.41-.761M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m-1-12a2 2 0 1 1-4 0a2 2 0 0 1 4 0"/>',
    },
    "image-edit-fill": {
      body: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v1.757l-2 2V5H5v8.1l4-4l4.328 4.329l-1.327 1.327l-.006 4.239l4.246.006l1.33-1.33L18.899 19H19v-2.758l2-2V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1.778 4.808l1.414 1.414L15.414 17l-1.416-.002l.002-1.412zM15.5 7a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "image-edit-line": {
      body: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v1.757l-2 2V5H5v8.1l4-4l4.328 4.329l-1.415 1.413L9 11.93l-4 3.999V19h10.533l.708.001l1.329-1.33L18.9 19h.1v-2.758l2-2V20a1 1 0 0 1-1 1H4c-.55 0-1-.45-1-1V4a1 1 0 0 1 1-1zm1.778 4.808l1.414 1.414L15.414 17l-1.416-.002l.002-1.412zM15.5 7a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/>',
    },
    "image-fill": {
      body: '<path fill="currentColor" d="M20 5H4v14l9.292-9.294a1 1 0 0 1 1.415 0L20 15.01zM2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM8 11a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "image-line": {
      body: '<path fill="currentColor" d="M2.992 21A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993zM20 15V5H4v14L14 9zm0 2.828l-6-6L6.828 19H20zM8 11a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "import-fill": {
      body: '<path fill="currentColor" d="M21 3H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-9 13a3 3 0 0 1-3-3H4V5h16v8h-5a3 3 0 0 1-3 3m4-7h-3V6h-2v3H8l4 4.5z"/>',
    },
    "import-line": {
      body: '<path fill="currentColor" d="M22 4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1zM4 15h3.416a5.001 5.001 0 0 0 9.168 0H20v4H4zM4 5h16v8h-5a3 3 0 1 1-6 0H4zm12 4h-3V6h-2v3H8l4 4.5z"/>',
    },
    "inbox-2-fill": {
      body: '<path fill="currentColor" d="M5 3a1 1 0 0 0-.976.783l-2 9A1 1 0 0 0 2 13v7a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-7q0-.11-.024-.217l-2-9A1 1 0 0 0 19 3zm14.753 9H15a3 3 0 1 1-6 0H4.247l1.555-7h12.396z"/>',
    },
    "inbox-2-line": {
      body: '<path fill="currentColor" d="M4.024 3.783A1 1 0 0 1 5 3h14a1 1 0 0 1 .976.783l2 9Q22 12.89 22 13v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 .024-.217zM5.802 5l-1.555 7H9a3 3 0 1 0 6 0h4.753l-1.555-7zm10.782 9a5.001 5.001 0 0 1-9.168 0H4v5h16v-5z"/>',
    },
    "inbox-archive-fill": {
      body: '<path fill="currentColor" d="M4 3h16l2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004zm9 11v-4h-2v4H8l4 4l4-4zm6.764-7l-1-2H5.237l-1 2z"/>',
    },
    "inbox-archive-line": {
      body: '<path fill="currentColor" d="m20 3l2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004L4 3zm0 6H4v10h16zm-7 1v4h3l-4 4l-4-4h3v-4zm5.764-5H5.237l-1 2h15.527z"/>',
    },
    "inbox-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m6 9a3 3 0 1 0 6 0h5V5H4v7z"/>',
    },
    "inbox-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM7.416 14H4v5h16v-5h-3.416a5.001 5.001 0 0 1-9.168 0M20 5H4v7h5a3 3 0 1 0 6 0h5z"/>',
    },
    "inbox-unarchive-fill": {
      body: '<path fill="currentColor" d="m20 3l2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004L4 3zm-8 7l-4 4h3v4h2v-4h3zm6.764-5H5.236l-.999 2h15.527z"/>',
    },
    "inbox-unarchive-line": {
      body: '<path fill="currentColor" d="m20 3l2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004L4 3zm0 6H4v10h16zm-8 1l4 4h-3v4h-2v-4H8zm6.764-5H5.236l-.999 2h15.527z"/>',
    },
    "increase-decrease-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m6 8v-2h-2v2h-2v2h2v2h2v-2h2v-2zm4 0v2h6v-2z"/>',
    },
    "increase-decrease-line": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m1 2v14h16v-14zm5 6h2v2h-2v2h-2v-2h-2v-2h2v-2h2zm4 0h6v2h-6z"/>',
    },
    "indent-decrease": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 15h18v2H3zm8-5h10v2H11zm0-5h10v2H11zm-8 3.5L7 9v7z"/>',
    },
    "indent-increase": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 15h18v2H3zm8-5h10v2H11zm0-5h10v2H11zm-4 3.5L3 16V9z"/>',
    },
    "indeterminate-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M7 11v2h10v-2z"/>',
    },
    "indeterminate-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-9h10v2H7z"/>',
    },
    "infinity-fill": {
      body: '<path fill="currentColor" d="M3 12a3.5 3.5 0 0 0 3.5 3.5c1.204 0 2.02-.434 2.7-1.113c.621-.623 1.121-1.44 1.655-2.387c-.534-.947-1.034-1.764-1.656-2.387C8.52 8.933 7.704 8.5 6.5 8.5A3.5 3.5 0 0 0 3 12m3.5 5.5a5.5 5.5 0 1 1 0-11c1.797 0 3.105.691 4.113 1.7c.536.534.987 1.162 1.387 1.802c.4-.64.851-1.268 1.387-1.803C14.395 7.191 15.703 6.5 17.5 6.5a5.5 5.5 0 1 1 0 11c-1.796 0-3.105-.691-4.113-1.7c-.536-.534-.987-1.162-1.387-1.802c-.4.64-.851 1.268-1.387 1.803C9.605 16.809 8.297 17.5 6.5 17.5m6.645-5.5c.534.947 1.034 1.764 1.656 2.387c.68.68 1.496 1.113 2.699 1.113a3.5 3.5 0 1 0 0-7c-1.203 0-2.02.434-2.7 1.113c-.621.623-1.121 1.44-1.655 2.387"/>',
    },
    "infinity-line": {
      body: '<path fill="currentColor" d="M3 12a3.5 3.5 0 0 1 3.5-3.5c1.204 0 2.02.434 2.7 1.113c.726.727 1.285 1.72 1.926 2.873l.034.06c.6 1.082 1.283 2.311 2.227 3.255c1.008 1.008 2.316 1.699 4.113 1.699a5.5 5.5 0 1 0-4.158-9.1a24 24 0 0 1 1.122 1.857A3.5 3.5 0 1 1 17.5 15.5c-1.203 0-2.02-.434-2.7-1.113c-.726-.727-1.285-1.72-1.926-2.873l-.034-.06c-.6-1.082-1.283-2.311-2.227-3.255C9.605 7.191 8.297 6.5 6.5 6.5a5.5 5.5 0 1 0 4.158 9.1a24 24 0 0 1-1.122-1.857A3.5 3.5 0 0 1 3 12"/>',
    },
    "info-i": {
      body: '<path fill="currentColor" d="M12 6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-3 4h2v8H9v2h6v-2h-2V8H9z"/>',
    },
    "information-2-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-12.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m2 5.5h-1v-4.5h-3v2h1V15h-1v2h4z"/>',
    },
    "information-2-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-9.5V15h1v2h-4v-2h1v-2.5h-1v-2zm.5-2.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "information-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-1-11v6h2v-6zm0-4v2h2V7z"/>',
    },
    "information-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M11 7h2v2h-2zm0 4h2v6h-2z"/>',
    },
    "information-off-fill": {
      body: '<path fill="currentColor" d="M19.743 18.329A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10a9.96 9.96 0 0 0-6.329 2.257l6.243 6.243H13v1.086zM10 11.414L4.257 5.671A9.96 9.96 0 0 0 2 12c0 5.523 4.477 10 10 10a9.96 9.96 0 0 0 6.329-2.257L14 15.414V17h-4v-2h1v-2.5h-1zM13.586 15H13v-.586zM13.5 8a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"/>',
    },
    "information-off-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m14.906 6.32A8 8 0 0 1 5.68 7.094l4.32 4.32V12.5h1V15h-1v2h4v-1.586zm1.414-1.414L13 11.586V10.5h-1.086l-4.82-4.82A8 8 0 0 1 18.32 16.905M13 14.414V15h.586zM12 9.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "infrared-thermometer-fill": {
      body: '<path fill="currentColor" d="M21 2v9h-3.001L18 12a4 4 0 0 1-4 4h-1.379l-.613 3.111l.911 1.321A1 1 0 0 1 12.096 22H3l2.313-10.024L3 11l4-9zm-5.001 9h-2.394l-.591 3H14a2 2 0 0 0 2-2z"/>',
    },
    "infrared-thermometer-line": {
      body: '<path fill="currentColor" d="M21 2v9h-3.001L18 12a4 4 0 0 1-4 4h-1.379l-.613 3.111l.911 1.321A1 1 0 0 1 12.096 22H3l2.313-10.024L3 11l4-9zm-2 2H8.3L5.655 9.95l1.985.837L5.514 20h4.678l-.309-.448L11.96 9H19zm-3.001 7h-2.394l-.591 3H14a2 2 0 0 0 2-2z"/>',
    },
    "ink-bottle-fill": {
      body: '<path fill="currentColor" d="m16 8.997l4.371 1.748a1 1 0 0 1 .629.929v9.323a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.323a1 1 0 0 1 .629-.929L8 8.997zm4 5H8v5h12zm-4-11a1 1 0 0 1 1 1v4H7v-4a1 1 0 0 1 1-1z"/>',
    },
    "ink-bottle-line": {
      body: '<path fill="currentColor" d="m16 8.997l4.371 1.748a1 1 0 0 1 .629.929v9.323a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.323a1 1 0 0 1 .629-.929L8 8.997zm-.385 2h-7.23L5 12.35v7.646h14v-1H8v-5h11V12.35zm.385-8a1 1 0 0 1 1 1v4H7v-4a1 1 0 0 1 1-1zm-1 2H9v1h6z"/>',
    },
    "input-cursor-move": {
      body: '<path fill="currentColor" d="M8 21v-2h3V5H8V3h8v2h-3v14h3v2zM18.05 7.05L23 12l-4.95 4.95l-1.414-1.414L20.172 12l-3.536-3.536zm-12.1 0l1.414 1.414L3.828 12l3.536 3.536L5.95 16.95L1 12z"/>',
    },
    "input-field": {
      body: '<path fill="currentColor" d="M8 5h3v14H8v2h8v-2h-3V5h3V3H8zM2 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6v-2H3V9h5V7zm14 2h5v6h-5v2h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-6z"/>',
    },
    "input-method-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5.869 12h4.262l.82 2h2.216L13 7h-2L6.833 17H9.05zm.82-2L12 9.8l1.312 3.2z"/>',
    },
    "input-method-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5.869 12l-.82 2H6.833L11 7h2l4.167 10H14.95l-.82-2zm.82-2h2.623L12 9.8z"/>',
    },
    "insert-column-left": {
      body: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2h-4v14h4zM6 7a5 5 0 1 1 0 10A5 5 0 0 1 6 7m1 2H5v1.999L3 11v2l2-.001V15h2v-2.001L9 13v-2l-2-.001z"/>',
    },
    "insert-column-right": {
      body: '<path fill="currentColor" d="M10 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM9 5H5v14h4zm9 2a5 5 0 1 1 0 10a5 5 0 0 1 0-10m1 2h-2v1.999L15 11v2l2-.001V15h2v-2.001L21 13v-2l-2-.001z"/>',
    },
    "insert-row-bottom": {
      body: '<path fill="currentColor" d="M12 13a5 5 0 1 1 0 10a5 5 0 0 1 0-10m1 2h-2v1.999L9 17v2l2-.001V21h2v-2.001L15 19v-2l-2-.001zm7-12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM5 5v4h14V5z"/>',
    },
    "insert-row-top": {
      body: '<path fill="currentColor" d="M20 13a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm-1 2H5v4h14zM12 1a5 5 0 1 1 0 10a5 5 0 0 1 0-10m1 2h-2v1.999L9 5v2l2-.001V9h2V6.999L15 7V5l-2-.001z"/>',
    },
    "instagram-fill": {
      body: '<path fill="currentColor" d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5"/>',
    },
    "instagram-line": {
      body: '<path fill="currentColor" d="M12.001 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6m0-2a5 5 0 1 1 0 10a5 5 0 0 1 0-10m6.5-.25a1.25 1.25 0 0 1-2.5 0a1.25 1.25 0 0 1 2.5 0M12.001 4c-2.474 0-2.878.007-4.029.058c-.784.037-1.31.142-1.798.332a2.9 2.9 0 0 0-1.08.703a2.9 2.9 0 0 0-.704 1.08c-.19.49-.295 1.015-.331 1.798C4.007 9.075 4 9.461 4 12c0 2.475.007 2.878.058 4.029c.037.783.142 1.31.331 1.797c.17.435.37.748.702 1.08c.337.336.65.537 1.08.703c.494.191 1.02.297 1.8.333C9.075 19.994 9.461 20 12 20c2.475 0 2.878-.007 4.029-.058c.782-.037 1.308-.142 1.797-.331a2.9 2.9 0 0 0 1.08-.703c.337-.336.538-.649.704-1.08c.19-.492.296-1.018.332-1.8c.052-1.103.058-1.49.058-4.028c0-2.474-.007-2.878-.058-4.029c-.037-.782-.143-1.31-.332-1.798a2.9 2.9 0 0 0-.703-1.08a2.9 2.9 0 0 0-1.08-.704c-.49-.19-1.016-.295-1.798-.331C14.926 4.006 14.54 4 12 4m0-2c2.717 0 3.056.01 4.123.06c1.064.05 1.79.217 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.047 1.066.06 1.405.06 4.122s-.01 3.056-.06 4.122s-.218 1.79-.465 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465c-1.067.047-1.406.06-4.123.06s-3.056-.01-4.123-.06c-1.064-.05-1.789-.218-2.427-.465a4.9 4.9 0 0 1-1.772-1.153a4.9 4.9 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.012 15.056 2 14.717 2 12s.01-3.056.06-4.122s.217-1.79.465-2.428a4.9 4.9 0 0 1 1.153-1.772A4.9 4.9 0 0 1 5.45 2.525c.637-.248 1.362-.415 2.427-.465C8.945 2.013 9.284 2 12.001 2"/>',
    },
    "install-fill": {
      body: '<path fill="currentColor" d="M11 2v5H8l4 4l4-4h-3V2h7a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm8 14H5v4h14zm-2 1v2h-2v-2z"/>',
    },
    "install-line": {
      body: '<path fill="currentColor" d="M9 2v2H5l-.001 10h14L19 4h-4V2h5a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm9.999 14h-14L5 20h14zM17 17v2h-2v-2zM13 2v5h3l-4 4l-4-4h3V2z"/>',
    },
    "instance-fill": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zM6.499 9.97L11 12.578v5.048h2v-5.048l4.501-2.606l-1.002-1.731L12 10.845L7.501 8.24z"/>',
    },
    "instance-line": {
      body: '<path fill="currentColor" d="M4.5 7.653v8.694l7.5 4.342l7.5-4.342V7.653L12 3.311zM12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zM6.499 9.97L11 12.577v5.049h2v-5.049l4.501-2.605l-1.002-1.731L12 10.845L7.501 8.24z"/>',
    },
    "invision-fill": {
      body: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m2.988 11.065c-.06.267-.091.555-.091.79c0 .927.483 1.542 1.51 1.542c.85 0 1.54-.526 2.037-1.375l-.303 1.267h1.69l.966-4.031c.242-1.02.71-1.55 1.419-1.55c.558 0 .905.36.905.957c0 .173-.015.361-.075.565l-.498 1.853a3 3 0 0 0-.106.785c0 .88.498 1.523 1.54 1.523c.89 0 1.6-.596 1.992-2.025l-.664-.267c-.332.958-.62 1.13-.846 1.13s-.347-.156-.347-.47c0-.141.03-.298.076-.487l.483-1.805c.12-.424.166-.8.166-1.145c0-1.35-.785-2.055-1.736-2.055c-.89 0-1.796.835-2.248 1.715l.331-1.579h-2.58l-.362 1.39h1.207l-.744 3.098c-.584 1.35-1.656 1.372-1.79 1.34c-.222-.051-.363-.139-.363-.437c0-.173.03-.42.106-.72l1.132-4.67H6.928l-.362 1.39h1.192zm1.637-5.44a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25"/>',
    },
    "invision-line": {
      body: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5zm1.988 9.065l.77-3.271H6.565l.362-1.39h2.868l-1.132 4.67a3 3 0 0 0-.106.72c0 .298.141.386.362.437c.135.032 1.207.01 1.791-1.34l.744-3.097h-1.207l.362-1.39h2.58l-.332 1.578c.453-.88 1.359-1.715 2.25-1.715c.95 0 1.735.704 1.735 2.055c0 .345-.046.721-.166 1.145l-.483 1.805a2.2 2.2 0 0 0-.076.487c0 .314.121.47.347.47c.227 0 .514-.172.846-1.13l.664.267c-.393 1.429-1.102 2.025-1.993 2.025c-1.041 0-1.539-.643-1.539-1.523c0-.25.03-.518.106-.785l.498-1.853a2 2 0 0 0 .075-.565c0-.596-.347-.958-.905-.958c-.71 0-1.178.53-1.419 1.55l-.966 4.032h-1.69l.303-1.267c-.497.85-1.187 1.375-2.038 1.375c-1.026 0-1.509-.615-1.509-1.542c0-.235.03-.523.09-.79m1.637-5.44a1.125 1.125 0 1 1 0-2.25a1.125 1.125 0 0 1 0 2.25"/>',
    },
    italic: {
      body: '<path fill="currentColor" d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z"/>',
    },
    "java-fill": {
      body: '<path fill="currentColor" d="m15.638 4.566l.056.032c-.758.4-2.924 1.69-2.924 3.332c0 .554.317 1.088.614 1.59c.262.442.509.858.509 1.238c0 .957-.933 1.7-1.46 2.042l-.1-.058c.199-.243.444-.65.444-1.084c0-.598-.307-1.076-.618-1.561c-.322-.501-.648-1.01-.648-1.67c0-2.292 3.115-3.522 4.127-3.861m-4.095 1.212c1.253-1.12 2.622-2.344 2.622-4.185c0-.833-.341-1.365-.51-1.578L13.6.046c.04.166.1.472.1.872c0 1.676-1.422 2.85-2.798 3.988C9.611 5.974 8.36 7.008 8.36 8.392c0 1.985 1.958 3.206 2.785 3.722l.063.04l.05-.03q-.067-.074-.142-.152c-.636-.677-1.602-1.704-1.602-3.275c0-1.103.974-1.974 2.03-2.919m-.452 9.908c1.764 0 2.998-.253 3.546-.408l.832.48c-.793.403-2.551.71-4.382.71c-2.153 0-4.507-.462-4.514-1.078c-.005-.34.765-.566 1.595-.712l.05.029s-.281.101-.278.333c.004.35 1.42.646 3.15.646m-3.529 2.171c0-.407.839-.6 1.223-.677l.05.03c-.066.049-.102.116-.102.173c0 .267.93.511 2.356.511c1.278 0 1.988-.157 2.41-.258l.99.573c-.045.032-1.02.645-3.402.645c-1.731 0-3.525-.432-3.525-.997m8.529-1.728c1.18-.673 2.361-1.469 2.428-2.747c.044-.839-.727-1.454-1.57-1.29l.045-.112v-.002c.212-.064.474-.116.767-.116c.943 0 1.666.565 1.758 1.356c.186 1.586-2.062 2.618-3.321 2.973zm1.975 2.988c.01 1.09-3.698 1.738-7.012 1.767c-2.861.025-7.474-.515-7.484-1.605c-.006-.753 2-1.274 3.09-1.424l.115.065s-1.625.377-1.62 1.062c.006.683 3.425 1.274 5.894 1.253c3.825-.034 6.414-.657 6.72-1.502l.054-.031c.112.082.24.217.243.415M6.43 21.337a26 26 0 0 0 4.279.325c6.208-.054 7.96-1.58 8.23-1.912l.047.028c-.064 1.208-3.347 2.212-7.396 2.247c-2.061.018-3.937-.22-5.285-.615zm2.602-9.283c-1.079.083-3.396.426-3.396 1.036c0 .462 2.124 1.113 5.452 1.113c2.994 0 4.884-.565 5.325-.78l-.643-.375c-.46.125-2.169.506-4.682.506c-1.48 0-4.03-.273-4.03-.69c0-.374 1.591-.662 2.048-.745l.029-.005z"/>',
    },
    "java-line": {
      body: '<path fill="currentColor" d="M10.82 8.427c-.76-1.085-1.046-1.872-1.108-2.445c-.059-.54.073-.97.335-1.383c.283-.447.708-.862 1.248-1.353c.505-.458 1.137-1.003 1.633-1.62L11.37.374c-.416.517-.928.947-1.418 1.391c-.534.485-1.149 1.062-1.593 1.764c-.466.735-.75 1.611-.635 2.67c.112 1.026.588 2.132 1.458 3.375zm1.25-3.03c.284-.684.861-1.37 1.78-2.156l1.3 1.518c-.831.713-1.129 1.153-1.235 1.407c-.104.25-.035.499.035.747c.084.296.223.79.214 1.322c-.012.706-.254 1.452-.832 2.32l-1.664-1.11c.422-.632.492-1.01.496-1.243c.005-.295-.072-.46-.197-.96c-.12-.478-.21-1.097.102-1.845M6.141 10c.47-.314 1.05-.474 1.592-.604L7.266 7.45c-.813.196-1.551.46-2.112.807C4.644 8.573 4 9.136 4 10c0 .726.486 1.306 1.065 1.686a2.5 2.5 0 0 0-.065.572c0 .98.418 1.807 1.143 2.42c-.107.3-.155.634-.14.968c-.777.151-1.536.373-2.17.664c-.432.198-.858.451-1.19.777c-.334.329-.643.804-.643 1.413c0 .427.189.772.374 1.01c.189.242.432.449.684.624c.506.351 1.184.669 1.959.936c1.558.538 3.669.93 5.983.93c3.327 0 5.663-.384 7.19-.782a13 13 0 0 0 1.704-.561c.21-.088.42-.181.616-.297c.01-.006-1.028-1.715-1.024-1.718c-.564.294-1.188.48-1.8.64c-1.349.352-3.513.718-6.686.718c-2.104 0-3.993-.358-5.33-.82c-.532-.184-1.088-.398-1.541-.74c.115-.09.29-.199.538-.312c.558-.256 1.323-.466 2.14-.591q.344.365.814.64c.965.562 2.292.823 3.879.823c1.31 0 2.258-.132 2.898-.274c.356-.078.714-.167 1.042-.328c.003-.002-.881-1.795-.881-1.795q-.291.105-.593.17c-.489.109-1.29.227-2.466.227c-1.413 0-2.336-.24-2.871-.551c-.426-.248-.589-.524-.622-.824c.868.253 1.895.375 3.056.375c1.463 0 2.518-.143 3.228-.297c.386-.083.775-.179 1.134-.346c.02-.01-.857-1.807-.857-1.807a4.4 4.4 0 0 1-.7.198c-.56.121-1.473.252-2.806.252c-1.603 0-2.67-.264-3.302-.623c-.471-.268-.678-.568-.74-.89c1.24.326 2.805.513 4.48.513c1.817 0 3.502-.22 4.783-.598l-.566-1.918c-1.054.311-2.54.516-4.217.516c-1.724 0-3.245-.216-4.302-.542c-.5-.153-.846-.316-1.056-.458m11.448.746c1.213-.11 1.66.188 1.804.342c.149.16.201.408.136.67c-.116.464-.443.914-.973 1.328c-.529.413-1.2.74-1.873.965l.632 1.897c.828-.276 1.718-.698 2.471-1.285c.75-.586 1.424-1.385 1.683-2.42c.185-.74.112-1.741-.614-2.52c-.73-.782-1.909-1.109-3.447-.969z"/>',
    },
    "javascript-fill": {
      body: '<path fill="currentColor" d="M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm7.334 13.055q1.08.87 2.156.858q.66 0 1.012-.242a.75.75 0 0 0 .341-.66a.97.97 0 0 0-.34-.748q-.352-.307-1.332-.616q-1.177-.34-1.815-.88q-.626-.54-.638-1.507q0-.913.792-1.529q.77-.616 1.97-.616q1.672 0 2.683.814l-.77 1.199a2.6 2.6 0 0 0-.935-.462a3.2 3.2 0 0 0-.946-.165q-.57 0-.913.209q-.34.21-.34.55q0 .374.417.638q.42.254 1.43.561q1.221.363 1.738.968t.517 1.54q0 .957-.737 1.65q-.726.682-2.112.715q-1.815 0-3.036-1.089zm-5.53.638q.352.22.847.22q.517 0 .858-.297q.34-.308.341-1.067v-5.302h1.485v5.588q-.033 1.298-.748 1.87a2.5 2.5 0 0 1-.891.484a3.3 3.3 0 0 1-.935.143q-.825 0-1.463-.286q-.682-.307-1.144-1.089l1.034-.847q.285.385.616.583"/>',
    },
    "javascript-line": {
      body: '<path fill="currentColor" d="m13.334 16.055l-.858 1.188q1.221 1.089 3.036 1.089q1.386-.033 2.112-.715q.737-.693.737-1.65q0-.935-.517-1.54t-1.738-.968q-1.01-.307-1.43-.561q-.418-.264-.418-.638q0-.34.341-.55q.342-.21.913-.209q.419 0 .946.165q.528.143.935.462l.77-1.199q-1.011-.814-2.684-.814q-1.198 0-1.969.616q-.792.615-.792 1.529q.011.968.638 1.507q.638.54 1.815.88q.98.307 1.331.616a.97.97 0 0 1 .341.748a.75.75 0 0 1-.34.66q-.353.242-1.013.242q-1.077.01-2.156-.858m-5.53.638a2.2 2.2 0 0 1-.616-.583l-1.034.847q.463.78 1.144 1.089q.638.285 1.463.286q.45 0 .935-.143t.891-.484q.715-.572.748-1.87v-5.588H9.85v5.302q0 .76-.34 1.067q-.342.297-.859.297q-.495 0-.847-.22M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"/>',
    },
    "kakao-talk-fill": {
      body: '<path fill="currentColor" d="M12 3c5.8 0 10.501 3.664 10.501 8.185c0 4.52-4.701 8.184-10.5 8.184a14 14 0 0 1-1.727-.11l-4.408 2.883c-.501.265-.678.236-.472-.413l.892-3.678c-2.88-1.46-4.785-3.99-4.785-6.866c0-4.52 4.7-8.185 10.5-8.185m5.908 8.06l1.47-1.424a.472.472 0 0 0-.656-.678l-1.928 1.866V9.282a.472.472 0 0 0-.944 0v2.557a.5.5 0 0 0 0 .222V13.5a.472.472 0 0 0 .944 0v-1.363l.427-.413l1.428 2.033a.472.472 0 1 0 .773-.543zm-2.958 1.924h-1.46V9.297a.472.472 0 0 0-.943 0v4.159c0 .26.21.472.471.472h1.932a.472.472 0 1 0 0-.944m-5.857-1.091l.696-1.708l.638 1.707zm2.523.487l.002-.016a.47.47 0 0 0-.127-.32l-1.046-2.8a.69.69 0 0 0-.627-.474a.7.7 0 0 0-.653.447l-1.662 4.075a.472.472 0 0 0 .874.357l.332-.813h2.07l.298.8a.472.472 0 1 0 .884-.33zM8.294 9.302a.47.47 0 0 0-.471-.472H4.578a.472.472 0 1 0 0 .944h1.16v3.736a.472.472 0 0 0 .944 0V9.774h1.14a.47.47 0 0 0 .472-.472"/>',
    },
    "kakao-talk-line": {
      body: '<path fill="currentColor" d="M5.679 18.123C3.093 16.566 1.5 14.112 1.5 11.405C1.501 6.701 6.249 3 12.001 3s10.5 3.701 10.5 8.405s-4.748 8.405-10.5 8.405q-.663 0-1.318-.065l-3.765 2.458c-.615.326-.957.425-1.485.066c-.62-.424-.596-.892-.382-1.56zM3.5 11.405c0 2.132 1.418 4.123 3.781 5.32l.706.359l-.186.77l-.401 1.648l2.8-1.83l.365.046q.711.092 1.435.092c4.741 0 8.5-2.93 8.5-6.405S16.742 5 12.001 5s-8.5 2.93-8.5 6.405m14.407-.346l1.514 2.155a.472.472 0 1 1-.773.543l-1.428-2.033l-.427.413V13.5a.472.472 0 1 1-.944 0v-1.439a.5.5 0 0 1 0-.222V9.282a.472.472 0 0 1 .944 0v1.542l1.928-1.866a.472.472 0 0 1 .656.678zm-2.958 1.925a.472.472 0 1 1 0 .944h-1.932a.47.47 0 0 1-.471-.472V9.297a.472.472 0 1 1 .943 0v3.687zm-5.857-1.091h1.334l-.638-1.708zm2.523.487l.345.925a.472.472 0 1 1-.884.33l-.298-.799h-2.07l-.332.813a.472.472 0 1 1-.874-.357l1.662-4.075a.7.7 0 0 1 .653-.447a.69.69 0 0 1 .627.474l1.046 2.8a.47.47 0 0 1 .127.32zM8.294 9.302c0 .26-.21.472-.471.472h-1.14v3.736a.472.472 0 0 1-.945 0V9.774h-1.16a.472.472 0 1 1 0-.944h3.245c.26 0 .471.211.471.472"/>',
    },
    "kanban-view": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm1 16V5h16v14zM9 7H7v8h2zm6 0h2v6h-2zm-2 0h-2v10h2z"/>',
    },
    "kanban-view-2": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm14 15h4V5h-4zM14 5h-4v14h4zM4 5v14h4V5z"/>',
    },
    "key-2-fill": {
      body: '<path fill="currentColor" d="m10.313 11.566l7.94-7.94l2.121 2.12l-1.414 1.415l2.121 2.121l-3.535 3.536l-2.121-2.121l-2.99 2.99a5.002 5.002 0 0 1-7.97 5.849a5 5 0 0 1 5.848-7.97m-.899 5.848a2 2 0 1 0-2.828-2.828a2 2 0 0 0 2.828 2.828"/>',
    },
    "key-2-line": {
      body: '<path fill="currentColor" d="m10.758 11.828l7.849-7.849l1.414 1.414l-1.414 1.415l2.474 2.474l-1.414 1.415l-2.475-2.475l-1.414 1.414l2.121 2.121l-1.414 1.415l-2.121-2.122l-2.192 2.192a5.002 5.002 0 0 1-7.708 6.293a5 5 0 0 1 6.294-7.707m-.637 6.293A3 3 0 1 0 5.88 13.88a3 3 0 0 0 4.242 4.242"/>',
    },
    "key-fill": {
      body: '<path fill="currentColor" d="M17 14h-4.341a6 6 0 1 1 0-4H23v4h-2v4h-4zM7 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "key-line": {
      body: '<path fill="currentColor" d="M12.917 13A6.002 6.002 0 0 1 1 12a6 6 0 0 1 11.917-1H23v2h-2v4h-2v-4h-2v4h-2v-4zM7 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8"/>',
    },
    "keyboard-box-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m2 4v2h2V7zm0 4v2h2v-2zm0 4v2h14v-2zm4-4v2h2v-2zm0-4v2h2V7zm4 0v2h2V7zm4 0v2h2V7zm-4 4v2h2v-2zm4 0v2h2v-2z"/>',
    },
    "keyboard-box-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V5zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 4h2v2H6zm0 4h2v2H6zm0 4h12v2H6zm5-4h2v2h-2zm0-4h2v2h-2zm5 0h2v2h-2zm0 4h2v2h-2z"/>',
    },
    "keyboard-fill": {
      body: '<path fill="currentColor" d="M3 17h18v2H3zm0-6h3v3H3zm5 0h3v3H8zM3 5h3v3H3zm10 0h3v3h-3zm5 0h3v3h-3zm-5 6h3v3h-3zm5 0h3v3h-3zM8 5h3v3H8z"/>',
    },
    "keyboard-line": {
      body: '<path fill="currentColor" d="M3 17h18v2H3zm0-6h3v3H3zm5 0h3v3H8zM3 5h3v3H3zm10 0h3v3h-3zm5 0h3v3h-3zm-5 6h3v3h-3zm5 0h3v3h-3zM8 5h3v3H8z"/>',
    },
    "keynote-fill": {
      body: '<path fill="currentColor" d="M19 2c.552 0 1.086.43 1.195.977l1.61 8.046c.108.54-.26.977-.797.977H13v8h4v2H7v-2h4v-8H2.992c-.548 0-.906-.43-.797-.977l1.61-8.046C3.913 2.437 4.445 2 5 2z"/>',
    },
    "keynote-line": {
      body: '<path fill="currentColor" d="M4.44 10h15.12l-1.2-6H5.64zM13 12v8h4v2H7v-2h4v-8H2.992c-.548 0-.906-.43-.797-.977l1.61-8.046C3.913 2.437 4.445 2 5 2h13.998c.553 0 1.087.43 1.197.977l1.609 8.046c.108.54-.26.977-.797.977z"/>',
    },
    "kick-fill": {
      body: '<path fill="currentColor" d="M3 3h18v18H3zm7.564 2.536h-4.31v12.928h4.31V15.59H12v1.436h1.436v1.436h4.31v-4.309h-1.437v-1.436h-1.436v-1.436h1.436V9.845h1.436V5.536h-4.309v1.436H12V8.41h-1.436z"/>',
    },
    "kick-line": {
      body: '<path fill="currentColor" d="M3 2h8v2h2V2h8v8h-2v4h2v8h-8v-2h-2v2H3zm10 16h2v2h4v-4h-2v-2h-2v-4h2V8h2V4h-4v2h-2v2H9V4H5v16h4v-4h4z"/>',
    },
    "knife-blood-fill": {
      body: '<path fill="currentColor" d="M4.343 1.408L22.374 19.44a1.5 1.5 0 1 1-2.121 2.122l-4.596-4.596L12.12 20.5L8 16.38V19a1 1 0 1 1-2 0v-4a1 1 0 0 0-1.993-.117L4.001 15v1a1 1 0 1 1-2 0V7.214A7.98 7.98 0 0 1 4.17 1.587z"/>',
    },
    "knife-blood-line": {
      body: '<path fill="currentColor" d="M4.343 1.408L22.374 19.44a1.5 1.5 0 1 1-2.121 2.122l-4.596-4.596L12.12 20.5L8 16.38V19a1 1 0 1 1-2 0v-4a1 1 0 0 0-1.993-.117L4.001 15v1a1 1 0 1 1-2 0V7.214A7.98 7.98 0 0 1 4.17 1.587zm.241 3.07l-.051.11a6 6 0 0 0-.522 2.103l-.01.31v.119a5.98 5.98 0 0 0 1.58 4.003l.176.185l6.364 6.364l2.828-2.829z"/>',
    },
    "knife-fill": {
      body: '<path fill="currentColor" d="M22.374 19.44a1.5 1.5 0 1 1-2.121 2.12l-4.596-4.595L12.12 20.5l-7.778-7.778A8 8 0 0 1 4.17 1.587l.173-.179z"/>',
    },
    "knife-line": {
      body: '<path fill="currentColor" d="M4.343 1.408L22.374 19.44a1.5 1.5 0 1 1-2.121 2.122l-4.596-4.596L12.12 20.5l-7.778-7.778A8 8 0 0 1 4.17 1.587zm.241 3.07l-.051.11a6 6 0 0 0 1.048 6.535l.176.185l6.364 6.364l2.828-2.829z"/>',
    },
    "landscape-fill": {
      body: '<path fill="currentColor" d="m16 21l-4.762-8.73L15 6l8 15zM8 10l6 11H2zM5.5 8a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5"/>',
    },
    "landscape-line": {
      body: '<path fill="currentColor" d="M11.27 12.216L15 6l8 15H2L9 8zm1.12 2.022L14.987 19h4.68l-4.77-8.942zM5.348 19h7.304L9 12.219zM5.5 8a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5"/>',
    },
    "layout-2-fill": {
      body: '<path fill="currentColor" d="M11 3v18H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm10 10v7a1 1 0 0 1-1 1h-7v-8zM20 3a1 1 0 0 1 1 1v7h-8V3z"/>',
    },
    "layout-2-line": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zM11 5H5v14h6zm8 8h-6v6h6zm0-8h-6v6h6z"/>',
    },
    "layout-3-fill": {
      body: '<path fill="currentColor" d="M8 10v11H4a1 1 0 0 1-1-1V10zm13 0v10a1 1 0 0 1-1 1H10V10zm-1-7a1 1 0 0 1 1 1v4H3V4a1 1 0 0 1 1-1z"/>',
    },
    "layout-3-line": {
      body: '<path fill="currentColor" d="M4 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zm4-11H5v9h3zm11 0h-9v9h9zm0-5H5v3h14z"/>',
    },
    "layout-4-fill": {
      body: '<path fill="currentColor" d="M11 13v8H4a1 1 0 0 1-1-1v-7zm2-10h7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-7zM3 4a1 1 0 0 1 1-1h7v8H3z"/>',
    },
    "layout-4-line": {
      body: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-9 10H5v6h6zm2 6h6V5h-6zM11 5H5v6h6z"/>',
    },
    "layout-5-fill": {
      body: '<path fill="currentColor" d="M7 10v11H3a1 1 0 0 1-1-1V10zm15 0v10a1 1 0 0 1-1 1H9V10zm-1-7a1 1 0 0 1 1 1v4H2V4a1 1 0 0 1 1-1z"/>',
    },
    "layout-5-line": {
      body: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zm4-11H4v9h3zm13 0H9v9h11zm0-5H4v3h16z"/>',
    },
    "layout-6-fill": {
      body: '<path fill="currentColor" d="M15 10v11H3a1 1 0 0 1-1-1V10zm7 0v10a1 1 0 0 1-1 1h-4V10zm-1-7a1 1 0 0 1 1 1v4H2V4a1 1 0 0 1 1-1z"/>',
    },
    "layout-6-line": {
      body: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zm12-11H4v9h11zm5 0h-3v9h3zm0-5H4v3h16z"/>',
    },
    "layout-bottom-2-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-2 13H5v2h14z"/>',
    },
    "layout-bottom-2-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H4v14h16zm-2 10v2H6v-2z"/>',
    },
    "layout-bottom-fill": {
      body: '<path fill="currentColor" d="M22 16v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4zM21 3a1 1 0 0 1 1 1v10H2V4a1 1 0 0 1 1-1z"/>',
    },
    "layout-bottom-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM4 16v3h16v-3zm0-2h16V5H4z"/>',
    },
    "layout-column-fill": {
      body: '<path fill="currentColor" d="M12 5v14h7V5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "layout-column-line": {
      body: '<path fill="currentColor" d="M11 5H5v14h6zm2 0v14h6V5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "layout-fill": {
      body: '<path fill="currentColor" d="M16 21V10h5v10a1 1 0 0 1-1 1zm-2 0H4a1 1 0 0 1-1-1V10h11zm7-13H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1z"/>',
    },
    "layout-grid-2-fill": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v4h5.5V3zm6.5 0v5h5V3zm7 0v5H22V4a1 1 0 0 0-1-1zm5.5 7h-5.5v4H22zm0 6h-5.5v5H21a1 1 0 0 0 1-1zm-7.5 5v-5h-5v5zm-7 0v-5H2v4a1 1 0 0 0 1 1zM2 14h5.5v-4H2zm7.5-4h5v4h-5z"/>',
    },
    "layout-grid-2-line": {
      body: '<path fill="currentColor" d="M4 10h4v4H4zm0 9v-3h4v3zm6 0v-3h4v3zm6 0v-3h4v3zm0-5v-4h4v4zm0-6V5h4v3zm-2-3v3h-4V5zm0 5v4h-4v-4zM4 8V5h4v3zM3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"/>',
    },
    "layout-grid-fill": {
      body: '<path fill="currentColor" d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001zm-11 0V21H3a1 1 0 0 1-1-1v-7.001zM11 3v7.999H2V4a1 1 0 0 1 1-1zm10 0a1 1 0 0 1 1 1v6.999h-9V3z"/>',
    },
    "layout-grid-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM11 13H4v6h7zm9 0h-7v6h7zm-9-8H4v6h7zm9 0h-7v6h7z"/>',
    },
    "layout-horizontal-fill": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm3 6V7h10v2zm0 4v-2h10v2zm10 4H7v-2h10z"/>',
    },
    "layout-horizontal-line": {
      body: '<path fill="currentColor" d="M5 19h14V5H5zM3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm4 5h10V7H7zm10 4H7v-2h10zM7 17h10v-2H7z"/>',
    },
    "layout-left-2-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM7 6H5v12h2z"/>',
    },
    "layout-left-2-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H4v14h16zM8 7v10H6V7z"/>',
    },
    "layout-left-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H9V3zM7 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4z"/>',
    },
    "layout-left-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM7 5H4v14h3zm13 0H9v14h11z"/>',
    },
    "layout-line": {
      body: '<path fill="currentColor" d="M5 8h14V5H5zm9 11v-9H5v9zm2 0h3v-9h-3zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "layout-masonry-fill": {
      body: '<path fill="currentColor" d="M22 9.999V20a1 1 0 0 1-1 1h-8V9.999zm-11 6V21H3a1 1 0 0 1-1-1v-4.001zM11 3v10.999H2V4a1 1 0 0 1 1-1zm10 0a1 1 0 0 1 1 1v3.999h-9V3z"/>',
    },
    "layout-masonry-line": {
      body: '<path fill="currentColor" d="M22 20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-11-5H4v4h7zm9-4h-7v8h7zm-9-6H4v8h7zm9 0h-7v4h7z"/>',
    },
    "layout-right-2-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-2 3h-2v12h2z"/>',
    },
    "layout-right-2-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H4v14h16zm-2 2v10h-2V7z"/>',
    },
    "layout-right-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4V3zm-6 18H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12z"/>',
    },
    "layout-right-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-6 2H4v14h11zm5 0h-3v14h3z"/>',
    },
    "layout-row-fill": {
      body: '<path fill="currentColor" d="M19 12H5v7h14zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "layout-row-line": {
      body: '<path fill="currentColor" d="M19 11V5H5v6zm0 2H5v6h14zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "layout-top-2-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-2 3H5v2h14z"/>',
    },
    "layout-top-2-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H4v14h16zm-2 2v2H6V7z"/>',
    },
    "layout-top-fill": {
      body: '<path fill="currentColor" d="M22 10v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10zm-1-7a1 1 0 0 1 1 1v4H2V4a1 1 0 0 1 1-1z"/>',
    },
    "layout-top-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM4 10v9h16v-9zm0-2h16V5H4z"/>',
    },
    "layout-vertical-fill": {
      body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm3 14V7h2v10zm4-10h2v10h-2zm4 0h2v10h-2z"/>',
    },
    "layout-vertical-line": {
      body: '<path fill="currentColor" d="M5 19h14V5H5zM3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm12 3v10h2V7zm-4 0v10h2V7zM7 17V7h2v10z"/>',
    },
    "leaf-fill": {
      body: '<path fill="currentColor" d="M20.998 3v2c0 9.627-5.373 14-12 14H7.096c.212-3.012 1.15-4.835 3.598-7.001c1.204-1.065 1.102-1.68.509-1.327C7.119 13.102 5.09 16.386 5 21.63l-.003.37h-2c0-1.363.116-2.6.346-3.732Q2.999 16.327 2.998 13c0-5.523 4.477-10 10-10c2 0 4 1 8 0"/>',
    },
    "leaf-line": {
      body: '<path fill="currentColor" d="M20.998 3v2c0 9.627-5.373 14-12 14H5.241a17 17 0 0 0-.243 3h-2c0-1.363.116-2.6.346-3.732Q2.999 16.327 2.998 13c0-5.523 4.477-10 10-10c2 0 4 1 8 0m-8 2a8 8 0 0 0-8 8q0 .543.01 1.046c1.254-1.978 3.091-3.541 5.494-4.914l.992 1.736C8.64 12.5 6.746 14.354 5.774 17h3.224c6.015 0 9.871-3.973 9.997-11.612c-1.372.133-2.647.048-4.22-.188c-1.15-.173-1.376-.2-1.777-.2"/>',
    },
    "lifebuoy-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2M7.197 14.682l-2.175 2.173a8.6 8.6 0 0 0 1.818 1.9l.305.223l2.173-2.175a5.5 5.5 0 0 1-1.98-1.883zm9.606 0a5.5 5.5 0 0 1-1.883 1.98l-.238.14l2.173 2.176a8.6 8.6 0 0 0 1.9-1.818l.223-.305zM12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8M7.145 5.022a8.6 8.6 0 0 0-1.9 1.818l-.223.305l2.175 2.173a5.5 5.5 0 0 1 1.883-1.98l.238-.14zm9.71 0l-2.173 2.175a5.5 5.5 0 0 1 1.98 1.883l.14.238l2.176-2.173a8.6 8.6 0 0 0-1.818-1.9z"/>',
    },
    "lifebuoy-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 15a5 5 0 0 1-1.828-.344l-2.236 2.236A7.96 7.96 0 0 0 12 20a7.96 7.96 0 0 0 4.064-1.108l-2.236-2.236A5 5 0 0 1 12 17m-8-5a7.96 7.96 0 0 0 1.108 4.064l2.237-2.236A5 5 0 0 1 7 12c0-.645.122-1.261.345-1.828L5.108 7.936A7.96 7.96 0 0 0 4 12m14.892-4.064l-2.236 2.236c.222.567.344 1.183.344 1.828s-.122 1.261-.344 1.828l2.236 2.236A7.96 7.96 0 0 0 20 12a7.96 7.96 0 0 0-1.108-4.064M12 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6m0-5a7.96 7.96 0 0 0-4.064 1.108l2.236 2.237A5 5 0 0 1 12 7c.645 0 1.261.122 1.828.345l2.236-2.237A7.96 7.96 0 0 0 12 4"/>',
    },
    "lightbulb-fill": {
      body: '<path fill="currentColor" d="M11 18H7.941c-.297-1.273-1.637-2.314-2.187-3a8 8 0 1 1 12.49.002c-.55.685-1.888 1.726-2.185 2.998H13v-5h-2zm5 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1z"/>',
    },
    "lightbulb-flash-fill": {
      body: '<path fill="currentColor" d="M7.941 18c-.297-1.273-1.637-2.314-2.187-3a8 8 0 1 1 12.49.002c-.55.685-1.888 1.726-2.185 2.998zM16 20v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1zm-3-9.995V6l-4.5 6.005H11v4l4.5-6z"/>',
    },
    "lightbulb-flash-line": {
      body: '<path fill="currentColor" d="M9.973 18h4.054c.132-1.202.745-2.193 1.74-3.277c.113-.122.832-.867.917-.973a6 6 0 1 0-9.37-.002c.086.107.807.853.918.974c.996 1.084 1.609 2.076 1.741 3.278M14 20h-4v1h4zm-8.246-5a8 8 0 1 1 12.49.002C17.624 15.774 16 17 16 18.5V21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2.5C8 17 6.375 15.774 5.754 15M13 10.004h2.5l-4.5 6v-4H8.5L13 6z"/>',
    },
    "lightbulb-line": {
      body: '<path fill="currentColor" d="M9.973 18H11v-5h2v5h1.027c.132-1.202.745-2.193 1.74-3.277c.113-.122.832-.867.917-.973a6 6 0 1 0-9.37-.002c.086.107.807.853.918.974c.996 1.084 1.609 2.076 1.741 3.278M10 20v1h4v-1zm-4.246-5a8 8 0 1 1 12.49.002C17.624 15.774 16 17 16 18.5V21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2.5C8 17 6.375 15.774 5.754 15"/>',
    },
    "line-chart-fill": {
      body: '<path fill="currentColor" d="M5 3v16h16v2H3V3zm14.94 2.94l2.12 2.12L16 14.122l-3-3l-3.94 3.94l-2.12-2.122L13 6.88l3 3z"/>',
    },
    "line-chart-line": {
      body: '<path fill="currentColor" d="M5 3v16h16v2H3V3zm15.293 3.293l1.414 1.414L16 13.414l-3-2.999l-4.293 4.292l-1.414-1.414L13 7.586l3 2.999z"/>',
    },
    "line-fill": {
      body: '<path fill="currentColor" d="M18.664 10.84a.526.526 0 0 1-.526.525h-1.462v.938h1.463a.525.525 0 1 1 0 1.049H16.15a.526.526 0 0 1-.522-.524V8.852c0-.287.235-.525.525-.525h1.988a.526.526 0 0 1-.002 1.05h-1.463v.938h1.463c.29 0 .524.237.524.525m-4.098 2.485a.5.5 0 0 1-.166.025a.52.52 0 0 1-.425-.208l-2.036-2.764v2.45a.525.525 0 0 1-1.047 0V8.852a.52.52 0 0 1 .52-.523c.162 0 .312.086.412.211l2.052 2.775V8.852c0-.287.235-.525.525-.525c.287 0 .525.238.525.525v3.976a.52.52 0 0 1-.36.497m-4.95.027a.526.526 0 0 1-.523-.524V8.852c0-.287.235-.525.525-.525c.289 0 .524.238.524.525v3.976a.527.527 0 0 1-.526.524m-1.53 0H6.099a.53.53 0 0 1-.525-.524V8.852c0-.287.238-.525.525-.525c.29 0 .525.238.525.525v3.45h1.464a.525.525 0 0 1 0 1.05m3.915-10.78c-5.513 0-10 3.643-10 8.118c0 4.01 3.558 7.369 8.363 8.007c.325.068.769.215.881.492c.1.25.066.638.032.9l-.137.85c-.037.25-.2.988.874.537c1.076-.449 5.764-3.398 7.864-5.812C21.314 14.089 22 12.477 22 10.69c0-4.475-4.488-8.118-10-8.118"/>',
    },
    "line-height": {
      body: '<path fill="currentColor" d="M11 4h10v2H11zM6 7v4H4V7H1l4-4l4 4zm0 10h3l-4 4l-4-4h3v-4h2zm5 1h10v2H11zm-2-7h12v2H9z"/>',
    },
    "line-line": {
      body: '<path fill="currentColor" d="M22.001 10.69c0 1.787-.687 3.4-2.123 4.974c-2.1 2.414-6.788 5.363-7.864 5.812c-1.074.451-.911-.287-.874-.537l.137-.85c.034-.262.068-.65-.032-.9c-.112-.277-.556-.424-.881-.492C5.559 18.059 2 14.7 2 10.69c0-4.475 4.487-8.118 10-8.118s10 3.643 10 8.118m-3.6 3.626c1.113-1.22 1.6-2.362 1.6-3.626c0-3.268-3.51-6.118-8-6.118s-8 2.85-8 6.118c0 2.905 2.728 5.507 6.626 6.024l.147.026c1.079.226 1.884.614 2.329 1.708l.037.096c1.805-1.176 4.173-2.979 5.26-4.228m-.262-4.001a.526.526 0 0 1 0 1.05h-1.463v.938h1.463a.525.525 0 1 1 0 1.049H16.15a.526.526 0 0 1-.522-.524V8.852c0-.287.235-.525.525-.525h1.988a.526.526 0 0 1-.002 1.05h-1.463v.938zm-3.213 2.513a.524.524 0 0 1-.526.522a.52.52 0 0 1-.425-.208l-2.036-2.764v2.45a.525.525 0 0 1-1.047 0V8.852a.52.52 0 0 1 .52-.523c.162 0 .312.086.412.211l2.052 2.775V8.852c0-.287.235-.525.525-.525c.287 0 .525.238.525.525zm-4.784 0a.527.527 0 0 1-.526.524a.526.526 0 0 1-.523-.524V8.852c0-.287.235-.525.525-.525c.289 0 .524.238.524.525zm-2.055.524H6.098a.53.53 0 0 1-.525-.524V8.852c0-.287.238-.525.525-.525c.29 0 .525.238.525.525v3.45h1.464a.525.525 0 0 1 0 1.05"/>',
    },
    link: {
      body: '<path fill="currentColor" d="M18.364 15.536L16.95 14.12l1.414-1.414a5 5 0 0 0-7.071-7.071L9.878 7.05L8.464 5.636l1.414-1.414a7 7 0 0 1 9.9 9.9zm-2.829 2.828l-1.414 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 0 0 7.07 7.071l1.415-1.414zm-.707-10.607l1.415 1.415l-7.072 7.07l-1.414-1.414z"/>',
    },
    "link-m": {
      body: '<path fill="currentColor" d="m17.657 14.828l-1.415-1.414L17.658 12A4 4 0 1 0 12 6.343l-1.414 1.414L9.17 6.343l1.415-1.414a6 6 0 0 1 8.485 8.485zm-2.829 2.829l-1.414 1.414a6 6 0 0 1-8.485-8.485l1.414-1.414l1.414 1.414L6.343 12A4 4 0 0 0 12 17.657l1.414-1.414zm0-9.9l1.415 1.415l-7.072 7.07l-1.414-1.414z"/>',
    },
    "link-unlink": {
      body: '<path fill="currentColor" d="M17 17h5v2h-3v3h-2zM7 7H2V5h3V2h2zm11.364 8.536L16.95 14.12l1.414-1.414a5 5 0 0 0-7.071-7.071L9.879 7.05L8.464 5.636L9.88 4.222a7 7 0 0 1 9.9 9.9zm-2.828 2.828l-1.415 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 0 0 7.071 7.071l1.414-1.414zm-.708-10.607l1.415 1.415l-7.071 7.07l-1.415-1.414z"/>',
    },
    "link-unlink-m": {
      body: '<path fill="currentColor" d="m17.657 14.828l-1.414-1.414L17.657 12A4 4 0 1 0 12 6.343l-1.414 1.414l-1.414-1.414l1.414-1.414a6 6 0 0 1 8.485 8.485zm-2.828 2.829l-1.415 1.414a6 6 0 0 1-8.485-8.485l1.414-1.414l1.414 1.414L6.343 12A4 4 0 0 0 12 17.657l1.414-1.414zm0-9.9l1.414 1.415l-7.071 7.07l-1.415-1.414zM5.775 2.293l1.932-.518L8.743 5.64l-1.932.518zm9.483 16.068l1.932-.518l1.035 3.864l-1.932.518zM2.293 5.775l3.864 1.036l-.518 1.931l-3.864-1.035zm16.068 9.483l3.864 1.035l-.518 1.932l-3.864-1.036z"/>',
    },
    "linkedin-box-fill": {
      body: '<path fill="currentColor" d="M18.336 18.339h-2.665v-4.177c0-.996-.02-2.278-1.39-2.278c-1.389 0-1.601 1.084-1.601 2.205v4.25h-2.666V9.75h2.56v1.17h.035c.358-.674 1.228-1.387 2.528-1.387c2.7 0 3.2 1.778 3.2 4.092v4.714M7.004 8.575a1.546 1.546 0 0 1-1.548-1.549a1.548 1.548 0 1 1 1.547 1.549m1.336 9.764H5.667V9.75H8.34zM19.67 3H4.33C3.594 3 3 3.58 3 4.297v15.406C3 20.42 3.594 21 4.328 21h15.339C20.4 21 21 20.42 21 19.703V4.297C21 3.581 20.4 3 19.666 3z"/>',
    },
    "linkedin-box-line": {
      body: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5zm2.5 4a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-1 1h2v7.5h-2zm5.5.43c.584-.565 1.266-.93 2-.93c2.071 0 3.5 1.679 3.5 3.75v4.25h-2v-4.25a1.75 1.75 0 1 0-3.5 0v4.25h-2V10h2z"/>',
    },
    "linkedin-fill": {
      body: '<path fill="currentColor" d="M6.94 5a2 2 0 1 1-4-.002a2 2 0 0 1 4 .002M7 8.48H3V21h4zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91z"/>',
    },
    "linkedin-line": {
      body: '<path fill="currentColor" d="M12.001 9.55c.917-.937 2.111-1.55 3.5-1.55a5.5 5.5 0 0 1 5.5 5.5V21h-2v-7.5a3.5 3.5 0 1 0-7 0V21h-2V8.5h2zm-7-3.05a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-1 2h2V21h-2z"/>',
    },
    "links-fill": {
      body: '<path fill="currentColor" d="m13.06 8.111l1.415 1.414a7 7 0 0 1 0 9.9l-.354.353a7 7 0 1 1-9.9-9.9l1.415 1.415a5 5 0 1 0 7.071 7.071l.354-.354a5 5 0 0 0 0-7.07l-1.415-1.415zm6.718 6.01l-1.414-1.414a5 5 0 0 0-7.071-7.07l-.354.353a5 5 0 0 0 0 7.07l1.415 1.415l-1.415 1.414l-1.414-1.414a7 7 0 0 1 0-9.9l.354-.353a7 7 0 1 1 9.9 9.9"/>',
    },
    "links-line": {
      body: '<path fill="currentColor" d="m13.06 8.111l1.415 1.414a7 7 0 0 1 0 9.9l-.354.353a7 7 0 1 1-9.9-9.9l1.415 1.415a5 5 0 1 0 7.071 7.071l.354-.354a5 5 0 0 0 0-7.07l-1.415-1.415zm6.718 6.01l-1.414-1.414a5 5 0 0 0-7.071-7.07l-.354.353a5 5 0 0 0 0 7.07l1.415 1.415l-1.415 1.414l-1.414-1.414a7 7 0 0 1 0-9.9l.354-.353a7 7 0 1 1 9.9 9.9"/>',
    },
    "list-check": {
      body: '<path fill="currentColor" d="M8 4h13v2H8zm-5-.5h3v3H3zm0 7h3v3H3zm0 7h3v3H3zM8 11h13v2H8zm0 7h13v2H8z"/>',
    },
    "list-check-2": {
      body: '<path fill="currentColor" d="M11 4h10v2H11zm0 4h6v2h-6zm0 6h10v2H11zm0 4h6v2h-6zM3 4h6v6H3zm2 2v2h2V6zm-2 8h6v6H3zm2 2v2h2v-2z"/>',
    },
    "list-check-3": {
      body: '<path fill="currentColor" d="M8 6v3H5V6zM3 4v7h7V4zm10 0h8v2h-8zm0 7h8v2h-8zm0 7h8v2h-8zm-2.293-1.793l-1.414-1.414L6 18.086l-1.793-1.793l-1.414 1.414L6 20.914z"/>',
    },
    "list-indefinite": {
      body: '<path fill="currentColor" d="M13 4h8v2h-8zm0 7h8v2h-8zm0 7h8v2h-8zm-6.5 1a2 2 0 1 1 0-4a2 2 0 0 1 0 4m0 2a4 4 0 1 0 0-8a4 4 0 0 0 0 8M5 6v3h3V6zM3 4h7v7H3z"/>',
    },
    "list-ordered": {
      body: '<path fill="currentColor" d="M8 4h13v2H8zM5 3v3h1v1H3V6h1V4H3V3zM3 14v-2.5h2V11H3v-1h3v2.5H4v.5h2v1zm2 5.5H3v-1h2V18H3v-1h3v4H3v-1h2zM8 11h13v2H8zm0 7h13v2H8z"/>',
    },
    "list-ordered-2": {
      body: '<path fill="currentColor" d="M5.75 3.5H4.717l-1.467.393v1.553l1-.268V8.5H3V10h4V8.5H5.75zM10 4h11v2H10zm0 7h11v2H10zm0 7h11v2H10zm-7.125-2.375a2.125 2.125 0 1 1 3.812 1.292l-.004.006L5.316 18.5H7V20H3v-1.121l2.472-2.844a.625.625 0 1 0-1.094-.466l-.013.306h-1.49z"/>',
    },
    "list-radio": {
      body: '<path fill="currentColor" d="M8.5 7a2 2 0 1 0-4 0a2 2 0 0 0 4 0m2 0a4 4 0 1 1-8 0a4 4 0 0 1 8 0M21 4h-8v2h8zm0 7h-8v2h8zm0 7h-8v2h8zM6.5 19a2 2 0 1 1 0-4a2 2 0 0 1 0 4m0 2a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-13a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "list-settings-fill": {
      body: '<path fill="currentColor" d="M2 18h7v2H2zm0-7h9v2H2zm0-7h20v2H2zm18.674 9.025l1.156-.391l1 1.732l-.916.805a4 4 0 0 1 0 1.658l.916.805l-1 1.732l-1.156-.391a4 4 0 0 1-1.435.83L19 21h-2l-.24-1.196a4 4 0 0 1-1.434-.83l-1.156.392l-1-1.732l.916-.805a4 4 0 0 1 0-1.658l-.916-.805l1-1.732l1.156.391c.41-.37.898-.655 1.435-.83L17 11h2l.24 1.196a4 4 0 0 1 1.434.83M18 17a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "list-settings-line": {
      body: '<path fill="currentColor" d="M2 18h7v2H2zm0-7h9v2H2zm0-7h20v2H2zm18.674 9.025l1.156-.391l1 1.732l-.916.805a4 4 0 0 1 0 1.658l.916.805l-1 1.732l-1.156-.391a4 4 0 0 1-1.435.83L19 21h-2l-.24-1.196a4 4 0 0 1-1.434-.83l-1.156.392l-1-1.732l.916-.805a4 4 0 0 1 0-1.658l-.916-.805l1-1.732l1.156.391c.41-.37.898-.655 1.435-.83L17 11h2l.24 1.196a4 4 0 0 1 1.434.83M18 18a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "list-unordered": {
      body: '<path fill="currentColor" d="M8 4h13v2H8zM4.5 6.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m0 7a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m0 6.9a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3M8 11h13v2H8zm0 7h13v2H8z"/>',
    },
    "list-view": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 1v14h16V5zm2 2h2v2H6zm2 4H6v2h2zm-2 4h2v2H6zm12-8h-8v2h8zm-8 8h8v2h-8zm8-4h-8v2h8z"/>',
    },
    "live-fill": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM7.4 8.829a.4.4 0 0 0-.392.32L7 9.228v5.542a.4.4 0 0 0 .542.374l.073-.036l4.355-2.771a.4.4 0 0 0 .063-.625l-.063-.05L7.615 8.89a.4.4 0 0 0-.215-.06"/>',
    },
    "live-line": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm-1 2H3v12h12zM7.4 8.829a.4.4 0 0 1 .215.062l4.355 2.771a.4.4 0 0 1 0 .675L7.615 15.11A.4.4 0 0 1 7 14.77V9.23a.4.4 0 0 1 .4-.4m13.6.01l-4 2.8v.718l4 2.8z"/>',
    },
    "loader-2-fill": {
      body: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m10-5a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1M7 12a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1m12.071 7.071a1 1 0 0 1-1.414 0l-2.121-2.121a1 1 0 0 1 1.414-1.414l2.121 2.12a1 1 0 0 1 0 1.415M8.464 8.464a1 1 0 0 1-1.414 0l-2.12-2.12a1 1 0 0 1 1.414-1.415l2.12 2.121a1 1 0 0 1 0 1.414M4.93 19.071a1 1 0 0 1 0-1.414l2.121-2.121a1 1 0 0 1 1.414 1.414l-2.12 2.121a1 1 0 0 1-1.415 0M15.536 8.464a1 1 0 0 1 0-1.414l2.12-2.121a1 1 0 1 1 1.415 1.414L16.95 8.464a1 1 0 0 1-1.414 0"/>',
    },
    "loader-2-line": {
      body: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m10-5a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1M7 12a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1m12.071 7.071a1 1 0 0 1-1.414 0l-2.121-2.121a1 1 0 0 1 1.414-1.414l2.121 2.12a1 1 0 0 1 0 1.415M8.464 8.464a1 1 0 0 1-1.414 0l-2.12-2.12a1 1 0 0 1 1.414-1.415l2.12 2.121a1 1 0 0 1 0 1.414M4.93 19.071a1 1 0 0 1 0-1.414l2.121-2.121a1 1 0 0 1 1.414 1.414l-2.12 2.121a1 1 0 0 1-1.415 0M15.536 8.464a1 1 0 0 1 0-1.414l2.12-2.121a1 1 0 1 1 1.415 1.414L16.95 8.464a1 1 0 0 1-1.414 0"/>',
    },
    "loader-3-fill": {
      body: '<path fill="currentColor" d="M3.055 13H5.07a7.002 7.002 0 0 0 13.858 0h2.016a9.001 9.001 0 0 1-17.89 0m0-2a9.001 9.001 0 0 1 17.89 0h-2.016A7.002 7.002 0 0 0 5.07 11z"/>',
    },
    "loader-3-line": {
      body: '<path fill="currentColor" d="M3.055 13H5.07a7.002 7.002 0 0 0 13.858 0h2.016a9.001 9.001 0 0 1-17.89 0m0-2a9.001 9.001 0 0 1 17.89 0h-2.016A7.002 7.002 0 0 0 5.07 11z"/>',
    },
    "loader-4-fill": {
      body: '<path fill="currentColor" d="M18.364 5.636L16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364"/>',
    },
    "loader-4-line": {
      body: '<path fill="currentColor" d="M18.364 5.636L16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364"/>',
    },
    "loader-5-fill": {
      body: '<path fill="currentColor" d="M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7z"/>',
    },
    "loader-5-line": {
      body: '<path fill="currentColor" d="M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7z"/>',
    },
    "loader-fill": {
      body: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m8.66-10a1 1 0 0 1-.366 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5A1 1 0 0 1 20.66 7M7.67 14.5a1 1 0 0 1-.367 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5a1 1 0 0 1 1.366.366M20.66 17a1 1 0 0 1-1.366.366l-2.598-1.5a1 1 0 0 1 1-1.732l2.598 1.5A1 1 0 0 1 20.66 17M7.67 9.5a1 1 0 0 1-1.367.366l-2.598-1.5a1 1 0 1 1 1-1.732l2.598 1.5A1 1 0 0 1 7.67 9.5"/>',
    },
    "loader-line": {
      body: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m8.66-10a1 1 0 0 1-.366 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5A1 1 0 0 1 20.66 7M7.67 14.5a1 1 0 0 1-.367 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5a1 1 0 0 1 1.366.366M20.66 17a1 1 0 0 1-1.366.366l-2.598-1.5a1 1 0 0 1 1-1.732l2.598 1.5A1 1 0 0 1 20.66 17M7.67 9.5a1 1 0 0 1-1.367.366l-2.598-1.5a1 1 0 1 1 1-1.732l2.598 1.5A1 1 0 0 1 7.67 9.5"/>',
    },
    "lock-2-fill": {
      body: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0zm-7 7.732V18h2v-2.268A2 2 0 0 0 12 12a2 2 0 0 0-1 3.732M16 8V7a4 4 0 0 0-8 0v1z"/>',
    },
    "lock-2-line": {
      body: '<path fill="currentColor" d="M6 8V7a6 6 0 1 1 12 0v1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zm13 2H5v10h14zm-8 5.732A2 2 0 0 1 12 12a2 2 0 0 1 1 3.732V18h-2zM8 8h8V7a4 4 0 0 0-8 0z"/>',
    },
    "lock-fill": {
      body: '<path fill="currentColor" d="M19 10h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 14 0zm-2 0V9A5 5 0 0 0 7 9v1zm-6 4v4h2v-4z"/>',
    },
    "lock-line": {
      body: '<path fill="currentColor" d="M19 10h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 14 0zM5 12v8h14v-8zm6 2h2v4h-2zm6-4V9A5 5 0 0 0 7 9v1z"/>',
    },
    "lock-password-fill": {
      body: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0zm-2 0V7a4 4 0 0 0-8 0v1zm-5 6v2h2v-2zm-4 0v2h2v-2zm8 0v2h2v-2z"/>',
    },
    "lock-password-line": {
      body: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0zM5 10v10h14V10zm6 4h2v2h-2zm-4 0h2v2H7zm8 0h2v2h-2zm1-6V7a4 4 0 0 0-8 0v1z"/>',
    },
    "lock-star-fill": {
      body: '<path fill="currentColor" d="M12 1a6 6 0 0 0-6 6v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.044A6 6 0 0 1 21 14.044V9a1 1 0 0 0-1-1h-2V7a6 6 0 0 0-6-6m4 7H8V7a4 4 0 1 1 8 0zm5.145 15.14l-.505-2.945l2.14-2.086l-2.957-.43L18.5 15l-1.323 2.68l-2.957.43l2.14 2.085l-.505 2.946L18.5 21.75z"/>',
    },
    "lock-star-line": {
      body: '<path fill="currentColor" d="M6 7a6 6 0 1 1 12 0v1h1.5A1.5 1.5 0 0 1 21 9.5V13h-2v-3H5v10h8v2H4.5A1.5 1.5 0 0 1 3 20.5v-11A1.5 1.5 0 0 1 4.5 8H6zm10 0a4 4 0 0 0-8 0v1h8zm4.64 13.195l.505 2.946L18.5 21.75l-2.645 1.39l.505-2.945l-2.14-2.086l2.957-.43L18.5 15l1.323 2.68l2.957.43z"/>',
    },
    "lock-unlock-fill": {
      body: '<path fill="currentColor" d="M7 10h13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 13.262-3.131l-1.789.894A5 5 0 0 0 7 9zm3 5v2h4v-2z"/>',
    },
    "lock-unlock-line": {
      body: '<path fill="currentColor" d="M7 10h13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 13.262-3.131l-1.789.894A5 5 0 0 0 7 9zm-2 2v8h14v-8zm5 3h4v2h-4z"/>',
    },
    "login-box-fill": {
      body: '<path fill="currentColor" d="M10 11H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8h6v3l5-4l-5-4z"/>',
    },
    "login-box-line": {
      body: '<path fill="currentColor" d="M4 15h2v5h12V4H6v5H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm6-4V8l5 4l-5 4v-3H2v-2z"/>',
    },
    "login-circle-fill": {
      body: '<path fill="currentColor" d="M10 11H2.048c.502-5.053 4.765-9 9.95-9c5.523 0 10 4.477 10 10s-4.477 10-10 10c-5.185 0-9.448-3.947-9.95-9h7.95v3l5-4l-5-4z"/>',
    },
    "login-circle-line": {
      body: '<path fill="currentColor" d="M10 11V8l5 4l-5 4v-3H1v-2zm-7.542 4h2.124A8.003 8.003 0 0 0 20 12A8 8 0 0 0 4.582 9H2.458C3.732 4.943 7.522 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.478 0-8.268-2.943-9.542-7"/>',
    },
    "logout-box-fill": {
      body: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m4 9V8l-5 4l5 4v-3h6v-2z"/>',
    },
    "logout-box-line": {
      body: '<path fill="currentColor" d="M4 18h2v2h12V4H6v2H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm2-7h7v2H6v3l-5-4l5-4z"/>',
    },
    "logout-box-r-fill": {
      body: '<path fill="currentColor" d="M5 22a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1zm10-6l5-4l-5-4v3H9v2h6z"/>',
    },
    "logout-box-r-line": {
      body: '<path fill="currentColor" d="M5 22a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3h-2V4H6v16h12v-2h2v3a1 1 0 0 1-1 1zm13-6v-3h-7v-2h7V8l5 4z"/>',
    },
    "logout-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M7 11V8l-5 4l5 4v-3h8v-2z"/>',
    },
    "logout-circle-line": {
      body: '<path fill="currentColor" d="M5 11h8v2H5v3l-5-4l5-4zm-1 7h2.708a8 8 0 1 0 0-12H4a9.99 9.99 0 0 1 8-4c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.99 9.99 0 0 1-8-4"/>',
    },
    "logout-circle-r-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m5-6l5-4l-5-4v3H9v2h8z"/>',
    },
    "logout-circle-r-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.99 9.99 0 0 1 8 4h-2.71a8 8 0 1 0 .001 12h2.71A9.99 9.99 0 0 1 12 22m7-6v-3h-8v-2h8V8l5 4z"/>',
    },
    "loop-left-fill": {
      body: '<path fill="currentColor" d="M12 4a7.99 7.99 0 0 0-6.357 3.143L8 9.5H2v-6l2.219 2.219A9.98 9.98 0 0 1 12 2c5.523 0 10 4.477 10 10h-2a8 8 0 0 0-8-8m-8 8a8 8 0 0 0 14.357 4.857L16 14.5h6v6l-2.219-2.219A9.98 9.98 0 0 1 12 22C6.477 22 2 17.523 2 12z"/>',
    },
    "loop-left-line": {
      body: '<path fill="currentColor" d="M12 4a7.99 7.99 0 0 0-6.616 3.5H8v2H2v-6h2V6a9.98 9.98 0 0 1 8-4c5.523 0 10 4.477 10 10h-2a8 8 0 0 0-8-8m-8 8a8 8 0 0 0 14.616 4.5H16v-2h6v6h-2V18a9.98 9.98 0 0 1-8 4C6.477 22 2 17.523 2 12z"/>',
    },
    "loop-right-fill": {
      body: '<path fill="currentColor" d="M12 4c2.59 0 4.894 1.23 6.357 3.143L16 9.5h6v-6l-2.219 2.219A9.98 9.98 0 0 0 12 2C6.477 2 2 6.477 2 12h2a8 8 0 0 1 8-8m8 8a8 8 0 0 1-14.357 4.857L8 14.5H2v6l2.219-2.219A9.98 9.98 0 0 0 12 22c5.523 0 10-4.477 10-10z"/>',
    },
    "loop-right-line": {
      body: '<path fill="currentColor" d="M12 4a7.99 7.99 0 0 1 6.616 3.5H16v2h6v-6h-2V6a9.98 9.98 0 0 0-8-4C6.477 2 2 6.477 2 12h2a8 8 0 0 1 8-8m8 8a8 8 0 0 1-14.616 4.5H8v-2H2v6h2V18a9.98 9.98 0 0 0 8 4c5.523 0 10-4.477 10-10z"/>',
    },
    "luggage-cart-fill": {
      body: '<path fill="currentColor" d="M5.5 20a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m13 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M2.172 1.757L6 5.585V17h14v2H5a1 1 0 0 1-1-1V6.413L.758 3.172zM16 3a1 1 0 0 1 1 1v2h2.994C20.55 6 21 6.456 21 6.995v8.01a1 1 0 0 1-1.006.995H8.007A1.01 1.01 0 0 1 7 15.005v-8.01A1 1 0 0 1 8.007 6H11V4a1 1 0 0 1 1-1zm-5 5h-1v6h1zm7 0h-1v6h1zm-3-3h-2v1h2z"/>',
    },
    "luggage-cart-line": {
      body: '<path fill="currentColor" d="M5.5 20a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m13 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M2.172 1.757L6 5.585V17h14v2H5a1 1 0 0 1-1-1V6.413L.758 3.172zM16 3a1 1 0 0 1 1 1v2h2.994C20.55 6 21 6.456 21 6.995v8.01a1 1 0 0 1-1.006.995H8.007A1.01 1.01 0 0 1 7 15.005v-8.01A1 1 0 0 1 8.007 6H11V4a1 1 0 0 1 1-1zm-6 5H9v6h1zm6 0h-4v6h4zm3 0h-1v6h1zm-4-3h-2v1h2z"/>',
    },
    "luggage-deposit-fill": {
      body: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h4a1 1 0 0 1 1 1v12h2v2H1v-2h2V7a1 1 0 0 1 1-1h4V4a1 1 0 0 1 1-1zm-5 5H8v11h2zm6 0h-2v11h2zm-2-3h-4v1h4z"/>',
    },
    "luggage-deposit-line": {
      body: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h4a1 1 0 0 1 1 1v12h2v2H1v-2h2V7a1 1 0 0 1 1-1h4V4a1 1 0 0 1 1-1zM8 8H5v11h3zm6 0h-4v11h4zm5 0h-3v11h3zm-5-3h-4v1h4z"/>',
    },
    "lungs-fill": {
      body: '<path fill="currentColor" d="M8.5 5.5c1.412.47 2.048 2.159 2.327 4.023l-4.523 2.611l1 1.732l3.71-2.141C11.06 13.079 11 14.309 11 15c0 3-1 6-5 6s-4 0-4-4C2 9.5 5.5 4.5 8.5 5.5M22.001 17v.436c-.005 3.564-.15 3.564-4 3.564c-4 0-5-3-5-6c0-.691-.06-1.92-.014-3.274l3.71 2.14l1-1.732l-4.523-2.61c.279-1.865.915-3.553 2.327-4.024c3-1 6.5 4 6.5 11.5M13 2v9h-2V2z"/>',
    },
    "lungs-line": {
      body: '<path fill="currentColor" d="M22.001 17c-.001 4-.001 4-4 4s-5-3-5-6c0-.378-.018-.918-.026-1.55l2.023 1.169L15 15c0 2.776.816 4 3 4c1.14 0 1.61-.007 1.963-.038c.03-.351.037-.822.037-1.962c0-3.205-.703-6.033-1.835-7.9c-.838-1.382-1.613-1.842-2.032-1.703c-.293.098-.605.65-.831 1.623l-1.79-1.033c.369-1.197.982-2.151 1.988-2.487c3-1 6.503 4 6.5 11.5M8.5 5.5c1.007.336 1.62 1.29 1.989 2.487L8.699 9.02c-.226-.973-.539-1.525-.831-1.623c-.42-.14-1.195.32-2.032 1.702C4.703 10.967 4 13.795 4 17c0 1.14.007 1.61.037 1.962C4.39 18.993 4.86 19 6 19c2.184 0 3-1.224 3-4l.004-.382l2.023-1.168c-.01.633-.027 1.172-.027 1.55c0 3-1 6-5 6s-4 0-4-4C2 9.5 5.5 4.5 8.5 5.5M13 2v7.422l4.696 2.712l-1 1.732L12 11.155l-4.696 2.711l-1-1.732L11 9.422V2z"/>',
    },
    "mac-fill": {
      body: '<path fill="currentColor" d="M14 18v2l2 1v1H8l-.004-.996L10 20v-2H2.992A1 1 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008zM4 14v2h16v-2z"/>',
    },
    "mac-line": {
      body: '<path fill="currentColor" d="M14 18v2l2 1v1H8l-.004-.996L10 20v-2H2.992A1 1 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008zM4 5v9h16V5z"/>',
    },
    "macbook-fill": {
      body: '<path fill="currentColor" d="M2 4.007C2 3.45 2.455 3 2.992 3h18.016c.548 0 .992.45.992 1.007V17H2zM1 19h22v2H1z"/>',
    },
    "macbook-line": {
      body: '<path fill="currentColor" d="M4 5v11h16V5zm-2-.993C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007V18H2zM1 19h22v2H1z"/>',
    },
    "magic-fill": {
      body: '<path fill="currentColor" d="m15.224 15.508l-2.213 4.65a.6.6 0 0 1-.977.155l-3.542-3.739a.6.6 0 0 0-.358-.182l-5.106-.668a.6.6 0 0 1-.45-.881l2.462-4.524a.6.6 0 0 0 .063-.396L4.16 4.86a.6.6 0 0 1 .7-.7l5.062.943a.6.6 0 0 0 .397-.063l4.523-2.46a.6.6 0 0 1 .882.448l.668 5.107a.6.6 0 0 0 .182.357l3.739 3.542a.6.6 0 0 1-.155.977l-4.65 2.213a.6.6 0 0 0-.284.284m.797 1.927l1.414-1.414l4.243 4.242l-1.415 1.415z"/>',
    },
    "magic-line": {
      body: '<path fill="currentColor" d="M15.199 9.944a2.6 2.6 0 0 1-.79-1.55l-.403-3.083l-2.731 1.486a2.6 2.6 0 0 1-1.719.272L6.5 6.5l.57 3.056a2.6 2.6 0 0 1-.273 1.72l-1.486 2.73l3.083.403a2.6 2.6 0 0 1 1.55.79l2.138 2.257l1.336-2.807a2.6 2.6 0 0 1 1.23-1.231l2.808-1.336zm.025 5.564l-2.213 4.65a.6.6 0 0 1-.977.155l-3.542-3.739a.6.6 0 0 0-.358-.182l-5.106-.668a.6.6 0 0 1-.45-.881l2.462-4.524a.6.6 0 0 0 .063-.396L4.16 4.86a.6.6 0 0 1 .7-.7l5.062.943a.6.6 0 0 0 .397-.063l4.523-2.46a.6.6 0 0 1 .882.448l.668 5.107a.6.6 0 0 0 .182.357l3.739 3.542a.6.6 0 0 1-.155.977l-4.65 2.213a.6.6 0 0 0-.284.284m.797 1.927l1.414-1.414l4.243 4.242l-1.415 1.415z"/>',
    },
    "mail-add-fill": {
      body: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-1.658L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zM21 18h3v2h-3v3h-2v-3h-3v-2h3v-3h2z"/>',
    },
    "mail-add-line": {
      body: '<path fill="currentColor" d="M22 13h-2V7.238l-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM4.511 5l7.55 6.662L19.502 5zM21 18h3v2h-3v3h-2v-3h-3v-2h3v-3h2z"/>',
    },
    "mail-check-fill": {
      body: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-1.658L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zM19 22l-3.536-3.535l1.415-1.415L19 19.172l3.535-3.536l1.415 1.414z"/>',
    },
    "mail-check-line": {
      body: '<path fill="currentColor" d="M22 14h-2V7.238l-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM4.511 5l7.55 6.662L19.502 5zM19 22l-3.536-3.535l1.415-1.415L19 19.172l3.535-3.536l1.415 1.414z"/>',
    },
    "mail-close-fill": {
      body: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-1.658L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zM21.415 19l2.121 2.121l-1.414 1.415L20 20.414l-2.121 2.121l-1.415-1.414L18.587 19l-2.121-2.121l1.414-1.415L20 17.587l2.121-2.121l1.415 1.414z"/>',
    },
    "mail-close-line": {
      body: '<path fill="currentColor" d="M22 14h-2V7.238l-7.928 7.1L4 7.216V19h11v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM4.511 5l7.55 6.662L19.502 5zm16.903 14l2.121 2.121l-1.414 1.415L20 20.414l-2.121 2.121l-1.415-1.414L18.587 19l-2.121-2.121l1.414-1.415L20 17.587l2.121-2.121l1.415 1.414z"/>',
    },
    "mail-download-fill": {
      body: '<path fill="currentColor" d="M22 12.803A6 6 0 0 0 13.803 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-1.12L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zM20 18h3l-4 4l-4-4h3v-4h2z"/>',
    },
    "mail-download-line": {
      body: '<path fill="currentColor" d="m20 7.238l-7.928 7.1L4 7.216V19h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8h-2zM19.501 5H4.511l7.55 6.662zM20 18h3l-4 4l-4-4h3v-4h2z"/>',
    },
    "mail-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m9.06 8.683L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513z"/>',
    },
    "mail-forbid-fill": {
      body: '<path fill="currentColor" d="m15.266 11.554l4.388-3.798l-1.308-1.512l-6.285 5.439l-6.414-5.445l-1.294 1.524l7.702 6.54A6.97 6.97 0 0 0 11 18c0 1.074.242 2.09.674 3H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8.255A6.97 6.97 0 0 0 18 11a7 7 0 0 0-2.734.554m1.44 9.154a3 3 0 0 0 4.001-4.001zm-1.414-1.415l4.001-4a3 3 0 0 0-4.001 4.001M18 23a5 5 0 1 1 0-10a5 5 0 0 1 0 10"/>',
    },
    "mail-forbid-line": {
      body: '<path fill="currentColor" d="m20 7.238l-7.928 7.1L4 7.216V19h7.07c.102.706.308 1.378.604 2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8.255a7 7 0 0 0-2-.965zM19.501 5H4.511l7.55 6.662zm-2.794 15.708a3 3 0 0 0 4.001-4.001zm-1.415-1.415l4.001-4a3 3 0 0 0-4.001 4.001M18 23a5 5 0 1 1 0-10a5 5 0 0 1 0 10"/>',
    },
    "mail-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m17 4.238l-7.928 7.1L4 7.216V19h16zM4.511 5l7.55 6.662L19.502 5z"/>',
    },
    "mail-lock-fill": {
      body: '<path fill="currentColor" d="M22 12a5.002 5.002 0 0 0-7.9 3H13v6H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-.317L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zM22 17h1v5h-8v-5h1v-1a3 3 0 1 1 6 0zm-2 0v-1a1 1 0 1 0-2 0v1z"/>',
    },
    "mail-lock-line": {
      body: '<path fill="currentColor" d="m20 7.238l-7.928 7.1L4 7.216V19h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v7h-2zM19.501 5H4.511l7.55 6.662zM22 17h1v5h-8v-5h1v-1a3 3 0 1 1 6 0zm-2 0v-1a1 1 0 1 0-2 0v1z"/>',
    },
    "mail-open-fill": {
      body: '<path fill="currentColor" d="M2.243 6.854L11.49 1.31a1 1 0 0 1 1.028 0l9.24 5.545a.5.5 0 0 1 .242.429V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.283a.5.5 0 0 1 .243-.429m16.103 1.39l-6.285 5.439l-6.414-5.445l-1.294 1.524l7.72 6.555l7.581-6.56z"/>',
    },
    "mail-open-line": {
      body: '<path fill="currentColor" d="M2.243 6.854L11.49 1.31a1 1 0 0 1 1.028 0l9.24 5.545a.5.5 0 0 1 .242.429V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.283a.5.5 0 0 1 .243-.429M4 8.133V19h16V8.132l-7.996-4.8zm8.06 5.565l5.296-4.463l1.288 1.53l-6.57 5.537l-6.71-5.53l1.272-1.544z"/>',
    },
    "mail-send-fill": {
      body: '<path fill="currentColor" d="M2 5.5V3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V19h18V7.3l-8 7.2zM0 10h5v2H0zm0 5h8v2H0z"/>',
    },
    "mail-send-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16.007a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V19h18V7.3l-8 7.2l-10-9V4a1 1 0 0 1 1-1zM8 15v2H0v-2zm-3-5v2H0v-2zm14.566-5H4.434L12 11.81z"/>',
    },
    "mail-settings-fill": {
      body: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-1.658L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zm4.99 7.866a3 3 0 0 1 0-1.098l-1.014-.585l1-1.732l1.014.586c.278-.238.599-.425.95-.55V15h2v1.17c.351.125.672.312.95.55l1.014-.586l1 1.732l-1.014.585a3 3 0 0 1 0 1.098l1.014.585l-1 1.732l-1.014-.586a3 3 0 0 1-.95.55V23h-2v-1.17a3 3 0 0 1-.95-.55l-1.014.586l-1-1.732zM20 20a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "mail-settings-line": {
      body: '<path fill="currentColor" d="m20 7.238l-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9h-2zM19.501 5H4.511l7.55 6.662zM17.05 19.549a3 3 0 0 1 0-1.098l-1.014-.585l1-1.732l1.014.586c.278-.238.599-.425.95-.55V15h2v1.17c.351.125.672.312.95.55l1.014-.586l1 1.732l-1.014.585a3 3 0 0 1 0 1.098l1.014.585l-1 1.732l-1.014-.586a3 3 0 0 1-.95.55V23h-2v-1.17a3 3 0 0 1-.95-.55l-1.014.586l-1-1.732zM20 20a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "mail-star-fill": {
      body: '<path fill="currentColor" d="M22 14.044A6 6 0 0 0 13.689 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-2.361L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zM19.5 21.75l-2.645 1.39l.505-2.945l-2.14-2.086l2.957-.43L19.5 15l1.323 2.68l2.957.43l-2.14 2.085l.505 2.946z"/>',
    },
    "mail-star-line": {
      body: '<path fill="currentColor" d="M22 13h-2V7.238l-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM4.511 5l7.55 6.662L19.502 5zM19.5 21.75l-2.645 1.39l.505-2.945l-2.14-2.086l2.957-.43L19.5 15l1.323 2.68l2.957.43l-2.14 2.085l.505 2.946z"/>',
    },
    "mail-unread-fill": {
      body: '<path fill="currentColor" d="M18.803 8.493A5.02 5.02 0 0 0 22 8.9V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h13.1q-.1.486-.1 1a4.98 4.98 0 0 0 1.193 3.241l-5.132 4.442l-6.414-5.445l-1.294 1.524l7.72 6.555zM21 7a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "mail-unread-line": {
      body: '<path fill="currentColor" d="M16.1 3a5 5 0 0 0 0 2H4.511l7.55 6.662l5.049-4.52c.426.527.958.966 1.563 1.285l-6.601 5.911L4 7.216V19h16V8.9a5 5 0 0 0 2 0V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM21 1a3 3 0 1 1 0 6a3 3 0 0 1 0-6"/>',
    },
    "mail-volume-fill": {
      body: '<path fill="currentColor" d="M20 14.5v9L16.667 21H14v-4h2.667zM21 3a1 1 0 0 1 1 1v10.529A6 6 0 0 0 12.34 21H3.002a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 14a2 2 0 0 1 .15 3.994L21 21zM5.647 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513l-6.286 5.438z"/>',
    },
    "mail-volume-line": {
      body: '<path fill="currentColor" d="M20 14.5v9L16.667 21H14v-4h2.667zM21 3a1 1 0 0 1 1 1v9h-2V7.237l-7.928 7.101L4 7.215V19h8v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 14a2 2 0 0 1 .15 3.994L21 21zM19.5 5H4.511l7.55 6.662z"/>',
    },
    "map-2-fill": {
      body: '<path fill="currentColor" d="m2 5l7-3l6 3l6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46zm13 14.764V7.176l-.065.028L9 4.236v12.588l.065-.028z"/>',
    },
    "map-2-line": {
      body: '<path fill="currentColor" d="m2 5l7-3l6 3l6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46zm14 14.395l4-1.714V5.033l-4 1.714zm-2-.131V6.736l-4-2v12.528zm-6-2.011V4.605L4 6.319v12.648z"/>',
    },
    "map-fill": {
      body: '<path fill="currentColor" d="m2 5l7-3l6 3l6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46z"/>',
    },
    "map-line": {
      body: '<path fill="currentColor" d="m2 5l7-3l6 3l6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46zm12.935 2.204l-6-3L4 6.319v12.648l5.065-2.17l6 3L20 17.68V5.033z"/>',
    },
    "map-pin-2-fill": {
      body: '<path fill="currentColor" d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0M12 13a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "map-pin-2-line": {
      body: '<path fill="currentColor" d="m12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zm4.95-7.778a7 7 0 1 0-9.9 0L12 20.9zM12 13a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "map-pin-3-fill": {
      body: '<path fill="currentColor" d="M11 19.945A9.001 9.001 0 0 1 12 2a9 9 0 0 1 1 17.945V24h-2z"/>',
    },
    "map-pin-3-line": {
      body: '<path fill="currentColor" d="M11 19.945A9.001 9.001 0 0 1 12 2a9 9 0 0 1 1 17.945V24h-2zM12 18a7 7 0 1 0 0-14a7 7 0 0 0 0 14"/>',
    },
    "map-pin-4-fill": {
      body: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938V21h-2zM5 22h14v2H5z"/>',
    },
    "map-pin-4-line": {
      body: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938V21h-2zM12 16a6 6 0 1 0 0-12a6 6 0 0 0 0 12m-7 6h14v2H5z"/>',
    },
    "map-pin-5-fill": {
      body: '<path fill="currentColor" d="M17.657 15.657L12 21.314l-5.657-5.657a8 8 0 1 1 11.314 0M5 22h14v2H5z"/>',
    },
    "map-pin-5-line": {
      body: '<path fill="currentColor" d="m12 18.485l4.243-4.242a6 6 0 1 0-8.486 0zm5.657-2.828L12 21.314l-5.657-5.657a8 8 0 1 1 11.314 0M5 22h14v2H5z"/>',
    },
    "map-pin-add-fill": {
      body: '<path fill="currentColor" d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0M11 10H8v2h3v3h2v-3h3v-2h-3V7h-2z"/>',
    },
    "map-pin-add-line": {
      body: '<path fill="currentColor" d="m12 20.9l4.95-4.95a7 7 0 1 0-9.9 0zm0 2.828l-6.364-6.364a9 9 0 1 1 12.728 0zM11 10V7h2v3h3v2h-3v3h-2v-3H8v-2z"/>',
    },
    "map-pin-fill": {
      body: '<path fill="currentColor" d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0M12 15a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "map-pin-line": {
      body: '<path fill="currentColor" d="m12 20.9l4.95-4.95a7 7 0 1 0-9.9 0zm0 2.828l-6.364-6.364a9 9 0 1 1 12.728 0zM12 13a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8"/>',
    },
    "map-pin-range-fill": {
      body: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488c0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488zM12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "map-pin-range-line": {
      body: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488c0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488zM12 16a6 6 0 1 0 0-12a6 6 0 0 0 0 12m0-4a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "map-pin-time-fill": {
      body: '<path fill="currentColor" d="M13 11V6h-2v7h6v-2zm5.364 6.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0"/>',
    },
    "map-pin-time-line": {
      body: '<path fill="currentColor" d="M16.95 15.95a7 7 0 1 0-9.9 0L12 20.9zM12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM13 11h4v2h-6V6h2z"/>',
    },
    "map-pin-user-fill": {
      body: '<path fill="currentColor" d="M17.084 15.812a7 7 0 1 0-10.168 0A6 6 0 0 1 12 13a6 6 0 0 1 5.084 2.812M12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 12a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "map-pin-user-line": {
      body: '<path fill="currentColor" d="M17.084 15.812a7 7 0 1 0-10.168 0A6 6 0 0 1 12 13a6 6 0 0 1 5.084 2.812m-8.699 1.473L12 20.899l3.615-3.614a4 4 0 0 0-7.23 0M12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 10a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "mark-pen-fill": {
      body: '<path fill="currentColor" d="m15.95 2.39l5.657 5.657a1 1 0 0 1 0 1.414l-7.778 7.778l-2.122.707l-1.414 1.415a1 1 0 0 1-1.414 0l-4.243-4.243a1 1 0 0 1 0-1.414L6.05 12.29l.707-2.122l7.779-7.778a1 1 0 0 1 1.414 0m.707 3.536l-6.364 6.364l1.414 1.414l6.364-6.364zM4.283 16.886l2.828 2.828l-1.414 1.415l-4.243-1.415z"/>',
    },
    "mark-pen-line": {
      body: '<path fill="currentColor" d="M15.243 4.511L8.505 11.25l-.707 2.121l-1.04 1.041l2.828 2.828l1.04-1.04l2.122-.708l6.737-6.737zm6.364 3.536a1 1 0 0 1 0 1.414l-7.778 7.778l-2.122.707l-1.414 1.415a1 1 0 0 1-1.414 0l-4.243-4.243a1 1 0 0 1 0-1.414L6.05 12.29l.707-2.122l7.779-7.778a1 1 0 0 1 1.414 0zm-6.364-.707l1.414 1.414l-4.95 4.95l-1.414-1.414zm-10.96 9.546l2.828 2.828l-1.414 1.415l-4.243-1.415z"/>',
    },
    "markdown-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4 12.5v-4l2 2l2-2v4h2v-7h-2l-2 2l-2-2H5v7zm11-3v-4h-2v4h-2l3 3l3-3z"/>',
    },
    "markdown-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h16V5zm3 10.5H5v-7h2l2 2l2-2h2v7h-2v-4l-2 2l-2-2zm11-3h2l-3 3l-3-3h2v-4h2z"/>',
    },
    "markup-fill": {
      body: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m5.051-3.796l-.862-3.447a1 1 0 0 0-.97-.757H8.781a1 1 0 0 0-.97.757l-.862 3.447A7.97 7.97 0 0 0 12 19.997a7.97 7.97 0 0 0 5.051-1.796M10 11.997h4v-1.5l-1.039-3.635a1 1 0 0 0-1.922 0L10 10.497z"/>',
    },
    "markup-line": {
      body: '<path fill="currentColor" d="m10 10.497l1.039-3.635a1 1 0 0 1 1.922 0L14 10.497v1.5h.72a1 1 0 0 1 .97.757l1.361 5.447a8 8 0 1 0-10.102 0l1.362-5.447a1 1 0 0 1 .97-.757H10zm2 9.5q.362 0 .719-.032a8 8 0 0 0 2.546-.663l-1.327-5.305h-3.876l-1.327 5.305a7.95 7.95 0 0 0 3.265.695m0 2c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "mastercard-fill": {
      body: '<path fill="currentColor" d="M12.001 6.654a6.79 6.79 0 0 1 2.596 5.344A6.79 6.79 0 0 1 12 17.34a6.79 6.79 0 0 1-2.596-5.343A6.79 6.79 0 0 1 12 6.653m-.87-.582A7.78 7.78 0 0 0 8.402 12a7.78 7.78 0 0 0 2.728 5.926a6.798 6.798 0 1 1 .003-11.854m1.742 11.854A7.78 7.78 0 0 0 15.602 12a7.78 7.78 0 0 0-2.73-5.928a6.798 6.798 0 1 1 .003 11.854"/>',
    },
    "mastercard-line": {
      body: '<path fill="currentColor" d="M12.001 18.294a7.3 7.3 0 1 1 0-12.588a7.3 7.3 0 1 1 0 12.588m1.702-1.384a5.3 5.3 0 1 0 0-9.82A7.27 7.27 0 0 1 15.6 12c0 1.89-.719 3.614-1.898 4.91m-3.404-9.82a5.3 5.3 0 1 0 0 9.82A7.27 7.27 0 0 1 8.401 12c0-1.89.719-3.614 1.898-4.91m1.702 1.115a5.28 5.28 0 0 0-1.6 3.795c0 1.488.613 2.832 1.6 3.795a5.28 5.28 0 0 0 1.6-3.795a5.28 5.28 0 0 0-1.6-3.795"/>',
    },
    "mastodon-fill": {
      body: '<path fill="currentColor" d="M21.26 13.99c-.275 1.41-2.457 2.955-4.963 3.254c-1.306.156-2.593.3-3.965.236c-2.244-.103-4.014-.535-4.014-.535q0 .328.04.62c.292 2.215 2.196 2.347 4 2.41c1.82.061 3.44-.45 3.44-.45l.075 1.646s-1.273.684-3.54.81c-1.252.068-2.805-.032-4.613-.51c-3.923-1.039-4.598-5.22-4.701-9.464c-.032-1.26-.012-2.447-.012-3.44c0-4.34 2.843-5.611 2.843-5.611C7.283 2.298 9.742 2.021 12.3 2h.062c2.557.02 5.018.298 6.451.956c0 0 2.843 1.272 2.843 5.61c0 0 .036 3.201-.396 5.424m-2.957-5.087q0-1.611-.823-2.558c-.566-.631-1.307-.955-2.228-.955c-1.065 0-1.872.41-2.405 1.228l-.518.87l-.519-.87C11.277 5.8 10.47 5.39 9.406 5.39c-.921 0-1.663.324-2.229.955q-.823.947-.822 2.558v5.253h2.081V9.057c0-1.075.452-1.62 1.357-1.62c1 0 1.501.647 1.501 1.927v2.79h2.07v-2.79c0-1.28.5-1.927 1.5-1.927c.905 0 1.358.545 1.358 1.62v5.1h2.08z"/>',
    },
    "mastodon-line": {
      body: '<path fill="currentColor" d="M3.019 12.008c-.032-1.26-.012-2.448-.012-3.442c0-4.338 2.843-5.61 2.843-5.61C7.283 2.298 9.742 2.021 12.3 2h.062c2.557.02 5.018.298 6.451.956c0 0 2.843 1.272 2.843 5.61c0 0 .036 3.201-.396 5.424c-.275 1.41-2.457 2.955-4.963 3.254c-1.306.156-2.593.3-3.965.236c-2.244-.102-4.014-.535-4.014-.535q0 .328.04.62c.084.633.299 1.095.605 1.435c.766.85 2.106.93 3.395.974c1.82.063 3.44-.449 3.44-.449l.075 1.646s-1.273.684-3.54.81c-1.251.068-2.804-.032-4.613-.51c-1.532-.406-2.568-1.29-3.27-2.471c-1.093-1.843-1.368-4.406-1.431-6.992m3.3 4.937v-2.548l2.474.605q.073.018.324.07a22 22 0 0 0 3.307.41c1.019.047 1.9-.017 3.636-.224c1.663-.199 3.148-1.196 3.236-1.65c.082-.422.151-.922.206-1.482c.07-.705.114-1.47.137-2.245c.015-.51.02-.945.017-1.256v-.059c0-1.43-.369-2.438-.963-3.158a3 3 0 0 0-.584-.548c-.09-.064-.135-.089-.13-.087c-1.013-.465-3.093-.752-5.617-.773h-.046c-2.54.02-4.62.308-5.65.782c.023-.01-.021.014-.112.078a3 3 0 0 0-.584.548c-.594.72-.963 1.729-.963 3.158c0 .232 0 .397-.003.875a78 78 0 0 0 .014 2.518c.054 2.197.264 3.835.7 5.041q.318.88.78 1.45a5.7 5.7 0 0 1-.18-1.505M8.085 6.37a1.143 1.143 0 1 1 0 2.287a1.143 1.143 0 0 1 0-2.287"/>',
    },
    "medal-2-fill": {
      body: '<path fill="currentColor" d="m12 8.5l2.116 5.088l5.493.44l-4.185 3.585l1.278 5.36L12 20.1l-4.702 2.872l1.278-5.36l-4.184-3.584l5.492-.44zM8 2v9H6V2zm10 0v9h-2V2zm-5 0v5h-2V2z"/>',
    },
    "medal-2-line": {
      body: '<path fill="currentColor" d="m12 8.5l2.116 5.088l5.493.44l-4.185 3.585l1.278 5.36L12 20.1l-4.702 2.872l1.278-5.36l-4.184-3.584l5.492-.44zm0 5.207l-.739 1.776l-1.916.154l1.46 1.251l-.447 1.871L12 17.756l1.641 1.003l-.446-1.87l1.46-1.252l-1.916-.154zM8 2v9H6V2zm10 0v9h-2V2zm-5 0v5h-2V2z"/>',
    },
    "medal-fill": {
      body: '<path fill="currentColor" d="M12 7a8 8 0 1 1 0 16a8 8 0 0 1 0-16m0 3.5l-1.322 2.68l-2.958.43l2.14 2.085l-.505 2.946L12 17.25l2.645 1.39l-.505-2.945l2.14-2.086l-2.958-.43zm1-8.501L18 2v3l-1.363 1.138A9.9 9.9 0 0 0 13 5.05zm-2 0v3.05a9.9 9.9 0 0 0-3.636 1.088L6 5V2z"/>',
    },
    "medal-line": {
      body: '<path fill="currentColor" d="M12 7a8 8 0 1 1 0 16a8 8 0 0 1 0-16m0 2a6 6 0 1 0 0 12a6 6 0 0 0 0-12m0 1.5l1.322 2.68l2.958.43l-2.14 2.085l.505 2.946L12 17.25l-2.645 1.39l.505-2.945l-2.14-2.086l2.958-.43zM18 2v3l-1.363 1.138A9.9 9.9 0 0 0 13 5.049V2zm-7-.001v3.05a9.9 9.9 0 0 0-3.636 1.088L6 5V2z"/>',
    },
    "medicine-bottle-fill": {
      body: '<path fill="currentColor" d="M17 5v2a3 3 0 0 1 3 3v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a3 3 0 0 1 3-3V5zm-4 6h-2v2H9v2h1.999L11 17h2l-.001-2H15v-2h-2zm6-9v2H5V2z"/>',
    },
    "medicine-bottle-line": {
      body: '<path fill="currentColor" d="M19 2v2h-2v3a3 3 0 0 1 3 3v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a3 3 0 0 1 3-3V4H5V2zm-2 7H7a1 1 0 0 0-1 1v10h12V10a1 1 0 0 0-1-1m-4 2v2h2v2h-2.001L13 17h-2l-.001-2H9v-2h2v-2zm2-7H9v3h6z"/>',
    },
    "medium-fill": {
      body: '<path fill="currentColor" d="M13.41 12.007c0 3.45-2.779 6.247-6.205 6.247S1 15.458 1 12.007S3.778 5.76 7.205 5.76s6.204 2.797 6.204 6.247m6.806 0c0 3.248-1.39 5.88-3.102 5.88c-1.714 0-3.103-2.633-3.103-5.88s1.39-5.88 3.103-5.88s3.102 2.633 3.102 5.88m2.784 0c0 2.91-.489 5.269-1.091 5.269c-.603 0-1.091-2.36-1.091-5.269s.488-5.269 1.091-5.269S23 9.098 23 12.008"/>',
    },
    "medium-line": {
      body: '<path fill="currentColor" d="M8 7a5 5 0 1 0 0 10A5 5 0 0 0 8 7m0-2a7 7 0 0 1 5.804 3.086l.034-.069C14.343 7.007 15.227 6 16.5 6c1.181 0 2.027.866 2.547 1.798q.058-.076.12-.147c.29-.325.737-.651 1.333-.651s1.044.326 1.332.65c.29.327.505.743.665 1.17c.323.863.503 1.987.503 3.18s-.18 2.317-.503 3.18c-.16.427-.375.843-.665 1.17c-.288.324-.736.65-1.332.65s-1.044-.326-1.332-.65a3 3 0 0 1-.121-.148C18.527 17.134 17.68 18 16.5 18c-1.273 0-2.157-1.006-2.662-2.017l-.034-.069A7 7 0 1 1 8 5m12 7c0 .913.08 1.933.5 2.764c.42-.83.5-1.85.5-2.764s-.08-1.933-.5-2.764c-.42.83-.5 1.85-.5 2.764m-2 0c0-.76-.213-4-1.5-4S15 11.24 15 12s.213 4 1.5 4s1.5-3.24 1.5-4"/>',
    },
    "megaphone-fill": {
      body: '<path fill="currentColor" d="M21 10.063V4a1 1 0 0 0-1-1h-1c-1.979 1.979-5.697 3.087-8 3.613v10.774c2.303.526 6.021 1.634 8 3.613h1a1 1 0 0 0 1-1v-6.063a2 2 0 0 0 0-3.874M5 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1l1 5h2V7z"/>',
    },
    "megaphone-line": {
      body: '<path fill="currentColor" d="M9 17s7 1 10 4h1a1 1 0 0 0 1-1v-6.063a2 2 0 0 0 0-3.874V4a1 1 0 0 0-1-1h-1C16 6 9 7 9 7H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1l1 5h2zm2-8.339c.683-.146 1.527-.35 2.44-.617c1.678-.494 3.81-1.271 5.56-2.47v12.851c-1.75-1.198-3.883-1.975-5.56-2.469A34 34 0 0 0 11 15.34zM5 9h4v6H5z"/>',
    },
    "memories-fill": {
      body: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.98 9.98 0 0 0-7.553 3.446L2 3v6h6L5.865 6.865A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10M10.777 8.518l4.599 3.066a.5.5 0 0 1 0 .832l-4.599 3.066a.5.5 0 0 1-.777-.416V8.934a.5.5 0 0 1 .777-.416"/>',
    },
    "memories-line": {
      body: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.99 9.99 0 0 0-8 4V3.5H2v6h6v-2H5.385A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10M10.777 8.518l4.599 3.066a.5.5 0 0 1 0 .832l-4.599 3.066a.5.5 0 0 1-.777-.416V8.934a.5.5 0 0 1 .777-.416"/>',
    },
    "men-fill": {
      body: '<path fill="currentColor" d="M18.586 5H14V3h8v8h-2V6.414l-3.537 3.537a7.5 7.5 0 1 1-1.414-1.414z"/>',
    },
    "men-line": {
      body: '<path fill="currentColor" d="M15.05 8.537L18.585 5H14V3h8v8h-2V6.414l-3.537 3.537a7.5 7.5 0 1 1-1.414-1.414M10.5 20a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11"/>',
    },
    "mental-health-fill": {
      body: '<path fill="currentColor" d="M11 2a8 8 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2m-.53 5.763a1.75 1.75 0 0 0-2.475 2.474L11 13.243l3.005-3.006a1.75 1.75 0 1 0-2.475-2.474l-.53.53z"/>',
    },
    "mental-health-line": {
      body: '<path fill="currentColor" d="M11 2a8 8 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2m0 2a6 6 0 0 0-4.684 9.75C7.41 15.114 8 16.667 8 18.306V20h5l.002-3H17v-4.248l1.55-.664l-1.543-2.425l-.057-.442A6 6 0 0 0 11 4m-.53 3.763l.53.53l.53-.53a1.75 1.75 0 0 1 2.475 2.474L11 13.243l-3.005-3.006a1.75 1.75 0 1 1 2.475-2.474"/>',
    },
    "menu-2-fill": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 7h12v2H3zm0 7h18v2H3z"/>',
    },
    "menu-2-line": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 7h12v2H3zm0 7h18v2H3z"/>',
    },
    "menu-3-fill": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm6 7h12v2H9zm-6 7h18v2H3z"/>',
    },
    "menu-3-line": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm6 7h12v2H9zm-6 7h18v2H3z"/>',
    },
    "menu-4-fill": {
      body: '<path fill="currentColor" d="M16 18v2H5v-2zm5-7v2H3v-2zm-2-7v2H8V4z"/>',
    },
    "menu-4-line": {
      body: '<path fill="currentColor" d="M16 18v2H5v-2zm5-7v2H3v-2zm-2-7v2H8V4z"/>',
    },
    "menu-5-fill": {
      body: '<path fill="currentColor" d="M18 18v2H6v-2zm3-7v2H3v-2zm-3-7v2H6V4z"/>',
    },
    "menu-5-line": {
      body: '<path fill="currentColor" d="M18 18v2H6v-2zm3-7v2H3v-2zm-3-7v2H6V4z"/>',
    },
    "menu-add-fill": {
      body: '<path fill="currentColor" d="m18 15l-.001 3H21v2h-3.001L18 23h-2l-.001-3H13v-2h2.999L16 15zm-7 3v2H3v-2zm10-7v2H3v-2zm0-7v2H3V4z"/>',
    },
    "menu-add-line": {
      body: '<path fill="currentColor" d="m18 15l-.001 3H21v2h-3.001L18 23h-2l-.001-3H13v-2h2.999L16 15zm-7 3v2H3v-2zm10-7v2H3v-2zm0-7v2H3V4z"/>',
    },
    "menu-fill": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 7h18v2H3zm0 7h18v2H3z"/>',
    },
    "menu-fold-2-fill": {
      body: '<path fill="currentColor" d="m4 3.5l5 5l-5 5zM21 20v-2H3v2zm0-7v-2h-9v2zm0-7V4h-9v2z"/>',
    },
    "menu-fold-2-line": {
      body: '<path fill="currentColor" d="M4.403 3.903L2.99 5.318L6.171 8.5L2.99 11.682l1.414 1.414L9 8.5zM21 20v-2H3v2zm0-7v-2h-9v2zm0-7V4h-9v2z"/>',
    },
    "menu-fold-3-fill": {
      body: '<path fill="currentColor" d="M21 4H7v2h14zm0 7H11v2h10zm0 7H7v2h14zM8 17V7l-5 5z"/>',
    },
    "menu-fold-3-line": {
      body: '<path fill="currentColor" d="M21 4H7v2h14zm0 7H11v2h10zm0 7H7v2h14zM9.01 8.814L7.596 7.4L3 11.996l4.596 4.596l1.414-1.414l-3.182-3.182z"/>',
    },
    "menu-fold-4-fill": {
      body: '<path fill="currentColor" d="M21 4H7v2h14zm0 7H11v2h10zm0 7H7v2h14zM3 17V7l5 5z"/>',
    },
    "menu-fold-4-line": {
      body: '<path fill="currentColor" d="M21 4H7v2h14zm0 7H11v2h10zm0 7H7v2h14zM1.99 8.814L3.402 7.4L8 11.996l-4.597 4.596l-1.414-1.414l3.182-3.182z"/>',
    },
    "menu-fold-fill": {
      body: '<path fill="currentColor" d="M21 18v2H3v-2zM7 3.5v10l-5-5zM21 11v2h-9v-2zm0-7v2h-9V4z"/>',
    },
    "menu-fold-line": {
      body: '<path fill="currentColor" d="M21 18v2H3v-2zM6.596 3.903L8.01 5.318L4.828 8.5l3.182 3.182l-1.414 1.414L2 8.5zM21 11v2h-9v-2zm0-7v2h-9V4z"/>',
    },
    "menu-line": {
      body: '<path fill="currentColor" d="M3 4h18v2H3zm0 7h18v2H3zm0 7h18v2H3z"/>',
    },
    "menu-search-fill": {
      body: '<path fill="currentColor" d="M18.618 13.032a5.5 5.5 0 1 1 1.414-1.414l2.675 2.675l-1.414 1.414zM3 4h5v2H3zm0 7h5v2H3zm0 7h18v2H3z"/>',
    },
    "menu-search-line": {
      body: '<path fill="currentColor" d="M15.5 5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7M10 8.5a5.5 5.5 0 1 1 10.032 3.117l2.675 2.676l-1.414 1.414l-2.675-2.675A5.5 5.5 0 0 1 10 8.5M3 4h5v2H3zm0 7h5v2H3zm18 7v2H3v-2z"/>',
    },
    "menu-unfold-2-fill": {
      body: '<path fill="currentColor" d="M21 3.5v10l-5-5zM21 20v-2H3v2zm-9-7v-2H3v2zm0-7V4H3v2z"/>',
    },
    "menu-unfold-2-line": {
      body: '<path fill="currentColor" d="M20.596 3.903L15.999 8.5l4.597 4.596l1.414-1.415L18.828 8.5l3.182-3.182zM21 20v-2H3v2zm-9-7v-2H3v2zm0-7V4H3v2z"/>',
    },
    "menu-unfold-3-fill": {
      body: '<path fill="currentColor" d="M17 4H3v2h14zm-4 7H3v2h10zm4 7H3v2h14zm0-1V7l5 5z"/>',
    },
    "menu-unfold-3-line": {
      body: '<path fill="currentColor" d="M17 4H3v2h14zm-4 7H3v2h10zm4 7H3v2h14zm-1.01-9.186L17.404 7.4L22 11.996l-4.596 4.596l-1.414-1.414l3.182-3.182z"/>',
    },
    "menu-unfold-4-fill": {
      body: '<path fill="currentColor" d="M17 4H3v2h14zm-4 7H3v2h10zm4 7H3v2h14zm4-1V7l-5 5z"/>',
    },
    "menu-unfold-4-line": {
      body: '<path fill="currentColor" d="M17 4H3v2h14zm-4 7H3v2h10zm4 7H3v2h14zm5.01-9.186L20.596 7.4L16 11.996l4.596 4.596l1.414-1.414l-3.182-3.182z"/>',
    },
    "menu-unfold-fill": {
      body: '<path fill="currentColor" d="M21 18v2H3v-2zM17 3.5l5 5l-5 5zM12 11v2H3v-2zm0-7v2H3V4z"/>',
    },
    "menu-unfold-line": {
      body: '<path fill="currentColor" d="M21 18v2H3v-2zM17.404 3.903L22 8.5l-4.596 4.596l-1.414-1.415L19.172 8.5L15.99 5.318zM12 11v2H3v-2zm0-7v2H3V4z"/>',
    },
    "merge-cells-horizontal": {
      body: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-9 2H5v5.999h2V9l3 3l-3 3v-2H5v6h6v-2h2v2h6v-6h-2v2l-3-3l3-3v1.999h2V5h-6v2h-2zm2 8v2h-2v-2zm0-4v2h-2V9z"/>',
    },
    "merge-cells-vertical": {
      body: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zm-2-9V5h-5.999v2H15l-3 3l-3-3h2V5H5v6h2v2H5v6h6v-2H9l3-3l3 3h-1.999v2H19v-6h-2v-2zm-8 2H9v-2h2zm4 0h-2v-2h2z"/>',
    },
    "message-2-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM7 10v2h2v-2zm4 0v2h2v-2zm4 0v2h2v-2z"/>',
    },
    "message-2-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm-.692-2H20V5H4v13.385zM11 10h2v2h-2zm-4 0h2v2H7zm8 0h2v2h-2z"/>',
    },
    "message-3-fill": {
      body: '<path fill="currentColor" d="M2 8.994A5.99 5.99 0 0 1 8 3h8c3.313 0 6 2.695 6 5.994V21H8c-3.313 0-6-2.695-6-5.994zM14 11v2h2v-2zm-6 0v2h2v-2z"/>',
    },
    "message-3-line": {
      body: '<path fill="currentColor" d="M2 8.994A5.99 5.99 0 0 1 8 3h8c3.313 0 6 2.695 6 5.994V21H8c-3.313 0-6-2.695-6-5.994zM20 19V8.994A4.004 4.004 0 0 0 16 5H8a3.99 3.99 0 0 0-4 3.994v6.012A4.004 4.004 0 0 0 8 19zm-6-8h2v2h-2zm-6 0h2v2H8z"/>',
    },
    "message-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM8 10v2h8v-2z"/>',
    },
    "message-line": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm-.692-2H20V5H4v13.385zM8 10h8v2H8z"/>',
    },
    "messenger-fill": {
      body: '<path fill="currentColor" d="M12.001 2c5.634 0 10 4.127 10 9.7s-4.367 9.7-10 9.7a11 11 0 0 1-2.895-.384a.8.8 0 0 0-.534.039l-1.985.876a.8.8 0 0 1-1.123-.707l-.054-1.78a.8.8 0 0 0-.269-.57c-1.945-1.74-3.14-4.258-3.14-7.174c0-5.573 4.366-9.7 10-9.7M5.996 14.537c-.282.447.268.951.689.631l3.155-2.394a.6.6 0 0 1 .723 0l2.336 1.75a1.5 1.5 0 0 0 2.17-.4l2.937-4.66c.282-.448-.268-.952-.689-.633l-3.155 2.396a.6.6 0 0 1-.723 0l-2.337-1.75a1.5 1.5 0 0 0-2.169.4z"/>',
    },
    "messenger-line": {
      body: '<path fill="currentColor" d="M7.765 19.225c.59-.26 1.25-.309 1.868-.139c.77.21 1.565.316 2.368.314c4.585 0 8-3.286 8-7.7s-3.415-7.7-8-7.7s-8 3.287-8 7.7c0 2.27.896 4.272 2.466 5.676a2.8 2.8 0 0 1 .942 2.006zM12.001 2c5.634 0 10 4.127 10 9.7s-4.367 9.7-10 9.7a11 11 0 0 1-2.895-.384a.8.8 0 0 0-.534.039l-1.985.876a.8.8 0 0 1-1.123-.707l-.054-1.78a.8.8 0 0 0-.269-.57c-1.945-1.74-3.14-4.258-3.14-7.174c0-5.573 4.366-9.7 10-9.7M5.996 14.537l2.937-4.66a1.5 1.5 0 0 1 2.17-.4l2.336 1.75a.6.6 0 0 0 .723 0l3.155-2.395c.421-.32.971.184.689.631l-2.937 4.66a1.5 1.5 0 0 1-2.17.4l-2.336-1.75a.6.6 0 0 0-.723 0L6.685 15.17c-.421.319-.971-.185-.689-.633"/>',
    },
    "meta-fill": {
      body: '<path fill="currentColor" d="M16.92 4.5c-1.851 0-3.298 1.394-4.608 3.165C10.512 5.373 9.007 4.5 7.206 4.5C3.534 4.5.72 9.28.72 14.338c0 3.165 1.531 5.162 4.096 5.162c1.846 0 3.174-.87 5.535-4.997c0 0 .984-1.737 1.66-2.934q.356.574.75 1.238l1.107 1.862c2.156 3.608 3.358 4.831 5.534 4.831c2.5 0 3.89-2.024 3.89-5.255c0-5.297-2.877-9.745-6.372-9.745m-8.37 8.886c-1.913 3-2.575 3.673-3.64 3.673c-1.097 0-1.749-.963-1.749-2.68c0-3.672 1.831-7.427 4.014-7.427c1.182 0 2.17.682 3.683 2.848c-1.437 2.204-2.307 3.586-2.307 3.586m7.224-.377L14.45 10.8a45 45 0 0 0-1.032-1.608c1.193-1.841 2.176-2.759 3.347-2.759c2.43 0 4.375 3.58 4.375 7.976c0 1.676-.549 2.649-1.686 2.649c-1.09 0-1.61-.72-3.68-4.05"/>',
    },
    "meta-line": {
      body: '<path fill="currentColor" d="M20.974 16.164q-.427 1.335-1.47 1.336q-1.316 0-2.587-1.58q-.883-1.096-2.477-4.168a58 58 0 0 0-1.269-2.33q.465-.732.829-1.176Q15.436 6.5 17.005 6.5q1.252 0 2.386 1.608q1.164 1.651 1.632 4.08q.46 2.391-.049 3.975m-8.97-4.734q.315.578.66 1.242q1.687 3.25 2.695 4.503q1.872 2.325 4.146 2.325q1.284 0 2.197-.81q.787-.7 1.177-1.916q.665-2.07.108-4.963q-.549-2.852-1.962-4.856Q19.294 4.5 17.005 4.5q-2.514 0-4.55 2.476q-.213.259-.45.594a10 10 0 0 0-.45-.594Q9.519 4.501 7.005 4.5q-2.289 0-4.02 2.455q-1.413 2.004-1.962 4.856q-.556 2.892.108 4.963q.39 1.216 1.177 1.915q.913.81 2.197.811q2.274 0 4.146-2.325q1.008-1.253 2.694-4.502q.345-.666.66-1.243m-1.166-2.008q-.585 1.01-1.268 2.33q-1.595 3.072-2.477 4.169Q5.82 17.5 4.505 17.5q-1.041 0-1.47-1.337q-.507-1.584-.048-3.974q.466-2.43 1.632-4.081Q5.753 6.5 7.005 6.5q1.57 0 3.005 1.746q.365.444.828 1.176"/>',
    },
    "meteor-fill": {
      body: '<path fill="currentColor" d="M21 1v12A9 9 0 1 1 7.375 5.278L14 1.453v2.77zm-9 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10"/>',
    },
    "meteor-line": {
      body: '<path fill="currentColor" d="M21 1v12A9 9 0 1 1 7.375 5.278L14 1.453v2.77zm-2 3.122l-7 3.224v-2.43L8.597 6.881a7 7 0 0 0-3.592 5.845L5 13a7 7 0 0 0 13.996.24L19 13zM12 8a5 5 0 1 1 0 10a5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6a3 3 0 0 0 0-6"/>',
    },
    "mic-2-fill": {
      body: '<path fill="currentColor" d="M12 1a5 5 0 0 1 5 5v6a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5M2.192 13.962l1.962-.393a8.003 8.003 0 0 0 15.692 0l1.962.392C20.896 18.545 16.852 22 12 22s-8.896-3.455-9.808-8.039"/>',
    },
    "mic-2-line": {
      body: '<path fill="currentColor" d="M12 3a3 3 0 0 0-3 3v6a3 3 0 1 0 6 0V6a3 3 0 0 0-3-3m0-2a5 5 0 0 1 5 5v6a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5M2.192 13.962l1.962-.393a8.003 8.003 0 0 0 15.692 0l1.962.392C20.896 18.545 16.852 22 12 22s-8.896-3.455-9.808-8.039"/>',
    },
    "mic-fill": {
      body: '<path fill="currentColor" d="M12 1a5 5 0 0 1 5 5v4a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5M3.055 11H5.07a7.002 7.002 0 0 0 13.858 0h2.016A9.004 9.004 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11"/>',
    },
    "mic-line": {
      body: '<path fill="currentColor" d="M12 3a3 3 0 0 0-3 3v4a3 3 0 1 0 6 0V6a3 3 0 0 0-3-3m0-2a5 5 0 0 1 5 5v4a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5M3.055 11H5.07a7.002 7.002 0 0 0 13.858 0h2.016A9.004 9.004 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11"/>',
    },
    "mic-off-fill": {
      body: '<path fill="currentColor" d="M16.425 17.839A8.9 8.9 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11h2.016a7.002 7.002 0 0 0 9.87 5.354l-1.55-1.55A5 5 0 0 1 7 10V8.414L1.393 2.808l1.414-1.415l19.799 19.8l-1.415 1.414zm2.95-2.679l-1.443-1.442c.509-.81.856-1.73.997-2.718h2.016a8.95 8.95 0 0 1-1.57 4.16m-2.91-2.909l-8.78-8.78A5 5 0 0 1 17 6v4a4.96 4.96 0 0 1-.533 2.251"/>',
    },
    "mic-off-line": {
      body: '<path fill="currentColor" d="m16.425 17.839l4.767 4.768l1.415-1.415l-19.8-19.799l-1.413 1.415L7 8.414V10a5 5 0 0 0 6.39 4.804l1.55 1.55A7.002 7.002 0 0 1 5.07 11H3.056A9.004 9.004 0 0 0 11 18.945V23h2v-4.055a8.9 8.9 0 0 0 3.425-1.106m-4.872-4.872a3 3 0 0 1-2.52-2.52zm7.822 2.193l-1.443-1.442c.509-.81.856-1.73.997-2.718h2.016a8.95 8.95 0 0 1-1.57 4.16m-2.91-2.909l-1.548-1.548Q15 10.364 15 10V6a3 3 0 0 0-5.818-1.032L7.686 3.471A5 5 0 0 1 17 6v4c0 .81-.192 1.575-.534 2.251"/>',
    },
    "mickey-fill": {
      body: '<path fill="currentColor" d="M18.5 2a4.5 4.5 0 0 1 .883 8.913a8 8 0 1 1-14.765-.001A4.499 4.499 0 0 1 5.5 2a4.5 4.5 0 0 1 4.493 4.254A8 8 0 0 1 12 6a8 8 0 0 1 2.006.254A4.5 4.5 0 0 1 18.5 2"/>',
    },
    "mickey-line": {
      body: '<path fill="currentColor" d="M4.617 10.913A4.501 4.501 0 0 1 5.5 2a4.5 4.5 0 0 1 4.493 4.254A8 8 0 0 1 12 6c.693 0 1.365.088 2.007.254a4.5 4.5 0 1 1 5.376 4.66a8 8 0 1 1-14.766 0M3 6.5a2.5 2.5 0 0 0 2.766 2.486a8 8 0 0 1 2.158-1.871Q7.999 6.819 8 6.5a2.5 2.5 0 0 0-5 0m15.234 2.486q.13.014.266.014a2.5 2.5 0 1 0-2.424-1.885a8 8 0 0 1 2.158 1.871M6 14a6 6 0 1 0 12 0a6 6 0 0 0-12 0"/>',
    },
    "microscope-fill": {
      body: '<path fill="currentColor" d="m13.196 2.268l3.25 5.63a1 1 0 0 1-.366 1.365l-1.3.75l1.001 1.732l-1.732 1l-1-1.733l-1.299.751a1 1 0 0 1-1.366-.366L8.546 8.215a5 5 0 0 0-3.222 6.56A4.97 4.97 0 0 1 8 14c1.684 0 3.174.833 4.08 2.109l7.688-4.439l1 1.733l-7.878 4.548a5 5 0 0 1 .01 2.05L21 20v2l-17 .001A4.98 4.98 0 0 1 3 19c0-1.007.298-1.945.81-2.73a7.003 7.003 0 0 1 3.717-9.82l-.393-.682a2 2 0 0 1 .732-2.732l2.598-1.5a2 2 0 0 1 2.732.732"/>',
    },
    "microscope-line": {
      body: '<path fill="currentColor" d="m13.196 2.268l3.25 5.63a1 1 0 0 1-.366 1.365l-1.3.75l1.001 1.732l-1.732 1l-1-1.733l-1.299.751a1 1 0 0 1-1.366-.366L8.546 8.215a5 5 0 0 0-3.222 6.56A4.97 4.97 0 0 1 8 14c1.684 0 3.174.833 4.08 2.109l7.688-4.439l1 1.733l-7.878 4.548a5 5 0 0 1 .01 2.05L21 20v2l-17 .001A4.98 4.98 0 0 1 3 19c0-1.007.298-1.945.81-2.73a7.003 7.003 0 0 1 3.717-9.82l-.393-.682a2 2 0 0 1 .732-2.732l2.598-1.5a2 2 0 0 1 2.732.732M8 16a3 3 0 0 0-2.83 4h5.66A3 3 0 0 0 8 16m3.464-12.732l-2.598 1.5l2.75 4.763l2.598-1.5z"/>',
    },
    "microsoft-fill": {
      body: '<path fill="currentColor" d="M11.501 3v8.5h-8.5V3zm0 18h-8.5v-8.5h8.5zm1-18h8.5v8.5h-8.5zm8.5 9.5V21h-8.5v-8.5z"/>',
    },
    "microsoft-line": {
      body: '<path fill="currentColor" d="M11.001 5h-6v6h6zm2 0v6h6V5zm6 8h-6v6h6zm-8 6v-6h-6v6zm-8-16h18v18h-18z"/>',
    },
    "microsoft-loop-fill": {
      body: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10H6.665A7.99 7.99 0 0 0 10 15.5h2A3.5 3.5 0 1 0 8.5 12v3.5A6.5 6.5 0 0 1 2 22V12C2 6.477 6.477 2 12 2s10 4.477 10 10"/>',
    },
    "microsoft-loop-line": {
      body: '<path fill="currentColor" d="M12 4a8 8 0 1 1 0 16H7.69a6.5 6.5 0 0 0 1.734-3.5H12A4.5 4.5 0 1 0 7.5 12v3.5A4.5 4.5 0 0 1 4 19.889V12a8 8 0 0 1 8-8m0 18c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12v10zm-2.5-7.5V12a2.5 2.5 0 1 1 2.5 2.5z"/>',
    },
    "mind-map": {
      body: '<path fill="currentColor" d="M18 3a3 3 0 1 1 0 6h-3a3 3 0 0 1-2.829-2H11c-1.1 0-2 .9-2 2v.171a3.001 3.001 0 0 1 0 5.658V15c0 1.1.9 2 2 2h1.17A3 3 0 0 1 15 15h3a3 3 0 1 1 0 6h-3a3 3 0 0 1-2.829-2H11c-2.21 0-4-1.79-4-4H5a3 3 0 1 1 0-6h2a4 4 0 0 1 4-4h1.17A3 3 0 0 1 15 3zm0 14h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2M8 11H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2m10-6h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2"/>',
    },
    "mini-program-fill": {
      body: '<path fill="currentColor" d="m15.84 12.691l-.066.02a1.5 1.5 0 0 1-.414.062c-.61 0-.954-.412-.77-.921c.136-.372.491-.686.925-.831c.672-.245 1.142-.804 1.142-1.455c0-.877-.853-1.587-1.905-1.587s-1.905.71-1.905 1.587v4.868c0 1.17-.678 2.197-1.693 2.778a3.83 3.83 0 0 1-1.904.502c-1.984 0-3.598-1.471-3.598-3.28c0-.576.164-1.117.451-1.587c.444-.73 1.184-1.287 2.07-1.541q.23-.073.46-.073c.612 0 .958.414.773.924c-.126.347-.466.645-.861.803a2 2 0 0 0-.139.052c-.628.26-1.061.798-1.061 1.422c0 .877.853 1.587 1.905 1.587s1.904-.71 1.904-1.587V9.566c0-1.17.679-2.197 1.694-2.778a3.83 3.83 0 0 1 1.904-.502c1.984 0 3.598 1.471 3.598 3.28a3.04 3.04 0 0 1-.451 1.587c-.442.726-1.178 1.282-2.058 1.538M2.002 12c0 5.523 4.477 10 10 10s10-4.477 10-10s-4.477-10-10-10s-10 4.477-10 10"/>',
    },
    "mini-program-line": {
      body: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-6a3.5 3.5 0 1 1-4.977-3.174a1 1 0 1 1 .845 1.813A1.5 1.5 0 1 0 11 14v-4a3.5 3.5 0 1 1 4.977 3.174a1 1 0 0 1-.845-1.813A1.5 1.5 0 1 0 13.001 10z"/>',
    },
    "mist-fill": {
      body: '<path fill="currentColor" d="M4 4h4v2H4zm12 15h4v2h-4zM2 9h10v2H2zm12 0h6v2h-6zM4 14h6v2H4zm8 0h10v2H12zM10 4h12v2H10zM2 19h12v2H2z"/>',
    },
    "mist-line": {
      body: '<path fill="currentColor" d="M4 4h4v2H4zm12 15h4v2h-4zM2 9h5v2H2zm7 0h3v2H9zm5 0h6v2h-6zM4 14h6v2H4zm8 0h3v2h-3zm5 0h5v2h-5zM10 4h12v2H10zM2 19h12v2H2z"/>',
    },
    "mobile-download-fill": {
      body: '<path fill="currentColor" d="M12 6c0-1.537.578-2.938 1.528-4H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9.083Q18.511 12 18 12a6 6 0 0 1-6-6m0 11a1 1 0 1 1 0 2a1 1 0 0 1 0-2M22 6h-3V2h-2v4h-3l4 4z"/>',
    },
    "mobile-download-line": {
      body: '<path fill="currentColor" d="M7 4v16h10v-8h2v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h7v2zm12 2h3l-4 4l-4-4h3V2h2zm-6 12a1 1 0 1 1-2 0a1 1 0 0 1 2 0"/>',
    },
    "money-cny-box-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m10 10v-1h3v-2h-2.586L15.54 7.88l-1.414-1.414l-2.121 2.122l-2.121-2.122L8.469 7.88l2.122 2.122H8.005v2h3v1h-3v2h3v2h2v-2h3v-2z"/>',
    },
    "money-cny-box-line": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m1 2v14h16v-14zm9 8h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586L8.469 7.88l1.415-1.414l2.12 2.122l2.122-2.122L15.54 7.88l-2.12 2.122h2.585v2h-3z"/>',
    },
    "money-cny-circle-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m1-9v-1h3v-2h-2.586L15.54 7.88l-1.414-1.414l-2.121 2.122l-2.121-2.122L8.469 7.88l2.122 2.122H8.005v2h3v1h-3v2h3v2h2v-2h3v-2z"/>',
    },
    "money-cny-circle-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-7h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586L8.469 7.88l1.415-1.414l2.12 2.122l2.122-2.122L15.54 7.88l-2.12 2.122h2.585v2h-3z"/>',
    },
    "money-dollar-box-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m5.5 11v2h2.5v2h2v-2h1a2.5 2.5 0 1 0 0-5h-4a.5.5 0 1 1 0-1h5.5v-2h-2.5v-2h-2v2h-1a2.5 2.5 0 1 0 0 5h4a.5.5 0 0 1 0 1z"/>',
    },
    "money-dollar-box-line": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m1 2v14h16v-14zm4.5 9h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1v-2h2v2h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5z"/>',
    },
    "money-dollar-circle-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-3.5-8v2h2.5v2h2v-2h1a2.5 2.5 0 1 0 0-5h-4a.5.5 0 1 1 0-1h5.5v-2h-2.5v-2h-2v2h-1a2.5 2.5 0 1 0 0 5h4a.5.5 0 0 1 0 1z"/>',
    },
    "money-dollar-circle-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3.5-6h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1v-2h2v2h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5z"/>',
    },
    "money-euro-box-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m7.05 8a2.5 2.5 0 0 1 4.064-1.41l1.7-1.133a4.5 4.5 0 0 0-7.787 2.543H7.005v2h1.027a4.5 4.5 0 0 0 7.788 2.543l-1.701-1.134a2.5 2.5 0 0 1-4.064-1.41h4.95v-2z"/>',
    },
    "money-euro-box-line": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m1 2v14h16v-14zm6.05 6h4.95v2h-4.95a2.5 2.5 0 0 0 4.064 1.409l1.7 1.134a4.5 4.5 0 0 1-7.787-2.543H7.005v-2h1.027A4.5 4.5 0 0 1 15.82 8.46l-1.701 1.134a2.5 2.5 0 0 0-4.064 1.41"/>',
    },
    "money-euro-circle-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-1.95-11a2.5 2.5 0 0 1 4.064-1.41l1.7-1.133a4.5 4.5 0 0 0-7.787 2.543H7.005v2h1.027a4.5 4.5 0 0 0 7.788 2.543l-1.701-1.134a2.5 2.5 0 0 1-4.064-1.41h4.95v-2z"/>',
    },
    "money-euro-circle-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1.95-9h4.95v2h-4.95a2.5 2.5 0 0 0 4.064 1.409l1.7 1.134a4.5 4.5 0 0 1-7.787-2.543H7.005v-2h1.027A4.5 4.5 0 0 1 15.82 8.46l-1.701 1.134a2.5 2.5 0 0 0-4.064 1.41"/>',
    },
    "money-pound-box-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m6 10v2h-1v2h8v-2h-5v-2h3v-2h-3v-1a1.5 1.5 0 0 1 2.76-.815l1.986-.497a3.501 3.501 0 0 0-6.746 1.312v1h-1v2z"/>',
    },
    "money-pound-box-line": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m1 2v14h16v-14zm5 8h-1v-2h1v-1A3.5 3.5 0 0 1 15.75 8.69l-1.987.497a1.499 1.499 0 0 0-2.76.815v1h3v2h-3v2h5v2h-8v-2h1z"/>',
    },
    "money-pound-circle-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-3-9v2h-1v2h8v-2h-5v-2h3v-2h-3v-1a1.5 1.5 0 0 1 2.76-.815l1.986-.497a3.501 3.501 0 0 0-6.746 1.312v1h-1v2z"/>',
    },
    "money-pound-circle-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3-7h-1v-2h1v-1A3.5 3.5 0 0 1 15.75 8.69l-1.987.497a1.499 1.499 0 0 0-2.76.815v1h3v2h-3v2h5v2h-8v-2h1z"/>',
    },
    "money-rupee-circle-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m1.5-14c.328.436.563.946.675 1.5H16V11h-1.825a3.75 3.75 0 0 1-3.675 3h-.19l3.72 3.72l-1.06 1.06L8 13.81V12.5h2.5a2.25 2.25 0 0 0 2.122-1.5H8V9.5h4.622A2.25 2.25 0 0 0 10.5 8H8V6.5h8V8z"/>',
    },
    "money-rupee-circle-line": {
      body: '<path fill="currentColor" d="M20 12a8 8 0 1 0-16 0a8 8 0 0 0 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-8.5-4c.328.436.563.946.675 1.5H16V11h-1.825a3.75 3.75 0 0 1-3.675 3h-.19l3.72 3.72l-1.06 1.06L8 13.81V12.5h2.5a2.25 2.25 0 0 0 2.122-1.5H8V9.5h4.622A2.25 2.25 0 0 0 10.5 8H8V6.5h8V8z"/>',
    },
    "moon-clear-fill": {
      body: '<path fill="currentColor" d="M9.822 2.238a9 9 0 0 0 11.94 11.94C20.768 18.654 16.775 22 12 22C6.477 22 2 17.523 2 12c0-4.775 3.346-8.768 7.822-9.762m8.342.053L19 2.5v1l-.836.209a2 2 0 0 0-1.455 1.455L16.5 6h-1l-.209-.836a2 2 0 0 0-1.455-1.455L13 3.5v-1l.836-.209A2 2 0 0 0 15.29.836L15.5 0h1l.209.836a2 2 0 0 0 1.455 1.455m5 5L24 7.5v1l-.836.209a2 2 0 0 0-1.455 1.455L21.5 11h-1l-.209-.836a2 2 0 0 0-1.455-1.455L18 8.5v-1l.836-.209a2 2 0 0 0 1.455-1.455L20.5 5h1l.209.836a2 2 0 0 0 1.455 1.455"/>',
    },
    "moon-clear-line": {
      body: '<path fill="currentColor" d="M10 6a8 8 0 0 0 11.955 6.956C21.474 18.03 17.2 22 12 22C6.477 22 2 17.523 2 12c0-5.2 3.97-9.474 9.044-9.955A7.96 7.96 0 0 0 10 6m-6 6a8 8 0 0 0 8 8a8 8 0 0 0 6.957-4.045Q18.482 16 18 16C12.477 16 8 11.523 8 6q0-.481.045-.957A8 8 0 0 0 4 12m14.164-9.709L19 2.5v1l-.836.209a2 2 0 0 0-1.455 1.455L16.5 6h-1l-.209-.836a2 2 0 0 0-1.455-1.455L13 3.5v-1l.836-.209A2 2 0 0 0 15.29.836L15.5 0h1l.209.836a2 2 0 0 0 1.455 1.455m5 5L24 7.5v1l-.836.209a2 2 0 0 0-1.455 1.455L21.5 11h-1l-.209-.836a2 2 0 0 0-1.455-1.455L18 8.5v-1l.836-.209a2 2 0 0 0 1.455-1.455L20.5 5h1l.209.836a2 2 0 0 0 1.455 1.455"/>',
    },
    "moon-cloudy-fill": {
      body: '<path fill="currentColor" d="M8.67 5.007a7 7 0 0 1 7.55-3.901a4.5 4.5 0 0 0 5.674 5.674a7.04 7.04 0 0 1-.759 4.593A5.5 5.5 0 0 1 17.5 21H9a8 8 0 0 1-.33-15.993m2.177.207a8.02 8.02 0 0 1 5.61 4.885a5.53 5.53 0 0 1 2.96.245a5 5 0 0 0 .488-1.37a6.5 6.5 0 0 1-5.878-5.88a5 5 0 0 0-3.18 2.12"/>',
    },
    "moon-cloudy-line": {
      body: '<path fill="currentColor" d="M8.67 5.007a7 7 0 0 1 7.55-3.901a4.5 4.5 0 0 0 5.674 5.674a7.04 7.04 0 0 1-.759 4.593A5.5 5.5 0 0 1 17.5 21H9a8 8 0 0 1-.33-15.993m2.177.207a8.02 8.02 0 0 1 5.61 4.885a5.53 5.53 0 0 1 2.96.245a5 5 0 0 0 .488-1.37a6.5 6.5 0 0 1-5.878-5.88a5 5 0 0 0-3.18 2.12M17.5 19a3.5 3.5 0 1 0-2.5-5.95V13a6 6 0 1 0-6 6z"/>',
    },
    "moon-fill": {
      body: '<path fill="currentColor" d="M11.38 2.019a7.5 7.5 0 1 0 10.6 10.6C21.662 17.854 17.316 22 12.001 22C6.477 22 2 17.523 2 12c0-5.315 4.146-9.661 9.38-9.981"/>',
    },
    "moon-foggy-fill": {
      body: '<path fill="currentColor" d="M16 20.335V18h-2v-4H3.332A9.5 9.5 0 0 1 3 11.5c0-4.56 3.213-8.37 7.5-9.289a8 8 0 0 0 11.49 9.724a9.5 9.5 0 0 1-5.99 8.4M7 20h7v2H7zm-5-4h10v2H2z"/>',
    },
    "moon-foggy-line": {
      body: '<path fill="currentColor" d="M16 20.335v-2.2a7.52 7.52 0 0 0 3.623-4.281a9 9 0 0 1-10.622-8.99A7.52 7.52 0 0 0 5.151 10H3.117a9.505 9.505 0 0 1 8.538-7.963a7 7 0 0 0 10.316 8.728q.027.364.028.735c0 4.01-2.485 7.44-6 8.834M7 20h7v2H7zm-3-8h6v2H4zm-2 4h10v2H2z"/>',
    },
    "moon-line": {
      body: '<path fill="currentColor" d="M10 7a7 7 0 0 0 12 4.9v.1c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2h.1A6.98 6.98 0 0 0 10 7m-6 5a8 8 0 0 0 15.062 3.762A9 9 0 0 1 8.238 4.938A8 8 0 0 0 4 12"/>',
    },
    "more-2-fill": {
      body: '<path fill="currentColor" d="M12 3c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m0 14c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m0-7c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2"/>',
    },
    "more-2-line": {
      body: '<path fill="currentColor" d="M12 3c-.825 0-1.5.675-1.5 1.5S11.175 6 12 6s1.5-.675 1.5-1.5S12.825 3 12 3m0 15c-.825 0-1.5.675-1.5 1.5S11.175 21 12 21s1.5-.675 1.5-1.5S12.825 18 12 18m0-7.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5s1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5"/>',
    },
    "more-fill": {
      body: '<path fill="currentColor" d="M5 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m14 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-7 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2"/>',
    },
    "more-line": {
      body: '<path fill="currentColor" d="M4.5 10.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S6 12.825 6 12s-.675-1.5-1.5-1.5m15 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S21 12.825 21 12s-.675-1.5-1.5-1.5m-7.5 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5s1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5"/>',
    },
    "motorbike-fill": {
      body: '<path fill="currentColor" d="M8.365 10L11.2 8h3.492L13.6 5H11V3h4l1.092 3H20v3h-2.816l1.456 4.002a4.5 4.5 0 1 1-1.985.392L15.419 10h-.947l-1.582 5.87l-2.925 1.069q.035.276.035.561a4.5 4.5 0 1 1-6-4.244V12H2v-2zM5.5 20a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m13 0a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"/>',
    },
    "motorbike-line": {
      body: '<path fill="currentColor" d="M4 13.256V12H2v-2h6.365L11.2 8h3.492L13.6 5H11V3h4l1.092 3H20v3h-2.816l1.456 4.002a4.5 4.5 0 1 1-1.985.392L15.419 10h-.947l-1.582 5.87l-.002-.001l.002.005l-2.925 1.065q.035.276.035.561a4.5 4.5 0 1 1-6-4.244m2-.229a4.5 4.5 0 0 1 3.281 2.033l1.957-.713L12.403 10h-.547L9 12H6zM5.5 20a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m13 0a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"/>',
    },
    "mouse-fill": {
      body: '<path fill="currentColor" d="M11.141 2h1.718c2.014 0 3.094.278 4.071.801A5.45 5.45 0 0 1 19.2 5.07c.522.978.801 2.058.801 4.072v5.718c0 2.014-.279 3.094-.801 4.071a5.45 5.45 0 0 1-2.27 2.269c-.977.522-2.057.801-4.071.801H11.14c-2.014 0-3.094-.279-4.072-.801A5.45 5.45 0 0 1 4.8 18.931c-.522-.977-.8-2.057-.8-4.071V9.14c0-2.014.278-3.094.801-4.072A5.45 5.45 0 0 1 7.07 2.801C8.047 2.278 9.127 2 11.141 2M11 6v5h2V6z"/>',
    },
    "mouse-line": {
      body: '<path fill="currentColor" d="M11.141 4c-1.582 0-2.387.169-3.128.565a3.45 3.45 0 0 0-1.448 1.448C6.169 6.753 6 7.559 6 9.14v5.718c0 1.582.169 2.387.565 3.128q.504.944 1.448 1.448c.74.396 1.546.565 3.128.565h1.718c1.582 0 2.387-.169 3.128-.565a3.45 3.45 0 0 0 1.448-1.448c.396-.74.565-1.546.565-3.128V9.14c0-1.582-.169-2.387-.565-3.128a3.45 3.45 0 0 0-1.448-1.448C15.247 4.169 14.441 4 12.86 4zm0-2h1.718c2.014 0 3.094.278 4.071.801A5.45 5.45 0 0 1 19.2 5.07c.522.978.801 2.058.801 4.072v5.718c0 2.014-.279 3.094-.801 4.071a5.45 5.45 0 0 1-2.27 2.269c-.977.522-2.057.801-4.071.801H11.14c-2.014 0-3.094-.279-4.072-.801A5.45 5.45 0 0 1 4.8 18.931c-.522-.977-.8-2.057-.8-4.071V9.14c0-2.014.278-3.094.801-4.072A5.45 5.45 0 0 1 7.07 2.801C8.047 2.278 9.127 2 11.141 2M11 6h2v5h-2z"/>',
    },
    "movie-2-fill": {
      body: '<path fill="currentColor" d="M18.001 20H20v2h-8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a9.99 9.99 0 0 1-3.999 8M12 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-4 4a2 2 0 1 0 0-4a2 2 0 0 0 0 4m8 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-4 4a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "movie-2-line": {
      body: '<path fill="currentColor" d="M12 20h8v2h-8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a9.96 9.96 0 0 1-2 6h-2.708A8 8 0 1 0 12 20m0-10a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-4 4a2 2 0 1 1 0-4a2 2 0 0 1 0 4m8 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-4 4a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "movie-fill": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zm8.622 4.422a.4.4 0 0 0-.622.332v6.506a.4.4 0 0 0 .622.332l4.879-3.252a.4.4 0 0 0 0-.666z"/>',
    },
    "movie-line": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM4 5v14h16V5zm6.622 3.415l4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332"/>',
    },
    "music-2-fill": {
      body: '<path fill="currentColor" d="M20 3v14a4 4 0 1 1-2-3.465V6H9v11a4 4 0 1 1-2-3.465V3z"/>',
    },
    "music-2-line": {
      body: '<path fill="currentColor" d="M20 3v14a4 4 0 1 1-2-3.465V5H9v12a4 4 0 1 1-2-3.465V3zM5 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4m11 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "music-fill": {
      body: '<path fill="currentColor" d="M12 13.535V3h8v3h-6v11a4 4 0 1 1-2-3.465"/>',
    },
    "music-line": {
      body: '<path fill="currentColor" d="M12 13.535V3h8v2h-6v12a4 4 0 1 1-2-3.465M10 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "mv-fill": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zm10 8.178A3 3 0 1 0 14 15V7.999h3V6h-5z"/>',
    },
    "mv-line": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM4 5v14h16V5zm8 7.17V6h5v2h-3v7a3 3 0 1 1-2-2.83"/>',
    },
    "navigation-fill": {
      body: '<path fill="currentColor" d="m2.9 2.3l18.805 6.268a.5.5 0 0 1 .028.939L13 13l-4.425 8.85a.5.5 0 0 1-.928-.086L2.261 2.912a.5.5 0 0 1 .638-.612"/>',
    },
    "navigation-line": {
      body: '<path fill="currentColor" d="m4.965 5.096l3.546 12.41l3.04-6.08l5.637-2.255zM2.899 2.3l18.806 6.268a.5.5 0 0 1 .028.939L13 13l-4.425 8.85a.5.5 0 0 1-.928-.086L2.261 2.91a.5.5 0 0 1 .638-.611"/>',
    },
    "netease-cloud-music-fill": {
      body: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-1.086-10.432c.24-.84 1.075-1.541 1.99-1.648c.187.694.388 1.373.545 2.063c.053.23.037.495-.018.727c-.213.892-1.248 1.242-1.978.685c-.53-.405-.742-1.12-.539-1.827m3.817-.197c-.125-.465-.256-.927-.393-1.42c.5.13.907.36 1.255.697c1.257 1.222 1.385 3.3.294 4.732c-1.135 1.49-3.155 2.134-5.028 1.605c-2.302-.65-3.808-2.952-3.441-5.316c.274-1.768 1.27-3.004 2.9-3.733c.407-.182.58-.56.42-.93c-.157-.364-.54-.504-.944-.343c-2.721 1.088-4.32 4.134-3.67 6.987c.713 3.118 3.495 5.163 6.675 4.859c1.732-.166 3.164-.948 4.216-2.347c1.506-2.002 1.297-4.783-.463-6.499c-.666-.65-1.471-1.018-2.39-1.153c-.083-.013-.217-.052-.232-.106c-.087-.313-.18-.632-.206-.954c-.029-.357.29-.64.65-.645c.253-.003.434.13.603.3c.303.3.704.322.988.062c.29-.264.296-.678.018-1.008c-.566-.672-1.586-.891-2.43-.523c-.847.37-1.321 1.187-1.2 2.093c.038.28.11.557.167.842l-.26.072a3.86 3.86 0 0 0-2.098 1.414c-.921 1.22-.936 2.828-.041 3.947c1.274 1.594 3.747 1.284 4.523-.568c.284-.677.275-1.368.087-2.065"/>',
    },
    "netease-cloud-music-line": {
      body: '<path fill="currentColor" d="M10.422 11.375c-.294 1.028.012 2.065.784 2.653c1.061.81 2.565.3 2.874-.995c.08-.337.103-.722.027-1.056c-.23-1.001-.521-1.988-.792-2.996c-1.33.154-2.543 1.172-2.893 2.394m5.548-.287c.273 1.012.285 2.017-.127 3c-1.128 2.69-4.722 3.14-6.573.826c-1.302-1.627-1.28-3.961.06-5.734c.78-1.032 1.804-1.707 3.048-2.054l.379-.104c-.084-.415-.188-.816-.243-1.224c-.176-1.317.512-2.503 1.744-3.04c1.226-.535 2.708-.216 3.53.76c.406.479.395 1.08-.025 1.464c-.412.377-.997.346-1.435-.09c-.247-.246-.51-.44-.877-.436c-.525.006-.987.418-.945.937c.037.468.172.93.3 1.386c.022.078.216.135.338.153c1.333.197 2.504.731 3.472 1.676c2.558 2.493 2.861 6.531.672 9.44c-1.529 2.032-3.61 3.169-6.127 3.409c-4.621.44-8.664-2.53-9.7-7.058C2.516 10.255 4.84 5.831 8.796 4.25c.586-.234 1.143-.031 1.371.498c.232.537-.019 1.086-.61 1.35c-2.368 1.06-3.817 2.855-4.215 5.424c-.533 3.433 1.656 6.776 5 7.72c2.723.77 5.658-.166 7.308-2.33c1.586-2.08 1.4-5.099-.427-6.873A4 4 0 0 0 15.4 9.026c.198.716.389 1.388.57 2.062"/>',
    },
    "netflix-fill": {
      body: '<path fill="currentColor" d="m11.292 3.814l2.018 5.707l.396 1.116l.007-4.81l.01-4.818h4.27L18 11.871c.003 5.98-.003 10.89-.015 10.9s-.209 0-.436-.027a49 49 0 0 0-3.34-.282a15 15 0 0 1-.636-.038c-.003-.003-.273-.762-.776-2.184v-.004l-2.144-6.061l-.34-.954l-.008 4.586c-.006 4.365-.01 4.61-.057 4.61c-.163 0-1.57.09-2.04.136c-.308.027-.926.09-1.37.145c-.446.051-.816.085-.823.078S6 17.867 6 11.883V1.002h.005V1h4.288l.028.08c.007.016.065.176.157.437l.641 1.778l.173.496z"/>',
    },
    "netflix-line": {
      body: '<path fill="currentColor" d="M15.985 17.208L16.001 2h2v20a7.6 7.6 0 0 0-2.02-.5L8 6.302V21.5a7.3 7.3 0 0 0-2 .5V2h2z"/>',
    },
    "news-fill": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm3 4h6v6H6zm2 2v2h2V9zm10 0h-4V7h4zm-4 4v-2h4v2zm-8 4v-2h12v2z"/>',
    },
    "news-line": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 1v14h16V5zm2 2h6v6H6zm2 2v2h2V9zm6 0h4V7h-4zm4 4h-4v-2h4zM6 15v2h12v-2z"/>',
    },
    "newspaper-fill": {
      body: '<path fill="currentColor" d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7h4v9a3 3 0 0 1-3 3m-1-10v7a1 1 0 1 0 2 0v-7zM5 6v6h6V6zm0 7v2h10v-2zm0 3v2h10v-2zm2-8h2v2H7z"/>',
    },
    "newspaper-line": {
      body: '<path fill="currentColor" d="M16 20V4H4v15a1 1 0 0 0 1 1zm3 2H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7h4v9a3 3 0 0 1-3 3m-1-10v7a1 1 0 1 0 2 0v-7zM6 6h6v6H6zm2 2v2h2V8zm-2 5h8v2H6zm0 3h8v2H6z"/>',
    },
    "nextjs-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m4-14h-1.35v4H16zM9.346 9.71l6.059 7.828l1.054-.809L9.683 8H8v7.997h1.346z"/>',
    },
    "nextjs-line": {
      body: '<path fill="currentColor" d="M17.664 17.65L10.26 8H8v8h2v-5.054l6.087 7.933a8 8 0 1 1 1.578-1.23M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m2-10V8h2v4z"/>',
    },
    "nft-fill": {
      body: '<path fill="currentColor" d="M9 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m3-11l9.5 5.5v11L12 23l-9.5-5.5v-11zM4.5 7.653v8.694l2.372 1.373l8.073-5.92l4.555 2.734v-6.88L12 3.31z"/>',
    },
    "nft-line": {
      body: '<path fill="currentColor" d="M9 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m12.5-5.5L12 1L2.5 6.5v11L12 23l9.5-5.5zM12 3.311l7.5 4.342v6.88l-4.562-2.736l-7.971 5.978L4.5 16.347V7.653zm0 17.378l-3.152-1.825l6.214-4.66l3.998 2.398z"/>',
    },
    "node-tree": {
      body: '<path fill="currentColor" d="M10 2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8v2h5V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1H8v6h5v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1H7a1 1 0 0 1-1-1V8H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm9 16h-4v2h4zm0-8h-4v2h4zM9 4H5v2h4z"/>',
    },
    "nodejs-fill": {
      body: '<path fill="currentColor" d="M11.174 22.555c.256.139.531.218.826.218s.59-.08.826-.178l7.848-4.572c.511-.297.826-.851.826-1.445V7.454c0-.593-.315-1.148-.826-1.444l-7.848-4.572a1.75 1.75 0 0 0-1.652 0L3.326 6.01A1.67 1.67 0 0 0 2.5 7.454v9.124c0 .594.315 1.148.826 1.445l2.065 1.188c1.003.494 1.358.494 1.81.494c1.475 0 2.32-.91 2.32-2.474V8.226a.24.24 0 0 0-.235-.237H8.283a.24.24 0 0 0-.236.237v9.005c0 .693-.728 1.386-1.889.792l-2.143-1.247c-.08-.04-.118-.138-.118-.218V7.435c0-.08.039-.179.118-.218l7.848-4.552c.058-.04.157-.04.235 0l7.849 4.552c.078.04.118.119.118.218v9.123c0 .1-.04.178-.118.218l-7.849 4.572c-.059.04-.157.04-.236 0L9.857 20.14c-.059-.04-.138-.06-.197-.02c-.55.317-.649.356-1.18.534c-.118.04-.314.119.079.337zm-.885-8.985c0 1.346.708 2.929 4.15 2.929c2.478 0 3.914-.99 3.914-2.731c0-1.702-1.141-2.158-3.56-2.474c-2.44-.317-2.695-.495-2.695-1.069c0-.475.217-1.108 2.026-1.108c1.613 0 2.222.356 2.459 1.444a.23.23 0 0 0 .216.179h1.042c.06 0 .118-.04.158-.08a.3.3 0 0 0 .059-.178c-.157-1.9-1.396-2.77-3.914-2.77c-2.242 0-3.58.95-3.58 2.553c0 1.721 1.338 2.196 3.481 2.414c2.577.258 2.774.634 2.774 1.148c0 .89-.708 1.267-2.36 1.267c-2.085 0-2.538-.515-2.695-1.564c0-.118-.098-.198-.216-.198h-1.023a.24.24 0 0 0-.236.238"/>',
    },
    "nodejs-line": {
      body: '<path fill="currentColor" d="M12.887 1.362a1.75 1.75 0 0 0-1.774 0L3.363 5.92A1.75 1.75 0 0 0 2.5 7.429v9.142c0 .62.328 1.194.863 1.508l2.623 1.543C7.319 20.408 9 19.446 9 17.9V7.747H7v10.152l-2.5-1.471V7.572L12 3.16l7.5 4.412v8.856L12 20.84l-1.768-1.04l-1.014 1.723l1.895 1.115a1.75 1.75 0 0 0 1.774 0l7.75-4.559a1.75 1.75 0 0 0 .863-1.508V7.429a1.75 1.75 0 0 0-.863-1.508zM14 7.5c-1.363 0-2.329.351-2.95.97a2.5 2.5 0 0 0-.737 1.761c0 .555.157 1.058.482 1.474c.313.4.725.649 1.12.81c.72.297 1.62.394 2.344.471l.087.01c.831.09 1.454.167 1.88.345c.193.08.272.154.305.197c.021.028.062.09.062.26c0 .264-.09.434-.373.595c-.347.197-.96.347-1.883.347c-.915 0-1.553-.17-1.918-.422c-.283-.196-.492-.497-.437-1.15l-1.993-.167c-.108 1.289.359 2.316 1.292 2.962c.851.59 1.97.777 3.056.777c1.077 0 2.092-.165 2.873-.61c.846-.48 1.383-1.282 1.383-2.332c0-.557-.155-1.061-.477-1.48c-.31-.404-.722-.656-1.118-.822c-.728-.305-1.64-.403-2.368-.481l-.07-.008c-.833-.09-1.456-.165-1.885-.341c-.194-.08-.273-.152-.303-.192c-.02-.024-.059-.08-.059-.243c0-.077.023-.219.15-.345c.122-.122.499-.386 1.537-.386c.99 0 1.567.105 1.897.3c.215.128.448.363.48 1.133l1.998-.08c-.05-1.246-.506-2.208-1.458-2.772C16.08 7.583 15.01 7.5 14 7.5"/>',
    },
    "notification-2-fill": {
      body: '<path fill="currentColor" d="M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1zM9.5 21h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notification-2-line": {
      body: '<path fill="currentColor" d="M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1zM5 18h14v-6.969C19 7.148 15.866 4 12 4s-7 3.148-7 7.031zm4.5 3h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notification-3-fill": {
      body: '<path fill="currentColor" d="M20 17h2v2H2v-2h2v-7a8 8 0 1 1 16 0zM9 21h6v2H9z"/>',
    },
    "notification-3-line": {
      body: '<path fill="currentColor" d="M20 17h2v2H2v-2h2v-7a8 8 0 1 1 16 0zm-2 0v-7a6 6 0 0 0-12 0v7zm-9 4h6v2H9z"/>',
    },
    "notification-4-fill": {
      body: '<path fill="currentColor" d="m20 18.667l.4.533a.5.5 0 0 1-.4.8H4a.5.5 0 0 1-.4-.8l.4-.533V10a8 8 0 1 1 16 0zM9.5 21h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notification-4-line": {
      body: '<path fill="currentColor" d="M18 10a6 6 0 0 0-12 0v8h12zm2 8.667l.4.533a.5.5 0 0 1-.4.8H4a.5.5 0 0 1-.4-.8l.4-.533V10a8 8 0 1 1 16 0zM9.5 21h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notification-badge-fill": {
      body: '<path fill="currentColor" d="M13.341 4A6 6 0 0 0 21 11.659V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM19 10a4 4 0 1 1 0-8a4 4 0 0 1 0 8"/>',
    },
    "notification-badge-line": {
      body: '<path fill="currentColor" d="M13.341 4A6 6 0 0 0 13 6H5v14h14v-8a6 6 0 0 0 2-.341V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM19 8a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8"/>',
    },
    "notification-fill": {
      body: '<path fill="currentColor" d="M12 2c4.97 0 9 4.043 9 9.031V20H3v-8.969C3 6.043 7.03 2 12 2M9.5 21h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notification-line": {
      body: '<path fill="currentColor" d="M5 18h14v-6.969C19 7.148 15.866 4 12 4s-7 3.148-7 7.031zm7-16c4.97 0 9 4.043 9 9.031V20H3v-8.969C3 6.043 7.03 2 12 2M9.5 21h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notification-off-fill": {
      body: '<path fill="currentColor" d="M18.586 20H4a.5.5 0 0 1-.4-.8l.4-.533V10c0-1.33.325-2.584.899-3.687L1.394 2.808l1.414-1.415l19.799 19.8l-1.415 1.414zM20 15.786L7.56 3.345A8 8 0 0 1 20 10zM9.5 21h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notification-off-line": {
      body: '<path fill="currentColor" d="M18.586 20H4a.5.5 0 0 1-.4-.8l.4-.533V10c0-1.33.325-2.584.899-3.687L1.394 2.808l1.414-1.415l19.799 19.8l-1.415 1.414zM6.408 7.822A6 6 0 0 0 6 10v8h10.586zM20 15.786l-2-2V10a6 6 0 0 0-8.99-5.203L7.56 3.345A8 8 0 0 1 20 10zM9.5 21h5a2.5 2.5 0 0 1-5 0"/>',
    },
    "notion-fill": {
      body: '<path fill="currentColor" d="M6.104 5.91c.584.474.802.438 1.898.365l10.332-.62c.22 0 .037-.22-.036-.256l-1.716-1.24c-.329-.255-.767-.548-1.606-.475l-10.005.73c-.364.036-.437.219-.292.365zm.62 2.408v10.87c0 .585.292.803.95.767l11.354-.657c.657-.036.73-.438.73-.913V7.588c0-.474-.182-.73-.584-.693l-11.866.693c-.438.036-.584.255-.584.73m11.21.583c.072.328 0 .657-.33.694l-.547.109v8.025c-.475.256-.913.401-1.278.401c-.584 0-.73-.182-1.168-.729l-3.579-5.618v5.436l1.133.255s0 .656-.914.656l-2.519.146c-.073-.146 0-.51.256-.583l.657-.182v-7.187l-.913-.073c-.073-.329.11-.803.621-.84l2.702-.182l3.724 5.692V9.886l-.95-.109c-.072-.402.22-.693.585-.73zM4.131 3.429l10.406-.766c1.277-.11 1.606-.036 2.41.547l3.321 2.335c.548.401.731.51.731.948v12.805c0 .803-.292 1.277-1.314 1.35l-12.085.73c-.767.036-1.132-.073-1.534-.584L3.62 17.62c-.438-.584-.62-1.021-.62-1.533V4.705c0-.656.292-1.203 1.132-1.276"/>',
    },
    "notion-line": {
      body: '<path fill="currentColor" d="M16.285 2.955a1.9 1.9 0 0 0-1.211-.31l-11.06.961a.99.99 0 0 0-.903.986v11.575c0 .408.133.806.378 1.133l2.767 3.69a.99.99 0 0 0 .867.392l12.853-.989a.99.99 0 0 0 .913-.986V6.527a.94.94 0 0 0-.418-.781zm-1.057 1.46a.1.1 0 0 1 .071.02l2.746 1.83l-10.207.816l-1.86-1.86zm3.883 14.262l-10.722.825V8.82l10.722-.858zM4.89 6.646l1.722 1.722V18.5l-1.7-2.267a.1.1 0 0 1-.022-.066zm7.09 3.477l-1.977.13v7.562l1.996-.13v-4.337l3.512 4.169l1.976-.13V9.825l-1.996.13v4.337z"/>',
    },
    "npmjs-fill": {
      body: '<path fill="currentColor" d="M20.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-3 4h-10v10h5V9.5h2.5V17h2.5z"/>',
    },
    "npmjs-line": {
      body: '<path fill="currentColor" d="M20.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2h-14v14h14zm-2 2v10h-2.5V9.5h-2.5V17h-5V7z"/>',
    },
    "number-0": {
      body: '<path fill="currentColor" d="M12 1.5c1.321 0 2.484.348 3.447.994c.963.645 1.726 1.588 2.249 2.778c.522 1.19.804 2.625.804 4.257v4.942c0 1.632-.282 3.068-.804 4.257c-.523 1.19-1.286 2.133-2.25 2.778c-.962.646-2.125.994-3.446.994s-2.484-.348-3.447-.994c-.963-.645-1.726-1.588-2.249-2.778c-.522-1.19-.804-2.625-.804-4.257V9.529c0-1.632.282-3.068.804-4.257c.523-1.19 1.286-2.133 2.25-2.778C9.515 1.848 10.678 1.5 12 1.5m0 2c-.916 0-1.694.226-2.333.655c-.637.427-1.158 1.07-1.532 1.92c-.412.94-.635 2.108-.635 3.454v4.942c0 1.346.223 2.514.635 3.453c.374.852.895 1.494 1.532 1.921c.639.428 1.417.655 2.333.655s1.694-.227 2.333-.655c.637-.427 1.158-1.07 1.531-1.92c.413-.94.636-2.108.636-3.454V9.529c0-1.346-.223-2.514-.636-3.453c-.373-.851-.894-1.494-1.53-1.921c-.64-.429-1.418-.655-2.334-.655"/>',
    },
    "number-1": {
      body: '<path fill="currentColor" d="M14 1.5V22h-2V3.704L7.5 4.91V2.839l5-1.339z"/>',
    },
    "number-2": {
      body: '<path fill="currentColor" d="M16 7.5a4 4 0 1 0-8 0H6a6 6 0 1 1 10.663 3.776l-7.319 8.723L18 20v2H6v-1.127l9.064-10.802A3.98 3.98 0 0 0 16 7.5"/>',
    },
    "number-3": {
      body: '<path fill="currentColor" d="M18 2v1.362L12.81 9.55a6.501 6.501 0 1 1-7.116 8.028l1.94-.486A4.502 4.502 0 0 0 16.5 16a4.5 4.5 0 0 0-6.505-4.03l-.228.122l-.69-1.207L14.855 4H6.5V2z"/>',
    },
    "number-4": {
      body: '<path fill="currentColor" d="M16 1.5V16h3v2h-3v4h-2v-4H4v-1.102L14 1.5zM14 16V5.171L6.968 16z"/>',
    },
    "number-5": {
      body: '<path fill="currentColor" d="M18 2v2H9.3l-.677 6.445a6.5 6.5 0 1 1-2.93 7.133l1.94-.486A4.502 4.502 0 0 0 16.5 16a4.5 4.5 0 0 0-4.5-4.5c-2.022 0-3.278.639-3.96 1.53l-1.575-1.182L7.5 2z"/>',
    },
    "number-6": {
      body: '<path fill="currentColor" d="m14.886 2l-4.438 7.686A6.5 6.5 0 1 1 6.4 12.7L12.576 2zM12 11.5a4.5 4.5 0 1 0 0 9a4.5 4.5 0 0 0 0-9"/>',
    },
    "number-7": {
      body: '<path fill="currentColor" d="M19 2v1.5L10.763 22H8.574l8.013-18H6V2z"/>',
    },
    "number-8": {
      body: '<path fill="currentColor" d="M12 1.5a5.5 5.5 0 0 1 3.352 9.86c1.888 1.05 3.148 2.96 3.148 5.14c0 3.314-2.91 6-6.5 6s-6.5-2.686-6.5-6c0-2.181 1.261-4.09 3.147-5.141A5.5 5.5 0 0 1 12 1.5m0 11c-2.52 0-4.5 1.828-4.5 4s1.98 4 4.5 4s4.5-1.828 4.5-4s-1.98-4-4.5-4m0-9a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7"/>',
    },
    "number-9": {
      body: '<path fill="currentColor" d="M12 1.5a6.5 6.5 0 0 1 5.619 9.77l-6.196 10.729H9.114l4.439-7.686A6.5 6.5 0 1 1 12 1.5m0 2a4.5 4.5 0 1 0 0 9a4.5 4.5 0 0 0 0-9"/>',
    },
    "numbers-fill": {
      body: '<path fill="currentColor" d="M9 18H4v-8h5zm6 0h-5V6h5zm6 0h-5V2h5zm1 4H3v-2h19z"/>',
    },
    "numbers-line": {
      body: '<path fill="currentColor" d="M9 18H4v-8h5zm-2-2v-4H6v4zm6 0V8h-1v8zm2 2h-5V6h5zm4-2V4h-1v12zm2 2h-5V2h5zm1 4H3v-2h19z"/>',
    },
    "nurse-fill": {
      body: '<path fill="currentColor" d="M14.957 15.564A8.01 8.01 0 0 1 19.94 22H4.063a8.01 8.01 0 0 1 4.981-6.436L12.001 20zM18.001 2v6A6 6 0 0 1 6 8V2zm-2 6H8a4 4 0 0 0 8 0"/>',
    },
    "nurse-line": {
      body: '<path fill="currentColor" d="M12 15a8 8 0 0 1 7.939 7H4.063A8 8 0 0 1 12 15m-1.812 2.28A6.02 6.02 0 0 0 6.802 20h5.199zm3.626 0L12.001 20h5.198a6.02 6.02 0 0 0-3.385-2.72M18.001 2v6A6 6 0 0 1 6 8V2zM8 8a4 4 0 0 0 8 0zm8-4H8v2h8z"/>',
    },
    "octagon-fill": {
      body: '<path fill="currentColor" d="m15.936 2.501l5.565 5.565v7.87l-5.565 5.565h-7.87l-5.565-5.565v-7.87l5.565-5.565z"/>',
    },
    "octagon-line": {
      body: '<path fill="currentColor" d="m15.936 2.501l5.565 5.565v7.87l-5.565 5.565h-7.87l-5.565-5.565v-7.87l5.565-5.565zm-.828 2H8.894L4.501 8.894v6.214L8.894 19.5h6.214l4.393-4.393V8.894z"/>',
    },
    "oil-fill": {
      body: '<path fill="currentColor" d="M8 5h11a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V11zm5-4h5a1 1 0 0 1 1 1v2h-7V2a1 1 0 0 1 1-1M6 12v7h2v-7z"/>',
    },
    "oil-line": {
      body: '<path fill="currentColor" d="M9.07 7L6 11.606V20h12V7zM8 5h11a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V11zm5-4h5a1 1 0 0 1 1 1v2h-7V2a1 1 0 0 1 1-1M8 12h2v6H8z"/>',
    },
    omega: {
      body: '<path fill="currentColor" d="M14 20v-2.157c1.863-1.192 3.5-3.875 3.5-6.959c0-3.073-2-6.029-5.5-6.029s-5.5 2.956-5.5 6.03c0 3.083 1.637 5.766 3.5 6.958V20H3v-2h4.76C5.666 16.505 4 13.989 4 10.884C4 6.247 7.5 3 12 3s8 3.247 8 7.884c0 3.105-1.666 5.621-3.76 7.116H21v2z"/>',
    },
    "open-arm-fill": {
      body: '<path fill="currentColor" d="M12 12a5 5 0 1 1 0-10a5 5 0 0 1 0 10m6 5v5h-2v-5a11 11 0 0 1 6.448-10.016l.827 1.82A9 9 0 0 0 18 17M8 17v5H6v-5A9 9 0 0 0 .726 8.805l.827-1.821A11 11 0 0 1 8 17"/>',
    },
    "open-arm-line": {
      body: '<path fill="currentColor" d="M18 17v5h-2v-5a11 11 0 0 1 6.448-10.016l.827 1.82A9 9 0 0 0 18 17M8 17v5H6v-5A9 9 0 0 0 .726 8.805l.827-1.821A11 11 0 0 1 8 17m4-5a5 5 0 1 1 0-10a5 5 0 0 1 0 10m0-2a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "open-source-fill": {
      body: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10c0 4.13-2.504 7.676-6.077 9.201l-2.518-6.55A3 3 0 0 0 12 9a3 3 0 0 0-1.404 5.652l-2.518 6.55A10 10 0 0 1 2 12C2 6.477 6.477 2 12 2"/>',
    },
    "open-source-line": {
      body: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10c0 4.4-2.841 8.136-6.789 9.473l-.226.074l-2.904-7.55A2.016 2.016 0 0 0 14.001 12a2 2 0 1 0-2.083 1.998l-2.903 7.549l-.225-.074C4.842 20.136 2 16.4 2 12C2 6.477 6.477 2 12 2m0 2a8 8 0 0 0-4.099 14.872l1.48-3.849a4 4 0 1 1 5.239 0l1.479 3.85A8 8 0 0 0 12 4"/>',
    },
    "openai-fill": {
      body: '<path fill="currentColor" d="M20.562 10.188c.25-.688.313-1.376.25-2.063c-.062-.687-.312-1.375-.625-2c-.562-.937-1.375-1.687-2.312-2.125c-1-.437-2.063-.562-3.125-.312c-.5-.5-1.063-.938-1.688-1.25S11.687 2 11 2a5.17 5.17 0 0 0-3 .938c-.875.624-1.5 1.5-1.813 2.5c-.75.187-1.375.5-2 .875c-.562.437-1 1-1.375 1.562c-.562.938-.75 2-.625 3.063a5.44 5.44 0 0 0 1.25 2.874a4.7 4.7 0 0 0-.25 2.063c.063.688.313 1.375.625 2c.563.938 1.375 1.688 2.313 2.125c1 .438 2.062.563 3.125.313c.5.5 1.062.937 1.687 1.25S12.312 22 13 22a5.17 5.17 0 0 0 3-.937c.875-.625 1.5-1.5 1.812-2.5a4.54 4.54 0 0 0 1.938-.875c.562-.438 1.062-.938 1.375-1.563c.562-.937.75-2 .625-3.062c-.125-1.063-.5-2.063-1.188-2.876m-7.5 10.5c-1 0-1.75-.313-2.437-.875c0 0 .062-.063.125-.063l4-2.312a.5.5 0 0 0 .25-.25a.57.57 0 0 0 .062-.313V11.25l1.688 1v4.625a3.685 3.685 0 0 1-3.688 3.813M5 17.25c-.438-.75-.625-1.625-.438-2.5c0 0 .063.063.125.063l4 2.312a.56.56 0 0 0 .313.063c.125 0 .25 0 .312-.063l4.875-2.812v1.937l-4.062 2.375A3.7 3.7 0 0 1 7.312 19c-1-.25-1.812-.875-2.312-1.75M3.937 8.563a3.8 3.8 0 0 1 1.938-1.626v4.751c0 .124 0 .25.062.312a.5.5 0 0 0 .25.25l4.875 2.813l-1.687 1l-4-2.313a3.7 3.7 0 0 1-1.75-2.25c-.25-.937-.188-2.062.312-2.937M17.75 11.75l-4.875-2.812l1.687-1l4 2.312c.625.375 1.125.875 1.438 1.5s.5 1.313.437 2.063a3.7 3.7 0 0 1-.75 1.937c-.437.563-1 1-1.687 1.25v-4.75c0-.125 0-.25-.063-.312c0 0-.062-.126-.187-.188m1.687-2.5s-.062-.062-.125-.062l-4-2.313c-.125-.062-.187-.062-.312-.062s-.25 0-.313.062L9.812 9.688V7.75l4.063-2.375c.625-.375 1.312-.5 2.062-.5c.688 0 1.375.25 2 .688c.563.437 1.063 1 1.313 1.625s.312 1.375.187 2.062m-10.5 3.5l-1.687-1V7.063c0-.688.187-1.438.562-2C8.187 4.438 8.75 4 9.375 3.688a3.37 3.37 0 0 1 2.062-.313c.688.063 1.375.375 1.938.813c0 0-.063.062-.125.062l-4 2.313a.5.5 0 0 0-.25.25c-.063.125-.063.187-.063.312zm.875-2L12 9.5l2.187 1.25v2.5L12 14.5l-2.188-1.25z"/>',
    },
    "openai-line": {
      body: '<path fill="currentColor" d="M11 4c.649 0 1.25.206 1.741.556c-1.292.673-2.48 1.52-3.741 2.248l1 1.732c1.575-.91 3.052-2.05 4.76-2.706a3 3 0 0 1 4.057 3.09C17.588 8.137 16.26 7.531 15 6.804l-1 1.732c1.575.91 3.302 1.618 4.723 2.77a3 3 0 0 1-.648 5.058C18.14 14.908 18 13.455 18 12h-2c0 1.818.25 3.669-.037 5.476a3 3 0 0 1-4.705 1.967c1.293-.673 2.482-1.52 3.742-2.247l-1-1.732c-1.575.91-3.052 2.05-4.76 2.706a3 3 0 0 1-4.057-3.09c1.23.782 2.557 1.388 3.817 2.116l1-1.732c-1.575-.91-3.302-1.618-4.724-2.77a3 3 0 0 1 .649-5.058C5.86 9.092 6 10.545 6 12h2c0-1.818-.25-3.669.037-5.476A3 3 0 0 1 11 4m3.793-.258a5.001 5.001 0 0 0-8.548 1.71a5.001 5.001 0 0 0-2.793 8.258a5.001 5.001 0 0 0 5.756 6.548a5.001 5.001 0 0 0 8.548-1.71a5.001 5.001 0 0 0 2.793-8.258a5.001 5.001 0 0 0-5.756-6.548"/>',
    },
    "openbase-fill": {
      body: '<path fill="currentColor" d="m12 2.76l10 3.236l-.9 9.468l-9.1 6.86l-9.1-6.864L2.01 6zm0 .825l-8.81 2.85L12 20.793l8.806-14.358z"/>',
    },
    "openbase-line": {
      body: '<path fill="currentColor" d="M12 3L2 5.996l1 9.464l9 7.04l9-7.04l1-9.464zm7.837 4.436L12 19.96L4.163 7.436L12 5.088z"/>',
    },
    "opera-fill": {
      body: '<path fill="currentColor" d="M8.71 6.365c-1.107 1.305-1.822 3.236-1.872 5.4v.47c.051 2.165.765 4.093 1.872 5.4c1.434 1.862 3.566 3.044 5.95 3.044a7.2 7.2 0 0 0 4.005-1.226a9.94 9.94 0 0 1-7.139 2.535A10 10 0 0 1 2.001 12c0-5.524 4.477-10 10-10h.038a9.97 9.97 0 0 1 6.627 2.546a7.24 7.24 0 0 0-4.008-1.226c-2.382 0-4.514 1.183-5.95 3.045zM22.001 12a9.97 9.97 0 0 1-3.335 7.454c-2.565 1.25-4.955.376-5.747-.17c2.52-.554 4.423-3.6 4.423-7.284c0-3.685-1.903-6.73-4.423-7.283c.791-.545 3.182-1.42 5.747-.171A9.97 9.97 0 0 1 22.001 12"/>',
    },
    "opera-line": {
      body: '<path fill="currentColor" d="M14.767 19.51a8.003 8.003 0 0 0 0-15.02C16.712 5.977 18 8.935 18 12s-1.289 6.024-3.235 7.51M9.235 4.49a8.003 8.003 0 0 0 0 15.02C7.29 18.023 6.001 15.065 6.001 12S7.29 5.976 9.235 4.49M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-3.5c2 0 4-3.033 4-6.5s-2-6.5-4-6.5s-4 3.033-4 6.5s2 6.5 4 6.5"/>',
    },
    "order-play-fill": {
      body: '<path fill="currentColor" d="M17 4V2.068a.5.5 0 0 1 .82-.385l4.12 3.433a.5.5 0 0 1-.321.884H2V4zM2 18h20v2H2zm0-7h20v2H2z"/>',
    },
    "order-play-line": {
      body: '<path fill="currentColor" d="M17 4V2.068a.5.5 0 0 1 .82-.385l4.12 3.433a.5.5 0 0 1-.321.884H2V4zM2 18h20v2H2zm0-7h20v2H2z"/>',
    },
    "organization-chart": {
      body: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v2h4a1 1 0 0 1 1 1v3h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-2H8v2h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-3a1 1 0 0 1 1-1h4V9H9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM9 17H5v2h4zm10 0h-4v2h4zM14 5h-4v2h4z"/>',
    },
    "outlet-2-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M11 7v4h2V7zm3 5v4h2v-4zm-6 0v4h2v-4z"/>',
    },
    "outlet-2-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M11 7h2v4h-2zm3 5h2v4h-2zm-6 0h2v4H8z"/>',
    },
    "outlet-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m2-12v4h2v-4zm-6 0v4h2v-4z"/>',
    },
    "outlet-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m2-10h2v4h-2zm-6 0h2v4H8z"/>',
    },
    overline: {
      body: '<path fill="currentColor" d="M15.246 18H8.754l-1.6 4H5l6-15h2l6 15h-2.154zm-.8-2L12 9.885L9.554 16zM4 3h16v2H4z"/>',
    },
    "p2p-fill": {
      body: '<path fill="currentColor" d="M20 5a3 3 0 1 1-6 0a3 3 0 0 1 6 0M7 3a4 4 0 0 0-4 4v2h2V7a2 2 0 0 1 2-2h3V3zm10 18a4 4 0 0 0 4-4v-2h-2v2a2 2 0 0 1-2 2h-3v2zM7 16a3 3 0 1 0 0-6a3 3 0 0 0 0 6m10-7a4 4 0 0 0-4 4h8a4 4 0 0 0-4-4M3 21a4 4 0 0 1 8 0z"/>',
    },
    "p2p-line": {
      body: '<path fill="currentColor" d="M17 6a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0 2a3 3 0 1 0 0-6a3 3 0 0 0 0 6M7 3a4 4 0 0 0-4 4v2h2V7a2 2 0 0 1 2-2h3V3zm10 18a4 4 0 0 0 4-4v-2h-2v2a2 2 0 0 1-2 2h-3v2zm-9-8a1 1 0 1 0-2 0a1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0m7-2a2 2 0 0 0-2 2h-2a4 4 0 0 1 8 0h-2a2 2 0 0 0-2-2M5 21a2 2 0 1 1 4 0h2a4 4 0 0 0-8 0z"/>',
    },
    "page-separator": {
      body: '<path fill="currentColor" d="M17 21v-4H7v4H5v-5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5zM7 3v4h10V3h2v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3zM2 9l4 3l-4 3zm20 0v6l-4-3z"/>',
    },
    "pages-fill": {
      body: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V8h18v13a1 1 0 0 1-1 1m1-16H3V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zM7 11v4h4v-4zm0 6v2h10v-2zm6-5v2h4v-2z"/>',
    },
    "pages-line": {
      body: '<path fill="currentColor" d="M5 8v12h14V8zm0-2h14V4H5zm15 16H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M7 10h4v4H7zm0 6h10v2H7zm6-5h4v2h-4z"/>',
    },
    "paint-brush-fill": {
      body: '<path fill="currentColor" d="M4 2.997h16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1m2 9h6a1 1 0 0 1 1 1v3h1v6h-4v-6h1v-2H5a1 1 0 0 1-1-1v-2h2zm11.732 1.732L19.5 11.96l1.768 1.768a2.5 2.5 0 1 1-3.536 0"/>',
    },
    "paint-brush-line": {
      body: '<path fill="currentColor" d="M5 4.997v3h14v-3zm-1-2h16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1m2 9h6a1 1 0 0 1 1 1v3h1v6h-4v-6h1v-2H5a1 1 0 0 1-1-1v-2h2zm11.732 1.732L19.5 11.96l1.768 1.768a2.5 2.5 0 1 1-3.536 0"/>',
    },
    "paint-fill": {
      body: '<path fill="currentColor" d="m19.228 18.732l1.767-1.767l1.768 1.767a2.5 2.5 0 1 1-3.535 0M8.878 1.08l11.314 11.313a1 1 0 0 1 0 1.415l-8.485 8.485a1 1 0 0 1-1.414 0l-8.485-8.485a1 1 0 0 1 0-1.415l7.778-7.778l-2.122-2.121zM11 6.03L3.929 13.1H18.07z"/>',
    },
    "paint-line": {
      body: '<path fill="currentColor" d="m19.228 18.732l1.767-1.767l1.768 1.767a2.5 2.5 0 1 1-3.535 0M8.878 1.08l11.314 11.313a1 1 0 0 1 0 1.415l-8.485 8.485a1 1 0 0 1-1.414 0l-8.485-8.485a1 1 0 0 1 0-1.415l7.778-7.778l-2.122-2.121zM11 6.03L3.929 13.1l7.07 7.072l7.072-7.071z"/>',
    },
    "palette-fill": {
      body: '<path fill="currentColor" d="M12 2c5.522 0 10 3.978 10 8.889a5.56 5.56 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667c0 .422.167.811.422 1.1c.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22C6.478 22 2 17.522 2 12S6.478 2 12 2M7.5 12a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m9 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M12 9a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "palette-line": {
      body: '<path fill="currentColor" d="M12 2c5.522 0 10 3.978 10 8.889a5.56 5.56 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667c0 .422.167.811.422 1.1c.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22C6.478 22 2 17.522 2 12S6.478 2 12 2m-1.189 16.111a3.664 3.664 0 0 1 3.667-3.667h1.966A3.56 3.56 0 0 0 20 10.89C20 7.139 16.468 4 12 4a8 8 0 0 0-.676 15.972a3.65 3.65 0 0 1-.513-1.86M7.5 12a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3M12 9a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "pantone-fill": {
      body: '<path fill="currentColor" d="m4 18.922l-1.35-.545a1 1 0 0 1-.552-1.302L4 12.367zM8.86 21H7a1 1 0 0 1-1-1v-6.078zM6.022 5.968l9.272-3.746a1 1 0 0 1 1.302.552l5.619 13.908a1 1 0 0 1-.553 1.302L12.39 21.73a1 1 0 0 1-1.302-.553L5.47 7.27a1 1 0 0 1 .553-1.302M9 9a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "pantone-line": {
      body: '<path fill="currentColor" d="m5.765 8l-.296-.73a1 1 0 0 1 .553-1.302l9.272-3.746a1 1 0 0 1 1.302.552l5.619 13.908a1 1 0 0 1-.553 1.302L12.39 21.73a1 1 0 0 1-1.302-.553L11 20.96V21H7a1 1 0 0 1-1-1v-.27l-3.35-1.353a1 1 0 0 1-.552-1.302zM8 19h2.209L8 13.533zm-2-6.244l-1.673 4.141L6 17.608zm1.698-5.309l4.87 12.054l7.418-2.997l-4.87-12.053zm2.979 2.033a1 1 0 1 1-.75-1.855a1 1 0 0 1 .75 1.855"/>',
    },
    paragraph: {
      body: '<path fill="currentColor" d="M12 6v15h-2v-5a6 6 0 0 1 0-12h10v2h-3v15h-2V6zm-2 0a4 4 0 1 0 0 8z"/>',
    },
    "parent-fill": {
      body: '<path fill="currentColor" d="M7 11a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m10.5 4a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0 1a4.5 4.5 0 0 1 4.5 4.5v.5h-9v-.5a4.5 4.5 0 0 1 4.5-4.5M7 12a5 5 0 0 1 5 5v4H2v-4a5 5 0 0 1 5-5"/>',
    },
    "parent-line": {
      body: '<path fill="currentColor" d="M7 9a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m0 2a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m10.5 2a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8m2.5 6v-.5a2.5 2.5 0 0 0-5 0v.5h-2v-.5a4.5 4.5 0 1 1 9 0v.5zm-10 0v-4a3 3 0 1 0-6 0v4H2v-4a5 5 0 0 1 10 0v4z"/>',
    },
    "parentheses-fill": {
      body: '<path fill="currentColor" d="M6.923 21C5.113 18.664 4 15.493 4 12s1.113-6.664 2.923-9h2.014C7.235 5.388 6.2 8.542 6.2 12s1.035 6.612 2.737 9zm10.151 0H15.06c1.702-2.388 2.737-5.542 2.737-9s-1.035-6.612-2.737-9h2.014c1.81 2.336 2.923 5.507 2.923 9s-1.112 6.664-2.923 9"/>',
    },
    "parentheses-line": {
      body: '<path fill="currentColor" d="M6.923 21C5.113 18.664 4 15.493 4 12s1.113-6.664 2.923-9h2.014C7.235 5.388 6.2 8.542 6.2 12s1.035 6.612 2.737 9zm10.151 0H15.06c1.702-2.388 2.737-5.542 2.737-9s-1.035-6.612-2.737-9h2.014c1.81 2.336 2.923 5.507 2.923 9s-1.112 6.664-2.923 9"/>',
    },
    "parking-box-fill": {
      body: '<path fill="currentColor" d="M11 14h1.5a3.5 3.5 0 1 0 0-7H9v10h2zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m7 6h1.5a1.5 1.5 0 0 1 0 3H11z"/>',
    },
    "parking-box-line": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5zm4 2h3.5a3.5 3.5 0 1 1 0 7H11v3H9zm2 2v3h1.5a1.5 1.5 0 0 0 0-3z"/>',
    },
    "parking-fill": {
      body: '<path fill="currentColor" d="M6 3h7a6 6 0 0 1 0 12h-3v6H6zm4 4v4h3a2 2 0 1 0 0-4z"/>',
    },
    "parking-line": {
      body: '<path fill="currentColor" d="M6 3h7a6 6 0 0 1 0 12H8v6H6zm2 2v8h5a4 4 0 0 0 0-8z"/>',
    },
    "pass-expired-fill": {
      body: '<path fill="currentColor" d="M9 10a1 1 0 1 1-2 0a1 1 0 0 1 2 0M2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm9 6a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-5.473 7.025l-1.414-1.414A5.5 5.5 0 0 1 8.003 14c1.518 0 2.894.617 3.888 1.61l-1.414 1.415A3.5 3.5 0 0 0 8.002 16c-.967 0-1.84.39-2.475 1.025M16 10.585l1.793-1.792l1.414 1.414L17.414 12l1.793 1.793l-1.414 1.414L16 13.414l-1.793 1.793l-1.414-1.414L14.586 12l-1.793-1.793l1.414-1.414z"/>',
    },
    "pass-expired-line": {
      body: '<path fill="currentColor" d="M3 18h18V6H3zM1 5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm8 5a1 1 0 1 0-2 0a1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-2.998 6c-.967 0-1.84.39-2.475 1.025l-1.414-1.414A5.5 5.5 0 0 1 8.002 14a5.5 5.5 0 0 1 3.889 1.61l-1.414 1.415A3.5 3.5 0 0 0 8.002 16m9.79-7.207L16 10.586l-1.793-1.793l-1.414 1.414L14.586 12l-1.793 1.793l1.414 1.414L16 13.414l1.793 1.793l1.414-1.414L17.414 12l1.793-1.793z"/>',
    },
    "pass-pending-fill": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm7 6a1 1 0 1 0-2 0a1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-5.473 7.025l-1.414-1.414A5.5 5.5 0 0 1 8.003 14c1.518 0 2.894.617 3.888 1.61l-1.414 1.415A3.5 3.5 0 0 0 8.002 16c-.967 0-1.84.39-2.475 1.025M13 15V9h2v6zm4 0V9h2v6z"/>',
    },
    "pass-pending-line": {
      body: '<path fill="currentColor" d="M3 18h18V6H3zM1 5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm8 5a1 1 0 1 0-2 0a1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-2.998 6c-.967 0-1.84.39-2.475 1.025l-1.414-1.414A5.5 5.5 0 0 1 8.002 14a5.5 5.5 0 0 1 3.889 1.61l-1.414 1.415A3.5 3.5 0 0 0 8.002 16M13 9v6h2V9zm4 0v6h2V9z"/>',
    },
    "pass-valid-fill": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm7 6a1 1 0 1 0-2 0a1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-5.473 7.025l-1.414-1.414A5.5 5.5 0 0 1 8.003 14c1.518 0 2.894.617 3.888 1.61l-1.414 1.415A3.5 3.5 0 0 0 8.002 16c-.967 0-1.84.39-2.475 1.025m14.68-6.318l-4 4l-.707.707l-.707-.707l-2.5-2.5l1.414-1.414l1.793 1.793l3.293-3.293z"/>',
    },
    "pass-valid-line": {
      body: '<path fill="currentColor" d="M3 18h18V6H3zM1 5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm8 5a1 1 0 1 0-2 0a1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-2.998 6c-.967 0-1.84.39-2.475 1.025l-1.414-1.414A5.5 5.5 0 0 1 8.002 14a5.5 5.5 0 0 1 3.889 1.61l-1.414 1.415A3.5 3.5 0 0 0 8.002 16m8.205-1.293l4-4l-1.414-1.414l-3.293 3.293l-1.793-1.793l-1.414 1.414l2.5 2.5l.707.707z"/>',
    },
    "passport-fill": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-4 14H8v2h8zM12 6a4 4 0 1 0 0 8a4 4 0 0 0 0-8m0 2a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "passport-line": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-1 2H5v16h14zm-3 12v2H8v-2zM12 6a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "patreon-fill": {
      body: '<path fill="currentColor" d="M15.001 17a7.5 7.5 0 1 1 0-15a7.5 7.5 0 0 1 0 15m-13-15h4v20h-4z"/>',
    },
    "patreon-line": {
      body: '<path fill="currentColor" d="M15.001 17a7.5 7.5 0 1 1 0-15a7.5 7.5 0 0 1 0 15m0-2a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11m-13-13h5v20h-5zm2 2v16h1V4z"/>',
    },
    "pause-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M9 9v6h2V9zm4 0v6h2V9z"/>',
    },
    "pause-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M9 9h2v6H9zm4 0h2v6h-2z"/>',
    },
    "pause-fill": {
      body: '<path fill="currentColor" d="M6 5h2v14H6zm10 0h2v14h-2z"/>',
    },
    "pause-large-fill": {
      body: '<path fill="currentColor" d="M6 3h2v18H6zm10 0h2v18h-2z"/>',
    },
    "pause-large-line": {
      body: '<path fill="currentColor" d="M6 3h2v18H6zm10 0h2v18h-2z"/>',
    },
    "pause-line": {
      body: '<path fill="currentColor" d="M6 5h2v14H6zm10 0h2v14h-2z"/>',
    },
    "pause-mini-fill": {
      body: '<path fill="currentColor" d="M15 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0zM7 7a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0z"/>',
    },
    "pause-mini-line": {
      body: '<path fill="currentColor" d="M15 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0zM7 7a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0z"/>',
    },
    "paypal-fill": {
      body: '<path fill="currentColor" d="M20.067 8.478c.492.88.557 2.014.3 3.327c-.74 3.806-3.275 5.12-6.513 5.12h-.5a.805.805 0 0 0-.794.68l-.041.22l-.63 3.993l-.032.17a.804.804 0 0 1-.794.679H7.72a.483.483 0 0 1-.477-.558L7.418 21h1.519l.949-6.02h1.386c4.678 0 7.749-2.203 8.795-6.502m-2.96-5.09c.762.868.984 1.81.753 3.285c-.02.123-.04.24-.063.36c-.735 3.773-3.088 5.446-6.955 5.446H8.957c-.63 0-1.173.414-1.353 1.002l-.015-.002l-.93 5.894H3.123a.05.05 0 0 1-.051-.06L5.67 2.803A.95.95 0 0 1 6.608 2h5.975c2.183 0 3.717.469 4.524 1.388"/>',
    },
    "paypal-line": {
      body: '<path fill="currentColor" d="M8.496 20.667h1.551l.538-3.376a2.805 2.805 0 0 1 2.77-2.366h.5c2.677 0 4.06-.983 4.55-3.503c.208-1.066.117-1.73-.171-2.102c-1.207 3.054-3.79 4.16-6.962 4.16h-.884c-.384 0-.793.209-.852.58zm-4.944-.294a.55.55 0 0 1-.544-.637l2.674-16.96A.92.92 0 0 1 6.59 2h6.424c2.213 0 3.942.467 4.9 1.558c.869.99 1.122 2.084.87 3.692q.542.285.916.706c.819.933.979 2.26.669 3.85c-.741 3.805-3.276 5.12-6.514 5.12h-.5a.805.805 0 0 0-.795.679l-.702 4.383a.804.804 0 0 1-.794.679H6.72a.483.483 0 0 1-.477-.558l.274-1.736zm6.836-8.894h.885c3.189 0 4.894-1.212 5.482-4.229q.03-.15.054-.309c.166-1.06.05-1.553-.399-2.063c-.465-.53-1.603-.878-3.396-.878h-5.5L5.247 18.373h1.561l.73-4.628l.008.001a2.915 2.915 0 0 1 2.842-2.267"/>',
    },
    "pen-nib-fill": {
      body: '<path fill="currentColor" d="m4.929 21.482l5.846-5.846a2 2 0 1 0-1.414-1.414l-5.846 5.846l-1.06-1.06c2.828-3.3 3.888-6.954 5.302-13.082l6.364-.708l5.657 5.657l-.707 6.364c-6.128 1.415-9.782 2.475-13.081 5.304zM16.596 2.037l6.347 6.346a.5.5 0 0 1-.277.848l-1.474.23l-5.656-5.657l.212-1.485a.5.5 0 0 1 .848-.282"/>',
    },
    "pen-nib-line": {
      body: '<path fill="currentColor" d="m16.596 1.037l6.347 6.346a.5.5 0 0 1-.277.848l-1.474.23l-5.656-5.657l.212-1.485a.5.5 0 0 1 .848-.282M4.595 20.147c3.722-3.33 7.995-4.327 12.643-5.52l.446-4.017l-4.297-4.298l-4.018.447c-1.192 4.648-2.189 8.92-5.52 12.643l-1.395-1.395c2.829-3.3 3.89-6.953 5.303-13.081l6.364-.708l5.657 5.657l-.707 6.364c-6.128 1.415-9.782 2.475-13.081 5.304zm5.284-6.029a2 2 0 1 1 2.828-2.828a2 2 0 0 1-2.828 2.828"/>',
    },
    "pencil-fill": {
      body: '<path fill="currentColor" d="m12.9 6.855l4.242 4.242l-9.9 9.9H3v-4.243zm1.414-1.415l2.121-2.121a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.415l-2.122 2.121z"/>',
    },
    "pencil-line": {
      body: '<path fill="currentColor" d="m15.728 9.576l-1.414-1.414L5 17.476v1.414h1.414zm1.414-1.414l1.414-1.414l-1.414-1.414l-1.414 1.414zm-9.9 12.728H3v-4.243L16.435 3.212a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414z"/>',
    },
    "pencil-ruler-2-fill": {
      body: '<path fill="currentColor" d="m5.636 12.707l1.829 1.829l1.414-1.415l-1.829-1.828l1.415-1.414l1.828 1.828l1.414-1.414L9.88 8.464l1.414-1.414l1.828 1.829l1.415-1.415l-1.829-1.828l2.829-2.828a1 1 0 0 1 1.414 0l4.243 4.242a1 1 0 0 1 0 1.414L8.465 21.192a1 1 0 0 1-1.415 0L2.808 16.95a1 1 0 0 1 0-1.414zm8.485 5.656l4.243-4.242L21 16.756V21h-4.242zM5.636 9.878L2.808 7.05a1 1 0 0 1 0-1.415l2.828-2.828a1 1 0 0 1 1.414 0l2.83 2.828z"/>',
    },
    "pencil-ruler-2-line": {
      body: '<path fill="currentColor" d="m7.05 14.121l-2.12 2.122l2.828 2.828L19.071 7.757L16.243 4.93L14.12 7.05l1.415 1.414L14.12 9.88l-1.414-1.415l-1.414 1.415l1.414 1.414l-1.414 1.414l-1.414-1.414l-1.414 1.414l1.414 1.414l-1.414 1.415zm9.9-11.313l4.243 4.242a1 1 0 0 1 0 1.414L8.465 21.192a1 1 0 0 1-1.415 0L2.808 16.95a1 1 0 0 1 0-1.414L15.536 2.808a1 1 0 0 1 1.414 0m-2.83 15.555l1.415-1.414l2.242 2.243h1.414v-1.414l-2.242-2.243l1.414-1.414L21 16.756V21h-4.242zM5.636 9.878L2.808 7.05a1 1 0 0 1 0-1.415l2.828-2.828a1 1 0 0 1 1.414 0l2.83 2.828L8.464 7.05l-2.12-2.122l-1.415 1.415l2.121 2.12z"/>',
    },
    "pencil-ruler-fill": {
      body: '<path fill="currentColor" d="M5 18v2h4v-2zM3 7l4-5l4 5v15H3zm18 1h-2v2h2v2h-3v2h3v2h-2v2h2v3a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>',
    },
    "pencil-ruler-line": {
      body: '<path fill="currentColor" d="M5 8v12h4V8zM3 7l4-5l4 5v15H3zm16 9v-2h-3v-2h3v-2h-2V8h2V6h-4v14h4v-2h-2v-2zM14 4h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"/>',
    },
    "pentagon-fill": {
      body: '<path fill="currentColor" d="m12 .7l10.747 7.808l-4.105 12.634H5.358L1.253 8.508z"/>',
    },
    "pentagon-line": {
      body: '<path fill="currentColor" d="m12 3.03l8.53 6.198l-3.258 10.028H6.729L3.47 9.228zm10.747 5.478L12 .7L1.253 8.508l4.105 12.634h13.284z"/>',
    },
    "percent-fill": {
      body: '<path fill="currentColor" d="M17.505 21.003a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m-11-11a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m12.571-6.486l1.414 1.415L4.934 20.488L3.52 19.074z"/>',
    },
    "percent-line": {
      body: '<path fill="currentColor" d="M17.505 21.003a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-11-9a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m12.571-4.486l1.414 1.415L4.934 20.488L3.52 19.074z"/>',
    },
    "phone-camera-fill": {
      body: '<path fill="currentColor" d="M14.803 4A6 6 0 0 0 23 12.197V19a.996.996 0 0 1-1.003 1.001H2.002A1 1 0 0 1 1 19V5c0-.552.44-1 1.002-1zM20 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-1 6v3h2v-3z"/>',
    },
    "phone-camera-line": {
      body: '<path fill="currentColor" d="M14.803 4a6 6 0 0 0-.72 2H3v12h18v-5.083a6 6 0 0 0 2-.72V19a.996.996 0 0 1-1.003 1.001H2.002A1 1 0 0 1 1 19V5c0-.552.44-1 1.002-1zM20 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8m-2 2h2v3h-2z"/>',
    },
    "phone-fill": {
      body: '<path fill="currentColor" d="M21 16.42v3.536a1 1 0 0 1-.93.998Q19.415 21 19 21C10.163 21 3 13.837 3 5q0-.414.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45q.034.344.064.552A13.9 13.9 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.05 13.05 0 0 0 6.844 6.844l1.54-2.154a.46.46 0 0 1 .573-.149a13.9 13.9 0 0 0 4 1.205q.208.03.55.064a.5.5 0 0 1 .449.498"/>',
    },
    "phone-find-fill": {
      body: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v8.529A6 6 0 0 0 9 16c0 3.238 2.76 6 6 6H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-3 10a4 4 0 0 1 3.446 6.032l2.21 2.21l-1.413 1.415l-2.211-2.21A4 4 0 1 1 15 12m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "phone-find-line": {
      body: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v8h-2V4H7v16h4v2H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-3 10a4 4 0 0 1 3.446 6.032l2.21 2.21l-1.413 1.415l-2.212-2.21A4 4 0 1 1 15 12m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "phone-line": {
      body: '<path fill="currentColor" d="M9.366 10.682a10.56 10.56 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296a11.4 11.4 0 0 0 4.583 1.364a1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995Q19.307 21 18.5 21C9.94 21 3 14.06 3 5.5q0-.807.082-1.602A1 1 0 0 1 4.077 3h4.462a1 1 0 0 1 .997.921A11.4 11.4 0 0 0 10.9 8.504a1 1 0 0 1-.296 1.294zm-2.522-.657l1.9-1.357A13.4 13.4 0 0 1 7.647 5H5.01Q5 5.25 5 5.5C5 12.956 11.044 19 18.5 19q.25 0 .5-.01v-2.637a13.4 13.4 0 0 1-3.668-1.097l-1.357 1.9a12.5 12.5 0 0 1-1.588-.75l-.058-.033a12.56 12.56 0 0 1-4.702-4.702l-.033-.058a12.4 12.4 0 0 1-.75-1.588"/>',
    },
    "phone-lock-fill": {
      body: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1l.001 7.1A5 5 0 0 0 13.1 14H12v8H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 10a3 3 0 0 1 3 3v1h1v5a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5h1v-1a3 3 0 0 1 3-3m0 2c-.513 0-1 .45-1 1v1h2v-1a1 1 0 0 0-1-1"/>',
    },
    "phone-lock-line": {
      body: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v7h-2V4H7v16h5v2H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 10a3 3 0 0 1 3 3v1h1v5a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5h1v-1a3 3 0 0 1 3-3m2 6h-4v2h4zm-2-4c-.508 0-1 .45-1 1v1h2v-1a1 1 0 0 0-1-1"/>',
    },
    "picture-in-picture-2-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zM6.707 6.293l2.25 2.25L11 6.5V12H5.5l2.043-2.043l-2.25-2.25z"/>',
    },
    "picture-in-picture-2-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm-1 2h-6v4h6zM6.707 6.293l2.25 2.25L11 6.5V12H5.5l2.043-2.043l-2.25-2.25z"/>',
    },
    "picture-in-picture-exit-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm-9.5-6L9.457 9.043l2.25 2.25l-1.414 1.414l-2.25-2.25L6 12.5V7z"/>',
    },
    "picture-in-picture-exit-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm-1 2h-6v4h6zm-8.5-8L9.457 9.043l2.25 2.25l-1.414 1.414l-2.25-2.25L6 12.5V7z"/>',
    },
    "picture-in-picture-fill": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z"/>',
    },
    "picture-in-picture-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm-1 2h-6v4h6z"/>',
    },
    "pie-chart-2-fill": {
      body: '<path fill="currentColor" d="M11 2.05V13h10.95c-.501 5.053-4.765 9-9.95 9c-5.523 0-10-4.477-10-10c0-5.185 3.947-9.449 9-9.95m2-1.507C18.554 1.02 22.979 5.447 23.457 11H13z"/>',
    },
    "pie-chart-2-line": {
      body: '<path fill="currentColor" d="M12 .5C18.351.5 23.5 5.649 23.5 12q0 .505-.043 1h-1.506c-.502 5.053-4.766 9-9.951 9c-5.523 0-10-4.477-10-10c0-5.185 3.947-9.449 9-9.95V.542Q11.495.5 12 .5m-1 3.562A8.001 8.001 0 0 0 12 20a8 8 0 0 0 7.938-7H11zm2-1.51V11h8.448A9.5 9.5 0 0 0 13 2.552"/>',
    },
    "pie-chart-box-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m13.9 10H11V7.1a5.002 5.002 0 0 0 1 9.9a5 5 0 0 0 4.9-4m0-2A5.01 5.01 0 0 0 13 7.1V11z"/>',
    },
    "pie-chart-box-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h16V5zm12.9 8A5.002 5.002 0 0 1 7 12a5 5 0 0 1 4-4.9V13zm0-2H13V7.1a5.01 5.01 0 0 1 3.9 3.9"/>',
    },
    "pie-chart-fill": {
      body: '<path fill="currentColor" d="M11 2.05V13h10.95c-.501 5.053-4.765 9-9.95 9c-5.523 0-10-4.477-10-10c0-5.185 3.947-9.449 9-9.95m2 0A10 10 0 0 1 21.95 11H13z"/>',
    },
    "pie-chart-line": {
      body: '<path fill="currentColor" d="M9 2.458v2.124A8.003 8.003 0 0 0 12 20a8 8 0 0 0 7.419-5h2.123c-1.274 4.057-5.064 7-9.542 7c-5.523 0-10-4.477-10-10c0-4.478 2.943-8.268 7-9.542M12 2c5.523 0 10 4.477 10 10q0 .507-.05 1H11V2.05Q11.493 2 12 2m1 2.062V11h6.938A8.004 8.004 0 0 0 13 4.062"/>',
    },
    "pin-distance-fill": {
      body: '<path fill="currentColor" d="M11.39 10.39L7.5 14.277L3.61 10.39a5.5 5.5 0 1 1 7.78 0M7.5 8.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4m12.89 10.89l-3.89 3.888l-3.89-3.889a5.5 5.5 0 1 1 7.78 0M16.5 17.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "pin-distance-line": {
      body: '<path fill="currentColor" d="M9.975 8.975a3.5 3.5 0 1 0-4.95 0L7.5 11.45zM7.5 14.278L3.61 10.39a5.5 5.5 0 1 1 7.78 0zM7.5 8a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m9 12.45l2.475-2.475a3.5 3.5 0 1 0-4.95 0zm3.89-1.06l-3.89 3.888l-3.89-3.889a5.5 5.5 0 1 1 7.78 0M16.5 17a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "ping-pong-fill": {
      body: '<path fill="currentColor" d="M11.5 2a9.5 9.5 0 0 1 9.5 9.5c0 1.53-.361 2.974-1.003 4.254l2.463 2.464a1 1 0 0 1 0 1.414l-2.828 2.828a1 1 0 0 1-1.415 0l-2.463-2.463A9.46 9.46 0 0 1 11.5 21a9.5 9.5 0 0 1 0-19m5.303 13.388l-1.414 1.414l3.536 3.535l1.414-1.414zm1.864-6.105l-9.384 9.384A7.5 7.5 0 0 0 11.5 19a7.5 7.5 0 0 0 2.74-.516l-.972-.974a1 1 0 0 1 0-1.414l2.828-2.828a1 1 0 0 1 1.414 0l.974.972A7.5 7.5 0 0 0 19 11.5c0-.772-.117-1.516-.333-2.217"/>',
    },
    "ping-pong-line": {
      body: '<path fill="currentColor" d="M11.5 2a9.5 9.5 0 0 1 9.5 9.5c0 1.53-.361 2.974-1.003 4.254l2.463 2.464a1 1 0 0 1 0 1.414l-2.828 2.828a1 1 0 0 1-1.415 0l-2.463-2.463A9.46 9.46 0 0 1 11.5 21a9.5 9.5 0 0 1 0-19m5.303 13.388l-1.414 1.414l3.536 3.535l1.414-1.414zm1.864-6.105l-9.384 9.384A7.5 7.5 0 0 0 11.5 19a7.5 7.5 0 0 0 2.74-.516l-.972-.974a1 1 0 0 1 0-1.414l2.828-2.828a1 1 0 0 1 1.414 0l.974.972A7.5 7.5 0 0 0 19 11.5c0-.772-.117-1.516-.333-2.217M11.5 4a7.5 7.5 0 0 0-4.136 13.757L17.757 7.364A7.5 7.5 0 0 0 11.5 4"/>',
    },
    "pinterest-fill": {
      body: '<path fill="currentColor" d="M13.372 2.094a10.003 10.003 0 0 0-5.369 19.074a7.8 7.8 0 0 1 .162-2.292c.185-.839 1.296-5.463 1.296-5.463a3.7 3.7 0 0 1-.324-1.577c0-1.485.857-2.593 1.923-2.593a1.334 1.334 0 0 1 1.342 1.508c0 .9-.578 2.262-.88 3.54a1.544 1.544 0 0 0 1.575 1.923c1.897 0 3.17-2.431 3.17-5.301c0-2.201-1.457-3.847-4.143-3.847a4.746 4.746 0 0 0-4.93 4.793a2.96 2.96 0 0 0 .648 1.97a.48.48 0 0 1 .162.554c-.046.184-.162.623-.208.785a.354.354 0 0 1-.51.253c-1.384-.554-2.036-2.077-2.036-3.816c0-2.847 2.384-6.255 7.154-6.255c3.796 0 6.319 2.777 6.319 5.747c0 3.909-2.176 6.848-5.393 6.848a2.86 2.86 0 0 1-2.454-1.246s-.579 2.316-.692 2.754a8 8 0 0 1-1.019 2.131c.923.28 1.882.42 2.846.416a9.99 9.99 0 0 0 9.996-10.002a10 10 0 0 0-8.635-9.904"/>',
    },
    "pinterest-line": {
      body: '<path fill="currentColor" d="M8.492 19.191q.035-.505.143-1.001c.063-.295.254-1.13.534-2.34l.007-.03l.387-1.668c.079-.34.14-.604.181-.692a3.5 3.5 0 0 1-.284-1.423c0-1.337.756-2.373 1.736-2.373c.36-.006.704.15.942.426s.348.643.302.996c0 .453-.085.798-.453 2.035a28 28 0 0 0-.165.571a11 11 0 0 0-.133.522c-.096.386-.008.797.237 1.105a1.2 1.2 0 0 0 1.006.457c1.492 0 2.6-1.985 2.6-4.548c0-1.97-1.29-3.274-3.432-3.274A3.88 3.88 0 0 0 9.201 9.1a4.13 4.13 0 0 0-1.195 2.961a2.55 2.55 0 0 0 .512 1.644c.181.14.25.383.175.59c-.041.168-.14.552-.177.68a.41.41 0 0 1-.215.297a.39.39 0 0 1-.355.002c-1.16-.479-1.796-1.778-1.796-3.44c0-2.985 2.491-5.584 6.192-5.584c3.135 0 5.481 2.329 5.481 5.14c0 3.532-1.932 6.104-4.69 6.104a2.5 2.5 0 0 1-2.046-.959l-.043.177l-.207.852l-.002.008c-.146.6-.248 1.017-.288 1.173q-.16.534-.4 1.04a8 8 0 1 0-1.655-.593M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "pinyin-input": {
      body: '<path fill="currentColor" d="m17.934 3.036l1.732 1L18.531 6H21v2h-2v4h2v2h-2v7h-2v-7h-3.084c-.325 2.862-1.564 5.394-3.37 7.193l-1.562-1.27c1.52-1.438 2.596-3.522 2.917-5.922L10 14v-2l2-.001V8h-2V6h2.467l-1.133-1.964l1.732-1L14.777 6h1.444zM5 13.803l-2 .536v-2.071l2-.536V8H3V6h2V3h2v3h2v2H7v3.197l2-.536v2.07l-2 .536V18.5A2.5 2.5 0 0 1 4.5 21H3v-2h1.5a.5.5 0 0 0 .492-.41L5 18.5zM17 8h-3v4h3z"/>',
    },
    "pixelfed-fill": {
      body: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10m1.031 6.099h-2.624c-.988 0-1.789.776-1.789 1.733v6.748l2.595-2.471h1.818c1.713 0 3.101-1.345 3.101-3.005s-1.388-3.005-3.1-3.005"/>',
    },
    "pixelfed-line": {
      body: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m1.031 4.099c1.713 0 3.101 1.345 3.101 3.005s-1.388 3.005-3.1 3.005h-1.819L8.62 16.58V9.832c0-.957.801-1.733 1.79-1.733z"/>',
    },
    "plane-fill": {
      body: '<path fill="currentColor" d="M14 8.947L22 14v2l-8-2.526v5.36l3 1.666V22l-4.5-1L8 22v-1.5l3-1.667v-5.36L3 16v-2l8-5.053V3.5a1.5 1.5 0 0 1 3 0z"/>',
    },
    "plane-line": {
      body: '<path fill="currentColor" d="M14 8.947L22 14v2l-8-2.526v5.36l3 1.666V22l-4.5-1L8 22v-1.5l3-1.667v-5.36L3 16v-2l8-5.053V3.5a1.5 1.5 0 0 1 3 0z"/>',
    },
    "planet-fill": {
      body: '<path fill="currentColor" d="M5.322 5.966A9.2 9.2 0 0 1 7.2 4.386a4.5 4.5 0 0 0-.844-.157c-.572-.043-.823.093-.93.2c-.106.106-.242.357-.2.93q.022.275.097.607m15.404 8.245q.091.184.177.366c.476 1.02.791 2.017.859 2.913c.067.892-.106 1.82-.78 2.495c-.674.674-1.603.847-2.495.78c-.78-.06-1.637-.306-2.52-.684l-.003.002a13 13 0 0 1-.462-.208c-2.033-.963-4.359-2.654-6.542-4.838c-2.181-2.181-3.872-4.505-4.835-6.536q-.11-.233-.209-.463l.001-.002c-.379-.885-.626-1.745-.685-2.527c-.068-.892.105-1.82.78-2.495c.673-.674 1.602-.847 2.494-.78c.896.068 1.892.383 2.913.86q.186.085.373.18a9 9 0 0 1 8.572 2.362a9 9 0 0 1 2.362 8.575m-1.113 2.593a9 9 0 0 1-1.576 1.871q.328.075.6.095c.573.043.824-.093.93-.2c.108-.106.244-.357.2-.93a4.5 4.5 0 0 0-.154-.836m-13.977 1.56a9 9 0 0 1-2.417-8.342c1.082 1.981 2.705 4.1 4.68 6.076c1.977 1.977 4.098 3.6 6.08 4.683a9 9 0 0 1-8.343-2.417"/>',
    },
    "planet-line": {
      body: '<path fill="currentColor" d="M3.918 8.037A9 9 0 0 0 15.966 20.08c.873.373 1.719.618 2.49.681c.902.074 1.844-.095 2.526-.777c.752-.752.88-1.816.746-2.812c-.123-.91-.48-1.92-1.002-2.961A9 9 0 0 0 9.791 3.274c-1.044-.524-2.055-.882-2.965-1.006c-.997-.135-2.062-.007-2.815.746c-.682.683-.851 1.626-.777 2.528c.064.773.31 1.62.684 2.495m1.404-2.071a4 4 0 0 1-.095-.587c-.048-.586.09-.842.198-.95c.12-.12.423-.275 1.132-.179q.298.04.643.136a9 9 0 0 0-1.878 1.58m14.29 10.837a5 5 0 0 1 .134.637c.096.709-.06 1.012-.178 1.13c-.109.109-.364.247-.95.199a4 4 0 0 1-.581-.094a9 9 0 0 0 1.575-1.872m-3.73 1.023c-1.677-.878-3.625-2.323-5.507-4.205c-1.88-1.88-3.324-3.825-4.203-5.5A7.02 7.02 0 0 1 9.97 5.298a7 7 0 0 1 5.912 12.528m-2.277.99a7 7 0 0 1-8.42-8.419c.964 1.516 2.25 3.112 3.776 4.638c1.528 1.528 3.126 2.815 4.644 3.78"/>',
    },
    "plant-fill": {
      body: '<path fill="currentColor" d="M20.998 3v2a7 7 0 0 1-7 7h-1v1h5v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-7h5v-3a7 7 0 0 1 7-7zm-15.5-1a7.49 7.49 0 0 1 6.124 3.169A7.96 7.96 0 0 0 9.998 10v1h-.5a7.5 7.5 0 0 1-7.5-7.5V2z"/>',
    },
    "plant-line": {
      body: '<path fill="currentColor" d="M5.998 2a7 7 0 0 1 6.197 3.741A6.49 6.49 0 0 1 17.498 3h3.5v2.5a6.5 6.5 0 0 1-6.5 6.5h-1.5v1h5v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-7h5v-2h-2a7 7 0 0 1-7-7V2zm10 13h-8v5h8zm3-10h-1.5a4.5 4.5 0 0 0-4.5 4.5v.5h1.5a4.5 4.5 0 0 0 4.5-4.5zm-13-1h-2a5 5 0 0 0 5 5h2a5 5 0 0 0-5-5"/>',
    },
    "play-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M10.622 8.415a.4.4 0 0 0-.622.332v6.506a.4.4 0 0 0 .622.332l4.879-3.252a.4.4 0 0 0 0-.666z"/>',
    },
    "play-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M10.622 8.415l4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332"/>',
    },
    "play-fill": {
      body: '<path fill="currentColor" d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"/>',
    },
    "play-large-fill": {
      body: '<path fill="currentColor" d="M6 20.196V3.804a1 1 0 0 1 1.53-.848l13.113 8.196a1 1 0 0 1 0 1.696L7.53 21.044A1 1 0 0 1 6 20.196"/>',
    },
    "play-large-line": {
      body: '<path fill="currentColor" d="M8 18.392V5.608L18.226 12zM6 3.804v16.392a1 1 0 0 0 1.53.848l13.113-8.196a1 1 0 0 0 0-1.696L7.53 2.956A1 1 0 0 0 6 3.804"/>',
    },
    "play-line": {
      body: '<path fill="currentColor" d="M16.394 12L10 7.737v8.526zm2.982.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832"/>',
    },
    "play-list-2-fill": {
      body: '<path fill="currentColor" d="M22 18v2H2v-2zM2 3.5l8 5l-8 5zM22 11v2H12v-2zm0-7v2H12V4z"/>',
    },
    "play-list-2-line": {
      body: '<path fill="currentColor" d="M22 18v2H2v-2zM2 3.5l8 5l-8 5zM22 11v2H12v-2zM4 7.109v2.783L6.226 8.5zM22 4v2H12V4z"/>',
    },
    "play-list-add-fill": {
      body: '<path fill="currentColor" d="M2 18h10v2H2zm0-7h20v2H2zm0-7h20v2H2zm16 14v-3h2v3h3v2h-3v3h-2v-3h-3v-2z"/>',
    },
    "play-list-add-line": {
      body: '<path fill="currentColor" d="M2 18h10v2H2zm0-7h20v2H2zm0-7h20v2H2zm16 14v-3h2v3h3v2h-3v3h-2v-3h-3v-2z"/>',
    },
    "play-list-fill": {
      body: '<path fill="currentColor" d="M2 18h10v2H2zm0-7h14v2H2zm0-7h20v2H2zm17 11.17V9h5v2h-3v7a3 3 0 1 1-2-2.83"/>',
    },
    "play-list-line": {
      body: '<path fill="currentColor" d="M2 18h10v2H2zm0-7h14v2H2zm0-7h20v2H2zm17 11.17V9h5v2h-3v7a3 3 0 1 1-2-2.83M18 19a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "play-mini-fill": {
      body: '<path fill="currentColor" d="m7.752 5.439l10.508 6.13a.5.5 0 0 1 0 .863l-10.508 6.13A.5.5 0 0 1 7 18.13V5.87a.5.5 0 0 1 .752-.431"/>',
    },
    "play-mini-line": {
      body: '<path fill="currentColor" d="M9 8.482v7.036L15.03 12zM7.752 5.44l10.508 6.13a.5.5 0 0 1 0 .863l-10.508 6.13A.5.5 0 0 1 7 18.13V5.87a.5.5 0 0 1 .752-.431"/>',
    },
    "play-reverse-fill": {
      body: '<path fill="currentColor" d="m4.624 12.416l10.599 7.066a.5.5 0 0 0 .777-.416V4.934a.5.5 0 0 0-.777-.416L4.624 11.584a.5.5 0 0 0 0 .832"/>',
    },
    "play-reverse-large-fill": {
      body: '<path fill="currentColor" d="M18 20.196V3.804a1 1 0 0 0-1.53-.848L3.357 11.152a1 1 0 0 0 0 1.696l13.113 8.196a1 1 0 0 0 1.53-.848"/>',
    },
    "play-reverse-large-line": {
      body: '<path fill="currentColor" d="M16 18.392V5.608L5.774 12zm2-14.588v16.392a1 1 0 0 1-1.53.848L3.357 12.848a1 1 0 0 1 0-1.696L16.47 2.956a1 1 0 0 1 1.53.848"/>',
    },
    "play-reverse-line": {
      body: '<path fill="currentColor" d="M7.606 12L14 7.737v8.526zm-2.982.416l10.599 7.066a.5.5 0 0 0 .777-.416V4.934a.5.5 0 0 0-.777-.416L4.624 11.584a.5.5 0 0 0 0 .832"/>',
    },
    "play-reverse-mini-fill": {
      body: '<path fill="currentColor" d="M16.248 5.439L5.74 11.569a.5.5 0 0 0 0 .863l10.508 6.13A.5.5 0 0 0 17 18.13V5.87a.5.5 0 0 0-.752-.431"/>',
    },
    "play-reverse-mini-line": {
      body: '<path fill="currentColor" d="M15 8.482v7.036L8.97 12zm1.248-3.043L5.74 11.569a.5.5 0 0 0 0 .863l10.508 6.13A.5.5 0 0 0 17 18.13V5.87a.5.5 0 0 0-.752-.431"/>',
    },
    "playstation-fill": {
      body: '<path fill="currentColor" d="M22.585 17.011c-.43.543-1.483.93-1.483.93l-7.832 2.817V18.68l5.764-2.057c.654-.234.754-.566.223-.74s-1.492-.125-2.147.111l-3.84 1.354v-2.155l.221-.076s1.11-.393 2.67-.566c1.561-.172 3.472.024 4.972.593c1.69.535 1.88 1.323 1.452 1.866m-8.57-3.537V8.162c0-.624-.115-1.198-.7-1.36c-.447-.144-.725.272-.725.895V21l-3.583-1.139V4c1.523.283 3.743.953 4.936 1.355c3.035 1.043 4.064 2.342 4.064 5.267c0 2.851-1.758 3.932-3.992 2.852m-11.583 4.99c-1.736-.49-2.025-1.51-1.234-2.097c.731-.542 1.975-.95 1.975-.95l5.138-1.83v2.086l-3.698 1.325c-.653.234-.753.566-.223.74c.532.175 1.493.125 2.147-.11l1.774-.644v1.865l-.354.06c-1.774.29-3.663.169-5.525-.445"/>',
    },
    "playstation-line": {
      body: '<path fill="currentColor" d="M22.585 17.011c-.43.543-1.483.93-1.483.93l-7.832 2.817V18.68l5.764-2.057c.654-.234.754-.566.223-.74s-1.492-.125-2.147.111l-3.84 1.354v-2.155l.221-.076s1.11-.393 2.67-.566c1.561-.172 3.472.024 4.972.593c1.69.535 1.88 1.323 1.452 1.866m-8.57-3.537V8.162c0-.624-.115-1.198-.7-1.36c-.447-.144-.725.272-.725.895V21l-3.583-1.139V4c1.523.283 3.743.953 4.936 1.355c3.035 1.043 4.064 2.342 4.064 5.267c0 2.851-1.758 3.932-3.992 2.852m-11.583 4.99c-1.736-.49-2.025-1.51-1.234-2.097c.731-.542 1.975-.95 1.975-.95l5.138-1.83v2.086l-3.698 1.325c-.653.234-.753.566-.223.74c.532.175 1.493.125 2.147-.11l1.774-.644v1.865l-.354.06c-1.774.29-3.663.169-5.525-.445"/>',
    },
    "plug-2-fill": {
      body: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4v-4h16v4a4 4 0 0 1-4 4zm4-12h2a1 1 0 0 1 1 1v2H4V7a1 1 0 0 1 1-1h2V2h2v4h6V2h2zm-5 8.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2M11 2h2v3h-2z"/>',
    },
    "plug-2-line": {
      body: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4V7a1 1 0 0 1 1-1h2V2h2v4h6V2h2v4h2a1 1 0 0 1 1 1v7a4 4 0 0 1-4 4zm-5-2h8a2 2 0 0 0 2-2v-3H6v3a2 2 0 0 0 2 2m10-8H6v1h12zm-6 6.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2M11 2h2v3h-2z"/>',
    },
    "plug-fill": {
      body: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4v-4h16v4a4 4 0 0 1-4 4zm3-12h3a1 1 0 0 1 1 1v2H4V7a1 1 0 0 1 1-1h3V2h2v4h4V2h2zm-4 8.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "plug-line": {
      body: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4V7a1 1 0 0 1 1-1h3V2h2v4h4V2h2v4h3a1 1 0 0 1 1 1v7a4 4 0 0 1-4 4zm-5-2h8a2 2 0 0 0 2-2v-3H6v3a2 2 0 0 0 2 2m10-8H6v1h12zm-6 6.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "polaroid-2-fill": {
      body: '<path fill="currentColor" d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007zM6 17v2h12v-2zM5 5v2h2V5zm7 7a2 2 0 1 1 0-4a2 2 0 0 1 0 4m0 2a4 4 0 1 0 0-8a4 4 0 0 0 0 8"/>',
    },
    "polaroid-2-line": {
      body: '<path fill="currentColor" d="M19 15V5H5v10zM3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007zM12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8M6 6h2v2H6zm0 11v2h12v-2z"/>',
    },
    "polaroid-fill": {
      body: '<path fill="currentColor" d="M20.659 10a6 6 0 1 0 0 4H21v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6zM5 6v3h2V6zm10 10a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "polaroid-line": {
      body: '<path fill="currentColor" d="M21 6h-2V5H5v14h14v-1h2v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zM6 6h2v3H6zm9 10a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0 2a6 6 0 1 1 0-12a6 6 0 0 1 0 12m0-4a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "police-badge-fill": {
      body: '<path fill="currentColor" d="M2.913 11.674C3.236 10.195 3.54 8.808 2 6.5l3.5-4S9 4 12 1.5c3 2.5 6.5 1 6.5 1l3.5 4c-1.539 2.308-1.236 3.695-.913 5.174c.306 1.404.63 2.89-.587 5.326c-1.157 2.315-3.152 3.123-5.015 3.877c-1.356.55-2.642 1.07-3.485 2.123c-.842-1.053-2.129-1.574-3.485-2.123C6.652 20.123 4.658 19.315 3.5 17c-1.218-2.435-.893-3.922-.587-5.326m11.465 1.099l2.377-2.318l-3.286-.478L12 7l-1.47 2.977l-3.285.478l2.377 2.318l-.561 3.272L12 14.5l2.939 1.545z"/>',
    },
    "police-badge-line": {
      body: '<path fill="currentColor" d="M16.475 4.935c.505-.025.962-.09 1.351-.168l1.732 1.98c-.39.82-.612 1.602-.695 2.377c-.124 1.157.089 2.143.245 2.863l.007.033c.162.744.269 1.234.253 1.809c-.015.541-.147 1.256-.657 2.277c-1.1 2.201-3.695 2.666-5.715 3.675c-.326.164-.662.35-.996.569a10 10 0 0 0-.996-.569c-2.02-1.01-4.614-1.474-5.715-3.675c-.51-1.02-.642-1.736-.657-2.277c-.016-.575.09-1.065.253-1.81l.007-.032c.156-.72.369-1.706.245-2.863a7.3 7.3 0 0 0-.695-2.377l1.732-1.98c.389.078.846.143 1.351.168C8.79 4.998 10.402 4.81 12 3.918c1.598.892 3.21 1.08 4.475 1.017m4.612 6.739c-.323-1.479-.626-2.866.913-5.174l-3.5-4S15 4 12 1.5c-3 2.5-6.5 1-6.5 1L2 6.5c1.539 2.308 1.236 3.695.913 5.174c-.306 1.404-.63 2.89.587 5.326c1.577 3.154 4.708 3.51 6.943 4.745c.6.332 1.134.726 1.557 1.255c.423-.529.958-.923 1.558-1.255C15.792 20.51 18.923 20.154 20.5 17c1.218-2.435.893-3.922.587-5.326m-6.71 1.099l.562 3.272l-2.94-1.545l-2.938 1.545l.561-3.273l-2.377-2.317l3.285-.478L12 7l1.47 2.977l3.285.478z"/>',
    },
    "police-car-fill": {
      body: '<path fill="currentColor" d="M22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5h1.929L4.48 6.212A2 2 0 0 1 6.319 5H8V3h3v2h2V3h3v2h1.681a2 2 0 0 1 1.838 1.212L21.572 11H23.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97zM4 15v2a1 1 0 0 0 1 1h3.245a.5.5 0 0 0 .44-.736Q7.476 15 4 15m16 0q-3.476 0-4.686 2.264a.5.5 0 0 0 .441.736H19a1 1 0 0 0 1-1zM6 7l-1.451 3.629A1 1 0 0 0 5.477 12h13.046a1 1 0 0 0 .928-1.371L18 7z"/>',
    },
    "police-car-line": {
      body: '<path fill="currentColor" d="M4 13v5h16v-5zm1.618-2h12.764a1 1 0 0 0 .894-1.447L18 7H6L4.724 9.553A1 1 0 0 0 5.618 11M22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5H2l2.447-4.894A2 2 0 0 1 6.237 5H8V3h3v2h2V3h3v2h1.764a2 2 0 0 1 1.789 1.106L22 11h1.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97zM5 14q3.476 0 4.686 2.264a.5.5 0 0 1-.441.736H6a1 1 0 0 1-1-1zm14 0v2a1 1 0 0 1-1 1h-3.245a.5.5 0 0 1-.44-.736Q15.524 14 19 14"/>',
    },
    "presentation-fill": {
      body: '<path fill="currentColor" d="M8 4a2 2 0 1 1-4 0a2 2 0 0 1 4 0M5 16v6H3V10a3 3 0 0 1 5.106-2.137l2.374 2.243l2.313-2.313l1.414 1.414l-3.687 3.687L9 11.46V22H7v-6zm5-11h9v9h-9v2h4.365l2.824 6h2.21l-2.823-6H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H10z"/>',
    },
    "presentation-line": {
      body: '<path fill="currentColor" d="M8 4a2 2 0 1 1-4 0a2 2 0 0 1 4 0M5 16v6H3V10a3 3 0 0 1 5.106-2.137l2.374 2.243l2.313-2.313l1.414 1.414l-3.687 3.687L9 11.46V22H7v-6zm1-7a1 1 0 0 0-1 1v4h2v-4a1 1 0 0 0-1-1m13-4h-9V3h10a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-3.424l2.823 6h-2.21l-2.824-6H10v-2h9z"/>',
    },
    "price-tag-2-fill": {
      body: '<path fill="currentColor" d="m3.005 7l8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1zm9 4a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-4 5v2h8v-2zm0-3v2h8v-2z"/>',
    },
    "price-tag-2-line": {
      body: '<path fill="currentColor" d="m3.005 7l8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1zm2 1.07V20h14V8.07l-7-4.667zm3 7.93h8v2h-8zm0-3h8v2h-8zm4-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "price-tag-3-fill": {
      body: '<path fill="currentColor" d="m10.904 2.1l9.9 1.414l1.414 9.9l-9.192 9.192a1 1 0 0 1-1.415 0l-9.9-9.9a1 1 0 0 1 0-1.413zm2.829 8.486a2 2 0 1 0 2.828-2.829a2 2 0 0 0-2.828 2.829"/>',
    },
    "price-tag-3-line": {
      body: '<path fill="currentColor" d="m10.904 2.1l9.9 1.414l1.414 9.9l-9.192 9.192a1 1 0 0 1-1.415 0l-9.9-9.9a1 1 0 0 1 0-1.413zm.707 2.122L3.833 12l8.485 8.485l7.779-7.778l-1.061-7.425zm2.122 6.363a2 2 0 1 1 2.828-2.828a2 2 0 0 1-2.828 2.829"/>',
    },
    "price-tag-fill": {
      body: '<path fill="currentColor" d="m3.005 7l8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1zm9 4a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "price-tag-line": {
      body: '<path fill="currentColor" d="m3.005 7l8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1zm2 1.07V20h14V8.07l-7-4.667zm7 2.93a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "printer-cloud-fill": {
      body: '<path fill="currentColor" d="M7 2h10a1 1 0 0 1 1 1v3H6V3a1 1 0 0 1 1-1m15 7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2v-5h7.194q.364-1.337 1.417-2.39Q15.22 11 17.5 11t3.89 1.61q.34.343.61.714zM8 10v2H5v-2zm13 6.5a3.5 3.5 0 1 0-7 0l.003.102a2.751 2.751 0 0 0 .58 5.393l.167.005h5.5l.168-.005a2.75 2.75 0 0 0 .58-5.392zM7 17h3.562A4.6 4.6 0 0 0 10 19.25q0 1.548.871 2.75H7z"/>',
    },
    "printer-cloud-line": {
      body: '<path fill="currentColor" d="M17 2a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v5.324a6 6 0 0 0-.61-.713A5.6 5.6 0 0 0 20 11.583V9H4v8h2v-1a1 1 0 0 1 1-1h5.194a5 5 0 0 0-.07.283q-.645.428-1.142 1.074q-.24.312-.42.643H8v3h2.054a4.5 4.5 0 0 0 .817 2H7a1 1 0 0 1-1-1v-2H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1zm-1 2H8v3h8zm-8 6v2H5v-2zm13 6.5a3.5 3.5 0 1 0-7 0l.003.102a2.751 2.751 0 0 0 .58 5.393l.167.005h5.5l.168-.005a2.75 2.75 0 0 0 .58-5.392zm-4.993-.145a1.5 1.5 0 0 1 2.986 0L19 16.5v1.62q1.044.298 1.444.406A.75.75 0 0 1 20.255 20h-5.51a.75.75 0 0 1-.19-1.474q.357-.096 1.22-.342L16 18.12V16.5z"/>',
    },
    "printer-fill": {
      body: '<path fill="currentColor" d="M7 17h10v5H7zm12 3v-5H5v5H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM5 10v2h3v-2zm2-8h10a1 1 0 0 1 1 1v3H6V3a1 1 0 0 1 1-1"/>',
    },
    "printer-line": {
      body: '<path fill="currentColor" d="M17 2a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1zm-1 15H8v3h8zm4-8H4v8h2v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1h2zM8 10v2H5v-2zm8-6H8v3h8z"/>',
    },
    "product-hunt-fill": {
      body: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m1.334-10H10.5V9h2.834a1.5 1.5 0 0 1 0 3m0-5H8.5v10h2v-3h2.834a3.5 3.5 0 1 0 0-7"/>',
    },
    "product-hunt-line": {
      body: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1.334-8a1.5 1.5 0 0 0 0-3H10.5v3zm0-5a3.5 3.5 0 1 1 0 7H10.5v3h-2V7z"/>',
    },
    "profile-fill": {
      body: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007zM6 15v2h12v-2zm0-8v6h6V7zm8 0v2h4V7zm0 4v2h4v-2zM8 9h2v2H8z"/>',
    },
    "profile-line": {
      body: '<path fill="currentColor" d="M21.008 3c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zM20 5H4v14h16zm-2 10v2H6v-2zm-6-8v6H6V7zm6 4v2h-4v-2zm-8-2H8v2h2zm8-2v2h-4V7z"/>',
    },
    "progress-1-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m0-10V6a5.98 5.98 0 0 1 4.243 1.757z"/>',
    },
    "progress-1-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-8 0V6a5.98 5.98 0 0 1 4.243 1.757z"/>',
    },
    "progress-2-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m0-10V6a6 6 0 0 1 6 6z"/>',
    },
    "progress-2-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-8 0V6a6 6 0 0 1 6 6z"/>',
    },
    "progress-3-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m6-10a5.98 5.98 0 0 1-1.757 4.243L12 12V6a6 6 0 0 1 6 6"/>',
    },
    "progress-3-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-2 0a5.98 5.98 0 0 1-1.757 4.243L12 12V6a6 6 0 0 1 6 6"/>',
    },
    "progress-4-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m6-10a6 6 0 0 1-6 6V6a6 6 0 0 1 6 6"/>',
    },
    "progress-4-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-2 0a6 6 0 0 1-6 6V6a6 6 0 0 1 6 6"/>',
    },
    "progress-5-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m6-10a6 6 0 0 1-10.243 4.243L12 12V6a6 6 0 0 1 6 6"/>',
    },
    "progress-5-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-2 0a6 6 0 0 1-10.243 4.243L12 12V6a6 6 0 0 1 6 6"/>',
    },
    "progress-6-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m6-10a6 6 0 0 1-12 0h6V6a6 6 0 0 1 6 6"/>',
    },
    "progress-6-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-2 0a6 6 0 0 1-12 0h6V6a6 6 0 0 1 6 6"/>',
    },
    "progress-7-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m6-10A6 6 0 1 1 7.757 7.757L12 12V6a6 6 0 0 1 6 6"/>',
    },
    "progress-7-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-2 0A6 6 0 1 1 7.757 7.757L12 12V6a6 6 0 0 1 6 6"/>',
    },
    "progress-8-fill": {
      body: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m0-4a6 6 0 1 1 0-12a6 6 0 0 1 0 12"/>',
    },
    "progress-8-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12m18 0a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-8 6a6 6 0 1 0 0-12a6 6 0 0 0 0 12"/>',
    },
    "prohibited-2-fill": {
      body: '<path fill="currentColor" d="M4.257 18.329A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2c2.401 0 4.605.846 6.329 2.257zM19.743 5.67A9.96 9.96 0 0 1 22 12c0 5.523-4.477 10-10 10a9.96 9.96 0 0 1-6.329-2.257z"/>',
    },
    "prohibited-2-line": {
      body: '<path fill="currentColor" d="M16.906 5.68L5.68 16.906A8 8 0 0 1 16.906 5.68M7.094 18.32L18.32 7.094A8 8 0 0 1 7.094 18.32M12 2C6.477 2 2 6.477 2 12s4.478 10 10 10s10-4.477 10-10S17.522 2 12 2"/>',
    },
    "prohibited-fill": {
      body: '<path fill="currentColor" d="M19.743 18.329A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10a9.96 9.96 0 0 0-6.329 2.257zM4.257 5.67A9.96 9.96 0 0 0 2 12c0 5.523 4.477 10 10 10a9.96 9.96 0 0 0 6.329-2.257z"/>',
    },
    "prohibited-line": {
      body: '<path fill="currentColor" d="M7.094 5.68L18.32 16.906A8 8 0 0 0 7.094 5.68m9.812 12.64L5.68 7.094A8 8 0 0 0 16.906 18.32M4.929 4.929A9.97 9.97 0 0 1 12 2c5.523 0 10 4.477 10 10a9.97 9.97 0 0 1-2.929 7.071A9.97 9.97 0 0 1 12 22C6.477 22 2 17.523 2 12a9.97 9.97 0 0 1 2.929-7.071"/>',
    },
    "projector-2-fill": {
      body: '<path fill="currentColor" d="M22 19v2h-2v-2H4v2H2v-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h9.81a6.48 6.48 0 0 1 4.69-2c1.843 0 3.508.767 4.69 2H22a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1m-5.5-5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9m0-2a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5M4 13v2h2v-2zm4 0v2h2v-2z"/>',
    },
    "projector-2-line": {
      body: '<path fill="currentColor" d="M22 19v2h-2v-2H4v2H2v-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10.528A6 6 0 0 1 17 3c1.777 0 3.374.773 4.472 2H22a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1M11.341 7H3v10h18v-3.528A6 6 0 0 1 11.341 7M17 13a4 4 0 1 0 0-8a4 4 0 0 0 0 8M5 13h2v2H5zm3 0h2v2H8z"/>',
    },
    "projector-fill": {
      body: '<path fill="currentColor" d="M11.112 12a4.502 4.502 0 0 0 8.777 0H22v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8zM5 16h2v2H5zm10.5-2.5a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5M11.111 10H2V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6h-2.111a4.502 4.502 0 0 0-8.777 0"/>',
    },
    "projector-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8.126 9H4v7h16v-7h-1.126a4.002 4.002 0 0 1-7.748 0m0-2a4.002 4.002 0 0 1 7.748 0H20V5H4v5zM15 13a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-9 2h2v2H6z"/>',
    },
    "psychotherapy-fill": {
      body: '<path fill="currentColor" d="M11 2a8 8 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2m0 5a1 1 0 0 0-1 1v.999L9 9a1 1 0 0 0 0 2l1-.001V12a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V8a1 1 0 0 0-1-1"/>',
    },
    "psychotherapy-line": {
      body: '<path fill="currentColor" d="M11 2a8 8 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2m0 2a6 6 0 0 0-4.684 9.75C7.41 15.114 8 16.667 8 18.306V20h5l.002-3H17v-4.248l1.55-.664l-1.543-2.425l-.057-.442A6 6 0 0 0 11 4m0 3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1.001L9 11a1 1 0 1 1 0-2l1-.001V8a1 1 0 0 1 1-1"/>',
    },
    "pulse-fill": {
      body: '<path fill="currentColor" d="m9 7.539l6 14L18.66 13H23v-2h-5.66L15 16.461l-6-14L5.34 11H1v2h5.66z"/>',
    },
    "pulse-line": {
      body: '<path fill="currentColor" d="m9 7.539l6 14L18.66 13H23v-2h-5.66L15 16.461l-6-14L5.34 11H1v2h5.66z"/>',
    },
    "pushpin-2-fill": {
      body: '<path fill="currentColor" d="M18 3v2h-1v6l2 3v2h-6v7h-2v-7H5v-2l2-3V5H6V3z"/>',
    },
    "pushpin-2-line": {
      body: '<path fill="currentColor" d="M18 3v2h-1v6l2 3v2h-6v7h-2v-7H5v-2l2-3V5H6V3zM9 5v6.606L7.404 14h9.192L15 11.606V5z"/>',
    },
    "pushpin-fill": {
      body: '<path fill="currentColor" d="m22.313 10.175l-1.415 1.414l-.707-.707l-4.242 4.243l-.707 3.536l-1.415 1.414l-4.242-4.243l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.243-4.243l1.414-1.414l3.536-.707l4.242-4.243l-.707-.707l1.414-1.414z"/>',
    },
    "pushpin-line": {
      body: '<path fill="currentColor" d="m13.827 1.69l8.486 8.485l-1.415 1.414l-.707-.707l-4.242 4.243l-.707 3.536l-1.415 1.414l-4.242-4.243l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.243-4.243l1.414-1.414l3.536-.707l4.242-4.243l-.707-.707zm.707 3.536l-4.67 4.67l-2.822.565l6.5 6.5l.564-2.822l4.671-4.67z"/>',
    },
    "puzzle-2-fill": {
      body: '<path fill="currentColor" d="M8 4a3 3 0 1 1 5.83 1H20a1 1 0 0 1 1 1v3.126a1 1 0 0 1-1.25.969a3 3 0 1 0 0 5.811a1 1 0 0 1 1.25.968V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4.17C8.06 4.687 8 4.35 8 4"/>',
    },
    "puzzle-2-line": {
      body: '<path fill="currentColor" d="M7 5a4 4 0 1 1 8 0h5a1 1 0 0 1 1 1v4.17a1 1 0 0 1-1.333.944a2 2 0 1 0 0 3.773a1 1 0 0 1 1.333.942V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm4-2a2 2 0 0 0-1.886 2.667A1 1 0 0 1 8.17 7H5v12h14v-2a4 4 0 0 1 0-8V7h-5.17a1 1 0 0 1-.944-1.333Q13 5.355 13 5a2 2 0 0 0-2-2"/>',
    },
    "puzzle-fill": {
      body: '<path fill="currentColor" d="M8 4a3 3 0 1 1 5.83 1H18a1 1 0 0 1 1 1v4.17a3 3 0 1 1 0 5.659V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4.17C8.06 4.687 8 4.35 8 4"/>',
    },
    "puzzle-line": {
      body: '<path fill="currentColor" d="M7 5a4 4 0 1 1 8 0h3a1 1 0 0 1 1 1v3a4 4 0 0 1 0 8v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm4-2a2 2 0 0 0-1.886 2.667A1 1 0 0 1 8.17 7H5v12h12v-3.17a1 1 0 0 1 1.333-.944Q18.646 15 19 15a2 2 0 1 0-.667-3.886A1 1 0 0 1 17 10.17V7h-3.17a1 1 0 0 1-.944-1.333Q13 5.355 13 5a2 2 0 0 0-2-2"/>',
    },
    "qq-fill": {
      body: '<path fill="currentColor" d="M19.914 14.529a32 32 0 0 0-.676-1.886l-.91-2.246c.002-.026.013-.468.013-.696C18.34 5.86 16.508 2 12 2S5.66 5.86 5.66 9.7c0 .229.011.671.012.697l-.91 2.246a32 32 0 0 0-.675 1.886c-.86 2.737-.581 3.87-.369 3.895c.455.054 1.771-2.06 1.771-2.06c0 1.224.637 2.822 2.016 3.976c-.515.157-1.147.399-1.554.695c-.365.267-.319.54-.253.65c.289.481 4.955.307 6.303.157c1.347.15 6.014.324 6.302-.158c.066-.11.112-.382-.253-.649c-.407-.296-1.039-.538-1.555-.695c1.379-1.154 2.016-2.752 2.016-3.977c0 0 1.316 2.115 1.771 2.06c.212-.025.49-1.157-.37-3.894"/>',
    },
    "qq-line": {
      body: '<path fill="currentColor" d="m17.536 12.514l-.696-1.796c0-.021.01-.375.01-.558C16.85 7.088 15.447 4 12 4s-4.848 3.088-4.848 6.16c0 .183.009.537.01.557l-.696 1.797c-.19.515-.38 1.05-.517 1.51c-.657 2.189-.444 3.095-.282 3.115c.348.043 1.354-1.648 1.354-1.648c0 .98.487 2.258 1.542 3.18c-.394.127-.878.32-1.188.557c-.28.214-.245.431-.194.52c.22.385 3.79.245 4.82.125c1.03.12 4.599.26 4.82-.126c.05-.088.085-.305-.194-.519c-.311-.237-.795-.43-1.19-.556c1.055-.923 1.542-2.202 1.542-3.181c0 0 1.007 1.691 1.355 1.648c.162-.02.378-.928-.283-3.116a27 27 0 0 0-.516-1.509m1.021 8.227c-.373.652-.833.892-1.438 1.057a5 5 0 0 1-.794.138c-.44.045-.986.065-1.613.064a33 33 0 0 1-2.71-.116c-.692.065-1.785.114-2.71.116a16 16 0 0 1-1.614-.064a5 5 0 0 1-.793-.138c-.605-.164-1.065-.405-1.44-1.059a2.27 2.27 0 0 1-.239-1.652c-.592-.132-1.001-.482-1.279-.911a2.4 2.4 0 0 1-.309-.71a4 4 0 0 1-.116-1.106c.013-.785.187-1.762.532-2.912c.14-.466.327-1.008.567-1.655l.554-1.43l-.002-.203C5.153 5.605 7.589 2 12 2c4.413 0 6.848 3.605 6.848 8.16l-.001.203l.553 1.43l.01.026c.225.606.413 1.153.556 1.626c.348 1.15.522 2.128.535 2.916q.012.61-.118 1.108c-.066.246-.161.48-.31.708c-.276.427-.684.776-1.277.91c.13.554.055 1.14-.24 1.654"/>',
    },
    "qr-code-fill": {
      body: '<path fill="currentColor" d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1zm5 4h-4v-2h2v-2h2zM3 3h8v8H3zm10 0h8v8h-8zM3 13h8v8H3zm15 0h3v2h-3zM6 6v2h2V6zm0 10v2h2v-2zM16 6v2h2V6z"/>',
    },
    "qr-code-line": {
      body: '<path fill="currentColor" d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1zm5 4h-4v-2h2v-2h2zM3 3h8v8H3zm2 2v4h4V5zm8-2h8v8h-8zm2 2v4h4V5zM3 13h8v8H3zm2 2v4h4v-4zm13-2h3v2h-3zM6 6h2v2H6zm0 10h2v2H6zM16 6h2v2h-2z"/>',
    },
    "qr-scan-2-fill": {
      body: '<path fill="currentColor" d="M15 3h6v6h-6zM9 3v6H3V3zm6 18v-6h6v6zm-6 0H3v-6h6zM3 11h18v2H3z"/>',
    },
    "qr-scan-2-line": {
      body: '<path fill="currentColor" d="M15 3h6v5h-2V5h-4zM9 3v2H5v3H3V3zm6 18v-2h4v-3h2v5zm-6 0H3v-5h2v3h4zM3 11h18v2H3z"/>',
    },
    "qr-scan-fill": {
      body: '<path fill="currentColor" d="M21 15v5.007a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007V15zM2 11h20v2H2zm19-2H3V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993z"/>',
    },
    "qr-scan-line": {
      body: '<path fill="currentColor" d="M21 16v5H3v-5h2v3h14v-3zM3 11h18v2H3zm18-3h-2V5H5v3H3V3h18z"/>',
    },
    "question-answer-fill": {
      body: '<path fill="currentColor" d="M8 18h10.237L20 19.385V9h1a1 1 0 0 1 1 1v13.5L17.546 20H9a1 1 0 0 1-1-1zm-2.545-2L1 19.5V4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v12z"/>',
    },
    "question-answer-line": {
      body: '<path fill="currentColor" d="M5.455 15L1 18.5V3a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v12zm-.692-2H16V4H3v10.385zM8 17h10.237L20 18.385V8h1a1 1 0 0 1 1 1v13.5L17.546 19H9a1 1 0 0 1-1-1z"/>',
    },
    "question-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m-1-7v2h2v-2zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.5 3.5 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2z"/>',
    },
    "question-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1-5h2v2h-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1a1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355"/>',
    },
    "question-mark": {
      body: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m0-17a6 6 0 0 1 6 6c0 2.165-.753 3.29-2.674 4.923C13.399 14.56 13 15.297 13 17h-2c0-2.474.787-3.695 3.031-5.601C15.548 10.11 16 9.434 16 8a4 4 0 0 0-8 0v1H6V8a6 6 0 0 1 6-6"/>',
    },
    "questionnaire-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM11 14v2h2v-2zM8.567 8.813l1.962.393A1.5 1.5 0 1 1 12 11h-1v2h1a3.5 3.5 0 1 0-3.433-4.187"/>',
    },
    "questionnaire-line": {
      body: '<path fill="currentColor" d="M5.763 17H20V5H4v13.385zm.692 2L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM11 14h2v2h-2zM8.567 8.813A3.501 3.501 0 1 1 12 13h-1v-2h1a1.5 1.5 0 1 0-1.471-1.794z"/>',
    },
    "quill-pen-fill": {
      body: '<path fill="currentColor" d="M21 1.997c-15 0-17 14-18 20h1.998q.999-5 5.002-5.5c4-.5 7-4 8-7l-1.5-1l1-1c1-1 2.004-2.5 3.5-5.5"/>',
    },
    "quill-pen-line": {
      body: '<path fill="currentColor" d="M6.94 14.033a30 30 0 0 0-.606 1.783c.96-.697 2.101-1.14 3.418-1.304c2.513-.314 4.746-1.973 5.876-4.058l-1.456-1.455l1.413-1.415l1-1.002c.43-.429.915-1.224 1.428-2.367c-5.593.867-9.018 4.291-11.074 9.818M17 8.997l1 1c-1 3-4 6-8 6.5q-4.003.5-5.002 5.5H3c1-6 3-20 18-20q-1.5 4.496-2.997 5.997z"/>',
    },
    "quote-text": {
      body: '<path fill="currentColor" d="M21 4H3v2h18zm0 7H8v2h13zm0 7H8v2h13zM5 11H3v9h2z"/>',
    },
    "radar-fill": {
      body: '<path fill="currentColor" d="m14.369 4.398l-3.485 6.035l1.732 1l3.485-6.035c4.169 2.772 6.305 7.08 4.56 10.102c-1.86 3.222-7.19 3.355-11.91.63C4.028 13.402 1.48 8.721 3.34 5.5c1.745-3.023 6.543-3.327 11.028-1.102m1.515-2.625l1.732 1l-1.5 2.598l-1.732-1zM6.732 20H17v2H5.018a1 1 0 0 1-1.015-.922a1 1 0 0 1 .131-.578l2.25-3.897l1.732 1z"/>',
    },
    "radar-line": {
      body: '<path fill="currentColor" d="m12.507 3.623l-1.024 1.772c-2.91-.879-5.513-.45-6.41 1.105c-1.178 2.04.79 5.652 4.677 7.897c3.888 2.245 8.001 2.142 9.179.103c.897-1.555-.033-4.024-2.25-6.105l1.024-1.772c3.082 2.709 4.462 6.27 2.957 8.877c-1.86 3.222-7.188 3.355-11.91.63C4.03 13.402 1.48 8.721 3.34 5.5c1.505-2.607 5.28-3.192 9.167-1.877m3.377-1.85l1.732 1l-5 8.66l-1.732-1zM6.732 20H17v2H5.018a1 1 0 0 1-1.015-.922a1 1 0 0 1 .131-.578l2.25-3.897l1.732 1z"/>',
    },
    "radio-2-fill": {
      body: '<path fill="currentColor" d="M6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zm3 12a3 3 0 1 0 0-6a3 3 0 0 0 0 6m5-6v2h4V9zm0 4v2h4v-2z"/>',
    },
    "radio-2-line": {
      body: '<path fill="currentColor" d="M6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zM4 5v14h16V5zm5 10a3 3 0 1 1 0-6a3 3 0 0 1 0 6m5-6h4v2h-4zm0 4h4v2h-4z"/>',
    },
    "radio-button-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-6a4 4 0 1 0 0-8a4 4 0 0 0 0 8"/>',
    },
    "radio-button-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-3a5 5 0 1 1 0-10a5 5 0 0 1 0 10"/>',
    },
    "radio-fill": {
      body: '<path fill="currentColor" d="M17 10h3V6H4v4h11V8h2zM6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zm1 16a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "radio-line": {
      body: '<path fill="currentColor" d="M17 10V8h-2v2H5V6h14v4zM6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3zM4 5v14h16V5zm4 13a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "rainbow-fill": {
      body: '<path fill="currentColor" d="M12 4c6.075 0 11 4.925 11 11v5h-3v-5a8 8 0 0 0-7.75-7.996L12 7a8 8 0 0 0-7.996 7.75L4 15v5H1v-5C1 8.925 5.925 4 12 4m0 4a7 7 0 0 1 7 7v5h-3v-5a4 4 0 0 0-3.8-3.995L12 11a4 4 0 0 0-3.995 3.8L8 15v5H5v-5a7 7 0 0 1 7-7m0 4a3 3 0 0 1 3 3v5H9v-5a3 3 0 0 1 3-3"/>',
    },
    "rainbow-line": {
      body: '<path fill="currentColor" d="M12 4c6.075 0 11 4.925 11 11v5h-2v-5a9 9 0 0 0-8.735-8.996L12 6a9 9 0 0 0-8.996 8.735L3 15v5H1v-5C1 8.925 5.925 4 12 4m0 4a7 7 0 0 1 7 7v5h-2v-5a5 5 0 0 0-4.783-4.995L12 10a5 5 0 0 0-4.995 4.783L7 15v5H5v-5a7 7 0 0 1 7-7m0 4a3 3 0 0 1 3 3v5h-2v-5a1 1 0 0 0-.883-.993L12 14a1 1 0 0 0-.993.883L11 15v5H9v-5a3 3 0 0 1 3-3"/>',
    },
    "rainy-fill": {
      body: '<path fill="currentColor" d="m15.86 18l-3.153-3.153a1 1 0 0 0-1.414 0L8.18 17.96a8.001 8.001 0 1 1 7.8-11.873A6 6 0 1 1 17 18zm-5.628.732L12 16.965l1.768 1.767a2.5 2.5 0 1 1-3.536 0"/>',
    },
    "rainy-line": {
      body: '<path fill="currentColor" d="M16 18v-2h1a4 4 0 1 0-2.157-7.37A6 6 0 1 0 8 15.917v2.022A8.001 8.001 0 0 1 9 2a8 8 0 0 1 6.98 4.087A6 6 0 1 1 17 18zm-5.768.732L12 16.965l1.768 1.767a2.5 2.5 0 1 1-3.536 0"/>',
    },
    "ram-2-fill": {
      body: '<path fill="currentColor" d="M2 5h20a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1v2a1 1 0 0 1-1 1h-7.414l-1-1h-1.172l-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m2 11v1h5.586l1-1zm9.414 0l1 1H20v-1zM7 9H5v3h2zm2 0v3h2V9zm6 0h-2v3h2zm2 0v3h2V9z"/>',
    },
    "ram-2-line": {
      body: '<path fill="currentColor" d="M2 5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1v2a1 1 0 0 0 1 1h7.414l1-1h1.172l1 1H21a1 1 0 0 0 1-1v-2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm18 11v1h-5.586l-1-1zm-9.414 0l-1 1H4v-1zM3 14V7h18v7zm2-5h2v3H5zm6 0H9v3h2zm2 0h2v3h-2zm6 0h-2v3h2z"/>',
    },
    "ram-fill": {
      body: '<path fill="currentColor" d="M2 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm3 4h6v3H5zm8 0h6v3h-6z"/>',
    },
    "ram-line": {
      body: '<path fill="currentColor" d="M3 7h18v10h-2v-2h-2v2h-2v-2h-2v2h-2v-2H9v2H7v-2H5v2H3zM2 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm9 4H5v3h6zm2 0h6v3h-6z"/>',
    },
    "reactjs-fill": {
      body: '<path fill="currentColor" d="M14.448 16.24a22 22 0 0 1-1.747 2.175c1.673 1.623 3.228 2.383 4.091 1.884c.863-.498.982-2.225.413-4.484c-.853.19-1.779.334-2.757.424m-1.31.087a28 28 0 0 1-2.275 0c.376.492.758.948 1.137 1.363q.571-.623 1.138-1.364m5.04-7.894c2.665.764 4.406 2.034 4.406 3.567s-1.74 2.803-4.405 3.567c.67 2.69.44 4.832-.887 5.598c-1.327.767-3.297-.105-5.292-2.031c-1.994 1.925-3.964 2.798-5.291 2.031s-1.557-2.908-.887-5.598C3.157 14.803 1.417 13.533 1.417 12s1.74-2.803 4.405-3.567c-.67-2.69-.44-4.832.887-5.599c1.327-.766 3.297.106 5.291 2.032c1.995-1.926 3.965-2.798 5.292-2.032c1.327.767 1.557 2.909.887 5.599m-.973-.248c.57-2.26.45-3.986-.413-4.485c-.863-.498-2.418.262-4.09 1.885a22 22 0 0 1 1.746 2.175c.978.09 1.904.234 2.757.425m-10.41 7.63c-.569 2.26-.45 3.986.414 4.484c.863.498 2.418-.261 4.09-1.884a22 22 0 0 1-1.746-2.176a22 22 0 0 1-2.757-.425m4.068-8.142a28 28 0 0 1 2.275 0A21 21 0 0 0 12 6.31q-.57.625-1.137 1.364m-1.31.087a22 22 0 0 1 1.746-2.175C9.627 3.962 8.072 3.202 7.21 3.7c-.863.499-.983 2.226-.413 4.485c.853-.19 1.779-.334 2.757-.425m4.34 7.52A25.4 25.4 0 0 0 15.788 12a25.4 25.4 0 0 0-1.893-3.28a25.4 25.4 0 0 0-3.787 0A25.4 25.4 0 0 0 8.213 12a25.4 25.4 0 0 0 1.894 3.28a25.4 25.4 0 0 0 3.787 0m1.285-.132q.924-.12 1.75-.303a21 21 0 0 0-.612-1.667a28 28 0 0 1-1.137 1.97M8.823 8.851q-.924.121-1.75.304q.255.806.613 1.667a28 28 0 0 1 1.137-1.97m-1.75 5.994q.826.182 1.75.303a28 28 0 0 1-1.137-1.97a21 21 0 0 0-.613 1.667m-.978-.245c.262-.834.6-1.708 1.01-2.6a22 22 0 0 1-1.01-2.6c-2.241.636-3.677 1.604-3.677 2.6s1.436 1.963 3.677 2.6M16.93 9.155q-.827-.183-1.75-.304a28 28 0 0 1 1.137 1.97q.357-.86.613-1.666m.977.245c-.26.834-.6 1.708-1.01 2.6c.41.892.75 1.766 1.01 2.6c2.242-.637 3.678-1.604 3.678-2.6s-1.436-1.963-3.678-2.6M12 13.879a1.88 1.88 0 1 1 0-3.758a1.88 1.88 0 0 1 0 3.758"/>',
    },
    "reactjs-line": {
      body: '<path fill="currentColor" d="M12.001 13.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-.528 2.994q.262.316.528.609q.266-.292.528-.609a25 25 0 0 1-1.056 0m-1.995-.125a21 21 0 0 1-2.285-.367q-.113.525-.17 1.015c-.19 1.583.075 2.545.478 2.777s1.368-.019 2.645-.974q.395-.296.794-.655a21 21 0 0 1-1.462-1.796m7.331-.367a21 21 0 0 1-2.285.367a21 21 0 0 1-1.462 1.796q.4.36.794.655c1.277.955 2.242 1.207 2.645.974c.403-.232.667-1.194.479-2.777a11 11 0 0 0-.17-1.015m1.45-.388c.577 2.639.274 4.74-1.008 5.48s-3.253-.048-5.25-1.867c-1.997 1.819-3.968 2.606-5.25 1.866s-1.585-2.84-1.009-5.48C3.168 14.794 1.501 13.48 1.501 12s1.667-2.793 4.241-3.613c-.576-2.64-.273-4.74 1.009-5.48s3.253.047 5.25 1.866c1.997-1.819 3.968-2.606 5.25-1.866s1.585 2.84 1.009 5.48c2.573.82 4.24 2.133 4.24 3.613s-1.668 2.794-4.241 3.614m-7.32-9.779q-.398-.359-.793-.655C8.869 4.225 7.904 3.973 7.5 4.206c-.403.232-.667 1.194-.479 2.778q.06.49.17 1.015a21 21 0 0 1 2.286-.368q.714-.981 1.462-1.796m3.585 1.796a21 21 0 0 1 2.285.368q.113-.526.17-1.015c.19-1.584-.075-2.546-.478-2.778s-1.368.019-2.645.974q-.395.296-.794.655q.748.815 1.462 1.796m-1.995-.125q-.262-.316-.528-.609q-.265.293-.528.609a25 25 0 0 1 1.056 0m-4.156 7.198a25 25 0 0 1-.528-.914q-.143.385-.263.762q.386.083.79.152m1.932.234a23 23 0 0 0 3.392 0A23 23 0 0 0 15.393 12a23 23 0 0 0-1.696-2.938a23 23 0 0 0-3.392 0A23 23 0 0 0 8.609 12a23 23 0 0 0 1.696 2.938m5.852-4.728q.143-.385.263-.761a18 18 0 0 0-.79-.153a25 25 0 0 1 .527.914M6.131 9.837q-.51.165-.964.36c-1.465.628-2.166 1.338-2.166 1.803s.7 1.175 2.166 1.803q.454.195.964.36c.222-.7.497-1.426.825-2.163a21 21 0 0 1-.825-2.163m1.45-.388q.121.375.264.76a25 25 0 0 1 .528-.913q-.405.069-.791.153m10.29 4.714q.51-.165.964-.36C20.3 13.175 21 12.465 21 12s-.7-1.175-2.166-1.803q-.454-.195-.965-.36c-.22.7-.496 1.426-.824 2.163c.328.737.603 1.463.825 2.163m-1.45.389q-.122-.377-.264-.762a25 25 0 0 1-.528.914q.405-.07.791-.152"/>',
    },
    "receipt-fill": {
      body: '<path fill="currentColor" d="M9 4L6 2L3 4v15a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-2H7v2a1 1 0 1 1-2 0v-4h16V4l-3-2l-3 2l-3-2z"/>',
    },
    "receipt-line": {
      body: '<path fill="currentColor" d="M9 4L6 2L3 4v15a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-3h-2V4l-3-2l-3 2l-3-2zm10 12H7v3a1 1 0 1 1-2 0V5.07l1-.666l3 2l3-2l3 2l3-2l1 .666zm1 4H8.83c.11-.313.17-.65.17-1v-1h12v1a1 1 0 0 1-1 1"/>',
    },
    "record-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-7a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "record-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-5a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "record-mail-fill": {
      body: '<path fill="currentColor" d="M9.743 15h4.514a5.5 5.5 0 1 1 4.243 2h-13a5.5 5.5 0 1 1 4.243-2M5.5 13a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m13 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "record-mail-line": {
      body: '<path fill="currentColor" d="M14.257 15a5.5 5.5 0 1 1 4.243 2h-13a5.5 5.5 0 1 1 4.243-2zM5.5 15a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7m13 0a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7"/>',
    },
    "rectangle-fill": {
      body: '<path fill="currentColor" d="M3 4h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"/>',
    },
    "rectangle-line": {
      body: '<path fill="currentColor" d="M3 4h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m1 2v12h16V6z"/>',
    },
    "recycle-fill": {
      body: '<path fill="currentColor" d="m19.561 12.099l1.532 2.651A3.5 3.5 0 0 1 18.06 20H16v2l-5-3.5l5-3.5v2h2.062a.5.5 0 0 0 .471-.668l-.038-.082l-1.53-2.652zM7.736 9.384l.531 6.08l-1.731-1l-1.032 1.786a.5.5 0 0 0 .343.742l.09.008H9v3H5.937a3.5 3.5 0 0 1-3.031-5.25l1.032-1.786l-1.733-1zM13.75 2.97a3.5 3.5 0 0 1 1.28 1.28l1.031 1.786l1.733-1l-.532 6.08l-5.53-2.58l1.73-1l-1.03-1.786a.5.5 0 0 0-.814-.074l-.052.074l-1.53 2.652l-2.598-1.5l1.53-2.652a3.5 3.5 0 0 1 4.782-1.28"/>',
    },
    "recycle-line": {
      body: '<path fill="currentColor" d="m19.56 12.098l1.532 2.652A3.5 3.5 0 0 1 18.061 20h-2.062v2.5l-5-3.5l5-3.5V18h2.062a1.5 1.5 0 0 0 1.299-2.25l-1.532-2.652zM7.304 9.134l.53 6.08l-2.165-1.25l-1.03 1.786A1.5 1.5 0 0 0 5.937 18h3.062v2H5.937a3.5 3.5 0 0 1-3.032-5.25l1.031-1.787l-2.165-1.249zm6.446-6.165a3.5 3.5 0 0 1 1.28 1.281l1.032 1.786l2.165-1.25l-.531 6.08l-5.531-2.58l2.165-1.25l-1.031-1.786a1.5 1.5 0 0 0-2.598 0L9.168 7.903l-1.732-1L8.968 4.25a3.5 3.5 0 0 1 4.78-1.281"/>',
    },
    "red-packet-fill": {
      body: '<path fill="currentColor" d="M21.005 5.94a12 12 0 0 1-6.806 3.863a2.5 2.5 0 0 0-4.388 0A12 12 0 0 1 3.005 5.94V3.003a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1zm0 2.787v12.276a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V8.727a13.95 13.95 0 0 0 6.63 3.076a2.501 2.501 0 0 0 4.739 0a13.95 13.95 0 0 0 6.63-3.076"/>',
    },
    "red-packet-line": {
      body: '<path fill="currentColor" d="M14.178 9.766a10 10 0 0 0 4.827-2.622V4.003h-14v3.141a10 10 0 0 0 4.827 2.622a2.5 2.5 0 0 1 4.346 0m.208 2a2.501 2.501 0 0 1-4.762 0a11.9 11.9 0 0 1-4.62-2.015v10.252h14V9.75a11.9 11.9 0 0 1-4.618 2.016M4.005 2.004h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-18a1 1 0 0 1 1-1"/>',
    },
    "reddit-fill": {
      body: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m6.67-10a1.46 1.46 0 0 0-2.47-1a7.1 7.1 0 0 0-3.85-1.23l.65-3.12l2.14.45a1 1 0 1 0 .13-.61L12.821 6a.31.31 0 0 0-.37.24l-.74 3.47a7.14 7.14 0 0 0-3.9 1.23a1.46 1.46 0 1 0-1.61 2.39a3 3 0 0 0 0 .44c0 2.24 2.61 4.06 5.83 4.06s5.83-1.82 5.83-4.06a3 3 0 0 0 0-.44a1.46 1.46 0 0 0 .81-1.33m-10 1a1 1 0 1 1 2 0a1 1 0 0 1-2 0m5.81 2.75a3.84 3.84 0 0 1-2.47.77a3.84 3.84 0 0 1-2.47-.77a.27.27 0 0 1 .38-.38a3.27 3.27 0 0 0 2.08.63a3.28 3.28 0 0 0 2.09-.61a.28.28 0 1 1 .39.4zm-.18-1.71a1 1 0 1 1 1-1a1 1 0 0 1-1.01 1.04z"/>',
    },
    "reddit-line": {
      body: '<path fill="currentColor" d="m11.053 7.815l.751-3.536a2 2 0 0 1 2.372-1.54l3.196.68a2 2 0 1 1-.415 1.956l-3.197-.68l-.666 3.135c1.785.137 3.558.73 5.164 1.7A3.192 3.192 0 0 1 23 12.203v.021a3.2 3.2 0 0 1-1.207 2.55l-.008.123c0 3.998-4.45 7.03-9.799 7.03c-5.333 0-9.708-3.024-9.705-6.953l-.01-.181a3.193 3.193 0 0 1 3.454-5.35a11.45 11.45 0 0 1 5.329-1.628m9.285 5.526a1.19 1.19 0 0 0 .662-1.075a1.192 1.192 0 0 0-2.016-.806l-.585.56l-.67-.455c-1.615-1.098-3.452-1.725-5.23-1.764h-1.006c-1.875.028-3.652.6-5.237 1.675l-.664.45l-.583-.55a1.192 1.192 0 1 0-1.315 1.952l.633.29l-.053.695a4 4 0 0 0 .003.584c0 2.71 3.356 5.03 7.708 5.03c4.371 0 7.799-2.336 7.802-5.107a3 3 0 0 0 0-.507l-.052-.672zM6.951 13.5a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m7 0a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m-1.985 5.103c-1.397 0-2.766-.37-3.881-1.21a.424.424 0 0 1 .597-.597c.945.693 2.123.99 3.269.99s2.33-.275 3.284-.959a.44.44 0 0 1 .732.206a.47.47 0 0 1-.12.423c-.683.797-2.483 1.147-3.88 1.147"/>',
    },
    "refresh-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m4.82-4.924A7 7 0 0 0 9.032 5.658l.975 1.755A5 5 0 0 1 17 12h-3zm-1.852 1.266l-.975-1.755A5 5 0 0 1 7 12h3L7.18 6.924a7 7 0 0 0 7.788 11.418"/>',
    },
    "refresh-line": {
      body: '<path fill="currentColor" d="M5.463 4.433A9.96 9.96 0 0 1 12 2c5.523 0 10 4.477 10 10c0 2.136-.67 4.116-1.81 5.74L17 12h3A8 8 0 0 0 6.46 6.228zm13.074 15.134A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.136.67-4.116 1.81-5.74L7 12H4a8 8 0 0 0 13.54 5.772z"/>',
    },
    "refund-2-fill": {
      body: '<path fill="currentColor" d="M12.005 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-6.383-2.302l-.244-.209l.901-1.902a8 8 0 1 0-2.27-5.837l-.004.25h2.5l-2.706 5.716A9.95 9.95 0 0 1 2.005 12c0-5.523 4.477-10 10-10m1 4v2h2.5v2h-5.5a.5.5 0 0 0-.09.992l.09.008h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5v-2h5.5a.5.5 0 0 0 .09-.992l-.09-.008h-4a2.5 2.5 0 1 1 0-5h1V6z"/>',
    },
    "refund-2-line": {
      body: '<path fill="currentColor" d="M5.676 4.257c3.928-3.219 9.733-2.995 13.4.672c3.905 3.905 3.905 10.237 0 14.142s-10.237 3.905-14.142 0a9.99 9.99 0 0 1-2.678-9.304l.077-.313l1.934.51a8 8 0 1 0 3.053-4.45l-.22.166l1.017 1.017l-4.596 1.06l1.06-4.596zM13.005 6v2h2.5v2h-5.5a.5.5 0 0 0-.09.992l.09.008h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5v-2h5.5a.5.5 0 0 0 .09-.992l-.09-.008h-4a2.5 2.5 0 1 1 0-5h1V6z"/>',
    },
    "refund-fill": {
      body: '<path fill="currentColor" d="M22.005 7h-20V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm0 2v11a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V9zm-11 5v-2.5l-4.5 4.5h10.5v-2z"/>',
    },
    "refund-line": {
      body: '<path fill="currentColor" d="M20.005 8V5h-16v3zm0 2h-16v9h16zm-17-7h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 11h6v2h-10.5l4.5-4.5z"/>',
    },
    "registered-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m.5 5H8v10h2v-3h2.217l2.18 3h2.472l-2.55-3.51a3.5 3.5 0 0 0-1.627-6.486zm0 2a1.5 1.5 0 0 1 1.493 1.355L14 10.5l-.007.145a1.5 1.5 0 0 1-1.348 1.348L12.5 12H10V9z"/>',
    },
    "registered-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m.5 3a3.5 3.5 0 0 1 1.82 6.49L16.868 17h-2.472l-2.18-3H10v3H8V7zm0 2H10v3h2.5a1.5 1.5 0 0 0 1.493-1.355L14 10.5A1.5 1.5 0 0 0 12.5 9"/>',
    },
    "remix-run-fill": {
      body: '<path fill="currentColor" d="M19.116 20c0-1.064 0-2.04-.162-4.119c-.2-2.09-1.289-3.148-3.15-3.52c2.205-.286 3.837-2.004 3.837-4.637C19.64 4.204 17.32 2 12.656 2H4v3.669h7.797c2.061 0 3.092.884 3.092 2.344c0 1.66-1.03 2.287-3.092 2.287H4v3.75h7.568c1.632 0 2.52.457 2.662 2.518a25 25 0 0 1 .082 2.773v.003c-.004.214-.008.425-.008.656zM4 17.205V20h6.122v-1.79c0-.375-.184-1.005-1.034-1.005z"/>',
    },
    "remix-run-line": {
      body: '<path fill="currentColor" d="M4 2h10.5a6 6 0 0 1 3.054 11.166A6 6 0 0 1 20 18v3h-2v-3a4 4 0 0 0-4-4H4v-2h10.5a4 4 0 0 0 0-8H4zm7 19H4v-2h7z"/>',
    },
    "remixicon-fill": {
      body: '<path fill="currentColor" d="M16.53 17.53L20.001 21h-17V4h10.667v.008A7 7 0 0 1 14.137 4q-.135.556-.136 1.166c0 2.318 2.015 4.333 4.667 4.333a4.2 4.2 0 0 0 2.032-.538a7 7 0 0 1-4.17 8.567M18.501 7.5a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5"/>',
    },
    "remixicon-line": {
      body: '<path fill="currentColor" d="m6.365 6l8.784 9.663l.72-.283c1.685-.661 2.864-2.156 3.092-3.896q-.23.016-.46.016A6.5 6.5 0 0 1 12.077 6zM14 5a4.5 4.5 0 0 0 6.714 3.918c.186.618.286 1.271.286 1.947c0 2.891-1.822 5.365-4.4 6.377L20 21H3V4h11.111A4.5 4.5 0 0 0 14 5m4.5 2.5a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5M5 7.47V19h10.48z"/>',
    },
    "remote-control-2-fill": {
      body: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-3 13h-2v2h2zm-4 0H9v2h2zm2-9h-2v2H9v2h1.999L11 12h2l-.001-2H15V8h-2z"/>',
    },
    "remote-control-2-line": {
      body: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-1 2H7v16h10zm-2 11v2h-2v-2zm-4 0v2H9v-2zm2-9v2h2v2h-2.001L13 12h-2l-.001-2H9V8h2V6z"/>',
    },
    "remote-control-fill": {
      body: '<path fill="currentColor" d="M17 12a1 1 0 0 1 1 1v9H6v-9a1 1 0 0 1 1-1zm-7 2H8v2h2zm2-8a6 6 0 0 1 5.368 3.316l-1.79.895a4 4 0 0 0-7.156 0l-1.79-.895A6 6 0 0 1 12 6m0-4a10 10 0 0 1 8.947 5.527l-1.79.895A8 8 0 0 0 12 4a8 8 0 0 0-7.157 4.422l-1.79-.895A10 10 0 0 1 12 2"/>',
    },
    "remote-control-line": {
      body: '<path fill="currentColor" d="M17 12a1 1 0 0 1 1 1v9h-2v-8H8v8H6v-9a1 1 0 0 1 1-1zm-5 4v2h-2v-2zm0-10a6 6 0 0 1 5.368 3.316l-1.79.895a4 4 0 0 0-7.156 0l-1.79-.895A6 6 0 0 1 12 6m0-4a10 10 0 0 1 8.947 5.527l-1.79.895A8 8 0 0 0 12 4a8 8 0 0 0-7.157 4.422l-1.79-.895A10 10 0 0 1 12 2"/>',
    },
    "repeat-2-fill": {
      body: '<path fill="currentColor" d="M8 20v1.933a.5.5 0 0 1-.82.384l-4.12-3.433A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4zm8-16V2.068a.5.5 0 0 1 .82-.385l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4z"/>',
    },
    "repeat-2-line": {
      body: '<path fill="currentColor" d="M8 20v1.932a.5.5 0 0 1-.82.385l-4.12-3.433A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4zm8-16V2.068a.5.5 0 0 1 .82-.385l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4z"/>',
    },
    "repeat-fill": {
      body: '<path fill="currentColor" d="M6 4h15a1 1 0 0 1 1 1v7h-2V6H6v3L1 5l5-4zm12 16H3a1 1 0 0 1-1-1v-7h2v6h14v-3l5 4l-5 4z"/>',
    },
    "repeat-line": {
      body: '<path fill="currentColor" d="M6 4h15a1 1 0 0 1 1 1v7h-2V6H6v3L1 5l5-4zm12 16H3a1 1 0 0 1-1-1v-7h2v6h14v-3l5 4l-5 4z"/>',
    },
    "repeat-one-fill": {
      body: '<path fill="currentColor" d="M8 20v1.933a.5.5 0 0 1-.82.384l-4.12-3.433A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4zm8-16V2.068a.5.5 0 0 1 .82-.385l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4zm-5 4h2v8h-2v-6H9V9z"/>',
    },
    "repeat-one-line": {
      body: '<path fill="currentColor" d="M8 20v1.933a.5.5 0 0 1-.82.384l-4.12-3.433A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4zm8-17.932a.5.5 0 0 1 .82-.385l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4h10zM11 8h2v8h-2v-6H9V9z"/>',
    },
    "replay-10-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.865-5.135L8 9H2V3l2.447 2.446A9.98 9.98 0 0 1 12 2m2.5 6.25a2.5 2.5 0 0 0-2.5 2.5v2.5a2.5 2.5 0 0 0 5 0v-2.5a2.5 2.5 0 0 0-2.5-2.5m1 2.5v2.5a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0M10 8.5H8.5v7H10z"/>',
    },
    "replay-10-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.99 9.99 0 0 1 8-4m3.5 11.25a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0zm-1-5a2.5 2.5 0 0 0-2.5 2.5v2.5a2.5 2.5 0 0 0 5 0v-2.5a2.5 2.5 0 0 0-2.5-2.5m-6 7.25v-7H10v7z"/>',
    },
    "replay-15-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.865-5.135L8 9H2V3l2.447 2.446A9.98 9.98 0 0 1 12 2M8.5 8.5H10v7H8.5zm8.25 0H12v4.25h2.875a.625.625 0 1 1 0 1.25H12v1.5h2.875a2.125 2.125 0 0 0 0-4.25H13.5V10h3.25z"/>',
    },
    "replay-15-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.99 9.99 0 0 1 8-4M8.5 15.5v-7H10v7zm3.5-7h4.75V10H13.5v1.25h1.375a2.125 2.125 0 0 1 0 4.25H12V14h2.875a.625.625 0 1 0 0-1.25H12z"/>',
    },
    "replay-30-fill": {
      body: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.98 9.98 0 0 0-7.553 3.446L2 3v6h4.75v1h2.625a.625.625 0 1 1 0 1.25H7.5v1.5h1.875a.625.625 0 1 1 0 1.25H6.75v1.5h2.625a2.125 2.125 0 0 0 1.62-3.5a2.125 2.125 0 0 0-1.62-3.5H7.5L5.865 6.865A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10m-9.5-1.25a2.5 2.5 0 0 1 5 0v2.5a2.5 2.5 0 0 1-5 0zm2.5-1a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1"/>',
    },
    "replay-30-line": {
      body: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.99 9.99 0 0 0-8 4V3.5H2v6h4.75v.5h2.625a.625.625 0 1 1 0 1.25H7.5v1.5h1.875a.625.625 0 1 1 0 1.25H6.75v1.5h2.625a2.125 2.125 0 0 0 1.62-3.5a2.125 2.125 0 0 0-1.62-3.5H8v-1H5.385A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10m-9.5-1.25a2.5 2.5 0 0 1 5 0v2.5a2.5 2.5 0 0 1-5 0zm2.5-1a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1"/>',
    },
    "replay-5-fill": {
      body: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.98 9.98 0 0 0-7.553 3.446L2 3v6h6L5.865 6.865A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10m-7.5-2V8.5h-5v4.25h3.125a.625.625 0 1 1 0 1.25H9.5v1.5h3.125a2.125 2.125 0 0 0 0-4.25H11V10z"/>',
    },
    "replay-5-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.99 9.99 0 0 1 8-4M9.5 8.5h5V10H11v1.25h1.625a2.125 2.125 0 0 1 0 4.25H9.5V14h3.125a.625.625 0 1 0 0-1.25H9.5z"/>',
    },
    "reply-all-fill": {
      body: '<path fill="currentColor" d="M14 4.5V9c5.523 0 10 4.477 10 10q0 .41-.032.81a9 9 0 0 0-7.655-4.805L16 15h-2v4.5L6 12zm-6 0v2.737L2.92 12l5.079 4.761L8 19.5L0 12z"/>',
    },
    "reply-all-line": {
      body: '<path fill="currentColor" d="M14 4.5V9c5.523 0 10 4.477 10 10q0 .41-.032.81a9 9 0 0 0-7.655-4.805L16 15h-2v4.5L6 12zm-6 0v2.737L2.92 12l5.079 4.761L8 19.5L0 12zm4 4.616L8.924 12L12 14.883V13h4.034l.347.007c1.285.043 2.524.31 3.676.766A7.98 7.98 0 0 0 14 11h-2z"/>',
    },
    "reply-fill": {
      body: '<path fill="currentColor" d="M11 20L1 12l10-8v5c5.523 0 10 4.477 10 10q0 .41-.032.81A9 9 0 0 0 13 15h-2z"/>',
    },
    "reply-line": {
      body: '<path fill="currentColor" d="M11 20L1 12l10-8v5c5.523 0 10 4.477 10 10q0 .41-.032.81a9 9 0 0 0-7.655-4.805L13 15h-2zm-2-7h4.034l.347.007c1.285.043 2.524.31 3.676.766A7.98 7.98 0 0 0 11 11H9V8.161L4.202 12L9 15.839z"/>',
    },
    "reserved-fill": {
      body: '<path fill="currentColor" d="M13 15v4h3v2H8v-2h3v-4H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM8 8v2h8V8z"/>',
    },
    "reserved-line": {
      body: '<path fill="currentColor" d="M13 15v4h3v2H8v-2h3v-4H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zm-8-2h14V5H5zm3-5h8v2H8z"/>',
    },
    "reset-left-fill": {
      body: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2v2a8 8 0 1 0 5.135 1.865L15 8V2h6l-2.447 2.447A9.98 9.98 0 0 1 22 12"/>',
    },
    "reset-left-line": {
      body: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2v2a8 8 0 1 0 4.5 1.385V8h-2V2h6v2H18a9.99 9.99 0 0 1 4 8"/>',
    },
    "reset-right-fill": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2v2a8 8 0 1 1-5.135 1.865L9 8V2H3l2.446 2.447A9.98 9.98 0 0 0 2 12"/>',
    },
    "reset-right-line": {
      body: '<path fill="currentColor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2v2a8 8 0 1 1-4.5 1.385V8h2V2h-6v2H6a9.99 9.99 0 0 0-4 8"/>',
    },
    "rest-time-fill": {
      body: '<path fill="currentColor" d="M11 6v8h8a8 8 0 1 1-16 0c0-4.335 3.58-8 8-8m10-4v2l-5.327 6H21v2h-8v-2l5.326-6H13V2z"/>',
    },
    "rest-time-line": {
      body: '<path fill="currentColor" d="M11 6v2a6 6 0 1 0 5.996 6.225L17 14h2a8 8 0 1 1-16 0c0-4.335 3.58-8 8-8m10-4v2l-5.327 6H21v2h-8v-2l5.326-6H13V2z"/>',
    },
    "restart-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m4.82-4.924a7 7 0 1 0-1.853 1.266l-.974-1.755A5 5 0 1 1 17 12h-3z"/>',
    },
    "restart-line": {
      body: '<path fill="currentColor" d="M18.537 19.567A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c0 2.136-.67 4.116-1.81 5.74L17 12h3a8 8 0 1 0-2.46 5.772z"/>',
    },
    "restaurant-2-fill": {
      body: '<path fill="currentColor" d="m4.222 3.808l6.718 6.717l-2.829 2.829l-3.889-3.89a4 4 0 0 1 0-5.656m10.046 8.338l-.853.854l7.07 7.071l-1.413 1.414L12 14.415l-7.072 7.07l-1.414-1.414l9.339-9.339c-.588-1.457.02-3.555 1.621-5.157c1.953-1.952 4.644-2.427 6.01-1.06c1.368 1.366.893 4.057-1.06 6.01c-1.602 1.602-3.7 2.21-5.157 1.621"/>',
    },
    "restaurant-2-line": {
      body: '<path fill="currentColor" d="m14.268 12.147l-.853.853l7.07 7.071l-1.413 1.414L12 14.415l-7.072 7.07l-1.414-1.414l9.339-9.339c-.588-1.457.02-3.555 1.621-5.156c1.953-1.953 4.644-2.428 6.01-1.061c1.368 1.367.893 4.058-1.06 6.01c-1.602 1.602-3.7 2.21-5.157 1.622M4.222 3.807l6.718 6.718l-2.829 2.829l-3.889-3.89a4 4 0 0 1 0-5.656m13.789 5.304c1.257-1.257 1.516-2.726 1.06-3.182s-1.924-.196-3.181 1.06c-1.258 1.258-1.517 2.727-1.061 3.183s1.925.196 3.182-1.06"/>',
    },
    "restaurant-fill": {
      body: '<path fill="currentColor" d="M21 2v20h-2v-8h-3V7a5 5 0 0 1 5-5M9 13.9V22H7v-8.1A5 5 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5 5 0 0 1-4 4.9"/>',
    },
    "restaurant-line": {
      body: '<path fill="currentColor" d="M21 2v20h-2v-7h-4V8a6 6 0 0 1 6-6m-2 2.53C18.17 5 17 6.17 17 8v5h2zM9 13.9V22H7v-8.1A5 5 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5 5 0 0 1-4 4.9"/>',
    },
    "rewind-fill": {
      body: '<path fill="currentColor" d="m12 10.667l9.223-6.149a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L12 13.333v5.733a.5.5 0 0 1-.777.416L.624 12.416a.5.5 0 0 1 0-.832l10.599-7.066a.5.5 0 0 1 .777.416z"/>',
    },
    "rewind-line": {
      body: '<path fill="currentColor" d="m12 10.667l9.223-6.149a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L12 13.333v5.733a.5.5 0 0 1-.777.416L.624 12.416a.5.5 0 0 1 0-.832l10.599-7.066a.5.5 0 0 1 .777.416zm-2 5.596V7.737L3.606 12zm10 0V7.737L13.606 12z"/>',
    },
    "rewind-mini-fill": {
      body: '<path fill="currentColor" d="M11 17.035a.5.5 0 0 1-.788.409l-7.133-5.035a.5.5 0 0 1 0-.818l7.133-5.035a.5.5 0 0 1 .788.409zm1.079-4.626a.5.5 0 0 1 0-.818l7.133-5.035a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.409z"/>',
    },
    "rewind-mini-line": {
      body: '<path fill="currentColor" d="M9 9.86L5.968 12L9 14.14zm1.909 7.463a.5.5 0 0 1-.697.12l-7.133-5.035a.5.5 0 0 1 0-.816l7.133-5.036a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.091.288M18 14.14V9.86L14.968 12zm-5.921-1.732a.5.5 0 0 1 0-.816l7.133-5.036a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.409z"/>',
    },
    "rewind-start-fill": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0v-5.667l9.223 6.149a.5.5 0 0 0 .777-.416v-5.733l9.223 6.149a.5.5 0 0 0 .777-.416V4.934a.5.5 0 0 0-.777-.416L13 10.666V4.934a.5.5 0 0 0-.777-.416L3 10.667V5a1 1 0 0 0-1-1"/>',
    },
    "rewind-start-line": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0v-5.667l9.223 6.149a.5.5 0 0 0 .777-.416v-5.733l9.223 6.149a.5.5 0 0 0 .777-.416V4.934a.5.5 0 0 0-.777-.416L13 10.666V4.934a.5.5 0 0 0-.777-.416L3 10.667V5a1 1 0 0 0-1-1m9 3.737v8.526L4.606 12zm10 0v8.526L14.606 12z"/>',
    },
    "rewind-start-mini-fill": {
      body: '<path fill="currentColor" d="M3 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1m9.909 11.323a.5.5 0 0 0 .091-.288V6.965a.5.5 0 0 0-.788-.409l-7.133 5.035a.5.5 0 0 0 0 .817l7.133 5.035a.5.5 0 0 0 .697-.12m1.05-5.035a.5.5 0 0 0 .12.12l7.133 5.035a.5.5 0 0 0 .788-.408V6.965a.5.5 0 0 0-.788-.409l-7.133 5.035a.5.5 0 0 0-.12.697"/>',
    },
    "rewind-start-mini-line": {
      body: '<path fill="currentColor" d="M3 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1m4.968 6L11 9.86v4.28zm4.244 5.443a.5.5 0 0 0 .788-.408V6.965a.5.5 0 0 0-.788-.409l-7.133 5.035a.5.5 0 0 0 0 .817zM16.968 12L20 9.86v4.28zm-3.01.288a.5.5 0 0 0 .12.12l7.134 5.035a.5.5 0 0 0 .788-.408V6.965a.5.5 0 0 0-.788-.409l-7.133 5.035a.5.5 0 0 0-.12.697"/>',
    },
    "rfid-fill": {
      body: '<path fill="currentColor" d="M18.364 18.364a9 9 0 0 0 0-12.728l1.414-1.414c4.296 4.296 4.296 11.26 0 15.556zM5.636 5.636a9 9 0 0 0 0 12.728l-1.414 1.414c-4.296-4.295-4.296-11.26 0-15.556zm9.9 9.9a5 5 0 0 0 0-7.072L16.95 7.05a7 7 0 0 1 0 9.9zM8.464 8.464a5 5 0 0 0 0 7.072L7.05 16.95a7 7 0 0 1 0-9.9zM12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "rfid-line": {
      body: '<path fill="currentColor" d="M18.364 18.364a9 9 0 0 0 0-12.728l1.414-1.414c4.296 4.296 4.296 11.26 0 15.556zM5.636 5.636a9 9 0 0 0 0 12.728l-1.414 1.414c-4.296-4.295-4.296-11.26 0-15.556zm9.9 9.9a5 5 0 0 0 0-7.072L16.95 7.05a7 7 0 0 1 0 9.9zM8.464 8.464a5 5 0 0 0 0 7.072L7.05 16.95a7 7 0 0 1 0-9.9zM12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "rhythm-fill": {
      body: '<path fill="currentColor" d="M2 9h2v12H2zm6-6h2v18H8zm6 9h2v9h-2zm6-6h2v15h-2z"/>',
    },
    "rhythm-line": {
      body: '<path fill="currentColor" d="M2 9h2v12H2zm6-6h2v18H8zm6 9h2v9h-2zm6-6h2v15h-2z"/>',
    },
    "riding-fill": {
      body: '<path fill="currentColor" d="M5.5 21a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0-3a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m13 3a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0-3a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-6.969-8.203L13 12v6h-2v-5l-2.719-2.266A2 2 0 0 1 8 7.671l2.828-2.828a2 2 0 0 1 2.829 0l1.414 1.414a6.97 6.97 0 0 0 3.917 1.975l-.01 2.015a8.96 8.96 0 0 1-5.321-2.575zM16 5a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "riding-line": {
      body: '<path fill="currentColor" d="M5.5 21a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0-2a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m13 2a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0-2a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m-7.477-8.695L13 12v6h-2v-5l-2.719-2.266A2 2 0 0 1 8 7.671l2.828-2.828a2 2 0 0 1 2.829 0l1.414 1.414a6.97 6.97 0 0 0 3.917 1.975l-.01 2.015a8.96 8.96 0 0 1-5.321-2.575zM16 5a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "road-map-fill": {
      body: '<path fill="currentColor" d="M16.95 11.95a7 7 0 0 0 1.858-6.582l2.495-1.07a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46V7l3.129-1.341a7 7 0 0 0 1.921 6.29L12 16.9zm-1.414-1.414L12 14.07l-3.536-3.535a5 5 0 1 1 7.072 0"/>',
    },
    "road-map-line": {
      body: '<path fill="currentColor" d="M4 6.143v12.824l5.065-2.17l6 3L20 17.68V4.857l1.303-.558a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46V7zm12.243 5.1L12 15.485l-4.243-4.242a6 6 0 1 1 8.486 0M12 12.657l2.828-2.829a4 4 0 1 0-5.656 0z"/>',
    },
    "roadster-fill": {
      body: '<path fill="currentColor" d="M22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5h1.875l2.138-5.702A2 2 0 0 1 6.386 4h11.228a2 2 0 0 1 1.873 1.298L21.625 11H23.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97zM4 15v2a1 1 0 0 0 1 1h3.245a.5.5 0 0 0 .44-.736Q7.476 15 4 15m16 0q-3.476 0-4.686 2.264a.5.5 0 0 0 .441.736H19a1 1 0 0 0 1-1zM6 6l-1.561 4.684A1 1 0 0 0 5.387 12h13.226a1 1 0 0 0 .948-1.316L18 6z"/>',
    },
    "roadster-line": {
      body: '<path fill="currentColor" d="M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5H2l2.48-5.788A2 2 0 0 1 6.32 4h11.36a2 2 0 0 1 1.838 1.212L22 11h1.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97L22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm1-2v-5H4v5zM5.477 11h13.046a1 1 0 0 0 .928-1.371L18 6H6L4.549 9.629A1 1 0 0 0 5.477 11M5 14q3.476 0 4.686 2.264a.5.5 0 0 1-.441.736H6a1 1 0 0 1-1-1zm14 0v2a1 1 0 0 1-1 1h-3.245a.5.5 0 0 1-.44-.736Q15.524 14 19 14"/>',
    },
    "robot-2-fill": {
      body: '<path fill="currentColor" d="M13.5 2c0 .444-.193.843-.5 1.118V5h5a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h5V3.118A1.5 1.5 0 1 1 13.5 2M0 10h2v6H0zm24 0h-2v6h2zM9 14.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m7.5-1.5a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0"/>',
    },
    "robot-2-line": {
      body: '<path fill="currentColor" d="M13.5 2c0 .444-.193.843-.5 1.118V5h5a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h5V3.118A1.5 1.5 0 1 1 13.5 2M6 7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm-4 3H0v6h2zm20 0h2v6h-2zM9 14.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m6 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "robot-3-fill": {
      body: '<path fill="currentColor" d="M17 2h-4V1h-2v1H7a3 3 0 0 0-3 3v3a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5V5a3 3 0 0 0-3-3m-6 5.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m5 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M4 22a8 8 0 1 1 16 0z"/>',
    },
    "robot-3-line": {
      body: '<path fill="currentColor" d="M11 1v1H7a3 3 0 0 0-3 3v3a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5V5a3 3 0 0 0-3-3h-4V1zM6 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3zm3.5 4a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M6 22a6 6 0 0 1 12 0h2a8 8 0 1 0-16 0z"/>',
    },
    "robot-fill": {
      body: '<path fill="currentColor" d="M13 4.055A9 9 0 0 1 21 13v9H3v-9a9 9 0 0 1 8-8.945V1h2zM12 18a5 5 0 1 0 0-10a5 5 0 0 0 0 10m0-2a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "robot-line": {
      body: '<path fill="currentColor" d="M13 4.055A9 9 0 0 1 21 13v9H3v-9a9 9 0 0 1 8-8.945V1h2zM19 20v-7a7 7 0 1 0-14 0v7zm-7-2a5 5 0 1 1 0-10a5 5 0 0 1 0 10m0-2a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "rocket-2-fill": {
      body: '<path fill="currentColor" d="M8.498 20.005h7.004A6.52 6.52 0 0 1 12 23.507a6.52 6.52 0 0 1-3.502-3.502M18 14.81l2 2.268v1.927H4v-1.927l2-2.268V9.005c0-3.483 2.504-6.447 6-7.545c3.496 1.098 6 4.062 6 7.545zm-6-3.805a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "rocket-2-line": {
      body: '<path fill="currentColor" d="M15.502 20.005A6.52 6.52 0 0 1 12 23.507a6.52 6.52 0 0 1-3.502-3.502h2.26c.326.488.747.912 1.242 1.243c.495-.33.916-.755 1.242-1.243zM18 14.81l2 2.268v1.927H4v-1.927l2-2.268V9.005c0-3.483 2.504-6.447 6-7.545c3.496 1.098 6 4.062 6 7.545zm-.73 2.195L16 15.565v-6.56c0-2.318-1.57-4.43-4-5.421c-2.43.99-4 3.103-4 5.42v6.561l-1.27 1.44zm-5.27-6a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "rocket-fill": {
      body: '<path fill="currentColor" d="M5.33 15.929a13 13 0 0 1-.33-2.93c0-5.087 2.903-9.435 7-11.181C16.099 3.564 19 7.912 19 13c0 1.01-.114 1.991-.33 2.929l2.02 1.795a.5.5 0 0 1 .097.631l-2.457 4.096a.5.5 0 0 1-.782.096l-2.255-2.254a1 1 0 0 0-.707-.293H9.415a1 1 0 0 0-.707.293l-2.255 2.254a.5.5 0 0 1-.782-.096l-2.457-4.096a.5.5 0 0 1 .096-.63zm6.67-2.93A2 2 0 1 0 12 9a2 2 0 0 0 0 4"/>',
    },
    "rocket-line": {
      body: '<path fill="currentColor" d="M5 13c0-5.088 2.902-9.436 7-11.182C16.097 3.564 19 7.912 19 13q-.002 1.236-.221 2.403l1.94 1.832a.5.5 0 0 1 .096.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.235-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.235 2.234a.5.5 0 0 1-.792-.114l-2.496-4.575a.5.5 0 0 1 .096-.603l1.94-1.832Q5.002 14.236 5 13m1.475 6.696l.817-.817a3 3 0 0 1 2.122-.88h5.171a3 3 0 0 1 2.122.88l.817.817l.982-1.8l-1.1-1.04a2 2 0 0 1-.593-1.82A11 11 0 0 0 17 13c0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13q0 1.038.186 2.036a2 2 0 0 1-.593 1.82l-1.1 1.04zM12 13a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "rotate-lock-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10c0 2.136-.67 4.116-1.811 5.741L17 12h3a8 8 0 1 0-2.46 5.772l.998 1.795A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2m0 5a3 3 0 0 1 3 3v1h1v5H8v-5h1v-1a3 3 0 0 1 3-3m0 2a1 1 0 0 0-.993.883L11 10v1h2v-1a1 1 0 0 0-.883-.993z"/>',
    },
    "rotate-lock-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10c0 2.136-.67 4.116-1.811 5.741L17 12h3a8 8 0 1 0-2.46 5.772l.998 1.795A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2m0 5a3 3 0 0 1 3 3v1h1v5H8v-5h1v-1a3 3 0 0 1 3-3m2 6h-4v1h4zm-2-4a1 1 0 0 0-.993.883L11 10v1h2v-1a1 1 0 0 0-.883-.993z"/>',
    },
    "rounded-corner": {
      body: '<path fill="currentColor" d="M21 19v2h-2v-2zm-4 0v2h-2v-2zm-4 0v2h-2v-2zm-4 0v2H7v-2zm-4 0v2H3v-2zm16-4v2h-2v-2zM5 15v2H3v-2zm0-4v2H3v-2zm11-8a5 5 0 0 1 4.995 4.783L21 8v5h-2V8a3.01 3.01 0 0 0-2.824-2.995L16 5h-5V3zM5 7v2H3V7zm0-4v2H3V3zm4 0v2H7V3z"/>',
    },
    "route-fill": {
      body: '<path fill="currentColor" d="M4 15V8.5a4.5 4.5 0 0 1 9 0v7a2.5 2.5 0 0 0 5 0V8.83a3.001 3.001 0 1 1 2 0v6.67a4.5 4.5 0 1 1-9 0v-7a2.5 2.5 0 0 0-5 0V15h3l-4 5l-4-5z"/>',
    },
    "route-line": {
      body: '<path fill="currentColor" d="M4 15V8.5a4.5 4.5 0 0 1 9 0v7a2.5 2.5 0 0 0 5 0V8.83a3.001 3.001 0 1 1 2 0v6.67a4.5 4.5 0 1 1-9 0v-7a2.5 2.5 0 0 0-5 0V15h3l-4 5l-4-5zm15-8a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "router-fill": {
      body: '<path fill="currentColor" d="M11 14v-3h2v3h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zM2.51 8.837C3.835 4.864 7.584 2 12 2c4.418 0 8.166 2.864 9.49 6.837l-1.898.632a8.004 8.004 0 0 0-15.183 0zm3.797 1.265a6.003 6.003 0 0 1 11.387 0l-1.898.633a4.002 4.002 0 0 0-7.592 0z"/>',
    },
    "router-line": {
      body: '<path fill="currentColor" d="M11 14v-3h2v3h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zM2.51 8.837C3.835 4.864 7.584 2 12 2c4.418 0 8.166 2.864 9.49 6.837l-1.898.632a8.004 8.004 0 0 0-15.183 0zm3.797 1.265a6.003 6.003 0 0 1 11.387 0l-1.898.633a4.002 4.002 0 0 0-7.592 0zM7 16v4h10v-4z"/>',
    },
    "rss-fill": {
      body: '<path fill="currentColor" d="M3 3c9.941 0 18 8.059 18 18h-3c0-8.284-6.716-15-15-15zm0 7c6.075 0 11 4.925 11 11h-3a8 8 0 0 0-8-8zm0 7a4 4 0 0 1 4 4H3z"/>',
    },
    "rss-line": {
      body: '<path fill="currentColor" d="M3 17a4 4 0 0 1 4 4H3zm0-7c6.075 0 11 4.925 11 11h-2a9 9 0 0 0-9-9zm0-7c9.941 0 18 8.059 18 18h-2c0-8.837-7.163-16-16-16z"/>',
    },
    "ruler-2-fill": {
      body: '<path fill="currentColor" d="M15 21h-2v-3h-2v3H9v-2H7v2H4a1 1 0 0 1-1-1v-3h2v-2H3v-2h3v-2H3V9h2V7H3V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-3v-2h-2z"/>',
    },
    "ruler-2-line": {
      body: '<path fill="currentColor" d="M17 19h2v-5h-9V5H5v2h2v2H5v2h3v2H5v2h2v2H5v2h2v-2h2v2h2v-3h2v3h2v-2h2zm-5-7h8a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1z"/>',
    },
    "ruler-fill": {
      body: '<path fill="currentColor" d="m4.929 13.314l2.121 2.121l1.415-1.414L6.343 11.9l2.122-2.122l2.828 2.829l1.414-1.414L9.88 8.364L12 6.243l2.121 2.121l1.415-1.414l-2.122-2.121L16.243 2a1 1 0 0 1 1.414 0l4.95 4.95a1 1 0 0 1 0 1.414l-14.85 14.85a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.415z"/>',
    },
    "ruler-line": {
      body: '<path fill="currentColor" d="m6.343 14.728l-2.828 2.829l3.535 3.535L20.485 7.657L16.95 4.121l-2.121 2.122l1.414 1.414l-1.414 1.414l-1.415-1.414l-2.121 2.121l2.121 2.122L12 13.314l-2.12-2.121l-2.122 2.12l1.415 1.415l-1.415 1.414zM17.657 2l4.95 4.95a1 1 0 0 1 0 1.414l-14.85 14.85a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.415L16.243 2a1 1 0 0 1 1.414 0"/>',
    },
    "run-fill": {
      body: '<path fill="currentColor" d="M9.83 8.79L8 9.456V13H6V8.05h.015l5.268-1.918c.244-.093.51-.14.782-.131a2.62 2.62 0 0 1 2.427 1.82q.279.875.51 1.181A5 5 0 0 0 19 11v2a6.99 6.99 0 0 1-5.402-2.547l-.581 3.297L15 15.67V23h-2v-5.986l-2.05-1.987l-.947 4.298l-6.894-1.215l.348-1.97l4.924.868zM13.5 5.5a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "run-line": {
      body: '<path fill="currentColor" d="M9.83 8.79L8 9.456V13H6V8.05h.015l5.268-1.918c.244-.093.51-.14.782-.131a2.62 2.62 0 0 1 2.427 1.82q.279.875.51 1.181A5 5 0 0 0 19 11v2a6.99 6.99 0 0 1-5.402-2.547l-.697 3.956L15 16.17V23h-2v-5.898l-2.27-1.904l-.727 4.127l-6.894-1.215l.348-1.97l4.924.868zM13.5 5.5a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "safari-fill": {
      body: '<path fill="currentColor" d="m16.701 6.8l-6.114 3.786L6.802 16.7l-.104-.104l-1.415 1.414l.708.707l1.414-1.414L7.3 17.2l6.114-3.785L17.2 7.3l.104.104L18.72 5.99l-.708-.708l-1.414 1.415zm-4.7 15.2c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-.5-19v2h1V3zm0 16v2h1v-2zM8.095 3.876l.765 1.848l.924-.383l-.765-1.847zm6.123 14.783l.765 1.847l.924-.382l-.765-1.848zm.765-15.165l-.765 1.847l.924.383l.765-1.848zM8.86 18.276l-.765 1.848l.924.382l.765-1.848zM21.001 11.5h-2v1h2zm-16 0h-2v1h2zm15.458 3.616l-1.835-.795l-.397.918l1.835.794zM5.775 8.76L3.94 7.967l-.397.918l1.835.794zm14.35-.667l-1.848.765l.383.924l1.847-.765zM5.342 14.217l-1.847.765l.382.924l1.848-.765zM18.72 18.01l-1.415-1.414l-.707.707l1.414 1.415zM7.404 6.697L5.99 5.282l-.708.708l1.415 1.414zm3.908 4.615l3.611-2.235l-2.235 3.61z"/>',
    },
    "safari-line": {
      body: '<path fill="currentColor" d="m17.813 6.503l-4.398 6.911l-6.911 4.398A7.97 7.97 0 0 0 11 19.938V18h2v1.938a7.96 7.96 0 0 0 3.906-1.618l-1.37-1.37l1.414-1.414l1.37 1.37A7.96 7.96 0 0 0 19.939 13h-1.938v-2h1.938a7.97 7.97 0 0 0-2.126-4.497m-.315-.315a7.97 7.97 0 0 0-4.497-2.126V6h-2V4.062A7.96 7.96 0 0 0 7.095 5.68l1.37 1.37l-1.414 1.414l-1.37-1.37A7.96 7.96 0 0 0 4.063 11H6v2H4.063a7.97 7.97 0 0 0 2.126 4.497l4.398-6.911zM12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "safe-2-fill": {
      body: '<path fill="currentColor" d="M10.005 20h-4v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7V1.59a.5.5 0 0 1 .582-.493L21.17 2.86a1 1 0 0 1 .836.986V6h1v2h-1v7h1v2h-1v2.153a1 1 0 0 1-.836.986l-1.164.194V22h-2v-1.334l-7.418 1.237a.5.5 0 0 1-.582-.493zm2-.361l8-1.334V4.694l-8-1.333zm4.5-5.64c-.828 0-1.5-1.119-1.5-2.5c0-1.38.672-2.5 1.5-2.5s1.5 1.12 1.5 2.5c0 1.381-.672 2.5-1.5 2.5"/>',
    },
    "safe-2-line": {
      body: '<path fill="currentColor" d="M20.005 20.333V22h-2v-1.334l-7.418 1.237a.5.5 0 0 1-.582-.493V20h-4v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7V1.59a.5.5 0 0 1 .582-.493L21.17 2.86a1 1 0 0 1 .836.986V6h1v2h-1v7h1v2h-1v2.153a1 1 0 0 1-.836.986zM4.005 5v13h6V5zm8 14.639l8-1.334V4.694l-8-1.333zm4.5-5.64c-.828 0-1.5-1.119-1.5-2.5c0-1.38.672-2.5 1.5-2.5s1.5 1.12 1.5 2.5c0 1.381-.672 2.5-1.5 2.5"/>',
    },
    "safe-fill": {
      body: '<path fill="currentColor" d="M18.005 20h-12v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-1v2h-2zm-7-6.126V17h2v-3.126a4.002 4.002 0 0 0-1-7.874a4 4 0 0 0-1 7.874m1-1.874a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "safe-line": {
      body: '<path fill="currentColor" d="M18.005 20h-12v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-1v2h-2zm-14-2h16V5h-16zm9-4.126V17h-2v-3.126a4.002 4.002 0 0 1 1-7.874a4 4 0 0 1 1 7.874m-1-1.874a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "sailboat-fill": {
      body: '<path fill="currentColor" d="M3 18h18a.5.5 0 0 1 .4.8l-2.1 2.8a1 1 0 0 1-.8.4h-13a1 1 0 0 1-.8-.4l-2.1-2.8A.5.5 0 0 1 3 18M15 2.425V15a1 1 0 0 1-1 1H4.04a.5.5 0 0 1-.39-.812L14.11 2.113a.5.5 0 0 1 .89.312"/>',
    },
    "sailboat-line": {
      body: '<path fill="currentColor" d="M3 18h18a.5.5 0 0 1 .4.8l-2.1 2.8a1 1 0 0 1-.8.4h-13a1 1 0 0 1-.8-.4l-2.1-2.8A.5.5 0 0 1 3 18m4.161-4H13V6.702zM15 2.425V15a1 1 0 0 1-1 1H4.04a.5.5 0 0 1-.39-.812L14.11 2.113a.5.5 0 0 1 .89.312"/>',
    },
    "save-2-fill": {
      body: '<path fill="currentColor" d="M4 3h13l3.707 3.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6M5 5v4h10V5z"/>',
    },
    "save-2-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V7.828L16.172 5zM4 3h13l3.707 3.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 15a3 3 0 1 1 0-6a3 3 0 0 1 0 6M6 6h9v4H6z"/>',
    },
    "save-3-fill": {
      body: '<path fill="currentColor" d="M4 3h14l2.707 2.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 1v5h9V4zm-1 8v7h12v-7zm7-7h2v3h-2z"/>',
    },
    "save-3-line": {
      body: '<path fill="currentColor" d="M18 19h1V6.828L17.172 5H16v4H7V5H5v14h1v-7h12zM4 3h14l2.707 2.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4 11v5h8v-5z"/>',
    },
    "save-fill": {
      body: '<path fill="currentColor" d="M18 21v-8H6v8H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h13l4 4v13a1 1 0 0 1-1 1zm-2 0H8v-6h8z"/>',
    },
    "save-line": {
      body: '<path fill="currentColor" d="M7 19v-6h10v6h2V7.828L16.172 5H5v14zM4 3h13l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5 12v4h6v-4z"/>',
    },
    "scales-2-fill": {
      body: '<path fill="currentColor" d="M5.998 2c0 .513.49 1 1 1h10c.513 0 1-.49 1-1h2a3 3 0 0 1-3 3h-4l.001 2.062A8 8 0 0 1 19.998 15v6a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-6a8 8 0 0 1 7-7.938V5h-4c-1.66 0-3-1.34-3-3zm6 9a4 4 0 1 0 3.446 1.968l-2.739 2.74l-.094.082a1 1 0 0 1-1.32-1.497l2.739-2.74A4 4 0 0 0 11.998 11"/>',
    },
    "scales-2-line": {
      body: '<path fill="currentColor" d="M5.998 2c0 .513.49 1 1 1h10c.513 0 1-.49 1-1h2a3 3 0 0 1-3 3h-4l.001 2.062A8 8 0 0 1 19.998 15v6a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-6a8 8 0 0 1 7-7.938V5h-4c-1.66 0-3-1.34-3-3zm6 7c-3.238 0-6 2.76-6 6v5h12v-5c0-3.238-2.762-6-6-6m0 2c.742 0 1.437.202 2.032.554l-2.74 2.739a1 1 0 0 0 1.32 1.497l.095-.083l2.74-2.739A4 4 0 1 1 11.998 11"/>',
    },
    "scales-3-fill": {
      body: '<path fill="currentColor" d="m12.999 2l-.001 1.278l5 1.668l3.633-1.21l.632 1.896l-3.031 1.011l3.095 8.512A5.98 5.98 0 0 1 17.998 17a5.98 5.98 0 0 1-4.328-1.845l3.094-8.512l-3.766-1.256V19h4v2h-10v-2h4V5.387L7.232 6.643l3.095 8.512A5.98 5.98 0 0 1 6 17a5.98 5.98 0 0 1-4.33-1.845l3.095-8.512l-3.03-1.01l.632-1.898L6 4.945l4.999-1.667V2zm5 7.103L16.58 13h2.835zm-12 0L4.58 13h2.835z"/>',
    },
    "scales-3-line": {
      body: '<path fill="currentColor" d="m12.999 2l-.001 1.278l5 1.668l3.633-1.21l.632 1.896l-3.031 1.011l3.095 8.512A5.98 5.98 0 0 1 17.998 17a5.98 5.98 0 0 1-4.328-1.845l3.094-8.512l-3.766-1.256V19h4v2h-10v-2h4V5.387L7.232 6.643l3.095 8.512A5.98 5.98 0 0 1 6 17a5.98 5.98 0 0 1-4.33-1.845l3.095-8.512l-3.03-1.01l.632-1.898L6 4.945l4.999-1.667V2zm5 7.103l-1.959 5.386a4 4 0 0 0 1.959.511c.7 0 1.37-.18 1.958-.51zm-12 0L4.04 14.489A4 4 0 0 0 5.999 15c.7 0 1.37-.18 1.958-.51z"/>',
    },
    "scales-fill": {
      body: '<path fill="currentColor" d="M12.998 2v1h7v2h-7v14h4v2h-10v-2h4V5h-7V3h7V2zm-8 4.343l2.828 2.829a4 4 0 1 1-5.657 0zm14 0l2.828 2.829a4 4 0 1 1-5.657 0zm0 2.829l-1.414 1.414A2 2 0 0 0 16.998 12l4 .001c0-.54-.212-1.041-.586-1.415zm-14 0l-1.414 1.414A2 2 0 0 0 2.998 12l4 .001c0-.54-.212-1.041-.586-1.415z"/>',
    },
    "scales-line": {
      body: '<path fill="currentColor" d="M12.998 2v1h7v2h-7v14h4v2h-10v-2h4V5h-7V3h7V2zm-8 4.343l2.828 2.829a4 4 0 1 1-5.657 0zm14 0l2.828 2.829a4 4 0 1 1-5.657 0zm-14 2.829l-1.414 1.414a2 2 0 1 0 2.828 0zm14 0l-1.414 1.414a2 2 0 1 0 2.828 0z"/>',
    },
    "scan-2-fill": {
      body: '<path fill="currentColor" d="m4.257 5.671l2.137 2.137a7 7 0 1 0 1.414-1.414L5.67 4.257A9.96 9.96 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-2.401.846-4.605 2.257-6.329m3.571 3.572L12 13.414L13.414 12L9.243 7.828a5 5 0 1 1-1.414 1.414"/>',
    },
    "scan-2-line": {
      body: '<path fill="currentColor" d="M5.671 4.257L13.414 12L12 13.414L8.554 9.968a4 4 0 1 0 3.696-1.96l-1.804-1.805a6 6 0 1 1-3.337 2.32L5.68 7.094a8 8 0 1 0 3.196-2.461L7.374 3.132A9.96 9.96 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12a9.98 9.98 0 0 1 3.671-7.743"/>',
    },
    "scan-fill": {
      body: '<path fill="currentColor" d="M4.257 5.671L12 13.414L13.414 12L5.671 4.257A9.96 9.96 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-2.401.846-4.605 2.257-6.329"/>',
    },
    "scan-line": {
      body: '<path fill="currentColor" d="M5.671 4.257L13.414 12L12 13.414l-6.32-6.32a8 8 0 1 0 3.706-2.658L7.85 2.9A10 10 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12a9.98 9.98 0 0 1 3.671-7.743"/>',
    },
    "school-fill": {
      body: '<path fill="currentColor" d="M23 19h-1V9h-4V6.586l-6-6l-6 6V9H2v10H1v2h22zM6 19H4v-8h2zm12-8h2v8h-2zm-7 1h2v7h-2z"/>',
    },
    "school-line": {
      body: '<path fill="currentColor" d="m12 .586l6 6V9h4v10h1v2H1v-2h1V9h4V6.586zM18 19h2v-8h-2zM6 11H4v8h2zm2-3.586V19h3v-7h2v7h3V7.414l-4-4z"/>',
    },
    "scissors-2-fill": {
      body: '<path fill="currentColor" d="m12 14.118l-2.317 2.316a4 4 0 1 1-2.121-2.121l2.317-2.316L4.21 6.329a2 2 0 0 1 0-2.828l.708-.707L12 9.875l7.081-7.081l.708.707a2 2 0 0 1 0 2.828l-5.668 5.668l2.317 2.316a4 4 0 1 1-2.121 2.121zm-6 5.879a2 2 0 1 0 0-4a2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "scissors-2-line": {
      body: '<path fill="currentColor" d="m12 13.41l-2.554 2.555a4 4 0 1 1-1.414-1.414l2.554-2.554l-6.021-6.021a2 2 0 0 1 0-2.829L12 10.582l7.435-7.435a2 2 0 0 1 0 2.829l-6.02 6.02l2.553 2.554a4 4 0 1 1-1.414 1.414zm-6 6.587a2 2 0 1 0 0-4a2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "scissors-cut-fill": {
      body: '<path fill="currentColor" d="M9.879 11.997L7.562 9.68a4 4 0 1 1 2.121-2.12L12 9.875l6.374-6.374a2 2 0 0 1 2.829 0l.707.707L9.683 16.435a4 4 0 1 1-2.121-2.121zM6 7.997a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m9.535-6.587l6.375 6.375l-.707.707a2 2 0 0 1-2.829 0l-4.96-4.96zM16 10.997h2v2h-2zm4 0h2v2h-2zm-14 0h2v2H6zm-4 0h2v2H2z"/>',
    },
    "scissors-cut-line": {
      body: '<path fill="currentColor" d="M10 5.997c0 .732-.197 1.419-.54 2.01L12 10.582l6.728-6.728a2 2 0 0 1 2.828 0l-12.11 12.11a4 4 0 1 1-1.414-1.414l2.554-2.554l-2.554-2.554A4 4 0 1 1 10 5.997m-2 0a2 2 0 1 0-4 0a2 2 0 0 0 4 0m13.556 14.142a2 2 0 0 1-2.828 0l-5.317-5.317l1.415-1.414zM16 10.997h2v2h-2zm4 0h2v2h-2zm-14 0h2v2H6zm-4 0h2v2H2zm4 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "scissors-fill": {
      body: '<path fill="currentColor" d="M9.683 7.559L12 9.875l6.374-6.374a2 2 0 0 1 2.829 0l.707.707L9.683 16.435a4 4 0 1 1-2.121-2.121l2.317-2.317L7.562 9.68a4 4 0 1 1 2.121-2.12M6 7.997a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m9.535-6.587l6.375 6.375l-.707.707a2 2 0 0 1-2.829 0l-4.96-4.96z"/>',
    },
    "scissors-line": {
      body: '<path fill="currentColor" d="M9.446 8.029L12 10.582l6.728-6.727a2 2 0 0 1 2.828 0l-12.11 12.11a4 4 0 1 1-1.414-1.414l2.554-2.554l-2.554-2.554a4 4 0 1 1 1.414-1.414m5.38 5.379l6.73 6.73a2 2 0 0 1-2.828 0l-5.317-5.316zm-7.412 3.175a2 2 0 1 0-2.828 2.828a2 2 0 0 0 2.828-2.829m0-9.172a2 2 0 1 0-2.828-2.828A2 2 0 0 0 7.414 7.41"/>',
    },
    "screenshot-2-fill": {
      body: '<path fill="currentColor" d="M3 3h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm0 4h2v2h-2zM3 19h2v2H3zm0-4h2v2H3zm0-4h2v2H3zm0-4h2v2H3zm7.667 4l1.036-1.555A1 1 0 0 1 12.535 9h2.93a1 1 0 0 1 .832.445L17.333 11H20a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1zM14 18a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "screenshot-2-line": {
      body: '<path fill="currentColor" d="M3 3h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm0 4h2v2h-2zM3 19h2v2H3zm0-4h2v2H3zm0-4h2v2H3zm0-4h2v2H3zm7.667 4l1.036-1.555A1 1 0 0 1 12.535 9h2.93a1 1 0 0 1 .832.445L17.333 11H20a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1zM9 19h10v-6h-2.737l-1.333-2h-1.86l-1.333 2H9zm5-1a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "screenshot-fill": {
      body: '<path fill="currentColor" d="m11.993 14.407l-1.552 1.552a4 4 0 1 1-1.418-1.41l1.555-1.556l-3.124-3.125a1.5 1.5 0 0 1 0-2.121l.354-.354l4.185 4.185l4.189-4.189l.353.354a1.5 1.5 0 0 1 0 2.12l-3.128 3.13l1.561 1.56a4 4 0 1 1-1.414 1.414zM19 13V5H5v8H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9zM7 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4m10 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "screenshot-line": {
      body: '<path fill="currentColor" d="m11.993 14.407l-1.552 1.552a4 4 0 1 1-1.418-1.41l1.555-1.556l-4.185-4.185l1.415-1.415l4.185 4.185l4.189-4.189l1.414 1.414l-4.19 4.19l1.562 1.56a4 4 0 1 1-1.414 1.414zM7 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4m10 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4m2-7V5H5v8H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9z"/>',
    },
    "scroll-to-bottom-fill": {
      body: '<path fill="currentColor" d="M12.859 2H11.14c-2.014 0-3.094.278-4.072.801A5.45 5.45 0 0 0 4.801 5.07C4.278 6.047 4 7.127 4 9.141v5.718c0 2.014.278 3.094.801 4.071A5.45 5.45 0 0 0 7.07 21.2c.978.522 2.058.801 4.072.801h1.718c2.014 0 3.094-.279 4.071-.801a5.45 5.45 0 0 0 2.269-2.27c.522-.977.801-2.057.801-4.071V9.14c0-2.014-.279-3.094-.801-4.072A5.45 5.45 0 0 0 16.931 2.8c-.978-.522-2.058-.8-4.071-.8M11 11V6h2v5zm-3.242 2.758l1.414-1.414l2.829 2.828l2.828-2.828l1.414 1.414l-4.242 4.243z"/>',
    },
    "scroll-to-bottom-line": {
      body: '<path fill="currentColor" d="M8.013 4.565C8.753 4.169 9.559 4 11.14 4h1.718c1.582 0 2.387.169 3.128.565q.945.504 1.448 1.448c.396.74.565 1.546.565 3.128v5.718c0 1.582-.169 2.387-.565 3.128a3.45 3.45 0 0 1-1.448 1.448c-.74.396-1.546.565-3.128.565H11.14c-1.582 0-2.387-.169-3.128-.565a3.45 3.45 0 0 1-1.448-1.448C6.169 17.247 6 16.441 6 14.86V9.14c0-1.582.169-2.387.565-3.128a3.45 3.45 0 0 1 1.448-1.448M12.859 2H11.14c-2.014 0-3.094.278-4.072.801A5.45 5.45 0 0 0 4.801 5.07C4.278 6.047 4 7.127 4 9.141v5.718c0 2.014.278 3.094.801 4.071A5.45 5.45 0 0 0 7.07 21.2c.978.522 2.058.801 4.072.801h1.718c2.014 0 3.094-.279 4.071-.801a5.45 5.45 0 0 0 2.269-2.27c.522-.977.801-2.057.801-4.071V9.14c0-2.014-.279-3.094-.801-4.072A5.45 5.45 0 0 0 16.931 2.8c-.978-.522-2.058-.8-4.071-.8M13 6h-2v5h2zm-5.242 7.758L12 18.001l4.242-4.243l-1.414-1.414L12 15.172l-2.829-2.828z"/>',
    },
    "sd-card-fill": {
      body: '<path fill="currentColor" d="M4.293 6.707L9 2h10a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.414a1 1 0 0 1 .293-.707M15 5v4h2V5zm-3 0v4h2V5zM9 5v4h2V5z"/>',
    },
    "sd-card-line": {
      body: '<path fill="currentColor" d="M6 7.828V20h12V4H9.828zm-1.707-1.12L9 2h10a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.414a1 1 0 0 1 .293-.707M15 5h2v4h-2zm-3 0h2v4h-2zM9 6h2v3H9z"/>',
    },
    "sd-card-mini-fill": {
      body: '<path fill="currentColor" d="M7 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.58a1 1 0 0 1 .292-.707l1.562-1.567A.5.5 0 0 0 6 9.793V3a1 1 0 0 1 1-1m8 2v4h2V4zm-3 0v4h2V4zM9 4v4h2V4z"/>',
    },
    "sd-card-mini-line": {
      body: '<path fill="currentColor" d="M8 4v5.793a2.5 2.5 0 0 1-.73 1.765L6 12.833V20h12V4zM7 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.58a1 1 0 0 1 .292-.707l1.562-1.567A.5.5 0 0 0 6 9.793V3a1 1 0 0 1 1-1m8 3h2v4h-2zm-3 0h2v4h-2zM9 5h2v4H9z"/>',
    },
    "search-2-fill": {
      body: '<path fill="currentColor" d="M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9s-9-4.032-9-9s4.032-9 9-9m8.485 16.071l2.829 2.828l-1.415 1.415l-2.828-2.829z"/>',
    },
    "search-2-line": {
      body: '<path fill="currentColor" d="M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9s-9-4.032-9-9s4.032-9 9-9m0 16c3.867 0 7-3.133 7-7s-3.133-7-7-7s-7 3.133-7 7s3.133 7 7 7m8.485.071l2.829 2.828l-1.415 1.415l-2.828-2.829z"/>',
    },
    "search-eye-fill": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617m-5.853-9.44a4 4 0 1 0 2.646 2.646a2 2 0 1 1-2.646-2.647"/>',
    },
    "search-eye-line": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617m-2.006-.742A6.98 6.98 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7s3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975zm-3.847-8.699a2 2 0 1 0 2.646 2.646a4 4 0 1 1-2.646-2.646"/>',
    },
    "search-fill": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617"/>',
    },
    "search-line": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617m-2.006-.742A6.98 6.98 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7s3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975z"/>',
    },
    "secure-payment-fill": {
      body: '<path fill="currentColor" d="m11.005 2l7.298 2.28a1 1 0 0 1 .702.955V7h2a1 1 0 0 1 1 1v2h-13V8a1 1 0 0 1 1-1h7V5.97l-6-1.876l-6 1.876v7.404a4 4 0 0 0 1.558 3.169l.189.136l4.253 2.9L14.787 17h-4.782a1 1 0 0 1-1-1v-4h13v4a1 1 0 0 1-1 1l-3.22.001c-.387.51-.857.96-1.4 1.33L11.005 22l-5.38-3.668a6 6 0 0 1-2.62-4.958V5.235a1 1 0 0 1 .702-.954z"/>',
    },
    "secure-payment-line": {
      body: '<path fill="currentColor" d="m11.005 2l7.298 2.28a1 1 0 0 1 .702.955V7h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1l-3.22.001c-.387.51-.857.96-1.4 1.33L11.005 22l-5.38-3.668a6 6 0 0 1-2.62-4.958V5.235a1 1 0 0 1 .702-.954zm0 2.094l-6 1.876v7.404a4 4 0 0 0 1.558 3.169l.189.136l4.253 2.9L14.787 17h-4.782a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7V5.97zm0 7.906v3h9v-3zm0-2h9V9h-9z"/>',
    },
    "seedling-fill": {
      body: '<path fill="currentColor" d="M21.998 7v2.5a6.5 6.5 0 0 1-6.5 6.5h-2.5v5h-2v-7l.019-1a6.5 6.5 0 0 1 6.481-6zm-16-4a7 7 0 0 1 6.643 4.786A7.48 7.48 0 0 0 10.014 13H8.998a7 7 0 0 1-7-7V3z"/>',
    },
    "seedling-line": {
      body: '<path fill="currentColor" d="M5.998 3a7 7 0 0 1 6.913 5.895A6.48 6.48 0 0 1 17.498 7h4.5v2.5a6.5 6.5 0 0 1-6.5 6.5h-2.5v5h-2v-8h-2a7 7 0 0 1-7-7V3zm14 6h-2.5a4.5 4.5 0 0 0-4.5 4.5v.5h2.5a4.5 4.5 0 0 0 4.5-4.5zm-14-4h-2v1a5 5 0 0 0 5 5h2v-1a5 5 0 0 0-5-5"/>',
    },
    "send-backward": {
      body: '<path fill="currentColor" d="M14 3a1 1 0 0 1 1 1v5h5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H5v8h4v-3a1 1 0 0 1 1-1h3z"/>',
    },
    "send-plane-2-fill": {
      body: '<path fill="currentColor" d="M3 13h6v-2H3V1.846a.5.5 0 0 1 .741-.439l18.462 10.155a.5.5 0 0 1 0 .876L3.741 22.592A.5.5 0 0 1 3 22.154z"/>',
    },
    "send-plane-2-line": {
      body: '<path fill="currentColor" d="M3.5 1.346a.5.5 0 0 1 .241.061l18.462 10.155a.5.5 0 0 1 0 .876L3.741 22.592A.5.5 0 0 1 3 22.154V1.846a.5.5 0 0 1 .5-.5M5 4.382V11h5v2H5v6.617L18.85 12z"/>',
    },
    "send-plane-fill": {
      body: '<path fill="currentColor" d="M1.946 9.315c-.522-.174-.526-.455.01-.634L21.044 2.32c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.678.045L12 14l6-8l-8 6z"/>',
    },
    "send-plane-line": {
      body: '<path fill="currentColor" d="m21.727 2.957l-5.454 19.086c-.15.529-.475.553-.717.07L11 13L1.923 9.37c-.51-.205-.503-.51.034-.689L21.043 2.32c.529-.176.832.12.684.638m-2.692 2.14L6.812 9.17l5.637 2.255l3.04 6.08z"/>',
    },
    "send-to-back": {
      body: '<path fill="currentColor" d="M11 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v5h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-2H7a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm5 5h-4v3a1 1 0 0 1-1 1H8v4h4v-3a1 1 0 0 1 1-1h3z"/>',
    },
    "sensor-fill": {
      body: '<path fill="currentColor" d="M6 8v2h12V8h-3V2h2v4h5v2h-2v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V2h2v6zm7-6v6h-2V2z"/>',
    },
    "sensor-line": {
      body: '<path fill="currentColor" d="M6 8v11h12V8h-3V2h2v4h5v2h-2v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V2h2v6zm7-6v6h-2V2z"/>',
    },
    "seo-fill": {
      body: '<path fill="currentColor" d="M8 3a7 7 0 0 0 0 14h1.07a7 7 0 0 1 0-2H8A5 5 0 0 1 8 5h8a5 5 0 0 1 4.9 6a7 7 0 0 1 1.426 2A7 7 0 0 0 16 3zm3 13a5 5 0 1 1 9.172 2.757l2.535 2.536l-1.414 1.414l-2.536-2.535A5 5 0 0 1 11 16"/>',
    },
    "seo-line": {
      body: '<path fill="currentColor" d="M8 3a7 7 0 0 0 0 14h1.07a7 7 0 0 1 0-2H8A5 5 0 0 1 8 5h8a5 5 0 0 1 4.9 6a7 7 0 0 1 1.426 2A7 7 0 0 0 16 3zm8 10a3 3 0 1 0 0 6a3 3 0 0 0 0-6m-5 3a5 5 0 1 1 9.172 2.757l2.535 2.536l-1.414 1.414l-2.536-2.535A5 5 0 0 1 11 16"/>',
    },
    separator: {
      body: '<path fill="currentColor" d="M2 11h2v2H2zm4 0h12v2H6zm14 0h2v2h-2z"/>',
    },
    "server-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v7H3V4a1 1 0 0 1 1-1M3 13h18v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm4 3v2h3v-2zM7 6v2h3V6z"/>',
    },
    "server-line": {
      body: '<path fill="currentColor" d="M5 11h14V5H5zm16-7v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1m-2 9H5v6h14zM7 15h3v2H7zm0-8h3v2H7z"/>',
    },
    "service-fill": {
      body: '<path fill="currentColor" d="M14.121 10.48a1 1 0 0 0-1.414 0l-.707.706a2 2 0 0 1-2.828-2.828l5.63-5.632a6.5 6.5 0 0 1 6.377 10.568l-2.108 2.135zM3.161 4.468a6.5 6.5 0 0 1 8.009-.938L7.757 6.944a4 4 0 0 0 5.513 5.794l.144-.137l4.243 4.242l-4.243 4.243a2 2 0 0 1-2.828 0L3.16 13.66a6.5 6.5 0 0 1 0-9.192"/>',
    },
    "service-line": {
      body: '<path fill="currentColor" d="M3.161 4.469a6.5 6.5 0 0 1 8.84-.328a6.5 6.5 0 0 1 9.178 9.154l-7.765 7.79a2 2 0 0 1-2.719.102l-.11-.101l-7.764-7.791a6.5 6.5 0 0 1 .34-8.826m1.414 1.414a4.5 4.5 0 0 0-.146 6.21l.146.154L12 19.672l5.303-5.305l-3.535-3.534l-1.06 1.06a3 3 0 0 1-4.244-4.242l2.102-2.103a4.5 4.5 0 0 0-5.837.189zm8.486 2.828a1 1 0 0 1 1.414 0l4.242 4.242l.708-.706a4.5 4.5 0 0 0-6.211-6.51l-.153.146l-3.182 3.182a1 1 0 0 0-.078 1.327l.078.087a1 1 0 0 0 1.327.078l.087-.078z"/>',
    },
    "settings-2-fill": {
      body: '<path fill="currentColor" d="m8.686 4l2.607-2.607a1 1 0 0 1 1.414 0L15.314 4H19a1 1 0 0 1 1 1v3.686l2.607 2.607a1 1 0 0 1 0 1.414L20 15.314V19a1 1 0 0 1-1 1h-3.686l-2.607 2.607a1 1 0 0 1-1.414 0L8.686 20H5a1 1 0 0 1-1-1v-3.686l-2.607-2.607a1 1 0 0 1 0-1.414L4 8.686V5a1 1 0 0 1 1-1zM12 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "settings-2-line": {
      body: '<path fill="currentColor" d="m8.686 4l2.607-2.607a1 1 0 0 1 1.414 0L15.314 4H19a1 1 0 0 1 1 1v3.686l2.607 2.607a1 1 0 0 1 0 1.414L20 15.314V19a1 1 0 0 1-1 1h-3.686l-2.607 2.607a1 1 0 0 1-1.414 0L8.686 20H5a1 1 0 0 1-1-1v-3.686l-2.607-2.607a1 1 0 0 1 0-1.414L4 8.686V5a1 1 0 0 1 1-1zM6 6v3.515L3.515 12L6 14.485V18h3.515L12 20.485L14.485 18H18v-3.515L20.485 12L18 9.515V6h-3.515L12 3.515L9.515 6zm6 10a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "settings-3-fill": {
      body: '<path fill="currentColor" d="M9.954 2.21a10 10 0 0 1 4.09-.002A4 4 0 0 0 16 5.07a4 4 0 0 0 3.457.261A10 10 0 0 1 21.5 8.877a4 4 0 0 0-1.5 3.122c0 1.264.586 2.391 1.501 3.124a10 10 0 0 1-2.045 3.543a4 4 0 0 0-3.456.261a4 4 0 0 0-1.955 2.86a10 10 0 0 1-4.09.004A4 4 0 0 0 8 18.927a4 4 0 0 0-3.457-.26A10 10 0 0 1 2.5 15.121A4 4 0 0 0 4 11.999c0-1.264-.587-2.39-1.502-3.124a10 10 0 0 1 2.045-3.542A4 4 0 0 0 8 5.07a4 4 0 0 0 1.954-2.86M12 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "settings-3-line": {
      body: '<path fill="currentColor" d="M3.34 17a10 10 0 0 1-.979-2.326a3 3 0 0 0 .003-5.347a10 10 0 0 1 2.5-4.337a3 3 0 0 0 4.632-2.674a10 10 0 0 1 5.007.003a3 3 0 0 0 4.632 2.671a10.06 10.06 0 0 1 2.503 4.336a3 3 0 0 0-.002 5.347a10 10 0 0 1-2.501 4.337a3 3 0 0 0-4.632 2.674a10 10 0 0 1-5.007-.002a3 3 0 0 0-4.631-2.672A10 10 0 0 1 3.339 17m5.66.196a5 5 0 0 1 2.25 2.77q.75.07 1.499.002a5 5 0 0 1 2.25-2.772a5 5 0 0 1 3.526-.564q.435-.614.748-1.298A5 5 0 0 1 18 12c0-1.26.47-2.437 1.273-3.334a8 8 0 0 0-.75-1.298A5 5 0 0 1 15 6.804a5 5 0 0 1-2.25-2.77q-.75-.071-1.5-.001A5 5 0 0 1 9 6.804a5 5 0 0 1-3.526.564q-.436.614-.747 1.298A5 5 0 0 1 6 12c0 1.26-.471 2.437-1.273 3.334a8 8 0 0 0 .75 1.298A5 5 0 0 1 9 17.196M12 15a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "settings-4-fill": {
      body: '<path fill="currentColor" d="M5.334 4.545a10 10 0 0 1 3.542-2.048A4 4 0 0 0 12 4a4 4 0 0 0 3.124-1.502a10 10 0 0 1 3.542 2.048A4 4 0 0 0 18.928 8a4 4 0 0 0 2.863 1.955a10 10 0 0 1 0 4.09c-1.16.178-2.23.86-2.863 1.955a4 4 0 0 0-.262 3.455a10 10 0 0 1-3.542 2.047A4 4 0 0 0 12 20a4 4 0 0 0-3.124 1.503a10 10 0 0 1-3.542-2.048A4 4 0 0 0 5.072 16a4 4 0 0 0-2.863-1.954a10 10 0 0 1 0-4.091A4 4 0 0 0 5.072 8a4 4 0 0 0 .262-3.454M13.5 14.597a3 3 0 1 0-3-5.196a3 3 0 0 0 3 5.196"/>',
    },
    "settings-4-line": {
      body: '<path fill="currentColor" d="M2 12c0-.865.11-1.704.316-2.504A3 3 0 0 0 4.99 4.867a10 10 0 0 1 4.335-2.506a3 3 0 0 0 5.348 0a10 10 0 0 1 4.335 2.506a3 3 0 0 0 2.675 4.63c.206.8.316 1.638.316 2.503c0 .864-.11 1.703-.316 2.503a3 3 0 0 0-2.675 4.63a10 10 0 0 1-4.335 2.505a3 3 0 0 0-5.348 0a10 10 0 0 1-4.335-2.505a3 3 0 0 0-2.675-4.63C2.11 13.703 2 12.864 2 12m4.804 3c.63 1.091.81 2.346.564 3.524q.613.436 1.297.75A5 5 0 0 1 12 18c1.26 0 2.438.471 3.335 1.274q.684-.314 1.297-.75A5 5 0 0 1 17.196 15a5 5 0 0 1 2.77-2.25a8 8 0 0 0 0-1.5A5 5 0 0 1 17.196 9a5 5 0 0 1-.564-3.524a8 8 0 0 0-1.297-.75A5 5 0 0 1 12 6a5 5 0 0 1-3.335-1.274a8 8 0 0 0-1.297.75A5 5 0 0 1 6.804 9a5 5 0 0 1-2.77 2.25a8 8 0 0 0 0 1.5A5 5 0 0 1 6.805 15M12 15a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "settings-5-fill": {
      body: '<path fill="currentColor" d="M2.131 13.63a10 10 0 0 1 .001-3.26c1.101.026 2.092-.502 2.477-1.431c.385-.93.058-2.003-.74-2.763a10 10 0 0 1 2.306-2.307c.76.798 1.834 1.125 2.763.74c.93-.385 1.458-1.376 1.431-2.477a10 10 0 0 1 3.261 0c-.026 1.102.502 2.092 1.431 2.477c.93.385 2.003.058 2.763-.74a10 10 0 0 1 2.307 2.306c-.798.76-1.125 1.834-.74 2.764s1.376 1.458 2.477 1.43a10 10 0 0 1 0 3.262c-1.102-.027-2.092.501-2.477 1.43c-.385.93-.058 2.004.74 2.764a10 10 0 0 1-2.306 2.306c-.76-.798-1.834-1.125-2.764-.74s-1.458 1.376-1.43 2.478a10 10 0 0 1-3.262-.001c.027-1.101-.502-2.092-1.43-2.477c-.93-.385-2.004-.058-2.764.74a10 10 0 0 1-2.306-2.306c.798-.76 1.125-1.834.74-2.763c-.385-.93-1.376-1.458-2.478-1.431M12 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "settings-5-line": {
      body: '<path fill="currentColor" d="M2.212 14.06a9.95 9.95 0 0 1 .001-4.12c1.11.131 2.079-.236 2.396-1.001s-.109-1.71-.986-2.402a9.95 9.95 0 0 1 2.913-2.914c.692.878 1.637 1.303 2.402.986s1.133-1.286 1.002-2.396a9.95 9.95 0 0 1 4.12 0c-.131 1.11.236 2.08 1.001 2.396c.765.317 1.71-.108 2.402-.985a9.9 9.9 0 0 1 2.914 2.912c-.878.692-1.303 1.638-.986 2.403s1.286 1.132 2.396 1.001a9.95 9.95 0 0 1 0 4.12c-1.11-.13-2.08.237-2.396 1.002c-.317.764.108 1.71.985 2.402a9.95 9.95 0 0 1-2.912 2.914c-.693-.878-1.638-1.304-2.403-.987s-1.132 1.286-1.001 2.397a9.9 9.9 0 0 1-4.12-.001c.13-1.11-.237-2.079-1.002-2.396s-1.71.109-2.402.986a9.9 9.9 0 0 1-2.914-2.913c.878-.692 1.304-1.637.987-2.402s-1.286-1.133-2.397-1.002M4 12.21c1.1.305 2.007 1.002 2.456 2.086c.45 1.085.3 2.22-.262 3.212q.145.153.298.298c.993-.563 2.127-.712 3.212-.262c1.084.449 1.781 1.356 2.085 2.456q.21.006.42 0c.305-1.1 1.002-2.007 2.087-2.456c1.084-.45 2.219-.3 3.212.262q.152-.145.297-.298c-.562-.993-.711-2.127-.262-3.212c.45-1.084 1.357-1.781 2.456-2.085q.006-.21 0-.421c-1.1-.304-2.007-1.001-2.456-2.086c-.45-1.084-.3-2.22.262-3.212a8 8 0 0 0-.297-.297c-.993.562-2.128.711-3.212.262C13.21 6.007 12.514 5.1 12.21 4a8 8 0 0 0-.42 0c-.305 1.1-1.002 2.008-2.086 2.457c-1.085.45-2.22.3-3.212-.262q-.153.144-.298.297c.563.993.712 2.128.262 3.212S5.1 11.485 4 11.79q-.006.21 0 .42M12 15a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "settings-6-fill": {
      body: '<path fill="currentColor" d="M17.5 2.474L23 12l-5.5 9.526h-11L1 12l5.5-9.526zM8.634 8.17l5 8.66l1.732-1l-5-8.66z"/>',
    },
    "settings-6-line": {
      body: '<path fill="currentColor" d="M17.5 2.474L23 12l-5.5 9.526h-11L1 12l5.5-9.526zm-1.155 2h-8.69L3.309 12l4.346 7.526h8.69L20.691 12zM8.634 8.17l1.732-1l5 8.66l-1.732 1z"/>',
    },
    "settings-fill": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zm0 14a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "settings-line": {
      body: '<path fill="currentColor" d="m12 1l9.5 5.5v11L12 23l-9.5-5.5v-11zm0 2.311L4.5 7.653v8.694l7.5 4.342l7.5-4.342V7.653zM12 16a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "shadow-fill": {
      body: '<path fill="currentColor" d="M2 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3H3a1 1 0 0 1-1-1zm6 15v2h3.44l-2-2zm3.56 0l2 2h2.88l-2-2zM20 20v-1.44l-2-2V17a1 1 0 0 1-1 1h-.44l2 2zm0-6.44l-2-2v2.88l2 2zm0-2.12V8h-2v1.44z"/>',
    },
    "shadow-line": {
      body: '<path fill="currentColor" d="M3 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3V3a1 1 0 0 0-1-1zm15 9.56l2 2v2.88l-2-2zm0-2.12V8h2v3.44zM18 17v-.44l2 2V20h-1.44l-2-2H17a1 1 0 0 0 1-1m-3.56 1l2 2h-2.88l-2-2zm-5 0l2 2H8v-2zM4 16V4h12v12z"/>',
    },
    "shake-hands-fill": {
      body: '<path fill="currentColor" d="M19.291 6h.71a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2l-4.17-5.836a2 2 0 0 0-2.201-.753l-2.486.746a2 2 0 0 1-1.988-.502l-.293-.293a1 1 0 0 1 .152-1.539l5.401-3.6a2 2 0 0 1 2.183-.024l4.156 2.645A1 1 0 0 0 19.29 6M5.027 14.295l-1.616 1.414a1 1 0 0 0 .041 1.538l5.14 4.04a1 1 0 0 0 1.487-.29l.704-1.232a2 2 0 0 0-.257-2.338l-2.702-2.972a2 2 0 0 0-2.797-.16M7.046 5H3a1 1 0 0 0-1 1v7.516a2 2 0 0 0 .35 1.13l.074-.066l1.615-1.414a3.5 3.5 0 0 1 4.895.28l2.702 2.972a3.5 3.5 0 0 1 .45 4.09l-.655 1.146a2 2 0 0 0 1.738-.155l4.41-2.646a1 1 0 0 0 .299-1.438l-5.267-7.379a.5.5 0 0 0-.55-.188l-2.486.745a3.5 3.5 0 0 1-3.48-.877l-.293-.293a2.5 2.5 0 0 1 .38-3.848z"/>',
    },
    "shake-hands-line": {
      body: '<path fill="currentColor" d="M11.861 2.39a3 3 0 0 1 3.275-.034L19.29 5H21a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.52a2.65 2.65 0 0 1-1.285 2.449l-5.093 3.056a2 2 0 0 1-2.07-.008a2 2 0 0 1-2.561.073l-5.14-4.039a2 2 0 0 1-.565-2.446A2 2 0 0 1 2 13.51V6a1 1 0 0 1 1-1h4.947zM4.173 13.646l.692-.605a3 3 0 0 1 4.195.24l2.702 2.972a3 3 0 0 1 .396 3.487l5.009-3.005a.66.66 0 0 0 .278-.79l-4.427-6.198a1 1 0 0 0-1.101-.377l-2.486.745a3 3 0 0 1-2.983-.752l-.293-.292A2 2 0 0 1 5.68 7H4v6.51zm9.89-9.602a1 1 0 0 0-1.093.012l-5.4 3.6l.292.293a1 1 0 0 0 .995.25l2.485-.745a3 3 0 0 1 3.303 1.13L18.515 14H20V7h-.709a2 2 0 0 1-1.074-.313zM6.181 14.545l-1.616 1.414l5.14 4.039l.705-1.232a1 1 0 0 0-.129-1.169L7.58 14.625a1 1 0 0 0-1.398-.08"/>',
    },
    "shape-2-fill": {
      body: '<path fill="currentColor" d="M2 2h5v5H2zm0 15h5v5H2zM17 2h5v5h-5zm0 15h5v5h-5zM8 4h8v2H8zM4 8h2v8H4zm14 0h2v8h-2zM8 18h8v2H8z"/>',
    },
    "shape-2-line": {
      body: '<path fill="currentColor" d="M20 16h2v6h-6v-2H8v2H2v-6h2V8H2V2h6v2h8V2h6v6h-2zm-2 0V8h-2V6H8v2H6v8h2v2h8v-2zM4 4v2h2V4zm0 14v2h2v-2zM18 4v2h2V4zm0 14v2h2v-2z"/>',
    },
    "shape-fill": {
      body: '<path fill="currentColor" d="M5 8a3 3 0 1 1 0-6a3 3 0 0 1 0 6m14 0a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0 14a3 3 0 1 1 0-6a3 3 0 0 1 0 6M5 22a3 3 0 1 1 0-6a3 3 0 0 1 0 6M9 4h6v2H9zm0 14h6v2H9zM4 9h2v6H4zm14 0h2v6h-2z"/>',
    },
    "shape-line": {
      body: '<path fill="currentColor" d="M7.83 20A3.001 3.001 0 1 1 4 16.17V7.83A3.001 3.001 0 1 1 7.83 4h8.34A3.001 3.001 0 1 1 20 7.83v8.34A3.001 3.001 0 1 1 16.17 20zm0-2h8.34A3 3 0 0 1 18 16.17V7.83A3 3 0 0 1 16.17 6H7.83A3 3 0 0 1 6 7.83v8.34A3 3 0 0 1 7.83 18M5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m14 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 14a1 1 0 1 0 0-2a1 1 0 0 0 0 2M5 20a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "shapes-fill": {
      body: '<path fill="currentColor" d="m12 1l6 10H6zm1 12.5h8v8h-8zM6.75 22a4.75 4.75 0 1 0 0-9.5a4.75 4.75 0 0 0 0 9.5"/>',
    },
    "shapes-line": {
      body: '<path fill="currentColor" d="M12 1L6 11h12zm0 3.887L14.468 9H9.532zM6.75 20a2.75 2.75 0 1 1 0-5.5a2.75 2.75 0 0 1 0 5.5m0 2a4.75 4.75 0 1 0 0-9.5a4.75 4.75 0 0 0 0 9.5M15 15.5v4h4v-4zm-2 6v-8h8v8z"/>',
    },
    "share-2-fill": {
      body: '<path fill="currentColor" d="M18.414 9L12 2.586L5.586 9H11v7h2V9zM3 14v4a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-4h-2v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4z"/>',
    },
    "share-2-line": {
      body: '<path fill="currentColor" d="m12 2.586l6.207 6.207l-1.414 1.414L13 6.414V16h-2V6.414l-3.793 3.793l-1.414-1.414zM3 18v-4h2v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4h2v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3"/>',
    },
    "share-box-fill": {
      body: '<path fill="currentColor" d="M10 3v2H5v14h14v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm7.707 4.707L12 13.414L10.586 12l5.707-5.707L13 3h8v8z"/>',
    },
    "share-box-line": {
      body: '<path fill="currentColor" d="M10 3v2H5v14h14v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm7.586 2H13V3h8v8h-2V6.414l-7 7L10.586 12z"/>',
    },
    "share-circle-fill": {
      body: '<path fill="currentColor" d="M11 2.05v2.012A8.001 8.001 0 0 0 12 20a8 8 0 0 0 7.938-7h2.013c-.502 5.053-4.766 9-9.951 9c-5.523 0-10-4.477-10-10c0-5.185 3.947-9.449 9-9.95m7.707 4.657L12 13.414L10.586 12l6.707-6.707L14 2h8v8z"/>',
    },
    "share-circle-line": {
      body: '<path fill="currentColor" d="M11 2.05v2.012A8.001 8.001 0 0 0 12 20a8 8 0 0 0 7.938-7h2.013c-.502 5.053-4.766 9-9.951 9c-5.523 0-10-4.477-10-10c0-5.185 3.947-9.449 9-9.95m9 3.364l-8 8L10.586 12l8-8H14V2h8v8h-2z"/>',
    },
    "share-fill": {
      body: '<path fill="currentColor" d="m13.576 17.271l-5.11-2.787a3.5 3.5 0 1 1 0-4.968l5.11-2.787a3.5 3.5 0 1 1 .958 1.755l-5.11 2.787a3.5 3.5 0 0 1 0 1.457l5.11 2.788a3.5 3.5 0 1 1-.958 1.755"/>',
    },
    "share-forward-2-fill": {
      body: '<path fill="currentColor" d="M4 19h16v-5h2v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6h2zm8-9H9a6 6 0 0 0-4.854 2.473A8 8 0 0 1 12 6V2l8 6l-8 6z"/>',
    },
    "share-forward-2-line": {
      body: '<path fill="currentColor" d="M4 19h16v-5h2v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6h2zM16.172 7l-3.95-3.95l1.414-1.414L20 8l-6.364 6.364l-1.414-1.415L16.172 9H5V7z"/>',
    },
    "share-forward-box-fill": {
      body: '<path fill="currentColor" d="M9 3v2H4v14h16v-9h2v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm7 2V1l7 6h-9a2 2 0 0 0-2 2v6h-2V9a4 4 0 0 1 4-4z"/>',
    },
    "share-forward-box-line": {
      body: '<path fill="currentColor" d="M9 3v2H4v14h16v-9h2v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm9.95 2L16 2.05L17.414.636l5.34 5.34A.6.6 0 0 1 22.33 7H14a2 2 0 0 0-2 2v6h-2V9a4 4 0 0 1 4-4z"/>',
    },
    "share-forward-fill": {
      body: '<path fill="currentColor" d="M13 14h-2a9 9 0 0 0-7.968 4.81A10 10 0 0 1 3 18C3 12.477 7.477 8 13 8V3l10 8l-10 8z"/>',
    },
    "share-forward-line": {
      body: '<path fill="currentColor" d="M13 14h-2a9 9 0 0 0-7.968 4.81A10 10 0 0 1 3 18C3 12.477 7.477 8 13 8V2.5L23.5 11L13 19.5zm-2-2h4v3.308L20.321 11L15 6.692V10h-2a7.98 7.98 0 0 0-6.057 2.774A11 11 0 0 1 11 12"/>',
    },
    "share-line": {
      body: '<path fill="currentColor" d="m13.12 17.023l-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4 4 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755M6 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m11-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "shield-check-fill": {
      body: '<path fill="currentColor" d="m12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976zm4.452 7.222l-4.95 4.949l-2.828-2.828l-1.414 1.414L11.503 16l6.364-6.364z"/>',
    },
    "shield-check-line": {
      body: '<path fill="currentColor" d="m12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976zm0 2.049L5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604zm4.452 5.173l1.415 1.414L11.503 16L7.26 11.757l1.414-1.414l2.828 2.828z"/>',
    },
    "shield-cross-fill": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M11 10H8v2h3v3h2v-3h3v-2h-3V7h-2z"/>',
    },
    "shield-cross-line": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05zM11 10V7h2v3h3v2h-3v3h-2v-3H8v-2z"/>',
    },
    "shield-fill": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976"/>',
    },
    "shield-flash-fill": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M13 10V5l-5 7h3v5l5-7z"/>',
    },
    "shield-flash-line": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05zM13 10h3l-5 7v-5H8l5-7z"/>',
    },
    "shield-keyhole-fill": {
      body: '<path fill="currentColor" d="m12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976zm0 6a2 2 0 0 0-1 3.732V15h2l.001-4.268A2 2 0 0 0 12 7"/>',
    },
    "shield-keyhole-line": {
      body: '<path fill="currentColor" d="m12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976zm0 2.049L5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604zM12 7a2 2 0 0 1 1.001 3.732L13 15h-2v-4.268A2 2 0 0 1 12 7"/>',
    },
    "shield-line": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05z"/>',
    },
    "shield-star-fill": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M12 13.5l2.939 1.545l-.561-3.272l2.377-2.318l-3.285-.478L12 6l-1.47 2.977l-3.285.478l2.377 2.318l-.56 3.272z"/>',
    },
    "shield-star-line": {
      body: '<path fill="currentColor" d="M5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05zM3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M12 13.5l-2.939 1.545l.561-3.272l-2.377-2.318l3.286-.478L12 6l1.47 2.977l3.285.478l-2.377 2.318l.56 3.272z"/>',
    },
    "shield-user-fill": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M12 11a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m-4.473 5h8.946a4.5 4.5 0 0 0-8.946 0"/>',
    },
    "shield-user-line": {
      body: '<path fill="currentColor" d="M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05zM12 11a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5m-4.473 5a4.5 4.5 0 0 1 8.946 0z"/>',
    },
    "shining-2-fill": {
      body: '<path fill="currentColor" d="M12 .5L16 8l7.5 4l-7.5 4l-4 7.5L8 16L.5 12L8 8z"/>',
    },
    "shining-2-line": {
      body: '<path fill="currentColor" d="m16 8l7.5 4l-7.5 4l-4 7.5L8 16L.5 12L8 8l4-7.5zm3.25 4l-4.728-2.522L12 4.75L9.478 9.478L4.75 12l4.728 2.522L12 19.25l2.522-4.728z"/>',
    },
    "shining-fill": {
      body: '<path fill="currentColor" d="M1 11c5.523 0 10-4.477 10-10h2c0 5.523 4.477 10 10 10v2c-5.523 0-10 4.477-10 10h-2c0-5.523-4.477-10-10-10z"/>',
    },
    "shining-line": {
      body: '<path fill="currentColor" d="M1 11c5.523 0 10-4.477 10-10h2c0 5.523 4.477 10 10 10v2c-5.523 0-10 4.477-10 10h-2c0-5.523-4.477-10-10-10zm4.803 1A12.04 12.04 0 0 1 12 18.197A12.04 12.04 0 0 1 18.197 12A12.04 12.04 0 0 1 12 5.803A12.04 12.04 0 0 1 5.803 12"/>',
    },
    "ship-2-fill": {
      body: '<path fill="currentColor" d="M9 4h5.446a1 1 0 0 1 .848.47L18.75 10h4.408a.5.5 0 0 1 .439.74l-3.937 7.217A4.99 4.99 0 0 1 15 16a5 5 0 0 1-4 2a5 5 0 0 1-4-2a4.99 4.99 0 0 1-4.55 1.97l-1.236-6.791A1 1 0 0 1 2.198 10H3V5a1 1 0 0 1 1-1h1V1h4zm-4 6h11.392l-2.5-4H5zM3 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 11 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 19 20h2v2h-2a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 11 22a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 3 22H1v-2z"/>',
    },
    "ship-2-line": {
      body: '<path fill="currentColor" d="M9 4h5.446a1 1 0 0 1 .848.47L18.75 10h4.408a.5.5 0 0 1 .439.74L19.637 18H19a6 6 0 0 1-1.535-.198L20.63 12H3.4l1.048 5.824A6 6 0 0 1 3 18h-.545l-1.24-6.821A1 1 0 0 1 2.197 10H3V5a1 1 0 0 1 1-1h1V1h4zm-4 6h11.392l-2.5-4H5zM3 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 11 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 19 20h2v2h-2a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 11 22a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 3 22H1v-2z"/>',
    },
    "ship-fill": {
      body: '<path fill="currentColor" d="M4 10.4V4a1 1 0 0 1 1-1h5V1h4v2h5a1 1 0 0 1 1 1v6.4l1.086.326a1 1 0 0 1 .683 1.2l-1.517 6.068A4.99 4.99 0 0 1 16 16a5 5 0 0 1-4 2a5 5 0 0 1-4-2a4.99 4.99 0 0 1-4.252 1.994l-1.516-6.068a1 1 0 0 1 .682-1.2zm2-.6L12 8l2.754.826l1.809.543L18 9.8V5H6zM4 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 12 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 20 20h2v2h-2a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 12 22a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 4 22H2v-2z"/>',
    },
    "ship-line": {
      body: '<path fill="currentColor" d="M4 10.4V4a1 1 0 0 1 1-1h5V1h4v2h5a1 1 0 0 1 1 1v6.4l1.086.326a1 1 0 0 1 .683 1.2l-1.517 6.068a5 5 0 0 1-1.902-.273l1.25-5.351L12 10l-7.6 2.37l1.25 5.351a5 5 0 0 1-1.902.273l-1.516-6.068a1 1 0 0 1 .682-1.2zm2-.6L12 8l6 1.8V5H6zM4 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 12 20a5.98 5.98 0 0 0 4-1.528A5.98 5.98 0 0 0 20 20h2v2h-2a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 12 22a7.96 7.96 0 0 1-4-1.07A7.96 7.96 0 0 1 4 22H2v-2z"/>',
    },
    "shirt-fill": {
      body: '<path fill="currentColor" d="M6.998 4v7l5-2.5l5 2.5V4h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm5 4l-4.5-5h9zm1 3.236l-1-.5l-1 .5V20h2zm2 2.764v2h4v-2z"/>',
    },
    "shirt-line": {
      body: '<path fill="currentColor" d="M12.998 20h6v-4h-4v-2h4V6h-2v5l-4-1.6zm-2 0V9.4l-4 1.6V6h-2v14zm-4-16V3h10v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm5 4l3.5-3h-7z"/>',
    },
    "shopping-bag-2-fill": {
      body: '<path fill="currentColor" d="M20.005 22h-16a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-11-16h-2v2a5 5 0 0 0 10 0V6h-2v2a3 3 0 0 1-6 0z"/>',
    },
    "shopping-bag-2-line": {
      body: '<path fill="currentColor" d="M20.005 22h-16a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-1-2V4h-14v16zm-10-14v2a3 3 0 1 0 6 0V6h2v2a5 5 0 0 1-10 0V6z"/>',
    },
    "shopping-bag-3-fill": {
      body: '<path fill="currentColor" d="M6.505 2h11a1 1 0 0 1 .8.4l2.7 3.6v15a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4m12 4l-1.5-2h-10l-1.5 2zm-9.5 4h-2v2a5 5 0 0 0 10 0v-2h-2v2a3 3 0 0 1-6 0z"/>',
    },
    "shopping-bag-3-line": {
      body: '<path fill="currentColor" d="M6.505 2h11a1 1 0 0 1 .8.4l2.7 3.6v15a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4m12.5 6h-14v12h14zm-.5-2l-1.5-2h-10l-1.5 2zm-9.5 4v2a3 3 0 1 0 6 0v-2h2v2a5 5 0 0 1-10 0v-2z"/>',
    },
    "shopping-bag-4-fill": {
      body: '<path fill="currentColor" d="M9 6a3 3 0 1 1 6 0zM7 6H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3A5 5 0 0 0 7 6m2 4a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0z"/>',
    },
    "shopping-bag-4-line": {
      body: '<path fill="currentColor" d="M9 6h6a3 3 0 1 0-6 0M7 6a5 5 0 0 1 10 0h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM5 8v12h14V8zm4 2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0z"/>',
    },
    "shopping-bag-fill": {
      body: '<path fill="currentColor" d="M12.005 1a5 5 0 0 1 5 5v2h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3V6a5 5 0 0 1 5-5m5 10h-2v1a1 1 0 0 0 1.993.116l.007-.116zm-8 0h-2v1a1 1 0 0 0 1.993.116L9.005 12zm3-8A3 3 0 0 0 9.01 5.823L9.005 6v2h6V6a3 3 0 0 0-2.824-2.995z"/>',
    },
    "shopping-bag-line": {
      body: '<path fill="currentColor" d="M7.005 8V6a5 5 0 0 1 10 0v2h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zm0 2h-2v10h14V10h-2v2h-2v-2h-6v2h-2zm2-2h6V6a3 3 0 0 0-6 0z"/>',
    },
    "shopping-basket-2-fill": {
      body: '<path fill="currentColor" d="m15.37 3.44l3.212 5.562h3.423v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917l-.757-9.083H2.005v-2h3.422L8.639 3.44l1.732 1l-2.634 4.562h8.535L13.639 4.44zm-2.365 9.562h-2v4h2zm-4 0h-2v4h2zm8 0h-2v4h2z"/>',
    },
    "shopping-basket-2-line": {
      body: '<path fill="currentColor" d="m15.37 3.44l3.212 5.562h3.423v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917l-.757-9.083H2.005v-2h3.422L8.639 3.44l1.732 1l-2.634 4.562h8.535L13.639 4.44zm3.46 7.562H5.179l.667 8h12.319zm-5.825 2v4h-2v-4zm-4 0v4h-2v-4zm8 0v4h-2v-4z"/>',
    },
    "shopping-basket-fill": {
      body: '<path fill="currentColor" d="M12.005 2a6 6 0 0 1 6 6v1h4v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917L3.171 11H2.005V9h4V8a6 6 0 0 1 6-6m1 11h-2v4h2zm-4 0h-2v4h2zm8 0h-2v4h2zm-5-9A4 4 0 0 0 8.01 7.8l-.005.2v1h8V8a4 4 0 0 0-3.8-3.995z"/>',
    },
    "shopping-basket-line": {
      body: '<path fill="currentColor" d="M12.005 2a6 6 0 0 1 6 6v1h4v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917L3.171 11H2.005V9h4V8a6 6 0 0 1 6-6m6.826 9H5.178l.667 8h12.319zm-5.826 2v4h-2v-4zm-4 0v4h-2v-4zm8 0v4h-2v-4zm-5-9A4 4 0 0 0 8.01 7.8l-.005.2v1h8V8a4 4 0 0 0-3.8-3.995z"/>',
    },
    "shopping-cart-2-fill": {
      body: '<path fill="currentColor" d="M4.004 6.417L.762 3.174L2.176 1.76l3.243 3.243H20.66a1 1 0 0 1 .958 1.287l-2.4 8a1 1 0 0 1-.958.713H6.004v2h11v2h-12a1 1 0 0 1-1-1zm1.5 16.586a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m12 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "shopping-cart-2-line": {
      body: '<path fill="currentColor" d="M4.004 6.417L.762 3.174L2.176 1.76l3.243 3.243H20.66a1 1 0 0 1 .958 1.287l-2.4 8a1 1 0 0 1-.958.713H6.004v2h11v2h-12a1 1 0 0 1-1-1zm2 .586v6h11.512l1.8-6zm-.5 16a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m12 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "shopping-cart-fill": {
      body: '<path fill="currentColor" d="M6.005 9h13.938l.5-2H8.005V5h13.72a1 1 0 0 1 .97 1.243l-2.5 10a1 1 0 0 1-.97.757H5.004a1 1 0 0 1-1-1V4h-2V2h3a1 1 0 0 1 1 1zm0 14a2 2 0 1 1 0-4a2 2 0 0 1 0 4m12 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "shopping-cart-line": {
      body: '<path fill="currentColor" d="M4.005 16V4h-2V2h3a1 1 0 0 1 1 1v12h12.438l2-8H8.005V5h13.72a1 1 0 0 1 .97 1.243l-2.5 10a1 1 0 0 1-.97.757H5.004a1 1 0 0 1-1-1m2 7a2 2 0 1 1 0-4a2 2 0 0 1 0 4m12 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/>',
    },
    "showers-fill": {
      body: '<path fill="currentColor" d="M15 18H9v3H7v-3.252a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18H17v3.001h-2zm-4 2h2v3h-2z"/>',
    },
    "showers-line": {
      body: '<path fill="currentColor" d="M5 16.93a8 8 0 1 1 11.458-9.831A5.5 5.5 0 0 1 19 17.793v-2.13a3.5 3.5 0 1 0-4-5.612V10a6 6 0 1 0-10 4.472zM7 16h2v4H7zm8 0h2v4h-2zm-4 3h2v4h-2z"/>',
    },
    "shuffle-fill": {
      body: '<path fill="currentColor" d="M18 17.883V16l5 3l-5 3v-2.09a9 9 0 0 1-6.997-5.365L11 14.54l-.003.006A9 9 0 0 1 2.725 20H2v-2h.725a7 7 0 0 0 6.434-4.243L9.912 12l-.753-1.757A7 7 0 0 0 2.725 6H2V4h.725a9 9 0 0 1 8.272 5.455L11 9.46l.003-.006A9 9 0 0 1 18 4.09V2l5 3l-5 3V6.117a7 7 0 0 0-5.159 4.126L12.088 12l.753 1.757A7 7 0 0 0 18 17.883"/>',
    },
    "shuffle-line": {
      body: '<path fill="currentColor" d="M18 17.883V16l5 3l-5 3v-2.09a9 9 0 0 1-6.997-5.365L11 14.54l-.003.006A9 9 0 0 1 2.725 20H2v-2h.725a7 7 0 0 0 6.434-4.243L9.912 12l-.753-1.757A7 7 0 0 0 2.725 6H2V4h.725a9 9 0 0 1 8.272 5.455L11 9.46l.003-.006A9 9 0 0 1 18 4.09V2l5 3l-5 3V6.117a7 7 0 0 0-5.159 4.126L12.088 12l.753 1.757A7 7 0 0 0 18 17.883"/>',
    },
    "shut-down-fill": {
      body: '<path fill="currentColor" d="M11 2.05V12h2V2.05c5.053.501 9 4.765 9 9.95c0 5.523-4.477 10-10 10S2 17.523 2 12c0-5.185 3.947-9.449 9-9.95"/>',
    },
    "shut-down-line": {
      body: '<path fill="currentColor" d="m6.265 3.807l1.147 1.639a8 8 0 1 0 9.176 0l1.147-1.639A9.99 9.99 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12a9.99 9.99 0 0 1 4.265-8.193M11 12V2h2v10z"/>',
    },
    "side-bar-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m6 2v14h11V5z"/>',
    },
    "side-bar-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5 2H4v14h4zm2 0v14h10V5z"/>',
    },
    "sidebar-fold-fill": {
      body: '<path fill="currentColor" d="M13 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h9zm2 18V3h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zM11 8.5v7L7 12z"/>',
    },
    "sidebar-fold-line": {
      body: '<path fill="currentColor" d="M5 5h8v14H5zm14 14h-4V5h4zM4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm3 9l4-3.5v7z"/>',
    },
    "sidebar-unfold-fill": {
      body: '<path fill="currentColor" d="M13 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h9zm2 18V3h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zM7 8.5l4 3.5l-4 3.5z"/>',
    },
    "sidebar-unfold-line": {
      body: '<path fill="currentColor" d="M5 5h8v14H5zm14 14h-4V5h4zM4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm7 9L7 8.5v7z"/>',
    },
    "signal-tower-fill": {
      body: '<path fill="currentColor" d="M6.116 20.087A9.99 9.99 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.99 9.99 0 0 1-4.116 8.087l-1.015-1.739a8 8 0 1 0-9.738 0zm2.034-3.485a6 6 0 1 1 7.7 0l-1.03-1.766a4 4 0 1 0-5.64 0zM11 13h2l1 9h-4z"/>',
    },
    "signal-tower-line": {
      body: '<path fill="currentColor" d="m6.116 20.087l1.015-1.739a8 8 0 1 1 9.738 0l1.015 1.739A9.99 9.99 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.99 9.99 0 0 0 4.116 8.087m2.034-3.485a6 6 0 1 1 7.7 0l-1.03-1.766a4 4 0 1 0-5.64 0zM11 13h2v9h-2z"/>',
    },
    "signal-wifi-1-fill": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m0 2a15.9 15.9 0 0 0-8.42 2.392l5.109 6.324A8 8 0 0 1 12 13c1.18 0 2.302.256 3.311.716L20.42 7.39A15.9 15.9 0 0 0 12 5"/>',
    },
    "signal-wifi-1-line": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m0 12a6 6 0 0 0-2 .34l2 2.477l2-2.477a6 6 0 0 0-2-.34m0-10a15.9 15.9 0 0 0-8.42 2.392l5.109 6.324A8 8 0 0 1 12 13c1.18 0 2.302.256 3.311.716L20.42 7.39A15.9 15.9 0 0 0 12 5"/>',
    },
    "signal-wifi-2-fill": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m0 2a15.9 15.9 0 0 0-8.42 2.392l3.179 3.935A10.95 10.95 0 0 1 12 10c1.897 0 3.683.48 5.241 1.327L20.42 7.39A15.9 15.9 0 0 0 12 5"/>',
    },
    "signal-wifi-2-line": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m0 9c-1.42 0-2.764.33-3.958.915L12 17.817l3.958-4.902A9 9 0 0 0 12 12m0-7a15.9 15.9 0 0 0-8.42 2.392l3.179 3.935A10.95 10.95 0 0 1 12 10c1.897 0 3.683.48 5.241 1.327L20.42 7.39A15.9 15.9 0 0 0 12 5"/>',
    },
    "signal-wifi-3-fill": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m0 2a15.9 15.9 0 0 0-8.42 2.392l1.904 2.357A12.94 12.94 0 0 1 12.001 8c2.374 0 4.6.637 6.516 1.749L20.42 7.39A15.9 15.9 0 0 0 12 5"/>',
    },
    "signal-wifi-3-line": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m0 7c-1.897 0-3.683.48-5.24 1.327l5.24 6.49l5.242-6.49A10.95 10.95 0 0 0 12 10m0-5a15.9 15.9 0 0 0-8.42 2.392l1.904 2.357A12.94 12.94 0 0 1 12.001 8c2.374 0 4.6.637 6.516 1.749L20.42 7.39A15.9 15.9 0 0 0 12 5"/>',
    },
    "signal-wifi-error-fill": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L22.5 8H18v5.571L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m10 16v2h-2v-2zm0-9v7h-2v-7z"/>',
    },
    "signal-wifi-error-line": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996l-1.256 1.556A15.93 15.93 0 0 0 12 5c-3.09 0-5.974.875-8.42 2.392L12 17.817l6-7.429v3.183L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m10 16v2h-2v-2zm0-9v7h-2v-7z"/>',
    },
    "signal-wifi-fill": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3"/>',
    },
    "signal-wifi-line": {
      body: '<path fill="currentColor" d="M12 3c4.285 0 8.22 1.497 11.31 3.996L12 21L.69 6.997A17.93 17.93 0 0 1 12 3m0 2a15.9 15.9 0 0 0-8.42 2.392L12 17.817L20.42 7.39A15.9 15.9 0 0 0 12 5"/>',
    },
    "signal-wifi-off-fill": {
      body: '<path fill="currentColor" d="m2.808 1.393l17.678 17.678l-1.414 1.414l-3.683-3.683L12 21L.69 6.997a18 18 0 0 1 2.951-1.942L1.394 2.808zM12.001 3c4.284 0 8.219 1.497 11.31 3.996l-5.407 6.693L7.725 3.511A18 18 0 0 1 12.001 3"/>',
    },
    "signal-wifi-off-line": {
      body: '<path fill="currentColor" d="m2.808 1.393l17.678 17.678l-1.414 1.414l-3.683-3.682L12 21L.69 6.997a18 18 0 0 1 2.951-1.942L1.394 2.808zm.772 5.999L12 17.817l1.967-2.437l-8.835-8.836q-.799.38-1.552.848M12 3c4.285 0 8.22 1.497 11.31 3.996l-5.406 6.693l-1.422-1.422l3.938-4.876A15.9 15.9 0 0 0 12 5q-1.31 0-2.579.207L7.725 3.51c1.37-.333 2.802-.51 4.276-.51"/>',
    },
    "signpost-fill": {
      body: '<path fill="currentColor" d="M12 5V2h-2v3H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h13.414l4.293-4.293a1 1 0 0 0 0-1.414L17.414 5zm0 12h-2v5h2z"/>',
    },
    "signpost-line": {
      body: '<path fill="currentColor" d="M12 5h5.414l4.293 4.293a1 1 0 0 1 0 1.414L17.414 15H12v7h-2v-7H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6V2h2zm4.586 8l3-3l-3-3H5v6z"/>',
    },
    "sim-card-2-fill": {
      body: '<path fill="currentColor" d="M5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m8 16v-8H8v2h3v6zm-5-5v2h2v-2zm6 0v2h2v-2zm0-3v2h2v-2zm-6 6v2h2v-2zm6 0v2h2v-2z"/>',
    },
    "sim-card-2-line": {
      body: '<path fill="currentColor" d="M6 4v16h12V7.828L14.172 4zM5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m8 8v8h-2v-6H8v-2zm-5 3h2v2H8zm6 0h2v2h-2zm0-3h2v2h-2zm-6 6h2v2H8zm6 0h2v2h-2z"/>',
    },
    "sim-card-fill": {
      body: '<path fill="currentColor" d="M5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m3 10v6h8v-6z"/>',
    },
    "sim-card-line": {
      body: '<path fill="currentColor" d="M6 4v16h12V7.828L14.172 4zM5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m3 10h8v6H8z"/>',
    },
    "single-quotes-l": {
      body: '<path fill="currentColor" d="M9.583 17.321C8.553 16.227 8 15 8 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621c.537-.278 1.24-.375 1.929-.311c1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5a3.87 3.87 0 0 1-2.748-1.179"/>',
    },
    "single-quotes-r": {
      body: '<path fill="currentColor" d="M14.417 6.679C15.447 7.773 16 9 16 10.989c0 3.5-2.456 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.248-5.621c-.537.278-1.24.375-1.93.311C9.591 12.323 8.17 10.842 8.17 9a3.5 3.5 0 0 1 3.5-3.5c1.073 0 2.1.49 2.748 1.179"/>',
    },
    "sip-fill": {
      body: '<path fill="currentColor" d="m13.96 6.501l2.829-2.828a1 1 0 0 1 1.414 0l2.121 2.121a1 1 0 0 1 0 1.414l-2.828 2.829l1.768 1.767l-1.415 1.415l-7.07-7.071l1.413-1.415zm-3.182 2.475l4.243 4.243l-7.778 7.778H3v-4.243z"/>',
    },
    "sip-line": {
      body: '<path fill="currentColor" d="m6.457 18.954l8.564-8.564l-1.414-1.414l-8.564 8.564zm5.735-11.392l-1.414-1.414l1.414-1.415l1.768 1.768l2.829-2.828a1 1 0 0 1 1.414 0l2.121 2.121a1 1 0 0 1 0 1.414l-2.828 2.829l1.768 1.767l-1.415 1.415l-1.414-1.415l-9.192 9.193H3v-4.243z"/>',
    },
    sketching: {
      body: '<path fill="currentColor" d="M10.036 7.698c-1.651 1.861-3.523 4.546-5.141 7.784a1 1 0 1 1-1.79-.895c1.692-3.383 3.66-6.215 5.434-8.216c.886-.999 1.74-1.81 2.506-2.38c.382-.285.76-.523 1.123-.693c.351-.166.753-.298 1.166-.298a1.24 1.24 0 0 1 1.116.69c.157.312.174.645.17.87c-.008.477-.135 1.073-.298 1.68c-.335 1.243-.923 2.891-1.507 4.518l-.082.228c-.566 1.574-1.123 3.123-1.485 4.36q-.146.501-.239.895c.694-.557 1.55-1.396 2.457-2.288l.03-.029c.881-.866 1.814-1.782 2.6-2.411c.391-.312.812-.609 1.218-.78c.34-.145 1.12-.38 1.727.227c.384.384.49.884.518 1.256c.03.39-.016.81-.087 1.21c-.14.8-.424 1.733-.683 2.575l-.041.135c-.232.751-.438 1.422-.555 1.96c.26-.26.58-.674.954-1.285a1 1 0 1 1 1.706 1.045c-.543.886-1.105 1.606-1.701 2.053c-.624.468-1.44.732-2.266.319c-.608-.305-.746-.91-.777-1.246c-.033-.363.02-.759.089-1.115c.13-.673.385-1.497.625-2.276l.055-.178c.267-.868.51-1.679.625-2.334l.024-.145l-.181.14c-.698.559-1.561 1.405-2.478 2.306l-.03.03c-.881.865-1.814 1.782-2.6 2.41c-.391.313-.812.61-1.218.781c-.34.145-1.12.38-1.727-.227c-.309-.309-.388-.699-.413-.936a3.5 3.5 0 0 1 .023-.803c.068-.528.226-1.17.426-1.85c.38-1.298.955-2.9 1.512-4.449l.092-.255c.593-1.652 1.149-3.214 1.457-4.36l.074-.286a7 7 0 0 0-.224.16c-.623.464-1.377 1.17-2.204 2.103"/>',
    },
    "skip-back-fill": {
      body: '<path fill="currentColor" d="m8 11.333l10.223-6.815a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L8 12.667V19a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0z"/>',
    },
    "skip-back-line": {
      body: '<path fill="currentColor" d="M7 4a1 1 0 0 1 1 1v6.333l10.223-6.815a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L8 12.667V19a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m10 3.737L10.606 12L17 16.263z"/>',
    },
    "skip-back-mini-fill": {
      body: '<path fill="currentColor" d="M7 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m2.079 6.409a.5.5 0 0 1 0-.818l7.133-5.035a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.409z"/>',
    },
    "skip-back-mini-line": {
      body: '<path fill="currentColor" d="M7 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m8 8.14V9.86L11.968 12zm-5.921-1.732a.5.5 0 0 1 0-.816l7.133-5.036a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.409z"/>',
    },
    "skip-down-fill": {
      body: '<path fill="currentColor" d="M18 17H6v-2h12zm-6-4l6-6H6z"/>',
    },
    "skip-down-line": {
      body: '<path fill="currentColor" d="M12 10.086L7.207 5.293L5.793 6.707L12 12.914l6.207-6.207l-1.414-1.414zM18 17H6v-2h12z"/>',
    },
    "skip-forward-fill": {
      body: '<path fill="currentColor" d="M16 12.667L5.777 19.482A.5.5 0 0 1 5 19.066V4.934a.5.5 0 0 1 .777-.416L16 11.333V5a1 1 0 1 1 2 0v14a1 1 0 1 1-2 0z"/>',
    },
    "skip-forward-line": {
      body: '<path fill="currentColor" d="M16 12.667L5.777 19.482A.5.5 0 0 1 5 19.066V4.934a.5.5 0 0 1 .777-.416L16 11.333V5a1 1 0 1 1 2 0v14a1 1 0 1 1-2 0zm-9-4.93v8.526L13.394 12z"/>',
    },
    "skip-forward-mini-fill": {
      body: '<path fill="currentColor" d="M7.788 17.444A.5.5 0 0 1 7 17.035V6.965a.5.5 0 0 1 .788-.409l7.133 5.036a.5.5 0 0 1 0 .816zM16 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0z"/>',
    },
    "skip-forward-mini-line": {
      body: '<path fill="currentColor" d="M12.032 12L9 9.86v4.28zM7.5 17.535a.5.5 0 0 1-.5-.5V6.965a.5.5 0 0 1 .788-.409l7.133 5.036a.5.5 0 0 1 0 .816l-7.133 5.036a.5.5 0 0 1-.288.091M16 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0z"/>',
    },
    "skip-left-fill": {
      body: '<path fill="currentColor" d="M7 18V6h2v12zm4-6l6-6v12z"/>',
    },
    "skip-left-line": {
      body: '<path fill="currentColor" d="m13.914 12l4.793-4.793l-1.414-1.414L11.086 12l6.207 6.207l1.414-1.414zM7 18V6h2v12z"/>',
    },
    "skip-right-fill": {
      body: '<path fill="currentColor" d="M17 6v12h-2V6zm-4 6l-6 6V6z"/>',
    },
    "skip-right-line": {
      body: '<path fill="currentColor" d="m10.086 12l-4.793 4.793l1.414 1.414L12.914 12L6.707 5.793L5.293 7.207zM17 6v12h-2V6z"/>',
    },
    "skip-up-fill": {
      body: '<path fill="currentColor" d="M6 7h12v2H6zm6 4l-6 6h12z"/>',
    },
    "skip-up-line": {
      body: '<path fill="currentColor" d="m12 13.914l4.793 4.793l1.414-1.414L12 11.086l-6.207 6.207l1.414 1.414zM6 7h12v2H6z"/>',
    },
    "skull-2-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10v3.764a2 2 0 0 1-1.106 1.789L18 19v1a3 3 0 0 1-2.824 2.995L14.95 23q.033-.161.044-.33L15 22.5V22a2 2 0 0 0-1.85-1.994L13 20h-2a2 2 0 0 0-1.995 1.85L9 22v.5q0 .258.05.5H9a3 3 0 0 1-3-3v-1l-2.894-1.447A2 2 0 0 1 2 15.763V12C2 6.477 6.477 2 12 2m-4 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "skull-2-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10v3.764a2 2 0 0 1-1.106 1.789L18 19v1a3 3 0 0 1-2.824 2.995L14.95 23q.033-.161.044-.33L15 22.5V22a2 2 0 0 0-1.85-1.994L13 20h-2a2 2 0 0 0-1.995 1.85L9 22v.5q0 .258.05.5H9a3 3 0 0 1-3-3v-1l-2.894-1.447A2 2 0 0 1 2 15.763V12C2 6.477 6.477 2 12 2m0 2a8 8 0 0 0-7.996 7.75L4 12v3.764l4 2v1.591l.075-.084a4 4 0 0 1 2.723-1.266L11 18l2.073.001l.223.01a4 4 0 0 1 2.55 1.177l.154.167v-1.591l4-2V12a8 8 0 0 0-8-8m-4 7a2 2 0 1 1 0 4a2 2 0 0 1 0-4m8 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "skull-fill": {
      body: '<path fill="currentColor" d="M18 18v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3H3a1 1 0 0 1-1-1v-5C2 6.477 6.477 2 12 2s10 4.477 10 10v5a1 1 0 0 1-1 1zM7.5 14a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m9 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "skull-line": {
      body: '<path fill="currentColor" d="M20 12a8 8 0 1 0-16 0v4h3a1 1 0 0 1 1 1v3h8v-3a1 1 0 0 1 1-1h3zm-2 6v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3H3a1 1 0 0 1-1-1v-5C2 6.477 6.477 2 12 2s10 4.477 10 10v5a1 1 0 0 1-1 1zM7.5 14a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "skype-fill": {
      body: '<path fill="currentColor" d="M13.31 20.4q-.64.1-1.309.1a8.5 8.5 0 0 1-8.4-9.81a5.25 5.25 0 0 1 7.09-7.09q.642-.1 1.31-.1a8.5 8.5 0 0 1 8.4 9.81a5.25 5.25 0 0 1-7.09 7.09m-1.257-3.244h-.04c2.872 0 4.303-1.386 4.303-3.243c0-1.198-.551-2.471-2.726-2.958l-1.983-.44c-.755-.172-1.622-.4-1.622-1.115s.62-1.213 1.724-1.213c2.23 0 2.027 1.528 3.131 1.528c.576 0 1.093-.342 1.093-.93c0-1.37-2.197-2.4-4.056-2.4c-2.021 0-4.173.859-4.173 3.144c0 1.098.394 2.27 2.56 2.813l2.689.671c.816.202 1.018.659 1.018 1.072c0 .687-.684 1.358-1.918 1.358c-2.417 0-2.078-1.857-3.374-1.857c-.58 0-1.003.398-1.003.971c0 1.114 1.352 2.598 4.377 2.598"/>',
    },
    "skype-line": {
      body: '<path fill="currentColor" d="M13.005 18.423a2 2 0 0 1 1.237.207a3.25 3.25 0 0 0 4.389-4.389a2 2 0 0 1-.207-1.237q.077-.495.077-1.004a6.5 6.5 0 0 0-7.504-6.423A2 2 0 0 1 9.76 5.37a3.25 3.25 0 0 0-4.389 4.39a2 2 0 0 1 .207 1.237Q5.5 11.49 5.5 12a6.5 6.5 0 0 0 7.504 6.423M12.001 20.5a8.5 8.5 0 0 1-8.4-9.81a5.25 5.25 0 0 1 7.09-7.09q.642-.1 1.31-.1a8.5 8.5 0 0 1 8.4 9.81a5.25 5.25 0 0 1-7.09 7.09q-.642.1-1.31.1m.053-3.5C9.252 17 8 15.62 8 14.586c0-.532.39-.902.928-.902c1.2 0 .887 1.725 3.125 1.725c1.143 0 1.776-.624 1.776-1.261c0-.384-.188-.808-.943-.995l-2.49-.624c-2.006-.504-2.37-1.592-2.37-2.612C8.027 7.797 10.019 7 11.89 7c1.72 0 3.755.956 3.755 2.228c0 .545-.479.863-1.011.863c-1.023 0-.835-1.418-2.9-1.418c-1.023 0-1.596.462-1.596 1.126s.803.876 1.502 1.035l1.836.409C15.49 11.695 16 12.876 16 13.989C16 15.713 14.675 17 12.015 17z"/>',
    },
    "slack-fill": {
      body: '<path fill="currentColor" d="M6.527 14.514A1.973 1.973 0 0 1 4.56 16.48a1.973 1.973 0 0 1-1.968-1.967c0-1.083.885-1.968 1.968-1.968h1.967zm.992 0c0-1.083.885-1.968 1.968-1.968s1.967.885 1.967 1.968v4.927a1.973 1.973 0 0 1-1.967 1.968a1.973 1.973 0 0 1-1.968-1.968zm1.968-7.987A1.973 1.973 0 0 1 7.519 4.56c0-1.083.885-1.967 1.968-1.967s1.967.884 1.967 1.967v1.968zm0 .992c1.083 0 1.967.884 1.967 1.967a1.973 1.973 0 0 1-1.967 1.968H4.56a1.973 1.973 0 0 1-1.968-1.968c0-1.083.885-1.967 1.968-1.967zm7.986 1.967c0-1.083.885-1.967 1.968-1.967s1.968.884 1.968 1.967a1.973 1.973 0 0 1-1.968 1.968h-1.968zm-.991 0a1.973 1.973 0 0 1-1.968 1.968a1.973 1.973 0 0 1-1.968-1.968V4.56c0-1.083.885-1.967 1.968-1.967s1.968.884 1.968 1.967zm-1.968 7.987c1.083 0 1.968.885 1.968 1.968a1.973 1.973 0 0 1-1.968 1.968a1.973 1.973 0 0 1-1.968-1.968v-1.968zm0-.992a1.973 1.973 0 0 1-1.968-1.967c0-1.083.885-1.968 1.968-1.968h4.927c1.083 0 1.968.885 1.968 1.968a1.973 1.973 0 0 1-1.968 1.967z"/>',
    },
    "slack-line": {
      body: '<path fill="currentColor" d="M14.501 3a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-3 0v-5a1.5 1.5 0 0 1 1.5-1.5m-10 10h1.5v1.5a1.5 1.5 0 1 1-1.5-1.5m8.5 5h1.5a1.5 1.5 0 1 1-1.5 1.5zm1.5-5h5a1.5 1.5 0 0 1 0 3h-5a1.5 1.5 0 1 1 0-3m5-5a1.5 1.5 0 0 1 0 3h-1.5V9.5a1.5 1.5 0 0 1 1.5-1.5m-15 0h5a1.5 1.5 0 1 1 0 3h-5a1.5 1.5 0 0 1 0-3m5-5a1.5 1.5 0 0 1 1.5 1.5V6h-1.5a1.5 1.5 0 1 1 0-3m0 10a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-3 0v-5a1.5 1.5 0 0 1 1.5-1.5"/>',
    },
    "slash-commands": {
      body: '<path fill="currentColor" d="M3 3h2v4H3zm6.788 18H7.66l6.551-18h2.129zM21 3h-2v4h2z"/>',
    },
    "slash-commands-2": {
      body: '<path fill="currentColor" d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zM4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm5.723 13L16.58 6h-2.303L7.42 18z"/>',
    },
    "slice-fill": {
      body: '<path fill="currentColor" d="m13.768 12.229l2.121 2.121c-4.596 4.596-10.253 6.01-13.788 5.303L17.657 4.097l2.121 2.121z"/>',
    },
    "slice-line": {
      body: '<path fill="currentColor" d="m15.69 12.915l1.769 1.767c-6.01 6.01-10.96 6.01-15.203 4.597L17.812 3.722l3.536 3.536zm-2.827 0l5.656-5.657l-.707-.707L6.314 18.048c2.732.108 5.358-.906 8.267-3.415z"/>',
    },
    "slideshow-2-fill": {
      body: '<path fill="currentColor" d="M13 17v3h5v2H6v-2h5v-3H4a1 1 0 0 1-1-1V4H2V2h20v2h-1v12a1 1 0 0 1-1 1zM10 6v7l5-3.5z"/>',
    },
    "slideshow-2-line": {
      body: '<path fill="currentColor" d="M13 17v3h5v2H6v-2h5v-3H4a1 1 0 0 1-1-1V4H2V2h20v2h-1v12a1 1 0 0 1-1 1zm-8-2h14V4H5zm5-9l5 3.5l-5 3.5z"/>',
    },
    "slideshow-3-fill": {
      body: '<path fill="currentColor" d="M13 18v2h4v2H7v-2h4v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1zM10 7.5v6l5-3z"/>',
    },
    "slideshow-3-line": {
      body: '<path fill="currentColor" d="M13 18v2h4v2H7v-2h4v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1zM4 5v11h16V5zm6 2.5l5 3l-5 3z"/>',
    },
    "slideshow-4-fill": {
      body: '<path fill="currentColor" d="M8.17 3A3 3 0 0 1 11 1h2c1.306 0 2.418.835 2.83 2H21a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM10 9v6l5-3zm1-6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"/>',
    },
    "slideshow-4-line": {
      body: '<path fill="currentColor" d="M8.17 3A3 3 0 0 1 11 1h2c1.306 0 2.418.835 2.83 2H21a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM4 5v14h16V5h-4.17A3 3 0 0 1 13 7h-2a3 3 0 0 1-2.83-2zm7-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm-1 6l5 3l-5 3z"/>',
    },
    "slideshow-fill": {
      body: '<path fill="currentColor" d="M13 21v2h-2v-2H3a1 1 0 0 1-1-1V6h20v14a1 1 0 0 1-1 1zM8 10a3 3 0 1 0 3 3H8zm5 0v2h6v-2zm0 4v2h6v-2zM2 3h20v2H2z"/>',
    },
    "slideshow-line": {
      body: '<path fill="currentColor" d="M13 21v2h-2v-2H3a1 1 0 0 1-1-1V6h20v14a1 1 0 0 1-1 1zm-9-2h16V8H4zm9-9h5v2h-5zm0 4h5v2h-5zm-4-4v3h3a3 3 0 1 1-3-3M2 3h20v2H2z"/>',
    },
    "slideshow-view": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 10h16V5H4zm0 2v3h4v-3zm6 0v3h4v-3zm6 0v3h4v-3z"/>',
    },
    "slow-down-fill": {
      body: '<path fill="currentColor" d="M4 13c0 2.21.895 4.21 2.343 5.657L4.93 20.07A9.97 9.97 0 0 1 2 13C2 7.477 6.477 3 12 3s10 4.477 10 10a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A8 8 0 1 0 4 13m4.707-4.707L13.5 12.5l-2 2l-4.207-4.793z"/>',
    },
    "slow-down-line": {
      body: '<path fill="currentColor" d="M4 13c0 2.21.895 4.21 2.343 5.657L4.93 20.07A9.97 9.97 0 0 1 2 13C2 7.477 6.477 3 12 3s10 4.477 10 10a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A8 8 0 1 0 4 13m4.707-4.707l4.5 4.5l-1.414 1.414l-4.5-4.5z"/>',
    },
    "smartphone-fill": {
      body: '<path fill="currentColor" d="M6 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m6 15a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "smartphone-line": {
      body: '<path fill="currentColor" d="M7 4v16h10V4zM6 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m6 15a1 1 0 1 1 0 2a1 1 0 0 1 0-2"/>',
    },
    "snapchat-fill": {
      body: '<path fill="currentColor" d="M11.872 21.765c-1.19 0-1.984-.562-2.693-1.057c-.504-.357-.976-.696-1.533-.79a4.6 4.6 0 0 0-.803-.066c-.472 0-.847.071-1.114.125c-.17.03-.312.058-.424.058c-.116 0-.263-.032-.32-.228c-.05-.16-.081-.312-.112-.459c-.08-.37-.147-.597-.286-.62c-1.489-.227-2.38-.57-2.554-.976c-.014-.044-.031-.09-.031-.125c-.01-.124.08-.227.205-.25c1.181-.195 2.242-.824 3.138-1.858c.696-.803 1.035-1.579 1.066-1.663c0-.01.009-.01.009-.01q.256-.527.102-.895c-.192-.46-.825-.656-1.257-.79c-.111-.03-.205-.066-.285-.093c-.37-.147-.986-.46-.905-.892c.058-.312.472-.535.811-.535q.141-.002.24.05c.38.173.723.262 1.017.262c.366 0 .54-.138.584-.182a25 25 0 0 0-.035-.593c-.09-1.365-.192-3.059.24-4.03c1.298-2.907 4.053-3.14 4.869-3.14L12.157 3h.05c.815 0 3.57.227 4.868 3.139c.437.971.33 2.67.24 4.03l-.009.067c-.008.182-.022.356-.03.535c.044.035.204.169.534.173c.286-.008.598-.102.954-.263a.8.8 0 0 1 .312-.066c.125 0 .25.03.357.066h.009c.299.112.495.321.495.54c.009.205-.152.517-.914.825c-.08.03-.174.067-.285.093c-.424.13-1.057.335-1.258.79c-.111.24-.067.548.103.896c0 .008.009.008.009.008c.049.125 1.337 3.05 4.204 3.527a.246.246 0 0 1 .205.25q.001.067-.031.129c-.174.41-1.057.744-2.555.976c-.138.022-.205.25-.285.62a7 7 0 0 1-.111.459c-.045.147-.139.227-.3.227h-.021a2.2 2.2 0 0 1-.424-.049a5.3 5.3 0 0 0-1.115-.116a5 5 0 0 0-.802.067c-.553.09-1.03.433-1.534.79c-.718.49-1.516 1.052-2.697 1.052z"/>',
    },
    "snapchat-line": {
      body: '<path fill="currentColor" d="m15.383 10.58l.02-.249c.01-.147.021-.304.031-.48q.05-.838.051-1.845c0-.872-.294-1.487-.914-2.064c-.66-.614-1.459-.942-2.59-.942c-1.137 0-1.958.335-2.51.888c-.696.695-.957 1.218-.957 2.1c0 .521.06 1.994.095 2.619a2 2 0 0 1-.468 1.4q.081.15.152.318c.3.771.198 1.543-.152 2.271c-.392.818-.73 1.393-1.41 2.154a8 8 0 0 1-.642.643a2 2 0 0 1 .412.564a6 6 0 0 1 1.585.075c.81.146 1.324.434 2.194 1.061l.016.011l.213.152c.62.44.877.546 1.473.546c.609 0 .91-.121 1.523-.552l.207-.146c.877-.632 1.407-.927 2.231-1.076a6.7 6.7 0 0 1 1.56-.074q.021-.043.048-.09q.151-.27.368-.477a8 8 0 0 1-.616-.617a9.2 9.2 0 0 1-1.447-2.159c-.363-.749-.47-1.54-.137-2.321q.06-.147.132-.276a2 2 0 0 1-.468-1.435m-10.316-.102c.42 0 .601.305 1.22.305a.74.74 0 0 0 .325-.066c-.008-.156-.098-1.986-.098-2.729c0-1.688.719-2.69 1.542-3.514S10.162 3 11.982 3s3.066.653 3.952 1.478s1.551 1.93 1.551 3.528c0 1.555-.099 2.594-.107 2.716a.6.6 0 0 0 .278.065c.63 0 .63-.31 1.33-.31c.686 0 .983.57.983.823c0 .621-.832.967-1.33 1.126c-.369.117-.931.291-1.075.635q-.11.261.092.678c.004.008 1.26 2.883 3.93 3.326c.235.035.392.241.392.483c0 .333-.37.617-.727.782c-.443.2-1.09.37-1.952.505c-.043.078-.134.485-.235.887c-.135.542-.8.366-.99.326A5 5 0 0 0 16.277 20c-.483.087-.913.378-1.396.726c-.713.504-1.465 1.076-2.9 1.076s-2.144-.572-2.857-1.076c-.482-.348-.904-.637-1.395-.726c-.899-.163-1.57.036-1.796.056s-.841.245-.996-.326c-.044-.166-.19-.808-.234-.895c-.857-.135-1.509-.313-1.953-.513c-.365-.165-.726-.443-.726-.778c0-.236.158-.44.392-.483c2.643-.483 3.765-3.004 3.921-3.33q.197-.412.092-.679c-.144-.343-.705-.513-1.074-.635c-.105-.034-1.335-.373-1.335-1.117c0-.24.204-.573.581-.73c.162-.066.359-.092.465-.092"/>',
    },
    "snowflake-fill": {
      body: '<path fill="currentColor" d="m12 3.298l2.445-1.63l1.11 1.664L13 5.035v5.233l4.53-2.618l.198-3.064l1.996.13l-.19 2.932l2.635 1.303l-.886 1.792l-2.753-1.36L14.001 12l4.53 2.616l2.753-1.36l.886 1.792l-2.634 1.303l.19 2.932l-1.997.129l-.197-3.064L13 13.732v5.233l2.555 1.703l-1.11 1.664L12 20.702l-2.446 1.63l-1.109-1.664L11 18.965v-5.233l-4.532 2.616l-.198 3.064l-1.996-.128l.19-2.933l-2.635-1.303l.887-1.793l2.752 1.361L10 12L5.468 9.383l-2.752 1.361l-.887-1.793L4.464 7.65l-.19-2.933l1.997-.129l.197 3.064L11 10.267V5.035L8.445 3.332l1.11-1.664z"/>',
    },
    "snowflake-line": {
      body: '<path fill="currentColor" d="m12 3.298l2.445-1.63l1.11 1.664L13 5.035v5.233l4.53-2.618l.198-3.064l1.996.13l-.19 2.932l2.635 1.303l-.886 1.792l-2.753-1.36L14.001 12l4.53 2.616l2.753-1.36l.886 1.792l-2.634 1.303l.19 2.932l-1.997.129l-.197-3.064L13 13.732v5.233l2.555 1.703l-1.11 1.664L12 20.702l-2.446 1.63l-1.109-1.664L11 18.965v-5.233l-4.532 2.616l-.198 3.064l-1.996-.128l.19-2.933l-2.635-1.303l.887-1.793l2.752 1.361L10 12L5.468 9.383l-2.752 1.361l-.887-1.793L4.464 7.65l-.19-2.933l1.997-.129l.197 3.064L11 10.267V5.035L8.445 3.332l1.11-1.664z"/>',
    },
    "snowy-fill": {
      body: '<path fill="currentColor" d="M6.027 17.43A8.003 8.003 0 0 1 9 2a8 8 0 0 1 7.458 5.099A5.5 5.5 0 1 1 18 17.978a6 6 0 0 0-11.973-.549M13 16.267l1.964-1.134l1 1.732L14 18l1.964 1.134l-1 1.732L13 19.732V22h-2v-2.268l-1.964 1.134l-1-1.732L10 18l-1.964-1.134l1-1.732L11 16.268V14h2z"/>',
    },
    "snowy-line": {
      body: '<path fill="currentColor" d="m13 16.268l1.964-1.134l1 1.732L14 18l1.964 1.134l-1 1.732L13 19.732V22h-2v-2.268l-1.964 1.134l-1-1.732L10 18l-1.964-1.134l1-1.732L11 16.268V14h2zM17 18v-2h.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 1 0-8 5.659v2.089a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18z"/>',
    },
    "sofa-fill": {
      body: '<path fill="currentColor" d="M15 3H9a6 6 0 0 0-5.92 5.02Q3.287 8 3.5 8A4.5 4.5 0 0 1 8 12.5V14h8v-1.5a4.5 4.5 0 0 1 4.92-4.48A6 6 0 0 0 15 3m6 7.05a2.5 2.5 0 0 0-3 2.45V17h-2v-1H8v1H6v-4.5a2.5 2.5 0 0 0-5 0c0 .589.182 1.039.39 1.555c.28.696.61 1.51.61 2.945v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3c0-1.434.33-2.25.61-2.945c.208-.516.39-.966.39-1.555a2.5 2.5 0 0 0-2-2.45"/>',
    },
    "sofa-line": {
      body: '<path fill="currentColor" d="M9 3a6 6 0 0 0-6 6v.351c-1.52.746-2.367 2.565-1.733 4.307l.312.86a7 7 0 0 1 .422 2.391V19.5A1.5 1.5 0 0 0 3.5 21h17a1.5 1.5 0 0 0 1.5-1.5v-2.59a7 7 0 0 1 .421-2.393l.313-.86c.633-1.741-.213-3.56-1.734-4.306V9a6 6 0 0 0-6-6zm10 6.032c-1.694.23-3 1.682-3 3.44V14H8v-1.528a3.47 3.47 0 0 0-3-3.44V9a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4zM16 16v1h2v-4.528a1.472 1.472 0 1 1 2.855.502l-.312.86A9 9 0 0 0 20 16.909V19H4v-2.09a9 9 0 0 0-.542-3.076l-.313-.86A1.471 1.471 0 1 1 6 12.472V17h2v-1z"/>',
    },
    "sort-alphabet-asc": {
      body: '<path fill="currentColor" d="M4.869 11H2.667L6 3h2l3.333 8H9.131l-.41-1H5.28zm1.23-3h1.803L7 5.8zm12.9 8V3h-2v13h-3l4 5l4-5zm-8-3H3v2h4.855L3 19v2h8v-2H6.146L11 15z"/>',
    },
    "sort-alphabet-desc": {
      body: '<path fill="currentColor" d="M4.869 11H2.667L6 3h2l3.333 8H9.131l-.41-1H5.28zm1.23-3h1.803L7 5.8zm15.9 0l-4-5l-4 5h3v13h2V8zm-11 5H3v2h4.855L3 19v2h8v-2H6.146L11 15z"/>',
    },
    "sort-asc": {
      body: '<path fill="currentColor" d="m19 3l4 5h-3v12h-2V8h-3zm-5 15v2H3v-2zm0-7v2H3v-2zm-2-7v2H3V4z"/>',
    },
    "sort-desc": {
      body: '<path fill="currentColor" d="M20 4v12h3l-4 5l-4-5h3V4zm-8 14v2H3v-2zm2-7v2H3v-2zm0-7v2H3V4z"/>',
    },
    "sort-number-asc": {
      body: '<path fill="currentColor" d="M9 3v8H7V5.41l-2 .539v-2.33L7.313 3zm10 0v13h3l-4 5l-4-5h3V3zm-8 12.5a3 3 0 0 1-.427 1.544L8.289 21h-2.31l1.473-2.55A3.001 3.001 0 1 1 11 15.5m-3 1a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "sort-number-desc": {
      body: '<path fill="currentColor" d="M9 11V3H7.314L5 3.62v2.329l2-.539V11zm13-3l-4-5l-4 5h3v13h2V8zM8 16.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2m2.573.544a3 3 0 1 0-3.121 1.406L5.979 21h2.31z"/>',
    },
    "sound-module-fill": {
      body: '<path fill="currentColor" d="M21 18v3h-2v-3h-2v-3h6v3zM5 18v3H3v-3H1v-3h6v3zm6-12V3h2v3h2v3H9V6zm0 5h2v10h-2zm-8 2V3h2v10zm16 0V3h2v10z"/>',
    },
    "sound-module-line": {
      body: '<path fill="currentColor" d="M21 18v3h-2v-3h-2v-2h6v2zM5 18v3H3v-3H1v-2h6v2zm6-12V3h2v3h2v2H9V6zm0 4h2v11h-2zm-8 4V3h2v11zm16 0V3h2v11z"/>',
    },
    "soundcloud-fill": {
      body: '<path fill="currentColor" d="M10.464 8.596c.265 0 .48 2.106.48 4.704l-.001.351c-.019 2.434-.226 4.353-.479 4.353c-.256 0-.465-1.965-.48-4.44v-.352c.005-2.557.218-4.616.48-4.616m-1.664.96c.259 0 .47 1.8.48 4.054v.34c-.01 2.254-.221 4.054-.48 4.054c-.255 0-.464-1.755-.48-3.97v-.34l.002-.34c.025-2.133.23-3.798.478-3.798m-1.664 0c.255 0 .464 1.755.48 3.97v.34l-.002.34c-.025 2.133-.23 3.798-.478 3.798c-.259 0-.47-1.8-.48-4.054v-.34c.01-2.254.221-4.054.48-4.054m-1.664.576c.265 0 .48 1.762.48 3.936l-.002.335c-.02 2.017-.227 3.601-.478 3.601c-.262 0-.474-1.717-.48-3.852v-.168c.006-2.135.218-3.852.48-3.852M3.808 11.86c.265 0 .48 1.375.48 3.072v.158c-.013 1.623-.223 2.914-.48 2.914c-.265 0-.48-1.375-.48-3.072v-.158c.013-1.623.223-2.914.48-2.914m10.784-4.8c2.58 0 4.72 1.886 5.118 4.355q.444-.129.93-.13a3.36 3.36 0 0 1 .063 6.718l-.063.001h-8.16a.77.77 0 0 1-.768-.768V7.933a5.16 5.16 0 0 1 2.88-.873M2.144 11.668c.265 0 .48 1.333.48 2.976v.156c-.014 1.57-.223 2.82-.48 2.82c-.26 0-.473-1.29-.48-2.898v-.078c0-1.643.215-2.976.48-2.976m-1.664.96c.265 0 .48.946.48 2.112v.131c-.016 1.105-.225 1.981-.48 1.981c-.265 0-.48-.946-.48-2.112v-.131c.016-1.105.225-1.98.48-1.98"/>',
    },
    "soundcloud-line": {
      body: '<path fill="currentColor" d="M4 10a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1m3 1a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m3-4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m5-1a6 6 0 0 1 5.996 5.775l.003.26a3.5 3.5 0 0 1-.307 6.96L20.5 19h-3.501a1 1 0 0 1-.117-1.993L17 17h3.447l.138-.002a1.5 1.5 0 0 0 .267-2.957l-.135-.026l-1.77-.252l.053-1.787l-.004-.176A4 4 0 0 0 15.2 8.005L15 8q-.402 0-.788.077L14 8.126v9.875a1 1 0 0 1-.883.992L13 19a1 1 0 0 1-1-1V6.804A6 6 0 0 1 15 6M1 12a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1"/>',
    },
    space: {
      body: '<path fill="currentColor" d="M4 9v4h16V9h2v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9z"/>',
    },
    "space-ship-fill": {
      body: '<path fill="currentColor" d="M2.88 18.049a35.9 35.9 0 0 1 8.531-16.32a.8.8 0 0 1 1.178 0q.25.27.412.456a35.9 35.9 0 0 1 8.119 15.864a44 44 0 0 1-6.584.875L12.447 23.1a.5.5 0 0 1-.894 0l-2.089-4.177a44 44 0 0 1-6.584-.875M12 14.995a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "space-ship-line": {
      body: '<path fill="currentColor" d="M2.88 18.05a35.9 35.9 0 0 1 8.53-16.322a.8.8 0 0 1 1.178 0q.25.27.412.456a35.9 35.9 0 0 1 8.119 15.864a44 44 0 0 1-6.584.875L12.447 23.1a.5.5 0 0 1-.894 0l-2.089-4.177a44 44 0 0 1-6.584-.875m6.697-1.123l1.158.066L12 19.523l1.265-2.53l1.157-.066a42 42 0 0 0 4.227-.455a33.9 33.9 0 0 0-6.65-12.387a33.9 33.9 0 0 0-6.648 12.387a42 42 0 0 0 4.226.455M12 14.995a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "spam-2-fill": {
      body: '<path fill="currentColor" d="m15.936 2.501l5.565 5.565v7.87l-5.565 5.565h-7.87l-5.565-5.565v-7.87l5.565-5.565zM11 15.001v2h2v-2zm0-8v6h2V7z"/>',
    },
    "spam-2-line": {
      body: '<path fill="currentColor" d="m15.936 2.501l5.565 5.565v7.87l-5.565 5.565h-7.87l-5.565-5.565v-7.87l5.565-5.565zm-.828 2H8.894L4.501 8.894v6.214L8.894 19.5h6.214l4.393-4.393V8.894zM11 15.001h2v2h-2zm0-8h2v6h-2z"/>',
    },
    "spam-3-fill": {
      body: '<path fill="currentColor" d="m15.936 2.501l5.565 5.565v7.87l-5.565 5.565h-7.87l-5.565-5.565v-7.87l5.565-5.565zM8 11.001v2h8v-2z"/>',
    },
    "spam-3-line": {
      body: '<path fill="currentColor" d="m15.936 2.501l5.565 5.565v7.87l-5.565 5.565h-7.87l-5.565-5.565v-7.87l5.565-5.565zm-.828 2H8.894L4.501 8.894v6.214L8.894 19.5h6.214l4.393-4.393V8.894zM8 11.001h8v2H8z"/>',
    },
    "spam-fill": {
      body: '<path fill="currentColor" d="M17.5 2.5L23 12l-5.5 9.5h-11L1 12l5.5-9.5zM11 15v2h2v-2zm0-8v6h2V7z"/>',
    },
    "spam-line": {
      body: '<path fill="currentColor" d="M17.5 2.5L23 12l-5.5 9.5h-11L1 12l5.5-9.5zm-1.153 2H7.653L3.311 12l4.342 7.5h8.694l4.342-7.5zM11 15h2v2h-2zm0-8h2v6h-2z"/>',
    },
    "sparkling-2-fill": {
      body: '<path fill="currentColor" d="m17 1.208l1.32 2.473L20.792 5L18.32 6.319L17 8.792l-1.318-2.473l-2.473-1.32l2.473-1.318zM8 4.333l2.667 5l5 2.667l-5 2.667l-2.666 5l-2.667-5l-5-2.667l5-2.667zm11.667 12l-1.666-3.125l-1.667 3.125L13.209 18l3.125 1.667l1.667 3.125l1.666-3.125L22.792 18z"/>',
    },
    "sparkling-2-line": {
      body: '<path fill="currentColor" d="m17 1.208l1.32 2.473L20.792 5L18.32 6.319L17 8.792l-1.318-2.473l-2.473-1.32l2.473-1.318zm-6.333 8.125l5 2.667l-5 2.667l-2.666 5l-2.667-5l-5-2.667l5-2.667l2.667-5zm.75 2.667L9.19 10.812L8.001 8.583l-1.189 2.229L4.584 12l2.228 1.188l1.189 2.229l1.188-2.229zm8.25 4.333l-1.666-3.125l-1.667 3.125L13.209 18l3.125 1.667l1.667 3.125l1.666-3.125L22.792 18z"/>',
    },
    "sparkling-fill": {
      body: '<path fill="currentColor" d="M14 4.438A2.437 2.437 0 0 0 16.438 2h1.125A2.437 2.437 0 0 0 20 4.438v1.125A2.437 2.437 0 0 0 17.563 8h-1.125A2.437 2.437 0 0 0 14 5.563zM1 11a6 6 0 0 0 6-6h2a6 6 0 0 0 6 6v2a6 6 0 0 0-6 6H7a6 6 0 0 0-6-6zm16.25 3A3.25 3.25 0 0 1 14 17.25v1.5A3.25 3.25 0 0 1 17.25 22h1.5A3.25 3.25 0 0 1 22 18.75v-1.5A3.25 3.25 0 0 1 18.75 14z"/>',
    },
    "sparkling-line": {
      body: '<path fill="currentColor" d="M14 4.438A2.437 2.437 0 0 0 16.438 2h1.125A2.437 2.437 0 0 0 20 4.438v1.125A2.437 2.437 0 0 0 17.563 8h-1.125A2.437 2.437 0 0 0 14 5.563zM1 11a6 6 0 0 0 6-6h2a6 6 0 0 0 6 6v2a6 6 0 0 0-6 6H7a6 6 0 0 0-6-6zm3.876 1A8.04 8.04 0 0 1 8 15.124A8.04 8.04 0 0 1 11.124 12A8.04 8.04 0 0 1 8 8.876A8.04 8.04 0 0 1 4.876 12m12.374 2A3.25 3.25 0 0 1 14 17.25v1.5A3.25 3.25 0 0 1 17.25 22h1.5A3.25 3.25 0 0 1 22 18.75v-1.5A3.25 3.25 0 0 1 18.75 14z"/>',
    },
    "speak-fill": {
      body: '<path fill="currentColor" d="M9 2a8 8 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L17 14.07V17a2 2 0 0 1-2 2h-1.999L13 22H4v-3.694c0-1.18-.436-2.297-1.244-3.305A8 8 0 0 1 9 2m12.154 16.102l-1.665-1.11A8.96 8.96 0 0 0 21 12a8.96 8.96 0 0 0-1.51-4.993l1.664-1.11A10.95 10.95 0 0 1 23 12c0 2.258-.68 4.356-1.846 6.102"/>',
    },
    "speak-line": {
      body: '<path fill="currentColor" d="M16.934 8.965A8.002 8.002 0 0 0 1 10c0 1.892.657 3.631 1.756 5.001C3.564 16.01 4 17.125 4 18.306V22h9l.001-3H15a2 2 0 0 0 2-2v-2.929l1.96-.84c.342-.146.372-.494.224-.727zM3 10a6 6 0 0 1 11.95-.779l.057.442l1.543 2.425l-1.55.664V17h-3.998L11 20H6v-1.694c0-1.639-.591-3.192-1.685-4.556A5.97 5.97 0 0 1 3 10m18.154 8.102l-1.665-1.11A8.96 8.96 0 0 0 21 12a8.96 8.96 0 0 0-1.51-4.993l1.664-1.11A10.95 10.95 0 0 1 23 12c0 2.258-.68 4.356-1.846 6.102"/>',
    },
    "speaker-2-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 14a5 5 0 1 1 0-10a5 5 0 0 1 0 10m0 2a7 7 0 1 0 0-14a7 7 0 0 0 0 14m0-5a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "speaker-2-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 13a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0 2a6 6 0 1 1 0-12a6 6 0 0 1 0 12m0-4.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "speaker-3-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 13a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0 2a6 6 0 1 0 0-12a6 6 0 0 0 0 12M6 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2m12 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 12a1 1 0 1 0 0-2a1 1 0 0 0 0 2M6 19a1 1 0 1 0 0-2a1 1 0 0 0 0 2m6-5.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "speaker-3-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 5a1 1 0 1 1 0-2a1 1 0 0 1 0 2m10 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0 10a1 1 0 1 1 0-2a1 1 0 0 1 0 2M7 18a1 1 0 1 1 0-2a1 1 0 0 1 0 2m5-3a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2a5 5 0 1 1 0-10a5 5 0 0 1 0 10m0-4a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "speaker-fill": {
      body: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m8 18a5 5 0 1 0 0-10a5 5 0 0 0 0 10m0-12a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 10a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "speaker-line": {
      body: '<path fill="currentColor" d="M5 4v16h14V4zM4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m8 15a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m0 2a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m0-10.5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "spectrum-fill": {
      body: '<path fill="currentColor" d="M13.2 2.006C21.24 2.093 22 3.25 22 12l-.005 1.2C21.908 21.24 20.75 22 12 22l-1.2-.006c-7.658-.083-8.712-1.136-8.794-8.795L2 11.691l.006-.89c.085-7.85 1.19-8.76 9.381-8.8zM8.25 7h-.583a.67.67 0 0 0-.66.568l-.006.099v3.666c0 .335.246.612.568.66l.098.007h.584a3.75 3.75 0 0 1 3.744 3.55l.006.2v.583c0 .335.246.612.568.66l.098.007h3.667a.67.67 0 0 0 .66-.568l.007-.099v-.583a8.75 8.75 0 0 0-8.492-8.746z"/>',
    },
    "spectrum-line": {
      body: '<path fill="currentColor" d="m11.389 2.001l1.81.005l.844.014c7.162.165 7.939 1.512 7.957 9.667l-.005 1.512l-.014.844c-.165 7.161-1.512 7.938-9.667 7.957l-1.512-.006l-.888-.015c-6.854-.163-7.828-1.427-7.907-8.78L2 11.691l.006-.89l.014-.865c.165-7.053 1.486-7.897 9.368-7.935M14.12 4.01L10.883 4l-1.322.01c-5.489.082-5.544.82-5.56 7.403l.002 2.175l.01 1.04c.088 4.983.793 5.343 6.399 5.37l3.455-.002l.776-.01c5.108-.091 5.346-.836 5.357-6.877l-.002-2.742l-.012-1.056c-.094-4.796-.785-5.25-5.866-5.303M8.25 7A8.75 8.75 0 0 1 17 15.75v.583a.667.667 0 0 1-.666.667h-3.667a.667.667 0 0 1-.666-.667v-.583A3.75 3.75 0 0 0 8.25 12h-.584A.667.667 0 0 1 7 11.333V7.667C7 7.299 7.299 7 7.667 7z"/>',
    },
    "speed-fill": {
      body: '<path fill="currentColor" d="m12 13.333l-9.223 6.149A.5.5 0 0 1 2 19.066V4.934a.5.5 0 0 1 .777-.416L12 10.667V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832l-10.599 7.066a.5.5 0 0 1-.777-.416z"/>',
    },
    "speed-line": {
      body: '<path fill="currentColor" d="m12 13.333l-9.223 6.149A.5.5 0 0 1 2 19.066V4.934a.5.5 0 0 1 .777-.416L12 10.667V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832l-10.599 7.066a.5.5 0 0 1-.777-.416zM10.394 12L4 7.737v8.526zM14 7.737v8.526L20.394 12z"/>',
    },
    "speed-mini-fill": {
      body: '<path fill="currentColor" d="M4.788 17.443A.5.5 0 0 1 4 17.035V6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817zM13 6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817l-7.133 5.035a.5.5 0 0 1-.788-.408z"/>',
    },
    "speed-mini-line": {
      body: '<path fill="currentColor" d="M9.032 12L6 9.86v4.28zm-4.244 5.443A.5.5 0 0 1 4 17.035V6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817zM15 14.14L18.032 12L15 9.86zm-2-7.175a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817l-7.133 5.035a.5.5 0 0 1-.788-.408z"/>',
    },
    "speed-up-fill": {
      body: '<path fill="currentColor" d="M20 13c0 2.21-.895 4.21-2.343 5.657l1.414 1.414A9.97 9.97 0 0 0 22 13c0-5.523-4.477-10-10-10S2 7.477 2 13a9.97 9.97 0 0 0 2.929 7.071l1.414-1.414A8 8 0 1 1 20 13m-4.707-4.707L10.5 12.5l2 2l4.207-4.793z"/>',
    },
    "speed-up-line": {
      body: '<path fill="currentColor" d="M20 13c0 2.21-.895 4.21-2.343 5.657l1.414 1.414A9.97 9.97 0 0 0 22 13c0-5.523-4.477-10-10-10S2 7.477 2 13a9.97 9.97 0 0 0 2.929 7.071l1.414-1.414A8 8 0 1 1 20 13m-4.707-4.707l-4.5 4.5l1.414 1.414l4.5-4.5z"/>',
    },
    "split-cells-horizontal": {
      body: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-9 2H5v14h6v-4h2v4h6V5h-6v4h-2zm4 4l3 3l-3 3v-2H9v2l-3-3l3-3v2h6z"/>',
    },
    "split-cells-vertical": {
      body: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 2H5v5.999L9 11v2H5v6h14v-6h-4v-2l4-.001zm-7 1l3 3h-2v6h2l-3 3l-3-3h2V9H9z"/>',
    },
    "spotify-fill": {
      body: '<path fill="currentColor" d="M12.001 2c-5.5 0-10 4.5-10 10s4.5 10 10 10s10-4.5 10-10s-4.45-10-10-10m3.75 14.65c-2.35-1.45-5.3-1.75-8.8-.95c-.35.1-.65-.15-.75-.45c-.1-.35.15-.65.45-.75c3.8-.85 7.1-.5 9.7 1.1c.35.15.4.55.25.85c-.2.3-.55.4-.85.2m1-2.7c-2.7-1.65-6.8-2.15-9.95-1.15c-.4.1-.85-.1-.95-.5s.1-.85.5-.95c3.65-1.1 8.15-.55 11.25 1.35c.3.15.45.65.2 1s-.7.5-1.05.25M6.3 9.75c-.5.15-1-.15-1.15-.6c-.15-.5.15-1 .6-1.15c3.55-1.05 9.4-.85 13.1 1.35c.45.25.6.85.35 1.3c-.25.35-.85.5-1.3.25C14.7 9 9.35 8.8 6.3 9.75"/>',
    },
    "spotify-line": {
      body: '<path fill="currentColor" d="M12.001 2c5.55 0 10 4.5 10 10s-4.5 10-10 10s-10-4.5-10-10s4.5-10 10-10m0 2c-4.395 0-8 3.605-8 8s3.605 8 8 8s8-3.605 8-8c0-4.414-3.573-8-8-8m3.75 12.65c-2.35-1.45-5.3-1.75-8.8-.95c-.35.1-.65-.15-.75-.45c-.1-.35.15-.65.45-.75c3.8-.85 7.1-.5 9.7 1.1c.35.15.4.55.25.85c-.2.3-.55.4-.85.2m1-2.7c-2.7-1.65-6.8-2.15-9.95-1.15c-.4.1-.85-.1-.95-.5s.1-.85.5-.95c3.65-1.1 8.15-.55 11.25 1.35c.3.15.45.65.2 1s-.7.5-1.05.25M6.3 9.75c-.5.15-1-.15-1.15-.6c-.15-.5.15-1 .6-1.15c3.55-1.05 9.4-.85 13.1 1.35c.45.25.6.85.35 1.3c-.25.35-.85.5-1.3.25C14.7 9 9.35 8.8 6.3 9.75"/>',
    },
    "spy-fill": {
      body: '<path fill="currentColor" d="M17 13a4 4 0 0 1 0 8c-2.142 0-4-1.79-4-4h-2a4 4 0 1 1-.535-2h3.07A4 4 0 0 1 17 13M2 12v-2h2V7a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3h2v2z"/>',
    },
    "spy-line": {
      body: '<path fill="currentColor" d="M17 13a4 4 0 1 1-4 4h-2a4 4 0 1 1-.535-2h3.07A4 4 0 0 1 17 13M7 15a2 2 0 1 0 0 4a2 2 0 0 0 0-4m10 0a2 2 0 1 0 0 4a2 2 0 0 0 0-4M16 3a4 4 0 0 1 4 4v3h2v2H2v-2h2V7a4 4 0 0 1 4-4zm0 2H8c-1.054 0-2 .95-2 2v3h12V7c0-1.054-.95-2-2-2"/>',
    },
    "square-fill": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "square-line": {
      body: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h14V5z"/>',
    },
    "square-root": {
      body: '<path fill="currentColor" d="M15.382 4H22v2h-5.382L9 21.236L5.382 14H2v-2h4.618L9 16.764z"/>',
    },
    "stack-fill": {
      body: '<path fill="currentColor" d="m20.083 10.5l1.203.721a.5.5 0 0 1 0 .858L12 17.649l-9.285-5.57a.5.5 0 0 1 0-.858l1.202-.721L12 15.35zm0 4.7l1.203.721a.5.5 0 0 1 0 .858l-8.772 5.262a1 1 0 0 1-1.028 0L2.715 16.78a.5.5 0 0 1 0-.858l1.202-.721L12 20.05zM12.515 1.309l8.77 5.262a.5.5 0 0 1 0 .858L12 12.999L2.715 7.43a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0"/>',
    },
    "stack-line": {
      body: '<path fill="currentColor" d="m20.083 15.2l1.203.721a.5.5 0 0 1 0 .858l-8.772 5.262a1 1 0 0 1-1.028 0L2.715 16.78a.5.5 0 0 1 0-.858l1.202-.721L12 20.05zm0-4.7l1.203.721a.5.5 0 0 1 0 .858L12 17.649l-9.285-5.57a.5.5 0 0 1 0-.858l1.202-.721L12 15.35zm-7.568-9.191l8.77 5.262a.5.5 0 0 1 0 .858L12 12.999L2.715 7.43a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0M12 3.332L5.887 7L12 10.668L18.113 7z"/>',
    },
    "stack-overflow-fill": {
      body: '<path fill="currentColor" d="M18.001 20.003v-5.334h2v7.334h-16v-7.334h2v5.334zM7.6 14.736l.313-1.98l8.837 1.7l-.113 1.586zm1.2-4.532l.732-1.6l7.998 3.733l-.733 1.6zm2.265-3.932l1.133-1.333l6.798 5.665l-1.133 1.333zm4.332-4.132l5.265 7.064l-1.4 1.067l-5.264-7.065zM7.333 18.668v-2h9.33v2z"/>',
    },
    "stack-overflow-line": {
      body: '<path fill="currentColor" d="M18.001 20.003V15h2v7.003h-16V15h2v5.003zM7.501 18v-2h9v2zm.077-4.38l.347-1.97l8.864 1.563l-.348 1.97zm1.634-5.504l1-1.732l7.794 4.5l-1 1.732zm3.417-4.613l1.532-1.285l5.785 6.894l-1.532 1.286z"/>',
    },
    "stacked-view": {
      body: '<path fill="currentColor" d="M4 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm1 11V4h14v9zm-1 4a1 1 0 0 0-1 1v4h2v-3h14v3h2v-4a1 1 0 0 0-1-1z"/>',
    },
    "stackshare-fill": {
      body: '<path fill="currentColor" d="M21.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-4.208 2.621a2.22 2.22 0 0 0-2.133 1.6h-1.998l-2.46 4.185H8.764a2.222 2.222 0 1 0 0 1.242h1.471l2.417 4.134h2.018a2.222 2.222 0 1 0 0-1.243h-1.317l-2.056-3.537l2.053-3.538h1.31a2.222 2.222 0 1 0 2.133-2.843m.011 9.427a1.168 1.168 0 1 1-1.145 1.394s-.03-.226 0-.453a1.17 1.17 0 0 1 1.145-.94m-10.152-4.21a1.169 1.169 0 0 1 0 2.335a1.168 1.168 0 0 1 0-2.335m10.15-4.209a1.168 1.168 0 0 1 0 2.335a1.17 1.17 0 0 1-1.144-.941c-.026-.206 0-.446 0-.446a1.17 1.17 0 0 1 1.144-.948"/>',
    },
    "stackshare-line": {
      body: '<path fill="currentColor" d="M9.537 13H7.33a3.001 3.001 0 0 1-5.829-1a3 3 0 0 1 5.83-1h2.206l3.464-6h3.17a3.001 3.001 0 0 1 5.83 1a3 3 0 0 1-5.829 1h-2.017l-2.886 4.999L14.156 17h2.016A3.001 3.001 0 0 1 22 18a3 3 0 0 1-5.829 1H13zm9.464 4a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-14.5-6a1 1 0 1 0 0 2a1 1 0 0 0 0-2m14.5-6a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "stairs-fill": {
      body: '<path fill="currentColor" d="M15 3h6v18H3v-6h4v-4h4V7h4z"/>',
    },
    "stairs-line": {
      body: '<path fill="currentColor" d="M15 3h6v18H3v-6h4v-4h4V7h4zm2 2v4h-4v4H9v4H5v2h14V5z"/>',
    },
    "star-fill": {
      body: '<path fill="currentColor" d="m12 18.26l-7.053 3.948l1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34l8.027.952l-5.934 5.488l1.575 7.928z"/>',
    },
    "star-half-fill": {
      body: '<path fill="currentColor" d="m12 15.968l4.247 2.377l-.948-4.773l3.573-3.305l-4.833-.573l-2.038-4.419zm0 2.292l-7.053 3.948l1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34l8.027.952l-5.934 5.488l1.575 7.928z"/>',
    },
    "star-half-line": {
      body: '<path fill="currentColor" d="m12 15.968l4.247 2.377l-.948-4.773l3.573-3.305l-4.833-.573l-2.038-4.419zm0 2.292l-7.053 3.948l1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34l8.027.952l-5.934 5.488l1.575 7.928z"/>',
    },
    "star-half-s-fill": {
      body: '<path fill="currentColor" d="m12 14.656l2.816 1.72l-.765-3.21l2.506-2.147l-3.29-.264L12 7.708zM12 17l-5.878 3.59l1.598-6.7l-5.23-4.48l6.865-.55L12 2.5l2.645 6.36l6.865.55l-5.23 4.48l1.598 6.7z"/>',
    },
    "star-half-s-line": {
      body: '<path fill="currentColor" d="m12 14.656l2.816 1.72l-.765-3.21l2.506-2.147l-3.29-.264L12 7.708zM12 17l-5.878 3.59l1.598-6.7l-5.23-4.48l6.865-.55L12 2.5l2.645 6.36l6.865.55l-5.23 4.48l1.598 6.7z"/>',
    },
    "star-line": {
      body: '<path fill="currentColor" d="m12 18.26l-7.053 3.948l1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34l8.027.952l-5.934 5.488l1.575 7.928zm0-2.292l4.247 2.377l-.948-4.773l3.573-3.305l-4.833-.573l-2.038-4.419l-2.039 4.42l-4.833.572l3.573 3.305l-.948 4.773z"/>',
    },
    "star-s-fill": {
      body: '<path fill="currentColor" d="m12 17l-5.878 3.59l1.598-6.7l-5.23-4.48l6.865-.55L12 2.5l2.645 6.36l6.865.55l-5.23 4.48l1.598 6.7z"/>',
    },
    "star-s-line": {
      body: '<path fill="currentColor" d="m12 17l-5.878 3.59l1.598-6.7l-5.23-4.48l6.865-.55L12 2.5l2.645 6.36l6.865.55l-5.23 4.48l1.598 6.7zm0-2.344l2.816 1.72l-.765-3.21l2.506-2.147l-3.29-.264L12 7.708l-1.268 3.047l-3.29.264l2.507 2.147l-.766 3.21z"/>',
    },
    "star-smile-fill": {
      body: '<path fill="currentColor" d="m12 .5l4.226 6.183l7.186 2.109l-4.575 5.93l.216 7.486L12 19.69l-7.054 2.518l.216-7.486l-4.575-5.93l7.187-2.109zM10 12H8a4 4 0 0 0 7.995.2L16 12h-2a2 2 0 0 1-3.995.15z"/>',
    },
    "star-smile-line": {
      body: '<path fill="currentColor" d="m12 .5l4.226 6.183l7.186 2.109l-4.575 5.93l.216 7.486L12 19.69l-7.054 2.518l.216-7.486l-4.575-5.93l7.187-2.109zm0 3.544L9.022 8.402L3.957 9.887l3.225 4.179l-.153 5.274l4.97-1.774l4.97 1.774l-.151-5.274l3.224-4.179l-5.065-1.485zM10 12a2 2 0 1 0 4 0h2a4 4 0 0 1-8 0z"/>',
    },
    "steam-fill": {
      body: '<path fill="currentColor" d="M12.005 2c-5.25 0-9.556 4.05-9.964 9.198l5.36 2.214a2.8 2.8 0 0 1 1.593-.491q.08.001.157.005l2.384-3.452v-.049c0-2.08 1.69-3.77 3.77-3.77a3.776 3.776 0 0 1 3.77 3.773c0 2.08-1.691 3.77-3.77 3.77h-.087l-3.397 2.426l.003.133A2.826 2.826 0 0 1 9 18.587a2.844 2.844 0 0 1-2.775-2.273l-3.838-1.589C3.574 18.923 7.428 22 12.006 22c5.522 0 9.998-4.477 9.998-10S17.527 2 12.005 2M7.08 16.667c.218.452.595.832 1.095 1.041a2.126 2.126 0 0 0 2.78-2.77a2.123 2.123 0 0 0-2.712-1.178l1.269.526a1.565 1.565 0 0 1-1.204 2.889zm10.74-7.245a2.516 2.516 0 0 0-2.513-2.512a2.513 2.513 0 1 0 2.513 2.512M15.312 7.53A1.89 1.89 0 0 1 17.2 9.418a1.89 1.89 0 0 1-1.888 1.888a1.887 1.887 0 1 1 0-3.776"/>',
    },
    "steam-line": {
      body: '<path fill="currentColor" d="M17.001 4a5 5 0 1 1-.892 9.92l-2.651 1.989q.042.29.043.591a4 4 0 1 1-7.966-.524L1.709 14.43l.75-1.854l3.826 1.545a4 4 0 0 1 3.697-1.592l2.04-3.061A5 5 0 0 1 17.002 4m-7.5 10.5c-.464 0-.892.158-1.231.424l1.606.649a1 1 0 0 1-.75 1.854L7.52 16.78a2 2 0 1 0 1.981-2.28m3.364-2.69l-.983 1.476c.284.21.54.458.758.735l1.36-1.02a5 5 0 0 1-1.135-1.191M17 6a3 3 0 1 0 0 6a3 3 0 0 0 0-6m0 1a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/>',
    },
    "steering-2-fill": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2M8 13l-3.938.001A8.004 8.004 0 0 0 11 19.938V16a3 3 0 0 1-3-3m11.938.001L16 13a3 3 0 0 1-3 3l.001 3.938a8.004 8.004 0 0 0 6.937-6.937M12 4a8 8 0 0 0-7.938 7H8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h3.938A8 8 0 0 0 12 4"/>',
    },
    "steering-2-line": {
      body: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2M8 13l-3.938.001A8.004 8.004 0 0 0 11 19.938V16a3 3 0 0 1-3-3m11.938.001L16 13a3 3 0 0 1-3 3l.001 3.938a8.004 8.004 0 0 0 6.937-6.937M14 12h-4v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm-2-8a8 8 0 0 0-7.938 7H8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h3.938A8 8 0 0 0 12 4"/>',
    },
    "steering-fill": {
      body: '<path fill="currentColor" d="M21.8 14.001a10.01 10.01 0 0 1-8.401 7.902v-2.025A8.01 8.01 0 0 0 19.747 14zm-17.548 0a8.01 8.01 0 0 0 6.247 5.859v2.028a10.01 10.01 0 0 1-8.3-7.887zM17.999 11v2h-1a4 4 0 0 0-3.995 3.8L13 17v1h-2v-1a4 4 0 0 0-3.8-3.995L7 13H6v-2zm-6-9c5.186 0 9.45 3.947 9.951 9h-2.012A8.001 8.001 0 0 0 4.06 11H2.05C2.552 5.947 6.815 2 12 2"/>',
    },
    "steering-line": {
      body: '<path fill="currentColor" d="M21.8 14.001a10.01 10.01 0 0 1-8.401 7.902v-2.025A8.01 8.01 0 0 0 19.747 14zm-17.548 0a8.01 8.01 0 0 0 6.247 5.859v2.028a10.01 10.01 0 0 1-8.3-7.887zM17.999 11v2h-3a2 2 0 0 0-1.994 1.85l-.006.15v3h-2v-3a2 2 0 0 0-1.85-1.995L8.999 13H6v-2zm-6-9c5.186 0 9.45 3.947 9.951 9h-2.012A8.001 8.001 0 0 0 4.06 11H2.05C2.552 5.947 6.815 2 12 2"/>',
    },
    "stethoscope-fill": {
      body: '<path fill="currentColor" d="M8 3v2H6v4a4 4 0 0 0 8 0V5h-2V3h3a1 1 0 0 1 1 1v5a6 6 0 0 1-5 5.917V16.5a3.5 3.5 0 0 0 6.775 1.238a3 3 0 1 1 2.05.148A5.502 5.502 0 0 1 8.999 16.5v-1.583A6 6 0 0 1 4 9V4a1 1 0 0 1 1-1z"/>',
    },
    "stethoscope-line": {
      body: '<path fill="currentColor" d="M8 3v2H6v4a4 4 0 0 0 8 0V5h-2V3h3a1 1 0 0 1 1 1v5a6 6 0 0 1-5 5.917V16.5a3.5 3.5 0 0 0 6.775 1.238a3 3 0 1 1 2.05.148A5.502 5.502 0 0 1 8.999 16.5v-1.583A6 6 0 0 1 4 9V4a1 1 0 0 1 1-1zm11 11a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "sticky-note-2-fill": {
      body: '<path fill="currentColor" d="m21 16l-5.003 5H3.998A.996.996 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.447.993.999z"/>',
    },
    "sticky-note-2-line": {
      body: '<path fill="currentColor" d="M3.998 21A.996.996 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.447.993.999V16l-5.003 5zM5 19h10.169L19 15.171V5H5z"/>',
    },
    "sticky-note-add-fill": {
      body: '<path fill="currentColor" d="M4 1v3H1v2h3v3h2V6h3V4H6V1zm7 4a6 6 0 0 1-8 5.659v9.348c0 .548.447.993.998.993H14v-6c0-.55.45-1 1-1h6V3.999A.996.996 0 0 0 20.007 3h-9.348A6 6 0 0 1 11 5m10 11l-5 4.997V16z"/>',
    },
    "sticky-note-add-line": {
      body: '<path fill="currentColor" d="M4 1v3H1v2h3v3h2V6h3V4H6V1zM3 20.007V11h2v8h8v-5c0-.55.45-1 1-1l5-.001V5h-8V3h9.007c.548 0 .993.456.993 1.002V15l-6 5.996L4.002 21A1 1 0 0 1 3 20.007m15.171-5.008L15 15v3.169z"/>',
    },
    "sticky-note-fill": {
      body: '<path fill="currentColor" d="m15 14l-.117.007a1 1 0 0 0-.876.876L14 15v6H3.998A.996.996 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.447.993.999V14zm6 2l-5 4.997V16z"/>',
    },
    "sticky-note-line": {
      body: '<path fill="currentColor" d="m21 15l-6 5.996L4.002 21A1 1 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.456.993 1.002zM19 5H5v14h8v-5a1 1 0 0 1 .883-.993L14 13l5-.001zm-.829 9.999L15 15v3.169z"/>',
    },
    "stock-fill": {
      body: '<path fill="currentColor" d="M8.005 5.003h3v9h-3v3h-2v-3h-3v-9h3v-3h2zm10 5h3v9h-3v3h-2v-3h-3v-9h3v-3h2z"/>',
    },
    "stock-line": {
      body: '<path fill="currentColor" d="M8.005 5.003h3v9h-3v3h-2v-3h-3v-9h3v-3h2zm-3 2v5h4v-5zm13 3h3v9h-3v3h-2v-3h-3v-9h3v-3h2zm-3 2v5h4v-5z"/>',
    },
    "stop-circle-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M9 9v6h6V9z"/>',
    },
    "stop-circle-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M9 9h6v6H9z"/>',
    },
    "stop-fill": {
      body: '<path fill="currentColor" d="M6 5h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/>',
    },
    "stop-large-fill": {
      body: '<path fill="currentColor" d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>',
    },
    "stop-large-line": {
      body: '<path fill="currentColor" d="M5 5h14v14H5zM4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"/>',
    },
    "stop-line": {
      body: '<path fill="currentColor" d="M7 7v10h10V7zM6 5h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/>',
    },
    "stop-mini-fill": {
      body: '<path fill="currentColor" d="M6 7v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1"/>',
    },
    "stop-mini-line": {
      body: '<path fill="currentColor" d="M6 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm2 1v8h8V8z"/>',
    },
    "store-2-fill": {
      body: '<path fill="currentColor" d="M22 20v2H2v-2h1v-6.758A4.5 4.5 0 0 1 1 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 0 1 .866-.5H18.79a1 1 0 0 1 .866.5l2.703 4.682c.418.694.642 1.49.642 2.318c0 1.56-.794 2.935-2 3.742V20zM5.789 4L3.356 8.213a2.5 2.5 0 1 0 4.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 0 0 4.644 0c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 1 0 4.457-2.232L18.21 4z"/>',
    },
    "store-2-line": {
      body: '<path fill="currentColor" d="M21 13.242V20h1v2H2v-2h1v-6.758A4.5 4.5 0 0 1 1 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 0 1 .866-.5H18.79a1 1 0 0 1 .866.5l2.703 4.682c.418.694.642 1.49.642 2.318c0 1.56-.794 2.935-2 3.742m-2 .73a4.5 4.5 0 0 1-3.75-1.36A4.5 4.5 0 0 1 12 14.001a4.5 4.5 0 0 1-3.25-1.387A4.5 4.5 0 0 1 5 13.973V20h14zM5.789 4L3.356 8.213a2.5 2.5 0 1 0 4.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 0 0 4.644 0c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 1 0 4.457-2.232L18.21 4z"/>',
    },
    "store-3-fill": {
      body: '<path fill="currentColor" d="M21 13v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7H2v-2l1-5h18l1 5v2zM5 13v6h14v-6zm1 1h8v3H6zM3 3h18v2H3z"/>',
    },
    "store-3-line": {
      body: '<path fill="currentColor" d="M21 13v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7H2v-2l1-5h18l1 5v2zM5 13v6h14v-6zm-.96-2h15.92l-.6-3H4.64zM6 14h8v3H6zM3 3h18v2H3z"/>',
    },
    "store-fill": {
      body: '<path fill="currentColor" d="M21 11.646V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.354A4 4 0 0 1 2 9V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6a4 4 0 0 1-1 2.646M14 9a1 1 0 1 1 2 0a2 2 0 1 0 4 0V4H4v5a2 2 0 1 0 4 0a1 1 0 0 1 2 0a2 2 0 1 0 4 0"/>',
    },
    "store-line": {
      body: '<path fill="currentColor" d="M21 11.646V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.354A4 4 0 0 1 2 9V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6a4 4 0 0 1-1 2.646m-2 1.228a4.01 4.01 0 0 1-4-1.228A4 4 0 0 1 12 13a4 4 0 0 1-3-1.354a3.99 3.99 0 0 1-4 1.228V20h14zM14 9a1 1 0 1 1 2 0a2 2 0 1 0 4 0V4H4v5a2 2 0 1 0 4 0a1 1 0 0 1 2 0a2 2 0 1 0 4 0"/>',
    },
    strikethrough: {
      body: '<path fill="currentColor" d="M17.154 14q.346.774.346 1.72q0 2.014-1.571 3.147Q14.357 20 11.586 20q-2.46 0-4.87-1.145v-2.254q2.28 1.316 4.666 1.316q3.826 0 3.839-2.197a2.2 2.2 0 0 0-.648-1.603l-.12-.117H3v-2h18v2zm-4.078-3H7.629a4 4 0 0 1-.481-.522Q6.5 9.643 6.5 8.452q0-1.854 1.397-3.153T12.222 4q2.207 0 4.222.984v2.152q-1.8-1.03-3.946-1.03q-3.72 0-3.719 2.346q0 .63.654 1.099q.654.47 1.613.75q.93.27 2.03.699"/>',
    },
    "strikethrough-2": {
      body: '<path fill="currentColor" d="M13 9h-2V6H5V4h14v2h-6zm0 6v5h-2v-5zM3 11h18v2H3z"/>',
    },
    subscript: {
      body: '<path fill="currentColor" d="M5.596 4L10.5 9.928L15.404 4H18l-6.202 7.497L18 18.994V19h-2.59l-4.91-5.934L5.59 19H3v-.006l6.202-7.497L3 4zM21.8 16a.8.8 0 1 0-1.57.22l-1.154.33A2.001 2.001 0 1 1 23 16c0 .573-.24 1.09-.626 1.454L20.744 19H23v1h-4v-1l2.55-2.42a.8.8 0 0 0 .25-.58"/>',
    },
    "subscript-2": {
      body: '<path fill="currentColor" d="M11 6v13H9V6H3V4h14v2zm8.55 10.58a.8.8 0 1 0-1.32-.36l-1.154.33A2.001 2.001 0 1 1 21 16c0 .573-.24 1.09-.626 1.454L18.744 19H21v1h-4v-1z"/>',
    },
    "subtract-fill": {
      body: '<path fill="currentColor" d="M19 11H5v2h14z"/>',
    },
    "subtract-line": {
      body: '<path fill="currentColor" d="M5 11v2h14v-2z"/>',
    },
    "subway-fill": {
      body: '<path fill="currentColor" d="m17.2 20l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2zM11 12V5H7a2 2 0 0 0-2 2v5zm2 0h6V7a2 2 0 0 0-2-2h-4zm-5.5 6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m9 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "subway-line": {
      body: '<path fill="currentColor" d="m17.2 20l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2zM13 5v6h6V7a2 2 0 0 0-2-2zm-2 0H7a2 2 0 0 0-2 2v4h6zm8 8H5v5h14zM7.5 17a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "subway-wifi-fill": {
      body: '<path fill="currentColor" d="M13 3v9h8v6a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4zM7.5 15a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m9 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3M11 5H7a2 2 0 0 0-1.995 1.85L5 7v5h6zm7.5-4a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    "subway-wifi-line": {
      body: '<path fill="currentColor" d="M21 18a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h6v8h8zm-2-5H5v5h14zM7.5 14a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m9 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3M11 5H7a2 2 0 0 0-1.995 1.85L5 7v4h6zm7.5-4a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    "suitcase-2-fill": {
      body: '<path fill="currentColor" d="M18 23h-2v-1H8v1H6v-1H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-1zM10 9H8v9h2zm6 0h-2v9h2zm-2-5h-4v1h4z"/>',
    },
    "suitcase-2-line": {
      body: '<path fill="currentColor" d="M18 23h-2v-1H8v1H6v-1H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-1zm1-16H5v13h14zm-9 2v9H8V9zm6 0v9h-2V9zm-2-5h-4v1h4z"/>',
    },
    "suitcase-3-fill": {
      body: '<path fill="currentColor" d="M15 1a1 1 0 0 1 1 1v5h1V6h2v1h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1v1h-2v-1H7v1H5v-1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6h2v1h1V2a1 1 0 0 1 1-1zm-6 9H7v8h2zm4 0h-2v8h2zm4 0h-2v8h2zm-3-7h-4v4h4z"/>',
    },
    "suitcase-3-line": {
      body: '<path fill="currentColor" d="M15 1a1 1 0 0 1 1 1v5h1V6h2v1h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1v1h-2v-1H7v1H5v-1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6h2v1h1V2a1 1 0 0 1 1-1zm4 8H5v10h14zM9 10v8H7v-8zm4 0v8h-2v-8zm4 0v8h-2v-8zm-3-7h-4v4h4z"/>',
    },
    "suitcase-fill": {
      body: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5V4a1 1 0 0 1 1-1zM8 8H6v11h2zm10 0h-2v11h2zm-4-3h-4v1h4z"/>',
    },
    "suitcase-line": {
      body: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5V4a1 1 0 0 1 1-1zm1 5H8v11h8zM4 8v11h2V8zm10-3h-4v1h4zm4 3v11h2V8z"/>',
    },
    "sun-cloudy-fill": {
      body: '<path fill="currentColor" d="M9.984 5.06a6.5 6.5 0 0 1 11.286 6.436A5.5 5.5 0 0 1 17.5 21H9a8 8 0 1 1 .984-15.941m2.071.544a8.03 8.03 0 0 1 4.403 4.495a5.53 5.53 0 0 1 3.12.307a4.5 4.5 0 0 0-7.522-4.802"/>',
    },
    "sun-cloudy-line": {
      body: '<path fill="currentColor" d="M9.984 5.06a6.5 6.5 0 0 1 11.286 6.436A5.5 5.5 0 0 1 17.5 21H9a8 8 0 1 1 .984-15.941m2.071.544a8.03 8.03 0 0 1 4.403 4.495a5.53 5.53 0 0 1 3.12.307a4.5 4.5 0 0 0-7.522-4.802M17.5 19a3.5 3.5 0 1 0-2.5-5.95V13a6 6 0 1 0-6 6z"/>',
    },
    "sun-fill": {
      body: '<path fill="currentColor" d="M12 18a6 6 0 1 1 0-12a6 6 0 0 1 0 12M11 1h2v3h-2zm0 19h2v3h-2zM3.515 4.929l1.414-1.414L7.05 5.636L5.636 7.05zM16.95 18.364l1.414-1.414l2.121 2.121l-1.414 1.414zm2.121-14.85l1.414 1.415l-2.121 2.121l-1.414-1.414zM5.636 16.95l1.414 1.414l-2.121 2.121l-1.414-1.414zM23 11v2h-3v-2zM4 11v2H1v-2z"/>',
    },
    "sun-foggy-fill": {
      body: '<path fill="currentColor" d="M6.341 14A6 6 0 1 1 12 18v-4zM6 20h9v2H6zm-5-9h3v2H1zm1 5h8v2H2zm9-15h2v3h-2zM3.515 4.929l1.414-1.414L7.05 5.636L5.636 7.05zM16.95 18.364l1.414-1.414l2.121 2.121l-1.414 1.414zm2.121-14.85l1.414 1.415l-2.121 2.121l-1.414-1.414zM23 11v2h-3v-2z"/>',
    },
    "sun-foggy-line": {
      body: '<path fill="currentColor" d="M8 12h2v2H4v-2h2a6 6 0 1 1 6 6v-2a4 4 0 1 0-4-4m-2 8h9v2H6zm-4-4h8v2H2zm9-15h2v3h-2zM3.515 4.929l1.414-1.414L7.05 5.636L5.636 7.05zM16.95 18.364l1.414-1.414l2.121 2.121l-1.414 1.414zm2.121-14.85l1.414 1.415l-2.121 2.121l-1.414-1.414zM23 11v2h-3v-2z"/>',
    },
    "sun-line": {
      body: '<path fill="currentColor" d="M12 18a6 6 0 1 1 0-12a6 6 0 0 1 0 12m0-2a4 4 0 1 0 0-8a4 4 0 0 0 0 8M11 1h2v3h-2zm0 19h2v3h-2zM3.515 4.929l1.414-1.414L7.05 5.636L5.636 7.05zM16.95 18.364l1.414-1.414l2.121 2.121l-1.414 1.414zm2.121-14.85l1.414 1.415l-2.121 2.121l-1.414-1.414zM5.636 16.95l1.414 1.414l-2.121 2.121l-1.414-1.414zM23 11v2h-3v-2zM4 11v2H1v-2z"/>',
    },
    "supabase-fill": {
      body: '<path fill="currentColor" d="M3.084 15.25c-1.664 0-2.6-1.912-1.58-3.226L10.21.806C10.794.054 12 .466 12 1.42v7.33h8.916c1.663 0 2.6 1.912 1.58 3.226L13.79 23.194c-.584.752-1.79.34-1.79-.613V15.25z"/>',
    },
    "supabase-line": {
      body: '<path fill="currentColor" d="M11 2.598V13.97H3.9c-.67 0-1.07-.784-.643-1.336zm2 5.433V2.333c0-1.811-2.297-2.624-3.418-1.171L1.673 11.41c-1.427 1.85-.125 4.559 2.227 4.559H11v5.698c0 1.811 2.296 2.624 3.418 1.171l7.908-10.249c1.427-1.849.126-4.558-2.227-4.558zm0 2h7.1c.669 0 1.069.784.643 1.336L13 21.402z"/>',
    },
    superscript: {
      body: '<path fill="currentColor" d="m5.596 5l4.904 5.928L15.404 5H18l-6.202 7.497L18 19.994V20h-2.59l-4.91-5.934L5.59 20H3v-.006l6.202-7.497L3 5zM21.55 6.58a.8.8 0 1 0-1.32-.36l-1.155.33A2.001 2.001 0 1 1 23 6c0 .573-.24 1.09-.626 1.454L20.744 9H23v1h-4V9z"/>',
    },
    "superscript-2": {
      body: '<path fill="currentColor" d="M11 7v13H9V7H3V5h12v2zm8.55-.42a.8.8 0 1 0-1.32-.36l-1.154.33A2.001 2.001 0 1 1 21 6c0 .573-.24 1.09-.626 1.454L18.744 9H21v1h-4V9z"/>',
    },
    "surgical-mask-fill": {
      body: '<path fill="currentColor" d="m12.485 3.121l7.758 1.94a1 1 0 0 1 .757.97V7h1c1.1 0 2 .9 2 2v3a3 3 0 0 1-3 3h-.421a6 6 0 0 1-2.896 3.158l-4.789 2.395a2 2 0 0 1-1.788 0l-4.79-2.395A6 6 0 0 1 3.422 15H3a3 3 0 0 1-3-3V9a2 2 0 0 1 2-2h1v-.97a1 1 0 0 1 .757-.97l7.758-1.939a2 2 0 0 1 .97 0M3 9H2v3a1 1 0 0 0 1 1zm19 0h-1v4a1 1 0 0 0 1-1z"/>',
    },
    "surgical-mask-line": {
      body: '<path fill="currentColor" d="m12.485 3.121l7.758 1.94a1 1 0 0 1 .757.97V7h1c1.1 0 2 .9 2 2v3a3 3 0 0 1-3 3h-.421a6 6 0 0 1-2.896 3.158l-4.789 2.395a2 2 0 0 1-1.788 0l-4.79-2.395A6 6 0 0 1 3.422 15H3a3 3 0 0 1-3-3V9a2 2 0 0 1 2-2h1v-.97a1 1 0 0 1 .757-.97l7.758-1.939a2 2 0 0 1 .97 0M12 5.061l-7 1.75v5.98a4 4 0 0 0 2.211 3.578L12 18.765l4.789-2.395A4 4 0 0 0 19 12.792v-5.98zM3 9H2v3a1 1 0 0 0 1 1zm19 0h-1v4a1 1 0 0 0 1-1z"/>',
    },
    "surround-sound-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4.05 4.121A6.98 6.98 0 0 0 5 12.071c0 1.933.784 3.683 2.05 4.95l1.414-1.414A4.98 4.98 0 0 1 7 12.07c0-1.38.56-2.63 1.464-3.535zm9.9 0l-1.414 1.415A4.98 4.98 0 0 1 17 12.07c0 1.38-.56 2.63-1.464 3.536l1.414 1.414A6.98 6.98 0 0 0 19 12.07a6.98 6.98 0 0 0-2.05-4.95M12 15.071a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "surround-sound-line": {
      body: '<path fill="currentColor" d="M4 5v14h16V5zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m4.05 4.121l1.414 1.415A4.98 4.98 0 0 0 7 12.07c0 1.38.56 2.63 1.464 3.536L7.05 17.02A6.98 6.98 0 0 1 5 12.07c0-1.933.784-3.683 2.05-4.95m9.9 0A6.98 6.98 0 0 1 19 12.07a6.98 6.98 0 0 1-2.05 4.95l-1.414-1.414A4.98 4.98 0 0 0 17 12.07c0-1.38-.56-2.63-1.464-3.535zM12 13.071a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "survey-fill": {
      body: '<path fill="currentColor" d="M6 4v4h12V4h2.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4zm3 13H7v2h2zm0-3H7v2h2zm0-3H7v2h2zm7-9v4H8V2z"/>',
    },
    "survey-line": {
      body: '<path fill="currentColor" d="M17 2v2h3.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7V2zM7 6H5v14h14V6h-2v2H7zm2 10v2H7v-2zm0-3v2H7v-2zm0-3v2H7v-2zm6-6H9v2h6z"/>',
    },
    "svelte-fill": {
      body: '<path fill="currentColor" d="M10.99 1.974c2.92-1.86 6.957-.992 9.001 1.934a6.27 6.27 0 0 1 1.072 4.74a5.9 5.9 0 0 1-.88 2.198c.64 1.221.855 2.62.61 3.977a5.88 5.88 0 0 1-2.657 3.94l-5.127 3.268c-2.92 1.86-6.957.993-9.002-1.933a6.27 6.27 0 0 1-1.07-4.741a5.9 5.9 0 0 1 .88-2.198a6.2 6.2 0 0 1-.611-3.977a5.88 5.88 0 0 1 2.658-3.94zM8.049 20.25c.782.29 1.633.332 2.44.123c.369-.099.72-.253 1.042-.458l5.128-3.267a3.54 3.54 0 0 0 1.598-2.37a3.77 3.77 0 0 0-.645-2.85a4.07 4.07 0 0 0-4.37-1.62c-.369.099-.72.253-1.042.458l-1.957 1.246a1.1 1.1 0 0 1-.314.138a1.227 1.227 0 0 1-1.5-.899a1.1 1.1 0 0 1-.01-.45a1.07 1.07 0 0 1 .48-.713l5.129-3.268a1.1 1.1 0 0 1 .314-.138a1.23 1.23 0 0 1 1.317.489c.157.222.23.492.207.762l-.018.19l.191.058a6.6 6.6 0 0 1 2.005 1.003l.263.192l.096-.295q.078-.235.123-.478a3.77 3.77 0 0 0-.644-2.85a4.07 4.07 0 0 0-4.371-1.621a3.7 3.7 0 0 0-1.042.458L7.34 7.357a3.54 3.54 0 0 0-1.6 2.37a3.77 3.77 0 0 0 .645 2.85a4.07 4.07 0 0 0 4.371 1.62c.369-.099.72-.253 1.042-.457l1.956-1.248q.148-.093.315-.137a1.23 1.23 0 0 1 1.5.899c.034.147.037.3.011.449a1.07 1.07 0 0 1-.482.713l-5.127 3.269a1.1 1.1 0 0 1-.314.137a1.23 1.23 0 0 1-1.317-.488a1.15 1.15 0 0 1-.207-.762l.017-.19l-.19-.058a6.6 6.6 0 0 1-2.005-1.003l-.263-.192l-.096.295a4 4 0 0 0-.123.478a3.77 3.77 0 0 0 .644 2.85a4.07 4.07 0 0 0 1.93 1.498"/>',
    },
    "svelte-line": {
      body: '<path fill="currentColor" d="M19.8 3.77a6.25 6.25 0 0 0-8.63-1.913L6.11 5.081a6.25 6.25 0 0 0-1.973 8.532a6.25 6.25 0 0 0 8.693 8.53l5.06-3.224a6.25 6.25 0 0 0 1.974-8.532A6.25 6.25 0 0 0 19.8 3.77m-1.352 5.004A6.26 6.26 0 0 0 15.65 7.5a1 1 0 0 0-1.525-1.003L9.066 9.72a1 1 0 1 0 1.075 1.686l2.109-1.343a4.25 4.25 0 1 1 4.567 7.17l-5.06 3.223a4.25 4.25 0 0 1-6.203-5.23A6.25 6.25 0 0 0 8.35 16.5a1 1 0 0 0 1.525 1.003l5.06-3.224a1 1 0 0 0-1.074-1.687l-2.109 1.344a4.25 4.25 0 0 1-4.567-7.17l5.06-3.223a4.25 4.25 0 0 1 6.203 5.23"/>',
    },
    "swap-2-fill": {
      body: '<path fill="currentColor" d="m17.207 2.293l-1.414 1.414L18.086 6H13v2h5.086l-2.293 2.293l1.414 1.414L21.914 7zM7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9M5.914 18l2.293 2.293l-1.414 1.414L2.086 17l4.707-4.707l1.414 1.414L5.914 16H11v2zM14 13a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z"/>',
    },
    "swap-2-line": {
      body: '<path fill="currentColor" d="m17.207 2.293l-1.414 1.414L18.086 6H13v2h5.086l-2.293 2.293l1.414 1.414L21.914 7zM9.5 7a2.5 2.5 0 1 0-5 0a2.5 2.5 0 0 0 5 0m2 0a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0M5.914 18l2.293 2.293l-1.414 1.414L2.086 17l4.707-4.707l1.414 1.414L5.914 16H11v2zM15 19h4v-4h-4zm-2-5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1z"/>',
    },
    "swap-3-fill": {
      body: '<path fill="currentColor" d="M6 5.914L3.707 8.207L2.293 6.793L7 2.086l4.707 4.707l-1.414 1.414L8 5.914V11H6zM12.5 7a4.5 4.5 0 1 0 9 0a4.5 4.5 0 0 0-9 0m9.207 10.207l-1.414-1.414L18 18.086V13h-2v5.086l-2.293-2.293l-1.414 1.414L17 21.914zM11 14a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1z"/>',
    },
    "swap-3-line": {
      body: '<path fill="currentColor" d="M6 5.914L3.707 8.207L2.293 6.793L7 2.086l4.707 4.707l-1.414 1.414L8 5.914V11H6zM17 9.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m0 2a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9m4.707 5.707l-1.414-1.414L18 18.086V13h-2v5.086l-2.293-2.293l-1.414 1.414L17 21.914zM5 19h4v-4H5zm5-6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z"/>',
    },
    "swap-box-fill": {
      body: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m12 4v2h-4v2h4v2l3.5-3zm-6 10v-2h4v-2h-4v-2l-3.5 3z"/>',
    },
    "swap-box-line": {
      body: '<path fill="currentColor" d="M4.005 5.003v14h16v-14zm-1-2h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1m12 4l3.5 3l-3.5 3v-2h-4v-2h4zm-6 10l-3.5-3l3.5-3v2h4v2h-4z"/>',
    },
    "swap-fill": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-5-13h2v4h2v-4h2l-3-3.5zm10 6h-2v-4h-2v4h-2l3 3.5z"/>',
    },
    "swap-line": {
      body: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-11l3-3.5l3 3.5h-2v4h-2v-4zm10 6l-3 3.5l-3-3.5h2v-4h2v4z"/>',
    },
    "switch-fill": {
      body: '<path fill="currentColor" d="M13.62 21c-.085 0-.141-.057-.127-.127V3.127c0-.056.042-.113.113-.113h2.785a4.61 4.61 0 0 1 4.61 4.61v8.766a4.61 4.61 0 0 1-4.61 4.61zm3.422-9.926c-1.004 0-1.824.82-1.824 1.824s.82 1.824 1.824 1.824s1.824-.82 1.824-1.824s-.82-1.824-1.824-1.824M5.8 8.4a1.7 1.7 0 0 1 1.696-1.696A1.7 1.7 0 0 1 9.193 8.4c0 .934-.763 1.697-1.697 1.697A1.7 1.7 0 0 1 5.8 8.4M11.54 3c.085 0 .142.057.128.127V20.86c0 .07-.057.127-.128.127H7.61A4.61 4.61 0 0 1 3 16.376V7.61A4.61 4.61 0 0 1 7.611 3zm-1.315 16.544V4.442H7.611c-.849 0-1.64.34-2.235.933a3.1 3.1 0 0 0-.933 2.235v8.766c0 .849.34 1.64.933 2.234a3.1 3.1 0 0 0 2.235.934z"/>',
    },
    "switch-line": {
      body: '<path fill="currentColor" d="M12.001 3v18h-4.4a4.6 4.6 0 0 1-4.6-4.6V7.6a4.6 4.6 0 0 1 4.6-4.6zm-2 2h-2.4a2.6 2.6 0 0 0-2.6 2.6v8.8a2.6 2.6 0 0 0 2.6 2.6h2.4zm-2.5 5a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m6.5-7h2.4a4.6 4.6 0 0 1 4.6 4.6v8.8a4.6 4.6 0 0 1-4.6 4.6h-2.4zm3 11.7a1.8 1.8 0 1 0 0-3.6a1.8 1.8 0 0 0 0 3.6"/>',
    },
    "sword-fill": {
      body: '<path fill="currentColor" d="m7.048 13.406l3.535 3.536l-1.413 1.414l1.415 1.415l-1.414 1.414l-2.475-2.475l-2.829 2.829l-1.414-1.414l2.829-2.83l-2.475-2.474l1.414-1.414l1.414 1.413zM3 3l3.546.003l11.817 11.818l1.415-1.414l1.415 1.414l-2.475 2.475l2.828 2.829l-1.414 1.414l-2.829-2.829l-2.474 2.475l-1.415-1.414l1.414-1.415L3.002 6.531zm14.457 0L21 3.003l.002 3.523l-4.053 4.052l-3.536-3.535z"/>',
    },
    "sword-line": {
      body: '<path fill="currentColor" d="M17.456 3L21 3.003l.002 3.523l-5.467 5.466l2.828 2.829l1.415-1.414l1.415 1.414l-2.475 2.475l2.828 2.829l-1.414 1.414l-2.829-2.829l-2.474 2.475l-1.415-1.414l1.414-1.415l-2.829-2.828l-2.828 2.828l1.415 1.415l-1.414 1.414l-2.475-2.475l-2.829 2.829l-1.414-1.414l2.829-2.83l-2.475-2.474l1.414-1.414l1.414 1.413l2.827-2.828l-5.46-5.46L2.999 3l3.546.003l5.453 5.454zm-7.58 10.406l-2.828 2.828l.708.707l2.827-2.828zM19 5.001h-.717l-4.87 4.869l.706.707L19 5.698zm-14 0v.7l11.241 11.241l.707-.707L5.715 5.002z"/>',
    },
    "syringe-fill": {
      body: '<path fill="currentColor" d="m21.678 7.98l-1.414 1.413l-2.122-2.12l-2.121 2.12l3.536 3.536l-1.415 1.414l-.707-.707L11.071 20H5.414l-2.12 2.121l-1.415-1.414L4 18.586v-5.657l6.364-6.364l-.707-.707l1.414-1.414l3.536 3.535l2.121-2.121l-2.121-2.121l1.414-1.415zm-12.02 6.363l-2.83-2.828l-1.414 1.414l2.829 2.828zm2.828-2.828L9.657 8.686l-1.414 1.415l2.828 2.828z"/>',
    },
    "syringe-line": {
      body: '<path fill="currentColor" d="m21.678 7.98l-1.414 1.413l-2.122-2.12l-2.121 2.12l3.536 3.536l-1.415 1.414l-.707-.707L11.071 20H5.414l-2.12 2.121l-1.415-1.414L4 18.586v-5.657l6.364-6.364l-.707-.707l1.414-1.414l3.536 3.535l2.121-2.121l-2.121-2.121l1.414-1.415zm-5.657 4.242l-4.243-4.243l-1.414 1.414l2.121 2.122l-1.414 1.414l-2.121-2.121l-1.414 1.414l2.121 2.121l-1.414 1.414l-2.121-2.121l-.122.121V18h4.243z"/>',
    },
    "t-box-fill": {
      body: '<path fill="currentColor" d="M17 8H7v2h4v7h2v-7h4zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "t-box-line": {
      body: '<path fill="currentColor" d="M5 5v14h14V5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m9 7v7h-2v-7H7V8h10v2z"/>',
    },
    "t-shirt-2-fill": {
      body: '<path fill="currentColor" d="M20.998 3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2.001l.001 8a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a3 3 0 1 0 6 0z"/>',
    },
    "t-shirt-2-line": {
      body: '<path fill="currentColor" d="M8.998 3a3 3 0 1 0 6 0h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2.001l.001 8a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm11 1.999h-3.417l-.017.041a5 5 0 0 1-4.35 2.955L11.999 8a5 5 0 0 1-4.566-2.96L7.414 5H3.998v5l2.999-.001V19h10.001l-.001-9l3.001-.001z"/>',
    },
    "t-shirt-air-fill": {
      body: '<path fill="currentColor" d="M12.705 17.793c.827.827 1.588 1.207 2.293 1.207c.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572c1.214 0 2.379.545 3.486 1.58l.221.213l-1.414 1.414C20.464 20.38 19.703 20 18.998 20c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572c-1.214 0-2.379-.545-3.486-1.58l-.221-.213zM8.998 3a3 3 0 1 0 6 0h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-9a2 2 0 0 0-1.994 1.85l-.006.15v7h-4a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm3.707 10.793c.827.827 1.588 1.207 2.293 1.207c.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572c1.214 0 2.379.545 3.486 1.58l.221.213l-1.414 1.414C20.464 16.38 19.703 16 18.998 16c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572c-1.214 0-2.379-.545-3.486-1.58l-.221-.213z"/>',
    },
    "t-shirt-air-line": {
      body: '<path fill="currentColor" d="M12.705 17.793c.827.827 1.588 1.207 2.293 1.207c.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572c1.214 0 2.379.545 3.486 1.58l.221.213l-1.414 1.414C20.464 20.38 19.703 20 18.998 20c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572c-1.214 0-2.379-.545-3.486-1.58l-.221-.213zM8.998 3a3 3 0 1 0 6 0h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-4.002v-2l3.002-.001v-5h-3.417l-.017.041a5 5 0 0 1-4.35 2.955L11.999 8a5 5 0 0 1-4.566-2.96L7.414 5H3.998v5l2.999-.001V19h3.001v2h-4a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm3.707 10.793c.827.827 1.588 1.207 2.293 1.207c.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572c1.214 0 2.379.545 3.486 1.58l.221.213l-1.414 1.414C20.464 16.38 19.703 16 18.998 16c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572c-1.214 0-2.379-.545-3.486-1.58l-.221-.213z"/>',
    },
    "t-shirt-fill": {
      body: '<path fill="currentColor" d="m14.514 5l2.606-2.607a1 1 0 0 1 1.414 0l4.243 4.243a1 1 0 0 1 0 1.414l-3.778 3.778V21a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-9.17L1.22 8.05a1 1 0 0 1 0-1.414l4.242-4.243a1 1 0 0 1 1.414 0L9.484 5z"/>',
    },
    "t-shirt-line": {
      body: '<path fill="currentColor" d="m14.514 5l2.606-2.607a1 1 0 0 1 1.414 0l4.243 4.243a1 1 0 0 1 0 1.414l-3.778 3.778V21a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-9.17L1.22 8.05a1 1 0 0 1 0-1.414l4.242-4.243a1 1 0 0 1 1.414 0L9.484 5zm.828 2H8.656L6.17 4.515L3.342 7.343L6.999 11v9h10v-9l3.657-3.657l-2.829-2.828z"/>',
    },
    "table-2": {
      body: '<path fill="currentColor" d="M13 10v4h6v-4zm-2 0H5v4h6zm2 9h6v-3h-6zm-2 0v-3H5v3zm2-14v3h6V5zm-2 0H5v3h6zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "table-3": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm8 2v3H4V5zm-7 9v-4h7v4zm0 2h7v3H4zm9 0h7v3h-7zm7-2h-7v-4h7zm0-9v3h-7V5z"/>',
    },
    "table-alt-fill": {
      body: '<path fill="currentColor" d="M7 14V3H3a1 1 0 0 0-1 1v10zm8 0V3H9v11zm7 0V4a1 1 0 0 0-1-1h-4v11zm-1 7a1 1 0 0 0 1-1v-4H2v4a1 1 0 0 0 1 1z"/>',
    },
    "table-alt-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 13H4v3h16zM8 5H4v9h4zm6 0h-4v9h4zm6 0h-4v9h4z"/>',
    },
    "table-fill": {
      body: '<path fill="currentColor" d="M15 21H9V10h6zm2 0V10h5v10a1 1 0 0 1-1 1zM7 21H3a1 1 0 0 1-1-1V10h5zM22 8H2V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1z"/>',
    },
    "table-line": {
      body: '<path fill="currentColor" d="M4 8h16V5H4zm10 11v-9h-4v9zm2 0h4v-9h-4zm-8 0v-9H4v9zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/>',
    },
    "table-view": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm5 2v3H4V5zm-4 9v-4h4v4zm0 2h4v3H4zm6 0h10v3H10zm10-2H10v-4h10zm0-9v3H10V5z"/>',
    },
    "tablet-fill": {
      body: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m7 15a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "tablet-line": {
      body: '<path fill="currentColor" d="M6 4v16h12V4zM5 2h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m7 15a1 1 0 1 1 0 2a1 1 0 0 1 0-2"/>',
    },
    "tailwind-css-fill": {
      body: '<path fill="currentColor" d="M12 4.86q-4.76 0-5.95 4.76q1.785-2.38 4.165-1.785c.905.226 1.552.883 2.268 1.61C13.651 10.63 15 12 17.95 12q4.76 0 5.95-4.76q-1.785 2.38-4.165 1.785c-.906-.226-1.552-.883-2.27-1.61C16.3 6.23 14.95 4.86 12 4.86M6.05 12Q1.29 12 .1 16.76q1.785-2.38 4.165-1.785c.905.226 1.552.883 2.269 1.61C7.7 17.77 9.05 19.14 12 19.14q4.76 0 5.95-4.76q-1.785 2.38-4.165 1.785c-.906-.226-1.552-.883-2.27-1.61C10.35 13.37 9 12 6.05 12"/>',
    },
    "tailwind-css-line": {
      body: '<path fill="currentColor" d="M8.127 6.22C9.177 5.377 10.499 5 12 5c1.409 0 2.485.33 3.358.834c.74.425 1.354 1.007 1.948 1.61c.646.657.996.976 1.437 1.086c.473.118.873.082 1.239-.074c.38-.163.791-.487 1.218-1.056l1.77.843c-.37 1.484-1.047 2.7-2.095 3.538C19.824 12.621 18.503 13 17 13c-1.408 0-2.484-.331-3.357-.834c-.834-.48-1.443-1.098-1.92-1.583c-.663-.672-1.018-1.001-1.465-1.113c-.473-.118-.873-.082-1.239.074c-.38.163-.792.487-1.219 1.056l-1.77-.843c.371-1.484 1.048-2.7 2.096-3.538M12 7c-.828 0-1.495.146-2.033.408c1.32.082 2.181.895 3.057 1.721c.504.476 1.013.956 1.617 1.304c.56.322 1.29.567 2.36.567c.828 0 1.495-.146 2.033-.408c-1.32-.083-2.181-.895-3.056-1.721c-.505-.476-1.013-.956-1.618-1.304C13.801 7.245 13.07 7 12 7m-8.874 5.22C4.177 11.377 5.499 11 7 11c1.409 0 2.485.33 3.358.834c.74.425 1.354 1.007 1.948 1.61c.646.657.996.976 1.437 1.086c.473.118.873.083 1.239-.074c.38-.163.791-.487 1.218-1.056l1.77.842c-.37 1.485-1.047 2.7-2.095 3.539C14.824 18.621 13.503 19 12 19c-1.408 0-2.484-.331-3.357-.834c-.834-.48-1.443-1.098-1.92-1.583c-.663-.672-1.018-1.001-1.465-1.113c-.473-.118-.873-.083-1.239.074c-.38.163-.792.487-1.219 1.056l-1.77-.843c.371-1.484 1.048-2.7 2.096-3.538M7 13c-.828 0-1.495.146-2.033.408c1.32.083 2.181.895 3.057 1.721c.504.476 1.013.956 1.617 1.304c.56.322 1.29.567 2.36.567c.828 0 1.495-.146 2.033-.408c-1.32-.082-2.181-.895-3.056-1.721c-.505-.476-1.014-.956-1.618-1.304C8.801 13.245 8.07 13 7 13"/>',
    },
    "takeaway-fill": {
      body: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v.999L22 3v6l-2.02-.001l2.767 7.596a4 4 0 1 1-7.62 2.406h-4.253a4.002 4.002 0 0 1-7.8-.229A2 2 0 0 1 2 17v-5h9a1 1 0 0 0 .883.993L12 13h2a1 1 0 0 0 .993-.883L15 12V3h-3V1zM7 16a2 2 0 1 0 0 4a2 2 0 0 0 0-4m12 0a2 2 0 1 0 0 4a2 2 0 0 0 0-4M10 3a1 1 0 0 1 1 1v7H2V4a1 1 0 0 1 1-1zm10 2h-3v2h3zM9 5H4v1h5z"/>',
    },
    "takeaway-line": {
      body: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v.999L22 3v6l-2.02-.001l2.767 7.596a4 4 0 1 1-7.62 2.406h-4.253a4.002 4.002 0 0 1-7.8-.229A2 2 0 0 1 2 17V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v8a1 1 0 0 0 .883.993L12 13h2a1 1 0 0 0 .993-.883L15 12V3h-3V1zM7 16a2 2 0 1 0 0 4a2 2 0 0 0 0-4m12-.001a2 2 0 1 0 0 4a2 2 0 0 0 0-4m-1.148-7H17V12a3 3 0 0 1-3 3h-2a3 3 0 0 1-2.829-2H4v2.354A4.002 4.002 0 0 1 10.874 17h4.252a4 4 0 0 1 4.57-2.94zM9 8H4v3h5zm11-3h-3v2h3zM9 5H4v1h5z"/>',
    },
    "taobao-fill": {
      body: '<path fill="currentColor" d="m3.576 8.277l-1.193 1.842l2.201 1.37s1.464.755.762 2.17c-.649 1.338-3.846 4.27-3.846 4.27l2.862 1.797c1.984-4.325 1.85-3.749 2.347-5.305c.512-1.58.625-2.794-.242-3.677c-1.113-1.125-1.238-1.23-2.89-2.467m1.565-.694c1.04 0 1.882-.758 1.882-1.693c0-.943-.842-1.701-1.882-1.701c-1.049 0-1.887.762-1.887 1.701c.004.931.838 1.693 1.887 1.693m17.005.21s-.625-4.87-11.208-1.855c.455-.794.67-1.306.67-1.306l-2.642-.75s-1.068 3.508-2.97 5.14c0 0 1.846 1.073 1.826 1.04A17 17 0 0 0 9.23 8.466q.633-.284 1.225-.524c-.492.887-1.278 2.217-2.068 3.056l1.113.984s.762-.738 1.588-1.62h.944v1.636H8.346v1.306h3.685v3.133l-.142-.004c-.407-.02-1.036-.09-1.286-.484c-.298-.484-.076-1.359-.064-1.903H7.995l-.093.052s-.935 4.205 2.69 4.113c3.386.092 5.329-.956 6.264-1.678l.371 1.395l2.089-.883l-1.415-3.483l-1.694.536l.315 1.19c-.428.33-.932.572-1.468.754v-2.738h3.592v-1.31h-3.592v-1.637h3.604V9.051h-6.41c.464-.569.823-1.089.92-1.415l-1.121-.307c4.797-1.733 7.47-1.435 7.45 1.403v7.475s.282 2.564-2.637 2.383l-1.58-.343l-.367 1.512s6.817 1.967 7.374-3.314c.552-5.282-.141-8.652-.141-8.652"/>',
    },
    "taobao-line": {
      body: '<path fill="currentColor" d="M17.173 14H14.5v1.375q.824-.332 1.812-.81l-.082-.238zm.828-.287l.12-.042c.641 1.851 1.034 3.012 1.185 3.5l-1.912.59q-.11-.36-.427-1.293c-6.081 2.884-8.671 2.054-9.008-1.908l1.993-.169c.1 1.165.344 1.621.897 1.752c.393.093.94.063 1.652-.104v-2.04h-3.5v-2h.513l-1.167-1.39q1.563-1.312 2.449-2.863q-.78.202-1.552.435A14 14 0 0 1 7.49 10.29l-1.4-1.428Q8 6.992 9.266 3.868l1.854.75q-.23.567-.48 1.1c3.702-.935 7.275-1.316 9.138-.68c1.223.419 1.919 1.392 2.188 2.585c.17.756.313 2.689.313 5.123c0 2.807-.056 3.77-.34 4.622c-.298.89-.697 1.418-1.408 1.984c-.657.523-1.553.763-2.645.823a12.5 12.5 0 0 1-2.094-.08c-.12-.013-.235-.027-.355-.042l-.242-.033l.264-1.982l.237.032l.319.038c.625.07 1.216.1 1.762.07c.714-.04 1.245-.181 1.508-.39c.426-.34.591-.558.756-1.054c.186-.555.238-1.448.238-3.989c0-2.298-.134-4.101-.265-4.682c-.13-.577-.41-.97-.883-1.132c-1.207-.412-3.801-.194-6.652.416l.615.263q-.195.453-.43.89h5.337v2h-3.5V12h3.5zm-5.5-3.213h-1.208A14 14 0 0 1 9.799 12h2.702zm-10.038-.438L3.54 8.376c1.062.68 2.935 2.428 3.338 3.162c1.239 2.26.198 4.176-3.122 7.997l-1.51-1.311c2.687-3.094 3.5-4.59 2.878-5.725c-.214-.39-1.857-1.923-2.661-2.437M5.14 7.583c-1.048 0-1.882-.762-1.886-1.693c0-.94.838-1.701 1.886-1.701c1.04 0 1.883.758 1.883 1.701c0 .935-.843 1.693-1.883 1.693"/>',
    },
    "tape-fill": {
      body: '<path fill="currentColor" d="M10.83 13A3 3 0 1 0 8 15h8a3 3 0 1 0-2.83-2zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m13 10a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-8 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/>',
    },
    "tape-line": {
      body: '<path fill="currentColor" d="M10.83 13h2.34A3 3 0 1 1 16 15H8a3 3 0 1 1 2.83-2M4 5v14h16V5zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5 10a1 1 0 1 0 0-2a1 1 0 0 0 0 2m8 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2"/>',
    },
    "task-fill": {
      body: '<path fill="currentColor" d="M21 3v18.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H20a1 1 0 0 1 1 1m-9.707 10.121l-2.475-2.475l-1.414 1.415l3.889 3.889l5.657-5.657l-1.414-1.414z"/>',
    },
    "task-line": {
      body: '<path fill="currentColor" d="M19 4H5v16h14zM3 2.992C3 2.444 3.447 2 3.999 2h16a1 1 0 0 1 1 1L21 20.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008zm8.293 10.13l4.243-4.243l1.414 1.414l-5.657 5.657l-3.89-3.89l1.415-1.414z"/>',
    },
    "taxi-fill": {
      body: '<path fill="currentColor" d="M22 12v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.48-5.788A2 2 0 0 1 6.32 5H9V3h6v2h2.681a2 2 0 0 1 1.838 1.212zM4.176 12h15.648l-2.143-5H6.32zM6.5 17a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m11 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "taxi-line": {
      body: '<path fill="currentColor" d="M22 11v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.447-4.894A2 2 0 0 1 6.237 5H9V3h6v2h2.764a2 2 0 0 1 1.789 1.106zm-2 2H4v5h16zM4.236 11h15.528l-2-4H6.236zM6.5 17a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m11 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3"/>',
    },
    "taxi-wifi-fill": {
      body: '<path fill="currentColor" d="M12 3v4H6.319l-2.144 5H22v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.48-5.788A2 2 0 0 1 6.32 5H9V3zM6.5 14a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m11 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m1-13a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    "taxi-wifi-line": {
      body: '<path fill="currentColor" d="M12 3v4H6.236l-2.001 4H22v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.447-4.894A2 2 0 0 1 6.237 5H9V3zm8 10H4v5h16zM6.5 14a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m11 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m1-13a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    "team-fill": {
      body: '<path fill="currentColor" d="M12 10a4 4 0 1 0 0-8a4 4 0 0 0 0 8m-6.5 3a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5M21 10.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m-9 .5a5 5 0 0 1 5 5v6H7v-6a5 5 0 0 1 5-5m-7 5c0-.693.1-1.362.288-1.994l-.17.014A3.5 3.5 0 0 0 2 17.5V22h3zm17 6v-4.5a3.5 3.5 0 0 0-3.288-3.494c.187.632.288 1.301.288 1.994v6z"/>',
    },
    "team-line": {
      body: '<path fill="currentColor" d="M12 11a5 5 0 0 1 5 5v6h-2v-6a3 3 0 0 0-2.824-2.995L12 13a3 3 0 0 0-2.995 2.824L9 16v6H7v-6a5 5 0 0 1 5-5m-6.5 3q.42.001.81.094a6 6 0 0 0-.301 1.575L6 16v.086a1.5 1.5 0 0 0-.356-.08L5.5 16a1.5 1.5 0 0 0-1.493 1.355L4 17.5V22H2v-4.5A3.5 3.5 0 0 1 5.5 14m13 0a3.5 3.5 0 0 1 3.5 3.5V22h-2v-4.5a1.5 1.5 0 0 0-1.355-1.493L18.5 16q-.264.001-.5.085V16c0-.666-.108-1.306-.308-1.904c.258-.063.53-.096.808-.096m-13-6a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5m13 0a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5m-13 2a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1m13 0a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1M12 2a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/>',
    },
    "telegram-2-fill": {
      body: '<path fill="currentColor" d="M2.148 11.81q7.87-3.429 10.497-4.522c4.999-2.079 6.037-2.44 6.714-2.452c.15-.003.482.034.698.21c.182.147.232.347.256.487s.054.459.03.708c-.27 2.847-1.443 9.754-2.04 12.942c-.252 1.348-.748 1.8-1.23 1.845c-1.045.096-1.838-.69-2.85-1.354c-1.585-1.039-2.48-1.686-4.018-2.699c-1.777-1.171-.625-1.815.388-2.867c.265-.275 4.87-4.464 4.96-4.844c.01-.048.021-.225-.084-.318c-.105-.094-.26-.062-.373-.036q-.239.054-7.592 5.018q-1.079.74-1.952.721c-.643-.014-1.88-.363-2.798-.662c-1.128-.367-2.024-.56-1.946-1.183q.061-.486 1.34-.994"/>',
    },
    "telegram-2-line": {
      body: '<path fill="currentColor" d="M17.094 7.146c.593-.215.888-.292 1.05-.32q.002.08-.002.122c-.232 2.444-1.251 8.457-1.775 11.255c-.122.655-.216.967-.85.595c-.416-.245-.792-.553-1.196-.817c-1.325-.869-3.221-2.162-3.065-2.084c-1.304-.86-.758-1.386-.03-2.088c.117-.113.24-.231.36-.356c.054-.056.317-.3.687-.645c1.188-1.104 3.484-3.239 3.542-3.486c.01-.04.018-.192-.071-.271c-.09-.08-.223-.053-.318-.031q-.203.046-6.474 4.279q-.918.63-1.664.614l.005.003c-.655-.231-1.308-.43-1.964-.63a66 66 0 0 1-1.3-.405l-.308-.098c4.527-1.972 7.542-3.27 9.053-3.899c2.194-.913 3.496-1.438 4.32-1.738m2.423-1.928a1.8 1.8 0 0 0-.726-.346c-.2-.048-.39-.063-.533-.06c-.477.008-.988.143-1.846.454c-.875.318-2.219.862-4.406 1.771Q9.691 8 2.804 11.001c-.404.161-.773.344-1.065.56c-.27.201-.647.56-.716 1.11c-.052.416.069.8.315 1.103c.214.263.488.423.697.524c.31.15.728.281 1.095.396c.573.18 1.144.363 1.719.539c1.778.544 3.242.992 4.852 2.054c1.181.778 2.34 1.59 3.523 2.366c.432.283.835.608 1.28.87c.488.285 1.106.546 1.86.477c1.138-.105 1.73-1.152 1.97-2.43c.521-2.79 1.557-8.886 1.8-11.432a3.8 3.8 0 0 0-.037-.885a1.66 1.66 0 0 0-.58-1.035"/>',
    },
    "telegram-fill": {
      body: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-9.642-2.618q-1.458.607-5.831 2.513q-.711.282-.744.552c-.038.304.343.424.862.587l.218.07c.51.166 1.198.36 1.555.368q.486.01 1.084-.4q4.086-2.76 4.218-2.789c.063-.014.149-.032.207.02c.059.052.053.15.047.177c-.038.161-1.534 1.552-2.308 2.271q-.344.324-.683.653c-.474.457-.83.8.02 1.36c.861.568 1.73 1.134 2.57 1.733c.414.296.786.56 1.246.519c.267-.025.543-.276.683-1.026c.332-1.77.983-5.608 1.133-7.19a1.8 1.8 0 0 0-.017-.393a.42.42 0 0 0-.142-.27c-.12-.098-.305-.118-.387-.117c-.376.007-.953.207-3.73 1.362"/>',
    },
    "telegram-line": {
      body: '<path fill="currentColor" d="M20 12a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-8 10c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m.358-12.618q-1.458.607-5.831 2.513q-.711.282-.744.552c-.038.304.343.424.862.587l.218.07c.51.166 1.198.36 1.555.368q.486.01 1.084-.4q4.086-2.76 4.218-2.789c.063-.014.149-.032.207.02c.059.052.053.15.047.177c-.038.161-1.534 1.552-2.308 2.271q-.344.324-.683.653c-.474.457-.83.8.02 1.36c.861.568 1.73 1.134 2.57 1.733c.414.296.786.56 1.246.519c.267-.025.543-.276.683-1.026c.332-1.77.983-5.608 1.133-7.19a1.8 1.8 0 0 0-.017-.393a.42.42 0 0 0-.142-.27c-.12-.098-.305-.118-.387-.117c-.376.007-.953.207-3.73 1.362"/>',
    },
    "temp-cold-fill": {
      body: '<path fill="currentColor" d="M8 10.255V5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0M8 16a4 4 0 0 0 8 0z"/>',
    },
    "temp-cold-line": {
      body: '<path fill="currentColor" d="M8 5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0zm1.144 6.895a5 5 0 1 0 5.712 0L14 11.298V5a2 2 0 1 0-4 0v6.298zM8 16h8a4 4 0 0 1-8 0"/>',
    },
    "temp-hot-fill": {
      body: '<path fill="currentColor" d="M8 10.255V5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0m3 1.871A4.002 4.002 0 0 0 12 20a4 4 0 0 0 1-7.874V5h-2z"/>',
    },
    "temp-hot-line": {
      body: '<path fill="currentColor" d="M8 5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0zm1.144 6.895a5 5 0 1 0 5.712 0L14 11.298V5a2 2 0 1 0-4 0v6.298zm1.856.231V5h2v7.126A4.002 4.002 0 0 1 12 20a4 4 0 0 1-1-7.874M12 18a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "tent-fill": {
      body: '<path fill="currentColor" d="m12.866 3l9.237 16H23v2H1v-2h.896l9.238-16a1 1 0 0 1 1.732 0M12 12.925L8.659 19h6.682z"/>',
    },
    "tent-line": {
      body: '<path fill="currentColor" d="M22.103 19L12.866 3a1 1 0 0 0-1.732 0L1.896 19H1v2h22v-2zM7.6 19H4.206L12 5.5L19.794 19H16.4L12 11zm4.4-3.85L14.117 19H9.884z"/>',
    },
    "terminal-box-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m9 12v2h6v-2zm-3.586-3l-2.828 2.828L7 16.243L11.243 12L7 7.757L5.586 9.172z"/>',
    },
    "terminal-box-line": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 2v14h16V5zm8 10h6v2h-6zm-3.333-3L5.838 9.172l1.415-1.415L11.495 12l-4.242 4.243l-1.415-1.415z"/>',
    },
    "terminal-fill": {
      body: '<path fill="currentColor" d="m11 12l-7.071 7.071l-1.414-1.414L8.172 12L2.515 6.343L3.929 4.93zm0 7h10v2H11z"/>',
    },
    "terminal-line": {
      body: '<path fill="currentColor" d="m11 12l-7.071 7.071l-1.414-1.414L8.172 12L2.515 6.343L3.929 4.93zm0 7h10v2H11z"/>',
    },
    "terminal-window-fill": {
      body: '<path fill="currentColor" d="M20 10H4v9h16zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m2 3v2h2V6zm4 0v2h2V6zm-4 5h3v5H5z"/>',
    },
    "terminal-window-line": {
      body: '<path fill="currentColor" d="M20 9V5H4v4zm0 2H4v8h16zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m2 9h3v5H5zm0-6h2v2H5zm4 0h2v2H9z"/>',
    },
    "test-tube-fill": {
      body: '<path fill="currentColor" d="M17 2v2h-1v14a4 4 0 0 1-8 0V4H7V2zm-4 13a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-2-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m3-8h-4v4h4z"/>',
    },
    "test-tube-line": {
      body: '<path fill="currentColor" d="M17 2v2h-1v14a4 4 0 0 1-8 0V4H7V2zm-3 8h-4v8a2 2 0 1 0 4 0zm-1 5a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-2-3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m3-8h-4v4h4z"/>',
    },
    text: {
      body: '<path fill="currentColor" d="M13 6v15h-2V6H5V4h14v2z"/>',
    },
    "text-block": {
      body: '<path fill="currentColor" d="M1 2v3h2V4h2v5H3.5v2h5V9H7V4h2v1h2V2zm20 1h-7v2h6v14H4v-5H2v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1"/>',
    },
    "text-direction-l": {
      body: '<path fill="currentColor" d="M11 5v10H9v-4a4 4 0 1 1 0-8h8v2h-2v10h-2V5zM9 5a2 2 0 1 0 0 4zm8 12v-2.5l4 3.5l-4 3.5V19H5v-2z"/>',
    },
    "text-direction-r": {
      body: '<path fill="currentColor" d="M11 5v10H9v-4a4 4 0 1 1 0-8h8v2h-2v10h-2V5zM9 5a2 2 0 1 0 0 4zM7 17h12v2H7v2.5L3 18l4-3.5z"/>',
    },
    "text-snippet": {
      body: '<path fill="currentColor" d="M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 1v14h16V5zm3 3h10v3h-2v-1h-2v4h1.5v2h-5v-2H11v-4H9v1H7z"/>',
    },
    "text-spacing": {
      body: '<path fill="currentColor" d="M7 17h10v-2.5l3.5 3.5l-3.5 3.5V19H7v2.5L3.5 18L7 14.5zm6-11v9h-2V6H5V4h14v2z"/>',
    },
    "text-wrap": {
      body: '<path fill="currentColor" d="M15 18h1.5a2.5 2.5 0 0 0 0-5H3v-2h13.5a4.5 4.5 0 1 1 0 9H15v2l-4-3l4-3zM3 4h18v2H3zm6 14v2H3v-2z"/>',
    },
    "thermometer-fill": {
      body: '<path fill="currentColor" d="M20.557 3.444a4 4 0 0 1 0 5.657l-8.2 8.2a4 4 0 0 1-2.387 1.147l-3.38.374l-2.297 2.3a1 1 0 1 1-1.414-1.415l2.298-2.299l.375-3.377A4 4 0 0 1 6.7 11.644l8.2-8.2a4 4 0 0 1 5.658 0m-9.193 9.192L9.95 14.05l2.121 2.122l1.414-1.415zm2.829-2.828l-1.415 1.414l2.122 2.121l1.414-1.414zm2.828-2.829l-1.414 1.414l2.121 2.122L19.142 9.1z"/>',
    },
    "thermometer-line": {
      body: '<path fill="currentColor" d="M20.557 3.444a4 4 0 0 1 0 5.657l-8.2 8.2a4 4 0 0 1-2.387 1.147l-3.38.374l-2.297 2.3a1 1 0 1 1-1.414-1.415l2.298-2.299l.375-3.377A4 4 0 0 1 6.7 11.644l8.2-8.2a4 4 0 0 1 5.658 0m-4.243 1.414l-8.2 8.2a2 2 0 0 0-.574 1.194l-.276 2.484l2.485-.276a2 2 0 0 0 1.193-.574l.422-.422L9.95 14.05l1.414-1.414l1.414 1.414l1.414-1.414l-1.414-1.414l1.415-1.414l1.414 1.414l1.414-1.415l-1.414-1.414L17.02 6.98l1.414 1.414l.707-.707a2 2 0 0 0-2.828-2.828"/>',
    },
    "threads-fill": {
      body: '<path fill="currentColor" d="M16.705 11.108c-.162-2.987-1.794-4.697-4.534-4.714c-1.652-.01-3.033.69-3.879 1.973L9.8 9.4c.634-.961 1.635-1.16 2.36-1.153c.903.006 1.583.268 2.024.78c.32.372.535.887.642 1.536q-1.202-.204-2.59-.125c-2.606.15-4.28 1.67-4.168 3.781c.057 1.071.59 1.993 1.502 2.595c.77.509 1.764.757 2.795.701c1.363-.075 2.432-.594 3.178-1.545c.566-.722.924-1.658 1.082-2.836c.65.392 1.13.907 1.397 1.527c.452 1.054.478 2.786-.935 4.198c-1.238 1.236-2.726 1.772-4.975 1.788c-2.495-.018-4.382-.819-5.608-2.378c-1.15-1.46-1.743-3.57-1.765-6.269c.022-2.7.616-4.809 1.765-6.27c1.226-1.559 3.113-2.359 5.608-2.377c2.513.019 4.432.822 5.706 2.39c.625.768 1.095 1.734 1.406 2.86l1.766-.47c-.377-1.387-.969-2.582-1.774-3.573c-1.633-2.01-4.033-3.039-7.11-3.06c-3.071.021-5.432 1.055-7.019 3.071c-1.411 1.795-2.14 4.306-2.164 7.436c.024 3.13.753 5.627 2.164 7.422c1.587 2.016 3.96 3.05 7.03 3.071c2.731-.019 4.655-.734 6.24-2.317c2.075-2.073 2.012-4.67 1.329-6.264c-.525-1.225-1.57-2.206-2.98-2.81m-4.438 4.557c-1.142.064-2.328-.448-2.387-1.546c-.043-.814.58-1.722 2.457-1.83a9.4 9.4 0 0 1 2.533.174c-.216 2.702-1.485 3.14-2.603 3.202"/>',
    },
    "threads-line": {
      body: '<path fill="currentColor" d="M12.184 1.41h-.002C9.09 1.432 6.7 2.473 5.094 4.516c-1.428 1.815-2.16 4.348-2.184 7.49v.002c.025 3.143.756 5.662 2.184 7.477c1.606 2.042 4.009 3.084 7.1 3.105h.002c2.748-.019 4.697-.74 6.303-2.344c2.104-2.103 2.042-4.741 1.347-6.363c-.53-1.234-1.575-2.221-2.976-2.835c-.18-2.985-1.86-4.726-4.62-4.744c-1.63-.01-3.102.72-4.003 2.087l1.655 1.136c.533-.809 1.377-1.199 2.335-1.19c1.387.009 2.3.774 2.555 2.117a11.7 11.7 0 0 0-2.484-.105c-2.64.152-4.368 1.712-4.253 3.875c.12 2.262 2.312 3.495 4.393 3.381c2.492-.137 3.973-1.976 4.324-4.321c.577.373 1.003.85 1.244 1.413c.44 1.025.468 2.716-.915 4.098c-1.217 1.216-2.68 1.746-4.912 1.762c-2.475-.018-4.332-.811-5.537-2.343C5.52 16.774 4.928 14.688 4.906 12c.022-2.688.614-4.775 1.746-6.213c1.205-1.533 3.062-2.325 5.537-2.344c2.493.019 4.384.815 5.636 2.356c.691.85 1.124 1.866 1.413 2.915l1.94-.517c-.363-1.338-.937-2.613-1.815-3.694c-1.653-2.034-4.081-3.071-7.18-3.093m.236 10.968a9.4 9.4 0 0 1 2.432.156c-.14 1.578-.793 2.947-2.512 3.041c-1.112.063-2.237-.434-2.292-1.461c-.04-.764.525-1.63 2.372-1.736"/>',
    },
    "thumb-down-fill": {
      body: '<path fill="currentColor" d="M22 15h-3V3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1m-5.293 1.293l-6.4 6.4a.5.5 0 0 1-.654.047L8.8 22.1a1.5 1.5 0 0 1-.553-1.57L9.4 16H3a2 2 0 0 1-2-2v-2.104a2 2 0 0 1 .15-.762L4.246 3.62A1 1 0 0 1 5.17 3H16a1 1 0 0 1 1 1v11.586a1 1 0 0 1-.293.707"/>',
    },
    "thumb-down-line": {
      body: '<path fill="currentColor" d="M9.4 16H3a2 2 0 0 1-2-2v-2.104a2 2 0 0 1 .15-.762L4.246 3.62A1 1 0 0 1 5.17 3H22a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3.482a1 1 0 0 0-.817.423l-5.453 7.726a.5.5 0 0 1-.632.159L9.802 22.4a2.5 2.5 0 0 1-1.305-2.853zm7.6-2.588V5H5.84L3 11.896V14h6.4a2 2 0 0 1 1.938 2.493l-.903 3.548a.5.5 0 0 0 .261.571l.661.33l4.71-6.672c.25-.354.57-.644.933-.857M19 13h2V5h-2z"/>',
    },
    "thumb-up-fill": {
      body: '<path fill="currentColor" d="M2 9h3v12H2a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1m5.293-1.293l6.4-6.4a.5.5 0 0 1 .654-.047l.853.64a1.5 1.5 0 0 1 .553 1.57L14.6 8H21a2 2 0 0 1 2 2v2.104a2 2 0 0 1-.15.762l-3.095 7.515a1 1 0 0 1-.925.619H8a1 1 0 0 1-1-1V8.414a1 1 0 0 1 .293-.707"/>',
    },
    "thumb-up-line": {
      body: '<path fill="currentColor" d="M14.6 8H21a2 2 0 0 1 2 2v2.105c0 .26-.051.52-.15.761l-3.095 7.515a1 1 0 0 1-.925.62H2a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3.482a1 1 0 0 0 .817-.424L11.752.851a.5.5 0 0 1 .632-.159l1.814.908a2.5 2.5 0 0 1 1.305 2.852zM7 10.588V19h11.16L21 12.105V10h-6.4a2 2 0 0 1-1.938-2.493l.903-3.548a.5.5 0 0 0-.261-.57l-.661-.331l-4.71 6.672c-.25.354-.57.645-.933.858M5 11H3v8h2z"/>',
    },
    "thunderstorms-fill": {
      body: '<path fill="currentColor" d="m16.989 18l1.215-1.58a1.5 1.5 0 0 0-1.189-2.415H15v-3.976a1.5 1.5 0 0 0-2.69-.914l-6.365 8.281A8.002 8.002 0 0 1 9 2a8 8 0 0 1 7.458 5.099A5.5 5.5 0 1 1 17.5 18zM13 16.005h3l-5 6.5v-4.5H8l5-6.505z"/>',
    },
    "thunderstorms-line": {
      body: '<path fill="currentColor" d="M17 18v-2h.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 1 0-8 5.659v2.089a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18zm-4-1.995h3l-5 6.5v-4.5H8l5-6.505z"/>',
    },
    "ticket-2-fill": {
      body: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1zm-5 6h-8v6h8z"/>',
    },
    "ticket-2-line": {
      body: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1zm-1 2h-16v2.968l.156.08a4.5 4.5 0 0 1 2.339 3.74l.005.212a4.5 4.5 0 0 1-2.344 3.95l-.156.08V19h16v-2.97l-.156-.08a4.5 4.5 0 0 1-2.34-3.738L17.506 12a4.5 4.5 0 0 1 2.344-3.951l.156-.081zm-4 4v6h-8V9z"/>',
    },
    "ticket-fill": {
      body: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1z"/>',
    },
    "ticket-line": {
      body: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1zm-1 2h-16v2.968l.156.08a4.5 4.5 0 0 1 2.339 3.74l.005.212a4.5 4.5 0 0 1-2.344 3.95l-.156.08V19h16v-2.97l-.156-.08a4.5 4.5 0 0 1-2.34-3.738L17.506 12a4.5 4.5 0 0 1 2.344-3.951l.156-.081z"/>',
    },
    "tiktok-fill": {
      body: '<path fill="currentColor" d="M16 8.245V15.5a6.5 6.5 0 1 1-5-6.326v3.163a3.5 3.5 0 1 0 2 3.163V2h3a5 5 0 0 0 5 5v3a7.97 7.97 0 0 1-5-1.755"/>',
    },
    "tiktok-line": {
      body: '<path fill="currentColor" d="M11 2v6.414a6.85 6.85 0 1 0 5.6 6.736v-3.736a8.6 8.6 0 0 0 3.4.686h1V6.5h-1c-1.903 0-3.4-1.537-3.4-3.5V2zm2 2h1.688c.394 2.22 2.08 3.996 4.312 4.41v1.618c-1.038-.152-1.975-.542-2.843-1.123L14.6 7.863v7.287a4.85 4.85 0 1 1-4.6-4.844v1.604a3.25 3.25 0 1 0 3 3.24zM8.5 15.15a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0"/>',
    },
    "time-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m1-10V7h-2v7h6v-2z"/>',
    },
    "time-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-8h4v2h-6V7h2z"/>',
    },
    "time-zone-fill": {
      body: '<path fill="currentColor" d="M12 2c5.078 0 9.272 3.785 9.915 8.687a8 8 0 0 0-11.228 11.228C5.785 21.272 2 17.078 2 12C2 6.477 6.477 2 12 2m0 1.833c-2.317 0-4.41.966-5.896 2.516c.177.123.331.296.437.534c.204.457.204.928.204 1.345c0 .328 0 .64.105.865c.144.308.766.44 1.315.554l.02.005c.19.04.385.08.563.13c.506.14.898.595 1.211.96c.13.151.323.374.42.43c.05-.036.211-.211.29-.498c.062-.22.044-.414-.045-.52c-.56-.66-.529-1.93-.356-2.399c.272-.739 1.122-.684 1.744-.644h.006c.23.015.446.03.608.009c.471-.06.695-.616.835-.964c.045-.111.081-.201.114-.246c.292-.4 1.186-1.003 1.74-1.375A8.1 8.1 0 0 0 12 3.833M23 17a6 6 0 1 1-12 0a6 6 0 0 1 12 0m-7 1h4v-2h-2v-2h-2z"/>',
    },
    "time-zone-line": {
      body: '<path fill="currentColor" d="M4 12c0-2.154.851-4.109 2.235-5.547c.122.111.227.252.306.43c.204.457.204.928.204 1.345c0 .328 0 .64.105.865c.144.308.766.44 1.315.554l.02.005c.19.04.385.08.563.13c.506.14.898.595 1.211.96c.13.151.323.374.42.43c.05-.036.211-.211.29-.498c.062-.22.044-.414-.045-.52c-.56-.66-.529-1.93-.356-2.399c.272-.739 1.122-.684 1.744-.644h.006c.23.015.446.03.608.009c.471-.06.695-.616.835-.964c.045-.111.081-.201.114-.246c.265-.363 1.024-.892 1.577-1.265a8.02 8.02 0 0 1 4.424 4.779a8 8 0 0 1 2.339 1.263C21.272 5.785 17.078 2 12 2C6.477 2 2 6.477 2 12c0 5.078 3.785 9.272 8.687 9.915a8 8 0 0 1-1.263-2.339A8 8 0 0 1 4 12m13 1a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0a6 6 0 0 1-12 0m5-3v4h4v-2h-2v-2z"/>',
    },
    "timeline-view": {
      body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm1 16V5h16v14zM14 7H6v2h8zm4 8v2h-8v-2zm-2-4H8v2h8z"/>',
    },
    "timer-2-fill": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m3.536 5.05L10.586 12L12 13.414l4.95-4.95z"/>',
    },
    "timer-2-line": {
      body: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12S6.48 2 12 2m0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m3.536-12.95l1.414 1.414l-4.95 4.95L10.586 12z"/>',
    },
    "timer-fill": {
      body: '<path fill="currentColor" d="m17.618 5.968l1.453-1.453l1.414 1.414l-1.453 1.453A9 9 0 1 1 12 4c2.125 0 4.078.736 5.618 1.968M11 8v6h2V8zM8 1h8v2H8z"/>',
    },
    "timer-flash-fill": {
      body: '<path fill="currentColor" d="M6.382 5.968A8.96 8.96 0 0 1 12 4c2.125 0 4.078.736 5.618 1.968l1.453-1.453l1.414 1.414l-1.453 1.453A9 9 0 1 1 3 13c0-2.125.736-4.078 1.968-5.618L3.515 5.93l1.414-1.414zM13 12V7.495L8 14h3v4.5l5-6.5zM8 1h8v2H8z"/>',
    },
    "timer-flash-line": {
      body: '<path fill="currentColor" d="M6.382 5.968A8.96 8.96 0 0 1 12 4c2.125 0 4.078.736 5.618 1.968l1.453-1.453l1.414 1.414l-1.453 1.453A9 9 0 1 1 3 13c0-2.125.736-4.078 1.968-5.618L3.515 5.93l1.414-1.414zM12 20a7 7 0 1 0 0-14a7 7 0 0 0 0 14m1-8h3l-5 6.5V14H8l5-6.505zM8 1h8v2H8z"/>',
    },
    "timer-line": {
      body: '<path fill="currentColor" d="m17.618 5.968l1.453-1.453l1.414 1.414l-1.453 1.453A9 9 0 1 1 12 4c2.125 0 4.078.736 5.618 1.968M12 20a7 7 0 1 0 0-14a7 7 0 0 0 0 14M11 8h2v6h-2zM8 1h8v2H8z"/>',
    },
    "todo-fill": {
      body: '<path fill="currentColor" d="M17 2h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3V0h2v2h6V0h2zM7 8v2h10V8zm0 4v2h10v-2z"/>',
    },
    "todo-line": {
      body: '<path fill="currentColor" d="M17 2h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3V0h2v2h6V0h2zm0 2v2h-2V4H9v2H7V4H5v16h14V4zM7 8h10v2H7zm0 4h10v2H7z"/>',
    },
    "toggle-fill": {
      body: '<path fill="currentColor" d="M8 5h8a7 7 0 1 1 0 14H8A7 7 0 1 1 8 5m8 10a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "toggle-line": {
      body: '<path fill="currentColor" d="M8 7a5 5 0 0 0 0 10h8a5 5 0 0 0 0-10zm0-2h8a7 7 0 1 1 0 14H8A7 7 0 1 1 8 5m0 10a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "token-swap-fill": {
      body: '<path fill="currentColor" d="M21.5 9a6.5 6.5 0 0 1-4 6.002V15A8.5 8.5 0 0 0 9 6.5h-.002A6.502 6.502 0 0 1 21.5 9M7 3a4 4 0 0 0-4 4v1.5h2V7a2 2 0 0 1 2-2h1.5V3zm12 12.5V17a2 2 0 0 1-2 2h-1.5v2H17a4 4 0 0 0 4-4v-1.5zm-10 6a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m0-9l2.5 2.5L9 17.5L6.5 15z"/>',
    },
    "token-swap-line": {
      body: '<path fill="currentColor" d="M9 12.5L6.5 15L9 17.5l2.5-2.5zm6-10a6.5 6.5 0 0 0-6.482 6.018a6.5 6.5 0 1 0 6.964 6.964A6.5 6.5 0 0 0 15 2.5m.323 10.989a6.51 6.51 0 0 0-4.812-4.812a4.5 4.5 0 1 1 4.812 4.812M13.5 15a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0M3 7a4 4 0 0 1 4-4h1.5v2H7a2 2 0 0 0-2 2v1.5H3zm16 10v-1.5h2V17a4 4 0 0 1-4 4h-1.5v-2H17a2 2 0 0 0 2-2"/>',
    },
    "tools-fill": {
      body: '<path fill="currentColor" d="M5.33 3.272a3.5 3.5 0 0 1 4.472 4.473L20.647 18.59l-2.122 2.121L7.68 9.867a3.5 3.5 0 0 1-4.472-4.474L5.444 7.63a1.5 1.5 0 0 0 2.121-2.121zm10.367 1.883l3.182-1.768l1.414 1.415l-1.768 3.181l-1.768.354l-2.12 2.121l-1.415-1.414l2.121-2.121zm-7.071 7.778l2.121 2.122l-4.95 4.95A1.5 1.5 0 0 1 3.58 17.99l.097-.107z"/>',
    },
    "tools-line": {
      body: '<path fill="currentColor" d="M5.33 3.272a3.5 3.5 0 0 1 4.254 4.962l10.709 10.71l-1.414 1.414l-10.71-10.71a3.502 3.502 0 0 1-4.962-4.255L5.444 7.63a1.5 1.5 0 0 0 2.121-2.121zm10.367 1.883l3.182-1.768l1.414 1.415l-1.768 3.181l-1.768.354l-2.12 2.121l-1.415-1.414l2.121-2.121zm-6.718 8.132l1.415 1.414l-5.304 5.303a1 1 0 0 1-1.492-1.327l.078-.087z"/>',
    },
    "tooth-fill": {
      body: '<path fill="currentColor" d="M12 3.232a6.5 6.5 0 0 1 3.266 4.034a1 1 0 0 0 1.928-.532A8.5 8.5 0 0 0 14.5 2.519q.248-.02.5-.019c2.007 0 3.68.728 4.83 2.11C20.963 5.967 21.5 7.846 21.5 10c0 3.097-.514 5.865-1.395 7.898c-.84 1.938-2.208 3.602-4.105 3.602c-1.1 0-1.787-.652-2.195-1.36c-.362-.63-.578-1.423-.752-2.062c-.207-.76-.366-1.328-.592-1.72C12.276 16.035 12.15 16 12 16s-.275.035-.461.358c-.226.392-.385.96-.592 1.72c-.174.639-.39 1.433-.752 2.062C9.787 20.848 9.1 21.5 8 21.5c-1.897 0-3.265-1.664-4.105-3.602C3.015 15.865 2.5 13.098 2.5 10c0-2.154.538-4.033 1.67-5.39C5.32 3.228 6.992 2.5 9 2.5h.028A6.5 6.5 0 0 1 12 3.232"/>',
    },
    "tooth-line": {
      body: '<path fill="currentColor" d="M5.706 5.89C6.429 5.022 7.507 4.5 9 4.5c.907 0 1.749.267 2.454.727a4.5 4.5 0 0 1 1.74 2.137a1 1 0 1 0 1.862-.728a6.5 6.5 0 0 0-1.224-1.983q.56-.151 1.168-.153c1.493 0 2.57.522 3.294 1.39c.744.893 1.206 2.264 1.206 4.11c0 2.903-.486 5.385-1.23 7.102c-.785 1.812-1.667 2.398-2.27 2.398c-.15 0-.275-.035-.461-.358c-.226-.392-.385-.96-.592-1.72c-.174-.639-.39-1.433-.752-2.062C13.787 14.652 13.1 14 12 14s-1.787.652-2.195 1.36c-.362.63-.578 1.423-.752 2.062c-.207.76-.366 1.328-.592 1.72c-.186.323-.311.358-.461.358c-.603 0-1.485-.586-2.27-2.398c-.744-1.717-1.23-4.2-1.23-7.102c0-1.846.462-3.217 1.206-4.11M12 3.232A6.5 6.5 0 0 0 9 2.5c-2.007 0-3.68.728-4.83 2.11C3.037 5.967 2.5 7.846 2.5 10c0 3.097.514 5.865 1.395 7.898C4.735 19.836 6.103 21.5 8 21.5c1.1 0 1.787-.652 2.195-1.36c.374-.65.593-1.477.77-2.127c.198-.726.354-1.274.574-1.655c.186-.323.311-.358.461-.358s.275.035.461.358c.22.381.376.93.574 1.655c.177.65.396 1.476.77 2.127c.408.708 1.095 1.36 2.195 1.36c1.897 0 3.265-1.664 4.105-3.602c.88-2.033 1.395-4.8 1.395-7.898c0-2.154-.538-4.033-1.67-5.39C18.68 3.228 17.008 2.5 15 2.5c-1.08 0-2.102.264-3 .732"/>',
    },
    "tornado-fill": {
      body: '<path fill="currentColor" d="M2 3h20v2H2zm2 4h16v2H4zm4 4h14v2H8zm2 4h8v2h-8zm-2 4h6v2H8z"/>',
    },
    "tornado-line": {
      body: '<path fill="currentColor" d="M2 3h20v2H2zm2 4h16v2H4zm4 4h14v2H8zm2 4h8v2h-8zm-2 4h6v2H8z"/>',
    },
    "trademark-fill": {
      body: '<path fill="currentColor" d="M10 6v2H6v10H4V8H0V6zm2 0h2.5l3 5.196L20.5 6H23v12h-2V9.133l-3.5 6.063L14 9.135V18h-2z"/>',
    },
    "trademark-line": {
      body: '<path fill="currentColor" d="M10 6v2H6v10H4V8H0V6zm2 0h2.5l3 5.196L20.5 6H23v12h-2V9.133l-3.5 6.063L14 9.135V18h-2z"/>',
    },
    "traffic-light-fill": {
      body: '<path fill="currentColor" d="M7 4V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1h3c0 2.5-2.5 3.5-3 3.5V10h3c0 2.5-2.5 3.5-3 3.5V16h3c0 2.5-2.5 3.5-3 3.5V21a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1.5c-.5 0-3-1-3-3.5h3v-2.5c-.5 0-3-1-3-3.5h3V7.5c-.5 0-3-1-3-3.5zm5 16a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "traffic-light-line": {
      body: '<path fill="currentColor" d="M7 4V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1h3c0 2.5-2.5 3.5-3 3.5V10h3c0 2.5-2.5 3.5-3 3.5V16h3c0 2.5-2.5 3.5-3 3.5V21a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1.5c-.5 0-3-1-3-3.5h3v-2.5c-.5 0-3-1-3-3.5h3V7.5c-.5 0-3-1-3-3.5zm5 16a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "train-fill": {
      body: '<path fill="currentColor" d="m17.2 20l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2zM5 7v4h14V7zm7 11a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "train-line": {
      body: '<path fill="currentColor" d="m17.2 20l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2zM7 5a2 2 0 0 0-2 2v11h14V7a2 2 0 0 0-2-2zm5 12a2 2 0 1 1 0-4a2 2 0 0 1 0 4M6 7h12v4H6z"/>',
    },
    "train-wifi-fill": {
      body: '<path fill="currentColor" d="M12.498 3a6.52 6.52 0 0 0-.324 4H5v4h10.035a6.47 6.47 0 0 0 3.465 1a6.5 6.5 0 0 0 2.5-.498V18a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4zM12 14a2 2 0 1 0 0 4a2 2 0 0 0 0-4m6.5-13a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    "train-wifi-line": {
      body: '<path fill="currentColor" d="M12.498 3a6.5 6.5 0 0 0-.479 2H7a2 2 0 0 0-1.995 1.85L5 7v11h14v-6.019a6.5 6.5 0 0 0 2-.48V18a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4zM12 13a2 2 0 1 1 0 4a2 2 0 0 1 0-4m.174-6a6.5 6.5 0 0 0 2.862 4.001L6 11V7zM18.5 1a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9m0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a2 2 0 0 0-1.413-.585m0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165l.944.942a3.32 3.32 0 0 1 2.357-.977a3.32 3.32 0 0 1 2.201.83l.156.147l.943-.943A4.65 4.65 0 0 0 18.5 3.5"/>',
    },
    translate: {
      body: '<path fill="currentColor" d="M5 15v2a2 2 0 0 0 1.85 1.994L7 19h3v2H7a4 4 0 0 1-4-4v-2zm13-5l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16 10zm-1 2.885L15.753 16h2.492zM8 2v2h4v7H8v3H6v-3H2V4h4V2zm9 1a4 4 0 0 1 4 4v2h-2V7a2 2 0 0 0-2-2h-3V3zM6 6H4v3h2zm4 0H8v3h2z"/>',
    },
    "translate-2": {
      body: '<path fill="currentColor" d="m18.5 10l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16.5 10zM10 2v2h6v2h-1.968a18.2 18.2 0 0 1-3.62 6.301a15 15 0 0 0 2.335 1.707l-.75 1.878A17 17 0 0 1 9 13.725a16.7 16.7 0 0 1-6.201 3.548l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042A18 18 0 0 1 4.767 8h2.24A16 16 0 0 0 9 10.877a16.2 16.2 0 0 0 2.91-4.876L2 6V4h6V2zm7.5 10.885L16.253 16h2.492z"/>',
    },
    "travesti-fill": {
      body: '<path fill="currentColor" d="M7.537 9.95L4.662 7.076L2.187 9.55L.772 8.136l6.364-6.364l1.415 1.414l-2.475 2.475L8.95 8.537A7.5 7.5 0 1 1 7.537 9.95"/>',
    },
    "travesti-line": {
      body: '<path fill="currentColor" d="M8.951 8.537A7.5 7.5 0 1 1 7.537 9.95L4.662 7.075L2.187 9.55L.772 8.136l6.364-6.364l1.415 1.414l-2.475 2.475zM13.501 20a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11"/>',
    },
    "treasure-map-fill": {
      body: '<path fill="currentColor" d="m2 5l7-3l6 3l6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46zm4 6v2h2v-2zm4 0v2h2v-2zm6-.06l-1.237-1.238l-1.061 1.06L14.939 12l-1.237 1.237l1.06 1.061L16 13.061l1.237 1.237l1.061-1.06L17.061 12l1.237-1.237l-1.06-1.061z"/>',
    },
    "treasure-map-line": {
      body: '<path fill="currentColor" d="m14.935 7.204l-6-3L4 6.319v12.648l5.065-2.17l6 3L20 17.68V5.033zM2 5l7-3l6 3l6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3l-6-3l-6.303 2.701a.5.5 0 0 1-.697-.46zm4 6h2v2H6zm4 0h2v2h-2zm5.998-.063L17.235 9.7l1.061 1.06l-1.237 1.238l1.237 1.238l-1.06 1.06l-1.238-1.237l-1.237 1.237l-1.061-1.06l1.237-1.238l-1.237-1.237L14.76 9.7z"/>',
    },
    "tree-fill": {
      body: '<path fill="currentColor" d="M18 7q0 .393-.05.774A6 6 0 0 1 13 18.658V22h-2v-3.6a5.5 5.5 0 0 1-6.517-8.657A8 8 0 0 0 6.286 12.6l1.428-1.4A6 6 0 0 1 6 7a6 6 0 1 1 12 0"/>',
    },
    "tree-line": {
      body: '<path fill="currentColor" d="M6 7a6 6 0 1 1 11.95.775A6 6 0 0 1 15 19h-2v3h-2v-3H8.5A5.5 5.5 0 0 1 6.191 8.507A6 6 0 0 1 6 7m1.01 3.332A3.502 3.502 0 0 0 8.5 17H15a4 4 0 0 0 1.454-7.728l-.841-.328C15.79 8.304 16 7.672 16 7a4 4 0 1 0-6.4 3.2l-1.2 1.6a6 6 0 0 1-1.39-1.468"/>',
    },
    "trello-fill": {
      body: '<path fill="currentColor" d="M5.251 3h13.5a2.25 2.25 0 0 1 2.25 2.25v13.5a2.25 2.25 0 0 1-2.25 2.25h-13.5a2.25 2.25 0 0 1-2.25-2.25V5.25A2.25 2.25 0 0 1 5.251 3m7.92 3.42v5.76c0 .596.484 1.08 1.08 1.08h3.33a1.08 1.08 0 0 0 1.08-1.08V6.42a1.08 1.08 0 0 0-1.08-1.08h-3.33a1.08 1.08 0 0 0-1.08 1.08m-7.83 0v10.26c0 .596.484 1.08 1.08 1.08h3.33a1.08 1.08 0 0 0 1.08-1.08V6.42a1.08 1.08 0 0 0-1.08-1.08h-3.33a1.08 1.08 0 0 0-1.08 1.08"/>',
    },
    "trello-line": {
      body: '<path fill="currentColor" d="M5.001 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m3 4h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1"/>',
    },
    "triangle-fill": {
      body: '<path fill="currentColor" d="m12.866 3l9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0"/>',
    },
    "triangle-line": {
      body: '<path fill="currentColor" d="m12.866 3l9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0m-8.66 16h15.588L12 5.5z"/>',
    },
    "triangular-flag-fill": {
      body: '<path fill="currentColor" d="M5.66 2.181C5.016 1.613 4 2.071 4 2.932V22h2v-4h14.99c.922 0 1.352-1.142.66-1.75z"/>',
    },
    "triangular-flag-line": {
      body: '<path fill="currentColor" d="M6 5.144V16h12.34zM4 2.932c0-.86 1.015-1.32 1.66-.75l15.99 14.067c.692.61.262 1.751-.66 1.751H6v4H4z"/>',
    },
    "trophy-fill": {
      body: '<path fill="currentColor" d="M13.005 16.94v2.063h5v2h-12v-2h5V16.94a8 8 0 0 1-7-7.938v-6h16v6a8 8 0 0 1-7 7.938m-12-11.937h2v4h-2zm20 0h2v4h-2z"/>',
    },
    "trophy-line": {
      body: '<path fill="currentColor" d="M13.005 16.94v2.063h5v2h-12v-2h5V16.94a8 8 0 0 1-7-7.938v-6h16v6a8 8 0 0 1-7 7.938m-7-11.937v4a6 6 0 1 0 12 0v-4zm-5 0h2v4h-2zm20 0h2v4h-2z"/>',
    },
    "truck-fill": {
      body: '<path fill="currentColor" d="M17 8h3l3 4.056V18h-2.035a3.501 3.501 0 0 1-6.93 0h-5.07a3.5 3.5 0 0 1-6.93 0H1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm0 2v3h4v-.285L18.992 10z"/>',
    },
    "truck-line": {
      body: '<path fill="currentColor" d="M8.965 18a3.5 3.5 0 0 1-6.93 0H1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2h3l3 4.056V18h-2.035a3.501 3.501 0 0 1-6.93 0zM15 7H3v8.05a3.5 3.5 0 0 1 5.663.95h5.674c.168-.353.393-.674.663-.95zm2 6h4v-.285L18.992 10H17zm.5 6a1.5 1.5 0 1 0 0-3.001a1.5 1.5 0 0 0 0 3.001M7 17.5a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0"/>',
    },
    "tumblr-fill": {
      body: '<path fill="currentColor" d="M6.27 7.63A5.76 5.76 0 0 0 10.817 2h3.03v5.152h3.637v3.636h-3.637v5.454c0 .515.198 1.207.91 1.667q.711.46 3.03.455V22h-4.243a4.546 4.546 0 0 1-4.545-4.546v-6.666H6.27z"/>',
    },
    "tumblr-line": {
      body: '<path fill="currentColor" d="M8.001 8c1.075 0 3.497-.673 3.497-4.5V2h1.5v6h5.003v2h-5.003v2.91c.003 2.48.003 3.686.003 4.09c-.002 2.208 1.615 3.4 4.785 3.4V22h-2.242c-2.402.002-4.546-2.035-4.546-4.546V10H7.001V8z"/>',
    },
    "tv-2-fill": {
      body: '<path fill="currentColor" d="M2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 18zm3 16h14v2H5z"/>',
    },
    "tv-2-line": {
      body: '<path fill="currentColor" d="M2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 18zm2 1v12h16V5zm1 15h14v2H5z"/>',
    },
    "tv-fill": {
      body: '<path fill="currentColor" d="M15.414 5h5.594c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6c0-.552.455-1 .992-1h5.594L6.05 2.464L7.464 1.05L11.414 5h1.172l3.95-3.95l1.414 1.414z"/>',
    },
    "tv-line": {
      body: '<path fill="currentColor" d="M15.414 5h5.594c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6c0-.552.455-1 .992-1h5.594L6.05 2.464L7.464 1.05L11.414 5h1.172l3.95-3.95l1.414 1.414zM4 7v12h16V7z"/>',
    },
    "twitch-fill": {
      body: '<path fill="currentColor" d="M21.001 3v11.74l-4.696 4.695h-3.913l-2.437 2.348H6.914v-2.348H3.001V6.13L4.228 3zm-1.565 1.565H6.13v11.74h3.13v2.347l2.349-2.348h4.695l3.13-3.13zm-3.13 3.13v4.696H14.74V7.696zm-3.914 0v4.696h-1.565V7.696z"/>',
    },
    "twitch-line": {
      body: '<path fill="currentColor" d="M4.301 3h16.7v11.7l-4.7 4.7h-3.9l-2.5 2.4h-2.9v-2.4h-4V6.2zm.7 14.4h4v2.4h.095l2.5-2.4h3.877L19 13.872V5H5zm10-9.4h2v4.7h-2zm0 0h2v4.7h-2zm-5 0h2v4.7h-2z"/>',
    },
    "twitter-fill": {
      body: '<path fill="currentColor" d="M22.213 5.656a8.4 8.4 0 0 1-2.402.658A4.2 4.2 0 0 0 21.649 4c-.82.488-1.719.83-2.655 1.015a4.182 4.182 0 0 0-7.126 3.814a11.87 11.87 0 0 1-8.621-4.37a4.17 4.17 0 0 0-.566 2.103c0 1.45.739 2.731 1.86 3.481a4.2 4.2 0 0 1-1.894-.523v.051a4.185 4.185 0 0 0 3.355 4.102a4.2 4.2 0 0 1-1.89.072A4.185 4.185 0 0 0 8.02 16.65a8.4 8.4 0 0 1-6.192 1.732a11.83 11.83 0 0 0 6.41 1.88c7.694 0 11.9-6.373 11.9-11.9q0-.271-.012-.541a8.5 8.5 0 0 0 2.086-2.164"/>',
    },
    "twitter-line": {
      body: '<path fill="currentColor" d="M15.35 5.55a2.9 2.9 0 0 0-2.9 2.847l-.028 1.575a.6.6 0 0 1-.68.583l-1.562-.212c-2.053-.28-4.021-1.226-5.91-2.799c-.597 3.31.57 5.603 3.383 7.372L9.4 16.014a.6.6 0 0 1 .035.993L7.843 18.17c.947.059 1.846.017 2.592-.131c4.718-.942 7.855-4.492 7.855-10.348c0-.478-1.013-2.141-2.94-2.141m-4.9 2.81a4.9 4.9 0 0 1 8.385-3.355c.711-.005 1.316.175 2.668-.645c-.334 1.64-.5 2.352-1.213 3.331c0 7.642-4.697 11.358-9.464 12.309c-3.267.652-8.02-.419-9.38-1.841c.693-.054 3.513-.357 5.143-1.55c-1.38-.91-6.868-4.14-3.261-12.823q2.54 2.966 5.15 4.037c1.157.475 1.442.466 1.973.538"/>',
    },
    "twitter-x-fill": {
      body: '<path fill="currentColor" d="M18.205 2.25h3.308l-7.227 8.26l8.502 11.24H16.13l-5.214-6.817L4.95 21.75H1.64l7.73-8.835L1.215 2.25H8.04l4.713 6.231zm-1.161 17.52h1.833L7.045 4.126H5.078z"/>',
    },
    "twitter-x-line": {
      body: '<path fill="currentColor" d="M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z"/>',
    },
    "typhoon-fill": {
      body: '<path fill="currentColor" d="m17.654 1.7l-2.782 2.533a9.1 9.1 0 0 1 3.49 1.973c3.512 3.2 3.512 8.388 0 11.588q-3.888 3.54-12.016 4.506l2.782-2.533a9.1 9.1 0 0 1-3.49-1.973c-3.512-3.2-3.533-8.369 0-11.588Q9.527 2.666 17.655 1.7M12 8c-2.485 0-4.5 1.79-4.5 4s2.015 4 4.5 4s4.5-1.79 4.5-4s-2.015-4-4.5-4"/>',
    },
    "typhoon-line": {
      body: '<path fill="currentColor" d="m17.654 1.7l-2.782 2.533a9.1 9.1 0 0 1 3.49 1.973c3.512 3.2 3.512 8.388 0 11.588q-3.888 3.54-12.016 4.506l2.782-2.533a9.1 9.1 0 0 1-3.49-1.973c-3.512-3.2-3.533-8.369 0-11.588Q9.527 2.666 17.655 1.7M12 6c-3.866 0-7 2.686-7 6s3.134 6 7 6s7-2.686 7-6s-3.134-6-7-6m0 2.3c2.21 0 4 1.657 4 3.7s-1.79 3.7-4 3.7s-4-1.656-4-3.7c0-2.043 1.79-3.7 4-3.7m0 2c-1.138 0-2 .797-2 1.7s.862 1.7 2 1.7s2-.797 2-1.7s-.862-1.7-2-1.7"/>',
    },
    "u-disk-fill": {
      body: '<path fill="currentColor" d="M4 12h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1M5 2h14v8H5zm4 3v2h2V5zm4 0v2h2V5z"/>',
    },
    "u-disk-line": {
      body: '<path fill="currentColor" d="M19 12H5v8h14zM5 10V2h14v8h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1zm2 0h10V4H7zm2-4h2v2H9zm4 0h2v2h-2z"/>',
    },
    "ubuntu-fill": {
      body: '<path fill="currentColor" d="M22.001 12c0 5.522-4.477 10-10 10s-10-4.478-10-10s4.477-10 10-10s10 4.477 10 10m-16.8-1.336a1.335 1.335 0 1 0 0 2.67a1.335 1.335 0 0 0 0-2.67m9.533 6.069a1.334 1.334 0 1 0 1.334 2.31a1.334 1.334 0 0 0-1.334-2.31M8.1 12c0-1.32.656-2.485 1.659-3.19l-.977-1.636a5.8 5.8 0 0 0-2.398 3.371a1.875 1.875 0 0 1 0 2.91a5.8 5.8 0 0 0 2.398 3.371l.977-1.636A3.89 3.89 0 0 1 8.1 12M12 8.1a3.9 3.9 0 0 1 3.884 3.554l1.903-.028a5.78 5.78 0 0 0-1.724-3.762A1.872 1.872 0 0 1 13.55 6.41a5.83 5.83 0 0 0-4.12.39l.927 1.663A3.9 3.9 0 0 1 12 8.1m0 7.8a3.9 3.9 0 0 1-1.642-.363l-.928 1.662a5.77 5.77 0 0 0 4.12.39a1.872 1.872 0 0 1 2.514-1.454a5.78 5.78 0 0 0 1.723-3.762l-1.903-.027A3.9 3.9 0 0 1 12 15.9m2.732-8.633a1.335 1.335 0 1 0 1.335-2.312a1.335 1.335 0 0 0-1.335 2.312"/>',
    },
    "ubuntu-line": {
      body: '<path fill="currentColor" d="m8.668 19.273l1.006-1.742a6 6 0 0 0 8.282-4.781h2.012A8 8 0 0 1 18.929 16a8 8 0 0 1-1.452 1.835a2.5 2.5 0 0 0-1.976.227a2.5 2.5 0 0 0-1.184 1.595a7.98 7.98 0 0 1-5.65-.384m-1.3-.75a7.98 7.98 0 0 1-3.157-4.7C4.696 13.367 5 12.719 5 12c0-.72-.304-1.369-.791-1.825A8 8 0 0 1 5.073 8a8 8 0 0 1 2.295-2.524l1.006 1.742a6 6 0 0 0 0 9.563zm1.3-13.796a8 8 0 0 1 5.648-.387a2.497 2.497 0 0 0 3.161 1.825a8 8 0 0 1 2.49 5.085h-2.013A5.99 5.99 0 0 0 15 6.804a5.99 5.99 0 0 0-5.327-.335zM16 5.072a1.5 1.5 0 1 1 1.5-2.598A1.5 1.5 0 0 1 16 5.072M4.001 12a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m12 6.928a1.5 1.5 0 1 1 1.5 2.598a1.5 1.5 0 0 1-1.5-2.598"/>',
    },
    "umbrella-fill": {
      body: '<path fill="currentColor" d="M12.998 2.05c5.053.501 9 4.765 9 9.95v1h-9v6a2 2 0 0 0 4 0v-1h2v1a4 4 0 1 1-8 0v-6h-9v-1c0-5.185 3.947-9.449 9-9.95V2a1 1 0 0 1 2 0z"/>',
    },
    "umbrella-line": {
      body: '<path fill="currentColor" d="M12.998 2.05c5.053.501 9 4.765 9 9.95v1h-9v6a2 2 0 0 0 4 0v-1h2v1a4 4 0 1 1-8 0v-6h-9v-1c0-5.185 3.947-9.449 9-9.95V2a1 1 0 0 1 2 0zM19.936 11A8.001 8.001 0 0 0 4.06 11z"/>',
    },
    underline: {
      body: '<path fill="currentColor" d="M8 3v9a4 4 0 0 0 8 0V3h2v9a6 6 0 0 1-12 0V3zM4 20h16v2H4z"/>',
    },
    "uninstall-fill": {
      body: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-1 14H5v4h14zm-2 1v2h-2v-2zM12 2L8 6h3v5h2V6h3z"/>',
    },
    "uninstall-line": {
      body: '<path fill="currentColor" d="M8 2v2H5l-.001 10h14L19 4h-3V2h4a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm10.999 14h-14L5 20h14zM17 17v2h-2v-2zM12 2l4 4h-3v5h-2V6H8z"/>',
    },
    "unpin-fill": {
      body: '<path fill="currentColor" d="m20.971 17.172l-1.414 1.414l-3.535-3.535l-.073.074l-.707 3.535l-1.415 1.415l-4.242-4.243l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.243-4.243l1.414-1.414l3.536-.707l.073-.074l-3.536-3.536l1.414-1.415zm-2.12-4.95l1.34-1.34l.707.707l1.415-1.414l-8.486-8.485l-1.414 1.414l.707.707l-1.34 1.34z"/>',
    },
    "unpin-line": {
      body: '<path fill="currentColor" d="m20.97 17.172l-1.414 1.414l-3.535-3.535l-.073.074l-.707 3.536l-1.415 1.414l-4.242-4.243l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.243-4.243L5.34 8.761l3.536-.707l.073-.074l-3.536-3.536L6.828 3.03zM10.365 9.394l-.502.502l-2.822.565l6.5 6.5l.564-2.822l.502-.502zm8.411.074l-1.34 1.34l1.414 1.415l1.34-1.34l.707.707l1.415-1.415l-8.486-8.485l-1.414 1.414l.707.707l-1.34 1.34l1.414 1.415l1.34-1.34z"/>',
    },
    "unsplash-fill": {
      body: '<path fill="currentColor" d="M8.501 11v5h7v-5h5.5v10h-18V11zm7-8v5h-7V3z"/>',
    },
    "unsplash-line": {
      body: '<path fill="currentColor" d="M10.001 10v4h4v-4h7v11h-18V10zm-2 2h-3v7h14v-7h-3L16 16H8zm8-9v6h-8V3zm-2 2h-4v2h4z"/>',
    },
    "upload-2-fill": {
      body: '<path fill="currentColor" d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2zM14 9v6h-4V9H5l7-7l7 7z"/>',
    },
    "upload-2-line": {
      body: '<path fill="currentColor" d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2zm9-10v7h-2V9H6l6-6l6 6z"/>',
    },
    "upload-cloud-2-fill": {
      body: '<path fill="currentColor" d="m12 12.586l4.243 4.242l-1.415 1.415L13 16.415V22h-2v-5.587l-1.828 1.83l-1.415-1.415zM12 2a7 7 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978V17a6 6 0 0 0-11.996-.225L6 17v1.978a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2"/>',
    },
    "upload-cloud-2-line": {
      body: '<path fill="currentColor" d="m12 12.586l4.243 4.242l-1.415 1.415L13 16.415V22h-2v-5.587l-1.828 1.83l-1.415-1.415zM12 2a7 7 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978v-2.014a3.5 3.5 0 1 0-1.111-6.91a5 5 0 1 0-9.777 0a3.5 3.5 0 0 0-1.292 6.88l.18.03v2.014a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2"/>',
    },
    "upload-cloud-fill": {
      body: '<path fill="currentColor" d="M7 20.981a6.5 6.5 0 0 1-2.936-12a8.001 8.001 0 0 1 15.872 0a6.5 6.5 0 0 1-2.936 12V21H7zM13 13h3l-4-5l-4 5h3v4h2z"/>',
    },
    "upload-cloud-line": {
      body: '<path fill="currentColor" d="M1 14.5a6.5 6.5 0 0 1 3.064-5.519a8.001 8.001 0 0 1 15.872 0a6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5m15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503l-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942l-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35zM13 13v4h-2v-4H8l4-5l4 5z"/>',
    },
    "upload-fill": {
      body: '<path fill="currentColor" d="M3 19h18v2H3zm10-9v8h-2v-8H4l8-8l8 8z"/>',
    },
    "upload-line": {
      body: '<path fill="currentColor" d="M3 19h18v2H3zM13 5.828V17h-2V5.828L4.929 11.9l-1.414-1.414L12 2l8.485 8.485l-1.414 1.415z"/>',
    },
    "usb-fill": {
      body: '<path fill="currentColor" d="m12 1l3 5h-2v7.381l3-1.499l-.001-.882H15V7h4v4h-1.001L18 13.118l-5 2.5v1.553A3.001 3.001 0 0 1 12 23a3 3 0 0 1-1.31-5.7L6 14l-.001-2.268a2 2 0 1 1 2.001 0V13l3 2.086V6H9z"/>',
    },
    "usb-line": {
      body: '<path fill="currentColor" d="m12 1l3 5h-2v7.381l3-1.499l-.001-.882H15V7h4v4h-1.001L18 13.118l-5 2.5v1.553A3.001 3.001 0 0 1 12 23a3 3 0 0 1-1.31-5.7L6 14l-.001-2.268a2 2 0 1 1 2.001 0V13l3 2.086V6H9zm0 18a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "user-2-fill": {
      body: '<path fill="currentColor" d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8 8 0 0 1 7-7.938M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6"/>',
    },
    "user-2-line": {
      body: '<path fill="currentColor" d="M4 22a8 8 0 1 1 16 0zm9-5.917V20h4.659A6.01 6.01 0 0 0 13 16.083M11 20v-3.917A6.01 6.01 0 0 0 6.341 20zm1-7c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4"/>',
    },
    "user-3-fill": {
      body: '<path fill="currentColor" d="M20 22H4v-2a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5zm-8-9a6 6 0 1 1 0-12a6 6 0 0 1 0 12"/>',
    },
    "user-3-line": {
      body: '<path fill="currentColor" d="M20 22h-2v-2a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v2H4v-2a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5zm-8-9a6 6 0 1 1 0-12a6 6 0 0 1 0 12m0-2a4 4 0 1 0 0-8a4 4 0 0 0 0 8"/>',
    },
    "user-4-fill": {
      body: '<path fill="currentColor" d="M5 20h14v2H5zm7-2a8 8 0 1 1 0-16a8 8 0 0 1 0 16"/>',
    },
    "user-4-line": {
      body: '<path fill="currentColor" d="M5 20h14v2H5zm7-2a8 8 0 1 1 0-16a8 8 0 0 1 0 16m0-2a6 6 0 1 0 0-12a6 6 0 0 0 0 12"/>',
    },
    "user-5-fill": {
      body: '<path fill="currentColor" d="M7.39 16.539a8 8 0 1 1 9.221 0l2.083 4.76a.5.5 0 0 1-.459.701H5.765a.5.5 0 0 1-.459-.7zm.729-5.569a4.002 4.002 0 0 0 7.763 0l-1.941-.485a2 2 0 0 1-3.882 0z"/>',
    },
    "user-5-line": {
      body: '<path fill="currentColor" d="M7.39 16.539a8 8 0 1 1 9.221 0l2.083 4.76a.5.5 0 0 1-.459.701H5.765a.5.5 0 0 1-.459-.7zm6.735-.693l1.332-.941a6 6 0 1 0-6.913 0l1.331.941L8.058 20h7.884zM8.119 10.97l1.94-.485a2 2 0 0 0 3.882 0l1.94.485a4.002 4.002 0 0 1-7.762 0"/>',
    },
    "user-6-fill": {
      body: '<path fill="currentColor" d="M12 17c3.662 0 6.865 1.575 8.607 3.925l-1.842.871C17.347 20.116 14.847 19 12 19c-2.848 0-5.347 1.116-6.765 2.796l-1.841-.872C5.136 18.574 8.338 17 12 17m0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5"/>',
    },
    "user-6-line": {
      body: '<path fill="currentColor" d="M12 17c3.662 0 6.865 1.575 8.607 3.925l-1.842.871C17.347 20.116 14.847 19 12 19c-2.848 0-5.347 1.116-6.765 2.796l-1.841-.872C5.136 18.574 8.338 17 12 17m0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-4.783 4.995L12 15a5 5 0 0 1-5-5V7a5 5 0 0 1 4.783-4.995zm0 2a3 3 0 0 0-2.995 2.824L9 7v3a3 3 0 0 0 5.995.176L15 10V7a3 3 0 0 0-3-3"/>',
    },
    "user-add-fill": {
      body: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m6 4v-3h2v3h3v2h-3v3h-2v-3h-3v-2z"/>',
    },
    "user-add-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2z"/>',
    },
    "user-fill": {
      body: '<path fill="currentColor" d="M4 22a8 8 0 1 1 16 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6"/>',
    },
    "user-follow-fill": {
      body: '<path fill="currentColor" d="M13 14.062V22H4a8 8 0 0 1 9-7.938M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m5.793 6.914l3.535-3.535l1.415 1.414l-4.95 4.95l-3.536-3.536l1.415-1.414z"/>',
    },
    "user-follow-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m5.793 8.914l3.535-3.535l1.415 1.414l-4.95 4.95l-3.536-3.536l1.415-1.414z"/>',
    },
    "user-forbid-fill": {
      body: '<path fill="currentColor" d="M12 13a6 6 0 1 0 0-12a6 6 0 0 0 0 12m3 5a3 3 0 0 1 4.293-2.708l-4 4.001A3 3 0 0 1 15 18m1.707 2.708l4-4.001a3 3 0 0 1-4.001 4.001M18 13a5 5 0 1 0 0 10a5 5 0 0 0 0-10m-6 1q.126 0 .252.004A6.97 6.97 0 0 0 11 18c0 1.487.464 2.866 1.255 4H4a8 8 0 0 1 8-8"/>',
    },
    "user-forbid-line": {
      body: '<path fill="currentColor" d="M8 7a4 4 0 1 1 8 0a4 4 0 0 1-8 0m4-6a6 6 0 1 0 0 12a6 6 0 0 0 0-12m3 17a3 3 0 0 1 4.293-2.708l-4 4.001A3 3 0 0 1 15 18m1.707 2.708l4-4.001a3 3 0 0 1-4.001 4.001M18 13a5 5 0 1 0 0 10a5 5 0 0 0 0-10m-6 1q.126 0 .252.004a7 7 0 0 0-.975 2.04A6 6 0 0 0 6 22H4a8 8 0 0 1 8-8"/>',
    },
    "user-heart-fill": {
      body: '<path fill="currentColor" d="m17.841 15.659l.176.177l.178-.177a2.25 2.25 0 1 1 3.182 3.182l-3.36 3.359l-3.358-3.359a2.25 2.25 0 1 1 3.182-3.182M12 14v8H4a8 8 0 0 1 7.75-7.996zm0-13c3.315 0 6 2.685 6 6s-2.685 6-6 6s-6-2.685-6-6s2.685-6 6-6"/>',
    },
    "user-heart-line": {
      body: '<path fill="currentColor" d="m17.841 15.659l.176.177l.178-.177a2.25 2.25 0 1 1 3.182 3.182l-3.36 3.359l-3.358-3.359a2.25 2.25 0 1 1 3.182-3.182M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 7.75-7.996zm0-13c3.315 0 6 2.685 6 6a6 6 0 0 1-5.775 5.996L12 13c-3.315 0-6-2.685-6-6a6 6 0 0 1 5.775-5.996zm0 2C9.79 3 8 4.79 8 7s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4"/>',
    },
    "user-line": {
      body: '<path fill="currentColor" d="M4 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4"/>',
    },
    "user-location-fill": {
      body: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m8.828 7.828L18 23.657l-2.828-2.829a4 4 0 1 1 5.656 0M18 17a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "user-location-line": {
      body: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m8.828 10.071L18 24l-2.828-2.929c-1.562-1.618-1.562-4.24 0-5.858a3.904 3.904 0 0 1 5.656 0c1.563 1.618 1.563 4.24 0 5.858m-1.438-1.39c.813-.842.813-2.236 0-3.079a1.904 1.904 0 0 0-2.78 0c-.813.843-.813 2.237 0 3.08L18 21.12z"/>',
    },
    "user-minus-fill": {
      body: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m11 5v2h-8v-2z"/>',
    },
    "user-minus-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m11 7v2h-8v-2z"/>',
    },
    "user-received-2-fill": {
      body: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m8 4h3v2h-3v3.5L15 18l5-4.5z"/>',
    },
    "user-received-2-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m8 6h3v2h-3v3.5L15 18l5-4.5z"/>',
    },
    "user-received-fill": {
      body: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m7.418 4h3.586v2h-3.586l1.829 1.828l-1.414 1.415L15.59 18l4.243-4.243l1.414 1.415z"/>',
    },
    "user-received-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m7.418 6h3.586v2h-3.586l1.829 1.828l-1.414 1.415L15.59 18l4.243-4.243l1.414 1.415z"/>',
    },
    "user-search-fill": {
      body: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m9.446 7.032l1.504 1.503l-1.415 1.415l-1.503-1.504a4 4 0 1 1 1.414-1.414M18 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "user-search-line": {
      body: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m9.446 9.032l1.504 1.503l-1.415 1.415l-1.503-1.504a4 4 0 1 1 1.414-1.414M18 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "user-settings-fill": {
      body: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m2.595 5.811a3.5 3.5 0 0 1 0-1.622l-.992-.573l1-1.732l.992.573A3.5 3.5 0 0 1 17 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573l1 1.732l-.991.573a3.5 3.5 0 0 1 0 1.622l.991.573l-1 1.732l-.992-.573a3.5 3.5 0 0 1-1.405.812V22.5h-2v-1.145a3.5 3.5 0 0 1-1.405-.812l-.992.573l-1-1.732zM18 17a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "user-settings-line": {
      body: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m2.595 7.811a3.5 3.5 0 0 1 0-1.622l-.992-.573l1-1.732l.992.573A3.5 3.5 0 0 1 17 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573l1 1.732l-.991.573a3.5 3.5 0 0 1 0 1.622l.991.573l-1 1.732l-.992-.573a3.5 3.5 0 0 1-1.405.812V22.5h-2v-1.145a3.5 3.5 0 0 1-1.405-.812l-.992.573l-1-1.732zM18 19.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"/>',
    },
    "user-shared-2-fill": {
      body: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m6 4v-3.5l5 4.5l-5 4.5V19h-3v-2z"/>',
    },
    "user-shared-2-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m6 6v-3.5l5 4.5l-5 4.5V19h-3v-2z"/>',
    },
    "user-shared-fill": {
      body: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m6.586 4l-1.829-1.828l1.415-1.415L22.414 18l-4.242 4.243l-1.415-1.415L18.586 19H15v-2z"/>',
    },
    "user-shared-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m6.586 6l-1.829-1.828l1.415-1.415L22.414 18l-4.242 4.243l-1.415-1.415L18.586 19H15v-2z"/>',
    },
    "user-smile-fill": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10M7 12a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0z"/>',
    },
    "user-smile-line": {
      body: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-5-8h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0"/>',
    },
    "user-star-fill": {
      body: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8m6 7.5l-2.939 1.545l.561-3.273l-2.377-2.317l3.286-.477L18 14l1.47 2.977l3.285.478l-2.377 2.318l.56 3.272zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6"/>',
    },
    "user-star-line": {
      body: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8m0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m6 10.5l-2.939 1.545l.561-3.273l-2.377-2.317l3.286-.477L18 14l1.47 2.977l3.285.478l-2.377 2.318l.56 3.272z"/>',
    },
    "user-unfollow-fill": {
      body: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m7 3.586l2.121-2.121l1.415 1.414L20.414 18l2.121 2.121l-1.414 1.415L19 19.414l-2.121 2.121l-1.415-1.414L17.587 18l-2.121-2.121l1.414-1.415z"/>',
    },
    "user-unfollow-line": {
      body: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m7 6.586l2.121-2.121l1.415 1.414L20.414 19l2.121 2.121l-1.414 1.415L19 20.414l-2.121 2.121l-1.415-1.414L17.587 19l-2.121-2.121l1.414-1.415z"/>',
    },
    "user-voice-fill": {
      body: '<path fill="currentColor" d="M1 22a8 8 0 1 1 16 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m9.246-9.815A10 10 0 0 1 19 7a10 10 0 0 1-.754 3.816l-1.677-1.22A8 8 0 0 0 17 7a8 8 0 0 0-.43-2.596zM21.548.784A13.94 13.94 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.217l-1.645-1.197A12 12 0 0 0 21 7a12 12 0 0 0-1.097-5.02z"/>',
    },
    "user-voice-line": {
      body: '<path fill="currentColor" d="M1 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4M21.548.784A13.94 13.94 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.217l-1.645-1.197A12 12 0 0 0 21 7a12 12 0 0 0-1.097-5.02zm-3.302 2.4A10 10 0 0 1 19 7a10 10 0 0 1-.754 3.816l-1.677-1.22A8 8 0 0 0 17 7a8 8 0 0 0-.43-2.596z"/>',
    },
    "verified-badge-fill": {
      body: '<path fill="currentColor" d="M10.007 2.104a3 3 0 0 0-3.595 1.49L5.606 5.17a1 1 0 0 1-.436.436l-1.577.806a3 3 0 0 0-1.49 3.595l.546 1.685a1 1 0 0 1 0 .616l-.545 1.685a3 3 0 0 0 1.49 3.595l1.576.806a1 1 0 0 1 .436.436l.806 1.577a3 3 0 0 0 3.595 1.49l1.685-.546a1 1 0 0 1 .616 0l1.685.545a3 3 0 0 0 3.595-1.489l.806-1.577a1 1 0 0 1 .436-.436l1.577-.805a3 3 0 0 0 1.49-3.596l-.546-1.685a1 1 0 0 1 0-.616l.545-1.685a3 3 0 0 0-1.489-3.595l-1.577-.806a1 1 0 0 1-.436-.436l-.805-1.577a3 3 0 0 0-3.596-1.49l-1.685.546a1 1 0 0 1-.616 0zM6.76 11.757l1.414-1.414l2.828 2.829l5.657-5.657l1.415 1.414l-7.072 7.07z"/>',
    },
    "verified-badge-line": {
      body: '<path fill="currentColor" d="M10.007 2.104a3 3 0 0 0-3.595 1.489L5.606 5.17a1 1 0 0 1-.436.436l-1.577.805a3 3 0 0 0-1.489 3.596l.545 1.685a1 1 0 0 1 0 .616l-.545 1.685a3 3 0 0 0 1.49 3.595l1.576.806a1 1 0 0 1 .436.436l.806 1.577a3 3 0 0 0 3.595 1.49l1.685-.546a1 1 0 0 1 .616 0l1.685.545a3 3 0 0 0 3.596-1.49l.806-1.576a1 1 0 0 1 .435-.436l1.577-.806a3 3 0 0 0 1.49-3.595l-.546-1.685a1 1 0 0 1 0-.616l.546-1.685a3 3 0 0 0-1.49-3.596l-1.577-.805a1 1 0 0 1-.435-.436l-.806-1.577a3 3 0 0 0-3.596-1.49l-1.685.546a1 1 0 0 1-.616 0zM8.193 4.503a1 1 0 0 1 1.198-.497l1.685.546a3 3 0 0 0 1.848 0l1.685-.546a1 1 0 0 1 1.199.497l.805 1.577a3 3 0 0 0 1.307 1.307l1.577.805a1 1 0 0 1 .497 1.199l-.546 1.685a3 3 0 0 0 0 1.848l.546 1.685a1 1 0 0 1-.497 1.198l-1.577.806a3 3 0 0 0-1.307 1.307l-.805 1.577a1 1 0 0 1-1.199.496l-1.685-.545a3 3 0 0 0-1.848 0l-1.685.545a1 1 0 0 1-1.198-.496l-.806-1.577a3 3 0 0 0-1.307-1.307l-1.577-.806a1 1 0 0 1-.496-1.198l.545-1.685a3 3 0 0 0 0-1.848l-.545-1.685a1 1 0 0 1 .496-1.199l1.577-.805A3 3 0 0 0 7.387 6.08zM6.76 11.757L11.003 16l7.07-7.071l-1.414-1.414l-5.656 5.657l-2.829-2.829z"/>',
    },
    "video-add-fill": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM8 8v3H5v2h2.999L8 16h2l-.001-3H13v-2h-3V8z"/>',
    },
    "video-add-line": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm-1 2H3v12h12zM8 8h2v3h3v2H9.999L10 16H8l-.001-3H5v-2h3zm13 .841l-4 2.8v.718l4 2.8z"/>',
    },
    "video-chat-fill": {
      body: '<path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM14 10.25V8H7v6h7v-2.25L17 14V8z"/>',
    },
    "video-chat-line": {
      body: '<path fill="currentColor" d="M14 10.25L17 8v6l-3-2.25V14H7V8h7zM5.763 17H20V5H4v13.385zm.692 2L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1z"/>',
    },
    "video-download-fill": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm-6 4H8v4H5l4 4l4-4h-3z"/>',
    },
    "video-download-line": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm-1 2H3v12h12zm-5 2v4h3l-4 4l-4-4h3V8zm11 .841l-4 2.8v.718l4 2.8z"/>',
    },
    "video-fill": {
      body: '<path fill="currentColor" d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007zm7.622 4.422a.4.4 0 0 0-.622.332v6.506a.4.4 0 0 0 .622.332l4.879-3.252a.4.4 0 0 0 0-.666z"/>',
    },
    "video-line": {
      body: '<path fill="currentColor" d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007zM5 5v14h14V5zm5.622 3.415l4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332"/>',
    },
    "video-off-fill": {
      body: '<path fill="currentColor" d="m17 18.414l4.192 4.193l1.415-1.415l-19.8-19.799l-1.414 1.415L2.586 4H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zM16 4H8.214l14.494 14.494A.5.5 0 0 0 23 18.04V5.96a.5.5 0 0 0-.787-.41L17 9.2V5a1 1 0 0 0-1-1"/>',
    },
    "video-off-line": {
      body: '<path fill="currentColor" d="m17 18.414l4.192 4.193l1.415-1.415l-19.8-19.799l-1.414 1.415L2.586 4H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-2-2V18H3V6h1.586zm8 1.626a.5.5 0 0 1-.292.454L21 16.786V8.841l-4 2.8v1.145l-2-2V6h-4.786l-2-2H16a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41z"/>',
    },
    "video-on-fill": {
      body: '<path fill="currentColor" d="m17 9.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z"/>',
    },
    "video-on-line": {
      body: '<path fill="currentColor" d="m17 9.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm0 3.159l4 2.8V8.84l-4 2.8zM3 6v12h12V6z"/>',
    },
    "video-upload-fill": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM9 8l-4 4h3v4h2v-4h3z"/>',
    },
    "video-upload-line": {
      body: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm-1 2H3v12h12zM9 8l4 4h-3v4H8v-4H5zm12 .841l-4 2.8v.718l4 2.8z"/>',
    },
    "vidicon-2-fill": {
      body: '<path fill="currentColor" d="M13 6V4H5V2h10v4h1a1 1 0 0 1 1 1v2.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm-8 4v2h2v-2z"/>',
    },
    "vidicon-2-line": {
      body: '<path fill="currentColor" d="M13 6V4H5V2h10v4h1a1 1 0 0 1 1 1v2.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm2 2H3v10h12zm2 4.359l4 2.8V8.84l-4 2.8zM5 10h2v2H5z"/>',
    },
    "vidicon-fill": {
      body: '<path fill="currentColor" d="m17 9.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zM5 8v2h2V8z"/>',
    },
    "vidicon-line": {
      body: '<path fill="currentColor" d="m17 9.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm0 3.159l4 2.8V8.84l-4 2.8zM3 6v12h12V6zm2 2h2v2H5z"/>',
    },
    "vimeo-fill": {
      body: '<path fill="currentColor" d="M1.174 8.301c-.281-.413-.252-.413.328-.922c1.232-1.082 2.394-2.266 3.736-3.212c1.215-.852 2.826-1.402 3.927-.047c1.014 1.249 1.038 3.142 1.295 4.65c.257 1.564.503 3.164 1.051 4.66c.152.421.443 1.217.968 1.284c.678.093 1.368-1.096 1.683-1.54c.817-1.18 1.925-2.769 1.785-4.286c-.138-1.612-1.878-1.309-2.966-.924c.175-1.809 1.858-3.843 3.48-4.53c1.72-.714 4.276-.702 5.14 1.237c.922 2.102.093 4.543-.912 6.448c-1.096 2.068-2.509 3.982-4.018 5.77c-1.331 1.588-2.906 3.33-4.89 4.089c-2.267.864-3.61-.82-4.382-2.77c-.843-2.123-1.262-4.506-1.87-6.716c-.256-.935-.56-1.998-1.167-2.77c-.792-.994-1.692-.059-2.474.478c-.27-.267-.491-.607-.714-.899"/>',
    },
    "vimeo-line": {
      body: '<path fill="currentColor" d="M17.994 3.004C20.427 3.004 22 4.516 22 7.5c0 1.72-.998 3.94-1.832 5.235c-2.789 4.333-6.233 8.74-9.643 8.74c-3.706 0-4.67-6.831-5.092-8.432s-.533-2.21-1.17-3.233q-.475.33-1.33.93a.5.5 0 0 1-.693-.117L.926 8.807a.5.5 0 0 1 .027-.62Q5.193 3.278 8 3.278c2.392 0 3.125 2.816 3.324 4.223c.3 2.117.69 4.738 1.245 5.872c.556-.792 2.18-2.888 1.966-3.99c-.094-.487-1.317.183-1.887.078c-.425-.08-.805-.402-.805-1.026c0-1.31 1.851-5.43 6.15-5.43m.007 2c-2.194 0-3.251 1.533-3.653 2.208c1.25.046 1.97.818 2.134 1.803c.388 2.33-1.917 4.92-2.34 5.565c-.396.603-3.061 3.328-4.25-3.36a160 160 0 0 1-.665-4.186c-.17-1.151-.872-1.763-1.229-1.763c-.843 0-1.92.65-3.856 2.515c1.905-.115 2.545 2.276 2.917 3.633c.815 2.984 1.57 8.055 3.62 8.055c1.726 0 4.438-2.645 7.37-7.038c.208-.312 1.965-3.025 1.965-5.037c0-2.395-1.469-2.395-2.013-2.395"/>',
    },
    "vip-crown-2-fill": {
      body: '<path fill="currentColor" d="M2.806 5.2L7.005 8l4.186-5.861a1 1 0 0 1 1.628 0l4.186 5.86l4.2-2.799a1 1 0 0 1 1.547.949L21.11 20.116a1 1 0 0 1-.993.884H3.894a1 1 0 0 1-.993-.884L1.258 6.15a1 1 0 0 1 1.548-.95m9.2 9.8a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>',
    },
    "vip-crown-2-line": {
      body: '<path fill="currentColor" d="M3.497 8.065L4.784 19h14.443l1.286-10.935l-4.01 2.673l-4.498-6.297l-4.498 6.297zM2.806 5.2L7.005 8l4.186-5.861a1 1 0 0 1 1.628 0l4.186 5.86l4.2-2.799a1 1 0 0 1 1.547.949L21.11 20.116a1 1 0 0 1-.993.884H3.894a1 1 0 0 1-.993-.884L1.258 6.15a1 1 0 0 1 1.548-.95m9.2 9.8a2 2 0 1 1-.001-4a2 2 0 0 1 0 4"/>',
    },
    "vip-crown-fill": {
      body: '<path fill="currentColor" d="M2.005 19h20v2h-20zm0-14l5 3l5-6l5 6l5-3v12h-20z"/>',
    },
    "vip-crown-line": {
      body: '<path fill="currentColor" d="M2.005 19h20v2h-20zm0-14l5 3.5l5-6.5l5 6.5l5-3.5v12h-20zm2 3.841V15h16V8.841l-3.42 2.394l-4.58-5.955l-4.58 5.955z"/>',
    },
    "vip-diamond-fill": {
      body: '<path fill="currentColor" d="M4.878 3.003h14.254a1 1 0 0 1 .809.412l3.822 5.256a.5.5 0 0 1-.037.633l-11.354 12.3a.5.5 0 0 1-.735 0L.283 9.305a.5.5 0 0 1-.037-.633l3.823-5.256a1 1 0 0 1 .809-.412"/>',
    },
    "vip-diamond-line": {
      body: '<path fill="currentColor" d="M4.878 3.003h14.254a1 1 0 0 1 .809.412l3.822 5.256a.5.5 0 0 1-.037.633l-11.354 12.3a.5.5 0 0 1-.706.029L.283 9.304a.5.5 0 0 1-.037-.633l3.823-5.256a1 1 0 0 1 .809-.412m.509 2l-2.8 3.849l9.418 10.202l9.417-10.202l-2.8-3.85z"/>',
    },
    "vip-fill": {
      body: '<path fill="currentColor" d="M3.005 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 5.5v7h2v-7zm-.285 0H8.606l-1.497 4.113L5.612 8.5H3.498l2.611 6.964h2zm5.285 5h1.5a2.5 2.5 0 0 0 0-5h-3.5v7h2zm0-2v-1h1.5a.5.5 0 0 1 0 1z"/>',
    },
    "vip-line": {
      body: '<path fill="currentColor" d="M2.005 19h20v2h-20zm9-11h2v8h-2zM7.97 8l-1.86 5.113L4.247 8H2.123l2.986 7.964h2L10.095 8zm9.035 6v2h-2V8h4a3 3 0 0 1 0 6zm0-4v2h2a1 1 0 1 0 0-2zm-15-7h20v2h-20z"/>',
    },
    "virus-fill": {
      body: '<path fill="currentColor" d="m13.716 1.947l3.735 1.434l-.717 1.867l-.934-.359l-.746 1.945a6 6 0 0 1 1.945 1.846l1.902-.847l-.406-.914l1.827-.813l1.627 3.654l-1.827.813l-.407-.913l-1.902.847a6 6 0 0 1 .07 2.68l1.944.746l.358-.933l1.867.716l-1.433 3.735l-1.867-.717l.357-.933l-1.944-.747A6 6 0 0 1 15.32 17l.848 1.903l.914-.407l.813 1.827l-3.654 1.627l-.813-1.827l.913-.407l-.847-1.902a6 6 0 0 1-2.68.07l-.747 1.944l.934.358l-.717 1.867L6.55 20.62l.717-1.867l.932.358l.748-1.944A6 6 0 0 1 7 15.319l-1.903.848l.407.914l-1.827.813L2.05 14.24l1.827-.813l.406.914l1.903-.848a6 6 0 0 1-.07-2.68l-1.945-.746l-.358.933l-1.867-.716L3.38 6.549l1.867.717l-.36.933l1.946.747A6 6 0 0 1 8.68 7l-.848-1.903l-.913.407l-.814-1.827L9.76 2.051l.813 1.827l-.914.407l.848 1.902a6 6 0 0 1 2.68-.07l.745-1.945L13 3.815zm-3.582 11.285a1 1 0 1 0 1.732 1a1 1 0 0 0-1.732-1M14 11a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-3.5-1.598a1 1 0 1 0 1 1.732a1 1 0 0 0-1-1.732"/>',
    },
    "virus-line": {
      body: '<path fill="currentColor" d="m13.716 1.947l3.735 1.434l-.717 1.867l-.934-.359l-.746 1.945a6 6 0 0 1 1.945 1.846l1.902-.847l-.406-.914l1.827-.813l1.627 3.654l-1.827.813l-.407-.913l-1.902.847a6 6 0 0 1 .07 2.68l1.944.746l.358-.933l1.867.716l-1.433 3.735l-1.867-.717l.357-.933l-1.944-.747A6 6 0 0 1 15.32 17l.848 1.903l.914-.407l.813 1.827l-3.654 1.627l-.813-1.827l.913-.407l-.847-1.902a6 6 0 0 1-2.68.07l-.747 1.944l.934.358l-.717 1.867L6.55 20.62l.717-1.867l.932.358l.748-1.944A6 6 0 0 1 7 15.319l-1.903.848l.407.914l-1.827.813L2.05 14.24l1.827-.813l.406.914l1.903-.848a6 6 0 0 1-.07-2.68l-1.945-.746l-.358.933l-1.867-.716L3.38 6.549l1.867.717l-.36.933l1.946.747A6 6 0 0 1 8.68 7l-.848-1.903l-.913.407l-.814-1.827L9.76 2.051l.813 1.827l-.914.407l.848 1.902a6 6 0 0 1 2.68-.07l.745-1.945L13 3.815zM12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-.5 4.866a1 1 0 1 1-1 1.732a1 1 0 0 1 1-1.732M14 11a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-2.134-1.232a1 1 0 1 1-1.732 1a1 1 0 0 1 1.732-1"/>',
    },
    "visa-fill": {
      body: '<path fill="currentColor" d="M1 4h22v2H1zm0 14h22v2H1zm18.622-3.086l-.174-.87h-1.949l-.31.863l-1.562.004q1.507-3.61 2.236-5.35q.189-.455.685-.454q.381.003 1.245 0L21 14.912zm-1.684-2.062h1.256l-.47-2.18zM7.872 9.106l1.57.002l-2.427 5.806l-1.59-.001q-.806-3.106-1.184-4.605c-.077-.307-.23-.521-.526-.622Q3.321 9.55 2.4 9.267v-.16h2.509c.434 0 .687.21.769.64l.62 3.289zm3.727.002l-1.24 5.805l-1.495-.002l1.24-5.805zM14.631 9c.446 0 1.01.138 1.334.267l-.262 1.204c-.293-.118-.775-.277-1.18-.27c-.59.009-.954.256-.954.493c0 .384.632.578 1.284.999c.743.48.84.91.832 1.378c-.011.971-.832 1.929-2.565 1.929c-.791-.012-1.076-.078-1.72-.306l.272-1.256c.656.274.935.361 1.495.361c.515 0 .956-.207.96-.568c.002-.257-.155-.384-.732-.702s-1.386-.756-1.375-1.64C12.033 9.759 13.107 9 14.63 9"/>',
    },
    "visa-line": {
      body: '<path fill="currentColor" d="m22.222 15.768l-.225-1.125h-2.514l-.4 1.117l-2.015.004q1.943-4.669 2.884-6.917c.164-.392.455-.592.884-.589q.492.004 1.606.001L24 15.765zm-2.174-2.666h1.621l-.605-2.82zM7.062 8.257l2.026.002l-3.132 7.51l-2.051-.002a951 951 0 0 1-1.528-5.956c-.1-.396-.298-.673-.679-.804Q1.187 8.832 0 8.466v-.207h3.237c.56 0 .887.271.992.827q.159.836.8 4.254zm4.81.002l-1.601 7.509l-1.929-.003L9.94 8.257zm3.91-.139c.577 0 1.304.18 1.722.346l-.338 1.556c-.378-.152-1-.357-1.523-.35c-.76.013-1.23.332-1.23.638c0 .498.816.749 1.656 1.293c.958.62 1.085 1.177 1.073 1.783c-.013 1.255-1.073 2.494-3.309 2.494c-1.02-.015-1.388-.1-2.22-.396l.352-1.624c.847.354 1.206.467 1.93.467c.663 0 1.232-.268 1.237-.735c.004-.332-.2-.497-.944-.907s-1.788-.979-1.774-2.122c.017-1.462 1.402-2.443 3.368-2.443"/>',
    },
    "vk-fill": {
      body: '<path fill="currentColor" d="M4.26 4.26C3 5.532 3 7.566 3 11.64v.72c0 4.068 0 6.102 1.26 7.38C5.532 21 7.566 21 11.64 21h.72c4.068 0 6.102 0 7.38-1.26C21 18.468 21 16.434 21 12.36v-.72c0-4.068 0-6.102-1.26-7.38C18.468 3 16.434 3 12.36 3h-.72C7.572 3 5.538 3 4.26 4.26m1.776 4.218H8.1c.066 3.432 1.578 4.884 2.778 5.184V8.478h1.938v2.958c1.182-.126 2.43-1.476 2.85-2.964h1.932a5.72 5.72 0 0 1-2.628 3.738a5.92 5.92 0 0 1 3.078 3.756h-2.13c-.456-1.422-1.596-2.526-3.102-2.676v2.676h-.24c-4.104 0-6.444-2.808-6.54-7.488"/>',
    },
    "vk-line": {
      body: '<path fill="currentColor" d="M5.827 5.828c-.344.349-.57.839-.696 1.77c-.129.965-.13 2.243-.13 4.082v.64c0 1.836.001 3.113.13 4.077c.125.932.352 1.425.697 1.777c.35.343.84.57 1.77.695c.965.129 2.243.131 4.082.131h.64c1.836 0 3.113-.002 4.078-.131c.931-.125 1.424-.352 1.776-.697c.343-.349.57-.839.695-1.77c.13-.965.131-2.243.131-4.082v-.64c0-1.836-.002-3.113-.13-4.077c-.126-.932-.353-1.425-.698-1.777c-.349-.343-.839-.57-1.77-.695C15.437 5.002 14.159 5 12.32 5h-.64c-1.836 0-3.113.002-4.077.131c-.932.125-1.424.352-1.776.697M11.68 3h.64c1.445 0 2.912-.043 4.347.149c1.156.155 2.135.486 2.917 1.26l.008.009c.773.784 1.105 1.763 1.26 2.92c.191 1.433.148 2.899.148 4.342v.64c0 1.444.044 2.911-.149 4.347c-.154 1.156-.486 2.135-1.26 2.917l-.009.008c-.783.773-1.762 1.104-2.92 1.26c-1.433.191-2.899.148-4.342.148h-.64c-1.444 0-2.911.043-4.346-.149c-1.157-.155-2.136-.486-2.917-1.26l-.009-.009c-.772-.784-1.104-1.763-1.259-2.92C2.957 15.23 3 13.764 3 12.32v-.64c0-1.444-.043-2.911.15-4.347c.154-1.156.486-2.135 1.26-2.917l.008-.008c.784-.773 1.763-1.104 2.92-1.26C8.772 2.958 10.238 3 11.68 3M6.036 8.478c.096 4.68 2.436 7.488 6.54 7.488h.24V13.29c1.506.15 2.646 1.254 3.102 2.676h2.13a5.92 5.92 0 0 0-3.078-3.756a5.72 5.72 0 0 0 2.628-3.738h-1.932c-.42 1.488-1.668 2.838-2.85 2.964V8.478h-1.938v5.184c-1.2-.3-2.712-1.752-2.778-5.184z"/>',
    },
    "voice-recognition-fill": {
      body: '<path fill="currentColor" d="M20.998 3v18h-18V3zm-8 3h-2v12h2zm-4 3h-2v6h2zm8 0h-2v6h2z"/>',
    },
    "voice-recognition-line": {
      body: '<path fill="currentColor" d="M4.998 15v4h4v2h-6v-6zm16 0v6h-6v-2h4v-4zm-8-9v12h-2V6zm-4 3v6h-2V9zm8 0v6h-2V9zm-8-6v2h-4v4h-2V3zm12 0v6h-2V5h-4V3z"/>',
    },
    "voiceprint-fill": {
      body: '<path fill="currentColor" d="M5 7h2v10H5zm-4 3h2v4H1zm8-8h2v18H9zm4 2h2v18h-2zm4 3h2v10h-2zm4 3h2v4h-2z"/>',
    },
    "voiceprint-line": {
      body: '<path fill="currentColor" d="M5 7h2v10H5zm-4 3h2v4H1zm8-8h2v18H9zm4 2h2v18h-2zm4 3h2v10h-2zm4 3h2v4h-2z"/>',
    },
    "volume-down-fill": {
      body: '<path fill="currentColor" d="M8.889 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387zm9.974.591l-1.422-1.422A4 4 0 0 0 19 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.99 5.99 0 0 1 21 12c0 1.842-.83 3.49-2.137 4.591"/>',
    },
    "volume-down-line": {
      body: '<path fill="currentColor" d="M13 7.22L9.603 10H6v4h3.603L13 16.78zM8.889 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387zm9.974.591l-1.422-1.422A4 4 0 0 0 19 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.99 5.99 0 0 1 21 12c0 1.842-.83 3.49-2.137 4.591"/>',
    },
    "volume-mute-fill": {
      body: '<path fill="currentColor" d="M5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387zm14.525-4l3.536 3.536l-1.415 1.414L19 13.414l-3.536 3.536l-1.414-1.414L17.586 12L14.05 8.464l1.414-1.414L19 10.586l3.535-3.536l1.415 1.414z"/>',
    },
    "volume-mute-line": {
      body: '<path fill="currentColor" d="M10 7.22L6.603 10H3v4h3.603L10 16.78zM5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387zm14.525-4l3.536 3.536l-1.415 1.414L19 13.414l-3.536 3.536l-1.414-1.414L17.586 12L14.05 8.464l1.414-1.414L19 10.586l3.535-3.536l1.415 1.414z"/>',
    },
    "volume-off-vibrate-fill": {
      body: '<path fill="currentColor" d="m19.39 3.161l1.413 1.414l-2.475 2.475l2.475 2.475L18.328 12l2.475 2.476l-2.475 2.475l2.475 2.475l-1.414 1.414l-3.889-3.89l2.475-2.474L15.5 12l2.475-2.475L15.5 7.05zM13 19.945a.5.5 0 0 1-.817.387L6.89 15.999L3 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1l2.584-.002l-3.776-3.776l1.414-1.414L13 12.586zm-.113-16.206a.5.5 0 0 1 .113.316v5.702L9.282 6.04l2.901-2.372a.5.5 0 0 1 .704.07"/>',
    },
    "volume-off-vibrate-line": {
      body: '<path fill="currentColor" d="m19.39 3.161l1.413 1.414l-2.475 2.475l2.475 2.475L18.328 12l2.475 2.476l-2.475 2.475l2.475 2.475l-1.414 1.414l-3.889-3.89l2.475-2.474L15.5 12l2.475-2.475L15.5 7.05zM13 19.945a.5.5 0 0 1-.817.387L6.89 15.999L3 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1l2.584-.002l-3.776-3.776l1.414-1.414L13 12.586zM7.584 9.998L4 10v4l3.603-.001L11 16.779v-3.365zm5.303-6.26a.5.5 0 0 1 .113.317v5.702l-2-2V7.22l-.296.241l-1.421-1.42l2.9-2.373a.5.5 0 0 1 .704.07"/>',
    },
    "volume-up-fill": {
      body: '<path fill="currentColor" d="M2 16h3.889l5.294 4.332a.5.5 0 0 0 .817-.387V4.055a.5.5 0 0 0-.817-.387L5.89 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m21-4c0 3.292-1.446 6.246-3.738 8.262l-1.418-1.418A8.98 8.98 0 0 0 21 12a8.98 8.98 0 0 0-3.155-6.844l1.417-1.418A10.97 10.97 0 0 1 23 12m-5 0a5.99 5.99 0 0 0-2.287-4.713l-1.429 1.429A4 4 0 0 1 16 12c0 1.36-.679 2.561-1.716 3.284l1.43 1.43A5.99 5.99 0 0 0 18 12"/>',
    },
    "volume-up-line": {
      body: '<path fill="currentColor" d="M6.603 10L10 7.22v9.56L6.603 14H3v-4zM2 16h3.889l5.294 4.332a.5.5 0 0 0 .817-.387V4.055a.5.5 0 0 0-.817-.387L5.89 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m21-4c0 3.292-1.446 6.246-3.738 8.262l-1.418-1.418A8.98 8.98 0 0 0 21 12a8.98 8.98 0 0 0-3.155-6.844l1.417-1.418A10.97 10.97 0 0 1 23 12m-5 0a5.99 5.99 0 0 0-2.287-4.713l-1.429 1.429A4 4 0 0 1 16 12c0 1.36-.679 2.561-1.716 3.284l1.43 1.43A5.99 5.99 0 0 0 18 12"/>',
    },
    "volume-vibrate-fill": {
      body: '<path fill="currentColor" d="m19.39 3.161l1.413 1.414l-2.475 2.475l2.475 2.475L18.328 12l2.475 2.476l-2.475 2.475l2.475 2.475l-1.414 1.414l-3.889-3.89l2.475-2.474L15.5 12l2.475-2.475L15.5 7.05zm-6.503.577a.5.5 0 0 1 .113.317v15.89a.5.5 0 0 1-.817.387L6.89 15.999L3 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .704.07"/>',
    },
    "volume-vibrate-line": {
      body: '<path fill="currentColor" d="m19.39 3.161l1.413 1.414l-2.475 2.475l2.475 2.475L18.328 12l2.475 2.476l-2.475 2.475l2.475 2.475l-1.414 1.414l-3.889-3.89l2.475-2.474L15.5 12l2.475-2.475L15.5 7.05zm-6.503.577a.5.5 0 0 1 .113.317v15.89a.5.5 0 0 1-.817.387L6.89 15.999L3 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .704.07M11 7.22L7.603 9.999H4V14l3.603-.001L11 16.779z"/>',
    },
    "vuejs-fill": {
      body: '<path fill="currentColor" d="M1.001 3h4l7 12l7-12h4l-11 19zm8.667 0L12 7l2.333-4h4.035L12 14L5.633 3z"/>',
    },
    "vuejs-line": {
      body: '<path fill="currentColor" d="M3.317 3L12 18l8.684-15H23L12 22L1 3zm4.342 0L12 10.5L16.343 3h2.316L12 14.5L5.343 3z"/>',
    },
    "walk-fill": {
      body: '<path fill="currentColor" d="m7.617 8.712l3.205-2.328A2 2 0 0 1 12.065 6a2.62 2.62 0 0 1 2.427 1.82q.279.875.51 1.181A5 5 0 0 0 19 11v2a6.99 6.99 0 0 1-5.401-2.547l-.698 3.956l2.061 1.729l2.223 6.108l-1.88.684l-2.039-5.604l-3.39-2.845a2 2 0 0 1-.714-1.904l.509-2.885l-.677.492l-2.127 2.928l-1.618-1.176L7.6 8.7zM13.5 5.5a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-2.97 13.181l-3.214 3.83l-1.532-1.285l2.975-3.546l.746-2.18l1.791 1.5z"/>',
    },
    "walk-line": {
      body: '<path fill="currentColor" d="m7.617 8.712l3.205-2.328A2 2 0 0 1 12.065 6a2.62 2.62 0 0 1 2.427 1.82q.279.875.51 1.181A5 5 0 0 0 19 11v2a6.99 6.99 0 0 1-5.401-2.547l-.698 3.956l2.061 1.729l2.223 6.108l-1.88.684l-2.039-5.604l-3.39-2.845a2 2 0 0 1-.714-1.904l.509-2.885l-.677.492l-2.127 2.928l-1.618-1.176L7.6 8.7zM13.5 5.5a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-2.97 13.181l-3.214 3.83l-1.532-1.285l2.975-3.546l.746-2.18l1.791 1.5z"/>',
    },
    "wallet-2-fill": {
      body: '<path fill="currentColor" d="M22.005 8h-9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h9v4a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-7 3h3v2h-3z"/>',
    },
    "wallet-2-line": {
      body: '<path fill="currentColor" d="M20.005 7V5h-16v14h16v-2h-8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm-17-4h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m10 6v6h7V9zm2 2h3v2h-3z"/>',
    },
    "wallet-3-fill": {
      body: '<path fill="currentColor" d="M22.005 6h-7a6 6 0 0 0 0 12h7v2a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-7 2h8v8h-8a4 4 0 1 1 0-8m0 3v2h3v-2z"/>',
    },
    "wallet-3-line": {
      body: '<path fill="currentColor" d="M22.005 7h1v10h-1v3a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-2 10h-6a5 5 0 0 1 0-10h6V5h-16v14h16zm1-2V9h-7a3 3 0 1 0 0 6zm-7-4h3v2h-3z"/>',
    },
    "wallet-fill": {
      body: '<path fill="currentColor" d="M2.005 9h19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1zm1-6h15v4h-16V4a1 1 0 0 1 1-1m12 11v2h3v-2z"/>',
    },
    "wallet-line": {
      body: '<path fill="currentColor" d="M18.005 7h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h15zm-14 2v10h16V9zm0-4v2h12V5zm11 8h3v2h-3z"/>',
    },
    "water-flash-fill": {
      body: '<path fill="currentColor" d="M5.64 6.639L12.006.275l6.364 6.364A9 9 0 1 1 5.64 19.367a9 9 0 0 1 0-12.728m7.365 4.364v-4.5l-4.5 6.5h2.5v4.5l4.5-6.5z"/>',
    },
    "water-flash-line": {
      body: '<path fill="currentColor" d="m12.005 3.103l-4.95 4.95a7 7 0 1 0 9.9 0zm0-2.828l6.364 6.364A9 9 0 1 1 5.64 19.367a9 9 0 0 1 0-12.728zm1 10.728h2.5l-4.5 6.5v-4.5h-2.5l4.5-6.5z"/>',
    },
    "water-percent-fill": {
      body: '<path fill="currentColor" d="M12 .269L5.636 6.633a9 9 0 1 0 12.728 0zm4.243 9.902l-7.071 7.072l-1.415-1.415l7.072-7.07zM8.11 9.111a1.5 1.5 0 1 1 2.121 2.121A1.5 1.5 0 0 1 8.11 9.111m7.778 7.778a1.5 1.5 0 1 1-2.121-2.121a1.5 1.5 0 0 1 2.121 2.12"/>',
    },
    "water-percent-line": {
      body: '<path fill="currentColor" d="M7.05 8.047L12 3.097l4.95 4.95a7 7 0 1 1-9.9 0m11.314-1.414L12 .269L5.636 6.633a9 9 0 1 0 12.728 0m-2.121 3.538l-1.414-1.414l-7.072 7.071l1.415 1.415zM8.11 11.232a1.5 1.5 0 1 0 2.121-2.121a1.5 1.5 0 0 0-2.121 2.121m7.778 5.657a1.5 1.5 0 1 1-2.121-2.121a1.5 1.5 0 0 1 2.121 2.12"/>',
    },
    "webcam-fill": {
      body: '<path fill="currentColor" d="M11 21v-1.07A7 7 0 0 1 5 13V8a7 7 0 0 1 14 0v5a7 7 0 0 1-6 6.93V21h4v2H7v-2zm1-12a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0 2a3 3 0 1 0 0-6a3 3 0 0 0 0 6"/>',
    },
    "webcam-line": {
      body: '<path fill="currentColor" d="M11 21v-1.07A7 7 0 0 1 5 13V8a7 7 0 0 1 14 0v5a7 7 0 0 1-6 6.93V21h4v2H7v-2zm1-18a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0V8a5 5 0 0 0-5-5m0 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/>',
    },
    "webhook-fill": {
      body: '<path fill="currentColor" d="M13.501 4.399a3 3 0 0 1 1.382 3.436l1.92.56A5.002 5.002 0 0 0 7.67 4.498a5 5 0 0 0 1.014 6.243L6.803 14H6.8a2 2 0 1 0 1.946 1.537c-.082-.347-.102-.725.076-1.034l2.545-4.408l-.866-.5a3 3 0 0 1 3-5.196m1.53 13.681a3.001 3.001 0 0 0 4.765-3.576a3 3 0 0 0-4.098-1.098l-.866.5l-2.546-4.41c-.178-.308-.515-.48-.857-.582a2.003 2.003 0 0 1-1.16-2.917a2 2 0 0 1 3.464 2L13.731 8l1.883 3.26a5.002 5.002 0 0 1 4.084 9.074a5 5 0 0 1-6.112-.872zM3.8 16c0-1.409.973-2.594 2.285-2.914l-.475-1.943A5.002 5.002 0 0 0 6.8 21a5 5 0 0 0 4.9-4h3.764l.002.004a2 2 0 1 0 .358-2.454c-.26.245-.577.45-.934.45H9.8v1a3 3 0 1 1-6 0"/>',
    },
    "webhook-line": {
      body: '<path fill="currentColor" d="M8.869 14.14c-.213.351-.319.638-.149 1.085c.47 1.236-.193 2.439-1.439 2.766c-1.175.308-2.32-.465-2.554-1.723c-.207-1.114.658-2.206 1.886-2.38c.067-.01.134-.014.22-.02q.07-.003.16-.01l1.869-3.132c-1.175-1.169-1.874-2.534-1.72-4.227c.11-1.196.58-2.23 1.44-3.077a4.89 4.89 0 0 1 6.098-.64c1.862 1.196 2.715 3.527 1.988 5.521l-1.707-.463c.229-1.109.06-2.105-.688-2.958c-.494-.563-1.128-.858-1.85-.967c-1.445-.218-2.864.71-3.285 2.129c-.478 1.61.246 2.925 2.222 3.916c-.829 1.394-1.651 2.792-2.491 4.18m4.915-5.867l1.806 3.186c3.041-.94 5.334.743 6.156 2.545c.994 2.177.315 4.755-1.637 6.098c-2.002 1.379-4.535 1.143-6.31-.628l1.393-1.165c1.752 1.136 3.285 1.082 4.423-.262a3.05 3.05 0 0 0-.05-3.979c-1.151-1.295-2.695-1.335-4.56-.091c-.775-1.373-1.562-2.736-2.311-4.119c-.253-.466-.532-.736-1.102-.835c-.95-.165-1.565-.981-1.602-1.897a2.08 2.08 0 0 1 1.33-2.041a2.075 2.075 0 0 1 2.35.64c.454.574.598 1.22.36 1.927a7 7 0 0 1-.159.407zm-2.232 8.622h3.66q.077.102.146.2c.097.138.19.268.297.384a2.07 2.07 0 0 0 2.913.1a2.074 2.074 0 0 0 .086-2.969c-.794-.814-2.151-.892-2.889-.03c-.447.524-.906.586-1.5.577c-1.524-.024-3.047-.008-4.57-.008c.1 2.142-.71 3.476-2.317 3.793c-1.572.31-3.02-.492-3.53-1.956c-.58-1.663.137-2.994 2.206-4.05l-.469-1.7c-2.255.492-3.948 2.68-3.773 5.142c.155 2.173 1.908 4.104 4.052 4.45a4.88 4.88 0 0 0 3.273-.584c1.306-.74 2.064-1.906 2.415-3.349"/>',
    },
    "wechat-2-fill": {
      body: '<path fill="currentColor" d="M5.458 18.185C3.359 16.677 2 14.4 2 11.908C2 7.323 6.475 3.6 12 3.6s10 3.723 10 8.308c0 4.584-4.475 8.308-10 8.308a11.4 11.4 0 0 1-3.272-.462c-.092-.03-.216-.03-.308-.03c-.185 0-.37.06-.525.153l-2.191 1.262c-.062.03-.124.061-.186.061a.34.34 0 0 1-.339-.338c0-.093.03-.154.062-.246c.03-.031.308-1.047.463-1.662c0-.062.03-.154.03-.215q0-.37-.277-.554m3.21-7.673c.717 0 1.285-.569 1.285-1.286S9.385 7.94 8.668 7.94s-1.285.568-1.285 1.286c0 .717.567 1.285 1.285 1.285m6.666 0c.718 0 1.285-.569 1.285-1.286s-.567-1.286-1.285-1.286c-.717 0-1.285.568-1.285 1.286c0 .717.568 1.285 1.285 1.285"/>',
    },
    "wechat-2-line": {
      body: '<path fill="currentColor" d="M8.667 11.511a1.276 1.276 0 0 1-1.285-1.285c0-.718.568-1.286 1.285-1.286c.718 0 1.285.568 1.285 1.286c0 .717-.567 1.285-1.285 1.285m6.667 0a1.276 1.276 0 0 1-1.285-1.285c0-.718.568-1.286 1.285-1.286s1.285.568 1.285 1.286c0 .717-.568 1.285-1.285 1.285m-8.511 7.704l.715-.436a4 4 0 0 1 2.706-.536q.317.05.52.076q.61.081 1.237.081c4.42 0 7.9-3.022 7.9-6.6S16.42 5.2 12 5.2c-4.421 0-7.9 3.022-7.9 6.6c0 1.365.5 2.673 1.431 3.78q.073.088.215.236a4 4 0 0 1 1.1 3.102zm-.63 2.727a1 1 0 0 1-1.527-.93l.189-2.26a2 2 0 0 0-.55-1.551a7 7 0 0 1-.303-.333C2.806 15.447 2.1 13.695 2.1 11.8c0-4.75 4.432-8.6 9.9-8.6c5.467 0 9.9 3.85 9.9 8.6s-4.433 8.6-9.9 8.6q-.765-.001-1.5-.098q-.229-.03-.568-.084a2 2 0 0 0-1.353.268z"/>',
    },
    "wechat-channels-fill": {
      body: '<path fill="currentColor" d="M19.194 3.181c1.162-.47 2.155-.019 2.672 1.277C23.26 7.944 20 21.133 17.441 21.133c-.828 0-1.657-.688-2.624-1.926a23 23 0 0 1-1.357-1.974c-.374-.6-.742-1.232-1.095-1.87L12 14.69l-.018.032a44 44 0 0 1-1.442 2.511c-.467.75-.922 1.416-1.358 1.974c-.966 1.238-1.795 1.926-2.623 1.926C4 21.133.74 7.943 2.133 4.458C2.651 3.162 3.644 2.71 4.806 3.18c.842.34 1.772 1.156 2.81 2.376A32 32 0 0 1 9.548 8.11a59 59 0 0 1 2.137 3.36l.316.538l.316-.538a62 62 0 0 1 1.696-2.71l.44-.65a32 32 0 0 1 1.931-2.553c1.039-1.22 1.968-2.035 2.81-2.376M4.324 4.353c-.49-.199-.743-.084-1.005.57c-.457 1.145-.265 4.028.413 7.264l.158.724l.174.733c.856 3.46 2.087 6.224 2.495 6.224c.28 0 .889-.506 1.615-1.436c.405-.518.835-1.148 1.28-1.863c.362-.581.72-1.194 1.063-1.816l.415-.767l.348-.671l-.364-.638l-.332-.566a58 58 0 0 0-2.09-3.287a31 31 0 0 0-1.852-2.45c-.916-1.077-1.716-1.778-2.318-2.021m16.356.57c-.261-.654-.514-.769-1.005-.57c-.602.243-1.402.944-2.317 2.02a31 31 0 0 0-1.852 2.45a56 56 0 0 0-1.687 2.615l-.574.962l-.527.915l.181.35l.245.465a43 43 0 0 0 1.401 2.438a22 22 0 0 0 1.28 1.864c.727.93 1.336 1.436 1.616 1.436c.408 0 1.639-2.763 2.494-6.224l.174-.733c.805-3.523 1.063-6.758.571-7.987"/>',
    },
    "wechat-channels-line": {
      body: '<path fill="currentColor" d="M6.66 18.964a2 2 0 0 1-.155-.21c-.238-.353-.515-.905-.805-1.627c-.575-1.432-1.138-3.372-1.536-5.326c-.4-1.965-.616-3.869-.537-5.244c.04-.7.153-1.161.283-1.416A.7.7 0 0 1 4.002 5c.292 0 .74.162 1.356.651c.6.476 1.25 1.174 1.927 2.032c1.236 1.565 2.464 3.532 3.552 5.326c-.18.315-.37.66-.565 1.014l-.278.502A38 38 0 0 1 8.67 16.77c-.465.715-.918 1.312-1.344 1.72c-.3.289-.52.42-.665.474M12 11.076c-.962-1.562-2.042-3.236-3.145-4.632c-.721-.914-1.481-1.747-2.254-2.36C5.846 3.486 4.959 3 4.001 3c-.923 0-1.537.57-1.874 1.234c-.315.62-.45 1.408-.496 2.209c-.094 1.625.16 3.721.573 5.756c.416 2.046 1.01 4.106 1.64 5.674c.313.778.65 1.476 1 1.997c.175.26.378.514.614.713c.225.192.582.417 1.042.417c.895 0 1.648-.526 2.211-1.067c.589-.565 1.14-1.31 1.636-2.073c.5-.77.973-1.603 1.396-2.364l.249-.45l.024.045l.21.393c.41.76.867 1.595 1.358 2.367c.486.766 1.035 1.518 1.639 2.088C15.812 20.495 16.58 21 17.5 21c.46 0 .817-.226 1.043-.417c.235-.2.439-.453.613-.712c.35-.522.688-1.22 1-1.998c.63-1.568 1.224-3.628 1.64-5.674c.414-2.034.668-4.131.574-5.756c-.046-.8-.18-1.589-.496-2.209C21.536 3.57 20.924 3 20 3c-.958 0-1.846.485-2.6 1.084c-.773.613-1.533 1.446-2.255 2.36c-1.102 1.396-2.183 3.07-3.145 4.632m1.162 1.935c1.089-1.795 2.317-3.763 3.553-5.328c.677-.857 1.327-1.556 1.927-2.032c.617-.49 1.064-.65 1.356-.651l.02.022a.7.7 0 0 1 .073.119c.13.255.242.717.282 1.416c.08 1.375-.137 3.279-.537 5.244c-.397 1.954-.96 3.894-1.536 5.326c-.29.722-.566 1.274-.804 1.628q-.099.144-.164.218c-.173-.052-.417-.186-.736-.488c-.426-.403-.871-.994-1.324-1.706a36 36 0 0 1-1.283-2.242q-.102-.188-.2-.374c-.216-.401-.426-.795-.627-1.152"/>',
    },
    "wechat-fill": {
      body: '<path fill="currentColor" d="M18.575 13.711a.91.91 0 0 0 .898-.898a.895.895 0 0 0-.898-.898a.894.894 0 0 0-.898.898c0 .5.4.898.898.898m-4.425 0a.91.91 0 0 0 .898-.898c0-.498-.4-.898-.898-.898a.894.894 0 0 0-.898.898c0 .5.399.898.898.898m6.567 5.04a.35.35 0 0 0-.172.37c0 .048 0 .098.025.147c.098.417.294 1.081.294 1.106c0 .073.025.122.025.172a.22.22 0 0 1-.221.22c-.05 0-.074-.024-.123-.048l-1.449-.836a.8.8 0 0 0-.344-.098c-.073 0-.147 0-.196.024c-.688.197-1.4.295-2.161.295c-3.66 0-6.607-2.457-6.607-5.505s2.947-5.505 6.607-5.505c3.659 0 6.606 2.458 6.606 5.505c0 1.647-.884 3.146-2.284 4.154M16.674 8.099a9 9 0 0 0-.28-.005c-4.174 0-7.606 2.86-7.606 6.505c0 .554.08 1.09.228 1.6h-.089a10 10 0 0 1-2.584-.368c-.074-.025-.148-.025-.222-.025a.83.83 0 0 0-.419.123l-1.747 1.005a.35.35 0 0 1-.148.05a.273.273 0 0 1-.27-.27c0-.074.024-.123.049-.197c.024-.024.246-.834.369-1.324c0-.05.024-.123.024-.172a.56.56 0 0 0-.221-.441C2.059 13.376 1 11.586 1 9.599C1.001 5.944 4.571 3 8.951 3c3.765 0 6.93 2.169 7.723 5.098m-5.154.418c.573 0 1.026-.477 1.026-1.026c0-.573-.453-1.026-1.026-1.026s-1.026.453-1.026 1.026s.453 1.026 1.026 1.026m-5.26 0c.573 0 1.027-.477 1.027-1.026c0-.573-.454-1.026-1.027-1.026c-.572 0-1.026.453-1.026 1.026s.454 1.026 1.026 1.026"/>',
    },
    "wechat-line": {
      body: '<path fill="currentColor" d="M10.001 14.676v-.062c0-2.509 2.017-4.618 4.753-5.233C14.39 7.079 11.96 5.2 8.9 5.2C5.58 5.2 3 7.413 3 9.98c0 .969.36 1.9 1.04 2.698q.048.058.152.165a3.57 3.57 0 0 1 1.002 2.238a3.6 3.6 0 0 1 2.363-.442q.25.039.405.06A7.3 7.3 0 0 0 10 14.676m.457 1.951a9.2 9.2 0 0 1-2.753.055a19 19 0 0 1-.454-.067a1.6 1.6 0 0 0-1.08.212l-1.904 1.147a.8.8 0 0 1-.49.118a.79.79 0 0 1-.729-.851l.15-1.781a1.57 1.57 0 0 0-.439-1.223a6 6 0 0 1-.241-.262C1.563 12.855 1 11.473 1 9.979C1 6.235 4.537 3.2 8.9 3.2c4.06 0 7.403 2.627 7.85 6.008c3.371.153 6.05 2.515 6.05 5.406c0 1.193-.456 2.296-1.229 3.19q-.076.09-.195.21a1.24 1.24 0 0 0-.356.976l.121 1.423a.635.635 0 0 1-.59.68a.66.66 0 0 1-.396-.094l-1.544-.917a1.32 1.32 0 0 0-.874-.169q-.22.034-.368.053q-.475.061-.969.062c-2.694 0-4.998-1.408-5.943-3.401m6.977 1.31a3.3 3.3 0 0 1 1.675.174a3.25 3.25 0 0 1 .842-1.502q.076-.077.106-.112c.489-.565.743-1.213.743-1.883c0-1.805-1.903-3.414-4.4-3.414S12 12.81 12 14.614s1.903 3.414 4.4 3.414a6 6 0 0 0 .714-.046q.121-.015.32-.046"/>',
    },
    "wechat-pay-fill": {
      body: '<path fill="currentColor" d="M9.271 14.669a.66.66 0 0 1-.88-.269l-.043-.095l-1.818-3.998a.5.5 0 0 1 0-.146a.327.327 0 0 1 .335-.327a.3.3 0 0 1 .196.066l2.18 1.527a1 1 0 0 0 .546.167a.9.9 0 0 0 .342-.066l10.047-4.5a10.73 10.73 0 0 0-8.171-3.526C6.479 3.502 2 7.232 2 11.87a7.83 7.83 0 0 0 3.46 6.296a.66.66 0 0 1 .24.727l-.45 1.701a1 1 0 0 0-.051.24a.327.327 0 0 0 .334.334a.4.4 0 0 0 .19-.058l2.18-1.265c.16-.098.343-.151.53-.152q.15 0 .292.043c1.062.3 2.16.452 3.264.45c5.525 0 10.011-3.729 10.011-8.33a7.23 7.23 0 0 0-1.098-3.883L9.351 14.625z"/>',
    },
    "wechat-pay-line": {
      body: '<path fill="currentColor" d="m19.146 8.993l-9.799 5.608l-.07.045a.65.65 0 0 1-.3.07a.66.66 0 0 1-.58-.345l-.046-.092l-1.831-3.95c-.023-.046-.023-.092-.023-.138c0-.184.139-.321.324-.321q.105 0 .209.069l2.155 1.515c.162.092.347.161.556.161a.9.9 0 0 0 .348-.069l8.274-3.649C16.935 6.273 14.635 5.2 12.001 5.2c-4.421 0-7.9 3.022-7.9 6.6c0 1.365.5 2.673 1.431 3.78q.073.088.215.236a4 4 0 0 1 1.1 3.102l-.024.297l.715-.436a4 4 0 0 1 2.706-.536q.317.05.52.076q.61.081 1.237.081c4.42 0 7.9-3.022 7.9-6.6c0-.996-.27-1.95-.755-2.807M6.193 21.943a1 1 0 0 1-1.527-.932l.189-2.259a2 2 0 0 0-.55-1.551a7 7 0 0 1-.303-.333C2.806 15.447 2.1 13.695 2.1 11.8c0-4.75 4.432-8.6 9.9-8.6c5.467 0 9.9 3.85 9.9 8.6s-4.433 8.6-9.9 8.6q-.765-.001-1.5-.098q-.229-.03-.568-.084a2 2 0 0 0-1.353.268z"/>',
    },
    "weibo-fill": {
      body: '<path fill="currentColor" d="M4.278 8.592c2.773-2.77 6.004-4.033 7.219-2.816c.537.537.588 1.464.244 2.572c-.178.557.524.25.524.25c2.241-.938 4.197-.994 4.91.027c.38.542.343 1.306-.008 2.19c-.163.407.048.47.36.563c1.262.392 2.668 1.336 2.668 3.004c0 2.763-3.98 6.239-9.964 6.239c-4.565 0-9.23-2.213-9.23-5.852c0-1.902 1.204-4.102 3.277-6.177m12.133 5.742c-.237-2.391-3.382-4.039-7.023-3.677c-3.64.359-6.403 2.59-6.167 4.98c.237 2.394 3.382 4.039 7.023 3.68c3.641-.362 6.401-2.592 6.167-4.983m-10.249.104c.754-1.528 2.712-2.39 4.446-1.94c1.792.463 2.707 2.154 1.976 3.799c-.744 1.683-2.883 2.58-4.695 1.994c-1.752-.566-2.493-2.295-1.727-3.853m2.715.578c-.563-.237-1.291.008-1.64.553c-.354.547-.189 1.201.371 1.456c.568.257 1.325.013 1.676-.55c.346-.568.163-1.217-.408-1.459m1.387-.578c-.216-.084-.486.018-.613.232c-.123.214-.054.458.163.547c.219.092.501-.012.628-.231c.123-.22.044-.466-.178-.548m5.694-11.514A5.83 5.83 0 0 1 21.5 4.72a5.84 5.84 0 0 1 1.22 5.704a.84.84 0 0 1-1.06.54a.844.844 0 0 1-.542-1.062a4.142 4.142 0 0 0-4.808-5.327a.845.845 0 0 1-.353-1.65m.626 2.926a2.836 2.836 0 0 1 3.29 3.648a.725.725 0 1 1-1.378-.45a1.38 1.38 0 0 0-.287-1.357a1.4 1.4 0 0 0-1.322-.426a.723.723 0 1 1-.303-1.415"/>',
    },
    "weibo-line": {
      body: '<path fill="currentColor" d="M20.195 14.197c0 3.362-4.53 6.424-9.926 6.424c-4.95 0-9.268-2.432-9.268-6.087c0-1.947 1.18-4.087 3.24-6.088C7.072 5.7 10.47 4.413 12.098 5.998c.498.482.723 1.122.719 1.858c1.975-.576 3.65-.404 4.483.752c.449.623.532 1.38.326 2.207c1.511.61 2.568 1.77 2.568 3.382m-4.44-2.07c-.386-.41-.4-.92-.198-1.41c.208-.508.213-.812.12-.94c-.264-.368-1.533-.363-3.194.311a2 2 0 0 1-.509.14c-.344.046-.671.001-.983-.265c-.419-.359-.473-.855-.322-1.316c.214-.67.18-1.076.037-1.215c-.186-.18-.777-.191-1.659.143C7.978 7.98 6.75 8.799 5.633 9.88c-1.707 1.659-2.632 3.337-2.632 4.653c0 2.242 3.276 4.087 7.268 4.087c4.42 0 7.926-2.37 7.926-4.424c0-.738-.637-1.338-1.673-1.652c-.394-.113-.536-.171-.767-.417m7.054-1.617a1 1 0 1 1-1.936-.502a4 4 0 0 0-4.693-4.924a1 1 0 0 1-.407-1.958a6 6 0 0 1 7.036 7.384"/>',
    },
    "weight-fill": {
      body: '<path fill="currentColor" d="M14 6a2 2 0 1 1-4 0a2 2 0 0 1 4 0m1.465 2a4 4 0 1 0-6.93 0H5.066a1 1 0 0 0-.986.832l-1.88 11A1 1 0 0 0 3.186 21h17.629a1 1 0 0 0 .986-1.169l-1.88-11A1 1 0 0 0 18.934 8z"/>',
    },
    "weight-line": {
      body: '<path fill="currentColor" d="M14 6a2 2 0 1 1-4 0a2 2 0 0 1 4 0m1.465 2a4 4 0 1 0-6.93 0H5.066a1 1 0 0 0-.986.832l-1.88 11A1 1 0 0 0 3.186 21h17.629a1 1 0 0 0 .986-1.169l-1.88-11A1 1 0 0 0 18.934 8zM12 10h6.091l1.538 9H4.372l1.539-9z"/>',
    },
    "whatsapp-fill": {
      body: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.95 9.95 0 0 1-5.03-1.355L2.005 22l1.352-4.968A9.95 9.95 0 0 1 2.001 12c0-5.523 4.477-10 10-10M8.593 7.3l-.2.008a1 1 0 0 0-.372.1a1.3 1.3 0 0 0-.294.228c-.12.113-.188.211-.261.306A2.73 2.73 0 0 0 6.9 9.62c.002.49.13.967.33 1.413c.409.902 1.082 1.857 1.97 2.742c.214.213.424.427.65.626a9.45 9.45 0 0 0 3.84 2.046l.568.087c.185.01.37-.004.556-.013a2 2 0 0 0 .833-.231a5 5 0 0 0 .383-.22q.001.002.125-.09c.135-.1.218-.171.33-.288q.126-.13.21-.302c.078-.163.156-.474.188-.733c.024-.198.017-.306.014-.373c-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.402-.621a.5.5 0 0 0-.176-.041a.48.48 0 0 0-.378.127c-.005-.002-.072.055-.795.931a.35.35 0 0 1-.368.13a1.4 1.4 0 0 1-.191-.066c-.124-.052-.167-.072-.252-.108a6 6 0 0 1-1.575-1.003c-.126-.11-.243-.23-.363-.346a6.3 6.3 0 0 1-1.02-1.268l-.059-.095a1 1 0 0 1-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41c.11-.14.203-.276.263-.373c.118-.19.155-.385.093-.536q-.42-1.026-.868-2.041c-.059-.134-.234-.23-.393-.249q-.081-.01-.162-.016a3 3 0 0 0-.403.004z"/>',
    },
    "whatsapp-line": {
      body: '<path fill="currentColor" d="m7.254 18.494l.724.423A7.95 7.95 0 0 0 12.001 20a8 8 0 1 0-8-8a7.95 7.95 0 0 0 1.084 4.024l.422.724l-.653 2.401zM2.005 22l1.352-4.968A9.95 9.95 0 0 1 2.001 12c0-5.523 4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10a9.95 9.95 0 0 1-5.03-1.355zM8.392 7.308q.202-.014.403-.004q.081.006.162.016c.159.018.334.115.393.249q.447 1.015.868 2.04c.062.152.025.347-.093.537c-.06.097-.154.233-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268c.12.116.237.235.363.346c.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11q.093.039.191.066q.036.01.073.011a.35.35 0 0 0 .295-.142c.723-.876.79-.933.795-.933v.002a.48.48 0 0 1 .378-.127q.092.004.177.04c.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265c.004.067.01.175-.013.373c-.032.259-.11.57-.188.733a1.2 1.2 0 0 1-.21.302a2.4 2.4 0 0 1-.33.288q-.124.092-.125.09a5 5 0 0 1-.383.22a2 2 0 0 1-.833.23c-.185.01-.37.024-.556.014c-.008 0-.568-.087-.568-.087a9.45 9.45 0 0 1-3.84-2.046c-.226-.199-.436-.413-.65-.626c-.888-.885-1.561-1.84-1.97-2.742a3.5 3.5 0 0 1-.33-1.413a2.73 2.73 0 0 1 .565-1.68c.073-.094.142-.192.261-.305c.126-.12.207-.184.294-.228a1 1 0 0 1 .371-.1"/>',
    },
    "wheelchair-fill": {
      body: '<path fill="currentColor" d="M7.998 10.341v2.194A4 4 0 1 0 13.463 18h2.193a6 6 0 1 1-7.658-7.66m4 6.659a3 3 0 0 1-3-3v-4a3 3 0 1 1 6 0v5h1.434a2 2 0 0 1 1.626.836l.089.135l2.709 4.514l-1.715 1.03L16.43 17zm0-15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5"/>',
    },
    "wheelchair-line": {
      body: '<path fill="currentColor" d="M7.998 10.341v2.194A4 4 0 1 0 13.463 18h2.193a6 6 0 1 1-7.658-7.66m4 6.659a3 3 0 0 1-3-3v-4c0-1.044.534-1.964 1.343-2.501a3 3 0 1 1 3.314.003A2.99 2.99 0 0 1 14.998 10v4.999l1.434.001a2 2 0 0 1 1.626.836l.089.135l2.709 4.514l-1.715 1.03L16.43 17l-1.433-.001zm0-8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.999l.001-5a1 1 0 0 0-1-1m0-5a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/>',
    },
    "wifi-fill": {
      body: '<path fill="currentColor" d="M.69 6.997A17.93 17.93 0 0 1 12 3c4.285 0 8.22 1.497 11.31 3.997L21.425 9.33A14.94 14.94 0 0 0 12 6C8.43 6 5.15 7.248 2.575 9.33zm3.141 3.89A12.95 12.95 0 0 1 12 8a12.95 12.95 0 0 1 8.169 2.886l-1.886 2.334A9.96 9.96 0 0 0 12 11c-2.38 0-4.567.832-6.284 2.22zm3.142 3.89A7.97 7.97 0 0 1 12 13c1.904 0 3.653.665 5.027 1.776l-1.885 2.334A4.98 4.98 0 0 0 12 16c-1.19 0-2.283.416-3.142 1.11zm3.142 3.89A3 3 0 0 1 12 18c.714 0 1.37.25 1.885.666L12 21z"/>',
    },
    "wifi-line": {
      body: '<path fill="currentColor" d="M.69 6.997A17.93 17.93 0 0 1 12 3c4.285 0 8.22 1.497 11.31 3.997l-1.256 1.556A15.93 15.93 0 0 0 12 5C8.19 5 4.694 6.33 1.946 8.553zm3.141 3.89A12.95 12.95 0 0 1 12 8a12.95 12.95 0 0 1 8.169 2.886l-1.257 1.556A10.95 10.95 0 0 0 12 10c-2.618 0-5.023.915-6.912 2.442zm3.142 3.89A7.97 7.97 0 0 1 12 13c1.904 0 3.653.665 5.027 1.776l-1.257 1.556A5.98 5.98 0 0 0 12 15c-1.428 0-2.74.499-3.77 1.332zm3.142 3.89A3 3 0 0 1 12 18c.714 0 1.37.25 1.885.666L12 21z"/>',
    },
    "wifi-off-fill": {
      body: '<path fill="currentColor" d="M12 18c.714 0 1.37.25 1.886.666L12 21l-1.886-2.334A3 3 0 0 1 12 18M2.808 1.393l17.677 17.678l-1.414 1.414l-3.682-3.68l-.246.306A4.98 4.98 0 0 0 12 16c-1.19 0-2.283.416-3.141 1.11l-1.885-2.334a7.96 7.96 0 0 1 4.622-1.766l-1.773-1.772a9.96 9.96 0 0 0-4.106 1.982L3.83 10.887A13 13 0 0 1 7.416 8.83L5.885 7.3a15 15 0 0 0-3.31 2.031L.689 6.997a18 18 0 0 1 2.952-1.942L1.393 2.808zM16.084 11.87l-3.867-3.867L12 8c3.095 0 5.937 1.081 8.17 2.887l-1.886 2.333a10 10 0 0 0-2.2-1.35M12 3a17.92 17.92 0 0 1 11.31 3.998L21.426 9.33A14.94 14.94 0 0 0 12 6q-.858 0-1.69.094L7.724 3.511A18 18 0 0 1 12 3"/>',
    },
    "wifi-off-line": {
      body: '<path fill="currentColor" d="M12 18c.714 0 1.37.25 1.886.666L12 21l-1.886-2.334A3 3 0 0 1 12 18M2.808 1.393l17.677 17.678l-1.414 1.414l-5.18-5.18a6 6 0 0 0-1.89-.305c-1.43 0-2.74.499-3.771 1.332l-1.256-1.556a7.96 7.96 0 0 1 4.622-1.766L9 10.414a11 11 0 0 0-3.912 2.029L3.83 10.887A13 13 0 0 1 7.416 8.83L5.132 6.545a16 16 0 0 0-3.185 2.007L.689 6.997a18 18 0 0 1 2.952-1.942L1.393 2.808zM14.5 10.285l-2.283-2.283L12 8c3.095 0 5.937 1.081 8.17 2.887l-1.258 1.556a10.96 10.96 0 0 0-4.412-2.158M12 3c4.285 0 8.22 1.497 11.31 3.997l-1.257 1.555A15.93 15.93 0 0 0 12 5q-1.319 0-2.58.207L7.726 3.51A18 18 0 0 1 12 3"/>',
    },
    "window-2-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m17 7H4v9h16zm-5-4v2h4V6z"/>',
    },
    "window-2-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 8H4v8h16zm0-6H4v4h16zm-1 1v2h-4V6z"/>',
    },
    "window-fill": {
      body: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m17 7H4v9h16zM5 6v2h2V6zm4 0v2h2V6z"/>',
    },
    "window-line": {
      body: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 8H4v8h16zm0-6H4v4h16zm-9 1v2H9V6zM7 6v2H5V6z"/>',
    },
    "windows-fill": {
      body: '<path fill="currentColor" d="m3.001 5.479l7.377-1.016v7.127H3zm0 13.042l7.377 1.017v-7.04H3zm8.188 1.125L21.001 21v-8.502h-9.812zm0-15.292v7.236h9.812V3z"/>',
    },
    "windows-line": {
      body: '<path fill="currentColor" d="M21.001 2.5v19l-18-2v-15zm-2 10.499l-7 .001v5.487l7 .779zm-14 4.71l5 .556V13l-5-.001zm14-6.71V4.735l-7 .777V11zm-9-5.265l-5 .556V11l5 .001z"/>',
    },
    "windy-fill": {
      body: '<path fill="currentColor" d="M10.5 17H4v-2h6.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 10.5 17M5 11h13.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 18.5 13H5a3 3 0 1 1 0-6h8.5a1.5 1.5 0 1 0-1.405-2.027l-1.873-.702A3.501 3.501 0 0 1 17 5.5A3.5 3.5 0 0 1 13.5 9H5a1 1 0 0 0 0 2"/>',
    },
    "windy-line": {
      body: '<path fill="currentColor" d="M10.5 17H4v-2h6.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 10.5 17M5 11h13.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 18.5 13H5a3 3 0 1 1 0-6h8.5a1.5 1.5 0 1 0-1.405-2.027l-1.873-.702A3.501 3.501 0 0 1 17 5.5A3.5 3.5 0 0 1 13.5 9H5a1 1 0 0 0 0 2"/>',
    },
    "wireless-charging-fill": {
      body: '<path fill="currentColor" d="m3.929 4.929l1.414 1.414A7.98 7.98 0 0 0 3 12c0 2.21.895 4.21 2.343 5.657L3.93 19.07A9.97 9.97 0 0 1 1 12a9.97 9.97 0 0 1 2.929-7.071m16.142 0A9.97 9.97 0 0 1 23 12a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A7.98 7.98 0 0 0 21 12a7.98 7.98 0 0 0-2.342-5.656zM13 5v6h3l-5 8v-6H8zM6.757 7.757l1.415 1.415A4 4 0 0 0 7 12c0 1.104.448 2.105 1.172 2.828l-1.415 1.415A5.98 5.98 0 0 1 5 12c0-1.657.672-3.157 1.757-4.243m10.487.001A5.98 5.98 0 0 1 19 12a5.98 5.98 0 0 1-1.757 4.243l-1.415-1.415A4 4 0 0 0 17 12a4 4 0 0 0-1.17-2.827z"/>',
    },
    "wireless-charging-line": {
      body: '<path fill="currentColor" d="m3.929 4.929l1.414 1.414A7.98 7.98 0 0 0 3 12c0 2.21.895 4.21 2.343 5.657L3.93 19.07A9.97 9.97 0 0 1 1 12.001a9.97 9.97 0 0 1 2.929-7.072m16.142 0A9.97 9.97 0 0 1 23 12a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A7.98 7.98 0 0 0 21 12a7.98 7.98 0 0 0-2.342-5.656zM13 5v6h3l-5 8v-6H8zM6.757 7.757l1.415 1.415A4 4 0 0 0 7 12c0 1.105.448 2.105 1.172 2.829l-1.415 1.414A5.98 5.98 0 0 1 5 12c0-1.657.672-3.157 1.757-4.243m10.487.001A5.98 5.98 0 0 1 19 12a5.98 5.98 0 0 1-1.757 4.243l-1.415-1.414A4 4 0 0 0 17 12a4 4 0 0 0-1.17-2.827z"/>',
    },
    "women-fill": {
      body: '<path fill="currentColor" d="M11 15.934A7.501 7.501 0 0 1 12 1a7.5 7.5 0 0 1 1 14.934V18h5v2h-5v4h-2v-4H6v-2h5z"/>',
    },
    "women-line": {
      body: '<path fill="currentColor" d="M11 15.934A7.501 7.501 0 0 1 12 1a7.5 7.5 0 0 1 1 14.934V18h5v2h-5v4h-2v-4H6v-2h5zM12 14a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11"/>',
    },
    "wordpress-fill": {
      body: '<path fill="currentColor" d="M3.323 12c0 3.438 2 6.4 4.892 7.808L4.077 8.469A8.65 8.65 0 0 0 3.323 12M12 20.677a8.8 8.8 0 0 0 2.885-.492l-.062-.116l-2.67-7.307l-2.6 7.561c.77.23 1.593.354 2.447.354M13.192 7.93l3.139 9.33l.869-2.892c.37-1.2.654-2.061.654-2.807c0-1.077-.385-1.816-.708-2.385c-.446-.723-.854-1.33-.854-2.039c0-.8.6-1.538 1.462-1.538h.107A8.65 8.65 0 0 0 12 3.323a8.67 8.67 0 0 0-7.246 3.908l.554.015c.907 0 2.307-.115 2.307-.115c.477-.023.531.661.062.715c0 0-.47.062-1 .085l3.17 9.4l1.9-5.692l-1.355-3.708a16 16 0 0 1-.907-.077c-.47-.03-.416-.746.053-.723c0 0 1.431.115 2.285.115c.908 0 2.308-.115 2.308-.115c.469-.023.53.661.061.715c0 0-.469.054-1 .085m3.17 11.569a8.676 8.676 0 0 0 3.253-11.662a8.2 8.2 0 0 1-.6 4zM12 22a10 10 0 1 1 0-20a10 10 0 0 1 0 20"/>',
    },
    "wordpress-line": {
      body: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-7.394 7.566l-2.155-5.985l-2.181 6.232a8.03 8.03 0 0 0 4.336-.247m2.468-1.38A7.98 7.98 0 0 0 20 12a8 8 0 0 0-.545-2.908c-.25 1.454-.692 3.35-.976 4.315zm-.201-12.531A7.97 7.97 0 0 0 12 4a7.99 7.99 0 0 0-6.245 3h1.39v2h-.75l2.755 7.958l2.227-6.362L10.802 9H8.645V7h5v2h-.717l2.621 7.282l1.012-3.44c.523-1.832.092-2.631-.339-3.429c-.289-.534-.577-1.068-.577-1.913a2 2 0 0 1 1.228-1.845M4.425 9.42A8 8 0 0 0 4 12a8 8 0 0 0 3.64 6.708z"/>',
    },
    "wubi-input": {
      body: '<path fill="currentColor" d="M3 21v-2h3.662l1.234-7H5v-2h3.249l.881-5H4V3h16v2h-8.839l-.882 5H18v9h3v2zm13-9H9.927l-1.235 7H16z"/>',
    },
    "xbox-fill": {
      body: '<path fill="currentColor" d="M5.42 19.528A9.96 9.96 0 0 0 12 22a9.97 9.97 0 0 0 6.585-2.472c1.564-1.594-3.597-7.258-6.585-9.515c-2.985 2.257-8.15 7.921-6.582 9.515m9.3-12.005c2.083 2.467 6.236 8.594 5.063 10.76A9.95 9.95 0 0 0 22 12.002a9.96 9.96 0 0 0-2.975-7.113s-.023-.018-.068-.035a.7.7 0 0 0-.234-.038c-.494 0-1.655.362-4.005 2.706M5.045 4.855c-.048.017-.068.034-.072.035A9.96 9.96 0 0 0 2 12.003c0 2.379.832 4.561 2.217 6.278C3.051 16.11 7.201 9.988 9.285 7.523C6.935 5.178 5.772 4.818 5.28 4.818a.6.6 0 0 0-.234.039zM12 4.959S9.546 3.523 7.63 3.455c-.753-.027-1.213.246-1.268.282C8.15 2.539 10.05 2 11.988 2H12c1.945 0 3.838.538 5.638 1.737c-.056-.038-.512-.31-1.266-.282c-1.917.068-4.372 1.5-4.372 1.5z"/>',
    },
    "xbox-line": {
      body: '<path fill="currentColor" d="M4.798 15.485c1.124-2.52 3.2-5.44 4.487-6.962c-1.248-1.246-2.162-1.931-2.818-2.3A7.98 7.98 0 0 0 4.001 12c0 1.25.286 2.432.797 3.485m4.051-10.84c1.6.406 3.152 1.314 3.152 1.314v-.005s1.552-.904 3.151-1.31A8 8 0 0 0 12.001 4c-1.12 0-2.185.23-3.152.645m8.686 1.578c-.655.37-1.568 1.055-2.816 2.3c1.287 1.523 3.362 4.441 4.486 6.961A8 8 0 0 0 20 12c0-2.27-.946-4.32-2.466-5.777m.408 11.134c-1.403-2.237-4.09-4.945-5.942-6.344c-1.85 1.4-4.539 4.108-5.941 6.345A7.98 7.98 0 0 0 12 20a7.98 7.98 0 0 0 5.942-2.643M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10"/>',
    },
    "xing-fill": {
      body: '<path fill="currentColor" d="M20.462 3.23c.154 0 .308.078.384.155a.49.49 0 0 1 0 .461l-6.076 10.77l3.846 7.076a.49.49 0 0 1 0 .462a.6.6 0 0 1-.385.154h-2.77c-.384 0-.614-.308-.768-.539l-3.923-7.154C11 14.308 16.924 3.77 16.924 3.77c.153-.308.384-.538.769-.538zM8.923 7c.385 0 .616.308.77.538l1.923 3.308c-.154.154-3 5.23-3 5.23c-.154.232-.385.54-.77.54H5.155a.6.6 0 0 1-.384-.154a.49.49 0 0 1 0-.462l2.846-5.154l-1.846-3.23a.49.49 0 0 1 0-.462A.6.6 0 0 1 6.154 7z"/>',
    },
    "xing-line": {
      body: '<path fill="currentColor" d="M20.444 3.5L13.81 14.99L17.857 22h-2.31l-4.045-7.009H11.5L18.134 3.5zM8.31 7l2.422 4.196l-.002.001L7.67 16.5H5.36l3.061-5.305L6.002 7z"/>',
    },
    "xrp-fill": {
      body: '<path fill="currentColor" d="M21.778 4h-2.837l-4.49 4.371a3.52 3.52 0 0 1-2.451.99a3.52 3.52 0 0 1-2.452-.99L5.062 4h-2.84L8.13 9.754c2.14 2.083 5.607 2.083 7.745 0zM2.223 20H5.05l4.508-4.385a3.5 3.5 0 0 1 2.443-.985c.914 0 1.792.354 2.443.985L18.952 20h2.826l-5.92-5.761c-2.132-2.073-5.585-2.073-7.715 0z"/>',
    },
    "xrp-line": {
      body: '<path fill="currentColor" d="M21.778 4h-2.837l-4.49 4.371a3.52 3.52 0 0 1-2.451.99a3.52 3.52 0 0 1-2.452-.99L5.062 4h-2.84L8.13 9.754c2.14 2.083 5.607 2.083 7.745 0zM2.223 20H5.05l4.508-4.385a3.5 3.5 0 0 1 2.443-.985c.914 0 1.792.354 2.443.985L18.952 20h2.826l-5.92-5.761c-2.132-2.073-5.585-2.073-7.715 0z"/>',
    },
    "xtz-fill": {
      body: '<path fill="currentColor" d="M19.631 17.494c-.221-3.858-5.15-5.61-5.62-5.791c-.021-.01-.021-.027-.011-.047l5.082-5.022v-.54a.167.167 0 0 0-.163-.162H9.553V2l-3.457.711v.512h.192s.848 0 .848.834v1.866H4.46c-.048 0-.097.047-.097.094v1.186h2.782v6.433c0 2.019 1.32 3.422 3.629 3.232a2.9 2.9 0 0 0 1.329-.473a.6.6 0 0 0 .28-.503v-.636c-.751.493-1.388.464-1.388.464c-1.463 0-1.433-1.83-1.433-1.83V7.202H16.3l-4.851 4.814l-.02 1.137q0 .03.029.029c4.447.739 5.65 3.572 5.65 4.397c0 0 .481 4.008-3.59 4.284c0 0-2.668.112-3.139-.939c-.019-.04 0-.076.038-.094c.444-.2.741-.588.741-1.11c0-.777-.48-1.412-1.492-1.412c-.817 0-1.492.636-1.492 1.413c0 0-.384 3.373 5.335 3.278c6.526-.114 6.121-5.504 6.121-5.504"/>',
    },
    "xtz-line": {
      body: '<path fill="currentColor" d="M9 6V2H7v4H4.5v2H7v5a4 4 0 0 0 6.667 2.981l-1.334-1.49A2 2 0 0 1 9 13V8h6.625L11.5 11.975V13.5h1c3.067 0 5 2.18 5 4c0 1.883-1.627 3.5-3.75 3.5c-1.823 0-3.293-1.202-3.66-2.733l-1.945.466C8.74 21.21 11.051 23 13.75 23c3.124 0 5.75-2.412 5.75-5.5c0-2.565-2.034-4.932-4.914-5.722L19 7.525V6z"/>',
    },
    "youtube-fill": {
      body: '<path fill="currentColor" d="M12.244 4c.534.003 1.87.016 3.29.073l.504.022c1.429.067 2.857.183 3.566.38c.945.266 1.687 1.04 1.938 2.022c.4 1.56.45 4.602.456 5.339l.001.152v.174c-.007.737-.057 3.78-.457 5.339c-.254.985-.997 1.76-1.938 2.022c-.709.197-2.137.313-3.566.38l-.504.023c-1.42.056-2.756.07-3.29.072l-.235.001h-.255c-1.13-.007-5.856-.058-7.36-.476c-.944-.266-1.687-1.04-1.938-2.022c-.4-1.56-.45-4.602-.456-5.339v-.326c.006-.737.056-3.78.456-5.339c.254-.985.997-1.76 1.939-2.021c1.503-.419 6.23-.47 7.36-.476zM9.999 8.5v7l6-3.5z"/>',
    },
    "youtube-line": {
      body: '<path fill="currentColor" d="M19.607 6.995c-.076-.298-.292-.523-.539-.592C18.63 6.28 16.501 6 12.001 6s-6.628.28-7.069.403c-.244.068-.46.293-.537.592c-.109.424-.394 2.2-.394 5.005s.285 4.58.394 5.006c.076.297.292.522.538.59C5.373 17.72 7.5 18 12 18s6.629-.28 7.069-.403c.244-.068.46-.293.537-.592c.11-.424.394-2.205.394-5.005s-.285-4.58-.394-5.005m1.937-.497C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.897 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.108 4 12.001 4 12.001 4s5.896 0 7.605.476c.944.266 1.687 1.04 1.938 2.022M10.001 15.5v-7l6 3.5z"/>',
    },
    "yuque-fill": {
      body: '<path fill="currentColor" d="M17.28 2.955c2.97.203 3.756 2.342 3.84 2.597l1.297.096c.13 0 .169.18.054.236c-1.323.716-1.727 2.17-1.49 3.118c.09.358.254.69.412 1.02c.307.642.651 1.418.707 2.981c.117 3.24-2.51 6.175-5.789 6.593c1.17-1.187 1.815-2.444 2.12-3.375c.606-1.846.508-3.316.055-4.44a4.46 4.46 0 0 0-1.782-2.141c-1.683-1.02-3.22-1.09-4.444-.762c.465-.594.876-1.201 1.2-1.864c.584-1.65-.102-2.848-.704-3.519c-.192-.246-.061-.655.305-.655c1.41 0 2.813.02 4.22.115M3.32 19.107c1.924-2.202 4.712-5.394 7.162-8.15c.559-.63 2.769-2.338 5.748-.533c.878.532 2.43 2.165 1.332 5.51c-.803 2.446-4.408 7.796-15.76 5.844c-.227-.039-.511-.354-.218-.687z"/>',
    },
    "yuque-line": {
      body: '<path fill="currentColor" d="M11.505 3.043a.92.92 0 0 1 .795-.46c1.547 0 3.09.05 4.637.154c2.51.171 3.7 1.59 4.18 2.43c.596.092 1.388.088 1.571.807c.14.552-.217.833-.554 1.148c-.483.45-1.133 1.176-.954 1.888c.055.222.159.437.316.765l.002.003c.318.667.684 1.51.742 3.115c.156 4.34-3.596 6.897-7.252 7.08c-2.41 1.815-6.345 3.025-12.557 1.957a1.33 1.33 0 0 1-.945-.709a1.25 1.25 0 0 1-.12-.735c.039-.275.165-.511.33-.7c3.228-3.675 6.635-7.246 9.654-11.098c.526-.67.96-1.28 1.15-1.648c.309-.919-.009-1.444-.625-2.463c-.282-.467-.69-.978-.37-1.534m1.989 5.843c.874.005 1.85.249 2.885.875c2.124 1.288 2.334 3.996 1.625 6.157a7.6 7.6 0 0 1-.836 1.727c1.936-.797 3.319-2.484 3.24-4.686c-.047-1.28-.317-1.871-.564-2.389l-.03-.06c-.132-.277-.31-.647-.412-1.054c-.271-1.08.175-2.04.614-2.678a.92.92 0 0 1-.387-.493v-.001a2.6 2.6 0 0 0-.58-.817c-.407-.393-1.094-.823-2.236-.901a65 65 0 0 0-2.89-.13c.452.878.758 1.94.289 3.267c-.151.426-.46.82-.718 1.183m-.832 1.945c-.719.202-1.214.63-1.378.815c-2.717 3.057-5.881 6.689-7.576 8.627c5.45.747 8.601-.49 10.378-1.922c1.295-1.043 1.925-2.24 2.176-3.004c.434-1.323.537-3.187-.834-4.018c-1.153-.699-2.088-.69-2.766-.498"/>',
    },
    "zcool-fill": {
      body: '<path fill="currentColor" d="M9.903 21.839a7.903 7.903 0 0 1-7.902-7.903c0-3.646 2.467-6.876 5.824-7.627C11.746 5.43 13.529 4.742 14.902 2c.998 1.935.323 3.71 0 4.677c4.698-1.129 6.371-3.28 6.774-3.548c0 3.952-1.231 6.452-2.419 8.065c1.476-.056 2.009-.484 2.744-.587c-.325 1.448-1.501 3.49-4.331 4.795a7.905 7.905 0 0 1-7.767 6.437m3.71-6.452c0 .323-.053.484-.403.484l-3.15.002l2.96-3.248c.86-.86.86-1.29.86-2.388c0-.334-.048-.717.048-1.05c.047-.144-.048-.192-.191-.144c-.335.095-.908.095-1.863.095H7.576c-.239 0-.335-.143-.239-.334c0-.048 0-.191-.096-.191c-.62.286-.764 1.576-.716 2.388c0 .43.239.669.573.669h3.391l-3.486 3.725c-.24.287-.478.669-.478 1.194v1.051c0 .478.287.764.812.86h5.988c.555 0 .933-.233.933-.855v-1.129c0-.208 0-.968-.645-1.129"/>',
    },
    "zcool-line": {
      body: '<path fill="currentColor" d="M8.262 8.26C5.838 8.803 4 11.208 4 13.936a5.903 5.903 0 0 0 11.703 1.097a2 2 0 0 1 1.129-1.447a8 8 0 0 0 1.284-.744c-.863-.603-1.186-1.862-.47-2.834a9.8 9.8 0 0 0 1.391-2.651c-1.084.51-2.3.936-3.668 1.265c-1.261.303-2.392-.638-2.466-1.814c-1.18.572-2.67 1.01-4.642 1.452m10.995 2.934c1.166 0 1.916-.424 2.744-.587c-.325 1.448-1.501 3.49-4.331 4.795A7.903 7.903 0 0 1 2 13.936C2 10.29 4.467 7.06 7.824 6.309C11.746 5.43 13.529 4.742 14.902 2q1.033 2 0 4.677q4.224-1.005 6.774-3.548c0 4.802-1.822 7.186-2.419 8.065m-5.84 3.932c.584.146.584.832.584 1.02v1.021c0 .562-.342.773-.844.773H7.743c-.475-.086-.734-.345-.734-.777v-.95c0-.475.216-.82.431-1.08l3.153-3.369H7.527c-.302 0-.518-.216-.518-.604c-.044-.735.086-1.9.647-2.16c.087 0 .087.13.087.173c-.087.173 0 .302.216.302h3.887c.863 0 1.381 0 1.684-.086c.13-.043.216 0 .173.13c-.087.302-.044.647-.044.95c0 .993 0 1.382-.777 2.159l-2.678 2.937l2.85-.002c.316 0 .364-.146.364-.437"/>',
    },
    "zhihu-fill": {
      body: '<path fill="currentColor" d="M13.374 18.897h1.452l.478 1.637l2.605-1.637h3.07V5.395h-7.605zM14.919 6.86h4.515v10.57h-1.732l-1.73 1.087l-.315-1.084l-.738-.003zm-2.83 4.712H8.846a70 70 0 0 0 .136-4.56h3.172s.122-1.4-.532-1.384H6.135q.325-1.22.814-2.524s-1.493 0-2.001 1.339c-.21.552-.82 2.677-1.903 4.848c.365-.04 1.573-.073 2.284-1.378c.13-.366.156-.414.318-.902h1.79c0 .651-.074 4.151-.105 4.558h-3.24c-.728 0-.964 1.466-.964 1.466h4.065c-.272 3.095-1.737 5.703-4.392 7.764c1.27.363 2.536-.057 3.162-.614c0 0 1.425-1.297 2.206-4.298l3.345 4.03s.491-1.668-.076-2.482c-.47-.553-1.74-2.051-2.281-2.594l-.907.72q.405-1.302.488-2.524h3.822s-.005-1.466-.47-1.466"/>',
    },
    "zhihu-line": {
      body: '<path fill="currentColor" d="m12.345 17.963l-1.688 1.074l-2.132-3.35c-.44 1.402-1.171 2.665-2.138 3.825c-.402.483-.82.918-1.301 1.376c-.155.146-.775.716-.878.82l-1.414-1.415c.139-.139.787-.735.914-.856c.43-.408.796-.79 1.143-1.205C6.117 16.712 6.88 15.02 6.988 13H3v-2h4V7h-.868c-.689 1.266-1.558 2.222-2.618 2.858L2.486 8.143c1.396-.838 2.426-2.603 3.039-5.36l1.952.434q-.21.95-.489 1.783h4.513v2H9v4h2.5v2H9.186zm3.838-.07L17.3 17h1.702V7h-4v10h.736zM13.001 5h8v14h-3l-2.5 2l-1-2H13z"/>',
    },
    "zoom-in-fill": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617M10 10H7v2h3v3h2v-3h3v-2h-3V7h-2z"/>',
    },
    "zoom-in-line": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617m-2.006-.742A6.98 6.98 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7s3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975zM10 10V7h2v3h3v2h-3v3h-2v-3H7v-2z"/>',
    },
    "zoom-out-fill": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617M7 10v2h8v-2z"/>',
    },
    "zoom-out-line": {
      body: '<path fill="currentColor" d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617m-2.006-.742A6.98 6.98 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7s3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975zM7 10h8v2H7z"/>',
    },
    "zzz-fill": {
      body: '<path fill="currentColor" d="M11 11v2l-5.327 6H11v2H3v-2l5.326-6H3v-2zm10-8v2l-5.327 6H21v2h-8v-2l5.326-6H13V3z"/>',
    },
    "zzz-line": {
      body: '<path fill="currentColor" d="M11 11v2l-5.327 6H11v2H3v-2l5.326-6H3v-2zm10-8v2l-5.327 6H21v2h-8v-2l5.326-6H13V3z"/>',
    },
  },
  aliases: {
    "arrow-down-circle-fill-2": {
      parent: "arrow-down-circle-fill",
    },
    "battery-low-fill-2": {
      parent: "battery-low-fill",
    },
    "book-mark-fill": {
      parent: "book-marked-fill",
    },
    "book-mark-line": {
      parent: "book-marked-line",
    },
    "chat-1-fill-2": {
      parent: "chat-1-fill",
    },
    "file-2-line-2": {
      parent: "file-2-line",
    },
    "file-mark-fill": {
      parent: "file-marked-fill",
    },
    "file-mark-line": {
      parent: "file-marked-line",
    },
    "hard-drive-2-fill-2": {
      parent: "hard-drive-2-fill",
    },
    "heading-2": {
      parent: "heading",
    },
    "menu-fold-3-line-2": {
      parent: "menu-fold-3-line",
    },
    "menu-unfold-3-line-2": {
      parent: "menu-unfold-3-line",
    },
    "menu-unfold-4-line-2": {
      parent: "menu-unfold-4-line",
    },
    "sticky-note-2-fill-2": {
      parent: "sticky-note-2-fill",
    },
  },
  categories: {
    Arrows: [
      "arrow-down-circle-fill",
      "arrow-down-circle-line",
      "arrow-down-double-fill",
      "arrow-down-double-line",
      "arrow-down-fill",
      "arrow-down-line",
      "arrow-down-s-fill",
      "arrow-down-s-line",
      "arrow-down-wide-fill",
      "arrow-down-wide-line",
      "arrow-drop-down-fill",
      "arrow-drop-down-line",
      "arrow-drop-left-fill",
      "arrow-drop-left-line",
      "arrow-drop-right-fill",
      "arrow-drop-right-line",
      "arrow-drop-up-fill",
      "arrow-drop-up-line",
      "arrow-go-back-fill",
      "arrow-go-back-line",
      "arrow-go-forward-fill",
      "arrow-go-forward-line",
      "arrow-left-circle-fill",
      "arrow-left-circle-line",
      "arrow-left-double-fill",
      "arrow-left-double-line",
      "arrow-left-down-fill",
      "arrow-left-down-line",
      "arrow-left-fill",
      "arrow-left-line",
      "arrow-left-right-fill",
      "arrow-left-right-line",
      "arrow-left-s-fill",
      "arrow-left-s-line",
      "arrow-left-up-fill",
      "arrow-left-up-line",
      "arrow-left-wide-fill",
      "arrow-left-wide-line",
      "arrow-right-circle-fill",
      "arrow-right-circle-line",
      "arrow-right-double-fill",
      "arrow-right-double-line",
      "arrow-right-down-fill",
      "arrow-right-down-line",
      "arrow-right-fill",
      "arrow-right-line",
      "arrow-right-s-fill",
      "arrow-right-s-line",
      "arrow-right-up-fill",
      "arrow-right-up-line",
      "arrow-right-wide-fill",
      "arrow-right-wide-line",
      "arrow-turn-back-fill",
      "arrow-turn-back-line",
      "arrow-turn-forward-fill",
      "arrow-turn-forward-line",
      "arrow-up-circle-fill",
      "arrow-up-circle-line",
      "arrow-up-double-fill",
      "arrow-up-double-line",
      "arrow-up-down-fill",
      "arrow-up-down-line",
      "arrow-up-fill",
      "arrow-up-line",
      "arrow-up-s-fill",
      "arrow-up-s-line",
      "arrow-up-wide-fill",
      "arrow-up-wide-line",
      "collapse-diagonal-2-fill",
      "collapse-diagonal-2-line",
      "collapse-diagonal-fill",
      "collapse-diagonal-line",
      "collapse-horizontal-fill",
      "collapse-horizontal-line",
      "collapse-vertical-fill",
      "collapse-vertical-line",
      "contract-left-fill",
      "contract-left-line",
      "contract-left-right-fill",
      "contract-left-right-line",
      "contract-right-fill",
      "contract-right-line",
      "contract-up-down-fill",
      "contract-up-down-line",
      "corner-down-left-fill",
      "corner-down-left-line",
      "corner-down-right-fill",
      "corner-down-right-line",
      "corner-left-down-fill",
      "corner-left-down-line",
      "corner-left-up-fill",
      "corner-left-up-line",
      "corner-right-down-fill",
      "corner-right-down-line",
      "corner-right-up-fill",
      "corner-right-up-line",
      "corner-up-left-double-fill",
      "corner-up-left-double-line",
      "corner-up-left-fill",
      "corner-up-left-line",
      "corner-up-right-double-fill",
      "corner-up-right-double-line",
      "corner-up-right-fill",
      "corner-up-right-line",
      "drag-move-2-fill",
      "drag-move-2-line",
      "drag-move-fill",
      "drag-move-line",
      "expand-diagonal-2-fill",
      "expand-diagonal-2-line",
      "expand-diagonal-fill",
      "expand-diagonal-line",
      "expand-diagonal-s-2-fill",
      "expand-diagonal-s-2-line",
      "expand-diagonal-s-fill",
      "expand-diagonal-s-line",
      "expand-height-fill",
      "expand-height-line",
      "expand-horizontal-fill",
      "expand-horizontal-line",
      "expand-horizontal-s-fill",
      "expand-horizontal-s-line",
      "expand-left-fill",
      "expand-left-line",
      "expand-left-right-fill",
      "expand-left-right-line",
      "expand-right-fill",
      "expand-right-line",
      "expand-up-down-fill",
      "expand-up-down-line",
      "expand-vertical-fill",
      "expand-vertical-line",
      "expand-vertical-s-fill",
      "expand-vertical-s-line",
      "expand-width-fill",
      "expand-width-line",
      "scroll-to-bottom-fill",
      "scroll-to-bottom-line",
      "skip-down-fill",
      "skip-down-line",
      "skip-left-fill",
      "skip-left-line",
      "skip-right-fill",
      "skip-right-line",
      "skip-up-fill",
      "skip-up-line",
    ],
    Buildings: [
      "ancient-gate-fill",
      "ancient-gate-line",
      "ancient-pavilion-fill",
      "ancient-pavilion-line",
      "bank-fill",
      "bank-line",
      "building-2-fill",
      "building-2-line",
      "building-3-fill",
      "building-3-line",
      "building-4-fill",
      "building-4-line",
      "building-fill",
      "building-line",
      "community-fill",
      "community-line",
      "government-fill",
      "government-line",
      "home-2-fill",
      "home-2-line",
      "home-3-fill",
      "home-3-line",
      "home-4-fill",
      "home-4-line",
      "home-5-fill",
      "home-5-line",
      "home-6-fill",
      "home-6-line",
      "home-7-fill",
      "home-7-line",
      "home-8-fill",
      "home-8-line",
      "home-fill",
      "home-gear-fill",
      "home-gear-line",
      "home-heart-fill",
      "home-heart-line",
      "home-line",
      "home-office-fill",
      "home-office-line",
      "home-smile-2-fill",
      "home-smile-2-line",
      "home-smile-fill",
      "home-smile-line",
      "home-wifi-fill",
      "home-wifi-line",
      "hospital-fill",
      "hospital-line",
      "hotel-fill",
      "hotel-line",
      "school-fill",
      "school-line",
      "store-2-fill",
      "store-2-line",
      "store-3-fill",
      "store-3-line",
      "store-fill",
      "store-line",
      "tent-fill",
      "tent-line",
    ],
    Business: [
      "advertisement-fill",
      "advertisement-line",
      "archive-2-fill",
      "archive-2-line",
      "archive-drawer-fill",
      "archive-drawer-line",
      "archive-fill",
      "archive-line",
      "archive-stack-fill",
      "archive-stack-line",
      "at-fill",
      "at-line",
      "attachment-fill",
      "attachment-line",
      "award-fill",
      "award-line",
      "bar-chart-2-fill",
      "bar-chart-2-line",
      "bar-chart-box-fill",
      "bar-chart-box-line",
      "bar-chart-fill",
      "bar-chart-grouped-fill",
      "bar-chart-grouped-line",
      "bar-chart-horizontal-fill",
      "bar-chart-horizontal-line",
      "bar-chart-line",
      "bookmark-2-fill",
      "bookmark-2-line",
      "bookmark-3-fill",
      "bookmark-3-line",
      "bookmark-fill",
      "bookmark-line",
      "briefcase-2-fill",
      "briefcase-2-line",
      "briefcase-3-fill",
      "briefcase-3-line",
      "briefcase-4-fill",
      "briefcase-4-line",
      "briefcase-5-fill",
      "briefcase-5-line",
      "briefcase-fill",
      "briefcase-line",
      "bubble-chart-fill",
      "bubble-chart-line",
      "calculator-fill",
      "calculator-line",
      "calendar-2-fill",
      "calendar-2-line",
      "calendar-check-fill",
      "calendar-check-line",
      "calendar-close-fill",
      "calendar-close-line",
      "calendar-event-fill",
      "calendar-event-line",
      "calendar-fill",
      "calendar-line",
      "calendar-schedule-fill",
      "calendar-schedule-line",
      "calendar-todo-fill",
      "calendar-todo-line",
      "cloud-fill",
      "cloud-line",
      "cloud-off-fill",
      "cloud-off-line",
      "copyleft-fill",
      "copyleft-line",
      "copyright-fill",
      "copyright-line",
      "creative-commons-by-fill",
      "creative-commons-by-line",
      "creative-commons-fill",
      "creative-commons-line",
      "creative-commons-nc-fill",
      "creative-commons-nc-line",
      "creative-commons-nd-fill",
      "creative-commons-nd-line",
      "creative-commons-sa-fill",
      "creative-commons-sa-line",
      "creative-commons-zero-fill",
      "creative-commons-zero-line",
      "customer-service-2-fill",
      "customer-service-2-line",
      "customer-service-fill",
      "customer-service-line",
      "donut-chart-fill",
      "donut-chart-line",
      "flag-2-fill",
      "flag-2-line",
      "flag-fill",
      "flag-line",
      "global-fill",
      "global-line",
      "honour-fill",
      "honour-line",
      "id-card-fill",
      "id-card-line",
      "inbox-2-fill",
      "inbox-2-line",
      "inbox-archive-fill",
      "inbox-archive-line",
      "inbox-fill",
      "inbox-line",
      "inbox-unarchive-fill",
      "inbox-unarchive-line",
      "line-chart-fill",
      "line-chart-line",
      "links-fill",
      "links-line",
      "mail-add-fill",
      "mail-add-line",
      "mail-check-fill",
      "mail-check-line",
      "mail-close-fill",
      "mail-close-line",
      "mail-download-fill",
      "mail-download-line",
      "mail-fill",
      "mail-forbid-fill",
      "mail-forbid-line",
      "mail-line",
      "mail-lock-fill",
      "mail-lock-line",
      "mail-open-fill",
      "mail-open-line",
      "mail-send-fill",
      "mail-send-line",
      "mail-settings-fill",
      "mail-settings-line",
      "mail-star-fill",
      "mail-star-line",
      "mail-unread-fill",
      "mail-unread-line",
      "mail-volume-fill",
      "mail-volume-line",
      "medal-2-fill",
      "medal-2-line",
      "medal-fill",
      "medal-line",
      "megaphone-fill",
      "megaphone-line",
      "pass-expired-fill",
      "pass-expired-line",
      "pass-pending-fill",
      "pass-pending-line",
      "pass-valid-fill",
      "pass-valid-line",
      "pie-chart-2-fill",
      "pie-chart-2-line",
      "pie-chart-box-fill",
      "pie-chart-box-line",
      "pie-chart-fill",
      "pie-chart-line",
      "presentation-fill",
      "presentation-line",
      "printer-cloud-fill",
      "printer-cloud-line",
      "printer-fill",
      "printer-line",
      "profile-fill",
      "profile-line",
      "projector-2-fill",
      "projector-2-line",
      "projector-fill",
      "projector-line",
      "record-mail-fill",
      "record-mail-line",
      "registered-fill",
      "registered-line",
      "reply-all-fill",
      "reply-all-line",
      "reply-fill",
      "reply-line",
      "send-plane-2-fill",
      "send-plane-2-line",
      "send-plane-fill",
      "send-plane-line",
      "seo-fill",
      "seo-line",
      "service-fill",
      "service-line",
      "shake-hands-fill",
      "shake-hands-line",
      "slideshow-2-fill",
      "slideshow-2-line",
      "slideshow-3-fill",
      "slideshow-3-line",
      "slideshow-4-fill",
      "slideshow-4-line",
      "slideshow-fill",
      "slideshow-line",
      "stack-fill",
      "stack-line",
      "trademark-fill",
      "trademark-line",
      "triangular-flag-fill",
      "triangular-flag-line",
      "verified-badge-fill",
      "verified-badge-line",
      "window-2-fill",
      "window-2-line",
      "window-fill",
      "window-line",
    ],
    Communication: [
      "chat-1-fill",
      "chat-1-line",
      "chat-2-fill",
      "chat-2-line",
      "chat-3-fill",
      "chat-3-line",
      "chat-4-fill",
      "chat-4-line",
      "chat-check-fill",
      "chat-check-line",
      "chat-delete-fill",
      "chat-delete-line",
      "chat-download-fill",
      "chat-download-line",
      "chat-follow-up-fill",
      "chat-follow-up-line",
      "chat-forward-fill",
      "chat-forward-line",
      "chat-heart-fill",
      "chat-heart-line",
      "chat-history-fill",
      "chat-history-line",
      "chat-new-fill",
      "chat-new-line",
      "chat-off-fill",
      "chat-off-line",
      "chat-poll-fill",
      "chat-poll-line",
      "chat-private-fill",
      "chat-private-line",
      "chat-quote-fill",
      "chat-quote-line",
      "chat-search-fill",
      "chat-search-line",
      "chat-settings-fill",
      "chat-settings-line",
      "chat-smile-2-fill",
      "chat-smile-2-line",
      "chat-smile-3-fill",
      "chat-smile-3-line",
      "chat-smile-fill",
      "chat-smile-line",
      "chat-thread-fill",
      "chat-thread-line",
      "chat-unread-fill",
      "chat-unread-line",
      "chat-upload-fill",
      "chat-upload-line",
      "chat-voice-fill",
      "chat-voice-line",
      "discuss-fill",
      "discuss-line",
      "emoji-sticker-fill",
      "emoji-sticker-line",
      "feedback-fill",
      "feedback-line",
      "message-2-fill",
      "message-2-line",
      "message-3-fill",
      "message-3-line",
      "message-fill",
      "message-line",
      "question-answer-fill",
      "question-answer-line",
      "questionnaire-fill",
      "questionnaire-line",
      "speak-fill",
      "speak-line",
      "video-chat-fill",
      "video-chat-line",
    ],
    Design: [
      "align-item-bottom-fill",
      "align-item-bottom-line",
      "align-item-horizontal-center-fill",
      "align-item-horizontal-center-line",
      "align-item-left-fill",
      "align-item-left-line",
      "align-item-right-fill",
      "align-item-right-line",
      "align-item-top-fill",
      "align-item-top-line",
      "align-item-vertical-center-fill",
      "align-item-vertical-center-line",
      "anticlockwise-2-fill",
      "anticlockwise-2-line",
      "anticlockwise-fill",
      "anticlockwise-line",
      "artboard-2-fill",
      "artboard-2-line",
      "artboard-fill",
      "artboard-line",
      "ball-pen-fill",
      "ball-pen-line",
      "blur-off-fill",
      "blur-off-line",
      "brush-2-fill",
      "brush-2-line",
      "brush-3-fill",
      "brush-3-line",
      "brush-4-fill",
      "brush-4-line",
      "brush-fill",
      "brush-line",
      "circle-fill",
      "circle-line",
      "clockwise-2-fill",
      "clockwise-2-line",
      "clockwise-fill",
      "clockwise-line",
      "collage-fill",
      "collage-line",
      "color-filter-fill",
      "color-filter-line",
      "compasses-2-fill",
      "compasses-2-line",
      "compasses-fill",
      "compasses-line",
      "contrast-2-fill",
      "contrast-2-line",
      "contrast-drop-2-fill",
      "contrast-drop-2-line",
      "contrast-drop-fill",
      "contrast-drop-line",
      "contrast-fill",
      "contrast-line",
      "crop-2-fill",
      "crop-2-line",
      "crop-fill",
      "crop-line",
      "crosshair-2-fill",
      "crosshair-2-line",
      "crosshair-fill",
      "crosshair-line",
      "drag-drop-fill",
      "drag-drop-line",
      "drop-fill",
      "drop-line",
      "edit-2-fill",
      "edit-2-line",
      "edit-box-fill",
      "edit-box-line",
      "edit-circle-fill",
      "edit-circle-line",
      "edit-fill",
      "edit-line",
      "eraser-fill",
      "eraser-line",
      "flip-horizontal-2-fill",
      "flip-horizontal-2-line",
      "flip-horizontal-fill",
      "flip-horizontal-line",
      "flip-vertical-2-fill",
      "flip-vertical-2-line",
      "flip-vertical-fill",
      "flip-vertical-line",
      "focus-2-fill",
      "focus-2-line",
      "focus-3-fill",
      "focus-3-line",
      "focus-fill",
      "focus-line",
      "grid-fill",
      "grid-line",
      "hammer-fill",
      "hammer-line",
      "hexagon-fill",
      "hexagon-line",
      "ink-bottle-fill",
      "ink-bottle-line",
      "input-method-fill",
      "input-method-line",
      "layout-2-fill",
      "layout-2-line",
      "layout-3-fill",
      "layout-3-line",
      "layout-4-fill",
      "layout-4-line",
      "layout-5-fill",
      "layout-5-line",
      "layout-6-fill",
      "layout-6-line",
      "layout-bottom-2-fill",
      "layout-bottom-2-line",
      "layout-bottom-fill",
      "layout-bottom-line",
      "layout-column-fill",
      "layout-column-line",
      "layout-fill",
      "layout-grid-2-fill",
      "layout-grid-2-line",
      "layout-grid-fill",
      "layout-grid-line",
      "layout-horizontal-fill",
      "layout-horizontal-line",
      "layout-left-2-fill",
      "layout-left-2-line",
      "layout-left-fill",
      "layout-left-line",
      "layout-line",
      "layout-masonry-fill",
      "layout-masonry-line",
      "layout-right-2-fill",
      "layout-right-2-line",
      "layout-right-fill",
      "layout-right-line",
      "layout-row-fill",
      "layout-row-line",
      "layout-top-2-fill",
      "layout-top-2-line",
      "layout-top-fill",
      "layout-top-line",
      "layout-vertical-fill",
      "layout-vertical-line",
      "magic-fill",
      "magic-line",
      "mark-pen-fill",
      "mark-pen-line",
      "markup-fill",
      "markup-line",
      "octagon-fill",
      "octagon-line",
      "paint-brush-fill",
      "paint-brush-line",
      "paint-fill",
      "paint-line",
      "palette-fill",
      "palette-line",
      "pantone-fill",
      "pantone-line",
      "pen-nib-fill",
      "pen-nib-line",
      "pencil-fill",
      "pencil-line",
      "pencil-ruler-2-fill",
      "pencil-ruler-2-line",
      "pencil-ruler-fill",
      "pencil-ruler-line",
      "pentagon-fill",
      "pentagon-line",
      "quill-pen-fill",
      "quill-pen-line",
      "rectangle-fill",
      "rectangle-line",
      "ruler-2-fill",
      "ruler-2-line",
      "ruler-fill",
      "ruler-line",
      "scissors-2-fill",
      "scissors-2-line",
      "scissors-cut-fill",
      "scissors-cut-line",
      "scissors-fill",
      "scissors-line",
      "screenshot-2-fill",
      "screenshot-2-line",
      "screenshot-fill",
      "screenshot-line",
      "shadow-fill",
      "shadow-line",
      "shape-2-fill",
      "shape-2-line",
      "shape-fill",
      "shape-line",
      "shapes-fill",
      "shapes-line",
      "sip-fill",
      "sip-line",
      "slice-fill",
      "slice-line",
      "square-fill",
      "square-line",
      "t-box-fill",
      "t-box-line",
      "table-alt-fill",
      "table-alt-line",
      "table-fill",
      "table-line",
      "tools-fill",
      "tools-line",
      "triangle-fill",
      "triangle-line",
    ],
    Development: [
      "braces-fill",
      "braces-line",
      "brackets-fill",
      "brackets-line",
      "bug-2-fill",
      "bug-2-line",
      "bug-fill",
      "bug-line",
      "code-box-fill",
      "code-box-line",
      "code-fill",
      "code-line",
      "code-s-fill",
      "code-s-line",
      "code-s-slash-fill",
      "code-s-slash-line",
      "command-fill",
      "command-line",
      "css3-fill",
      "css3-line",
      "cursor-fill",
      "cursor-line",
      "git-branch-fill",
      "git-branch-line",
      "git-close-pull-request-fill",
      "git-close-pull-request-line",
      "git-commit-fill",
      "git-commit-line",
      "git-fork-fill",
      "git-fork-line",
      "git-merge-fill",
      "git-merge-line",
      "git-pr-draft-fill",
      "git-pr-draft-line",
      "git-pull-request-fill",
      "git-pull-request-line",
      "git-repository-commits-fill",
      "git-repository-commits-line",
      "git-repository-fill",
      "git-repository-line",
      "git-repository-private-fill",
      "git-repository-private-line",
      "html5-fill",
      "html5-line",
      "javascript-fill",
      "javascript-line",
      "parentheses-fill",
      "parentheses-line",
      "puzzle-2-fill",
      "puzzle-2-line",
      "puzzle-fill",
      "puzzle-line",
      "terminal-box-fill",
      "terminal-box-line",
      "terminal-fill",
      "terminal-line",
      "terminal-window-fill",
      "terminal-window-line",
    ],
    Device: [
      "airplay-fill",
      "airplay-line",
      "barcode-box-fill",
      "barcode-box-line",
      "barcode-fill",
      "barcode-line",
      "base-station-fill",
      "base-station-line",
      "battery-2-charge-fill",
      "battery-2-charge-line",
      "battery-2-fill",
      "battery-2-line",
      "battery-charge-fill",
      "battery-charge-line",
      "battery-fill",
      "battery-line",
      "battery-low-fill",
      "battery-low-line",
      "battery-saver-fill",
      "battery-saver-line",
      "battery-share-fill",
      "battery-share-line",
      "bluetooth-connect-fill",
      "bluetooth-connect-line",
      "bluetooth-fill",
      "bluetooth-line",
      "cast-fill",
      "cast-line",
      "cellphone-fill",
      "cellphone-line",
      "computer-fill",
      "computer-line",
      "cpu-fill",
      "cpu-line",
      "dashboard-2-fill",
      "dashboard-2-line",
      "dashboard-3-fill",
      "dashboard-3-line",
      "database-2-fill",
      "database-2-line",
      "database-fill",
      "database-line",
      "device-fill",
      "device-line",
      "device-recover-fill",
      "device-recover-line",
      "dual-sim-1-fill",
      "dual-sim-1-line",
      "dual-sim-2-fill",
      "dual-sim-2-line",
      "fingerprint-2-fill",
      "fingerprint-2-line",
      "fingerprint-fill",
      "fingerprint-line",
      "gamepad-fill",
      "gamepad-line",
      "gps-fill",
      "gps-line",
      "gradienter-fill",
      "gradienter-line",
      "hard-drive-2-fill",
      "hard-drive-2-line",
      "hard-drive-3-fill",
      "hard-drive-3-line",
      "hard-drive-fill",
      "hard-drive-line",
      "hotspot-fill",
      "hotspot-line",
      "install-fill",
      "install-line",
      "instance-fill",
      "instance-line",
      "keyboard-box-fill",
      "keyboard-box-line",
      "keyboard-fill",
      "keyboard-line",
      "mac-fill",
      "mac-line",
      "macbook-fill",
      "macbook-line",
      "mobile-download-fill",
      "mobile-download-line",
      "mouse-fill",
      "mouse-line",
      "phone-fill",
      "phone-find-fill",
      "phone-find-line",
      "phone-line",
      "phone-lock-fill",
      "phone-lock-line",
      "qr-code-fill",
      "qr-code-line",
      "qr-scan-2-fill",
      "qr-scan-2-line",
      "qr-scan-fill",
      "qr-scan-line",
      "radar-fill",
      "radar-line",
      "ram-2-fill",
      "ram-2-line",
      "ram-fill",
      "ram-line",
      "remote-control-2-fill",
      "remote-control-2-line",
      "remote-control-fill",
      "remote-control-line",
      "restart-fill",
      "restart-line",
      "rfid-fill",
      "rfid-line",
      "rotate-lock-fill",
      "rotate-lock-line",
      "router-fill",
      "router-line",
      "rss-fill",
      "rss-line",
      "save-2-fill",
      "save-2-line",
      "save-3-fill",
      "save-3-line",
      "save-fill",
      "save-line",
      "scan-2-fill",
      "scan-2-line",
      "scan-fill",
      "scan-line",
      "sd-card-fill",
      "sd-card-line",
      "sd-card-mini-fill",
      "sd-card-mini-line",
      "sensor-fill",
      "sensor-line",
      "server-fill",
      "server-line",
      "shut-down-fill",
      "shut-down-line",
      "signal-wifi-1-fill",
      "signal-wifi-1-line",
      "signal-wifi-2-fill",
      "signal-wifi-2-line",
      "signal-wifi-3-fill",
      "signal-wifi-3-line",
      "signal-wifi-error-fill",
      "signal-wifi-error-line",
      "signal-wifi-fill",
      "signal-wifi-line",
      "signal-wifi-off-fill",
      "signal-wifi-off-line",
      "sim-card-2-fill",
      "sim-card-2-line",
      "sim-card-fill",
      "sim-card-line",
      "smartphone-fill",
      "smartphone-line",
      "tablet-fill",
      "tablet-line",
      "tv-2-fill",
      "tv-2-line",
      "tv-fill",
      "tv-line",
      "u-disk-fill",
      "u-disk-line",
      "uninstall-fill",
      "uninstall-line",
      "usb-fill",
      "usb-line",
      "wifi-fill",
      "wifi-line",
      "wifi-off-fill",
      "wifi-off-line",
      "wireless-charging-fill",
      "wireless-charging-line",
    ],
    Document: [
      "article-fill",
      "article-line",
      "bill-fill",
      "bill-line",
      "book-2-fill",
      "book-2-line",
      "book-3-fill",
      "book-3-line",
      "book-fill",
      "book-line",
      "book-marked-fill",
      "book-marked-line",
      "book-open-fill",
      "book-open-line",
      "book-read-fill",
      "book-read-line",
      "booklet-fill",
      "booklet-line",
      "clipboard-fill",
      "clipboard-line",
      "contacts-book-2-fill",
      "contacts-book-2-line",
      "contacts-book-3-fill",
      "contacts-book-3-line",
      "contacts-book-fill",
      "contacts-book-line",
      "contacts-book-upload-fill",
      "contacts-book-upload-line",
      "contract-fill",
      "contract-line",
      "draft-fill",
      "draft-line",
      "file-2-fill",
      "file-2-line",
      "file-3-fill",
      "file-3-line",
      "file-4-fill",
      "file-4-line",
      "file-add-fill",
      "file-add-line",
      "file-chart-2-fill",
      "file-chart-2-line",
      "file-chart-fill",
      "file-chart-line",
      "file-check-fill",
      "file-check-line",
      "file-close-fill",
      "file-close-line",
      "file-cloud-fill",
      "file-cloud-line",
      "file-code-fill",
      "file-code-line",
      "file-copy-2-fill",
      "file-copy-2-line",
      "file-copy-fill",
      "file-copy-line",
      "file-damage-fill",
      "file-damage-line",
      "file-download-fill",
      "file-download-line",
      "file-edit-fill",
      "file-edit-line",
      "file-excel-2-fill",
      "file-excel-2-line",
      "file-excel-fill",
      "file-excel-line",
      "file-fill",
      "file-forbid-fill",
      "file-forbid-line",
      "file-gif-fill",
      "file-gif-line",
      "file-history-fill",
      "file-history-line",
      "file-hwp-fill",
      "file-hwp-line",
      "file-image-fill",
      "file-image-line",
      "file-info-fill",
      "file-info-line",
      "file-line",
      "file-list-2-fill",
      "file-list-2-line",
      "file-list-3-fill",
      "file-list-3-line",
      "file-list-fill",
      "file-list-line",
      "file-lock-fill",
      "file-lock-line",
      "file-marked-fill",
      "file-marked-line",
      "file-music-fill",
      "file-music-line",
      "file-paper-2-fill",
      "file-paper-2-line",
      "file-paper-fill",
      "file-paper-line",
      "file-pdf-2-fill",
      "file-pdf-2-line",
      "file-pdf-fill",
      "file-pdf-line",
      "file-ppt-2-fill",
      "file-ppt-2-line",
      "file-ppt-fill",
      "file-ppt-line",
      "file-reduce-fill",
      "file-reduce-line",
      "file-search-fill",
      "file-search-line",
      "file-settings-fill",
      "file-settings-line",
      "file-shield-2-fill",
      "file-shield-2-line",
      "file-shield-fill",
      "file-shield-line",
      "file-shred-fill",
      "file-shred-line",
      "file-text-fill",
      "file-text-line",
      "file-transfer-fill",
      "file-transfer-line",
      "file-unknow-fill",
      "file-unknow-line",
      "file-upload-fill",
      "file-upload-line",
      "file-user-fill",
      "file-user-line",
      "file-video-fill",
      "file-video-line",
      "file-warning-fill",
      "file-warning-line",
      "file-word-2-fill",
      "file-word-2-line",
      "file-word-fill",
      "file-word-line",
      "file-zip-fill",
      "file-zip-line",
      "folder-2-fill",
      "folder-2-line",
      "folder-3-fill",
      "folder-3-line",
      "folder-4-fill",
      "folder-4-line",
      "folder-5-fill",
      "folder-5-line",
      "folder-6-fill",
      "folder-6-line",
      "folder-add-fill",
      "folder-add-line",
      "folder-chart-2-fill",
      "folder-chart-2-line",
      "folder-chart-fill",
      "folder-chart-line",
      "folder-check-fill",
      "folder-check-line",
      "folder-close-fill",
      "folder-close-line",
      "folder-cloud-fill",
      "folder-cloud-line",
      "folder-download-fill",
      "folder-download-line",
      "folder-fill",
      "folder-forbid-fill",
      "folder-forbid-line",
      "folder-history-fill",
      "folder-history-line",
      "folder-image-fill",
      "folder-image-line",
      "folder-info-fill",
      "folder-info-line",
      "folder-keyhole-fill",
      "folder-keyhole-line",
      "folder-line",
      "folder-lock-fill",
      "folder-lock-line",
      "folder-music-fill",
      "folder-music-line",
      "folder-open-fill",
      "folder-open-line",
      "folder-received-fill",
      "folder-received-line",
      "folder-reduce-fill",
      "folder-reduce-line",
      "folder-settings-fill",
      "folder-settings-line",
      "folder-shared-fill",
      "folder-shared-line",
      "folder-shield-2-fill",
      "folder-shield-2-line",
      "folder-shield-fill",
      "folder-shield-line",
      "folder-transfer-fill",
      "folder-transfer-line",
      "folder-unknow-fill",
      "folder-unknow-line",
      "folder-upload-fill",
      "folder-upload-line",
      "folder-user-fill",
      "folder-user-line",
      "folder-video-fill",
      "folder-video-line",
      "folder-warning-fill",
      "folder-warning-line",
      "folder-zip-fill",
      "folder-zip-line",
      "folders-fill",
      "folders-line",
      "keynote-fill",
      "keynote-line",
      "markdown-fill",
      "markdown-line",
      "news-fill",
      "news-line",
      "newspaper-fill",
      "newspaper-line",
      "numbers-fill",
      "numbers-line",
      "pages-fill",
      "pages-line",
      "receipt-fill",
      "receipt-line",
      "sticky-note-2-fill",
      "sticky-note-2-line",
      "sticky-note-add-fill",
      "sticky-note-add-line",
      "sticky-note-fill",
      "sticky-note-line",
      "survey-fill",
      "survey-line",
      "task-fill",
      "task-line",
      "todo-fill",
      "todo-line",
    ],
    Editor: [
      "a-b",
      "ai-generate",
      "align-bottom",
      "align-center",
      "align-justify",
      "align-left",
      "align-right",
      "align-top",
      "align-vertically",
      "asterisk",
      "attachment-2",
      "bold",
      "bring-forward",
      "bring-to-front",
      "calendar-view",
      "carousel-view",
      "code-block",
      "code-view",
      "delete-column",
      "delete-row",
      "double-quotes-l",
      "double-quotes-r",
      "draggable",
      "dropdown-list",
      "emphasis",
      "emphasis-cn",
      "english-input",
      "flow-chart",
      "focus-mode",
      "font-color",
      "font-family",
      "font-mono",
      "font-sans",
      "font-sans-serif",
      "font-size",
      "font-size-2",
      "format-clear",
      "formula",
      "functions",
      "gallery-view",
      "gallery-view-2",
      "h-1",
      "h-2",
      "h-3",
      "h-4",
      "h-5",
      "h-6",
      "hand",
      "hashtag",
      "heading",
      "indent-decrease",
      "indent-increase",
      "info-i",
      "input-cursor-move",
      "input-field",
      "insert-column-left",
      "insert-column-right",
      "insert-row-bottom",
      "insert-row-top",
      "italic",
      "kanban-view",
      "kanban-view-2",
      "line-height",
      "link",
      "link-m",
      "link-unlink",
      "link-unlink-m",
      "list-check",
      "list-check-2",
      "list-check-3",
      "list-indefinite",
      "list-ordered",
      "list-ordered-2",
      "list-radio",
      "list-unordered",
      "list-view",
      "merge-cells-horizontal",
      "merge-cells-vertical",
      "mind-map",
      "node-tree",
      "number-0",
      "number-1",
      "number-2",
      "number-3",
      "number-4",
      "number-5",
      "number-6",
      "number-7",
      "number-8",
      "number-9",
      "omega",
      "organization-chart",
      "overline",
      "page-separator",
      "paragraph",
      "pinyin-input",
      "question-mark",
      "quote-text",
      "rounded-corner",
      "send-backward",
      "send-to-back",
      "separator",
      "single-quotes-l",
      "single-quotes-r",
      "sketching",
      "slash-commands",
      "slash-commands-2",
      "slideshow-view",
      "sort-alphabet-asc",
      "sort-alphabet-desc",
      "sort-asc",
      "sort-desc",
      "sort-number-asc",
      "sort-number-desc",
      "space",
      "split-cells-horizontal",
      "split-cells-vertical",
      "square-root",
      "stacked-view",
      "strikethrough",
      "strikethrough-2",
      "subscript",
      "subscript-2",
      "superscript",
      "superscript-2",
      "table-2",
      "table-3",
      "table-view",
      "text",
      "text-block",
      "text-direction-l",
      "text-direction-r",
      "text-snippet",
      "text-spacing",
      "text-wrap",
      "timeline-view",
      "translate",
      "translate-2",
      "underline",
      "wubi-input",
    ],
    Finance: [
      "24-hours-fill",
      "24-hours-line",
      "auction-fill",
      "auction-line",
      "bank-card-2-fill",
      "bank-card-2-line",
      "bank-card-fill",
      "bank-card-line",
      "bit-coin-fill",
      "bit-coin-line",
      "bnb-fill",
      "bnb-line",
      "btc-fill",
      "btc-line",
      "cash-fill",
      "cash-line",
      "coin-fill",
      "coin-line",
      "coins-fill",
      "coins-line",
      "copper-coin-fill",
      "copper-coin-line",
      "copper-diamond-fill",
      "copper-diamond-line",
      "coupon-2-fill",
      "coupon-2-line",
      "coupon-3-fill",
      "coupon-3-line",
      "coupon-4-fill",
      "coupon-4-line",
      "coupon-5-fill",
      "coupon-5-line",
      "coupon-fill",
      "coupon-line",
      "currency-fill",
      "currency-line",
      "discount-percent-fill",
      "discount-percent-line",
      "eth-fill",
      "eth-line",
      "exchange-2-fill",
      "exchange-2-line",
      "exchange-box-fill",
      "exchange-box-line",
      "exchange-cny-fill",
      "exchange-cny-line",
      "exchange-dollar-fill",
      "exchange-dollar-line",
      "exchange-fill",
      "exchange-funds-fill",
      "exchange-funds-line",
      "exchange-line",
      "funds-box-fill",
      "funds-box-line",
      "funds-fill",
      "funds-line",
      "gift-2-fill",
      "gift-2-line",
      "gift-fill",
      "gift-line",
      "hand-coin-fill",
      "hand-coin-line",
      "hand-heart-fill",
      "hand-heart-line",
      "increase-decrease-fill",
      "increase-decrease-line",
      "money-cny-box-fill",
      "money-cny-box-line",
      "money-cny-circle-fill",
      "money-cny-circle-line",
      "money-dollar-box-fill",
      "money-dollar-box-line",
      "money-dollar-circle-fill",
      "money-dollar-circle-line",
      "money-euro-box-fill",
      "money-euro-box-line",
      "money-euro-circle-fill",
      "money-euro-circle-line",
      "money-pound-box-fill",
      "money-pound-box-line",
      "money-pound-circle-fill",
      "money-pound-circle-line",
      "money-rupee-circle-fill",
      "money-rupee-circle-line",
      "nft-fill",
      "nft-line",
      "p2p-fill",
      "p2p-line",
      "percent-fill",
      "percent-line",
      "price-tag-2-fill",
      "price-tag-2-line",
      "price-tag-3-fill",
      "price-tag-3-line",
      "price-tag-fill",
      "price-tag-line",
      "red-packet-fill",
      "red-packet-line",
      "refund-2-fill",
      "refund-2-line",
      "refund-fill",
      "refund-line",
      "safe-2-fill",
      "safe-2-line",
      "safe-fill",
      "safe-line",
      "secure-payment-fill",
      "secure-payment-line",
      "shopping-bag-2-fill",
      "shopping-bag-2-line",
      "shopping-bag-3-fill",
      "shopping-bag-3-line",
      "shopping-bag-4-fill",
      "shopping-bag-4-line",
      "shopping-bag-fill",
      "shopping-bag-line",
      "shopping-basket-2-fill",
      "shopping-basket-2-line",
      "shopping-basket-fill",
      "shopping-basket-line",
      "shopping-cart-2-fill",
      "shopping-cart-2-line",
      "shopping-cart-fill",
      "shopping-cart-line",
      "stock-fill",
      "stock-line",
      "swap-2-fill",
      "swap-2-line",
      "swap-3-fill",
      "swap-3-line",
      "swap-box-fill",
      "swap-box-line",
      "swap-fill",
      "swap-line",
      "ticket-2-fill",
      "ticket-2-line",
      "ticket-fill",
      "ticket-line",
      "token-swap-fill",
      "token-swap-line",
      "trophy-fill",
      "trophy-line",
      "vip-crown-2-fill",
      "vip-crown-2-line",
      "vip-crown-fill",
      "vip-crown-line",
      "vip-diamond-fill",
      "vip-diamond-line",
      "vip-fill",
      "vip-line",
      "wallet-2-fill",
      "wallet-2-line",
      "wallet-3-fill",
      "wallet-3-line",
      "wallet-fill",
      "wallet-line",
      "water-flash-fill",
      "water-flash-line",
      "xrp-fill",
      "xrp-line",
      "xtz-fill",
      "xtz-line",
    ],
    Food: [
      "beer-fill",
      "beer-line",
      "bowl-fill",
      "bowl-line",
      "bread-fill",
      "bread-line",
      "cake-2-fill",
      "cake-2-line",
      "cake-3-fill",
      "cake-3-line",
      "cake-fill",
      "cake-line",
      "cup-fill",
      "cup-line",
      "drinks-2-fill",
      "drinks-2-line",
      "drinks-fill",
      "drinks-line",
      "goblet-2-fill",
      "goblet-2-line",
      "goblet-fill",
      "goblet-line",
      "knife-blood-fill",
      "knife-blood-line",
      "knife-fill",
      "knife-line",
      "restaurant-2-fill",
      "restaurant-2-line",
      "restaurant-fill",
      "restaurant-line",
    ],
    "Health & Medical": [
      "aed-electrodes-fill",
      "aed-electrodes-line",
      "aed-fill",
      "aed-line",
      "brain-2-fill",
      "brain-2-line",
      "brain-fill",
      "brain-line",
      "capsule-fill",
      "capsule-line",
      "dislike-fill",
      "dislike-line",
      "dna-fill",
      "dna-line",
      "dossier-fill",
      "dossier-line",
      "dropper-fill",
      "dropper-line",
      "empathize-fill",
      "empathize-line",
      "first-aid-kit-fill",
      "first-aid-kit-line",
      "flask-fill",
      "flask-line",
      "hand-sanitizer-fill",
      "hand-sanitizer-line",
      "health-book-fill",
      "health-book-line",
      "heart-2-fill",
      "heart-2-line",
      "heart-3-fill",
      "heart-3-line",
      "heart-add-2-fill",
      "heart-add-2-line",
      "heart-add-fill",
      "heart-add-line",
      "heart-fill",
      "heart-line",
      "heart-pulse-fill",
      "heart-pulse-line",
      "hearts-fill",
      "hearts-line",
      "infrared-thermometer-fill",
      "infrared-thermometer-line",
      "lungs-fill",
      "lungs-line",
      "medicine-bottle-fill",
      "medicine-bottle-line",
      "mental-health-fill",
      "mental-health-line",
      "microscope-fill",
      "microscope-line",
      "nurse-fill",
      "nurse-line",
      "psychotherapy-fill",
      "psychotherapy-line",
      "pulse-fill",
      "pulse-line",
      "rest-time-fill",
      "rest-time-line",
      "stethoscope-fill",
      "stethoscope-line",
      "surgical-mask-fill",
      "surgical-mask-line",
      "syringe-fill",
      "syringe-line",
      "test-tube-fill",
      "test-tube-line",
      "thermometer-fill",
      "thermometer-line",
      "virus-fill",
      "virus-line",
      "zzz-fill",
      "zzz-line",
    ],
    Logos: [
      "alibaba-cloud-fill",
      "alibaba-cloud-line",
      "alipay-fill",
      "alipay-line",
      "amazon-fill",
      "amazon-line",
      "android-fill",
      "android-line",
      "angularjs-fill",
      "angularjs-line",
      "app-store-fill",
      "app-store-line",
      "apple-fill",
      "apple-line",
      "baidu-fill",
      "baidu-line",
      "bard-fill",
      "bard-line",
      "behance-fill",
      "behance-line",
      "bilibili-fill",
      "bilibili-line",
      "blender-fill",
      "blender-line",
      "blogger-fill",
      "blogger-line",
      "bluesky-fill",
      "bluesky-line",
      "bootstrap-fill",
      "bootstrap-line",
      "centos-fill",
      "centos-line",
      "chrome-fill",
      "chrome-line",
      "codepen-fill",
      "codepen-line",
      "copilot-fill",
      "copilot-line",
      "coreos-fill",
      "coreos-line",
      "dingding-fill",
      "dingding-line",
      "discord-fill",
      "discord-line",
      "disqus-fill",
      "disqus-line",
      "douban-fill",
      "douban-line",
      "dribbble-fill",
      "dribbble-line",
      "drive-fill",
      "drive-line",
      "dropbox-fill",
      "dropbox-line",
      "edge-fill",
      "edge-line",
      "edge-new-fill",
      "edge-new-line",
      "evernote-fill",
      "evernote-line",
      "facebook-box-fill",
      "facebook-box-line",
      "facebook-circle-fill",
      "facebook-circle-line",
      "facebook-fill",
      "facebook-line",
      "finder-fill",
      "finder-line",
      "firebase-fill",
      "firebase-line",
      "firefox-fill",
      "firefox-line",
      "flickr-fill",
      "flickr-line",
      "flutter-fill",
      "flutter-line",
      "friendica-fill",
      "friendica-line",
      "gatsby-fill",
      "gatsby-line",
      "gemini-fill",
      "gemini-line",
      "github-fill",
      "github-line",
      "gitlab-fill",
      "gitlab-line",
      "google-fill",
      "google-line",
      "google-play-fill",
      "google-play-line",
      "honor-of-kings-fill",
      "honor-of-kings-line",
      "ie-fill",
      "ie-line",
      "instagram-fill",
      "instagram-line",
      "invision-fill",
      "invision-line",
      "java-fill",
      "java-line",
      "kakao-talk-fill",
      "kakao-talk-line",
      "kick-fill",
      "kick-line",
      "line-fill",
      "line-line",
      "linkedin-box-fill",
      "linkedin-box-line",
      "linkedin-fill",
      "linkedin-line",
      "mastercard-fill",
      "mastercard-line",
      "mastodon-fill",
      "mastodon-line",
      "medium-fill",
      "medium-line",
      "messenger-fill",
      "messenger-line",
      "meta-fill",
      "meta-line",
      "microsoft-fill",
      "microsoft-line",
      "microsoft-loop-fill",
      "microsoft-loop-line",
      "mini-program-fill",
      "mini-program-line",
      "netease-cloud-music-fill",
      "netease-cloud-music-line",
      "netflix-fill",
      "netflix-line",
      "nextjs-fill",
      "nextjs-line",
      "nodejs-fill",
      "nodejs-line",
      "notion-fill",
      "notion-line",
      "npmjs-fill",
      "npmjs-line",
      "open-source-fill",
      "open-source-line",
      "openai-fill",
      "openai-line",
      "openbase-fill",
      "openbase-line",
      "opera-fill",
      "opera-line",
      "patreon-fill",
      "patreon-line",
      "paypal-fill",
      "paypal-line",
      "pinterest-fill",
      "pinterest-line",
      "pixelfed-fill",
      "pixelfed-line",
      "playstation-fill",
      "playstation-line",
      "product-hunt-fill",
      "product-hunt-line",
      "qq-fill",
      "qq-line",
      "reactjs-fill",
      "reactjs-line",
      "reddit-fill",
      "reddit-line",
      "remix-run-fill",
      "remix-run-line",
      "remixicon-fill",
      "remixicon-line",
      "safari-fill",
      "safari-line",
      "skype-fill",
      "skype-line",
      "slack-fill",
      "slack-line",
      "snapchat-fill",
      "snapchat-line",
      "soundcloud-fill",
      "soundcloud-line",
      "spectrum-fill",
      "spectrum-line",
      "spotify-fill",
      "spotify-line",
      "stack-overflow-fill",
      "stack-overflow-line",
      "stackshare-fill",
      "stackshare-line",
      "steam-fill",
      "steam-line",
      "supabase-fill",
      "supabase-line",
      "svelte-fill",
      "svelte-line",
      "switch-fill",
      "switch-line",
      "tailwind-css-fill",
      "tailwind-css-line",
      "taobao-fill",
      "taobao-line",
      "telegram-2-fill",
      "telegram-2-line",
      "telegram-fill",
      "telegram-line",
      "threads-fill",
      "threads-line",
      "tiktok-fill",
      "tiktok-line",
      "trello-fill",
      "trello-line",
      "tumblr-fill",
      "tumblr-line",
      "twitch-fill",
      "twitch-line",
      "twitter-fill",
      "twitter-line",
      "twitter-x-fill",
      "twitter-x-line",
      "ubuntu-fill",
      "ubuntu-line",
      "unsplash-fill",
      "unsplash-line",
      "vimeo-fill",
      "vimeo-line",
      "visa-fill",
      "visa-line",
      "vk-fill",
      "vk-line",
      "vuejs-fill",
      "vuejs-line",
      "webhook-fill",
      "webhook-line",
      "wechat-2-fill",
      "wechat-2-line",
      "wechat-channels-fill",
      "wechat-channels-line",
      "wechat-fill",
      "wechat-line",
      "wechat-pay-fill",
      "wechat-pay-line",
      "weibo-fill",
      "weibo-line",
      "whatsapp-fill",
      "whatsapp-line",
      "windows-fill",
      "windows-line",
      "wordpress-fill",
      "wordpress-line",
      "xbox-fill",
      "xbox-line",
      "xing-fill",
      "xing-line",
      "youtube-fill",
      "youtube-line",
      "yuque-fill",
      "yuque-line",
      "zcool-fill",
      "zcool-line",
      "zhihu-fill",
      "zhihu-line",
    ],
    Map: [
      "anchor-fill",
      "anchor-line",
      "barricade-fill",
      "barricade-line",
      "bike-fill",
      "bike-line",
      "bus-2-fill",
      "bus-2-line",
      "bus-fill",
      "bus-line",
      "bus-wifi-fill",
      "bus-wifi-line",
      "car-fill",
      "car-line",
      "car-washing-fill",
      "car-washing-line",
      "caravan-fill",
      "caravan-line",
      "charging-pile-2-fill",
      "charging-pile-2-line",
      "charging-pile-fill",
      "charging-pile-line",
      "china-railway-fill",
      "china-railway-line",
      "compass-2-fill",
      "compass-2-line",
      "compass-3-fill",
      "compass-3-line",
      "compass-4-fill",
      "compass-4-line",
      "compass-discover-fill",
      "compass-discover-line",
      "compass-fill",
      "compass-line",
      "direction-fill",
      "direction-line",
      "e-bike-2-fill",
      "e-bike-2-line",
      "e-bike-fill",
      "e-bike-line",
      "earth-fill",
      "earth-line",
      "flight-land-fill",
      "flight-land-line",
      "flight-takeoff-fill",
      "flight-takeoff-line",
      "footprint-fill",
      "footprint-line",
      "gas-station-fill",
      "gas-station-line",
      "globe-fill",
      "globe-line",
      "guide-fill",
      "guide-line",
      "hotel-bed-fill",
      "hotel-bed-line",
      "lifebuoy-fill",
      "lifebuoy-line",
      "luggage-cart-fill",
      "luggage-cart-line",
      "luggage-deposit-fill",
      "luggage-deposit-line",
      "map-2-fill",
      "map-2-line",
      "map-fill",
      "map-line",
      "map-pin-2-fill",
      "map-pin-2-line",
      "map-pin-3-fill",
      "map-pin-3-line",
      "map-pin-4-fill",
      "map-pin-4-line",
      "map-pin-5-fill",
      "map-pin-5-line",
      "map-pin-add-fill",
      "map-pin-add-line",
      "map-pin-fill",
      "map-pin-line",
      "map-pin-range-fill",
      "map-pin-range-line",
      "map-pin-time-fill",
      "map-pin-time-line",
      "map-pin-user-fill",
      "map-pin-user-line",
      "motorbike-fill",
      "motorbike-line",
      "navigation-fill",
      "navigation-line",
      "oil-fill",
      "oil-line",
      "parking-box-fill",
      "parking-box-line",
      "parking-fill",
      "parking-line",
      "passport-fill",
      "passport-line",
      "pin-distance-fill",
      "pin-distance-line",
      "plane-fill",
      "plane-line",
      "planet-fill",
      "planet-line",
      "police-car-fill",
      "police-car-line",
      "pushpin-2-fill",
      "pushpin-2-line",
      "pushpin-fill",
      "pushpin-line",
      "riding-fill",
      "riding-line",
      "road-map-fill",
      "road-map-line",
      "roadster-fill",
      "roadster-line",
      "rocket-2-fill",
      "rocket-2-line",
      "rocket-fill",
      "rocket-line",
      "route-fill",
      "route-line",
      "run-fill",
      "run-line",
      "sailboat-fill",
      "sailboat-line",
      "ship-2-fill",
      "ship-2-line",
      "ship-fill",
      "ship-line",
      "signal-tower-fill",
      "signal-tower-line",
      "signpost-fill",
      "signpost-line",
      "space-ship-fill",
      "space-ship-line",
      "steering-2-fill",
      "steering-2-line",
      "steering-fill",
      "steering-line",
      "subway-fill",
      "subway-line",
      "subway-wifi-fill",
      "subway-wifi-line",
      "suitcase-2-fill",
      "suitcase-2-line",
      "suitcase-3-fill",
      "suitcase-3-line",
      "suitcase-fill",
      "suitcase-line",
      "takeaway-fill",
      "takeaway-line",
      "taxi-fill",
      "taxi-line",
      "taxi-wifi-fill",
      "taxi-wifi-line",
      "time-zone-fill",
      "time-zone-line",
      "traffic-light-fill",
      "traffic-light-line",
      "train-fill",
      "train-line",
      "train-wifi-fill",
      "train-wifi-line",
      "treasure-map-fill",
      "treasure-map-line",
      "truck-fill",
      "truck-line",
      "unpin-fill",
      "unpin-line",
      "walk-fill",
      "walk-line",
    ],
    Media: [
      "4k-fill",
      "4k-line",
      "album-fill",
      "album-line",
      "aspect-ratio-fill",
      "aspect-ratio-line",
      "broadcast-fill",
      "broadcast-line",
      "camera-2-fill",
      "camera-2-line",
      "camera-3-fill",
      "camera-3-line",
      "camera-fill",
      "camera-lens-fill",
      "camera-lens-line",
      "camera-line",
      "camera-off-fill",
      "camera-off-line",
      "camera-switch-fill",
      "camera-switch-line",
      "clapperboard-fill",
      "clapperboard-line",
      "closed-captioning-fill",
      "closed-captioning-line",
      "disc-fill",
      "disc-line",
      "dv-fill",
      "dv-line",
      "dvd-fill",
      "dvd-line",
      "eject-fill",
      "eject-line",
      "equalizer-2-fill",
      "equalizer-2-line",
      "equalizer-3-fill",
      "equalizer-3-line",
      "equalizer-fill",
      "equalizer-line",
      "film-fill",
      "film-line",
      "forward-10-fill",
      "forward-10-line",
      "forward-15-fill",
      "forward-15-line",
      "forward-30-fill",
      "forward-30-line",
      "forward-5-fill",
      "forward-5-line",
      "forward-end-fill",
      "forward-end-line",
      "forward-end-mini-fill",
      "forward-end-mini-line",
      "fullscreen-exit-fill",
      "fullscreen-exit-line",
      "fullscreen-fill",
      "fullscreen-line",
      "gallery-fill",
      "gallery-line",
      "gallery-upload-fill",
      "gallery-upload-line",
      "hd-fill",
      "hd-line",
      "headphone-fill",
      "headphone-line",
      "hq-fill",
      "hq-line",
      "image-2-fill",
      "image-2-line",
      "image-add-fill",
      "image-add-line",
      "image-circle-fill",
      "image-circle-line",
      "image-edit-fill",
      "image-edit-line",
      "image-fill",
      "image-line",
      "landscape-fill",
      "landscape-line",
      "live-fill",
      "live-line",
      "memories-fill",
      "memories-line",
      "mic-2-fill",
      "mic-2-line",
      "mic-fill",
      "mic-line",
      "mic-off-fill",
      "mic-off-line",
      "movie-2-fill",
      "movie-2-line",
      "movie-fill",
      "movie-line",
      "music-2-fill",
      "music-2-line",
      "music-fill",
      "music-line",
      "mv-fill",
      "mv-line",
      "notification-2-fill",
      "notification-2-line",
      "notification-3-fill",
      "notification-3-line",
      "notification-4-fill",
      "notification-4-line",
      "notification-fill",
      "notification-line",
      "notification-off-fill",
      "notification-off-line",
      "order-play-fill",
      "order-play-line",
      "pause-circle-fill",
      "pause-circle-line",
      "pause-fill",
      "pause-large-fill",
      "pause-large-line",
      "pause-line",
      "pause-mini-fill",
      "pause-mini-line",
      "phone-camera-fill",
      "phone-camera-line",
      "picture-in-picture-2-fill",
      "picture-in-picture-2-line",
      "picture-in-picture-exit-fill",
      "picture-in-picture-exit-line",
      "picture-in-picture-fill",
      "picture-in-picture-line",
      "play-circle-fill",
      "play-circle-line",
      "play-fill",
      "play-large-fill",
      "play-large-line",
      "play-line",
      "play-list-2-fill",
      "play-list-2-line",
      "play-list-add-fill",
      "play-list-add-line",
      "play-list-fill",
      "play-list-line",
      "play-mini-fill",
      "play-mini-line",
      "play-reverse-fill",
      "play-reverse-large-fill",
      "play-reverse-large-line",
      "play-reverse-line",
      "play-reverse-mini-fill",
      "play-reverse-mini-line",
      "polaroid-2-fill",
      "polaroid-2-line",
      "polaroid-fill",
      "polaroid-line",
      "radio-2-fill",
      "radio-2-line",
      "radio-fill",
      "radio-line",
      "record-circle-fill",
      "record-circle-line",
      "repeat-2-fill",
      "repeat-2-line",
      "repeat-fill",
      "repeat-line",
      "repeat-one-fill",
      "repeat-one-line",
      "replay-10-fill",
      "replay-10-line",
      "replay-15-fill",
      "replay-15-line",
      "replay-30-fill",
      "replay-30-line",
      "replay-5-fill",
      "replay-5-line",
      "rewind-fill",
      "rewind-line",
      "rewind-mini-fill",
      "rewind-mini-line",
      "rewind-start-fill",
      "rewind-start-line",
      "rewind-start-mini-fill",
      "rewind-start-mini-line",
      "rhythm-fill",
      "rhythm-line",
      "shuffle-fill",
      "shuffle-line",
      "skip-back-fill",
      "skip-back-line",
      "skip-back-mini-fill",
      "skip-back-mini-line",
      "skip-forward-fill",
      "skip-forward-line",
      "skip-forward-mini-fill",
      "skip-forward-mini-line",
      "slow-down-fill",
      "slow-down-line",
      "sound-module-fill",
      "sound-module-line",
      "speaker-2-fill",
      "speaker-2-line",
      "speaker-3-fill",
      "speaker-3-line",
      "speaker-fill",
      "speaker-line",
      "speed-fill",
      "speed-line",
      "speed-mini-fill",
      "speed-mini-line",
      "speed-up-fill",
      "speed-up-line",
      "stop-circle-fill",
      "stop-circle-line",
      "stop-fill",
      "stop-large-fill",
      "stop-large-line",
      "stop-line",
      "stop-mini-fill",
      "stop-mini-line",
      "surround-sound-fill",
      "surround-sound-line",
      "tape-fill",
      "tape-line",
      "video-add-fill",
      "video-add-line",
      "video-download-fill",
      "video-download-line",
      "video-fill",
      "video-line",
      "video-off-fill",
      "video-off-line",
      "video-on-fill",
      "video-on-line",
      "video-upload-fill",
      "video-upload-line",
      "vidicon-2-fill",
      "vidicon-2-line",
      "vidicon-fill",
      "vidicon-line",
      "voiceprint-fill",
      "voiceprint-line",
      "volume-down-fill",
      "volume-down-line",
      "volume-mute-fill",
      "volume-mute-line",
      "volume-off-vibrate-fill",
      "volume-off-vibrate-line",
      "volume-up-fill",
      "volume-up-line",
      "volume-vibrate-fill",
      "volume-vibrate-line",
      "webcam-fill",
      "webcam-line",
    ],
    Others: [
      "armchair-fill",
      "armchair-line",
      "basketball-fill",
      "basketball-line",
      "bell-fill",
      "bell-line",
      "billiards-fill",
      "billiards-line",
      "book-shelf-fill",
      "book-shelf-line",
      "box-1-fill",
      "box-1-line",
      "box-2-fill",
      "box-2-line",
      "box-3-fill",
      "box-3-line",
      "boxing-fill",
      "boxing-line",
      "cactus-fill",
      "cactus-line",
      "candle-fill",
      "candle-line",
      "character-recognition-fill",
      "character-recognition-line",
      "cross-fill",
      "cross-line",
      "dice-1-fill",
      "dice-1-line",
      "dice-2-fill",
      "dice-2-line",
      "dice-3-fill",
      "dice-3-line",
      "dice-4-fill",
      "dice-4-line",
      "dice-5-fill",
      "dice-5-line",
      "dice-6-fill",
      "dice-6-line",
      "dice-fill",
      "dice-line",
      "door-closed-fill",
      "door-closed-line",
      "door-fill",
      "door-line",
      "door-lock-box-fill",
      "door-lock-box-line",
      "door-lock-fill",
      "door-lock-line",
      "door-open-fill",
      "door-open-line",
      "flower-fill",
      "flower-line",
      "football-fill",
      "football-line",
      "fridge-fill",
      "fridge-line",
      "game-fill",
      "game-line",
      "glasses-2-fill",
      "glasses-2-line",
      "glasses-fill",
      "glasses-line",
      "goggles-fill",
      "goggles-line",
      "golf-ball-fill",
      "golf-ball-line",
      "graduation-cap-fill",
      "graduation-cap-line",
      "handbag-fill",
      "handbag-line",
      "infinity-fill",
      "infinity-line",
      "key-2-fill",
      "key-2-line",
      "key-fill",
      "key-line",
      "leaf-fill",
      "leaf-line",
      "lightbulb-fill",
      "lightbulb-flash-fill",
      "lightbulb-flash-line",
      "lightbulb-line",
      "outlet-2-fill",
      "outlet-2-line",
      "outlet-fill",
      "outlet-line",
      "ping-pong-fill",
      "ping-pong-line",
      "plant-fill",
      "plant-line",
      "plug-2-fill",
      "plug-2-line",
      "plug-fill",
      "plug-line",
      "police-badge-fill",
      "police-badge-line",
      "recycle-fill",
      "recycle-line",
      "reserved-fill",
      "reserved-line",
      "scales-2-fill",
      "scales-2-line",
      "scales-3-fill",
      "scales-3-line",
      "scales-fill",
      "scales-line",
      "seedling-fill",
      "seedling-line",
      "shirt-fill",
      "shirt-line",
      "sofa-fill",
      "sofa-line",
      "stairs-fill",
      "stairs-line",
      "sword-fill",
      "sword-line",
      "t-shirt-2-fill",
      "t-shirt-2-line",
      "t-shirt-air-fill",
      "t-shirt-air-line",
      "t-shirt-fill",
      "t-shirt-line",
      "tooth-fill",
      "tooth-line",
      "tree-fill",
      "tree-line",
      "umbrella-fill",
      "umbrella-line",
      "voice-recognition-fill",
      "voice-recognition-line",
      "weight-fill",
      "weight-line",
      "wheelchair-fill",
      "wheelchair-line",
    ],
    System: [
      "add-box-fill",
      "add-box-line",
      "add-circle-fill",
      "add-circle-line",
      "add-fill",
      "add-large-fill",
      "add-large-line",
      "add-line",
      "alarm-fill",
      "alarm-line",
      "alarm-warning-fill",
      "alarm-warning-line",
      "alert-fill",
      "alert-line",
      "apps-2-add-fill",
      "apps-2-add-line",
      "apps-2-fill",
      "apps-2-line",
      "apps-fill",
      "apps-line",
      "check-double-fill",
      "check-double-line",
      "check-fill",
      "check-line",
      "checkbox-blank-circle-fill",
      "checkbox-blank-circle-line",
      "checkbox-blank-fill",
      "checkbox-blank-line",
      "checkbox-circle-fill",
      "checkbox-circle-line",
      "checkbox-fill",
      "checkbox-indeterminate-fill",
      "checkbox-indeterminate-line",
      "checkbox-line",
      "checkbox-multiple-blank-fill",
      "checkbox-multiple-blank-line",
      "checkbox-multiple-fill",
      "checkbox-multiple-line",
      "close-circle-fill",
      "close-circle-line",
      "close-fill",
      "close-large-fill",
      "close-large-line",
      "close-line",
      "dashboard-fill",
      "dashboard-horizontal-fill",
      "dashboard-horizontal-line",
      "dashboard-line",
      "delete-back-2-fill",
      "delete-back-2-line",
      "delete-back-fill",
      "delete-back-line",
      "delete-bin-2-fill",
      "delete-bin-2-line",
      "delete-bin-3-fill",
      "delete-bin-3-line",
      "delete-bin-4-fill",
      "delete-bin-4-line",
      "delete-bin-5-fill",
      "delete-bin-5-line",
      "delete-bin-6-fill",
      "delete-bin-6-line",
      "delete-bin-7-fill",
      "delete-bin-7-line",
      "delete-bin-fill",
      "delete-bin-line",
      "divide-fill",
      "divide-line",
      "download-2-fill",
      "download-2-line",
      "download-cloud-2-fill",
      "download-cloud-2-line",
      "download-cloud-fill",
      "download-cloud-line",
      "download-fill",
      "download-line",
      "equal-fill",
      "equal-line",
      "error-warning-fill",
      "error-warning-line",
      "export-fill",
      "export-line",
      "external-link-fill",
      "external-link-line",
      "eye-2-fill",
      "eye-2-line",
      "eye-close-fill",
      "eye-close-line",
      "eye-fill",
      "eye-line",
      "eye-off-fill",
      "eye-off-line",
      "filter-2-fill",
      "filter-2-line",
      "filter-3-fill",
      "filter-3-line",
      "filter-fill",
      "filter-line",
      "filter-off-fill",
      "filter-off-line",
      "find-replace-fill",
      "find-replace-line",
      "forbid-2-fill",
      "forbid-2-line",
      "forbid-fill",
      "forbid-line",
      "function-add-fill",
      "function-add-line",
      "function-fill",
      "function-line",
      "history-fill",
      "history-line",
      "hourglass-2-fill",
      "hourglass-2-line",
      "hourglass-fill",
      "hourglass-line",
      "import-fill",
      "import-line",
      "indeterminate-circle-fill",
      "indeterminate-circle-line",
      "information-2-fill",
      "information-2-line",
      "information-fill",
      "information-line",
      "information-off-fill",
      "information-off-line",
      "list-settings-fill",
      "list-settings-line",
      "loader-2-fill",
      "loader-2-line",
      "loader-3-fill",
      "loader-3-line",
      "loader-4-fill",
      "loader-4-line",
      "loader-5-fill",
      "loader-5-line",
      "loader-fill",
      "loader-line",
      "lock-2-fill",
      "lock-2-line",
      "lock-fill",
      "lock-line",
      "lock-password-fill",
      "lock-password-line",
      "lock-star-fill",
      "lock-star-line",
      "lock-unlock-fill",
      "lock-unlock-line",
      "login-box-fill",
      "login-box-line",
      "login-circle-fill",
      "login-circle-line",
      "logout-box-fill",
      "logout-box-line",
      "logout-box-r-fill",
      "logout-box-r-line",
      "logout-circle-fill",
      "logout-circle-line",
      "logout-circle-r-fill",
      "logout-circle-r-line",
      "loop-left-fill",
      "loop-left-line",
      "loop-right-fill",
      "loop-right-line",
      "menu-2-fill",
      "menu-2-line",
      "menu-3-fill",
      "menu-3-line",
      "menu-4-fill",
      "menu-4-line",
      "menu-5-fill",
      "menu-5-line",
      "menu-add-fill",
      "menu-add-line",
      "menu-fill",
      "menu-fold-2-fill",
      "menu-fold-2-line",
      "menu-fold-3-fill",
      "menu-fold-3-line",
      "menu-fold-4-fill",
      "menu-fold-4-line",
      "menu-fold-fill",
      "menu-fold-line",
      "menu-line",
      "menu-search-fill",
      "menu-search-line",
      "menu-unfold-2-fill",
      "menu-unfold-2-line",
      "menu-unfold-3-fill",
      "menu-unfold-3-line",
      "menu-unfold-4-fill",
      "menu-unfold-4-line",
      "menu-unfold-fill",
      "menu-unfold-line",
      "more-2-fill",
      "more-2-line",
      "more-fill",
      "more-line",
      "notification-badge-fill",
      "notification-badge-line",
      "progress-1-fill",
      "progress-1-line",
      "progress-2-fill",
      "progress-2-line",
      "progress-3-fill",
      "progress-3-line",
      "progress-4-fill",
      "progress-4-line",
      "progress-5-fill",
      "progress-5-line",
      "progress-6-fill",
      "progress-6-line",
      "progress-7-fill",
      "progress-7-line",
      "progress-8-fill",
      "progress-8-line",
      "prohibited-2-fill",
      "prohibited-2-line",
      "prohibited-fill",
      "prohibited-line",
      "question-fill",
      "question-line",
      "radio-button-fill",
      "radio-button-line",
      "refresh-fill",
      "refresh-line",
      "reset-left-fill",
      "reset-left-line",
      "reset-right-fill",
      "reset-right-line",
      "search-2-fill",
      "search-2-line",
      "search-eye-fill",
      "search-eye-line",
      "search-fill",
      "search-line",
      "settings-2-fill",
      "settings-2-line",
      "settings-3-fill",
      "settings-3-line",
      "settings-4-fill",
      "settings-4-line",
      "settings-5-fill",
      "settings-5-line",
      "settings-6-fill",
      "settings-6-line",
      "settings-fill",
      "settings-line",
      "share-2-fill",
      "share-2-line",
      "share-box-fill",
      "share-box-line",
      "share-circle-fill",
      "share-circle-line",
      "share-fill",
      "share-forward-2-fill",
      "share-forward-2-line",
      "share-forward-box-fill",
      "share-forward-box-line",
      "share-forward-fill",
      "share-forward-line",
      "share-line",
      "shield-check-fill",
      "shield-check-line",
      "shield-cross-fill",
      "shield-cross-line",
      "shield-fill",
      "shield-flash-fill",
      "shield-flash-line",
      "shield-keyhole-fill",
      "shield-keyhole-line",
      "shield-line",
      "shield-star-fill",
      "shield-star-line",
      "shield-user-fill",
      "shield-user-line",
      "side-bar-fill",
      "side-bar-line",
      "sidebar-fold-fill",
      "sidebar-fold-line",
      "sidebar-unfold-fill",
      "sidebar-unfold-line",
      "spam-2-fill",
      "spam-2-line",
      "spam-3-fill",
      "spam-3-line",
      "spam-fill",
      "spam-line",
      "star-fill",
      "star-half-fill",
      "star-half-line",
      "star-half-s-fill",
      "star-half-s-line",
      "star-line",
      "star-s-fill",
      "star-s-line",
      "subtract-fill",
      "subtract-line",
      "thumb-down-fill",
      "thumb-down-line",
      "thumb-up-fill",
      "thumb-up-line",
      "time-fill",
      "time-line",
      "timer-2-fill",
      "timer-2-line",
      "timer-fill",
      "timer-flash-fill",
      "timer-flash-line",
      "timer-line",
      "toggle-fill",
      "toggle-line",
      "upload-2-fill",
      "upload-2-line",
      "upload-cloud-2-fill",
      "upload-cloud-2-line",
      "upload-cloud-fill",
      "upload-cloud-line",
      "upload-fill",
      "upload-line",
      "zoom-in-fill",
      "zoom-in-line",
      "zoom-out-fill",
      "zoom-out-line",
    ],
    "User & Faces": [
      "account-box-fill",
      "account-box-line",
      "account-circle-fill",
      "account-circle-line",
      "account-pin-box-fill",
      "account-pin-box-line",
      "account-pin-circle-fill",
      "account-pin-circle-line",
      "admin-fill",
      "admin-line",
      "aliens-fill",
      "aliens-line",
      "bear-smile-fill",
      "bear-smile-line",
      "body-scan-fill",
      "body-scan-line",
      "contacts-fill",
      "contacts-line",
      "criminal-fill",
      "criminal-line",
      "emotion-2-fill",
      "emotion-2-line",
      "emotion-fill",
      "emotion-happy-fill",
      "emotion-happy-line",
      "emotion-laugh-fill",
      "emotion-laugh-line",
      "emotion-line",
      "emotion-normal-fill",
      "emotion-normal-line",
      "emotion-sad-fill",
      "emotion-sad-line",
      "emotion-unhappy-fill",
      "emotion-unhappy-line",
      "genderless-fill",
      "genderless-line",
      "ghost-2-fill",
      "ghost-2-line",
      "ghost-fill",
      "ghost-line",
      "ghost-smile-fill",
      "ghost-smile-line",
      "group-2-fill",
      "group-2-line",
      "group-3-fill",
      "group-3-line",
      "group-fill",
      "group-line",
      "men-fill",
      "men-line",
      "mickey-fill",
      "mickey-line",
      "open-arm-fill",
      "open-arm-line",
      "parent-fill",
      "parent-line",
      "robot-2-fill",
      "robot-2-line",
      "robot-3-fill",
      "robot-3-line",
      "robot-fill",
      "robot-line",
      "skull-2-fill",
      "skull-2-line",
      "skull-fill",
      "skull-line",
      "spy-fill",
      "spy-line",
      "star-smile-fill",
      "star-smile-line",
      "team-fill",
      "team-line",
      "travesti-fill",
      "travesti-line",
      "user-2-fill",
      "user-2-line",
      "user-3-fill",
      "user-3-line",
      "user-4-fill",
      "user-4-line",
      "user-5-fill",
      "user-5-line",
      "user-6-fill",
      "user-6-line",
      "user-add-fill",
      "user-add-line",
      "user-fill",
      "user-follow-fill",
      "user-follow-line",
      "user-forbid-fill",
      "user-forbid-line",
      "user-heart-fill",
      "user-heart-line",
      "user-line",
      "user-location-fill",
      "user-location-line",
      "user-minus-fill",
      "user-minus-line",
      "user-received-2-fill",
      "user-received-2-line",
      "user-received-fill",
      "user-received-line",
      "user-search-fill",
      "user-search-line",
      "user-settings-fill",
      "user-settings-line",
      "user-shared-2-fill",
      "user-shared-2-line",
      "user-shared-fill",
      "user-shared-line",
      "user-smile-fill",
      "user-smile-line",
      "user-star-fill",
      "user-star-line",
      "user-unfollow-fill",
      "user-unfollow-line",
      "user-voice-fill",
      "user-voice-line",
      "women-fill",
      "women-line",
    ],
    Weather: [
      "blaze-fill",
      "blaze-line",
      "celsius-fill",
      "celsius-line",
      "cloud-windy-fill",
      "cloud-windy-line",
      "cloudy-2-fill",
      "cloudy-2-line",
      "cloudy-fill",
      "cloudy-line",
      "drizzle-fill",
      "drizzle-line",
      "earthquake-fill",
      "earthquake-line",
      "fahrenheit-fill",
      "fahrenheit-line",
      "fire-fill",
      "fire-line",
      "flashlight-fill",
      "flashlight-line",
      "flood-fill",
      "flood-line",
      "foggy-fill",
      "foggy-line",
      "hail-fill",
      "hail-line",
      "haze-2-fill",
      "haze-2-line",
      "haze-fill",
      "haze-line",
      "heavy-showers-fill",
      "heavy-showers-line",
      "meteor-fill",
      "meteor-line",
      "mist-fill",
      "mist-line",
      "moon-clear-fill",
      "moon-clear-line",
      "moon-cloudy-fill",
      "moon-cloudy-line",
      "moon-fill",
      "moon-foggy-fill",
      "moon-foggy-line",
      "moon-line",
      "rainbow-fill",
      "rainbow-line",
      "rainy-fill",
      "rainy-line",
      "shining-2-fill",
      "shining-2-line",
      "shining-fill",
      "shining-line",
      "showers-fill",
      "showers-line",
      "snowflake-fill",
      "snowflake-line",
      "snowy-fill",
      "snowy-line",
      "sparkling-2-fill",
      "sparkling-2-line",
      "sparkling-fill",
      "sparkling-line",
      "sun-cloudy-fill",
      "sun-cloudy-line",
      "sun-fill",
      "sun-foggy-fill",
      "sun-foggy-line",
      "sun-line",
      "temp-cold-fill",
      "temp-cold-line",
      "temp-hot-fill",
      "temp-hot-line",
      "thunderstorms-fill",
      "thunderstorms-line",
      "tornado-fill",
      "tornado-line",
      "typhoon-fill",
      "typhoon-line",
      "water-percent-fill",
      "water-percent-line",
      "windy-fill",
      "windy-line",
    ],
  },
  suffixes: {
    line: "Line",
    fill: "Fill",
  },
  width: 24,
  height: 24,
  tags: {
    Arrows: {
      "arrow-left-up": "corner,左上",
      "arrow-up": "send,箭头,向上,发送",
      "arrow-right-up": "send,corner,右上,发送",
      "arrow-right": "forward,箭头,向右",
      "arrow-right-down": "corner,右下",
      "arrow-down": "receive,箭头,向下,接收,收款",
      "arrow-left-down": "receive,corner,箭头,左下,接收,收款",
      "arrow-left": "backward,箭头,向左,返回",
      "corner-right-up": "arrow,箭头,右上",
      "corner-up-left": "arrow,箭头,上左",
      "corner-up-right": "arrow,箭头,上右",
      "corner-right-down": "arrow,箭头,右下",
      "corner-down-left": "arrow,箭头,下左",
      "corner-left-up": "arrow,箭头,左上",
      "corner-left-down": "arrow,箭头,左下",
      "corner-down-right": "arrow,箭头,下右",
      "arrow-up-circle": "箭头,向上",
      "arrow-right-circle": "forward,箭头,向右",
      "arrow-down-circle": "箭头,向下,下载",
      "arrow-left-circle": "backward,箭头,向左,返回",
      "arrow-up-s": "chevron,箭头,向上",
      "arrow-right-s": "chevron,forward,箭头,向右",
      "arrow-down-s": "chevron,箭头,向下",
      "arrow-left-s": "chevron,backward,箭头,向左,返回",
      "skip-up": "arrow,unfold,top,expand,置顶,展开,收起",
      "skip-right": "arrow,unfold,next,expand,跳过,展开,收起",
      "skip-down": "arrow,unfold,next,expand,跳过,展开,收起",
      "skip-left": "arrow,unfold,expand,bottom,展开,收起",
      "arrow-left-right": "exchange,swap,箭头,左右,交换,换算,兑换",
      "arrow-up-down": "exchange,swap,箭头,上下,交换,换算,兑换",
      "arrow-drop-up": "chevron,箭头,向上",
      "arrow-drop-right": "chevron,forward,箭头,向右",
      "arrow-drop-down": "chevron,箭头,向下",
      "arrow-drop-left": "chevron,backward,箭头,向左,返回",
      "arrow-up-wide": "expand,箭头,向上,展开",
      "arrow-right-wide": "expand,箭头,向上,展开",
      "arrow-down-wide": "expand,箭头,向上,展开",
      "arrow-left-wide": "expand,箭头,向上,展开",
      "arrow-up-double": "unfold,expand,top,chevron,展开,收起",
      "arrow-right-double": "unfold,expand,chevron,展开,收起",
      "arrow-down-double": "unfold,expand,chevron,展开,收起",
      "arrow-left-double": "unfold,expand,chevron,展开,收起",
      "corner-up-left-double": "arrow,replay-all,回复全部",
      "corner-up-right-double": "arrow,forward-all,转发全部",
      "drag-move": "arrow,拖拽,移动,箭头",
      "drag-move-2": "arrow,拖拽,移动,箭头",
      "expand-left": "slide,pull,unfold,arrow",
      "expand-right": "arrow,展开,收起,右",
      "contract-left": "slide,pull,fold,arrow",
      "contract-right": "arrow,slide,pull,fold,展开,收起,右",
      "expand-up-down": "arrow,unfold,dropdown,switch,展开",
      "expand-left-right": "arrow,unfold,dropdown,switch",
      "contract-up-down": "fold,arrow,fold,收起",
      "contract-left-right": "arrow,fold,收起",
      "expand-height": "arrow,unfold,switch,展开",
      "expand-width": "arrow,unfold,switch,展开",
      "expand-horizontal": "arrow,unfold,switch,展开",
      "expand-vertical": "arrow,unfold,dropdown,switch,展开",
      "collapse-horizontal": "arrow,scale,收起,缩小",
      "collapse-vertical": "arrow,scale,收起,缩小",
      "expand-diagonal": "arrow,scale,展开,放大",
      "expand-diagonal-2": "arrow,scale,展开,放大",
      "collapse-diagonal": "arrow,scale,收起,缩小",
      "collapse-diagonal-2": "arrow,scale,收起,缩小",
      "expand-horizontal-s": "arrow,unfold,switch,展开",
      "expand-vertical-s": "arrow,unfold,switch,展开",
      "expand-diagonal-s": "arrow,scale,展开,放大",
      "expand-diagonal-s-2": "arrow,scale,展开,放大",
      "arrow-go-back": "undo,箭头,返回,撤销,撤回",
      "arrow-go-forward": "redo,箭头,重做,撤销,撤回",
      "arrow-turn-forward": "箭头,掉头",
      "arrow-turn-back": "箭头,掉头",
      "scroll-to-bottom": "mouse,滚动到底部,鼠标",
    },
    Buildings: {
      home: "house,房子,家,主页",
      "home-2": "house,房子,家,主页",
      "home-3": "house,房子,家,主页",
      "home-4": "house,房子,家,主页",
      "home-5": "house,房子,家,主页",
      "home-6": "house,房子,家,主页",
      "home-7": "house,房子,家,主页",
      "home-8": "house,房子,家,主页",
      "home-gear": "house,房子,工厂",
      "home-wifi": "smart home,房子,家具,智能家居",
      "home-smile": "house,smart home,smile,房子,智能家居,微笑",
      "home-smile-2": "house,smart home,smile,房子,智能家居,微笑",
      "home-heart": "house,心,房子,家,主页,孤儿院",
      "home-office": "居家办公",
      building: "city,office,enterprise,建筑,城市,楼,办公楼,写字楼,企业",
      "building-2": "city,office,construction,enterprise,城市,建筑,楼,企业",
      "building-3": "factory,plant,enterprise,工厂,建筑,楼,企业",
      "building-4": "city,office,enterprise,建筑,城市,楼,办公楼,写字楼,企业",
      hotel:
        "building,hotel,office,enterprise,tavern,建筑,酒店,楼,办公楼,写字楼,企业",
      community: "building,hotel,社区,建筑,酒店",
      school: "college,university,学校,学院",
      government: "building,政府,建筑,大会堂",
      bank: "bank,finance,savings,banking,银行,交易所",
      store: "shop,mall,supermarket,retail,商店,超市,店铺,商家",
      "store-2": "shop,mall,supermarket,retail,商店,超市,店铺,商家",
      "store-3": "shop,mall,supermarket,retail,商店,超市,店铺,商家",
      hospital: "medical,health,医院",
      "ancient-gate":
        "historical,genre,scenic,trip,travel,旅行,旅游,城门,古代,历史,景区",
      "ancient-pavilion":
        "historical,genre,scenic,trip,travel,旅行,旅游,凉亭,古代,历史,景区",
      tent: "camping,帐篷,露营,营地",
    },
    Business: {
      mail: "envelope,email,inbox,信封,邮箱,邮件,收件箱",
      "mail-open": "envelope,email,inbox,信封,邮箱,邮件,收件箱",
      "mail-send":
        "envelope,email,inbox,zoom,whoosh,信封,邮箱,邮件,发送,发件箱",
      "mail-unread": "envelope,email,inbox,信封,邮箱,邮件,未读",
      "mail-add": "envelope,email,inbox,add,信封,邮箱,邮件,新增,添加",
      "mail-check": "envelope,email,inbox,read,信封,邮箱,邮件,已读",
      "mail-close": "envelope,email,inbox,failed,x,信封,邮箱,邮件,失败",
      "mail-download": "envelope,email,inbox,download,信封,邮箱,邮件,下载",
      "mail-forbid": "envelope,email,inbox,privacy,信封,邮箱,邮件,禁止",
      "mail-lock": "envelope,email,inbox,lock,信封,邮箱,邮件,加密",
      "mail-settings": "envelope,email,inbox,settings,信封,邮箱,邮件,设置",
      "mail-star": "envelope,email,inbox,favorite,信封,邮箱,邮件,收藏,喜欢",
      "mail-volume":
        "envelope,email,inbox,promotional email,email campaign,subscription,sound,信封,邮箱,邮件,收件箱,推广,订阅",
      inbox: "收件箱",
      "inbox-2": "收件箱",
      "inbox-archive": "收件箱,归档,收纳",
      "inbox-unarchive": "unzip,unpack,extract,收件箱,取消归档,还原,解压缩",
      cloud: "weather,云端",
      "cloud-off":
        "offline mode,connection fail,slash,weather,云端,断网,无信号,连接失败",
      attachment: "annex,paperclip,附件,曲别针",
      profile: "id,档案,资料,身份证,证件",
      archive: "box,收纳,归档,存档,盒子,纸箱",
      "archive-2": "box,收纳,归档,存档,盒子,纸箱",
      "archive-drawer": "night table,收纳,抽屉,归档,存档,床头柜",
      "archive-stack": "box,收纳,归档,存档,盒子,纸箱,堆叠",
      at: "@,mention,提到,在",
      award: "medal,achievement,badge,成就,奖牌,金牌,勋章",
      medal: "award,achievement,badge,成就,奖牌,金牌,勋章",
      "medal-2": "award,achievement,badge,成就,奖牌,金牌,勋章",
      "verified-badge": "认证标志",
      "bar-chart": "statistics,rhythm,柱状图,统计,韵律,节奏",
      "bar-chart-horizontal": "statistics,rhythm,柱状图,统计,韵律,节奏",
      "bar-chart-2": "statistics,rhythm,柱状图,统计,排行,节奏",
      "bar-chart-box": "statistics,rhythm,柱状图,统计,节奏",
      "bar-chart-grouped": "statistics,rhythm,柱状图,统计,分组",
      "bubble-chart": "data,analysis,statistics,circles,气泡图,统计",
      "pie-chart": "data,analysis,饼图,饼状图,数据,分析",
      "pie-chart-2": "data,analysis,饼图,饼状图,数据,分析",
      "pie-chart-box": "data,analysis,饼图,饼状图,数据,分析",
      "donut-chart": "data,analysis,circle,pie,环形图,数据,分析",
      "line-chart": "data,analysis,stats,折线图,数据,分析",
      bookmark: "tag,书签,标记",
      "bookmark-2": "tag,书签,标记",
      "bookmark-3": "tag,书签,标记,荣誉",
      briefcase: "bag,baggage,公文包,行李箱,旅行箱,皮包",
      "briefcase-2": "bag,baggage,公文包,行李箱,旅行箱,皮包",
      "briefcase-3": "bag,baggage,公文包,行李箱,旅行箱,皮包",
      "briefcase-4": "bag,baggage,公文包,行李箱,旅行箱,皮包",
      "briefcase-5": "bag,baggage,公文包,行李箱,旅行箱,皮包",
      calculator: "计算器,计算机",
      calendar: "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
      "calendar-2": "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
      "calendar-event":
        "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
      "calendar-todo":
        "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
      "calendar-check":
        "date,plan,schedule,agenda,check-in,punch,日历,日期,月份,计划,日程,时间表,签到,打卡",
      "calendar-close":
        "date,plan,schedule,agenda,error,cancel,日历,日期,月份,计划,日程,时间表,取消,错误",
      "calendar-schedule":
        "date,plan,schedule,agenda,date,time,日历,日期,月份,计划,日程,时间表,预定,预约",
      "customer-service": "headset,headphones,earphones,客服,售后,耳机,耳麦",
      "customer-service-2":
        "headset,headphones,earphones,smile,客服,售后,耳机,耳麦",
      flag: "banner,pin,mark,milestone,旗帜,旗子,国旗,标记,里程碑",
      "flag-2": "banner,pin,mark,milestone,旗帜,旗子,国旗,标记,里程碑",
      "triangular-flag": "banner,pin,mark,milestone,旗帜,旗子,国旗,标记,里程碑",
      global: "earth,union,world,language,地球,联合,世界,全球,语言",
      honour: "honor,glory,锦旗,荣誉,荣耀,军衔",
      links: "connection,address,联系,链接,地址",
      printer: "打印机",
      "printer-cloud": "network,打印机,云打印",
      "record-mail": "voice mail,tape,录音,留言,语音信箱,磁带",
      reply: "forward,回复全部,回复所有",
      "reply-all": "forward,回复,答复,留言,转发",
      "send-plane": "发送,纸飞机",
      "send-plane-2": "发送,纸飞机",
      projector: "projection,meeting,投影仪,会议室",
      "projector-2": "projection,meeting,投影仪,会议室,极米",
      slideshow:
        "presentation,meeting,PPT,keynote,投影,放映,演示,演讲,幻灯片,会议室",
      "slideshow-2": "presentation,meeting,投影,放映,演示,演讲,幻灯片,会议室",
      "slideshow-3":
        "presentation,meeting,投影,放映,演示,演讲,视频会议,幻灯片,会议室",
      "slideshow-4":
        "presentation,meeting,投影,放映,演示,演讲,可视对讲,幻灯片,会议室",
      presentation: "teaching,training,演讲,老师,培训",
      window: "browser,program,web,窗口,浏览器,程序,网站",
      "window-2": "browser,program,web,窗口,浏览器,程序,网站",
      stack: "layers,图层,叠加,堆栈",
      "shake-hands": "cooperation,business,握手,合作,商务",
      service: "heart,handshake,cooperation,client,服务,握手,心,合作",
      registered: "注册,商标",
      trademark: "注册,商标",
      advertisement: "ad,广告,推广",
      copyleft: "著佐权",
      copyright: "版权",
      "creative-commons": "知识共享",
      "creative-commons-by": "attribution,copyright,版权,知识共享,署名",
      "creative-commons-nc": "noncommercial,copyright,版权,知识共享,非商业用途",
      "creative-commons-nd":
        "no derivative works,copyright,版权,知识共享,禁止演绎",
      "creative-commons-sa": "share alike,copyright,版权,知识共享,相同方式共享",
      "creative-commons-zero": "cc0,copyright,版权,知识共享",
      megaphone:
        "bullhorn,loudspeaker,commercial,campaign,扩音器,喇叭,广告,活动",
      "pass-valid": "id,passport,护照有效",
      "pass-pending": "id,passport,护照等待",
      "pass-expired": "id,passport,护照过期",
      "id-card":
        "card,identity,user,license,badge,passport,身份证,用户,许可证,护照",
      seo: "搜索引擎优化",
    },
    Communication: {
      "chat-1": "message,reply,comment,消息,聊天,回复,评论",
      "chat-2": "message,reply,comment,消息,聊天,回复,评论",
      "chat-3": "message,reply,comment,消息,聊天,回复,评论",
      "chat-4": "message,reply,comment,消息,聊天,回复,评论",
      message: "chat,comment,reply,消息,聊天,回复,评论",
      "message-2": "chat,reply,comment,消息,聊天,回复,评论",
      "message-3": "chat,reply,comment,消息,聊天,回复,评论",
      "chat-check": "message,reply,comment,消息,聊天,回复,评论,已阅",
      "chat-delete": "message,comment,消息,聊天,回复,评论,清除,删除",
      "chat-forward": "message,comment,消息,聊天,转发",
      "chat-upload": "message,comment,消息,聊天,上传",
      "chat-download": "message,comment,消息,下载",
      "chat-new": "message,reply,comment,消息,聊天,回复,评论",
      "chat-settings": "message,comment,消息,聊天,回复,评论,设置",
      "chat-unread": "new message,comment,badge,消息,聊天,回复,评论,未读",
      "chat-search": "message,comment,消息,聊天,回复,评论,搜索,放大镜",
      "chat-smile": "message,reply,comment,消息,聊天,回复,评论",
      "chat-smile-2": "message,reply,comment,消息,聊天,回复,评论",
      "chat-smile-3": "message,reply,comment,消息,聊天,回复,评论",
      "chat-heart": "message,reply,comment,消息,聊天,回复,评论,心,点赞,收藏",
      "chat-off": "message,reply,comment,slash,消息,聊天,回复,评论,禁止,关闭",
      feedback: "message,comment,消息,聊天,回复,评论,反馈",
      discuss: "message,reply,comment,消息,聊天,回复,评论,讨论,群聊",
      "question-answer": "message,reply,comment,消息,聊天,回复,评论,讨论,群聊",
      questionnaire:
        "message,comment,help,消息,聊天,回复,评论,讨论,调查问卷,帮助",
      "video-chat": "message,comment,消息,视频聊天",
      "chat-voice": "message,comment,消息,语音消息",
      "chat-quote": "message,reply,comment,消息,引用回复",
      "chat-follow-up": "message,reply,comment,消息,+1,跟帖",
      "chat-poll": "message,vote,questionnaire,消息,投票,问卷调查",
      "chat-history": "message,历史消息,消息记录",
      "chat-private": "message,私密消息,密聊",
      "chat-thread": "topic,hashtag,话题,井号,哈希",
      speak: "voice,讲话,声音",
      "emoji-sticker": "表情,贴纸",
    },
    Design: {
      pencil: "edit,铅笔,编辑",
      edit: "pencil,铅笔,编辑",
      "edit-2": "pencil,铅笔,编辑",
      "ball-pen": "圆珠笔",
      "quill-pen": "羽毛笔,钢笔,编辑",
      "pen-nib": "钢笔,笔尖",
      "ink-bottle": "墨水瓶",
      "mark-pen": "马克笔",
      markup: "标记,马克",
      "edit-box": "编辑",
      "edit-circle": "编辑",
      sip: "吸管,取色器",
      brush: "笔刷,画笔,刷子",
      "brush-2": "刷子",
      "brush-3": "刷子",
      "brush-4": "刷子",
      "paint-brush": "填色,填充,刷子",
      contrast: "brightness,tonalit,对比度,亮度,色调",
      "contrast-2": "moon,dark,brightness,tonalit,月亮,夜间,对比度,亮度,色调",
      drop: "water,blur,模糊,水,滴",
      "blur-off": "water,drop,slash,模糊,水,滴,禁止,关闭",
      "contrast-drop": "water,brightness,tonalit,水,对比度,亮度,色调,滴",
      "contrast-drop-2": "water,brightness,tonalit,水,对比度,亮度,色调,滴",
      "color-filter": "effect,滤镜,特效",
      compasses: "圆规",
      "compasses-2": "圆规",
      scissors: "剪刀,裁剪",
      "scissors-cut": "剪刀,裁剪",
      "scissors-2": "剪刀,裁剪,截屏",
      slice: "knife,切图,切片,刀",
      eraser: "remove formatting,橡皮,擦除,清除格式",
      ruler: "尺子",
      "ruler-2": "尺子",
      "pencil-ruler": "design,铅笔,尺子,文具,设计",
      "pencil-ruler-2": "design,铅笔,尺子,文具,设计",
      "t-box": "文字,字体,字号",
      "input-method": "输入法,文字",
      artboard: "grid,crop,画板,裁切",
      "artboard-2": "画板",
      crop: "裁切",
      "crop-2": "裁切",
      screenshot: "capture,屏幕截图,截屏",
      "screenshot-2": "capture,屏幕截图,截屏",
      focus: "aim,target,goal,焦点,聚焦,目标,靶心",
      "focus-2": "aim,target,goal,bullseye,焦点,聚焦,目标,靶心",
      "focus-3":
        "aim,target,goal,bullseye,crosshair,locate,焦点,聚焦,目标,靶心,瞄准镜,准心,定位",
      crosshair:
        "aim,target,goal,bullseye,crosshair,locate,焦点,聚焦,目标,靶心,瞄准镜,准心,定位",
      "crosshair-2":
        "aim,target,goal,bullseye,crosshair,locate,焦点,聚焦,目标,靶心,瞄准镜,准心,定位",
      paint: "fill,填色,填充,油漆桶",
      palette: "color,调色盘,色板",
      pantone: "color,色板,潘通色,色号",
      shape: "border,形状,描边,边框",
      "shape-2": "border,形状,描边,边框",
      magic: "fantasy,magic stick,beautify,wand,魔法棒,美化,幻想,魔幻",
      anticlockwise: "rotate,left,counterclockwise,左翻转,左旋转",
      "anticlockwise-2": "rotate,left,counterclockwise,左翻转,左旋转",
      clockwise: "rotate,right,右翻转,右旋转",
      "clockwise-2": "rotate,right,右翻转,右旋转",
      hammer: "tool,锤子",
      tools: "settings,screwdriver,configuration,工具,设置",
      "drag-drop": "drag and drop,mouse,拖拽,鼠标",
      table: "表格",
      "table-alt": "表格",
      layout: "布局",
      "layout-2": "collage,布局,拼贴画",
      "layout-3": "collage,布局,拼贴画",
      "layout-4": "collage,布局,拼贴画",
      "layout-5": "collage,布局,拼贴画",
      "layout-6": "collage,布局,拼贴画",
      "layout-column": "左右布局",
      "layout-row": "上下布局",
      "layout-top": "顶部布局,顶部导航",
      "layout-right": "右侧布局,右侧导航",
      "layout-bottom": "底部布局,底部导航",
      "layout-left": "左侧布局,左侧导航",
      "layout-top-2": "顶部布局,顶部导航",
      "layout-right-2": "右侧布局,右侧导航",
      "layout-bottom-2": "底部布局,底部导航",
      "layout-left-2": "左侧布局,左侧导航",
      "layout-grid": "卡片布局,网格",
      "layout-grid-2": "卡片布局,网格",
      "layout-masonry": "collage,瀑布流布局,拼贴画",
      collage: "瀑布流布局,拼贴画",
      grid: "table,网格,表格",
      circle: "圆形",
      triangle: "三角形",
      pentagon: "五边形,五角形",
      hexagon: "六边形",
      octagon: "八边形",
      square: "正方形",
      rectangle: "长方形,矩形",
      shapes: "形状,模块",
      shadow: "投影,影子",
      "layout-horizontal": "水平布局",
      "layout-vertical": "垂直布局",
      "flip-horizontal-2": "水平翻转",
      "flip-horizontal": "水平翻转",
      "flip-vertical": "垂直翻转",
      "flip-vertical-2": "垂直翻转",
      "align-item-horizontal-center": "水平居中",
      "align-item-vertical-center": "垂直居中",
      "align-item-left": "左对齐",
      "align-item-top": "顶部对齐",
      "align-item-right": "右对齐",
      "align-item-bottom": "底部对齐",
    },
    Development: {
      bug: "虫子",
      "bug-2": "虫子",
      code: "代码,编程",
      "code-s": "代码,编程",
      "code-s-slash": "代码,编程",
      "code-box": "代码,编程",
      "terminal-box": "code,command line,prompt,终端,代码,命令行",
      terminal: "code,command line,prompt,终端,代码,命令行",
      "terminal-window": "code,command line,browser,app,ui,终端,代码,命令行",
      parentheses: "code,math,小括号",
      brackets: "code,math,中括号",
      braces: "code,math,大括号,花括号",
      command: "apple key,place of interest,modified key,花键,苹果键",
      cursor: "mouse,pointer,arrow,指针,鼠标",
      "git-commit": "node,onewheel,circle line,dot line,history point,提交",
      "git-pull-request": "合并申请",
      "git-merge": "combine,unite,branch,split,diverge,合并",
      "git-branch": "combine,unite,split,diverge,分支",
      "git-fork": "",
      "git-close-pull-request": "取消,关闭",
      "git-pr-draft": "pull request,草稿",
      "git-repository": "book,bookmark,仓库",
      "git-repository-commits": "book,upload,仓库,提交",
      "git-repository-private": "lock,secure,私密仓库,私人仓库",
      html5: "html,h5,web",
      css3: "css,web,styles",
      javascript: "js,脚本",
      puzzle: "plugins,拼图,插件",
      "puzzle-2": "plugins,拼图,插件",
    },
    Device: {
      tv: "television,antenna,rabbet ears,电视",
      "tv-2": "monitor,display,screen,television,电视,显示器",
      computer: "pc,monitor,display,screen,电脑,显示器",
      mac: "monitor,imac,display,computer,screen,显示器",
      macbook: "laptop,computer,笔记本",
      cellphone: "手机,电话",
      smartphone: "mobile,手机",
      "mobile-download": "手机,下载",
      tablet: "平板电脑",
      device: "设备",
      phone: "电话",
      instance: "box,nft,cvm,实例,盒子,虚拟机",
      database: "storage,resource,bars,progress,数据库,存储",
      "database-2": "storage,discs,silo,platter,数据库,存储",
      server: "服务器",
      "hard-drive": "disc,storage,硬盘,存储",
      "hard-drive-2": "disc,server,storage,硬盘,服务器,存储",
      "hard-drive-3": "disc,server,storage,硬盘,服务器,存储",
      install: "安装",
      uninstall: "卸载",
      save: "floppy,保存,软盘",
      "save-2": "floppy,保存,软盘",
      "save-3": "floppy,保存,软盘",
      "sd-card": "内存卡",
      "sd-card-mini": "内存卡",
      "sim-card": "电话卡",
      "sim-card-2": "电话卡",
      "dual-sim-1": "sim card,电话卡,卡槽,双卡双待",
      "dual-sim-2": "sim card,电话卡,卡槽,双卡双待",
      "u-disk": "U盘,优盘",
      battery: "电池",
      "battery-charge": "电池,充电",
      "battery-low": "电池,低电量",
      "battery-2": "电池",
      "battery-2-charge": "电池,充电",
      "battery-saver": "电池,省电模式",
      "battery-share": "电池共享,共享电量",
      cast: "mirroring,投屏,无线,广播",
      airplay: "mirroring,投屏,无线",
      cpu: "中央处理器",
      gradienter: "水平仪",
      keyboard: "input,键盘,输入",
      "keyboard-box": "input,键盘,输入",
      mouse: "鼠标",
      sensor: "capacitor,传感器,电容器",
      router: "wifi,signal tower,radio,station,路由器,信号塔,广播,基站,流量",
      radar: "satellite receiver,雷达,卫星接收器,锅",
      gamepad: "consoles,controller,游戏手柄",
      "remote-control": "controller,遥控器",
      "remote-control-2": "controller,遥控器",
      "device-recover": "恢复出厂设置",
      hotspot: "手机热点",
      "phone-find": "找回手机",
      "phone-lock": "锁定手机",
      "rotate-lock": "锁定旋转屏幕",
      restart: "reload,refresh,重启",
      "shut-down": "power off,关机",
      fingerprint: "指纹",
      "fingerprint-2": "指纹",
      barcode: "scan,扫码,条形码,条码",
      "barcode-box": "scan,扫码,条形码,条码",
      "qr-code": "二维码",
      "qr-scan": "二维码,扫描",
      "qr-scan-2": "二维码,扫描",
      scan: "扫描",
      "scan-2": "扫描",
      rss: "feed,subscribe,订阅",
      gps: "signal,定位,信号",
      "base-station":
        "wifi,signal tower,router,cast,基站,信号塔,路由器,广播,流量",
      bluetooth: "wireless,蓝牙,无线",
      "bluetooth-connect": "wireless,蓝牙,连接,无线",
      wifi: "无线网",
      "wifi-off": "slash,offline,connection-fail,无线网,关闭,断网,链接失败",
      "signal-wifi": "cellular,strength,无线网,信号",
      "signal-wifi-1": "cellular,strength,无线网,信号",
      "signal-wifi-2": "cellular,strength,无线网,信号",
      "signal-wifi-3": "cellular,strength,无线网,信号",
      "signal-wifi-error":
        "cellular,offline,connection-fail,无线网,断网,链接失败,无信号",
      "signal-wifi-off":
        "cellular,slash,offline,connection-fail,无线网,关闭,断网,链接失败",
      "wireless-charging": "power,flash,无线充电,闪充",
      "dashboard-2": "仪表盘",
      "dashboard-3": "仪表盘",
      usb: "优盘",
      rfid: "radio,frequency,identification,devices,无线,射频识别",
      ram: "memory,electronics,内存条,记忆卡",
      "ram-2": "memory,electronics,内存条,记忆卡",
    },
    Document: {
      file: "new,paper,文件,文档,新建",
      "file-2": "new,paper,文件,文档,新建",
      "file-3": "new,paper,文件,文档,新建",
      "file-4": "new,paper,文件,文档,新建",
      "sticky-note": "new,paper,文件,文档,新建,便签纸,便利贴",
      "sticky-note-add": "new,paper,文件,文档,新建,便签纸,便利贴,添加",
      "sticky-note-2": "new,paper,文件,文档,新建,便签纸,便利贴",
      "file-edit": "文件,文档,编辑",
      draft: "草稿箱,文件,文档,编辑",
      "file-paper": "文件,文档,纸,谱",
      "file-paper-2": "文件,文档,纸,谱",
      receipt: "收据,凭据",
      "file-text": "文件,文档,文本",
      "file-list": "清单,列表",
      "file-list-2": "清单,列表",
      "file-list-3": "newspaper,清单,列表,报纸",
      bill: "账单",
      "file-copy": "duplicate,clone,复制,克隆",
      "file-copy-2": "duplicate,clone,复制,克隆",
      clipboard: "copy,复制,剪切板",
      survey:
        "research,questionnaire,clipboard,checkboxes,form,census,调查,问卷,调研",
      article:
        "newspaper,document,publisher,print,page,word,file,publication,文章,报纸",
      newspaper: "新闻,报纸",
      news: "blog,新闻,博客",
      "file-zip": "7z,rar,压缩包",
      "file-marked": "文件,文档,标记",
      task: "todo,任务,待办",
      todo: "待办",
      book: "read,dictionary,booklet,书,阅读,字典,小册子",
      "book-marked": "read,dictionary,booklet,书,阅读,字典,小册子,书签",
      "book-2": "read,dictionary,booklet,书,阅读,字典,小册子",
      "book-3": "read,dictionary,booklet,书,阅读,字典,小册子",
      "book-open": "read,booklet,magazine,书,阅读,小册子,杂志",
      "book-read": "booklet,magazine,书,阅读,小册子,杂志",
      "contacts-book": "通讯录,联系人",
      "contacts-book-2": "通讯录,联系人",
      "contacts-book-upload": "upload,通讯录,联系人,上传",
      booklet: "notebook,手册,笔记本,小册子",
      "contacts-book-3": "通讯录,联系人",
      "file-code": "config,文件,文档,代码,脚本,配置文件",
      "file-pdf": "文件,文档",
      "file-pdf-2": "文件,文档",
      "file-word": "文档",
      "file-ppt": "文件,文档",
      "file-excel": "文档,表单",
      "file-word-2": "文档",
      "file-ppt-2": "文件,文档",
      "file-excel-2": "文档,表单",
      "file-hwp": "文件,文档,hangul word processor",
      keynote: "演示文稿,幻灯片,讲演",
      numbers: "表格",
      pages: "website,browser,ui,blocks,prototype,文稿",
      "file-search": "文件,文档,搜索",
      "file-add": "page,document,new,plus,add,文件,文档,新建",
      "file-reduce": "page,document,subtract,delete,文件,文档,减",
      "file-settings": "page,document,cog,gear,文件,文档,设置",
      "file-upload": "page,document,文件,文档,上传",
      "file-transfer": "page,document,文件,文档,传输",
      "file-download": "page,document,文件,文档,下载",
      "file-lock": "page,document,文件,文档,锁",
      "file-chart": "page,document,report,文件,文档,柱状图,报表",
      "file-chart-2": "report,文件,文档,饼图,报表",
      "file-image": "文件,文档,图片",
      "file-music": "文件,文档,音乐",
      "file-video": "文件,文档,视频",
      "file-gif": "文件,文档,动图",
      "file-check": "文件,文档,对勾",
      "file-close": "文件,文档,关闭,删除,错误",
      "file-forbid": "文件,文档,禁用",
      "file-info": "文件,文档,信息",
      "file-warning":
        "page,document,paper,!,alert,important,exclamation,文件,文档,警告,提醒",
      "file-unknow": "文件,文档,未知,问号",
      "file-user": "文件,文档,用户",
      "file-shield": "protected,secured,文件,文档,盾牌,保护,安全",
      "file-shield-2": "protected,secured,文件,文档,盾牌,保护,安全",
      "file-damage": "breakdown,broken,corrupt,文件,文档,损坏,破损,破裂",
      "file-history": "record,文件,文档,记录,历史",
      "file-shred": "shredder,shred,destroy,cut,文档,销毁,碎纸机,破裂,粉碎",
      "file-cloud": "network,文件,文档,云",
      contract: "examine,apporove,合约,合同,考试,审批通过",
      folder: "directory,file,文件夹,目录,文档",
      "folder-2": "directory,file,文件夹,目录,文档",
      "folder-3": "directory,file,文件夹,目录,文档",
      "folder-4": "directory,file,文件夹,目录,文档",
      "folder-5": "directory,file,文件夹,目录,文档",
      "folder-6": "directory,file,文件夹,目录,文档",
      folders: "directory,file,文件夹,目录,文档,批量",
      "folder-add": "directory,file,文件夹,目录,文档,添加",
      "folder-reduce": "directory,file,remove,subtract,文件夹,目录,文档,减",
      "folder-settings": "directory,file,文件夹,目录,文档,设置",
      "folder-upload": "directory,file,文件夹,目录,文档,上传",
      "folder-transfer": "directory,file,文件夹,目录,文档,传输",
      "folder-download": "directory,file,文件夹,目录,文档,下载",
      "folder-lock": "directory,file,文件夹,目录,文档,锁",
      "folder-chart": "report,文件夹,目录,文档,柱状图,报表",
      "folder-chart-2": "report,文件夹,目录,文档,饼图,报表",
      "folder-music": "directory,file,audio,sound,文件夹,目录,文档,音乐",
      "folder-image": "directory,file,文件夹,目录,文档,图片",
      "folder-video": "directory,file,文件夹,目录,文档,视频",
      "folder-check": "directory,file,文件夹,目录,文档,对勾",
      "folder-close": "directory,file,文件夹,目录,文档,错误",
      "folder-forbid": "directory,file,文件夹,目录,文档,禁用",
      "folder-info": "directory,file,文件夹,目录,文档,信息",
      "folder-warning":
        "!,alert,important,exclamation,alert,directory,file,文件夹,目录,文档,警告,提醒",
      "folder-unknow": "directory,file,文件夹,目录,文档,未知",
      "folder-user": "directory,file,文件夹,目录,文档,用户",
      "folder-shield":
        "directory,file,protected,secured,文件夹,目录,文档,保护,盾牌,安全",
      "folder-shield-2":
        "directory,file,protected,secured,文件夹,目录,文档,保护,盾牌,安全",
      "folder-shared": "directory,file,文件夹,目录,文档,分享",
      "folder-received": "directory,file,文件夹,目录,文档,接收",
      "folder-open": "directory,file,文件夹,目录,文档,打开",
      "folder-keyhole":
        "directory,encryption,file,文件夹,目录,文档,打开,加密文档",
      "folder-zip": "directory,file,文件夹,目录,文档,打开,压缩",
      "folder-history": "directory,file,record,文件夹,目录,文档,记录,历史",
      "folder-cloud": "directory,file,云文件夹,目录,云文档",
      markdown: "arrow,箭头,下",
    },
    Editor: {
      bold: "加粗",
      italic: "斜体",
      heading: "标题",
      text: "字体",
      "font-family": "字体",
      "font-sans-serif": "衬线体",
      "font-sans": "非衬线体",
      "font-mono": "等宽字体",
      "font-color": "文字色",
      "font-size": "字号,字体大小",
      "font-size-2": "字号,字体大小",
      underline: "下划线",
      overline: "上划线",
      emphasis: "着重号",
      "emphasis-cn": "着重号",
      strikethrough: "remove formatting,del,删除线",
      "strikethrough-2": "remove formatting,del,删除线",
      "format-clear": "remove formatting,清除格式",
      "align-left": "ragged right,左对齐",
      "align-center": "居中对齐",
      "align-right": "ragged left,右对齐",
      "align-justify": "four,lines,ruled,left-right,full width,排列对齐",
      "align-top": "two arrows up,double-up,start,顶部对齐",
      "align-vertically": "centered,middle,balance,垂直对齐",
      "align-bottom": "two arrows down,double-down,end,底部对齐",
      "list-check": "check list,清单列表",
      "list-check-2": "check list,清单列表",
      "list-check-3": "check list,清单列表,问卷,task",
      "list-ordered": "numbered list,有序列表",
      "list-ordered-2": "numbered list,有序列表",
      "list-unordered": "bullet list,无序列表",
      "list-radio": "vote,投票,列表",
      "list-indefinite": "列表",
      "indent-decrease": "indent more,quote,缩进",
      "indent-increase": "indent less,quote,缩进",
      "line-height": "leading,行高",
      "text-spacing":
        "letter spacing,character spacing,kerning,tracking,字间距",
      "text-wrap": "return,文本换行",
      "attachment-2": "annex,paperclip,附件,曲别针",
      link: "connection,address,联系,链接,地址",
      "link-unlink": "connection,remove address,去除链接",
      "link-m": "connection,address,联系,链接,地址",
      "link-unlink-m": "connection,remove address,去除链接",
      separator: "分割线",
      space: "空格",
      "page-separator": "insert,分页符,插入",
      "code-view": "代码视图",
      "quote-text": "引用",
      "double-quotes-l": "left,quotaion marks,双引号",
      "double-quotes-r": "right,quotaion marks,双引号",
      "single-quotes-l": "left,quotaion marks,单引号",
      "single-quotes-r": "right,quotaion marks,单引号",
      "table-2": "表格",
      "table-3": "表格",
      subscript: "角标,下标,脚注",
      "subscript-2": "角标,下标,脚注",
      superscript: "角标,上标",
      "superscript-2": "角标,上标",
      paragraph: "¶,pilcrow,段落",
      "text-direction-l": "文本左对齐",
      "text-direction-r": "文本左对齐",
      functions: "Σ,sum,sigma,功能",
      omega: "Ω,horseshoe,特殊符号",
      hashtag: "#,pound,number,井号",
      asterisk: "*,all,everything,wildcard,星号",
      "question-mark": "?,问号",
      "info-i": "information,信息",
      translate: "translator,翻译",
      "translate-2": "translator,翻译",
      "a-b": "a/b testing,ab testing,split test,either-or,ab测试",
      "english-input": "英文输入法",
      "pinyin-input": "拼音输入法",
      "wubi-input": "五笔输入法",
      "input-cursor-move": "移动输入光标",
      "number-1": "1,一,数字",
      "number-2": "2,二,数字",
      "number-3": "3,三,数字",
      "number-4": "4,四,数字",
      "number-5": "5,五,数字",
      "number-6": "6,六,数字",
      "number-7": "7,七,数字",
      "number-8": "8,八,数字",
      "number-9": "9,九,数字",
      "number-0": "0,零,数字",
      "sort-asc":
        "ranking,ordering,sorting,ascending,descending,升序排列,排序,顺序",
      "sort-desc": "ranking,ordering,降序排列,排序",
      "sort-alphabet-asc": "ranking,ordering,升序排列,数字排序,顺序",
      "sort-alphabet-desc": "ranking,ordering,降序排列,字母排序,倒序,倒序",
      "sort-number-asc": "ranking,ordering,升序排列,数字排序,顺序",
      "sort-number-desc": "ranking,ordering,降序排列,数字排序,倒序",
      "bring-forward": "arrange,层级,向上一层",
      "send-backward": "arrange,层级,向下一层",
      "bring-to-front": "arrange,层级,移到最前面",
      "send-to-back": "arrange,层级,移到最后面",
      "h-1": "heading,一级标题",
      "h-2": "heading,一级标题",
      "h-3": "heading,一级标题",
      "h-4": "heading,一级标题",
      "h-5": "heading,一级标题",
      "h-6": "heading,一级标题",
      "insert-column-left": "添加列,左侧",
      "insert-column-right": "添加列,右侧",
      "insert-row-top": "添加行,顶部",
      "insert-row-bottom": "添加行,底部",
      "delete-column": "删除列,底部",
      "delete-row": "添加行,底部",
      "merge-cells-horizontal": "合并单元格",
      "merge-cells-vertical": "合并单元格",
      "split-cells-horizontal": "拆分单元格",
      "split-cells-vertical": "拆分单元格",
      "flow-chart": "流程图",
      "mind-map": "mindmap,脑图,思维导图",
      "node-tree": "节点,层级关系图",
      "organization-chart": "组织架构图,局域网",
      "rounded-corner": "圆角",
      sketching: "signature,手写,手绘,签名",
      draggable: "move,reorder,拖拽,排序",
      "slash-commands": "命令,斜线",
      "slash-commands-2": "命令,斜线",
      "ai-generate": "AI自动生成",
      "dropdown-list": "下拉菜单",
      "code-block": "代码块",
      "text-snippet": "文字片段,剪切板",
      "text-block": "文字块,文字片段",
      "table-view": "表格视图",
      "kanban-view": "看板视图",
      "kanban-view-2": "看板视图",
      "gallery-view": "画廊视图",
      "gallery-view-2": "画廊视图",
      "timeline-view": "时间轴视图,甘特图",
      "calendar-view": "日历视图",
      "list-view": "列表视图",
      "focus-mode": "聚焦模式,沉浸模式",
      "slideshow-view": "幻灯片视图",
      "stacked-view": "堆叠视图",
      "carousel-view": "循环播放视图",
      "input-field": "cursor,输入框,光标",
      hand: "drag,手,拖拽",
      "square-root": "formula,开根号,公式,计算",
      formula: "公式,计算",
    },
    Finance: {
      wallet: "pocketbook,钱包,卡包",
      "wallet-2": "money clip,钱包,卡包",
      "wallet-3": "money clip,钱包,卡包",
      "bank-card": "credit,purchase,payment,cc,银行卡,信用卡,购买,消费,支付",
      "bank-card-2": "credit,purchase,payment,cc,银行卡,信用卡,购买,消费,支付",
      "secure-payment":
        "credit,purchase,payment,cc,银行卡,信用卡,购买,消费,支付,安全",
      refund: "credit card,repayment,cc,银行卡,信用卡还款",
      "refund-2": "credit card,repayment,cc,银行卡,信用卡还款",
      safe: "vault,secure,保险柜,保险箱",
      "safe-2": "vault,insecure,unlocked,保险柜,保险箱",
      "price-tag": "label,标签,价签",
      "price-tag-2": "label,标签,价签",
      "price-tag-3": "label,标签,价签",
      ticket: "coupon,票,优惠券,代金券",
      "ticket-2": "coupon,票,优惠券,代金券",
      coupon: "ticket,票,优惠券,代金券",
      "coupon-2": "ticket,票,优惠券,代金券",
      "coupon-3": "ticket,票,优惠券,代金券",
      "coupon-4": "优惠券,代金券",
      "coupon-5": "优惠券,代金券",
      "shopping-bag": "purse,购物袋,购买,消费,商城",
      "shopping-bag-2": "购物袋,购买,消费,商城",
      "shopping-bag-3": "购物袋,购买,消费,商城",
      "shopping-basket": "购物篮,购买,消费,商城",
      "shopping-basket-2": "购物篮,购买,消费,商城",
      "shopping-cart": "购物车,购买,消费,商城",
      "shopping-cart-2": "购物车,购买,消费,商城",
      vip: "会员",
      "vip-crown": "king,queen,皇冠,会员,国王,女王,王后",
      "vip-crown-2": "king,queen,皇冠,会员,国王,女王,王后",
      "vip-diamond": "钻石,会员",
      trophy: "奖品,奖杯,金杯",
      exchange: "swap,交换,换算,兑换,交易",
      "exchange-box": "swap,交换,换算,兑换,交易",
      "exchange-2": "swap,交换,换算,兑换,交易",
      swap: "exchange,交换,换算,兑换,交易",
      "swap-box": "exchange,交换,换算,兑换,交易",
      "swap-2": "flow direction,exchange,交换,换算,兑换,交易",
      "swap-3": "flow direction,exchange,交换,换算,兑换,交易",
      "exchange-dollar": "swap,transfer,交换,换算,兑换,美元,转账,交易",
      "exchange-cny": "swap,transfer,交换,换算,兑换,人民币,转账,交易",
      "exchange-funds": "swap,transfer,交换,换算,兑换,基金,股票,转账,交易",
      "increase-decrease": "计算器",
      percent: "百分之,百分比",
      "copper-coin": "currency,payment,铜币,硬币,货币,钱,支付",
      "copper-diamond": "currency,coins,金币,钻石,货币,钱,支付",
      "money-cny-box": "currency,payment,货币,钱,支付,人民币",
      "money-cny-circle": "currency,coins,金币,payment,货币,钱,支付,人民币",
      "money-dollar-box": "currency,payment,货币,钱,支付,美元",
      "money-dollar-circle":
        "currency,coins,金币,payment,cent,penny,货币,钱,支付,美元,美分,便士",
      "money-euro-box": "currency,payment,货币,钱,支付,欧元",
      "money-euro-circle": "currency,coins,金币,payment,货币,钱,支付,欧元",
      "money-pound-box": "currency,payment,货币,钱,支付,英镑",
      "money-pound-circle": "currency,coins,金币,payment,货币,钱,支付,英镑",
      "money-rupee-circle": "currency,coins,金币,payment,货币,钱,支付,卢比",
      "bit-coin": "currency,payment,货币,钱,比特币",
      coin: "金币,硬币",
      cash: "现金,钞票",
      coins: "金币,硬币",
      currency: "cash,payment,货币,钱",
      funds: "foundation,stock,基金,股票",
      "funds-box": "foundation,stock,基金,股票",
      "red-packet": "红包",
      "water-flash": "水电费",
      stock: "股票",
      auction: "hammer,gavel,拍卖,锤子",
      gift: "present,礼物",
      "gift-2": "present,礼物",
      "hand-coin": "donate,business,捐赠",
      "hand-heart": "help,donate,volunteer,welfare,帮助,爱心,捐赠,志愿者,公益",
      "24-hours": "last,24小时营业",
      nft: "token",
      p2p: "trade,点对点,交易",
      "token-swap": "cryptocurrency,数字货币,代币,兑换",
      btc: "cryptocurrency,数字货币,bitcoin,比特币",
      eth: "cryptocurrency,数字货币,ethereum,以太坊",
      xtz: "cryptocurrency,数字货币,tezos,兔子币",
      bnb: "cryptocurrency,数字货币,binance,币安币",
      xrp: "cryptocurrency,数字货币,ripple,瑞波币",
      "discount-percent": "promotion,sale,折扣,促销,打折",
      "shopping-bag-4": "购物车,购买,消费,商城",
    },
    Food: {
      restaurant: "餐厅,饭店",
      "restaurant-2": "餐厅,饭店",
      cup: "tea,coffee,杯子,咖啡,茶",
      goblet: "cup,wine glass,cocktail,高脚杯,酒杯,鸡尾酒",
      "goblet-2": "cup,wine glass,cocktail,高脚杯,酒杯,鸡尾酒",
      beer: "cup,啤酒杯",
      cake: "anniversary,蛋糕",
      "cake-2": "anniversary,蛋糕,生日,蜡烛",
      "cake-3": "蛋糕,生日,蜡烛",
      knife: "菜刀",
      "knife-blood": "crime,菜刀,犯罪,血,杀人",
      bread: "toast,吐司面包",
      drinks: "beverage,coffee,饮料,咖啡",
      "drinks-2": "beverage,juice,饮料,果汁",
      bowl: "soup,碗,汤",
    },
    "Health & Medical": {
      heart: "like,love,favorite,心,喜欢,爱,收藏",
      "heart-2": "like,love,favorite,心,喜欢,爱,收藏",
      "heart-3": "like,love,favorite,心,喜欢,爱,收藏",
      "heart-add": "like,love,favorite,心,喜欢,爱,收藏",
      "heart-add-2": "like,love,favorite,心,喜欢,爱,收藏",
      dislike: "like,love,remove favorite,心,不喜欢,取消收藏",
      hearts: "romance,爱情,浪漫,心",
      "heart-pulse": "heart rate,脉搏,心率",
      pulse: "wave,heart rate,脉搏,心率,波",
      empathize: "care,heart,同理心,关爱,心",
      nurse: "doctors,医生,护士",
      dossier: "病例",
      "health-book": "健康手册,医疗手册",
      "first-aid-kit": "case,急救箱",
      capsule: "medicine,胶囊,药",
      "medicine-bottle": "药瓶",
      flask: "testing,experimental,experiment,烧瓶,实验,试验",
      "test-tube": "testing,experimental,experiment,试管,实验,试验",
      dropper:
        "eyedropper,color picker,color dropper,实验,试验,胶头滴管,取色器",
      microscope: "testing,experimental,experiment,显微镜,实验,试验",
      "hand-sanitizer": "alcohol,酒精消毒洗手液",
      "mental-health": "心理健康",
      psychotherapy: "心理治疗",
      stethoscope: "听诊器",
      syringe: "注射器",
      thermometer: "体温计",
      "infrared-thermometer": "红外线体温计,体温枪",
      "surgical-mask": "外科医用口罩",
      virus: "病毒",
      lungs: "肺部",
      "rest-time": "close,休息时间,打烊",
      zzz: "睡觉",
      brain: "think,ai,大脑,思考,人工智能",
      "brain-2": "think,ai,大脑,思考,人工智能",
      aed: "flash,心脏电击去颤器",
      "aed-electrodes": "电极",
      dna: "health,medical,people,DNA,gene,基因,健康,医疗",
    },
    Logos: {
      alipay: "zhifubao,支付宝",
      "alibaba-cloud": "阿里云",
      amazon: "亚马逊",
      android: "applications,安卓,应用",
      angularjs: "angular,programing framework",
      "app-store": "applications,苹果应用商店",
      apple: "苹果",
      baidu: "du,claw,百度,爪",
      bard: "google,ai,magic,star,shining,sparkling,twinkle,人工智能,魔法,星星,闪烁",
      behance: "behance",
      bilibili: "哔哩哔哩",
      blender: "3d",
      blogger: "博客",
      bluesky: "",
      bootstrap: "",
      centos: "linux,system,系统",
      chrome: "谷歌浏览器",
      codepen: "代码笔",
      copilot: "github,飞行员",
      coreos: "linux,system,系统",
      dingding: "钉钉",
      discord: "game,chat",
      disqus: "comments",
      douban: "豆瓣",
      dribbble: "追波",
      drive: "google drive,谷歌云端硬盘",
      dropbox: "多宝箱",
      edge: "microsoft edge,edge浏览器",
      "edge-new": "microsoft-edge,浏览器",
      evernote: "印象笔记",
      facebook: "脸书",
      "facebook-circle": "脸书",
      "facebook-box": "脸书",
      finder: "macintosh,仿达",
      firebase: "",
      firefox: "火狐浏览器",
      flickr: "",
      flutter: "google",
      friendica: "",
      gatsby: "gatsby",
      gemini: "ai,star",
      github: "github",
      gitlab: "gitlab",
      google: "谷歌",
      "google-play": "applications,谷歌应用商店",
      "honor-of-kings": "game,王者荣耀",
      ie: "internet explorer,浏览器",
      instagram: "照片墙",
      invision: "invision",
      "kakao-talk": "kakao talk,chat",
      line: "连我",
      linkedin: "领英",
      "linkedin-box": "领英",
      java: "",
      kick: "",
      "microsoft-loop": "Doc,笔记",
      mastercard: "bank card,银行卡",
      mastodon: "mastodon,长毛象",
      medium: "媒体",
      messenger: "facebook,脸书,信使",
      meta: "元",
      microsoft: "windows,窗户,微软",
      "mini-program": "微信小程序",
      "netease-cloud-music": "netease cloud music,网易云音乐",
      netflix: "网飞",
      nextjs: "",
      nodejs: "",
      notion: "notes,doc,笔记,文档",
      npmjs: "npm,nodejs",
      openai: "人工智能",
      openbase: "",
      "open-source": "opensource,开源",
      opera: "欧朋浏览器",
      patreon: "donate,money,捐赠,打赏",
      paypal: "贝宝",
      pinterest: "拼趣",
      pixelfed: "photography,pixelfed",
      playstation: "ps",
      "product-hunt": "product hunt",
      qq: "penguin,tencent,腾讯,企鹅",
      reactjs: "react,programing framework,facebook",
      reddit: "reddit",
      remixicon: "remix icon,图标",
      "remix-run": "",
      safari: "safari浏览器",
      skype: "skype",
      slack: "slack",
      snapchat: "ghost,色拉布,幽灵",
      soundcloud: "声云",
      spectrum: "spectrum",
      spotify: "music,音乐",
      "stack-overflow": "stack overflow",
      stackshare: "share,分享,技术栈",
      steam: "game,store",
      supabase: "",
      svelte: "",
      switch: "nintendo,任天堂",
      "tailwind-css": "",
      taobao: "淘宝",
      telegram: "telegram",
      "telegram-2": "",
      threads: "",
      tiktok: "抖音",
      trello: "trello",
      tumblr: "汤博乐",
      twitch: "twitch",
      twitter: "推特",
      "twitter-x": "推特",
      ubuntu: "linux,system,系统",
      unsplash: "photos",
      vimeo: "视频",
      vk: "",
      visa: "bank card,银行卡",
      vuejs: "vue,programing framework",
      webhook: "",
      wechat: "微信",
      "wechat-2": "微信",
      "wechat-channels": "微信视频号",
      "wechat-pay": "微信支付",
      weibo: "新浪微博",
      whatsapp: "瓦次艾普",
      windows: "microsoft,窗户,微软",
      wordpress: "blog,博客",
      xbox: "xbox",
      xing: "xing",
      youtube: "优兔,油管",
      yuque: "语雀",
      zcool: "zcool,站酷",
      zhihu: "知乎",
    },
    Map: {
      "map-pin": "location,navigation,地图,坐标,定位,导航,位置",
      "map-pin-2": "location,navigation,地图,坐标,定位,导航,位置",
      "map-pin-3": "location,navigation,地图,坐标,定位,导航,位置",
      "map-pin-4": "location,navigation,地图,坐标,定位,导航,位置",
      "map-pin-5": "location,navigation,地图,坐标,定位,导航,位置",
      "map-pin-add": "location,navigation,地图,坐标,定位,导航,位置,新增,添加",
      "map-pin-range": "location,navigation,地图,坐标,定位,导航,位置,范围",
      "map-pin-time": "location,navigation,地图,坐标,定位,导航,位置,时间",
      "map-pin-user": "location,navigation,地图,坐标,定位,导航,位置,用户",
      "pin-distance": "坐标,距离",
      pushpin: "图钉",
      unpin: "图钉,取消固定",
      "pushpin-2": "图钉",
      compass:
        "navigation,safari,direction,discover,指南针,导航,方向,发现,探索",
      "compass-2": "navigation,direction,discover,指南针,导航,方向,发现,探索",
      "compass-3":
        "navigation,safari,direction,discover,指南针,导航,方向,发现,探索",
      "compass-4": "navigation,direction,discover,指南针,导航,方向,发现,探索",
      "compass-discover": "navigation,direction,指南针,导航,方向,发现,探索",
      anchor: "锚",
      "china-railway": "中铁,铁路,火车",
      "space-ship": "太空飞船",
      rocket: "火箭",
      "rocket-2": "space ship,火箭,太空飞船",
      map: "navigation,travel,地图,导航,旅行",
      "map-2": "location,navigation,travel,地图,定位,导航,旅行",
      "treasure-map": "thriller,adventure,地图,藏宝图",
      "road-map": "navigation,travel,地图,导航,旅行",
      earth: "global,union,world,language,地球,全球,联合,世界,语言",
      "time-zone": "global,地球,时区,时间",
      globe: "earth,地球仪",
      planet: "space,discover,星球,宇宙,探索,发现",
      parking: "停车场",
      "parking-box": "停车场",
      route: "path,路线",
      guide: "path,指引,路线",
      "gas-station": "加气站,加油站",
      "charging-pile": "充电桩",
      "charging-pile-2": "充电桩",
      car: "汽车",
      "car-washing": "汽车,洗车",
      roadster: "car,汽车,跑车",
      taxi: "car,出租车,汽车",
      "taxi-wifi": "car,出租车,汽车",
      "police-car": "汽车,警车",
      bus: "大巴,巴士",
      "bus-2": "大巴,巴士",
      "bus-wifi": "大巴,巴士",
      truck: "van,delivery,卡车,货车,运输",
      train: "火车",
      "train-wifi": "火车",
      subway: "地铁",
      "subway-wifi": "地铁",
      "flight-takeoff": "airplane,plane,origin,起飞,出发,始发,起点,飞机",
      "flight-land": "airplane,plane,destination,着陆,到达,抵达,终点,飞机",
      plane: "fight,飞机,航班",
      sailboat: "帆船",
      ship: "轮船,航海,海运",
      "ship-2": "轮船",
      bike: "自行车",
      "e-bike": "take out,takeaway,电动车,外卖",
      "e-bike-2": "take out,takeaway,电动车,外卖",
      takeaway: "take out,takeaway,电动车,外卖",
      motorbike: "摩托车",
      caravan: "房车",
      walk: "步行",
      run: "奔跑,跑步",
      riding: "bike,骑行,自行车",
      barricade: "路障",
      footprint: "脚印,足迹",
      "traffic-light": "交通,信号灯",
      "signal-tower": "base station,antenna,信号塔,基站,天线",
      "hotel-bed": "酒店,床",
      navigation: "gps,导航",
      oil: "汽油,机油",
      direction: "right,方向,右转",
      steering: "drive,方向盘,驾车",
      "steering-2": "drive,方向盘,驾车",
      lifebuoy: "life ring,救生圈",
      passport: "passports,护照",
      suitcase: "travel,旅行,行李箱",
      "suitcase-2": "travel,旅行,行李箱,拉杆箱",
      "suitcase-3": "travel,旅行,boarding case,行李箱,拉杆箱,登机箱",
      "luggage-deposit": "consignment,行李箱,行李寄存,托运",
      "luggage-cart": "行李车",
      signpost: "milestone,路标,路牌,里程碑",
    },
    Media: {
      image: "picture,photo,图片,照片",
      "image-circle": "picture,photo,图片,照片",
      "image-2": "picture,photo,图片,照片",
      "image-add": "picture,photo,图片,照片,添加",
      "image-edit": "picture,photo,图片,照片,编辑",
      landscape: "picture,image,photo,图片,照片",
      gallery: "picture,image,图片,相册",
      "gallery-upload": "picture,image,图片,相册,上传",
      video: "视频",
      movie: "film,video,电影,硬盘,视频",
      "movie-2": "film,video,电影,硬盘,视频",
      film: "movie,video,影片,电影,视频",
      clapperboard: "movie,film,场记板,电影",
      "video-on": "vidicon,camera,摄像机,摄影机,视频",
      "video-off": "vidicon,camera,摄像机,摄影机,视频,关",
      vidicon: "video,camera,摄像机,摄影机,视频",
      "vidicon-2": "camera,摄像机,摄影机",
      live: "video,camera,摄像机,摄影机,视频,直播",
      "video-add": "camera,摄像机,摄影机,视频,添加",
      "video-upload": "camera,摄像机,摄影机,视频,上传",
      "video-download": "camera,摄像机,摄影机,视频,下载",
      dv: "vidicon,camera,摄像机,摄影机",
      camera: "photo,照相机,拍照,照片",
      "camera-off": "photo,slash,照相机,拍照,照片,禁止,关闭",
      "camera-2": "photo,照相机,拍照,照片",
      "camera-3": "photo,照相机,拍照,照片",
      "camera-lens": "aperture,photo,照相机,拍照,照片,朋友圈",
      "camera-switch": "照相机,拍照,翻转",
      polaroid: "camera,相机,宝丽来",
      "polaroid-2": "camera,相机,宝丽来",
      "phone-camera": "手机相机,手机摄像头",
      webcam: "摄像头",
      mv: "music video,音乐",
      music: "音乐",
      "music-2": "音乐",
      disc: "music,album,音乐,唱片",
      album: "music,唱片,音乐",
      dvd: "cd,dvd,record,光盘,刻录",
      headphone: "music,headset,耳机,音乐",
      radio: "收音机,电台",
      "radio-2": "收音机,电台",
      tape: "录音,磁带",
      mic: "record,voice,话筒,语音,录音,声音",
      "mic-2": "record,voice,话筒,语音,录音,声音",
      "mic-off": "record,voice,slash,关闭话筒,关闭语音,录音,关闭声音,静音,禁止",
      "volume-down": "trumpet,sound,speaker,音量低,喇叭,声音,扬声器",
      "volume-mute": "trumpet,sound,off,音量低,喇叭,声音,静音",
      "volume-up": "trumpet,sound,speaker,音量高,喇叭,声音,扬声器",
      "volume-vibrate": "trumpet,sound,speaker,喇叭,声音,扬声器,震动模式",
      "volume-off-vibrate":
        "trumpet,sound,speaker,静音,喇叭,声音,扬声器,静音模式",
      speaker: "音响",
      "speaker-2": "音响",
      "speaker-3": "音响",
      "surround-sound": "环绕立体声",
      broadcast: "广播",
      notification: "bell,alarm,通知,铃铛,提醒",
      "notification-2": "bell,alarm,通知,铃铛,提醒",
      "notification-3": "bell,alarm,通知,铃铛,提醒",
      "notification-4": "bell,alarm,通知,铃铛,提醒",
      "notification-off":
        "bell,alarm,silent,slash,通知,铃铛,提醒,免打扰,静音,关闭,禁止",
      "play-circle": "start,播放,开始",
      "pause-circle": "暂停",
      "record-circle": "录音",
      "stop-circle": "停止",
      eject: "推出",
      "play-reverse": "回放",
      play: "start,播放,开始",
      pause: "暂停",
      stop: "停止",
      rewind: "fast,快退",
      speed: "fast,快进",
      "skip-back": "上一曲",
      "skip-forward": "下一曲",
      "rewind-start": "上一曲",
      "forward-end": "下一曲",
      "play-reverse-mini": "回放",
      "play-mini": "播放",
      "pause-mini": "暂停",
      "stop-mini": "停止",
      "rewind-mini": "fast,快退",
      "speed-mini": "fast,快进",
      "skip-back-mini": "上一曲",
      "skip-forward-mini": "下一曲",
      "rewind-start-mini": "上一曲",
      "forward-end-mini": "下一曲",
      "play-reverse-large": "回放",
      "play-large": "start,播放,开始",
      "pause-large": "暂停",
      "stop-large": "停止",
      "replay-5": "playback,重播,回放",
      "forward-5": "skip,快进,快放,跳过",
      "replay-10": "playback,重播,回放",
      "forward-10": "skip,快进,快放,跳过",
      "replay-15": "playback,重播,回放",
      "forward-15": "skip,快进,快放,跳过",
      "replay-30": "playback,重播,回放",
      "forward-30": "skip,快进,快放,跳过",
      memories: "回忆",
      repeat: "swap,交换,循环播放",
      "repeat-2": "swap,交换,循环播放",
      "repeat-one": "单曲循环",
      "order-play": "顺序播放",
      shuffle: "随机播放",
      "play-list": "播放列表",
      "play-list-2": "播放列表",
      "play-list-add": "列表,添加",
      fullscreen: "maximize,全屏,最大化",
      "fullscreen-exit": "minimize,退出全屏,最小化",
      equalizer: "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
      "equalizer-2": "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
      "equalizer-3": "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
      "sound-module":
        "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
      rhythm: "节奏,韵律",
      voiceprint: "声纹",
      "speed-up": "dashboard,快,加速,仪表盘",
      "slow-down": "dashboard,慢,减速,仪表盘",
      hq: "high quality,高质量,高品质",
      hd: "high definition,高清晰度",
      "4k": "high definition,high quality,高清晰度,高品质,超清",
      "closed-captioning": "隐藏字幕",
      "aspect-ratio": "宽高比,比例",
      "picture-in-picture": "画中画,小窗",
      "picture-in-picture-2": "画中画,小窗",
      "picture-in-picture-exit": "退出画中画,退出小窗",
    },
    System: {
      apps: "应用",
      "apps-2": "应用",
      "apps-2-add": "添加应用",
      function: "layout,功能,应用,卡片布局",
      "function-add": "添加应用",
      dashboard: "仪表盘",
      "dashboard-horizontal": "仪表盘",
      menu: "navigation,hamburger,导航,菜单,汉堡包",
      "menu-2": "navigation,hamburger,导航,菜单,汉堡包",
      "menu-3": "navigation,hamburger,导航,菜单,汉堡包",
      "menu-4": "navigation,hamburger,导航,菜单,汉堡包",
      "menu-5": "navigation,hamburger,导航,菜单,汉堡包",
      "menu-add": "navigation,hamburger,导航,菜单,汉堡包,添加",
      "menu-fold": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-unfold": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-unfold-3": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-fold-4": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-unfold-4": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-fold-3": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-fold-2": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-unfold-2": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
      "menu-search": "category,菜单,搜索",
      more: "ellipsis,更多,省略",
      "more-2": "kebab menu,ellipsis,更多,省略",
      star: "favorite,like,mark,星星,星标,喜欢",
      "star-s": "favorite,like,mark,星星,星标,喜欢,半星",
      "star-half": "favorite,like,mark,星星,星标,喜欢",
      "star-half-s": "favorite,like,mark,星星,星标,喜欢,半星",
      settings: "edit,gear,preferences,偏好设置,编辑,齿轮",
      "settings-2": "edit,gear,preferences,偏好设置,编辑,齿轮",
      "settings-3": "edit,gear,preferences,偏好设置,编辑,齿轮",
      "settings-4": "edit,gear,preferences,偏好设置,编辑,齿轮",
      "settings-5": "edit,gear,preferences,偏好设置,编辑,齿轮",
      "settings-6": "edit,gear,preferences,偏好设置,编辑,齿轮",
      "list-settings": "列表,设置",
      forbid: "prohibited,slash,ban,禁止,禁用",
      "forbid-2": "prohibited,slash,ban,禁止,禁用",
      prohibited: "forbid,lash,ban,禁止,禁用",
      "prohibited-2": "forbid,lash,ban,禁止,禁用",
      information: "i,信息",
      "information-2": "i,信息",
      "information-off": "i,信息,关闭",
      "error-warning": "!,alert,important,alert,exclamation,警告,错误",
      question: "help,问号,帮助",
      alert: "提醒,警告",
      spam: "alert,垃圾邮件,警告",
      "spam-2": "block,alert,垃圾邮件,警告,拦截",
      "spam-3": "block,alert,垃圾邮件,警告,拦截",
      "checkbox-blank": "复选框,空",
      checkbox: "复选框",
      "checkbox-indeterminate": "复选框",
      "add-box": "plus,new,复选框,添加,加号,新增",
      "checkbox-blank-circle": "复选框,空",
      "checkbox-circle": "复选框",
      "indeterminate-circle": "slash,ban,复选框,禁",
      "add-circle": "plus,new,复选框,添加,加号,新增",
      "close-circle": "cancel,remove,delete,empty,x,关闭,取消,移除,删除,清空",
      "radio-button": "单选框",
      "checkbox-multiple-blank": "复选框,空",
      "checkbox-multiple": "复选框,空",
      check: "对勾",
      "check-double": "read,done,double-tick,双对勾,已读",
      close: "cancel,remove,delete,empty,x,关闭,取消,移除,删除,清空",
      add: "plus,new,添加,新增,加号",
      subtract: "minus,减",
      divide: "除以",
      equal: "sum,result,等于",
      "close-large": "cancel,remove,delete,empty,x,关闭,取消,移除,删除,清空",
      "add-large": "lus,new,添加,新增,加号",
      download: "import,receive,下载,接收,导入",
      upload: "export,send,上传,发送,导出",
      "download-2": "import,receive,下载,接收,导入",
      "upload-2": "export,send,上传,发送,导出",
      import: "download,导入,下载",
      export: "upload,导出,上传",
      "download-cloud": "下载,云",
      "upload-cloud": "上传,云",
      "download-cloud-2": "下载,云",
      "upload-cloud-2": "上传,云",
      "login-box": "sign in,登录",
      "logout-box": "sign out,登出,注销",
      "logout-box-r": "sign out,登出,注销",
      "login-circle": "sign in,登录",
      "logout-circle": "sign out,登出,注销",
      "logout-circle-r": "sign out,登出,注销",
      shield: "safety,protect,盾牌,卫士,安全,防御",
      "shield-cross": "safety,protect,盾牌,卫士,安全,防御,闪电",
      "shield-flash": "safety,protect,盾牌,卫士,安全,防御",
      "shield-star":
        "police badge,safety,protect,盾牌,卫士,安全,防御,星星,警徽",
      "shield-user":
        "safety,protect,user protected,guarantor,盾牌,卫士,安全,防御,用户",
      "shield-keyhole": "safety,protect,guarantor,盾牌,卫士,安全,防御,钥匙孔",
      "shield-check": "safety,protect,盾牌,卫士,安全,防御",
      "delete-back": "backspace,删除,退格",
      "delete-back-2": "backspace,删除,退格",
      "delete-bin":
        "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
      "delete-bin-2":
        "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
      "delete-bin-3":
        "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
      "delete-bin-4":
        "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
      "delete-bin-5":
        "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
      "delete-bin-6":
        "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
      "delete-bin-7":
        "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
      lock: "security,password,锁子,安全,密码",
      "lock-2": "security,password,锁子,安全,密码",
      "lock-password": "security,锁子,安全,密码",
      "lock-unlock": "security,password,锁子,安全,密码",
      "lock-star": "security,premium,锁子,安全,密码,会员,高级",
      eye: "watch,view,眼睛,查看",
      "eye-off": "slash,眼睛,不可见,关闭,禁止",
      "eye-2": "watch,view,眼睛,查看",
      "eye-close": "x,闭眼",
      search: "搜索,放大镜",
      "search-2": "搜索,放大镜",
      "search-eye": "搜索,放大镜,眼睛",
      "zoom-in": "放大,放大镜",
      "zoom-out": "缩小,放大镜",
      "find-replace": "查找,搜索,替换",
      share: "sharing,分享,转发",
      "share-2": "sharing,分享,转发",
      "share-box": "sharing,分享,转发",
      "share-circle": "sharing,分享,转发",
      "share-forward": "sharing,分享,转发",
      "share-forward-2": "sharing,分享,转发",
      "share-forward-box": "sharing,分享,转发",
      "external-link": "外链",
      "side-bar": "侧边栏",
      "sidebar-unfold": "expand,展开侧边栏",
      "sidebar-fold": "收起侧边栏",
      time: "clock,时间,时钟,钟表",
      timer: "chronograph,stopwatch,秒表,计时器",
      "timer-2": "chronograph,stopwatch,秒表,计时器",
      "timer-flash": "chronograph,stopwatch,秒表,计时器,闪电",
      alarm: "闹钟",
      history: "record,recent,time machine,历史记录,最近",
      "hourglass-2": "time,history,recent,duration,沙漏,时间,历史记录,最近",
      hourglass: "time,history,recent,duration,沙漏,时间,历史记录,最近",
      "thumb-up": "like,good,喜欢,好",
      "thumb-down": "dislike,bad,不喜欢,不好",
      "alarm-warning": "alert,report,police light,告警,举报,警灯",
      "notification-badge": "red dot,通知,小红点",
      toggle: "switch,开关,触发器",
      filter: "filtration,筛选,过滤",
      "filter-2": "filtration,筛选,过滤",
      "filter-3": "filtration,筛选,过滤",
      "filter-off": "filtration,clear-filter,筛选,过滤",
      loader: "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
      "loader-2": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
      "loader-3": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
      "loader-4": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
      "loader-5": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
      refresh:
        "reload,repeat,replace,reset,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
      "loop-left":
        "reload,repeat,replace,reset,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
      "loop-right":
        "reload,repeat,replace,reset,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
      "reset-left":
        "reload,repeat,replace,refresh,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
      "reset-right":
        "reload,repeat,replace,refresh,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
      "progress-1": "percent,进度,百分比",
      "progress-2": "percent,进度,百分比",
      "progress-3": "percent,进度,百分比",
      "progress-4": "percent,进度,百分比",
      "progress-5": "percent,进度,百分比",
      "progress-6": "percent,进度,百分比",
      "progress-7": "percent,进度,百分比",
      "progress-8": "percent,进度,百分比",
    },
    "User & Faces": {
      user: "person,people,用户",
      "user-2": "person,people,用户",
      "user-3": "person,people,用户",
      "user-4": "person,people,用户",
      "user-5": "person,people,用户",
      "user-6": "person,people,用户",
      "user-smile": "person,people,用户,微笑",
      "account-box": "person,people,用户,微笑",
      "account-circle": "person,people,用户,微笑",
      "account-pin-box": "person,people,用户,微笑",
      "account-pin-circle": "person,people,用户,微笑",
      "user-add": "person,people,用户,添加,新增",
      "user-minus": "person,peopl,unfollow,用户,减少,移除",
      "user-follow": "person,people,关注",
      "user-unfollow": "person,people,rejected,用户,取消关注,拒绝,错误",
      "user-shared": "transfer,用户,我分享的,发送,person,people",
      "user-shared-2": "transfer,用户,我分享的,发送,person,people",
      "user-received": "用户,我接收的,收取,person,people",
      "user-received-2": "用户,我接收的,收取,person,people",
      "user-location": "用户,定位,person,people",
      "user-search": "用户,查找,person,people",
      "user-settings": "admin,用户,设置,管理员,person,people",
      "user-star": "用户,关注,person,people",
      "user-heart": "用户,关注,person,people",
      admin: "admin,用户,管理员,person,people",
      "user-forbid": "terminated,禁止,终止",
      contacts: "联系人",
      group: "team,团队,群组,person,people,multiple users,user group",
      "group-2": "team,团队,群组,person,people,multiple users,user group",
      "group-3": "team,团队,群组,person,people,multiple users,user group",
      team: "团队,小组,群主,person,people",
      "user-voice": "用户,录音,演讲",
      emotion: "表情,笑脸",
      "emotion-2": "表情,笑脸",
      "emotion-happy": "表情,开心",
      "emotion-normal": "表情,一般",
      "emotion-unhappy": "表情,不开心",
      "emotion-laugh": "comedy,happy,表情,大笑,笑脸,开心,喜剧",
      "emotion-sad": "drama,tears,悲剧,哭泣,泪",
      skull: "ghost,骷髅,鬼怪",
      "skull-2": "ghost,horror,thriller,骷髅,鬼怪,恐惧,恐怖",
      men: "gender,man,male,男人,男性",
      women: "gender,woman,female,女人,女性",
      travesti: "女人,女性",
      genderless: "女人,女性",
      "open-arm": "张开双臂",
      "body-scan":
        "gesture recognition,body,扫描身体,体态识别,动作之别,手势识别",
      parent: "patriarch,父母,亲子,家长",
      robot: "AI,mechanic,机器人",
      "robot-2": "AI,mechanic,机器人",
      "robot-3": "AI,mechanic,机器人",
      aliens: "science fiction,ET,外星人,科幻小说",
      "bear-smile": "cartoon,anime,cartoon,小熊,微笑,儿童,动画片,卡通,动漫",
      mickey: "cartoon,disney,迪士尼,米老鼠,微笑,儿童,动画片",
      criminal: "horror,thriller,罪犯,犯罪,恐怖",
      ghost: "horror,thriller,鬼怪,恐怖,恐惧",
      "ghost-2": "horror,鬼怪,恐怖,恐惧",
      "ghost-smile": "鬼怪,笑",
      "star-smile": "animation,动画,微笑,星星",
      spy: "incognito mode,detective,secret,间谍,侦探,无痕模式,隐私模式",
    },
    Weather: {
      sun: "light mode,sunny,太阳,白天模式,晴天",
      moon: "dark mode,night,月亮,夜间模式,月牙",
      flashlight: "闪电",
      cloudy: "多云",
      "cloudy-2": "多云",
      mist: "雾气,雾霾",
      foggy: "大雾",
      "cloud-windy": "风",
      windy: "大风,刮风",
      rainy: "下雨,雨天",
      drizzle: "小雨",
      showers: "中雨",
      "heavy-showers": "大雨",
      thunderstorms: "雷暴,雷阵雨",
      hail: "冰雹",
      snowy: "下雪,雪天",
      snowflake: "下雪,雪天,雪花",
      "sun-cloudy": "晴转多云",
      "moon-cloudy": "夜间多云",
      tornado: "龙卷风",
      typhoon: "cyclone,tornado,龙卷风,旋风,台风",
      haze: "阴霾,薄雾",
      "haze-2": "阴霾,薄雾",
      "sun-foggy": "薄雾",
      "moon-foggy": "薄雾",
      "moon-clear": "夜间模式,夜间无云",
      "temp-hot": "temperature,温度,高温,热",
      "temp-cold": "temperature,温度,低温,冷",
      celsius: "temperature,温度,摄氏度",
      fahrenheit: "temperature,温度,华氏度",
      "water-percent": "humidity,水,百分比,湿度",
      fire: "flame,hot,火,热门",
      blaze: "flame,火灾",
      earthquake: "地震",
      flood: "洪水",
      meteor: "流星,陨石",
      rainbow: "彩虹",
      shining: "star,magic,ai,twinkle,星星,魔法,闪烁",
      "shining-2": "star,magic,ai,twinkle,星星,魔法,闪烁",
      sparkling: "shining,star,magic,ai,twinkle,星星,魔法,闪烁",
      "sparkling-2": "shining,star,magic,ai,twinkle,星星,魔法,闪烁",
    },
    Others: {
      basketball: "sports,篮球,运动,体育",
      bell: "cartoon,anime,doraemon,铃铛,哆啦A梦,卡通,动漫",
      billiards: "sports,运动,台球,8,体育",
      boxing: "sports,运动,拳击,体育",
      "door-lock": "门锁",
      "door-lock-box": "门锁",
      football: "sports,运动,足球,体育",
      game: "pac man,游戏,吃豆人,体育",
      handbag: "fashion,时尚,手提包,女包",
      key: "password,钥匙,密码",
      "key-2": "password,钥匙,密码",
      lightbulb: "energy,creativity,灯泡,能源,白炽灯,能源,电子产品",
      "lightbulb-flash":
        "energy,creativity,idea,灯泡,白炽灯,能源,闪电,创意,灵感",
      outlet: "二脚插座",
      "outlet-2": "三脚插座",
      plug: "plugin,二脚插头",
      "plug-2": "plugin,三脚插头",
      "ping-pong": "sports,table tennis,运动,乒乓球,球拍,体育",
      reserved: "已预定,会议室屏幕,电视,显示器",
      shirt: "clothes,衬衫,衣服,服饰,西装,西服",
      sword: "war,刀剑,战争,战斗,玄幻,对抗",
      "t-shirt": "skin,theme,T恤,皮肤,主题,服饰",
      "t-shirt-2": "skin,theme,T恤,皮肤,主题,服饰",
      "t-shirt-air": "dry,T恤,风干,烘干,服饰",
      umbrella: "protect,雨伞,保护,保险",
      "character-recognition": "ocr,文字识别",
      "voice-recognition": "asr,语音识别,音频",
      leaf: "energy,ecology,树叶,节能,环保,草,植物",
      plant: "植物,叶子,草,花盆",
      seedling: "树苗,植物,叶子,草",
      tree: "植物,树木",
      recycle: "recyclable,可回收,循环",
      "scales-2": "厨房称",
      scales: "balance,称,天平,天秤",
      "scales-3": "balance,称,天平,天秤",
      fridge: "refrigerator,电冰箱,柜子,服务器",
      wheelchair: "accessbility,轮椅,可访问性,辅助功能,残疾人",
      cactus: "desertr,仙人掌,沙漠,植物",
      door: "门,建筑",
      "door-open": "开门,建筑",
      "door-closed": "关门,建筑",
      "graduation-cap": "cap,school,student,毕业,帽子,学校,学生",
      "box-1": "instance,盒子,实例",
      "box-2": "instance,盒子,实例",
      "box-3": "instance,3d,盒子,实例,立体",
      candle: "蜡烛",
      cross: "tomb,十字架,坟墓",
      infinity:
        "infinite,endless,loop,forever,math,eternal,无限,循环,永远,永久,永恒",
      goggles: "vr,vision,护目镜",
      glasses: "vision,spectacles,眼镜",
      "glasses-2": "vision,spectacles,眼镜",
      "dice-1": "random,骰子",
      "dice-2": "random,骰子",
      "dice-4": "random,骰子",
      "dice-6": "random,骰子",
      "dice-5": "random,骰子",
      "dice-3": "random,骰子",
      dice: "random,骰子",
      flower: "plant,植物,花",
      armchair: "sofa,seat,手扶椅,沙发,座位",
      sofa: "armchair,seat,手扶椅,沙发,座位",
      tooth: "teeth,牙齿",
      weight: "weight,heavy,dense,kilo,pound,gram,large,重量",
      "police-badge": "警察,警徽",
      "golf-ball": "sports,高尔夫球",
      stairs: "stages,levels,楼梯,步行梯,台阶",
      "book-shelf": "books,library,categories,书架,书籍,图书馆,分类",
    },
  },
};

export default ri;
